import { jsx as g, jsxs as F, Fragment as _t } from "react/jsx-runtime";
import { c as W, a as ne, b as ae } from "./utils-B9z9WPG8.js";
import * as x from "react";
import We, { useId as $t, useState as qe, useEffect as Nt, createContext as yo, use as Cn, useRef as at, createElement as $1, useLayoutEffect as go, Children as ra, isValidElement as ia, useContext as Ig, cloneElement as Xc, useCallback as Ln, useMemo as Sl, Fragment as Rl } from "react";
import * as yn from "react-dom";
import { createPortal as l4 } from "react-dom";
function a4({ defaultTagName: t, props: e, render: n, state: o = {}, stateAttributesMapping: r }) {
  let i = Qc(c4(o, r), e);
  if (!n) return x.createElement(t, i);
  if (typeof n == "function") return n(i, o);
  if (!x.isValidElement(n)) return null;
  let s = n.props, l = { ...Qc(i, s), ref: ls(i.ref, s.ref) };
  return x.cloneElement(n, l);
}
function Qc(...t) {
  let e = {};
  for (let n of t) {
    if (!n) continue;
    let o = n;
    for (let r of Object.keys(o)) {
      let i = o[r];
      if (i === void 0) continue;
      let s = e[r];
      r === "className" ? e[r] = [s, i].filter(Boolean).join(" ") : r === "style" ? e[r] = { ...s, ...i } : r === "ref" ? e[r] = ls(s, i) : d4(r) && typeof s == "function" && typeof i == "function" ? e[r] = u4(i, s) : e[r] = i;
    }
  }
  return e;
}
function c4(t, e) {
  let n = {};
  for (let o of Object.keys(t)) {
    let r = t[o], i = e?.[o]?.(r);
    if (i) {
      Object.assign(n, i);
      continue;
    }
    if (o === "slot") {
      n["data-slot"] = r;
      continue;
    }
    let s = `data-${String(o).replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`)}`;
    typeof r == "boolean" ? n[s] = r ? "" : void 0 : r != null && (n[s] = String(r));
  }
  return n;
}
function u4(t, e) {
  return function(n) {
    t(n), n.defaultPrevented || e(n);
  };
}
function d4(t) {
  return /^on[A-Z]/.test(t);
}
function ls(...t) {
  let e = t.filter(Boolean);
  if (e.length !== 0) return (n) => {
    for (let o of e) typeof o == "function" ? o(n) : o && (o.current = n);
  };
}
var f4 = 8, p4 = 64, m4 = 0, _l = 0.5, g4 = 180, h4 = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "End", "Home", "PageDown", "PageUp", " "]), Pg = { start: !1, end: !1 }, b4 = [], Vl = { currentAnchorId: null, visibleMessageIds: b4 };
function v4({ content: t, scrollEdgeThreshold: e, spacer: n, viewport: o }) {
  if (!o || !t) return Pg;
  let r = Ou({ content: t, spacer: n, viewport: o });
  return { start: o.scrollTop > e, end: r - o.scrollTop - o.clientHeight > e };
}
function y4({ content: t, scrollMargin: e, scrollPreviousItemPeek: n, spacer: o, viewport: r, visibleMessageIds: i }) {
  if (!t || !r) return Vl;
  let s = r.getBoundingClientRect(), l = s.top + e + n, a = typeof IntersectionObserver > "u", c = [], u = null;
  for (let d of ji(t, o)) {
    let f = d.dataset.messageId;
    if (!f) continue;
    let p = d.dataset.scrollAnchor === "true", m = p || a ? d.getBoundingClientRect() : null;
    (a && m ? m.bottom > l && m.top < s.bottom : i.has(f)) && c.push(f), p && m && m.top <= l + _l && (u = f);
  }
  return c.length === 0 && u === null ? Vl : { currentAnchorId: u, visibleMessageIds: c };
}
function ji(t, e) {
  return Array.from(t.children).filter((n) => n instanceof HTMLElement && n !== e);
}
function x4(t, e) {
  for (let n = e; n < t.length; n++) {
    let o = t[n];
    if (o?.dataset.scrollAnchor === "true") return o;
  }
  return null;
}
function C4(t, e) {
  for (let n of t) if (n.dataset.scrollAnchor === "true" && !e.has(n)) return n;
  return null;
}
function w4(t, e) {
  let n = 0;
  for (let o = e; o < t.length; o++) if (t[o]?.dataset.scrollAnchor === "true" && (n += 1, n > 1)) return !0;
  return !1;
}
function S4(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    let n = t[e];
    if (n?.dataset.scrollAnchor === "true") return n;
  }
  return null;
}
function R4({ content: t, spacer: e, viewport: n }) {
  let o = n.getBoundingClientRect();
  for (let r of ji(t, e)) {
    if (!r.dataset.messageId) continue;
    let i = r.getBoundingClientRect();
    if (i.bottom > o.top && i.top < o.bottom) return r;
  }
  return null;
}
function E4({ align: t, element: e, scrollMargin: n, spacer: o, viewport: r }) {
  let i = Mg(e, r), s = e.getBoundingClientRect().height, l = I4(o);
  if (t === "center") {
    let a = Math.max(0, r.clientHeight - l.start - l.end);
    return i - l.start - (a - s) / 2 - n;
  }
  if (t === "end") return i - r.clientHeight + s + l.end + n;
  if (t === "nearest") {
    let a = i + s, c = r.scrollTop + l.start, u = r.scrollTop + r.clientHeight - l.end;
    return i >= c && a <= u ? r.scrollTop : i < c ? i - l.start - n : a - r.clientHeight + l.end + n;
  }
  return i - l.start - n;
}
function Mg(t, e) {
  let n = t.getBoundingClientRect(), o = e.getBoundingClientRect();
  return n.top - o.top + e.scrollTop;
}
function El(t, e) {
  return t.getBoundingClientRect().top - e.getBoundingClientRect().top;
}
function N4({ content: t, scrollTop: e, spacer: n, viewport: o }) {
  let r = Ou({ content: t, spacer: n, viewport: o });
  return e + o.clientHeight - r;
}
function Ou({ content: t, spacer: e, viewport: n }) {
  let o = ji(t, e), r = Tg(t), i = n.getBoundingClientRect(), s = n.scrollTop, l = r.start + r.end;
  for (let a of o) {
    let c = a.getBoundingClientRect();
    l = Math.max(l, c.bottom - i.top + s + r.end);
  }
  return l;
}
function k4(t) {
  return Math.max(0, t.scrollHeight - t.clientHeight);
}
function Tg(t) {
  let e = window.getComputedStyle(t);
  return { end: Jc(e.paddingBlockEnd || e.paddingBottom), start: Jc(e.paddingBlockStart || e.paddingTop) };
}
function I4(t) {
  let e = t?.parentElement;
  return e ? Tg(e) : { end: 0, start: 0 };
}
function P4(t) {
  if (!t) return 0;
  let e = window.getComputedStyle(t), n = e.rowGap === "normal" ? e.gap : e.rowGap;
  return Jc(n);
}
function Jc(t) {
  if (!t) return 0;
  let e = Number.parseFloat(t);
  return Number.isFinite(e) ? e : 0;
}
function M4({ refs: t, commitScrollState: e, scheduleStateCommit: n, scheduleVisibilitySync: o }) {
  let { streamingTurnRef: r, autoScrollRef: i, autoscrollingRef: s, autoscrollingTimeoutRef: l, contentRef: a, defaultScrollPositionAppliedRef: c, itemCountRef: u, messageElementsRef: d, modeRef: f, pendingScrollToMessageRef: p, prependRestoreRef: m, scrollMarginRef: h, scrollPreviousItemPeekRef: b, spacerGapRef: v, spacerHeightRef: C, spacerRef: y, viewportRef: w } = t, R = x.useCallback((P) => {
    l.current !== null && (window.clearTimeout(l.current), l.current = null), s.current !== P && (s.current = P, e()), P && (l.current = window.setTimeout(() => {
      l.current = null, s.current = !1, e();
    }, g4));
  }, [e]), S = x.useCallback((P) => {
    let D = y.current;
    if (!D) return;
    let O = Math.max(0, Math.ceil(P));
    C.current !== O && (C.current = O, D.hidden = O === 0, D.style.height = `${O}px`, D.style.marginTop = O > 0 ? `${-v.current}px` : "");
  }, []), E = x.useCallback((P, { behavior: D = "auto", autoscrolling: O = !1 } = {}) => {
    let V = w.current;
    if (!V) return;
    let _ = Math.max(0, P);
    if (Math.abs(V.scrollTop - _) <= _l) {
      V.scrollTop = _, e();
      return;
    }
    O && R(!0), V.scrollTo({ top: _, behavior: D }), n();
  }, [e, n, R]), N = x.useCallback(({ behavior: P = "auto" } = {}) => w.current ? (S(0), r.current = null, f.current = "free-scrolling", E(0, { behavior: P }), o(), !0) : !1, [o, E, S]), I = x.useCallback(({ behavior: P = "auto" } = {}) => {
    let D = w.current;
    return D ? (S(0), r.current = null, f.current = i.current ? "following-bottom" : "free-scrolling", E(k4(D), { autoscrolling: !0, behavior: P }), o(), !0) : !1;
  }, [o, E, S]), M = x.useCallback((P, { align: D = "start", behavior: O = "auto", scrollMargin: V = h.current } = {}, { keepPreviousPeek: _ = !1 } = {}) => {
    let A = a.current, L = w.current;
    if (!A || !L || !A.contains(P)) return !1;
    let $ = E4({ align: D, element: P, scrollMargin: _ ? V + b.current : V, spacer: y.current, viewport: L }), B = N4({ content: A, scrollTop: $, spacer: y.current, viewport: L });
    return S(B), m.current = { element: P, viewportTop: El(P, L) }, f.current = _ ? "anchored-to-message" : "settling-jump", r.current = _ ? P : null, E($, { behavior: O }), o(), !0;
  }, [o, E, S]), T = x.useCallback(() => {
    let P = r.current;
    return !P || !P.isConnected || f.current !== "anchored-to-message" ? !1 : M(P, { align: "start" }, { keepPreviousPeek: !0 });
  }, [M]), k = x.useCallback((P, D) => {
    let O = d.current.get(P);
    return O ? (c.current = !0, M(O, D) ? (p.current = null, !0) : (p.current = { messageId: P, options: D }, !0)) : u.current === 0 ? (p.current = { messageId: P, options: D }, c.current = !0, !0) : !1;
  }, [M]);
  return { flushPendingScrollToMessage: x.useCallback(() => {
    let P = p.current;
    if (!P) return !1;
    let D = d.current.get(P.messageId);
    return !D || !M(D, P.options) ? !1 : (p.current = null, c.current = !0, !0);
  }, [M]), reanchorToAnchoredMessage: T, scrollToElement: M, scrollToEnd: I, scrollToMessage: k, scrollToStart: N };
}
function Og(t, e) {
  let n = t, o = /* @__PURE__ */ new Set();
  return { getSnapshot: () => n, hasListeners: () => o.size > 0, setSnapshot: (r) => {
    e(n, r) || (n = r, o.forEach((i) => i()));
  }, subscribe: (r, i, s) => {
    let l = o.size === 0;
    return o.add(r), l && i?.(), () => {
      o.delete(r), o.size === 0 && s?.();
    };
  } };
}
function T4(t, e) {
  return Og(t, e);
}
function O4() {
  return Og(Vl, _4);
}
function D4(t, e) {
  return t.start === e.start && t.end === e.end;
}
function _4(t, e) {
  return t.currentAnchorId !== e.currentAnchorId || t.visibleMessageIds.length !== e.visibleMessageIds.length ? !1 : t.visibleMessageIds.every((n, o) => n === e.visibleMessageIds[o]);
}
function V4({ autoScroll: t, scrollEdgeThreshold: e, scrollMargin: n, scrollPreviousItemPeek: o }) {
  let r = x.useRef(t), i = x.useRef(!1), s = x.useRef(null), l = x.useRef(!1), a = x.useRef(e), c = x.useRef(0), u = x.useRef(null), d = x.useRef(0), f = x.useRef(t ? "following-bottom" : "free-scrolling"), p = x.useRef(/* @__PURE__ */ new Map()), m = x.useRef(null), h = x.useRef(null), b = x.useRef(null), v = x.useRef(o), C = x.useRef(!0), y = x.useRef(null), w = x.useRef(n), R = x.useRef(null), S = x.useRef(0), E = x.useRef(0), N = x.useRef(null), I = x.useRef(null), M = x.useRef(null), T = x.useRef(null), k = x.useRef(null), P = x.useRef(null), D = x.useRef(null), O = x.useRef(null), V = x.useRef(/* @__PURE__ */ new Set()), _ = x.useRef(/* @__PURE__ */ new WeakSet());
  return M.current === null && (M.current = T4(Pg, D4)), O.current === null && (O.current = O4()), r.current = t, a.current = e, w.current = n, v.current = o, { autoScrollRef: r, autoscrollingRef: i, autoscrollingTimeoutRef: T, streamingTurnRef: b, contentRef: s, defaultScrollPositionAppliedRef: l, firstItemRef: u, itemCountRef: c, lastScrollTopRef: d, messageElementsRef: p, modeRef: f, pendingScrollFrameRef: R, pendingScrollToMessageRef: m, prependRestoreRef: h, preserveScrollOnPrependRef: C, rootRef: y, scrollEdgeThresholdRef: a, scrollMarginRef: w, scrollPreviousItemPeekRef: v, spacerGapRef: S, spacerHeightRef: E, spacerRef: N, stateFrameRef: I, stateStore: M.current, viewportRef: k, visibilityFrameRef: P, visibilityObserverRef: D, visibilityStore: O.current, visibleMessageIdsRef: V, handledScrollAnchorsRef: _ };
}
function H1(t, e) {
  return x.useCallback((n) => {
    t.current = n, n && e();
  }, [t, e]);
}
function A4({ autoScroll: t = !1, defaultScrollPosition: e = "end", scrollEdgeThreshold: n = f4, scrollPreviousItemPeek: o = p4, scrollMargin: r = m4 }) {
  let i = V4({ autoScroll: t, scrollEdgeThreshold: n, scrollMargin: r, scrollPreviousItemPeek: o }), { streamingTurnRef: s, autoScrollRef: l, autoscrollingRef: a, autoscrollingTimeoutRef: c, contentRef: u, defaultScrollPositionAppliedRef: d, firstItemRef: f, itemCountRef: p, lastScrollTopRef: m, messageElementsRef: h, modeRef: b, pendingScrollFrameRef: v, pendingScrollToMessageRef: C, prependRestoreRef: y, preserveScrollOnPrependRef: w, rootRef: R, scrollEdgeThresholdRef: S, scrollMarginRef: E, scrollPreviousItemPeekRef: N, spacerGapRef: I, spacerHeightRef: M, spacerRef: T, stateFrameRef: k, stateStore: P, viewportRef: D, visibilityFrameRef: O, visibilityObserverRef: V, visibilityStore: _, visibleMessageIdsRef: A, handledScrollAnchorsRef: L } = i, $ = x.useRef(e);
  $.current !== e && ($.current = e, d.current = !1);
  let B = x.useCallback((ye) => {
    let xe = R.current, de = D.current, Se = [ye.start && "start", ye.end && "end"].filter(Boolean).join(" "), Me = a.current;
    for (let Re of [xe, de]) Re && (Se ? Re.setAttribute("data-scrollable", Se) : Re.removeAttribute("data-scrollable"), Re.toggleAttribute("data-autoscrolling", Me));
  }, []), z = x.useCallback((ye) => {
    let xe = D.current?.scrollTop ?? 0, de = xe < m.current - _l;
    m.current = xe, l.current && !ye.end && b.current !== "settling-jump" && b.current !== "anchored-to-message" ? b.current = "following-bottom" : b.current === "following-bottom" && ye.end && de && !a.current && (b.current = "free-scrolling");
  }, []), H = x.useCallback(() => {
    let ye = v4({ content: u.current, scrollEdgeThreshold: S.current, spacer: T.current, viewport: D.current });
    z(ye);
    let xe = b.current === "following-bottom" ? { ...ye, end: !1 } : ye;
    B(xe), P.setSnapshot(xe);
  }, [z, P, B]), K = x.useCallback(() => {
    k.current === null && (k.current = window.requestAnimationFrame(() => {
      k.current = null, H();
    }));
  }, [H]), G = x.useCallback(() => {
    _.hasListeners() && O.current === null && (O.current = window.requestAnimationFrame(() => {
      O.current = null, _.hasListeners() && _.setSnapshot(y4({ content: u.current, scrollMargin: E.current, scrollPreviousItemPeek: N.current, spacer: T.current, viewport: D.current, visibleMessageIds: A.current }));
    }));
  }, [_]), { flushPendingScrollToMessage: q, reanchorToAnchoredMessage: Q, scrollToElement: U, scrollToEnd: X, scrollToMessage: te, scrollToStart: re } = M4({ refs: i, commitScrollState: H, scheduleStateCommit: K, scheduleVisibilitySync: G }), J = x.useCallback(() => {
    let ye = y.current, xe = D.current;
    if (!ye || !xe || !ye.element.isConnected) return !1;
    let de = El(ye.element, xe) - ye.viewportTop;
    return Math.abs(de) <= _l ? !1 : (xe.scrollTop += de, ye.viewportTop = El(ye.element, xe), K(), G(), !0);
  }, [K, G]), ie = x.useCallback(() => {
    let ye = u.current, xe = D.current;
    if (!ye || !xe) {
      y.current = null;
      return;
    }
    let de = R4({ content: ye, spacer: T.current, viewport: xe });
    y.current = de ? { element: de, viewportTop: El(de, xe) } : null;
  }, []), ce = x.useCallback(() => {
    v.current === null && (v.current = window.requestAnimationFrame(() => {
      v.current = null, q() && ie();
    }));
  }, [ie, q]), oe = x.useCallback(() => {
    if (!e || d.current || p.current === 0) return !1;
    let ye = !1;
    if (e === "last-anchor") {
      let xe = u.current, de = D.current, Se = xe && de ? S4(ji(xe, T.current)) : null;
      if (!xe || !de || !Se) ye = X({ behavior: "auto" });
      else {
        let Me = Mg(Se, de);
        ye = Ou({ content: xe, spacer: T.current, viewport: de }) - Me <= de.clientHeight ? X({ behavior: "auto" }) : U(Se, { align: "start" }, { keepPreviousPeek: !0 });
      }
    } else ye = e === "end" ? X({ behavior: "auto" }) : re({ behavior: "auto" });
    return ye ? (d.current = !0, !0) : !1;
  }, [e, U, X, re]), se = x.useCallback(() => {
    let ye = u.current;
    if (!ye) return;
    let xe = ji(ye, T.current), de = p.current, Se = f.current;
    p.current = xe.length, f.current = xe[0] ?? null, (() => {
      if (q()) return;
      if (de === 0) {
        if (oe() || xe.length > 0 && l.current && X({ behavior: "auto" })) return;
        H(), G();
        return;
      }
      let Me = Se ? xe.indexOf(Se) : -1;
      if (w.current && Me > 0) {
        J();
        return;
      }
      if (xe.length > de) {
        let Re = x4(xe, de);
        if (Re) {
          if (l.current && b.current === "following-bottom" && w4(xe, de)) {
            X({ behavior: "auto" });
            return;
          }
          U(Re, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Re);
          return;
        }
      }
      if (xe.length === de) {
        let Re = C4(xe, L.current);
        if (Re) {
          U(Re, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Re);
          return;
        }
      }
      b.current === "following-bottom" && l.current ? X({ behavior: "auto" }) : (H(), G());
    })(), ie();
  }, [oe, ie, H, q, J, G, U, X]), me = x.useCallback(() => {
    if (b.current === "following-bottom" && l.current) {
      X({ behavior: "auto" });
      return;
    }
    let ye = M.current;
    if (Q()) {
      l.current && ye > 0 && M.current === 0 && X({ behavior: "auto" });
      return;
    }
    K(), G();
  }, [Q, K, G, X]), pe = x.useCallback(() => {
    let ye = D.current;
    if (!(!ye || !_.hasListeners())) {
      if (typeof IntersectionObserver > "u") {
        G();
        return;
      }
      V.current || (V.current = new IntersectionObserver((xe) => {
        for (let de of xe) {
          let Se = de.target.dataset.messageId;
          Se && (de.isIntersecting ? A.current.add(Se) : A.current.delete(Se));
        }
        G();
      }, { root: ye, rootMargin: `${-(E.current + N.current)}px 0px 0px 0px`, threshold: [0, 0.01, 0.5, 1] })), h.current.forEach((xe) => {
        V.current?.observe(xe);
      }), G();
    }
  }, [G, _]), le = x.useCallback(() => {
    O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), V.current?.disconnect(), V.current = null, A.current.clear(), _.setSnapshot(Vl);
  }, [_]), ge = x.useCallback((ye, xe, de) => {
    if (xe) {
      h.current.set(ye, xe), V.current?.observe(xe), G(), C.current?.messageId === ye && ce();
      return;
    }
    de && h.current.get(ye) === de && (h.current.delete(ye), A.current.delete(ye), V.current?.unobserve(de), G());
  }, [ce, G]), j = x.useCallback(() => {
    (b.current === "following-bottom" || b.current === "anchored-to-message" || b.current === "settling-jump") && (s.current = null, b.current = "free-scrolling");
  }, []), ee = x.useCallback(() => B(P.getSnapshot()), [P, B]), Y = H1(R, ee), Z = H1(D, ee), ue = x.useCallback((ye) => {
    u.current = ye;
  }, []), fe = x.useCallback((ye) => {
    T.current = ye, I.current = P4(ye?.parentElement ?? null);
  }, []), be = x.useCallback(() => {
    H(), G(), ie();
  }, [ie, H, G]), Ie = x.useMemo(() => ({ handleContentChange: se, handleResize: me, observeVisibility: pe, preserveScrollOnPrependRef: w, scrollToEnd: X, scrollToMessage: te, scrollToStart: re, setContentElement: ue, setRootElement: Y, setSpacerElement: fe, setViewportElement: Z, stateStore: P, syncAfterScroll: be, unobserveVisibility: le, userScrollIntent: j, viewportRef: D, visibilityStore: _ }), [se, me, pe, X, te, re, ue, Y, fe, Z, P, be, le, j, _]);
  return x.useLayoutEffect(() => {
    oe();
  }, [oe]), x.useEffect(() => () => {
    k.current !== null && (window.cancelAnimationFrame(k.current), k.current = null), O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), c.current !== null && (window.clearTimeout(c.current), c.current = null), v.current !== null && (window.cancelAnimationFrame(v.current), v.current = null), V.current?.disconnect(), V.current = null;
  }, []), x.useLayoutEffect(() => {
    if (t && b.current === "following-bottom" && p.current > 0) {
      X({ behavior: "auto" });
      return;
    }
    H();
  }, [t, H, X]), { context: Ie, registerMessage: ge };
}
function L4(t) {
  let e = x.useRef(t);
  return e.current = t, e;
}
var Dg = x.createContext(null), _g = x.createContext(null);
function as() {
  let t = x.useContext(Dg);
  if (!t) throw new Error("useMessageScroller must be used within a MessageScroller.");
  return t;
}
function F4() {
  let t = x.useContext(_g);
  if (!t) throw new Error("MessageScrollerItem must be used within a MessageScroller.");
  return t;
}
function Du() {
  let { scrollToEnd: t, scrollToMessage: e, scrollToStart: n } = as();
  return x.useMemo(() => ({ scrollToEnd: t, scrollToMessage: e, scrollToStart: n }), [t, e, n]);
}
function $4({ autoScroll: t = !1, children: e, defaultScrollPosition: n = "end", scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i }) {
  let { context: s, registerMessage: l } = A4({ autoScroll: t, defaultScrollPosition: n, scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i });
  return g(Dg.Provider, { value: s, children: g(_g.Provider, { value: l, children: e }) });
}
function H4({ children: t, ...e }) {
  let { setRootElement: n } = as();
  return g("div", { ref: n, ...e, children: t });
}
function z4({ "aria-label": t, children: e, onKeyDown: n, onScroll: o, onTouchMove: r, onWheel: i, preserveScrollOnPrepend: s = !0, ref: l, role: a, tabIndex: c, ...u }) {
  let { handleResize: d, preserveScrollOnPrependRef: f, setViewportElement: p, syncAfterScroll: m, userScrollIntent: h, viewportRef: b } = as();
  f.current = s;
  let v = x.useCallback((S) => {
    p(S), ls(l)?.(S);
  }, [l, p]);
  function C(S) {
    m(), o?.(S);
  }
  function y(S) {
    h(), i?.(S);
  }
  function w(S) {
    h(), r?.(S);
  }
  function R(S) {
    h4.has(S.key) && h(), n?.(S);
  }
  return x.useEffect(() => {
    let S = b.current;
    if (!S || typeof ResizeObserver > "u") return;
    let E = 0, N = new ResizeObserver(() => {
      window.cancelAnimationFrame(E), E = window.requestAnimationFrame(d);
    });
    return N.observe(S), () => {
      window.cancelAnimationFrame(E), N.disconnect();
    };
  }, [d, b]), g("div", { ref: v, role: a ?? "region", "aria-label": t ?? "Messages", tabIndex: c ?? 0, onKeyDown: R, onScroll: C, onTouchMove: w, onWheel: y, ...u, children: e });
}
function B4({ "aria-relevant": t, children: e, ref: n, role: o, spacerClassName: r, ...i }) {
  let { handleContentChange: s, handleResize: l, setContentElement: a, setSpacerElement: c } = as(), u = x.useRef(null), d = x.useCallback((f) => {
    u.current = f, a(f), ls(n)?.(f);
  }, [n, a]);
  return x.useLayoutEffect(() => {
    let f = u.current;
    if (!f || (s(), typeof MutationObserver > "u")) return;
    let p = new MutationObserver(() => {
      s();
    });
    return p.observe(f, { childList: !0 }), () => p.disconnect();
  }, [s]), x.useEffect(() => {
    let f = u.current;
    if (!f || typeof ResizeObserver > "u") return;
    let p = 0, m = new ResizeObserver(() => {
      window.cancelAnimationFrame(p), p = window.requestAnimationFrame(l);
    });
    return m.observe(f), () => {
      window.cancelAnimationFrame(p), m.disconnect();
    };
  }, [l]), F("div", { ref: d, role: o ?? "log", "aria-relevant": t ?? "additions", ...i, children: [e, g("div", { ref: c, "aria-hidden": "true", "data-message-scroller-spacer": "", hidden: !0, className: r })] });
}
function W4({ messageId: t, ref: e, scrollAnchor: n = !1, ...o }) {
  let r = F4(), i = x.useRef(null), s = x.useCallback((l) => {
    let a = i.current;
    i.current = l, t && r(t, l, a), ls(e)?.(l);
  }, [t, e, r]);
  return g("div", { ref: s, "data-message-id": t, "data-scroll-anchor": n ? "true" : "false", ...o });
}
function U4({ behavior: t = "smooth", children: e, direction: n = "end", onClick: o, render: r, tabIndex: i, type: s = "button", ...l }) {
  let { scrollToEnd: a, scrollToStart: c, stateStore: u } = as(), d = L4(o), f = x.useCallback((b) => u.subscribe(b), [u]), p = x.useCallback(() => {
    let b = u.getSnapshot();
    return n === "start" ? b.start : b.end;
  }, [n, u]), m = x.useSyncExternalStore(f, p, p), h = x.useCallback((b) => {
    m && (d.current?.(b), b.defaultPrevented || (b.currentTarget.blur(), n === "start" ? c({ behavior: t }) : a({ behavior: t })));
  }, [t, n, m, d, a, c]);
  return a4({ defaultTagName: "button", props: Qc({ type: s, inert: !m, tabIndex: m ? i : -1, children: e ?? F("span", { children: ["Scroll to ", n] }), onClick: h }, l), render: r, state: { active: m, direction: n }, stateAttributesMapping: { active: (b) => ({ "data-active": b ? "true" : "false" }) } });
}
var Zr = { Provider: $4, Root: H4, Viewport: z4, Content: B4, Item: W4, Button: U4 };
const Vg = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)"
};
function _u(t) {
  const e = W.c(18);
  let n, o;
  e[0] !== t ? ({
    size: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "md" : o, i = $t();
  let s;
  if (e[3] !== i) {
    let v;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /:/g, e[5] = v) : v = e[5], s = i.replace(v, ""), e[3] = i, e[4] = s;
  } else
    s = e[4];
  const a = `ai-sparkles-gradient-${s}`, c = Vg[r];
  let u, d, f;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), d = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), f = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), e[6] = u, e[7] = d, e[8] = f) : (u = e[6], d = e[7], f = e[8]);
  let p;
  e[9] !== a ? (p = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ F("linearGradient", { id: a, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
    u,
    d,
    f
  ] }) }), e[9] = a, e[10] = p) : p = e[10];
  const m = `url(#${a})`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  return e[13] !== c || e[14] !== n || e[15] !== p || e[16] !== h ? (b = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", width: c, height: c, "aria-hidden": "true", focusable: "false", ...n, children: [
    p,
    h
  ] }), e[13] = c, e[14] = n, e[15] = p, e[16] = h, e[17] = b) : b = e[17], b;
}
function G4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 12.52 7 12.938 7.418 12.938 7.9375 V 12.3125 C 12.938 12.832 12.52 13.25 12 13.25 C 11.48 13.25 11.062 12.832 11.062 12.3125 V 7.9375 C 11.062 7.418 11.48 7 12 7 Z M 10.75 15.75 C 10.75 15.4185 10.882 15.1005 11.116 14.8661 C 11.351 14.6317 11.668 14.5 12 14.5 C 12.332 14.5 12.649 14.6317 12.884 14.8661 C 13.118 15.1005 13.25 15.4185 13.25 15.75 C 13.25 16.0815 13.118 16.3995 12.884 16.6339 C 12.649 16.8683 12.332 17 12 17 C 11.668 17 11.351 16.8683 11.116 16.6339 C 10.882 16.3995 10.75 16.0815 10.75 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Y4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 6.96 C 4.32 6.561 4.641 6.24 5.04 6.24 C 5.439 6.24 5.76 6.561 5.76 6.96 V 17.04 C 5.76 17.439 5.439 17.76 5.04 17.76 C 4.641 17.76 4.32 17.439 4.32 17.04 V 6.96 Z M 8.37 12.51 C 8.088 12.228 8.088 11.772 8.37 11.493 L 12.45 7.41 C 12.732 7.128 13.188 7.128 13.467 7.41 C 13.746 7.692 13.749 8.148 13.467 8.427 L 10.617 11.277 H 18.96 C 19.359 11.277 19.68 11.598 19.68 11.997 C 19.68 12.396 19.359 12.717 18.96 12.717 H 10.617 L 13.467 15.567 C 13.749 15.849 13.749 16.305 13.467 16.584 C 13.185 16.863 12.729 16.866 12.45 16.584 L 8.37 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function j4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2.275 10.8332 C 1.908 11.2004 1.908 11.7942 2.275 12.1575 L 8.837 18.7246 C 9.204 19.0918 9.798 19.0918 10.161 18.7246 C 10.525 18.3574 10.528 17.7636 10.161 17.4002 L 5.201 12.4349 H 21.063 C 21.582 12.4349 22 12.0169 22 11.4973 C 22 10.9777 21.582 10.5597 21.063 10.5597 H 5.201 L 10.165 5.5983 C 10.532 5.2311 10.532 4.6373 10.165 4.274 C 9.798 3.9106 9.204 3.9067 8.841 4.274 L 2.275 10.8332 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function K4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.76 6.96 C 5.76 6.561 5.439 6.24 5.04 6.24 C 4.641 6.24 4.32 6.561 4.32 6.96 V 17.04 C 4.32 17.439 4.641 17.76 5.04 17.76 C 5.439 17.76 5.76 17.439 5.76 17.04 V 6.96 Z M 19.47 12.51 C 19.752 12.228 19.752 11.772 19.47 11.493 L 15.39 7.41 C 15.108 7.128 14.652 7.128 14.373 7.41 C 14.094 7.692 14.091 8.148 14.373 8.427 L 17.223 11.277 H 8.88 C 8.481 11.277 8.16 11.598 8.16 11.997 C 8.16 12.396 8.481 12.717 8.88 12.717 H 17.223 L 14.373 15.567 C 14.091 15.849 14.091 16.305 14.373 16.584 C 14.655 16.863 15.111 16.866 15.39 16.584 L 19.47 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function q4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19 4 C 19.554 4 20 4.4459 20 5.0001 V 15.0014 C 20 15.5557 19.554 16.0016 19 16.0016 C 18.446 16.0016 18 15.5557 18 15.0014 V 7.4129 L 5.706 19.7062 C 5.314 20.0979 4.68 20.0979 4.293 19.7062 C 3.905 19.3145 3.901 18.6852 4.289 18.2935 L 16.583 6.0003 H 8.994 C 8.439 6.0003 7.993 5.5544 7.993 5.0001 C 7.993 4.4459 8.439 4 8.994 4 H 18.996 H 19 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Z4(t) {
  const e = W.c(13), n = $t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 11.414 4.0871 C 11.582 3.9894 11.784 3.9894 11.953 4.0871 L 17.339 7.1983 L 11.683 10.4646 L 6.027 7.1983 L 11.414 4.0871 Z M 5.218 8.6006 L 10.874 11.8669 V 18.3995 L 5.488 15.2882 C 5.319 15.1905 5.218 15.0152 5.218 14.8197 V 8.5972 V 8.6006 Z M 12.492 18.3995 V 11.8669 L 18.148 8.6006 V 14.8231 C 18.148 15.0152 18.047 15.1938 17.879 15.2916 L 12.492 18.3995 Z M 12.762 2.6882 C 12.094 2.304 11.272 2.304 10.605 2.6882 L 4.679 6.1062 C 4.011 6.4905 3.6 7.2051 3.6 7.9736 V 14.8163 C 3.6 15.5882 4.011 16.2995 4.679 16.6837 L 10.605 20.1118 C 11.272 20.4961 12.094 20.4961 12.762 20.1118 L 18.691 16.6905 C 19.359 16.3062 19.77 15.5916 19.77 14.8231 V 7.9804 C 19.77 7.2085 19.359 6.4972 18.691 6.1129 L 12.762 2.6849 V 2.6882 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function X4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6 4.8 C 6 4.1362 6.536 3.6 7.2 3.6 H 8.4 C 9.064 3.6 9.6 4.1362 9.6 4.8 V 5.4 H 6 V 4.8 Z M 4.635 8.325 C 4.815 7.3275 5.685 6.6 6.701 6.6 H 9.9 C 10.399 6.6 10.8 7.0012 10.8 7.5 V 8.4 H 13.2 V 7.5 C 13.2 7.0012 13.601 6.6 14.1 6.6 H 17.299 C 18.315 6.6 19.185 7.3275 19.365 8.325 L 19.552 9.3487 C 19.687 10.095 19.957 10.8112 20.347 11.4637 L 20.445 11.6287 C 21.199 12.8887 21.6 14.3287 21.6 15.795 V 18.3 C 21.6 19.4587 20.659 20.4 19.5 20.4 H 15.3 C 14.141 20.4 13.2 19.4587 13.2 18.3 V 13.2 H 10.8 V 18.3 C 10.8 19.4587 9.859 20.4 8.7 20.4 H 4.5 C 3.341 20.4 2.4 19.4587 2.4 18.3 V 15.795 C 2.4 14.325 2.797 12.885 3.555 11.625 L 3.652 11.46 C 4.042 10.8075 4.312 10.0912 4.447 9.345 L 4.635 8.3212 V 8.325 Z M 6.701 8.4 C 6.555 8.4 6.431 8.505 6.405 8.6475 L 6.217 9.6712 C 6.045 10.6312 5.7 11.55 5.197 12.39 L 5.1 12.555 C 4.511 13.5337 4.2 14.6512 4.2 15.795 V 18.3 C 4.2 18.465 4.335 18.6 4.5 18.6 H 8.7 C 8.865 18.6 9 18.465 9 18.3 V 8.4 H 6.701 Z M 17.299 8.4 H 15 V 18.3 C 15 18.465 15.135 18.6 15.3 18.6 H 19.5 C 19.665 18.6 19.8 18.465 19.8 18.3 V 15.795 C 19.8 14.655 19.489 13.5337 18.904 12.555 L 18.806 12.39 C 18.304 11.5537 17.959 10.6312 17.782 9.6712 L 17.595 8.6475 C 17.569 8.505 17.445 8.4 17.299 8.4 Z M 15.6 3.6 H 16.8 C 17.464 3.6 18 4.1362 18 4.8 V 5.4 H 14.4 V 4.8 C 14.4 4.1362 14.936 3.6 15.6 3.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Q4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 20.66 17 C 21.512 15.5312 22 13.8203 22 12 C 22 6.4766 17.523 2 12 2 V 3.875 C 16.488 3.875 20.125 7.5117 20.125 12 C 20.125 13.4805 19.73 14.8672 19.039 16.0625 L 20.664 17 H 20.66 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function J4(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.357 2 C 7.951 2 8.429 2.4681 8.429 3.05 V 4.8 H 15.571 V 3.05 C 15.571 2.4681 16.049 2 16.643 2 C 17.237 2 17.714 2.4681 17.714 3.05 V 4.8 H 19.143 C 20.719 4.8 22 6.0556 22 7.6 V 20.2 C 22 21.7444 20.719 23 19.143 23 H 4.857 C 3.281 23 2 21.7444 2 20.2 V 7.6 C 2 6.0556 3.281 4.8 4.857 4.8 H 6.286 V 3.05 C 6.286 2.4681 6.763 2 7.357 2 Z M 7.357 6.9 H 4.857 C 4.464 6.9 4.143 7.215 4.143 7.6 V 9.7 H 19.857 V 7.6 C 19.857 7.215 19.536 6.9 19.143 6.9 H 7.357 Z M 4.143 11.8 V 20.2 C 4.143 20.585 4.464 20.9 4.857 20.9 H 19.143 C 19.536 20.9 19.857 20.585 19.857 20.2 V 11.8 H 4.143 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ev(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M1.82142 0.910712V0H0V16.9999H19.4285V15.1785H1.82142V0.910712ZM17.9486 5.19865L18.5937 4.55356L17.3073 3.26718L16.6622 3.91227L12.1466 8.42788C9.756 6.03726 8.54172 4.82298 8.50377 4.78503L7.85868 5.43012L3.91227 9.37653L3.26718 10.0216L4.55356 11.308L5.19865 10.6629L8.49998 7.36159L11.4977 10.3593L12.1428 11.0044L12.7879 10.3593L17.9486 5.19865Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function tv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 8.17 16.6234 L 3.194 11.648 L 1.5 13.3303 L 8.17 20 L 22.487 5.6823 L 20.805 4 L 8.17 16.6234 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function nv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.45739 5.45213C7.75425 5.03285 7.6527 4.4597 7.22692 4.16736C6.80115 3.87502 6.21914 3.97503 5.92227 4.39431L4.37153 6.56764L3.60201 5.80601C3.23484 5.44828 2.6411 5.44828 2.27392 5.80601C1.90674 6.16375 1.91065 6.75228 2.27392 7.11386L3.83638 8.6525C4.03169 8.84483 4.30512 8.94485 4.58246 8.91792C4.8598 8.89099 5.10979 8.75252 5.26994 8.52941L7.45739 5.45213ZM7.45739 11.6067C7.75425 11.1874 7.6527 10.6143 7.22692 10.3219C6.80115 10.0296 6.21914 10.1296 5.92227 10.5489L4.37153 12.7222L3.60201 11.9606C3.23484 11.599 2.6411 11.599 2.27783 11.9606C1.91455 12.3222 1.91065 12.9069 2.27392 13.2684L3.83638 14.8071C4.03169 14.9994 4.30512 15.0994 4.58246 15.0725C4.8598 15.0456 5.10979 14.9071 5.26994 14.684L7.45739 11.6067ZM9.50031 6.45994C9.50031 6.97154 9.91826 7.38312 10.4378 7.38312H21.0625C21.582 7.38312 22 6.97154 22 6.45994C22 5.94834 21.582 5.53675 21.0625 5.53675H10.4378C9.91826 5.53675 9.50031 5.94834 9.50031 6.45994ZM9.50031 12.6145C9.50031 13.1261 9.91826 13.5377 10.4378 13.5377H21.0625C21.582 13.5377 22 13.1261 22 12.6145C22 12.1029 21.582 11.6913 21.0625 11.6913H10.4378C9.91826 11.6913 9.50031 12.1029 9.50031 12.6145ZM8.25034 18.7691C8.25034 19.2807 8.6683 19.6923 9.18781 19.6923H21.0625C21.582 19.6923 22 19.2807 22 18.7691C22 18.2575 21.582 17.8459 21.0625 17.8459H9.18781C8.6683 17.8459 8.25034 18.2575 8.25034 18.7691ZM5.7504 18.7691C5.7504 18.4426 5.61871 18.1295 5.38429 17.8987C5.14988 17.6679 4.83194 17.5382 4.50043 17.5382C4.16892 17.5382 3.85098 17.6679 3.61657 17.8987C3.38215 18.1295 3.25046 18.4426 3.25046 18.7691C3.25046 19.0955 3.38215 19.4086 3.61657 19.6395C3.85098 19.8703 4.16892 20 4.50043 20C4.83194 20 5.14988 19.8703 5.38429 19.6395C5.61871 19.4086 5.7504 19.0955 5.7504 18.7691Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function ov(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function rv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function iv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 17.687 11.778 C 18.104 12.1768 18.104 12.8216 17.687 13.2162 L 8.816 21.7009 C 8.399 22.0997 7.725 22.0997 7.313 21.7009 C 6.9 21.3021 6.896 20.6573 7.313 20.2627 L 15.43 12.4992 L 7.313 4.7357 C 6.896 4.3369 6.896 3.692 7.313 3.2975 C 7.73 2.903 8.404 2.8987 8.816 3.2975 L 17.687 11.7822 V 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function sv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 7.41 C 11.787 7.128 12.243 7.128 12.522 7.41 L 18.522 13.41 C 18.804 13.692 18.804 14.148 18.522 14.427 C 18.24 14.706 17.784 14.709 17.505 14.427 L 12.015 8.937 L 6.525 14.427 C 6.243 14.709 5.787 14.709 5.508 14.427 C 5.229 14.145 5.226 13.689 5.508 13.41 L 11.508 7.41 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function lv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 21.6 C 6.697 21.6 2.4 17.3025 2.4 12 C 2.4 6.6975 6.697 2.4 12 2.4 C 17.302 2.4 21.6 6.6975 21.6 12 C 21.6 17.3025 17.302 21.6 12 21.6 Z M 12 4.2 C 7.691 4.2 4.2 7.6913 4.2 12 C 4.2 16.3088 7.691 19.8 12 19.8 C 16.309 19.8 19.8 16.3088 19.8 12 C 19.8 7.6913 16.309 4.2 12 4.2 Z M 14.651 8.7713 C 14.944 8.37 15.506 8.28 15.907 8.5725 C 16.309 8.865 16.399 9.4275 16.106 9.8288 L 11.527 16.1288 C 11.374 16.3425 11.134 16.4775 10.871 16.4963 C 10.609 16.515 10.35 16.4213 10.166 16.2375 L 8.07 14.1413 C 7.717 13.7888 7.717 13.2188 8.07 12.87 C 8.422 12.5213 8.992 12.5175 9.341 12.87 L 10.691 14.22 L 14.651 8.775 V 8.7713 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function av(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 11.48 7 11.062 7.418 11.062 7.9375 V 12.3125 C 11.062 12.832 11.48 13.25 12 13.25 C 12.52 13.25 12.938 12.832 12.938 12.3125 V 7.9375 C 12.938 7.418 12.52 7 12 7 Z M 13.25 15.75 C 13.25 15.4185 13.118 15.1005 12.884 14.8661 C 12.649 14.6317 12.332 14.5 12 14.5 C 11.668 14.5 11.351 14.6317 11.116 14.8661 C 10.882 15.1005 10.75 15.4185 10.75 15.75 C 10.75 16.0815 10.882 16.3995 11.116 16.6339 C 11.351 16.8683 11.668 17 12 17 C 12.332 17 12.649 16.8683 12.884 16.6339 C 13.118 16.3995 13.25 16.0815 13.25 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function cv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function uv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.672 11.75 C 19.672 13.851 18.837 15.866 17.352 17.3516 C 15.866 18.8373 13.851 19.6719 11.75 19.6719 C 9.649 19.6719 7.634 18.8373 6.148 17.3516 C 4.663 15.866 3.828 13.851 3.828 11.75 C 3.828 9.649 4.663 7.634 6.148 6.1484 C 7.634 4.6627 9.649 3.8281 11.75 3.8281 C 13.851 3.8281 15.866 4.6627 17.352 6.1484 C 18.837 7.634 19.672 9.649 19.672 11.75 Z M 2 11.75 C 2 14.3359 3.027 16.8158 4.856 18.6443 C 6.684 20.4728 9.164 21.5 11.75 21.5 C 14.336 21.5 16.816 20.4728 18.644 18.6443 C 20.473 16.8158 21.5 14.3359 21.5 11.75 C 21.5 9.1641 20.473 6.6842 18.644 4.8557 C 16.816 3.0272 14.336 2 11.75 2 C 9.164 2 6.684 3.0272 4.856 4.8557 C 3.027 6.6842 2 9.1641 2 11.75 Z M 10.836 6.5703 V 8.7298 L 10.074 7.5872 C 9.792 7.1683 9.225 7.054 8.806 7.332 C 8.387 7.6101 8.273 8.1813 8.551 8.6003 L 10.988 12.2565 C 11.213 12.5917 11.628 12.7402 12.013 12.626 C 12.397 12.5117 12.66 12.1537 12.66 11.75 V 6.5703 C 12.66 6.0638 12.253 5.6562 11.746 5.6562 C 11.24 5.6562 10.832 6.0638 10.832 6.5703 H 10.836 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function dv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M9 5.31034C9.47739 5.31034 9.93523 5.1069 10.2728 4.74476C10.6104 4.38262 10.8 3.89145 10.8 3.37931C10.8 2.86717 10.6104 2.376 10.2728 2.01386C9.93523 1.65172 9.47739 1.44828 9 1.44828C8.52261 1.44828 8.06477 1.65172 7.72721 2.01386C7.38964 2.376 7.2 2.86717 7.2 3.37931C7.2 3.89145 7.38964 4.38262 7.72721 4.74476C8.06477 5.1069 8.52261 5.31034 9 5.31034ZM9 0C9.83543 0 10.6366 0.356033 11.2274 0.989777C11.8181 1.62352 12.15 2.48306 12.15 3.37931C12.15 4.27556 11.8181 5.1351 11.2274 5.76884C10.6366 6.40259 9.83543 6.75862 9 6.75862C8.16457 6.75862 7.36335 6.40259 6.77261 5.76884C6.18187 5.1351 5.85 4.27556 5.85 3.37931C5.85 2.48306 6.18187 1.62352 6.77261 0.989777C7.36335 0.356033 8.16457 0 9 0ZM8.325 9.65517C6.71062 9.65517 5.4 11.0612 5.4 12.7931V13.2759C5.4 13.6772 5.09906 14 4.725 14C4.35094 14 4.05 13.6772 4.05 13.2759V12.7931C4.05 10.2616 5.96531 8.2069 8.325 8.2069H9.675C12.0347 8.2069 13.95 10.2616 13.95 12.7931V13.2759C13.95 13.6772 13.6491 14 13.275 14C12.9009 14 12.6 13.6772 12.6 13.2759V12.7931C12.6 11.0612 11.2894 9.65517 9.675 9.65517H8.325ZM12.1331 6.8431C12.4622 6.50216 12.7406 6.1069 12.96 5.67241C13.1259 5.75086 13.3087 5.7931 13.5 5.7931C14.2453 5.7931 14.85 5.1444 14.85 4.34483C14.85 3.54526 14.2453 2.89655 13.5 2.89655H13.4775C13.4325 2.39569 13.3144 1.91897 13.1372 1.47543C13.2553 1.45733 13.3791 1.44828 13.5 1.44828C14.9906 1.44828 16.2 2.74569 16.2 4.34483C16.2 5.94397 14.9906 7.24138 13.5 7.24138C13.0022 7.24138 12.5353 7.09655 12.1331 6.8431ZM4.5 1.44828C4.62375 1.44828 4.74469 1.45733 4.86281 1.47543C4.68562 1.91897 4.5675 2.39871 4.5225 2.89655H4.5C3.75469 2.89655 3.15 3.54526 3.15 4.34483C3.15 5.1444 3.75469 5.7931 4.5 5.7931C4.69125 5.7931 4.87406 5.75086 5.04 5.67241C5.25937 6.1069 5.53781 6.50216 5.86688 6.8431C5.4675 7.09655 5.00062 7.24138 4.5 7.24138C3.00937 7.24138 1.8 5.94397 1.8 4.34483C1.8 2.74569 3.00937 1.44828 4.5 1.44828ZM4.19906 8.68966C3.77437 9.18147 3.42563 9.74569 3.1725 10.3672C2.10375 10.8349 1.35 11.9603 1.35 13.2759C1.35 13.6772 1.04906 14 0.675 14C0.300937 14 0 13.6772 0 13.2759C0 10.7685 1.87313 8.7319 4.19906 8.68966ZM14.8275 10.3672C14.5744 9.74569 14.2228 9.17845 13.8009 8.68966C16.1269 8.7319 18 10.7685 18 13.2759C18 13.6772 17.6991 14 17.325 14C16.9509 14 16.65 13.6772 16.65 13.2759C16.65 11.9603 15.8962 10.8349 14.8275 10.3672Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function fv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M11.875 3.875H7.5C7.15625 3.875 6.875 4.15625 6.875 4.5V19.5C6.875 19.8438 7.15625 20.125 7.5 20.125H17.5C17.8438 20.125 18.125 19.8438 18.125 19.5V10.125H14.6875C13.1328 10.125 11.875 8.86719 11.875 7.3125V3.875ZM17.3477 8.25L13.75 4.65234V7.3125C13.75 7.83203 14.168 8.25 14.6875 8.25H17.3477ZM5 4.5C5 3.12109 6.12109 2 7.5 2H12.7148C13.3789 2 14.0156 2.26172 14.4844 2.73047L19.2695 7.51953C19.7383 7.98828 20 8.625 20 9.28906V19.5C20 20.8789 18.8789 22 17.5 22H7.5C6.12109 22 5 20.8789 5 19.5V4.5Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function pv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.366 12.0832C16.2569 12.0832 15.3571 11.15 15.3571 9.99987C15.3571 8.84971 16.2569 7.91656 17.366 7.91656C18.4751 7.91656 19.3749 8.84971 19.3749 9.99987C19.3749 11.15 18.4751 12.0832 17.366 12.0832ZM10 7.91656C11.1091 7.91656 12.0089 8.84971 12.0089 9.99987C12.0089 11.15 11.1091 12.0832 10 12.0832C8.89092 12.0832 7.99109 11.15 7.99109 9.99987C7.99109 8.84971 8.89092 7.91656 10 7.91656ZM2.634 12.0832C1.52492 12.0832 0.625095 11.15 0.625095 9.99987C0.625095 8.84971 1.52492 7.91656 2.634 7.91656C3.74309 7.91656 4.64291 8.84971 4.64291 9.99987C4.64291 11.15 3.74309 12.0832 2.634 12.0832Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function mv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M12.0833 2.634C12.0833 3.74309 11.1502 4.64291 10 4.64291C8.84984 4.64291 7.91669 3.74309 7.91669 2.634C7.91669 1.52492 8.84984 0.625095 10 0.625095C11.1502 0.625095 12.0833 1.52492 12.0833 2.634ZM7.91669 10C7.91669 8.89092 8.84984 7.99109 10 7.99109C11.1502 7.99109 12.0833 8.89092 12.0833 10C12.0833 11.1091 11.1502 12.0089 10 12.0089C8.84984 12.0089 7.91669 11.1091 7.91669 10ZM12.0833 17.366C12.0833 18.4751 11.1502 19.3749 10 19.3749C8.84984 19.3749 7.91669 18.4751 7.91669 17.366C7.91669 16.2569 8.84984 15.3571 10 15.3571C11.1502 15.3571 12.0833 16.2569 12.0833 17.366Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function gv(t) {
  const e = W.c(13), n = $t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 14.3999 C 11.682 14.3999 11.376 14.5263 11.151 14.7514 C 10.926 14.9764 10.8 15.2816 10.8 15.5999 C 10.8 15.9182 10.926 16.2234 11.151 16.4484 C 11.376 16.6735 11.682 16.7999 12 16.7999 C 12.318 16.7999 12.623 16.6735 12.848 16.4484 C 13.073 16.2234 13.2 15.9182 13.2 15.5999 C 13.2 15.2816 13.073 14.9764 12.848 14.7514 C 12.623 14.5263 12.318 14.3999 12 14.3999 Z M 12 7.1999 C 11.317 7.1999 10.774 7.7812 10.822 8.4637 L 11.1 12.3637 C 11.134 12.8362 11.527 13.1999 11.996 13.1999 C 12.469 13.1999 12.859 12.8362 12.892 12.3637 L 13.17 8.4637 C 13.219 7.7812 12.679 7.1999 11.992 7.1999 H 12 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function hv(t) {
  const e = W.c(13), n = $t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 4.1999 C 9.931 4.1999 7.947 5.0217 6.484 6.4845 C 5.022 7.9473 4.2 9.9312 4.2 11.9999 C 4.2 14.0686 5.022 16.0526 6.484 17.5153 C 7.947 18.9781 9.931 19.7999 12 19.7999 C 14.069 19.7999 16.053 18.9781 17.515 17.5153 C 18.978 16.0526 19.8 14.0686 19.8 11.9999 C 19.8 9.9312 18.978 7.9473 17.515 6.4845 C 16.053 5.0217 14.069 4.1999 12 4.1999 Z M 12 16.7999 C 11.682 16.7999 11.376 16.6735 11.151 16.4484 C 10.926 16.2234 10.8 15.9182 10.8 15.5999 C 10.8 15.2816 10.926 14.9764 11.151 14.7514 C 11.376 14.5263 11.682 14.3999 12 14.3999 C 12.318 14.3999 12.623 14.5263 12.848 14.7514 C 13.073 14.9764 13.2 15.2816 13.2 15.5999 C 13.2 15.9182 13.073 16.2234 12.848 16.4484 C 12.623 16.6735 12.318 16.7999 12 16.7999 Z M 12 7.1999 C 12.682 7.1999 13.226 7.7812 13.177 8.4637 L 12.9 12.3637 C 12.866 12.8362 12.472 13.1999 12.004 13.1999 C 11.531 13.1999 11.141 12.8362 11.107 12.3637 L 10.83 8.4637 C 10.774 7.7812 11.317 7.1999 12 7.1999 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function bv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.998 5.3214 C 9.508 5.3214 7.461 6.4446 5.891 7.8904 C 4.421 9.2489 3.405 10.8616 2.886 12 C 3.405 13.1384 4.421 14.7511 5.888 16.1096 C 7.461 17.5554 9.508 18.6786 11.998 18.6786 C 14.488 18.6786 16.535 17.5554 18.105 16.1096 C 19.575 14.7511 20.591 13.1384 21.11 12 C 20.591 10.8616 19.575 9.2489 18.109 7.8904 C 16.535 6.4446 14.488 5.3214 11.998 5.3214 Z M 4.642 6.5585 C 6.441 4.8964 8.912 3.5 11.998 3.5 C 15.084 3.5 17.555 4.8964 19.354 6.5585 C 21.141 8.2092 22.336 10.1786 22.905 11.5333 C 23.032 11.833 23.032 12.167 22.905 12.4667 C 22.336 13.8214 21.141 15.7946 19.354 17.4415 C 17.555 19.1036 15.084 20.5 11.998 20.5 C 8.912 20.5 6.441 19.1036 4.642 17.4415 C 2.855 15.7946 1.66 13.8214 1.095 12.4667 C 0.968 12.167 0.968 11.833 1.095 11.5333 C 1.66 10.1786 2.855 8.2054 4.642 6.5585 Z M 11.998 15.0357 C 13.686 15.0357 15.053 13.6772 15.053 12 C 15.053 10.3228 13.686 8.9643 11.998 8.9643 C 11.971 8.9643 11.948 8.9643 11.922 8.9643 C 11.971 9.1578 11.998 9.3627 11.998 9.5714 C 11.998 10.9109 10.902 12 9.554 12 C 9.344 12 9.138 11.9734 8.943 11.9241 C 8.943 11.9507 8.943 11.9734 8.943 12 C 8.943 13.6772 10.31 15.0357 11.998 15.0357 Z M 11.998 7.1429 C 13.295 7.1429 14.538 7.6546 15.455 8.5655 C 16.372 9.4764 16.887 10.7118 16.887 12 C 16.887 13.2882 16.372 14.5236 15.455 15.4345 C 14.538 16.3454 13.295 16.8571 11.998 16.8571 C 10.702 16.8571 9.458 16.3454 8.541 15.4345 C 7.625 14.5236 7.11 13.2882 7.11 12 C 7.11 10.7118 7.625 9.4764 8.541 8.5655 C 9.458 7.6546 10.702 7.1429 11.998 7.1429 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function vv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M3.88889 2.25C3.88889 1.00898 4.88542 0 6.11111 0H13.8889C15.1146 0 16.1111 1.00898 16.1111 2.25V6.75H17.7778C19.0035 6.75 20 7.75898 20 9V15.75C20 16.991 19.0035 18 17.7778 18H2.22222C0.996528 18 0 16.991 0 15.75V5.625C0 4.38398 0.996528 3.375 2.22222 3.375H3.88889V2.25ZM6.11111 1.6875C5.80556 1.6875 5.55556 1.94062 5.55556 2.25V4.21875C5.55556 4.68633 5.18403 5.0625 4.72222 5.0625H2.22222C1.91667 5.0625 1.66667 5.31563 1.66667 5.625V15.75C1.66667 16.0594 1.91667 16.3125 2.22222 16.3125H8.33333V13.5C8.33333 12.8777 8.82986 12.375 9.44444 12.375H10.5556C11.1701 12.375 11.6667 12.8777 11.6667 13.5V16.3125H17.7778C18.0833 16.3125 18.3333 16.0594 18.3333 15.75V9C18.3333 8.69063 18.0833 8.4375 17.7778 8.4375H15.2778C14.816 8.4375 14.4444 8.06133 14.4444 7.59375V2.25C14.4444 1.94062 14.1944 1.6875 13.8889 1.6875H6.11111ZM10.5556 3.9375C10.5556 3.62812 10.8056 3.375 11.1111 3.375H12.2222C12.5278 3.375 12.7778 3.62812 12.7778 3.9375V5.0625C12.7778 5.37187 12.5278 5.625 12.2222 5.625H11.1111C10.8056 5.625 10.5556 5.37187 10.5556 5.0625V3.9375ZM7.77778 3.375H8.88889C9.19444 3.375 9.44444 3.62812 9.44444 3.9375V5.0625C9.44444 5.37187 9.19444 5.625 8.88889 5.625H7.77778C7.47222 5.625 7.22222 5.37187 7.22222 5.0625V3.9375C7.22222 3.62812 7.47222 3.375 7.77778 3.375ZM10.5556 7.3125C10.5556 7.00313 10.8056 6.75 11.1111 6.75H12.2222C12.5278 6.75 12.7778 7.00313 12.7778 7.3125V8.4375C12.7778 8.74687 12.5278 9 12.2222 9H11.1111C10.8056 9 10.5556 8.74687 10.5556 8.4375V7.3125ZM7.77778 6.75H8.88889C9.19444 6.75 9.44444 7.00313 9.44444 7.3125V8.4375C9.44444 8.74687 9.19444 9 8.88889 9H7.77778C7.47222 9 7.22222 8.74687 7.22222 8.4375V7.3125C7.22222 7.00313 7.47222 6.75 7.77778 6.75ZM3.33333 7.3125C3.33333 7.00313 3.58333 6.75 3.88889 6.75H5C5.30556 6.75 5.55556 7.00313 5.55556 7.3125V8.4375C5.55556 8.74687 5.30556 9 5 9H3.88889C3.58333 9 3.33333 8.74687 3.33333 8.4375V7.3125ZM3.88889 10.125H5C5.30556 10.125 5.55556 10.3781 5.55556 10.6875V11.8125C5.55556 12.1219 5.30556 12.375 5 12.375H3.88889C3.58333 12.375 3.33333 12.1219 3.33333 11.8125V10.6875C3.33333 10.3781 3.58333 10.125 3.88889 10.125ZM15 10.125H16.1111C16.4167 10.125 16.6667 10.3781 16.6667 10.6875V11.8125C16.6667 12.1219 16.4167 12.375 16.1111 12.375H15C14.6944 12.375 14.4444 12.1219 14.4444 11.8125V10.6875C14.4444 10.3781 14.6944 10.125 15 10.125Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function yv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 7.131 C 4.32 6.639 4.719 6.24 5.211 6.24 H 18.792 C 19.284 6.24 19.683 6.639 19.683 7.131 C 19.683 7.368 19.59 7.593 19.422 7.761 L 14.4 12.777 V 18.789 C 14.4 19.281 14.001 19.68 13.509 19.68 C 13.272 19.68 13.047 19.587 12.879 19.419 L 9.81 16.35 C 9.675 16.215 9.6 16.032 9.6 15.84 V 12.777 L 4.581 7.758 C 4.413 7.593 4.32 7.365 4.32 7.131 Z M 6.537 7.68 L 10.83 11.97 C 10.965 12.105 11.04 12.288 11.04 12.48 V 15.543 L 12.96 17.463 V 12.48 C 12.96 12.288 13.035 12.105 13.17 11.97 L 17.46 7.68 H 6.537 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function xv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M6.87493 0.937491C6.87493 0.417965 6.45697 0 5.93744 0C5.41791 0 4.99995 0.417965 4.99995 0.937491V2.49997C3.62106 2.49997 2.49997 3.62106 2.49997 4.99995H0.937491C0.417965 4.99995 0 5.41791 0 5.93744C0 6.45697 0.417965 6.87493 0.937491 6.87493H2.49997V9.06241H0.937491C0.417965 9.06241 0 9.48037 0 9.9999C0 10.5194 0.417965 10.9374 0.937491 10.9374H2.49997V13.1249H0.937491C0.417965 13.1249 0 13.5428 0 14.0624C0 14.5819 0.417965 14.9998 0.937491 14.9998H2.49997C2.49997 16.3787 3.62106 17.4998 4.99995 17.4998V19.0623C4.99995 19.5818 5.41791 19.9998 5.93744 19.9998C6.45697 19.9998 6.87493 19.5818 6.87493 19.0623V17.4998H9.06241V19.0623C9.06241 19.5818 9.48037 19.9998 9.9999 19.9998C10.5194 19.9998 10.9374 19.5818 10.9374 19.0623V17.4998H13.1249V19.0623C13.1249 19.5818 13.5428 19.9998 14.0624 19.9998C14.5819 19.9998 14.9998 19.5818 14.9998 19.0623V17.4998C16.3787 17.4998 17.4998 16.3787 17.4998 14.9998H19.0623C19.5818 14.9998 19.9998 14.5819 19.9998 14.0624C19.9998 13.5428 19.5818 13.1249 19.0623 13.1249H17.4998V10.9374H19.0623C19.5818 10.9374 19.9998 10.5194 19.9998 9.9999C19.9998 9.48037 19.5818 9.06241 19.0623 9.06241H17.4998V6.87493H19.0623C19.5818 6.87493 19.9998 6.45697 19.9998 5.93744C19.9998 5.41791 19.5818 4.99995 19.0623 4.99995H17.4998C17.4998 3.62106 16.3787 2.49997 14.9998 2.49997V0.937491C14.9998 0.417965 14.5819 0 14.0624 0C13.5428 0 13.1249 0.417965 13.1249 0.937491V2.49997H10.9374V0.937491C10.9374 0.417965 10.5194 0 9.9999 0C9.48037 0 9.06241 0.417965 9.06241 0.937491V2.49997H6.87493V0.937491ZM15.6248 4.99995V14.9998C15.6248 15.3436 15.3436 15.6248 14.9998 15.6248H4.99995C4.6562 15.6248 4.37496 15.3436 4.37496 14.9998V4.99995C4.37496 4.6562 4.6562 4.37496 4.99995 4.37496H14.9998C15.3436 4.37496 15.6248 4.6562 15.6248 4.99995ZM7.49992 6.24994C6.80852 6.24994 6.24994 6.80852 6.24994 7.49992V12.4999C6.24994 13.1913 6.80852 13.7499 7.49992 13.7499H12.4999C13.1913 13.7499 13.7499 13.1913 13.7499 12.4999V7.49992C13.7499 6.80852 13.1913 6.24994 12.4999 6.24994H7.49992ZM8.12492 8.12492H11.8749V11.8749H8.12492V8.12492Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Cv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.378 2.2403 C 11.734 1.9199 12.273 1.9199 12.628 2.2403 L 21.688 10.3661 C 22.075 10.7098 22.106 11.3036 21.759 11.6904 C 21.411 12.0772 20.821 12.1084 20.435 11.7607 L 20.122 11.4794 V 19.4998 C 20.122 20.8788 19.001 22 17.623 22 H 6.376 C 4.997 22 3.876 20.8788 3.876 19.4998 V 11.4794 L 3.564 11.7607 C 3.177 12.1045 2.588 12.0732 2.24 11.6904 C 1.893 11.3075 1.928 10.7137 2.31 10.3661 L 11.378 2.2403 Z M 12.003 4.1975 L 5.755 9.8035 V 19.5037 C 5.755 19.8474 6.036 20.1287 6.38 20.1287 H 8.254 V 16.0658 C 8.254 14.511 9.512 13.2531 11.066 13.2531 H 12.94 C 14.495 13.2531 15.752 14.511 15.752 16.0658 V 20.1287 H 17.627 C 17.97 20.1287 18.252 19.8474 18.252 19.5037 V 9.8035 L 12.003 4.2014 V 4.1975 Z M 10.129 20.1287 H 13.878 V 16.0658 C 13.878 15.5462 13.46 15.1282 12.94 15.1282 H 11.066 C 10.547 15.1282 10.129 15.5462 10.129 16.0658 V 20.1287 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function wv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.5 5.375 C 19.844 5.375 20.125 5.6562 20.125 6 V 18.4922 L 19.93 18.2383 L 14.617 11.3633 C 14.441 11.1328 14.164 11 13.875 11 C 13.586 11 13.312 11.1328 13.133 11.3633 L 9.891 15.5586 L 8.699 13.8906 C 8.523 13.6445 8.242 13.5 7.938 13.5 C 7.633 13.5 7.352 13.6445 7.176 13.8945 L 4.051 18.2695 L 3.875 18.5117 V 18.5 V 6 C 3.875 5.6562 4.156 5.375 4.5 5.375 H 19.5 Z M 4.5 3.5 C 3.121 3.5 2 4.6211 2 6 V 18.5 C 2 19.8789 3.121 21 4.5 21 H 19.5 C 20.879 21 22 19.8789 22 18.5 V 6 C 22 4.6211 20.879 3.5 19.5 3.5 H 4.5 Z M 7.625 11 C 7.871 11 8.115 10.9515 8.343 10.8573 C 8.57 10.763 8.777 10.6249 8.951 10.4508 C 9.125 10.2767 9.263 10.07 9.357 9.8425 C 9.452 9.615 9.5 9.3712 9.5 9.125 C 9.5 8.8788 9.452 8.635 9.357 8.4075 C 9.263 8.18 9.125 7.9733 8.951 7.7992 C 8.777 7.6251 8.57 7.487 8.343 7.3927 C 8.115 7.2985 7.871 7.25 7.625 7.25 C 7.379 7.25 7.135 7.2985 6.907 7.3927 C 6.68 7.487 6.473 7.6251 6.299 7.7992 C 6.125 7.9733 5.987 8.18 5.893 8.4075 C 5.798 8.635 5.75 8.8788 5.75 9.125 C 5.75 9.3712 5.798 9.615 5.893 9.8425 C 5.987 10.07 6.125 10.2767 6.299 10.4508 C 6.473 10.6249 6.68 10.763 6.907 10.8573 C 7.135 10.9515 7.379 11 7.625 11 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Sv(t) {
  const e = W.c(13), n = $t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 9.12 5.5198 C 9.519 5.5198 9.84 5.8408 9.84 6.2398 C 9.84 6.6388 9.519 6.9598 9.12 6.9598 C 8.721 6.9598 8.4 6.6388 8.4 6.2398 C 8.4 5.8408 8.721 5.5198 9.12 5.5198 Z M 9.12 8.1598 C 9.153 8.1598 9.186 8.1598 9.219 8.1568 L 10.026 9.8848 C 9.087 10.5358 8.415 11.5468 8.22 12.7198 H 6.102 C 5.817 12.0148 5.127 11.5198 4.323 11.5198 C 3.264 11.5198 2.403 12.3808 2.403 13.4398 C 2.403 14.4988 3.264 15.3598 4.323 15.3598 C 5.13 15.3598 5.82 14.8648 6.102 14.1598 H 8.22 C 8.562 16.2028 10.341 17.7598 12.48 17.7598 C 13.794 17.7598 14.97 17.1748 15.762 16.2478 L 17.784 17.4598 C 17.769 17.5558 17.76 17.6578 17.76 17.7568 C 17.76 18.8158 18.621 19.6768 19.68 19.6768 C 20.739 19.6768 21.6 18.8158 21.6 17.7568 C 21.6 16.6978 20.739 15.8368 19.68 15.8368 C 19.245 15.8368 18.846 15.9808 18.525 16.2238 L 16.506 15.0118 C 16.698 14.5228 16.803 13.9918 16.803 13.4368 C 16.803 12.7408 16.638 12.0808 16.344 11.4988 L 18.672 9.7918 C 18.966 9.9748 19.311 10.0798 19.683 10.0798 C 20.742 10.0798 21.603 9.2188 21.603 8.1598 C 21.603 7.1008 20.742 6.2398 19.683 6.2398 C 18.624 6.2398 17.763 7.1008 17.763 8.1598 C 17.763 8.3218 17.784 8.4808 17.82 8.6308 L 15.492 10.3378 C 14.715 9.5818 13.653 9.1168 12.483 9.1168 C 12.084 9.1168 11.7 9.1708 11.334 9.2728 L 10.527 7.5478 C 10.845 7.2058 11.04 6.7468 11.04 6.2398 C 11.04 5.1808 10.179 4.3198 9.12 4.3198 C 8.061 4.3198 7.2 5.1808 7.2 6.2398 C 7.2 7.2988 8.061 8.1598 9.12 8.1598 Z M 19.68 7.4398 C 20.079 7.4398 20.4 7.7608 20.4 8.1598 C 20.4 8.5588 20.079 8.8798 19.68 8.8798 C 19.281 8.8798 18.96 8.5588 18.96 8.1598 C 18.96 7.7608 19.281 7.4398 19.68 7.4398 Z M 18.96 17.7598 C 18.96 17.3608 19.281 17.0398 19.68 17.0398 C 20.079 17.0398 20.4 17.3608 20.4 17.7598 C 20.4 18.1588 20.079 18.4798 19.68 18.4798 C 19.281 18.4798 18.96 18.1588 18.96 17.7598 Z M 4.32 12.7198 C 4.719 12.7198 5.04 13.0408 5.04 13.4398 C 5.04 13.8388 4.719 14.1598 4.32 14.1598 C 3.921 14.1598 3.6 13.8388 3.6 13.4398 C 3.6 13.0408 3.921 12.7198 4.32 12.7198 Z M 12.48 10.5598 C 14.07 10.5598 15.36 11.8498 15.36 13.4398 C 15.36 15.0298 14.07 16.3198 12.48 16.3198 C 10.89 16.3198 9.6 15.0298 9.6 13.4398 C 9.6 11.8498 10.89 10.5598 12.48 10.5598 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function Rv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M0.91935 0C0.409877 0 0 0.409877 0 0.91935V2.75805C0 3.26752 0.409877 3.6774 0.91935 3.6774H2.75805C3.26752 3.6774 3.6774 3.26752 3.6774 2.75805V0.91935C3.6774 0.409877 3.26752 0 2.75805 0H0.91935ZM6.43545 0.91935C5.92598 0.91935 5.5161 1.32923 5.5161 1.8387C5.5161 2.34817 5.92598 2.75805 6.43545 2.75805H18.0806C18.59 2.75805 18.9999 2.34817 18.9999 1.8387C18.9999 1.32923 18.59 0.91935 18.0806 0.91935H6.43545ZM6.43545 7.04835C5.92598 7.04835 5.5161 7.45823 5.5161 7.9677C5.5161 8.47717 5.92598 8.88705 6.43545 8.88705H18.0806C18.59 8.88705 18.9999 8.47717 18.9999 7.9677C18.9999 7.45823 18.59 7.04835 18.0806 7.04835H6.43545ZM6.43545 13.1774C5.92598 13.1774 5.5161 13.5872 5.5161 14.0967C5.5161 14.6062 5.92598 15.0161 6.43545 15.0161H18.0806C18.59 15.0161 18.9999 14.6062 18.9999 14.0967C18.9999 13.5872 18.59 13.1774 18.0806 13.1774H6.43545ZM0 7.04835V8.88705C0 9.39652 0.409877 9.8064 0.91935 9.8064H2.75805C3.26752 9.8064 3.6774 9.39652 3.6774 8.88705V7.04835C3.6774 6.53888 3.26752 6.129 2.75805 6.129H0.91935C0.409877 6.129 0 6.53888 0 7.04835ZM0.91935 12.258C0.409877 12.258 0 12.6679 0 13.1774V15.0161C0 15.5255 0.409877 15.9354 0.91935 15.9354H2.75805C3.26752 15.9354 3.6774 15.5255 3.6774 15.0161V13.1774C3.6774 12.6679 3.26752 12.258 2.75805 12.258H0.91935Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Ev(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.6 9.4725 C 6.6 10.5263 6.941 11.76 7.56 13.0913 C 8.171 14.4075 9 15.72 9.859 16.8975 C 10.62 17.9475 11.389 18.8663 12.004 19.5638 C 12.619 18.8663 13.384 17.9475 14.149 16.8975 C 15.007 15.72 15.836 14.4075 16.447 13.0913 C 17.062 11.76 17.407 10.5263 17.407 9.4725 C 17.407 6.5925 15.019 4.2 12.007 4.2 C 8.996 4.2 6.6 6.5888 6.6 9.4725 Z M 19.2 9.4725 C 19.2 13.6425 15.289 18.5775 13.234 20.8875 C 12.851 21.3188 12.532 21.6563 12.315 21.8813 C 12.116 22.0875 12 22.2 12 22.2 C 12 22.2 11.887 22.0875 11.685 21.8813 C 11.467 21.6563 11.149 21.315 10.766 20.8875 C 8.711 18.5775 4.8 13.6425 4.8 9.4725 C 4.8 5.565 8.025 2.4 12 2.4 C 15.975 2.4 19.2 5.565 19.2 9.4725 Z M 13.2 9.6 C 13.2 9.2818 13.073 8.9765 12.848 8.7515 C 12.623 8.5265 12.318 8.4 12 8.4 C 11.682 8.4 11.376 8.5265 11.151 8.7515 C 10.926 8.9765 10.8 9.2818 10.8 9.6 C 10.8 9.9183 10.926 10.2235 11.151 10.4486 C 11.376 10.6736 11.682 10.8 12 10.8 C 12.318 10.8 12.623 10.6736 12.848 10.4486 C 13.073 10.2235 13.2 9.9183 13.2 9.6 Z M 9 9.6 C 9 8.8044 9.316 8.0413 9.878 7.4787 C 10.441 6.9161 11.204 6.6 12 6.6 C 12.795 6.6 13.559 6.9161 14.121 7.4787 C 14.684 8.0413 15 8.8044 15 9.6 C 15 10.3957 14.684 11.1587 14.121 11.7213 C 13.559 12.284 12.795 12.6 12 12.6 C 11.204 12.6 10.441 12.284 9.878 11.7213 C 9.316 11.1587 9 10.3957 9 9.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Nv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.378 8.5091 C 9.378 5.1346 12.113 2.4 15.487 2.4 C 16.473 2.4 17.407 2.6328 18.233 3.0509 C 18.484 3.1782 18.658 3.4146 18.702 3.6909 C 18.745 3.9673 18.654 4.2473 18.458 4.4473 L 15.778 7.1273 V 8.2218 H 16.873 L 19.553 5.5418 C 19.749 5.3455 20.033 5.2546 20.309 5.2982 C 20.585 5.3418 20.825 5.5164 20.949 5.7673 C 21.364 6.5928 21.6 7.5273 21.6 8.5128 C 21.6 11.8873 18.865 14.6218 15.491 14.6218 C 14.887 14.6218 14.302 14.5346 13.749 14.3709 L 7.364 20.7491 C 6.229 21.8837 4.385 21.8837 3.251 20.7491 C 2.116 19.6146 2.116 17.7709 3.251 16.6364 L 9.629 10.2509 C 9.465 9.6982 9.378 9.1128 9.378 8.5091 Z M 15.487 4.1455 C 13.076 4.1455 11.124 6.0982 11.124 8.5091 C 11.124 9.0909 11.236 9.6473 11.444 10.1528 C 11.574 10.4764 11.502 10.8509 11.251 11.0982 L 4.48 17.8691 C 4.025 18.3237 4.025 19.0618 4.48 19.5164 C 4.934 19.9709 5.673 19.9709 6.127 19.5164 L 12.898 12.7455 C 13.145 12.4982 13.52 12.4218 13.844 12.5528 C 14.349 12.76 14.905 12.8728 15.487 12.8728 C 17.898 12.8728 19.851 10.92 19.851 8.5091 C 19.851 8.2582 19.829 8.0109 19.789 7.7709 L 17.851 9.7091 C 17.687 9.8728 17.465 9.9637 17.233 9.9637 H 14.905 C 14.422 9.9637 14.033 9.5746 14.033 9.0909 V 6.7637 C 14.033 6.5309 14.124 6.3091 14.287 6.1455 L 16.225 4.2073 C 15.985 4.1673 15.738 4.1455 15.487 4.1455 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function kv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Iv(t) {
  const e = W.c(13), n = $t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("path", { d: "M 15.12 5.76 C 15.12 6.024 14.904 6.24 14.64 6.24 H 12.48 V 8.16 H 15.84 C 16.899 8.16 17.76 9.021 17.76 10.08 V 10.581 C 17.445 10.554 17.115 10.554 16.8 10.581 V 10.08 C 16.8 9.549 16.371 9.12 15.84 9.12 H 8.16 C 7.629 9.12 7.2 9.549 7.2 10.08 V 13.92 C 7.2 14.451 7.629 14.88 8.16 14.88 H 9.12 C 9.27 14.88 9.414 14.952 9.504 15.072 L 10.512 16.416 C 10.692 16.659 10.977 16.8 11.28 16.8 H 11.541 C 11.568 17.13 11.622 17.448 11.703 17.76 H 11.283 C 10.68 17.76 10.11 17.475 9.747 16.992 L 8.88 15.84 H 8.16 C 7.101 15.84 6.24 14.979 6.24 13.92 V 12.48 H 5.28 V 14.88 C 5.28 15.144 5.064 15.36 4.8 15.36 C 4.536 15.36 4.32 15.144 4.32 14.88 V 9.12 C 4.32 8.856 4.536 8.64 4.8 8.64 C 5.064 8.64 5.28 8.856 5.28 9.12 V 11.52 H 6.24 V 10.08 C 6.24 9.021 7.101 8.16 8.16 8.16 H 11.52 V 6.24 H 9.36 C 9.096 6.24 8.88 6.024 8.88 5.76 C 8.88 5.496 9.096 5.28 9.36 5.28 H 14.64 C 14.904 5.28 15.12 5.496 15.12 5.76 Z M 18.72 10.74 V 9.6 C 18.72 9.336 18.936 9.12 19.2 9.12 C 19.464 9.12 19.68 9.336 19.68 9.6 V 11.082 C 19.374 10.941 19.053 10.827 18.72 10.74 Z M 14.4 11.04 C 14.523 11.04 14.634 11.085 14.718 11.16 C 14.265 11.385 13.845 11.67 13.47 12 H 9.6 C 9.336 12 9.12 11.784 9.12 11.52 C 9.12 11.256 9.336 11.04 9.6 11.04 H 14.4 Z M 20.64 16.32 C 20.64 14.463 19.137 12.96 17.28 12.96 C 15.423 12.96 13.92 14.463 13.92 16.32 C 13.92 18.177 15.423 19.68 17.28 19.68 C 19.137 19.68 20.64 18.177 20.64 16.32 Z M 12.96 16.32 C 12.96 13.935 14.895 12 17.28 12 C 19.665 12 21.6 13.935 21.6 16.32 C 21.6 18.705 19.665 20.64 17.28 20.64 C 14.895 20.64 12.96 18.705 12.96 16.32 Z M 17.28 17.64 C 17.61 17.64 17.88 17.91 17.88 18.24 C 17.88 18.57 17.61 18.84 17.28 18.84 C 16.95 18.84 16.68 18.57 16.68 18.24 C 16.68 17.91 16.95 17.64 17.28 17.64 Z M 17.28 13.92 C 17.544 13.92 17.76 14.136 17.76 14.4 V 16.32 C 17.76 16.584 17.544 16.8 17.28 16.8 C 17.016 16.8 16.8 16.584 16.8 16.32 V 14.4 C 16.8 14.136 17.016 13.92 17.28 13.92 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ g("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function Pv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 4.3199 C 11.601 4.3199 11.28 4.6409 11.28 5.0399 V 5.3309 C 8.838 5.6789 6.96 7.7819 6.96 10.3199 V 10.7549 C 6.96 11.8859 6.66 12.9959 6.09 13.9739 L 5.433 15.0959 C 5.334 15.2699 5.28 15.4649 5.28 15.6659 C 5.28 16.2929 5.787 16.7999 6.414 16.7999 H 17.586 C 18.213 16.7999 18.72 16.2929 18.72 15.6659 C 18.72 15.4649 18.666 15.2669 18.567 15.0959 L 17.91 13.9709 C 17.34 12.9929 17.04 11.8829 17.04 10.7519 V 10.3169 C 17.04 7.7789 15.162 5.6759 12.72 5.3279 V 5.0369 C 12.72 4.6379 12.399 4.3169 12 4.3169 V 4.3199 Z M 17.052 15.3599 H 6.945 L 7.332 14.6969 C 8.031 13.4999 8.4 12.1379 8.4 10.7549 V 10.3199 C 8.4 8.3309 10.011 6.7199 12 6.7199 C 13.989 6.7199 15.6 8.3309 15.6 10.3199 V 10.7549 C 15.6 12.1409 15.969 13.4999 16.665 14.6969 L 17.052 15.3599 Z M 9.963 18.2399 C 10.26 19.0799 11.061 19.6799 12 19.6799 C 12.939 19.6799 13.74 19.0799 14.037 18.2399 H 9.963 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Mv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.6 1 C 8.936 1 8.4 1.5462 8.4 2.2222 C 8.4 2.6729 8.64 3.0701 9 3.2802 V 7.9285 C 7.208 8.9865 6 10.9573 6 13.2222 V 19.6389 C 6 21.4951 7.478 23 9.3 23 H 14.7 C 16.523 23 18 21.4951 18 19.6389 V 13.2222 C 18 10.9573 16.793 8.9865 15 7.9285 V 3.2802 C 15.36 3.0701 15.6 2.6729 15.6 2.2222 C 15.6 1.5462 15.064 1 14.4 1 H 9.6 Z M 10.8 3.4444 H 13.2 V 8.4861 C 13.2 8.8451 13.406 9.1736 13.729 9.3226 C 15.188 9.9948 16.2 11.4882 16.2 13.2222 V 19.6389 C 16.2 20.483 15.529 21.1667 14.7 21.1667 H 9.3 C 8.471 21.1667 7.8 20.483 7.8 19.6389 V 13.2222 C 7.8 11.4882 8.812 9.9948 10.271 9.3226 C 10.594 9.1736 10.8 8.849 10.8 8.4861 V 3.4444 Z M 14.4 15.6667 C 14.4 14.8569 13.316 13.2031 12.604 12.2062 C 12.3 11.7823 11.696 11.7823 11.393 12.2062 C 10.68 13.2031 9.596 14.8569 9.596 15.6667 C 9.596 16.8736 10.673 18.1111 11.996 18.1111 C 13.32 18.1111 14.396 16.8736 14.396 15.6667 H 14.4 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Tv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.212 2.7115 C 13.212 2.0401 12.671 1.5 12 1.5 C 11.329 1.5 10.788 2.0401 10.788 2.7115 V 10.7885 H 2.712 C 2.04 10.7885 1.5 11.3286 1.5 12 C 1.5 12.6714 2.04 13.2115 2.712 13.2115 H 10.788 V 21.2885 C 10.788 21.9599 11.329 22.5 12 22.5 C 12.671 22.5 13.212 21.9599 13.212 21.2885 V 13.2115 H 21.288 C 21.96 13.2115 22.5 12.6714 22.5 12 C 22.5 11.3286 21.96 10.7885 21.288 10.7885 H 13.212 V 2.7115 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Ov(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.19979 5.27982V4.31982H5.27979V19.6798H7.19979V15.0718L9.08079 14.5078C10.3378 14.1298 11.6938 14.2468 12.8668 14.8348C14.1478 15.4768 15.6418 15.5548 16.9828 15.0508L18.7198 14.3998V4.79982L17.0218 5.64882C15.6748 6.32382 14.0878 6.32382 12.7378 5.64882C11.6458 5.10282 10.3888 4.99482 9.22178 5.34582L7.19979 5.95182V5.27982Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Dv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.199 10.2018 C 16.199 6.8871 13.514 4.2024 10.199 4.2024 C 6.884 4.2024 4.2 6.8871 4.2 10.2018 C 4.2 13.5165 6.884 16.2012 10.199 16.2012 C 13.514 16.2012 16.199 13.5165 16.199 10.2018 Z M 15.04 16.3175 C 13.713 17.3711 12.029 18.0011 10.199 18.0011 C 5.891 18.0011 2.4 14.5102 2.4 10.2018 C 2.4 5.8935 5.891 2.4026 10.199 2.4026 C 14.507 2.4026 17.998 5.8935 17.998 10.2018 C 17.998 12.0316 17.368 13.7152 16.315 15.0426 L 21.336 20.0634 C 21.688 20.4158 21.688 20.9858 21.336 21.3345 C 20.983 21.6832 20.413 21.687 20.064 21.3345 L 15.04 16.3175 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function _v(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.485 7.1008 L 10.896 5.2798 H 13.104 L 13.515 7.1008 C 13.566 7.3228 13.719 7.5088 13.929 7.6018 C 14.253 7.7458 14.559 7.9228 14.841 8.1298 C 15.024 8.2648 15.264 8.3068 15.483 8.2378 L 17.268 7.6828 L 18.372 9.5968 L 16.998 10.8658 C 16.83 11.0218 16.746 11.2468 16.77 11.4718 C 16.809 11.8168 16.809 12.1828 16.77 12.5278 C 16.746 12.7558 16.83 12.9808 16.998 13.1338 L 18.372 14.4028 L 17.268 16.3168 L 15.483 15.7618 C 15.264 15.6928 15.027 15.7348 14.841 15.8698 C 14.559 16.0768 14.253 16.2568 13.929 16.3978 C 13.719 16.4908 13.566 16.6768 13.515 16.8988 L 13.104 18.7198 H 10.896 L 10.485 16.8988 C 10.434 16.6768 10.281 16.4908 10.071 16.3978 C 9.747 16.2538 9.441 16.0768 9.159 15.8698 C 8.976 15.7348 8.736 15.6928 8.517 15.7618 L 6.732 16.3168 L 5.628 14.4028 L 7.002 13.1338 C 7.17 12.9778 7.254 12.7528 7.23 12.5278 C 7.191 12.1828 7.191 11.8168 7.23 11.4718 C 7.254 11.2438 7.17 11.0188 7.002 10.8658 L 5.628 9.5968 L 6.732 7.6828 L 8.517 8.2378 C 8.736 8.3068 8.973 8.2648 9.159 8.1298 C 9.441 7.9228 9.747 7.7428 10.071 7.6018 C 10.281 7.5088 10.434 7.3228 10.485 7.1008 Z M 10.704 3.8398 C 10.143 3.8398 9.657 4.2298 9.534 4.7758 L 9.156 6.4438 C 8.967 6.5398 8.787 6.6448 8.61 6.7588 L 6.978 6.2518 C 6.441 6.0838 5.862 6.3118 5.583 6.7978 L 4.287 9.0418 C 4.008 9.5278 4.101 10.1428 4.512 10.5238 L 5.769 11.6848 C 5.76 11.8918 5.76 12.1048 5.769 12.3148 L 4.512 13.4758 C 4.101 13.8568 4.005 14.4718 4.287 14.9578 L 5.583 17.2018 C 5.862 17.6878 6.444 17.9128 6.978 17.7478 L 8.613 17.2408 C 8.79 17.3548 8.97 17.4598 9.159 17.5558 L 9.537 19.2238 C 9.66 19.7698 10.146 20.1598 10.707 20.1598 H 13.299 C 13.86 20.1598 14.346 19.7698 14.469 19.2238 L 14.847 17.5558 C 15.036 17.4598 15.216 17.3548 15.393 17.2408 L 17.028 17.7478 C 17.565 17.9158 18.144 17.6878 18.423 17.2018 L 19.719 14.9578 C 19.998 14.4718 19.905 13.8568 19.494 13.4758 L 18.237 12.3148 C 18.246 12.1078 18.246 11.8948 18.237 11.6848 L 19.494 10.5238 C 19.905 10.1428 19.998 9.5278 19.719 9.0418 L 18.42 6.7978 C 18.138 6.3118 17.559 6.0868 17.025 6.2518 L 15.39 6.7588 C 15.213 6.6448 15.033 6.5398 14.844 6.4438 L 14.469 4.7758 C 14.343 4.2298 13.857 3.8398 13.296 3.8398 H 10.704 Z M 13.44 11.9998 C 13.44 12.7948 12.795 13.4398 12 13.4398 C 11.205 13.4398 10.56 12.7948 10.56 11.9998 C 10.56 11.2048 11.205 10.5598 12 10.5598 C 12.795 10.5598 13.44 11.2048 13.44 11.9998 Z M 12 9.1198 C 10.41 9.1198 9.12 10.4098 9.12 11.9998 C 9.12 13.5898 10.41 14.8798 12 14.8798 C 13.59 14.8798 14.88 13.5898 14.88 11.9998 C 14.88 10.4098 13.59 9.1198 12 9.1198 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Vv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.539 7.8393 C 13.187 8.1918 12.617 8.1918 12.268 7.8393 C 11.919 7.4868 11.916 6.9168 12.268 6.5681 L 16.164 2.6643 C 16.517 2.3118 17.087 2.3118 17.436 2.6643 L 21.336 6.5643 C 21.688 6.9168 21.688 7.4868 21.336 7.8356 C 20.983 8.1843 20.413 8.1881 20.064 7.8356 L 17.702 5.4731 V 20.7018 C 17.702 21.2006 17.301 21.6018 16.802 21.6018 C 16.303 21.6018 15.902 21.2006 15.902 20.7018 V 5.4731 L 13.539 7.8356 V 7.8393 Z M 3.939 16.1643 L 6.302 18.5268 V 3.2981 C 6.302 2.7993 6.703 2.3981 7.202 2.3981 C 7.701 2.3981 8.102 2.7993 8.102 3.2981 V 18.5268 L 10.464 16.1643 C 10.817 15.8118 11.387 15.8118 11.736 16.1643 C 12.084 16.5168 12.088 17.0868 11.736 17.4356 L 7.836 21.3356 C 7.483 21.6881 6.913 21.6881 6.564 21.3356 L 2.664 17.4393 C 2.312 17.0868 2.312 16.5168 2.664 16.1681 C 3.017 15.8193 3.587 15.8156 3.936 16.1681 L 3.939 16.1643 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Av(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Lv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.781 3.4736 C 12.632 3.1844 12.33 3 12.003 3 C 11.676 3 11.374 3.1844 11.225 3.4736 L 8.55 8.6862 L 2.737 9.6044 C 2.414 9.655 2.145 9.8828 2.043 10.1936 C 1.941 10.5045 2.025 10.8443 2.254 11.0757 L 6.412 15.2147 L 5.496 20.9949 C 5.445 21.3167 5.58 21.642 5.845 21.8336 C 6.111 22.0252 6.46 22.0541 6.754 21.9059 L 12.003 19.2526 L 17.249 21.9059 C 17.54 22.0541 17.892 22.0252 18.158 21.8336 C 18.423 21.642 18.558 21.3203 18.507 20.9949 L 17.587 15.2147 L 21.746 11.0757 C 21.978 10.8443 22.058 10.5045 21.957 10.1936 C 21.855 9.8828 21.589 9.655 21.262 9.6044 L 15.453 8.6862 L 12.781 3.4736 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Fv(t) {
  const e = W.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.199 11.3999 C 19.531 11.3998 19.799 11.6684 19.799 11.9997 L 19.8 15.9268 C 19.8 16.0859 19.737 16.2385 19.624 16.3511 C 19.512 16.4637 19.359 16.5269 19.2 16.5269 L 15.272 16.5268 C 14.941 16.5268 14.672 16.2581 14.672 15.9268 C 14.672 15.5954 14.941 15.3268 15.272 15.3268 L 18.6 15.3269 L 18.599 12 C 18.599 11.6686 18.868 11.4 19.199 11.3999 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 4.375 7.6474 C 4.61 7.4131 4.99 7.4131 5.224 7.6474 L 9.709 12.1324 L 12.557 9.2843 C 12.791 9.05 13.171 9.05 13.405 9.2843 L 19.624 15.502 C 19.858 15.7363 19.858 16.1162 19.624 16.3505 C 19.39 16.5848 19.01 16.5849 18.775 16.3506 L 12.981 10.5571 L 10.133 13.4052 C 9.899 13.6395 9.519 13.6395 9.285 13.4052 L 4.375 8.4959 C 4.141 8.2616 4.141 7.8817 4.375 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function $v(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M19.1454 10.5575C19.4514 10.2514 19.4514 9.75637 19.1454 9.45351L14.7188 5.02131C14.4128 4.71519 13.9181 4.71519 13.6154 5.02131C13.3127 5.32743 13.3094 5.82243 13.6154 6.12529L16.7075 9.21903H1.40627C0.973369 9.21903 0.625095 9.56749 0.625095 10.0006C0.625095 10.4337 0.973369 10.7822 1.40627 10.7822H16.7075L13.6154 13.8759C13.3094 14.1821 13.3094 14.677 13.6154 14.9799C13.9213 15.2828 14.4161 15.286 14.7188 14.9799L19.1454 10.5575Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Hv(t) {
  const e = W.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 14.673 8.0727 C 14.673 7.7413 14.941 7.4727 15.273 7.4727 H 19.2 C 19.531 7.4727 19.8 7.7413 19.8 8.0726 V 11.9996 C 19.8 12.3309 19.531 12.5996 19.2 12.5996 C 18.868 12.5996 18.6 12.3309 18.6 11.9996 V 8.6727 H 15.273 C 14.941 8.6727 14.673 8.404 14.673 8.0727 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.624 7.6474 C 19.858 7.8817 19.858 8.2616 19.624 8.4959 L 13.405 14.7144 C 13.293 14.8269 13.14 14.8901 12.981 14.8901 C 12.822 14.8901 12.669 14.8268 12.557 14.7144 L 9.709 11.8656 L 5.224 16.3505 C 4.99 16.5848 4.61 16.5848 4.375 16.3505 C 4.141 16.1162 4.141 15.7363 4.375 15.502 L 9.285 10.5928 C 9.397 10.4803 9.55 10.417 9.709 10.4171 C 9.868 10.4171 10.021 10.4803 10.133 10.5928 L 12.981 13.4416 L 18.775 7.6474 C 19.01 7.4131 19.39 7.4131 19.624 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function zv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.72 14.1599 C 12.72 14.5589 12.399 14.8799 12 14.8799 C 11.601 14.8799 11.28 14.5589 11.28 14.1599 V 6.7769 L 9.39 8.6669 C 9.108 8.9489 8.652 8.9489 8.373 8.6669 C 8.094 8.3849 8.091 7.9289 8.373 7.6499 L 11.49 4.5299 C 11.772 4.2479 12.228 4.2479 12.507 4.5299 L 15.63 7.6499 C 15.912 7.9319 15.912 8.3879 15.63 8.6669 C 15.348 8.9459 14.892 8.9489 14.613 8.6669 L 12.723 6.7769 V 14.1599 H 12.72 Z M 9.84 13.9199 H 7.2 C 6.936 13.9199 6.72 14.1359 6.72 14.3999 V 16.7999 C 6.72 17.0639 6.936 17.2799 7.2 17.2799 H 16.8 C 17.064 17.2799 17.28 17.0639 17.28 16.7999 V 14.3999 C 17.28 14.1359 17.064 13.9199 16.8 13.9199 H 14.16 V 12.4799 H 16.8 C 17.859 12.4799 18.72 13.3409 18.72 14.3999 V 16.7999 C 18.72 17.8589 17.859 18.7199 16.8 18.7199 H 7.2 C 6.141 18.7199 5.28 17.8589 5.28 16.7999 V 14.3999 C 5.28 13.3409 6.141 12.4799 7.2 12.4799 H 9.84 V 13.9199 Z M 14.88 15.5999 C 14.88 15.2009 15.201 14.8799 15.6 14.8799 C 15.999 14.8799 16.32 15.2009 16.32 15.5999 C 16.32 15.9989 15.999 16.3199 15.6 16.3199 C 15.201 16.3199 14.88 15.9989 14.88 15.5999 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Bv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M5.78571 5C5.78571 4.1712 6.12436 3.37634 6.72716 2.79029C7.32995 2.20424 8.14752 1.875 9 1.875C9.85248 1.875 10.67 2.20424 11.2728 2.79029C11.8756 3.37634 12.2143 4.1712 12.2143 5C12.2143 5.8288 11.8756 6.62366 11.2728 7.20971C10.67 7.79576 9.85248 8.125 9 8.125C8.14752 8.125 7.32995 7.79576 6.72716 7.20971C6.12436 6.62366 5.78571 5.8288 5.78571 5ZM14.1429 5C14.1429 3.67392 13.601 2.40215 12.6365 1.46447C11.6721 0.526784 10.364 0 9 0C7.63603 0 6.32792 0.526784 5.36345 1.46447C4.39898 2.40215 3.85714 3.67392 3.85714 5C3.85714 6.32608 4.39898 7.59785 5.36345 8.53553C6.32792 9.47322 7.63603 10 9 10C10.364 10 11.6721 9.47322 12.6365 8.53553C13.601 7.59785 14.1429 6.32608 14.1429 5ZM1.92857 18.75C1.92857 15.9883 4.2308 13.75 7.07143 13.75H10.9286C13.7692 13.75 16.0714 15.9883 16.0714 18.75V19.0625C16.0714 19.582 16.5013 20 17.0357 20C17.5701 20 18 19.582 18 19.0625V18.75C18 14.9531 14.8339 11.875 10.9286 11.875H7.07143C3.16607 11.875 0 14.9531 0 18.75V19.0625C0 19.582 0.429911 20 0.964286 20C1.49866 20 1.92857 19.582 1.92857 19.0625V18.75Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Wv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.103 3.2971 C 15.44 3.2971 19.037 6.4723 19.697 10.6231 C 19.353 10.7931 19.047 11.0446 18.806 11.3778 L 18.167 12.2515 C 18.17 12.1665 18.174 12.0849 18.174 11.9999 C 18.174 8.0938 15.009 4.9289 11.103 4.9289 C 7.197 4.9289 4.032 8.0938 4.032 11.9999 C 4.032 15.9059 7.197 19.0709 11.103 19.0709 C 12.33 19.0709 13.482 18.7581 14.485 18.2108 L 15.542 19.3055 C 15.58 19.3428 15.621 19.3802 15.661 19.4142 C 14.336 20.2301 12.775 20.7027 11.103 20.7027 C 6.296 20.7027 2.4 16.8068 2.4 11.9999 C 2.4 7.193 6.296 3.2971 11.103 3.2971 Z M 20.125 12.3364 C 20.39 11.9727 20.9 11.8911 21.264 12.1563 C 21.628 12.4214 21.709 12.9314 21.444 13.2951 L 17.963 18.0816 C 17.82 18.2754 17.599 18.4012 17.361 18.4148 C 17.123 18.4284 16.885 18.34 16.719 18.1666 L 15.141 16.5348 C 14.829 16.2119 14.835 15.6952 15.162 15.3824 C 15.488 15.0697 16.001 15.0799 16.314 15.4028 L 17.215 16.3343 L 20.125 12.333 V 12.3364 Z M 11.103 16.3513 C 10.501 16.3513 10.015 15.8651 10.015 15.2634 C 10.015 14.6617 10.501 14.1756 11.103 14.1756 C 11.704 14.1756 12.191 14.6617 12.191 15.2634 C 12.191 15.8651 11.704 16.3513 11.103 16.3513 Z M 11.103 7.6485 C 11.721 7.6485 12.214 8.1754 12.17 8.7941 L 11.919 12.3296 C 11.888 12.758 11.531 13.0877 11.106 13.0877 C 10.678 13.0877 10.324 12.758 10.294 12.3296 L 10.042 8.7941 C 9.998 8.1754 10.487 7.6485 11.109 7.6485 H 11.103 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Uv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2 5.2222 C 2 3.9965 2.997 3 4.222 3 H 13.111 C 14.337 3 15.333 3.9965 15.333 5.2222 V 9.8958 C 12.767 10.6215 10.889 12.9792 10.889 15.7778 C 10.889 17.8299 11.899 19.6424 13.448 20.7535 C 13.337 20.7708 13.226 20.7778 13.111 20.7778 H 4.222 C 2.997 20.7778 2 19.7812 2 18.5556 V 5.2222 Z M 4.222 8 C 4.222 8.3056 4.472 8.5556 4.778 8.5556 H 12.556 C 12.861 8.5556 13.111 8.3056 13.111 8 C 13.111 7.6944 12.861 7.4444 12.556 7.4444 H 4.778 C 4.472 7.4444 4.222 7.6944 4.222 8 Z M 4.778 10.7778 C 4.472 10.7778 4.222 11.0278 4.222 11.3333 C 4.222 11.6389 4.472 11.8889 4.778 11.8889 H 10.333 C 10.639 11.8889 10.889 11.6389 10.889 11.3333 C 10.889 11.0278 10.639 10.7778 10.333 10.7778 H 4.778 Z M 4.778 14.1111 C 4.472 14.1111 4.222 14.3611 4.222 14.6667 C 4.222 14.9722 4.472 15.2222 4.778 15.2222 H 8.111 C 8.417 15.2222 8.667 14.9722 8.667 14.6667 C 8.667 14.3611 8.417 14.1111 8.111 14.1111 H 4.778 Z M 17 10.7778 C 18.326 10.7778 19.598 11.3046 20.536 12.2422 C 21.473 13.1799 22 14.4517 22 15.7778 C 22 17.1039 21.473 18.3756 20.536 19.3133 C 19.598 20.251 18.326 20.7778 17 20.7778 C 15.674 20.7778 14.402 20.251 13.464 19.3133 C 12.527 18.3756 12 17.1039 12 15.7778 C 12 14.4517 12.527 13.1799 13.464 12.2422 C 14.402 11.3046 15.674 10.7778 17 10.7778 Z M 17 14.1111 C 17.221 14.1111 17.433 14.0233 17.589 13.867 C 17.746 13.7108 17.833 13.4988 17.833 13.2778 C 17.833 13.0568 17.746 12.8448 17.589 12.6885 C 17.433 12.5322 17.221 12.4444 17 12.4444 C 16.779 12.4444 16.567 12.5322 16.411 12.6885 C 16.254 12.8448 16.167 13.0568 16.167 13.2778 C 16.167 13.4988 16.254 13.7108 16.411 13.867 C 16.567 14.0233 16.779 14.1111 17 14.1111 Z M 15.889 15.7778 C 15.889 16.0833 16.139 16.3333 16.444 16.3333 V 18 C 16.139 18 15.889 18.25 15.889 18.5556 C 15.889 18.8611 16.139 19.1111 16.444 19.1111 H 17 H 17.556 C 17.861 19.1111 18.111 18.8611 18.111 18.5556 C 18.111 18.25 17.861 18 17.556 18 V 15.7778 C 17.556 15.4722 17.306 15.2222 17 15.2222 H 16.444 C 16.139 15.2222 15.889 15.4722 15.889 15.7778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Gv(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.465 7.47 C 6.183 7.188 6.183 6.732 6.465 6.453 C 6.747 6.174 7.203 6.171 7.482 6.453 L 12.012 10.983 L 16.542 6.453 C 16.824 6.171 17.28 6.171 17.559 6.453 C 17.838 6.735 17.841 7.191 17.559 7.47 L 13.029 12 L 17.559 16.53 C 17.841 16.812 17.841 17.268 17.559 17.547 C 17.277 17.826 16.821 17.829 16.542 17.547 L 12.012 13.017 L 7.482 17.547 C 7.2 17.829 6.744 17.829 6.465 17.547 C 6.186 17.265 6.183 16.809 6.465 16.53 L 10.995 12 L 6.465 7.47 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
const Ag = {
  alerts: G4,
  "arrow-left-shrink-sidebar": Y4,
  "arrow-left": j4,
  "arrow-right-expand-sidebar": K4,
  "arrow-up-right": q4,
  asset: Z4,
  binoculars: X4,
  "button-load-spinner": Q4,
  calendar: J4,
  "chart-line": ev,
  "check-mark": tv,
  checklist: nv,
  "chevron-down": ov,
  "chevron-left": rv,
  "chevron-right": iv,
  "chevron-up": sv,
  "circle-check": lv,
  "circle-exclamation": av,
  "circle-info": cv,
  "clock-seven": uv,
  customers: dv,
  document: fv,
  "ellipsis-dots-horiz": pv,
  "ellipsis-dots": mv,
  "error-solid": gv,
  error: hv,
  "eye-watching": bv,
  facilities: vv,
  filter: yv,
  hardware: xv,
  home: Cv,
  "image-regular": wv,
  integrations: Sv,
  list: Rv,
  "location-pin-solid": Ev,
  maintenance: Nv,
  "menu-hamburger": kv,
  "monitoring-point": Iv,
  "notification-bell": Pv,
  "oil-analysis-bottle": Mv,
  "plus-regular": Tv,
  priority: Ov,
  search: Dv,
  "settings-cog": _v,
  sort: Vv,
  sparkles: Av,
  "star-recommended": Lv,
  "trend-down": Fv,
  "trend-no-change": $v,
  "trend-up": Hv,
  upload: zv,
  user: Bv,
  warning: Wv,
  workorder: Uv,
  "x-close": Gv
}, Yv = {
  "add-photo": () => import("./add-photo-UE3i3aw7.js"),
  "add-plus": () => import("./add-plus-oFj-MK_p.js"),
  "advanced-readings": () => import("./advanced-readings-DE7-Y7MC.js"),
  "ai-filled": () => import("./ai-filled-1J1gMDKF.js"),
  ai: () => import("./ai-CruGGRMf.js"),
  "alert-exclamation": () => import("./alert-exclamation-C9YLD8Y5.js"),
  "alerts-outline": () => import("./alerts-outline-u0BE6BKG.js"),
  "angles-up-down-solid": () => import("./angles-up-down-solid-abyxkTyM.js"),
  api: () => import("./api-Cq21Vyn5.js"),
  "arrow-drop-down": () => import("./arrow-drop-down-CvUuwgsF.js"),
  "arrow-right-regular": () => import("./arrow-right-regular-ClIL3B0L.js"),
  "arrow-right": () => import("./arrow-right-BB9ZosBM.js"),
  "art-service": () => import("./art-service-D9k-QhdX.js"),
  "assign-link": () => import("./assign-link-Cz8DBNIP.js"),
  "barcode-scan-regular": () => import("./barcode-scan-regular-CRMPw43a.js"),
  "bars-filter-regular": () => import("./bars-filter-regular-rA10KAwS.js"),
  "bookmark-regular": () => import("./bookmark-regular-ErqXaTnq.js"),
  "bookmark-solid": () => import("./bookmark-solid-XxMmOSH8.js"),
  "calendar-solid": () => import("./calendar-solid-BKuAZoMG.js"),
  "camera-regular": () => import("./camera-regular-DCn5NMis.js"),
  "check-circle": () => import("./check-circle-pcTXVe3m.js"),
  "circle-check-regular": () => import("./circle-check-regular-D1RKE1A3.js"),
  "circle-minus-solid": () => import("./circle-minus-solid-DKh4s7Vy.js"),
  "circle-navigation": () => import("./circle-navigation-BggCTKte.js"),
  "circle-play-solid": () => import("./circle-play-solid-5RxV5EWv.js"),
  "circle-plus-regular": () => import("./circle-plus-regular-zl6C5_zW.js"),
  "circle-question": () => import("./circle-question-BInzI22Q.js"),
  "circle-stop-regular": () => import("./circle-stop-regular-C_JIeCcl.js"),
  "circle-xmark-solid": () => import("./circle-xmark-solid--KBWCnKI.js"),
  "cloud-slash-regular": () => import("./cloud-slash-regular-DoTIr8Oz.js"),
  collect: () => import("./collect-Co2HYlGr.js"),
  "collection-taken": () => import("./collection-taken-eCVooTdW.js"),
  "command-search": () => import("./command-search-C2xsNRgD.js"),
  component: () => import("./component-BbcQUwAb.js"),
  "configure-slider": () => import("./configure-slider-bFpbIHj4.js"),
  "copy-regular": () => import("./copy-regular-BuvekPFc.js"),
  "cost-savings-dollar": () => import("./cost-savings-dollar-WugkrpTl.js"),
  "developing-stage": () => import("./developing-stage-CBpNw3F8.js"),
  "document-upload": () => import("./document-upload-BGJdqBn4.js"),
  "dollar-sign": () => import("./dollar-sign-DrSDp3MT.js"),
  dot: () => import("./dot-Bsti8OLe.js"),
  download: () => import("./download-CnMNSBLT.js"),
  drag: () => import("./drag-BZplXPTC.js"),
  "early-stage": () => import("./early-stage-DN8bJpyi.js"),
  "edit-pen": () => import("./edit-pen-CxBiIwxm.js"),
  "email-envelope": () => import("./email-envelope-DiLoHzY9.js"),
  "expand-regular": () => import("./expand-regular-C05q6RBY.js"),
  expand: () => import("./expand-Ar2qxbi8.js"),
  "eye-slash-regular": () => import("./eye-slash-regular-BL-pt4ts.js"),
  "flash-auto": () => import("./flash-auto-COJnXXcG.js"),
  "flash-off": () => import("./flash-off-DxAJx4CC.js"),
  "flash-on": () => import("./flash-on-D41TNyqb.js"),
  "gauge-max-solid-full": () => import("./gauge-max-solid-full-DVsU73t4.js"),
  grid: () => import("./grid-BnvfXTkX.js"),
  "grip-drag": () => import("./grip-drag-T3n9XLV-.js"),
  hazardous: () => import("./hazardous-DMmCTvnj.js"),
  "hwe-sensor-triangle": () => import("./hwe-sensor-triangle-DoamELQq.js"),
  "invoke-reading-bolt-regular": () => import("./invoke-reading-bolt-regular-Cp5QGlzd.js"),
  "invoke-reading-bolt-solid": () => import("./invoke-reading-bolt-solid-B9yq2sii.js"),
  line: () => import("./line-bZnGeTu-.js"),
  "logout-exit": () => import("./logout-exit-CJdNt9zY.js"),
  marketplace: () => import("./marketplace-DjGN6iKj.js"),
  "mature-stage": () => import("./mature-stage-Dvx2oWNp.js"),
  message: () => import("./message-CnKMpyxz.js"),
  "microphone-solid": () => import("./microphone-solid-BN1BAqyC.js"),
  minus: () => import("./minus-Ck_rUujj.js"),
  "new-message": () => import("./new-message-COl6FN29.js"),
  "new-nxt-step": () => import("./new-nxt-step-DdKIQhHf.js"),
  "note-regular": () => import("./note-regular-DtG3iBud.js"),
  "paper-plane-top": () => import("./paper-plane-top-UvtbOAeS.js"),
  partners: () => import("./partners-qveXf0qH.js"),
  phone: () => import("./phone-bdISCoGZ.js"),
  "qr-code-scan": () => import("./qr-code-scan-0YI-iWcO.js"),
  "quarterly-collection": () => import("./quarterly-collection-CxUmYmn_.js"),
  "report-error-square-regular": () => import("./report-error-square-regular-BVmNOQPD.js"),
  rotate: () => import("./rotate-BZY99ywR.js"),
  save: () => import("./save-BMS6Tjxq.js"),
  send: () => import("./send-iYh4V9VL.js"),
  service: () => import("./service-D19lNwJd.js"),
  "settings-cog-solid": () => import("./settings-cog-solid-DzBAvMJm.js"),
  share: () => import("./share-DR74k9ao.js"),
  "signal-connection": () => import("./signal-connection-D2TXKNXS.js"),
  signal: () => import("./signal-ClsGNY50.js"),
  "sort-lines": () => import("./sort-lines-BqsmDERv.js"),
  "stacked-images-regular": () => import("./stacked-images-regular-C7r2AhI2.js"),
  sync: () => import("./sync-DCq2I0rc.js"),
  tag: () => import("./tag-C-1U0rZc.js"),
  "temperature-high-regular-full": () => import("./temperature-high-regular-full-CGdfPnlm.js"),
  "thumbs-down": () => import("./thumbs-down-CFpQbdTQ.js"),
  "thumbs-up": () => import("./thumbs-up-BA7gZye6.js"),
  "trash-delete-bin": () => import("./trash-delete-bin-BRaP7obb.js"),
  "triangle-exclamation-solid": () => import("./triangle-exclamation-solid-BlUal_cM.js"),
  ultrasound: () => import("./ultrasound-CVhj4j7D.js"),
  "up-down": () => import("./up-down-BgbgwQHo.js"),
  vero: () => import("./vero-BgxkNmbD.js"),
  vibration: () => import("./vibration-B66xjocq.js"),
  watching: () => import("./watching-C6VbFi_c.js"),
  "wifi-exclamation-sharp-solid": () => import("./wifi-exclamation-sharp-solid-B2lRByzu.js"),
  wifi: () => import("./wifi-8GgIkdeE.js"),
  "zoom-in": () => import("./zoom-in-B26X0B3W.js"),
  "zoom-out": () => import("./zoom-out-5iqiIT_e.js")
}, jv = {
  neutral: "text-icon-main",
  secondary: "text-icon-secondary",
  brand: "text-primary",
  warning: "text-accessibility-warning",
  negative: "text-negative",
  positive: "text-positive",
  informative: "text-informative",
  inherit: "text-current"
}, Al = /* @__PURE__ */ new Map(), Gs = /* @__PURE__ */ new Map();
function ec(t) {
  return t in Ag;
}
function Kv(t) {
  const e = Al.get(t);
  if (e)
    return Promise.resolve(e);
  const n = Gs.get(t);
  if (n)
    return n;
  const o = Yv[t], r = o().then((i) => (Al.set(t, i.default), Gs.delete(t), i.default)).catch((i) => {
    throw Gs.delete(t), i;
  });
  return Gs.set(t, r), r;
}
function Ue(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    name: r,
    size: l,
    tone: a,
    style: s,
    "aria-label": o,
    "aria-hidden": n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "md" : l, u = a === void 0 ? "neutral" : a, d = !o, f = Vg[c];
  let p;
  e[8] !== r ? (p = () => {
    if (ec(r))
      return;
    const I = Al.get(r);
    return I ? {
      name: r,
      Component: I
    } : void 0;
  }, e[8] = r, e[9] = p) : p = e[9];
  const [m, h] = qe(p), b = jv[u];
  let v;
  e[10] !== f || e[11] !== s ? (v = {
    width: f,
    height: f,
    flexShrink: 0,
    ...s
  }, e[10] = f, e[11] = s, e[12] = v) : v = e[12];
  const C = n ?? (d ? !0 : void 0), y = d ? void 0 : "img";
  let w;
  e[13] !== o || e[14] !== i || e[15] !== b || e[16] !== v || e[17] !== C || e[18] !== y ? (w = {
    className: b,
    style: v,
    "aria-hidden": C,
    "aria-label": o,
    role: y,
    ...i
  }, e[13] = o, e[14] = i, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19];
  const R = w;
  let S, E;
  if (e[20] !== r ? (E = () => {
    if (ec(r)) {
      h(void 0);
      return;
    }
    let I = !0;
    const M = r, T = Al.get(M);
    if (T) {
      h({
        name: M,
        Component: T
      });
      return;
    }
    return h(void 0), Kv(M).then((k) => {
      I && h({
        name: M,
        Component: k
      });
    }).catch(() => {
      I && h(void 0);
    }), () => {
      I = !1;
    };
  }, S = [r], e[20] = r, e[21] = S, e[22] = E) : (S = e[21], E = e[22]), Nt(E, S), ec(r)) {
    const I = Ag[r];
    let M;
    return e[23] !== I || e[24] !== R ? (M = /* @__PURE__ */ g(I, { ...R }), e[23] = I, e[24] = R, e[25] = M) : M = e[25], M;
  }
  if (m?.name === r) {
    const I = m.Component;
    let M;
    return e[26] !== I || e[27] !== R ? (M = /* @__PURE__ */ g(I, { ...R }), e[26] = I, e[27] = R, e[28] = M) : M = e[28], M;
  }
  let N;
  return e[29] !== R ? (N = /* @__PURE__ */ g("svg", { ...R }), e[29] = R, e[30] = N) : N = e[30], N;
}
const qv = ae(["inline-flex", "items-center", "justify-center", "max-w-full", "gap-(--spacing-4)", "h-(--spacing-24)", "rounded-(--radius-sm)", "overflow-hidden", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(--font-weight-medium)", "whitespace-nowrap"], {
  variants: {
    tone: {
      positive: ["bg-chip-positive-container", "text-chip-positive-label"],
      neutral: ["bg-chip-neutral-container", "text-chip-neutral-label"],
      negative: ["bg-chip-negative-container", "text-chip-negative-label"],
      warning: ["bg-chip-warning-container", "text-chip-warning-label"],
      informative: ["bg-chip-informative-container", "text-chip-informative-label"],
      brand: ["bg-chip-brand-container", "text-chip-brand-label"]
    },
    iconOnly: {
      true: ["px-(--spacing-4)", "py-(--spacing-4)"],
      false: ["px-(--spacing-6)", "py-(--spacing-4)"]
    }
  },
  defaultVariants: {
    tone: "neutral",
    iconOnly: !1
  }
}), Zv = {
  informative: "text-chip-informative-label-icon",
  positive: "text-chip-positive-label-icon",
  warning: "text-chip-warning-label-icon",
  negative: "text-chip-negative-label-icon"
};
function Lg(t) {
  const e = W.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: l,
    icon: o,
    label: r,
    children: n,
    truncate: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !0 : s, c = o !== void 0 && r === void 0;
  let u;
  e[7] !== c || e[8] !== l ? (u = qv({
    tone: l,
    iconOnly: c
  }), e[7] = c, e[8] = l, e[9] = u) : u = e[9];
  let d;
  e[10] !== o || e[11] !== l ? (d = o && /* @__PURE__ */ g("span", { className: ne("inline-flex shrink-0 items-center", Zv[l]), children: /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit" }) }), e[10] = o, e[11] = l, e[12] = d) : d = e[12];
  let f;
  e[13] !== r || e[14] !== a ? (f = r !== void 0 && /* @__PURE__ */ g("span", { className: a ? "min-w-0 flex-1 truncate" : void 0, children: String(r) }), e[13] = r, e[14] = a, e[15] = f) : f = e[15];
  let p;
  return e[16] !== n || e[17] !== i || e[18] !== u || e[19] !== d || e[20] !== f ? (p = /* @__PURE__ */ F("span", { className: u, ...i, children: [
    d,
    f,
    n
  ] }), e[16] = n, e[17] = i, e[18] = u, e[19] = d, e[20] = f, e[21] = p) : p = e[21], p;
}
function Wn(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Lg, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Xv(t) {
  const e = W.c(15);
  let n, o, r, i;
  e[0] !== t ? ({
    label: n,
    onClose: o,
    removeAriaLabel: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = i ?? `Remove ${n}`;
  let l;
  e[5] !== o ? (l = (d) => {
    d.stopPropagation(), o();
  }, e[5] = o, e[6] = l) : l = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }), e[7] = a) : a = e[7];
  let c;
  e[8] !== s || e[9] !== l ? (c = /* @__PURE__ */ g("button", { type: "button", "aria-label": s, className: "inline-flex shrink-0 cursor-pointer items-center text-icon-main rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: l, children: a }), e[8] = s, e[9] = l, e[10] = c) : c = e[10];
  let u;
  return e[11] !== n || e[12] !== r || e[13] !== c ? (u = /* @__PURE__ */ g(Lg, { tone: "neutral", label: n, ...r, children: c }), e[11] = n, e[12] = r, e[13] = c, e[14] = u) : u = e[14], u;
}
const Fg = yo({
  activeId: void 0,
  orientation: "vertical",
  onActiveChange: void 0,
  startScrollLock: void 0,
  scrollRef: void 0
}), z1 = ae([
  // Layout
  "relative",
  "inline-flex",
  "items-center",
  "gap-(--spacing-4)",
  "px-(--spacing-6)",
  "rounded-(--radius-sm)",
  // Typography
  "font-(family-name:--font-family-label)",
  "text-(length:--font-size-label-large)",
  "leading-(--font-line-height-16)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "select-none",
  "outline-none",
  "cursor-pointer",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Default text color
  "text-informative",
  // Hover
  "hover:bg-surface-hover",
  // Pressed
  "active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring"
], {
  variants: {
    orientation: {
      // Vertical: fixed 26px height, no extra vertical padding
      vertical: ["h-[26px]"],
      // Horizontal: fixed 26px height, no extra vertical padding
      horizontal: ["h-[26px]"]
    },
    selected: {
      true: [],
      false: []
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none", "cursor-default"]
    }
  },
  compoundVariants: [{
    orientation: "horizontal",
    selected: !0,
    className: "font-semibold"
  }]
}), Qv = ["flex", "items-center", "gap-(--spacing-16)", "h-[26px]", "w-full"].join(" "), B1 = ae(["shrink-0", "transition-colors", "duration-200", "ease-in-out"], {
  variants: {
    orientation: {
      vertical: ["shrink-0", "w-(--spacing-2)", "h-(--spacing-24)", "rounded-tr-(--radius-sm)", "rounded-br-(--radius-sm)"],
      horizontal: ["absolute", "bottom-0", "left-[14px]", "right-[14px]", "h-(--spacing-2)", "rounded-tl-(--radius-sm)", "rounded-tr-(--radius-sm)"]
    },
    selected: {
      true: "bg-informative",
      false: "bg-surface-container-highest"
    }
  }
});
function Jv(t) {
  const e = W.c(59), {
    targetId: n,
    icon: o,
    chip: r,
    disabled: i,
    children: s
  } = t, l = i === void 0 ? !1 : i, {
    activeId: a,
    orientation: c,
    onActiveChange: u,
    startScrollLock: d,
    scrollRef: f
  } = Cn(Fg), p = a === n, m = !l && p;
  let h;
  e[0] !== l || e[1] !== u || e[2] !== f || e[3] !== d || e[4] !== n ? (h = function(T) {
    if (l) {
      T.preventDefault();
      return;
    }
    if (T.button !== 0 || T.metaKey || T.ctrlKey || T.shiftKey || T.altKey)
      return;
    T.preventDefault();
    const k = document.getElementById(n);
    if (k) {
      const P = window.matchMedia("(prefers-reduced-motion: reduce)").matches, D = P ? "instant" : "smooth", O = f?.current;
      P || d?.(), O ? O.scrollTo({
        top: k.offsetTop - O.offsetTop,
        behavior: D
      }) : k.scrollIntoView({
        behavior: D
      });
    }
    window.history.pushState(null, "", `#${n}`), u?.(n);
  }, e[0] = l, e[1] = u, e[2] = f, e[3] = d, e[4] = n, e[5] = h) : h = e[5];
  const b = h;
  if (c === "vertical") {
    const M = m || l && p;
    let T;
    e[6] !== c || e[7] !== M ? (T = B1({
      orientation: c,
      selected: M
    }), e[6] = c, e[7] = M, e[8] = T) : T = e[8];
    const k = l && p ? "opacity-50" : "";
    let P;
    e[9] !== T || e[10] !== k ? (P = [T, k].filter(Boolean), e[9] = T, e[10] = k, e[11] = P) : P = e[11];
    const D = P.join(" ");
    let O;
    e[12] !== D ? (O = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: D }), e[12] = D, e[13] = O) : O = e[13];
    const V = `#${n}`, _ = m ? "true" : void 0, A = l ? "true" : void 0, L = l ? -1 : void 0;
    let $;
    e[14] !== l || e[15] !== m || e[16] !== c ? ($ = z1({
      selected: m,
      disabled: l,
      orientation: c
    }), e[14] = l, e[15] = m, e[16] = c, e[17] = $) : $ = e[17];
    let B;
    e[18] !== o ? (B = o && /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[18] = o, e[19] = B) : B = e[19];
    let z;
    e[20] !== r ? (z = r && /* @__PURE__ */ g(Wn, { ...r }), e[20] = r, e[21] = z) : z = e[21];
    let H;
    e[22] !== s || e[23] !== b || e[24] !== _ || e[25] !== A || e[26] !== L || e[27] !== $ || e[28] !== B || e[29] !== z || e[30] !== V ? (H = /* @__PURE__ */ F("a", { href: V, onClick: b, "aria-current": _, "aria-disabled": A, tabIndex: L, className: $, children: [
      B,
      s,
      z
    ] }), e[22] = s, e[23] = b, e[24] = _, e[25] = A, e[26] = L, e[27] = $, e[28] = B, e[29] = z, e[30] = V, e[31] = H) : H = e[31];
    let K;
    return e[32] !== H || e[33] !== O ? (K = /* @__PURE__ */ F("div", { className: Qv, children: [
      O,
      H
    ] }), e[32] = H, e[33] = O, e[34] = K) : K = e[34], K;
  }
  const v = `#${n}`, C = m ? "true" : void 0, y = l ? "true" : void 0, w = l ? -1 : void 0;
  let R;
  e[35] !== l || e[36] !== m || e[37] !== c ? (R = z1({
    selected: m,
    disabled: l,
    orientation: c
  }), e[35] = l, e[36] = m, e[37] = c, e[38] = R) : R = e[38];
  let S;
  e[39] !== o ? (S = o && /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[39] = o, e[40] = S) : S = e[40];
  let E;
  e[41] !== r ? (E = r && /* @__PURE__ */ g(Wn, { ...r }), e[41] = r, e[42] = E) : E = e[42];
  let N;
  e[43] !== l || e[44] !== p || e[45] !== m || e[46] !== c ? (N = (m || l && p) && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: [B1({
    orientation: c,
    selected: !0
  }), l && p ? "opacity-50" : ""].filter(Boolean).join(" ") }), e[43] = l, e[44] = p, e[45] = m, e[46] = c, e[47] = N) : N = e[47];
  let I;
  return e[48] !== s || e[49] !== b || e[50] !== N || e[51] !== v || e[52] !== C || e[53] !== y || e[54] !== w || e[55] !== R || e[56] !== S || e[57] !== E ? (I = /* @__PURE__ */ F("a", { href: v, onClick: b, "aria-current": C, "aria-disabled": y, tabIndex: w, className: R, children: [
    S,
    s,
    E,
    N
  ] }), e[48] = s, e[49] = b, e[50] = N, e[51] = v, e[52] = C, e[53] = y, e[54] = w, e[55] = R, e[56] = S, e[57] = E, e[58] = I) : I = e[58], I;
}
function e5(t) {
  const e = W.c(12), {
    orientation: n,
    activeId: o,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s,
    children: l
  } = t, a = n === void 0 ? "vertical" : n;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== a || e[3] !== s || e[4] !== i ? (c = {
    activeId: o,
    orientation: a,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s
  }, e[0] = o, e[1] = r, e[2] = a, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const u = a === "vertical" ? "flex flex-col items-start gap-(--spacing-8)" : "flex flex-row flex-wrap gap-(--spacing-8)";
  let d;
  e[6] !== l || e[7] !== u ? (d = /* @__PURE__ */ g("nav", { "aria-label": "On this page", className: u, children: l }), e[6] = l, e[7] = u, e[8] = d) : d = e[8];
  let f;
  return e[9] !== c || e[10] !== d ? (f = /* @__PURE__ */ g(Fg, { value: c, children: d }), e[9] = c, e[10] = d, e[11] = f) : f = e[11], f;
}
const t5 = 800;
function n5(t) {
  const e = at(null), n = at(!1), o = at(null), r = at(null), [i, s] = qe(t[0]), l = t.join(","), a = at(() => {
  });
  Nt(() => {
    const d = e.current, f = l ? l.split(",") : [], p = f.flatMap((w) => {
      const R = document.getElementById(w);
      return R ? [R] : [];
    });
    function m() {
      n.current = !1, r.current !== null && (clearTimeout(r.current), r.current = null);
    }
    a.current = m;
    function h() {
      if (n.current || o.current !== null) return;
      const R = (d ? d.getBoundingClientRect().top + d.clientTop : 0) + 1;
      let S = p[0], E = Number.NEGATIVE_INFINITY;
      for (const N of p) {
        const I = N.getBoundingClientRect().top;
        I <= R && I >= E && (S = N, E = I);
      }
      S && s(S.id);
    }
    function b() {
      o.current = null, m();
    }
    function v(w) {
      if (!(w instanceof KeyboardEvent)) return;
      const R = w.target;
      R instanceof HTMLElement && (R.isContentEditable || R.closest("input, textarea, select")) || ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(w.key) && b();
    }
    const C = new IntersectionObserver(h, {
      root: d,
      threshold: 0
    });
    for (const w of p) C.observe(w);
    const y = d ?? document;
    return y.addEventListener("scroll", h, {
      passive: !0
    }), y.addEventListener("scrollend", m), y.addEventListener("wheel", b, {
      passive: !0
    }), y.addEventListener("touchstart", b, {
      passive: !0
    }), y.addEventListener("pointerdown", b), y.addEventListener("keydown", v), window.addEventListener("resize", h), o.current && !f.includes(o.current) && (o.current = null, m()), () => {
      C.disconnect(), y.removeEventListener("scroll", h), y.removeEventListener("scrollend", m), y.removeEventListener("wheel", b), y.removeEventListener("touchstart", b), y.removeEventListener("pointerdown", b), y.removeEventListener("keydown", v), window.removeEventListener("resize", h), r.current !== null && clearTimeout(r.current);
    };
  }, [l]);
  const c = at(() => {
    n.current = !0, r.current !== null && clearTimeout(r.current), r.current = setTimeout(() => a.current(), t5);
  }).current;
  function u(d) {
    o.current = d, s(d);
  }
  return {
    scrollRef: e,
    activeId: i,
    onActiveChange: u,
    startScrollLock: c
  };
}
function o5(t, e) {
  return function(o, ...r) {
    const i = new URL(t);
    return i.searchParams.set("code", o.toString()), r.forEach((s) => i.searchParams.append("args[]", s)), `${e} error #${o}; visit ${i} for the full message.`;
  };
}
const st = o5("https://base-ui.com/production-error", "Base UI"), W1 = {};
function Lt(t, e) {
  const n = x.useRef(W1);
  return n.current === W1 && (n.current = t(e)), n;
}
function Rn(t, e, n, o) {
  const r = Lt($g).current;
  return i5(r, t, e, n, o) && Hg(r, [t, e, n, o]), r.callback;
}
function r5(t) {
  const e = Lt($g).current;
  return s5(e, t) && Hg(e, t), e.callback;
}
function $g() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function i5(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function s5(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function Hg(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const i = e[r];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (o[r] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const i = e[r];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = o[r];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const l5 = parseInt(x.version, 10);
function Vu(t) {
  return l5 >= t;
}
function U1(t) {
  if (!/* @__PURE__ */ x.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (Vu(19) ? n?.ref : e.ref) ?? null;
}
function eu(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
let tu;
process.env.NODE_ENV !== "production" && (tu = /* @__PURE__ */ new Set());
function sa(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    tu.has(e) || (tu.add(e), console.warn(`Base UI: ${e}`));
  }
}
function Ct() {
}
const Hn = Object.freeze([]), Et = Object.freeze({});
function a5(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const i = e[o](r);
      i != null && Object.assign(n, i);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function c5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function u5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
const Au = {};
function cn(t, e, n, o, r) {
  if (!n && !o && !r && !t)
    return Ll(e);
  let i = Ll(t);
  return e && (i = Li(i, e)), n && (i = Li(i, n)), o && (i = Li(i, o)), r && (i = Li(i, r)), i;
}
function d5(t) {
  if (t.length === 0)
    return Au;
  if (t.length === 1)
    return Ll(t[0]);
  let e = Ll(t[0]);
  for (let n = 1; n < t.length; n += 1)
    e = Li(e, t[n]);
  return e;
}
function Ll(t) {
  return Lu(t) ? {
    ...Bg(t, Au)
  } : f5(t);
}
function Li(t, e) {
  return Lu(e) ? Bg(e, t) : p5(t, e);
}
function f5(t) {
  const e = {
    ...t
  };
  for (const n in e) {
    const o = e[n];
    zg(n, o) && (e[n] = Wg(o));
  }
  return e;
}
function p5(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = eu(t.style, o);
        break;
      }
      case "className": {
        t[n] = Ug(t.className, o);
        break;
      }
      default:
        zg(n, o) ? t[n] = m5(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function zg(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function Lu(t) {
  return typeof t == "function";
}
function Bg(t, e) {
  return Lu(t) ? t(e) : t ?? Au;
}
function m5(t, e) {
  return e ? t ? (...n) => {
    const o = n[0];
    if (Gg(o)) {
      const i = o;
      Fl(i);
      const s = e(...n);
      return i.baseUIHandlerPrevented || t?.(...n), s;
    }
    const r = e(...n);
    return t?.(...n), r;
  } : Wg(e) : t;
}
function Wg(t) {
  return t && ((...e) => {
    const n = e[0];
    return Gg(n) && Fl(n), t(...e);
  });
}
function Fl(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function Ug(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function Gg(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function Le(t, e, n = {}) {
  const o = e.render, r = g5(e, n);
  if (n.enabled === !1)
    return null;
  const i = n.state ?? Et;
  return x5(t, o, r, i);
}
function g5(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: i = Et,
    ref: s,
    props: l,
    stateAttributesMapping: a,
    enabled: c = !0
  } = e, u = c ? c5(n, i) : void 0, d = c ? u5(o, i) : void 0, f = c ? a5(i, a) : Et, p = c && l ? h5(l) : void 0, m = c ? eu(f, p) ?? {} : Et;
  return typeof document < "u" && (c ? Array.isArray(s) ? m.ref = r5([m.ref, U1(r), ...s]) : m.ref = Rn(m.ref, U1(r), s) : Rn(null, null)), c ? (u !== void 0 && (m.className = Ug(m.className, u)), d !== void 0 && (m.style = eu(m.style, d)), m) : Et;
}
function h5(t) {
  return Array.isArray(t) ? d5(t) : cn(void 0, t);
}
const b5 = /* @__PURE__ */ Symbol.for("react.lazy"), v5 = /^[A-Z][A-Za-z0-9$]*$/, y5 = /[a-z]/;
function x5(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return process.env.NODE_ENV !== "production" && C5(e), e(n, o);
    const r = cn(n, e.props);
    r.ref = n.ref;
    let i = e;
    if (i?.$$typeof === b5 && (i = x.Children.toArray(e)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ x.isValidElement(i))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ x.cloneElement(i, r);
  }
  if (t && typeof t == "string")
    return w5(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : st(8));
}
function C5(t) {
  const e = t.name;
  e.length !== 0 && v5.test(e) && y5.test(e) && sa(`The \`render\` prop received a function named \`${e}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function w5(t, e) {
  return t === "button" ? /* @__PURE__ */ $1("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ $1("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ x.createElement(t, e);
}
const Fu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fu.displayName = "AvatarRootContext");
function Yg() {
  const t = x.useContext(Fu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : st(13));
  return t;
}
const $u = {
  imageLoadingStatus: () => null
}, nu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, [l, a] = x.useState("idle"), c = {
    imageLoadingStatus: l
  }, u = x.useMemo(() => ({
    imageLoadingStatus: l,
    setImageLoadingStatus: a
  }), [l, a]), d = Le("span", e, {
    state: c,
    ref: n,
    props: s,
    stateAttributesMapping: $u
  });
  return /* @__PURE__ */ g(Fu.Provider, {
    value: u,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (nu.displayName = "AvatarRoot");
const tc = x[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], S5 = (
  // React 17 doesn't have useInsertionEffect.
  tc && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  tc !== x.useLayoutEffect ? tc : (t) => t()
);
function we(t) {
  const e = Lt(R5).current;
  return e.next = t, S5(e.effect), e.trampoline;
}
function R5() {
  const t = {
    next: void 0,
    callback: E5,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function E5() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const N5 = () => {
}, ke = typeof document < "u" ? x.useLayoutEffect : N5, k5 = [];
function oi(t) {
  x.useEffect(t, k5);
}
const Ys = null;
let G1 = globalThis.requestAnimationFrame;
class I5 {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (e) => {
    this.isScheduled = !1;
    const n = this.callbacks, o = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
      for (let r = 0; r < n.length; r += 1)
        n[r]?.(e);
  };
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV !== "production" && G1 !== requestAnimationFrame && (G1 = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const js = new I5();
class Wt {
  static create() {
    return new Wt();
  }
  static request(e) {
    return js.request(e);
  }
  static cancel(e) {
    return js.cancel(e);
  }
  currentId = Ys;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = js.request(() => {
      this.currentId = Ys, e();
    });
  }
  cancel = () => {
    this.currentId !== Ys && (js.cancel(this.currentId), this.currentId = Ys);
  };
  disposeEffect = () => this.cancel;
}
function ri() {
  const t = Lt(Wt.create).current;
  return oi(t.disposeEffect), t;
}
function Ro(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
let Jn = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const P5 = {
  [Jn.startingStyle]: ""
}, M5 = {
  [Jn.endingStyle]: ""
}, Kt = {
  transitionStatus(t) {
    return t === "starting" ? P5 : t === "ending" ? M5 : null;
  }
};
function la(t, e = !1, n = !0) {
  const o = ri();
  return we((r, i = null) => {
    o.cancel();
    const s = Ro(t);
    if (s == null)
      return;
    const l = s, a = () => {
      yn.flushSync(r);
    };
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function c() {
      Promise.all(l.getAnimations().map((u) => u.finished)).then(() => {
        i?.aborted || a();
      }).catch(() => {
        if (n) {
          i?.aborted || a();
          return;
        }
        const u = l.getAnimations();
        !i?.aborted && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && c();
      });
    }
    if (e) {
      const u = Jn.startingStyle;
      if (!l.hasAttribute(u)) {
        o.request(c);
        return;
      }
      const d = new MutationObserver(() => {
        l.hasAttribute(u) || (d.disconnect(), c());
      });
      d.observe(l, {
        attributes: !0,
        attributeFilter: [u]
      }), i?.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    o.request(c);
  });
}
function Jt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, i = we(r), s = la(o, n, !1);
  x.useEffect(() => {
    if (!e)
      return;
    const l = new AbortController();
    return s(i, l.signal), () => {
      l.abort();
    };
  }, [e, n, i, s]);
}
function to(t, e = !1, n = !1) {
  const [o, r] = x.useState(t && e ? "idle" : void 0), [i, s] = x.useState(t);
  return t && !i && (s(!0), r("starting")), !t && i && o !== "ending" && !n && r("ending"), !t && !i && o === "ending" && r(void 0), ke(() => {
    if (!t && i && o !== "ending" && n) {
      const l = Wt.request(() => {
        r("ending");
      });
      return () => {
        Wt.cancel(l);
      };
    }
  }, [t, i, o, n]), ke(() => {
    if (!t || e)
      return;
    const l = Wt.request(() => {
      r(void 0);
    });
    return () => {
      Wt.cancel(l);
    };
  }, [e, t]), ke(() => {
    if (!t || !e)
      return;
    t && i && o !== "idle" && r("starting");
    const l = Wt.request(() => {
      r("idle");
    });
    return () => {
      Wt.cancel(l);
    };
  }, [e, t, i, o]), {
    mounted: i,
    setMounted: s,
    transitionStatus: o
  };
}
function T5(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = x.useState("idle");
  return ke(() => {
    if (!t)
      return r("error"), Ct;
    let i = !0;
    const s = new window.Image(), l = (a) => () => {
      i && r(a);
    };
    return r("loading"), s.onload = l("loaded"), s.onerror = l("error"), e && (s.referrerPolicy = e), s.crossOrigin = n ?? null, s.src = t, s.complete && r(s.naturalWidth > 0 ? "loaded" : "error"), () => {
      i = !1;
    };
  }, [t, n, e]), o;
}
const O5 = {
  ...$u,
  ...Kt
}, jg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: i,
    referrerPolicy: s,
    crossOrigin: l,
    style: a,
    ...c
  } = e, u = Yg(), d = T5(e.src, {
    referrerPolicy: s,
    crossOrigin: l
  }), f = d === "loaded", {
    mounted: p,
    transitionStatus: m,
    setMounted: h
  } = to(f), b = x.useRef(null), v = we((w) => {
    i?.(w), u.setImageLoadingStatus(w);
  });
  ke(() => {
    d !== "idle" && v(d);
  }, [d, v]);
  const C = {
    imageLoadingStatus: d,
    transitionStatus: m
  };
  Jt({
    open: f,
    ref: b,
    onComplete() {
      f || h(!1);
    }
  });
  const y = Le("img", e, {
    state: C,
    ref: [n, b],
    props: c,
    stateAttributesMapping: O5,
    enabled: p
  });
  return p ? y : null;
});
process.env.NODE_ENV !== "production" && (jg.displayName = "AvatarImage");
const Ii = 0;
class Pn {
  static create() {
    return new Pn();
  }
  currentId = Ii;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Ii, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== Ii;
  }
  clear = () => {
    this.currentId !== Ii && (clearTimeout(this.currentId), this.currentId = Ii);
  };
  disposeEffect = () => this.clear;
}
function Bt() {
  const t = Lt(Pn.create).current;
  return oi(t.disposeEffect), t;
}
const Kg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: i,
    style: s,
    ...l
  } = e, {
    imageLoadingStatus: a
  } = Yg(), [c, u] = x.useState(i === void 0), d = Bt();
  return x.useEffect(() => (i !== void 0 && d.start(i, () => u(!0)), d.clear), [d, i]), Le("span", e, {
    state: {
      imageLoadingStatus: a
    },
    ref: n,
    props: l,
    stateAttributesMapping: $u,
    enabled: a !== "loaded" && c
  });
});
process.env.NODE_ENV !== "production" && (Kg.displayName = "AvatarFallback");
const Y1 = ae(["inline-flex", "shrink-0", "items-center", "justify-center", "overflow-hidden", "rounded-full", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "select-none"], {
  variants: {
    size: {
      md: ["size-(--spacing-40)", "text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"],
      xs: ["size-(--spacing-20)", "text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)"]
    },
    variant: {
      internal: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      external: ["bg-surface-container-highest", "text-surface-on-surface"],
      ai: ["bg-ai-avatar-background"]
    }
  }
});
function Xr(t) {
  const e = W.c(44);
  let n, o, r, i;
  e[0] !== t ? ({
    size: r,
    variant: i,
    "aria-label": n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "md" : r;
  if (i === "ai") {
    const S = s === "xs", E = S ? void 0 : "img", N = S ? void 0 : n ?? "AI", I = S || void 0;
    let M;
    e[5] !== s || e[6] !== i ? (M = Y1({
      size: s,
      variant: i
    }), e[5] = s, e[6] = i, e[7] = M) : M = e[7];
    const T = s === "xs" ? "xs" : "sm", k = s === "xs" ? "size-[12px]" : void 0;
    let P;
    e[8] !== T || e[9] !== k ? (P = /* @__PURE__ */ g(_u, { size: T, className: k }), e[8] = T, e[9] = k, e[10] = P) : P = e[10];
    let D;
    return e[11] !== o || e[12] !== E || e[13] !== N || e[14] !== I || e[15] !== M || e[16] !== P ? (D = /* @__PURE__ */ g(nu, { ...o, "data-slot": "avatar", "data-variant": "ai", role: E, "aria-label": N, "aria-hidden": I, className: M, children: P }), e[11] = o, e[12] = E, e[13] = N, e[14] = I, e[15] = M, e[16] = P, e[17] = D) : D = e[17], D;
  }
  const l = o;
  let a, c, u;
  e[18] !== l ? ({
    initials: a,
    src: u,
    ...c
  } = l, e[18] = l, e[19] = a, e[20] = c, e[21] = u) : (a = e[19], c = e[20], u = e[21]);
  const d = s === "xs", f = !u && !d ? n : void 0, p = u && !d ? n : void 0, m = f ? "img" : void 0, h = d || void 0;
  let b;
  e[22] !== s || e[23] !== i ? (b = Y1({
    size: s,
    variant: i
  }), e[22] = s, e[23] = i, e[24] = b) : b = e[24];
  let v;
  e[25] !== n || e[26] !== d || e[27] !== u ? (v = u ? /* @__PURE__ */ g(jg, { "data-slot": "avatar-image", src: u, alt: d ? "" : n ?? "", className: "h-full w-full object-cover" }) : null, e[25] = n, e[26] = d, e[27] = u, e[28] = v) : v = e[28];
  const C = p ? "img" : void 0;
  let y;
  e[29] !== a ? (y = /* @__PURE__ */ g("span", { "aria-hidden": "true", children: a }), e[29] = a, e[30] = y) : y = e[30];
  let w;
  e[31] !== p || e[32] !== C || e[33] !== y ? (w = /* @__PURE__ */ g(Kg, { "data-slot": "avatar-fallback", role: C, "aria-label": p, children: y }), e[31] = p, e[32] = C, e[33] = y, e[34] = w) : w = e[34];
  let R;
  return e[35] !== f || e[36] !== c || e[37] !== m || e[38] !== h || e[39] !== b || e[40] !== v || e[41] !== w || e[42] !== i ? (R = /* @__PURE__ */ F(nu, { ...c, "data-slot": "avatar", "data-variant": i, role: m, "aria-label": f, "aria-hidden": h, className: b, children: [
    v,
    w
  ] }), e[35] = f, e[36] = c, e[37] = m, e[38] = h, e[39] = b, e[40] = v, e[41] = w, e[42] = i, e[43] = R) : R = e[43], R;
}
function aa() {
  return typeof window < "u";
}
function xn(t) {
  return Hu(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function St(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function xo(t) {
  var e;
  return (e = (Hu(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Hu(t) {
  return aa() ? t instanceof Node || t instanceof St(t).Node : !1;
}
function mt(t) {
  return aa() ? t instanceof Element || t instanceof St(t).Element : !1;
}
function wt(t) {
  return aa() ? t instanceof HTMLElement || t instanceof St(t).HTMLElement : !1;
}
function Qr(t) {
  return !aa() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof St(t).ShadowRoot;
}
function tr(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = En(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function D5(t) {
  return /^(table|td|th)$/.test(xn(t));
}
function ca(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const _5 = /transform|translate|scale|rotate|perspective|filter/, V5 = /paint|layout|strict|content/, lr = (t) => !!t && t !== "none";
let nc;
function zu(t) {
  const e = mt(t) ? En(t) : t;
  return lr(e.transform) || lr(e.translate) || lr(e.scale) || lr(e.rotate) || lr(e.perspective) || !ua() && (lr(e.backdropFilter) || lr(e.filter)) || _5.test(e.willChange || "") || V5.test(e.contain || "");
}
function A5(t) {
  let e = ho(t);
  for (; wt(e) && !uo(e); ) {
    if (zu(e))
      return e;
    if (ca(e))
      return null;
    e = ho(e);
  }
  return null;
}
function ua() {
  return nc == null && (nc = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), nc;
}
function uo(t) {
  return /^(html|body|#document)$/.test(xn(t));
}
function En(t) {
  return St(t).getComputedStyle(t);
}
function da(t) {
  return mt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ho(t) {
  if (xn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Qr(t) && t.host || // Fallback.
    xo(t)
  );
  return Qr(e) ? e.host : e;
}
function qg(t) {
  const e = ho(t);
  return uo(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : wt(e) && tr(e) ? e : qg(e);
}
function Ki(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = qg(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = St(r);
  if (i) {
    const l = ou(s);
    return e.concat(s, s.visualViewport || [], tr(r) ? r : [], l && n ? Ki(l) : []);
  } else
    return e.concat(r, Ki(r, [], n));
}
function ou(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
let ru;
process.env.NODE_ENV !== "production" && (ru = /* @__PURE__ */ new Set());
function Zo(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    ru.has(e) || (ru.add(e), console.error(`Base UI: ${e}`));
  }
}
const br = {
  ...x
}, Bu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bu.displayName = "CompositeRootContext");
function Wu(t = !1) {
  const e = x.useContext(Bu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : st(16));
  return e;
}
function L5(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: i
  } = t, s = o && e !== !1, l = o && e === !1;
  return {
    props: x.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !i && n && (c.tabIndex = e ? r : -1)), (i && (e || s) || !i && n) && (c["aria-disabled"] = n), i && (!e || l) && (c.disabled = n), c;
    }, [o, n, e, s, l, i, r])
  };
}
function qt(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0,
    composite: i
  } = t, s = x.useRef(null), l = Wu(!0), a = i ?? l !== void 0, {
    props: c
  } = L5({
    focusableWhenDisabled: n,
    disabled: e,
    composite: a,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!s.current)
      return;
    const p = Ks(s.current);
    if (r) {
      if (!p) {
        const m = br.captureOwnerStack?.() || "";
        Zo(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${m}`);
      }
    } else if (p) {
      const m = br.captureOwnerStack?.() || "";
      Zo(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${m}`);
    }
  }, [r]);
  const u = x.useCallback(() => {
    const p = s.current;
    Ks(p) && a && e && c.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, c.disabled, a]);
  ke(u, [u]);
  const d = x.useCallback((p = {}) => {
    const {
      onClick: m,
      onMouseDown: h,
      onKeyUp: b,
      onKeyDown: v,
      onPointerDown: C,
      ...y
    } = p;
    return cn({
      type: r ? "button" : void 0,
      onClick(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        m?.(R);
      },
      onMouseDown(R) {
        e || h?.(R);
      },
      onKeyDown(R) {
        if (e || (Fl(R), v?.(R), R.baseUIHandlerPrevented))
          return;
        const S = R.target === R.currentTarget, E = R.currentTarget, N = Ks(E), I = !r && F5(E), M = S && (r ? N : !I), T = R.key === "Enter", k = R.key === " ", P = E.getAttribute("role"), D = P?.startsWith("menuitem") || P === "option" || P === "gridcell";
        if (S && a && k) {
          if (R.defaultPrevented && D)
            return;
          R.preventDefault(), I || r && N ? (E.click(), R.preventBaseUIHandler()) : M && (m?.(R), R.preventBaseUIHandler());
          return;
        }
        M && (!r && (k || T) && R.preventDefault(), !r && T && m?.(R));
      },
      onKeyUp(R) {
        if (!e) {
          if (Fl(R), b?.(R), R.target === R.currentTarget && r && a && Ks(R.currentTarget) && R.key === " ") {
            R.preventDefault();
            return;
          }
          R.baseUIHandlerPrevented || R.target === R.currentTarget && !r && !a && R.key === " " && m?.(R);
        }
      },
      onPointerDown(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        C?.(R);
      }
    }, r ? void 0 : {
      role: "button"
    }, c, y);
  }, [e, c, a, r]), f = we((p) => {
    s.current = p, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function Ks(t) {
  return wt(t) && t.tagName === "BUTTON";
}
function F5(t) {
  return !!(t?.tagName === "A" && t?.href);
}
const no = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    focusableWhenDisabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    getButtonProps: u,
    buttonRef: d
  } = qt({
    disabled: i,
    focusableWhenDisabled: s,
    native: l
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, d],
    props: [c, u]
  });
});
process.env.NODE_ENV !== "production" && (no.displayName = "Button");
function Uu(t) {
  const e = W.c(2), {
    size: n
  } = t, o = n === void 0 ? "sm" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "aw-spinner inline-flex", "aria-hidden": "true", children: /* @__PURE__ */ g(Ue, { name: "button-load-spinner", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
const $5 = ae(["inline-flex", "items-center", "justify-center", "whitespace-nowrap", "shrink-0", "rounded-(--radius-sm)", "px-(--spacing-12)", "border", "border-solid", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-[background,color,box-shadow]", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "conversation-ui": ["bg-button-primary-conversation-ui-background", "text-button-primary-conversation-ui-text", "border-button-primary-conversation-ui-background", "hover:bg-button-primary-conversation-ui-background", "hover:border-button-primary-conversation-ui-background", "active:bg-button-primary-conversation-ui-background", "active:border-button-primary-conversation-ui-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-outline": ["aw-ai-button--outline", "bg-surface", "border-transparent", "text-text-default", "hover:bg-button-outline-hover-background", "active:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-ghost": ["border-transparent", "bg-transparent", "text-text-default", "hover:bg-surface-hover", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["h-(--spacing-32)", "gap-(--spacing-8)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"],
      md: ["h-(--spacing-40)", "gap-(--spacing-8)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"],
      lg: ["h-[44px]", "gap-(--spacing-8)", "px-(--spacing-16)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "sm",
    class: ["text-(length:--font-size-body-large)", "leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "md",
    class: ["leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "lg",
    class: ["px-(--spacing-12)", "leading-(--font-line-height-20)"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function H5() {
  const t = W.c(44), e = $t();
  let n;
  if (t[0] !== e) {
    let B;
    t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = /:/g, t[2] = B) : B = t[2], n = e.replace(B, ""), t[0] = e, t[1] = n;
  } else
    n = t[1];
  const o = n, r = `ai-button-gradient-${o}`, i = `ai-button-shimmer-${o}`, s = `ai-button-glow-${o}`;
  let l, a, c;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), a = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), c = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), t[3] = l, t[4] = a, t[5] = c) : (l = t[3], a = t[4], c = t[5]);
  let u;
  t[6] !== r ? (u = /* @__PURE__ */ F("linearGradient", { id: r, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    l,
    a,
    c
  ] }), t[6] = r, t[7] = u) : u = t[7];
  let d, f, p, m, h, b;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("stop", { offset: "0%", stopColor: "hsl(var(--primary-primary))", stopOpacity: "0" }), m = /* @__PURE__ */ g("stop", { offset: "30%", stopColor: "hsl(var(--primary-primary-container))", stopOpacity: "0" }), h = /* @__PURE__ */ g("stop", { offset: "46%", stopColor: "hsl(var(--gradients-ai-gradient-01))", stopOpacity: "0.9" }), b = /* @__PURE__ */ g("stop", { offset: "70%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), d = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), f = /* @__PURE__ */ g("animateTransform", { attributeName: "gradientTransform", type: "rotate", from: "-12 .5 .5", to: "348 .5 .5", dur: "3.25s", repeatCount: "indefinite" }), t[8] = d, t[9] = f, t[10] = p, t[11] = m, t[12] = h, t[13] = b) : (d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], b = t[13]);
  let v;
  t[14] !== i ? (v = /* @__PURE__ */ F("linearGradient", { id: i, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    p,
    m,
    h,
    b,
    d,
    f
  ] }), t[14] = i, t[15] = v) : v = t[15];
  let C, y, w, R;
  t[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "0.8", result: "haloBlur" }), y = /* @__PURE__ */ g("feFlood", { floodColor: "hsl(var(--gradients-ai-gradient-01))", floodOpacity: "0.4", result: "haloColor" }), w = /* @__PURE__ */ g("feComposite", { in: "haloColor", in2: "haloBlur", operator: "in", result: "halo" }), R = /* @__PURE__ */ g("feMerge", { children: /* @__PURE__ */ g("feMergeNode", { in: "halo" }) }), t[16] = C, t[17] = y, t[18] = w, t[19] = R) : (C = t[16], y = t[17], w = t[18], R = t[19]);
  let S;
  t[20] !== s ? (S = /* @__PURE__ */ F("filter", { id: s, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", filterUnits: "userSpaceOnUse", children: [
    C,
    y,
    w,
    R
  ] }), t[20] = s, t[21] = S) : S = t[21];
  const E = `${s}-outside`;
  let N, I;
  t[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g("rect", { x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", fill: "white" }), I = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "black" }), t[22] = N, t[23] = I) : (N = t[22], I = t[23]);
  let M;
  t[24] !== E ? (M = /* @__PURE__ */ F("mask", { id: E, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", maskUnits: "userSpaceOnUse", children: [
    N,
    I
  ] }), t[24] = E, t[25] = M) : M = t[25];
  let T;
  t[26] !== v || t[27] !== S || t[28] !== M || t[29] !== u ? (T = /* @__PURE__ */ F("defs", { children: [
    u,
    v,
    S,
    M
  ] }), t[26] = v, t[27] = S, t[28] = M, t[29] = u, t[30] = T) : T = t[30];
  const k = `url(#${s}-outside)`, P = `url(#${s})`;
  let D;
  t[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: "hsl(var(--gradients-ai-gradient-01))", strokeWidth: "4" }), t[31] = D) : D = t[31];
  let O;
  t[32] !== k || t[33] !== P ? (O = /* @__PURE__ */ g("g", { mask: k, filter: P, children: D }), t[32] = k, t[33] = P, t[34] = O) : O = t[34];
  const V = `url(#${r})`;
  let _;
  t[35] !== V ? (_ = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: V, strokeWidth: "1" }), t[35] = V, t[36] = _) : _ = t[36];
  const A = `url(#${i})`;
  let L;
  t[37] !== A ? (L = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border aw-ai-button__highlight", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: A, strokeWidth: "1.5" }), t[37] = A, t[38] = L) : L = t[38];
  let $;
  return t[39] !== T || t[40] !== O || t[41] !== _ || t[42] !== L ? ($ = /* @__PURE__ */ F("svg", { className: "pointer-events-none absolute inset-0 z-0 size-full overflow-visible", "aria-hidden": "true", focusable: "false", children: [
    T,
    O,
    _,
    L
  ] }), t[39] = T, t[40] = O, t[41] = _, t[42] = L, t[43] = $) : $ = t[43], $;
}
function Gu(t) {
  const e = W.c(42);
  let n, o, r, i, s, l, a, c, u, d;
  e[0] !== t ? ({
    children: n,
    variant: d,
    intent: r,
    size: l,
    icon: o,
    loading: a,
    loadingText: i,
    fullWidth: c,
    disabled: u,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10]);
  const f = a === void 0 ? !1 : a, p = c === void 0 ? !1 : c, m = u === void 0 ? !1 : u, h = m || f, b = d === "ai-outline" || d === "ai-ghost", v = d === "ai-outline", y = f ? `${i ?? (b ? "Thinking" : "Loading")}...` : n;
  let w;
  e[11] !== o || e[12] !== b || e[13] !== f ? (w = f ? /* @__PURE__ */ g(Uu, { size: "sm" }) : b ? /* @__PURE__ */ g("span", { className: "inline-flex size-(--icon-sm) shrink-0 overflow-hidden", "aria-hidden": "true", children: /* @__PURE__ */ g(_u, { className: "block size-(--icon-sm) shrink-0", size: "sm" }) }) : o ? /* @__PURE__ */ g(Ue, { name: o, size: "sm", tone: "inherit" }) : null, e[11] = o, e[12] = b, e[13] = f, e[14] = w) : w = e[14];
  let R;
  e[15] !== y || e[16] !== w ? (R = /* @__PURE__ */ F(_t, { children: [
    y,
    w
  ] }), e[15] = y, e[16] = w, e[17] = R) : R = e[17];
  const S = R;
  let E;
  e[18] !== m || e[19] !== p || e[20] !== r || e[21] !== h || e[22] !== f || e[23] !== l || e[24] !== d ? (E = ne($5({
    variant: d,
    intent: r,
    size: l
  }), p && "w-full", h && "opacity-40 pointer-events-none", m && "cursor-not-allowed", f && !m && "cursor-default"), e[18] = m, e[19] = p, e[20] = r, e[21] = h, e[22] = f, e[23] = l, e[24] = d, e[25] = E) : E = e[25];
  const N = h || void 0, I = f || void 0, M = h ? -1 : void 0;
  let T;
  e[26] !== v ? (T = v ? /* @__PURE__ */ g(H5, {}) : null, e[26] = v, e[27] = T) : T = e[27];
  let k;
  e[28] !== S || e[29] !== b ? (k = b ? /* @__PURE__ */ g("span", { className: "relative z-10 inline-flex items-center gap-(--spacing-8)", children: S }) : S, e[28] = S, e[29] = b, e[30] = k) : k = e[30];
  let P;
  return e[31] !== h || e[32] !== s || e[33] !== l || e[34] !== M || e[35] !== T || e[36] !== k || e[37] !== E || e[38] !== N || e[39] !== I || e[40] !== d ? (P = /* @__PURE__ */ F(no, { "data-slot": "button", "data-variant": d, "data-size": l, className: E, disabled: h, "aria-disabled": N, "aria-busy": I, tabIndex: M, ...s, children: [
    T,
    k
  ] }), e[31] = h, e[32] = s, e[33] = l, e[34] = M, e[35] = T, e[36] = k, e[37] = E, e[38] = N, e[39] = I, e[40] = d, e[41] = P) : P = e[41], P;
}
function pn(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Gu, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function j1(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Gu, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function z5(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Gu, { ...t, variant: "conversation-ui" }), e[0] = t, e[1] = n) : n = e[1], n;
}
const fa = yo({
  align: "start"
}), B5 = ae(["flex", "w-full", "min-w-0", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "justify-start",
      end: "justify-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), W5 = ae(["flex", "min-w-0", "w-full", "max-w-[520px]", "flex-col", "gap-(--spacing-4)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), U5 = ae(["flex", "items-center", "gap-(--spacing-6)", "px-(--spacing-2)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default"]), G5 = ae(["flex", "items-center", "min-w-0", "w-full", "gap-(--spacing-8)"]), Y5 = ae(["flex", "w-full", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), j5 = ae(["max-w-full", "break-words", "whitespace-pre-wrap", "rounded-(--radius-sm)", "p-(--spacing-16)", "shadow-elevation-1", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      inbound: ["w-fit", "bg-surface-container", "text-text-default"],
      outbound: ["w-fit", "bg-surface-container", "text-text-default"],
      system: ["w-full", "bg-surface-container", "text-text-default"],
      informative: ["w-full", "bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "inbound"
  }
}), K5 = ae(["flex", "w-full", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "px-(--spacing-16)", "py-(--spacing-8)", "text-center", "font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      default: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      informative: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      positive: ["border-positive-on-container", "bg-positive-container", "text-positive-on-container"],
      warning: ["border-warning-on-container", "bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["border-negative-on-container", "bg-negative-container", "text-negative-on-container"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function iu(t) {
  const e = W.c(18);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    direction: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = o === "outbound" ? "end" : "start";
  let s;
  e[4] !== o || e[5] !== i ? (s = {
    align: i,
    direction: o
  }, e[4] = o, e[5] = i, e[6] = s) : s = e[6];
  let l;
  e[7] !== i ? (l = ne(B5({
    align: i
  })), e[7] = i, e[8] = l) : l = e[8];
  let a;
  e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== i || e[13] !== l ? (a = /* @__PURE__ */ g("article", { "data-slot": "chat-message", "data-align": i, "data-direction": o, className: l, ...r, children: n }), e[9] = n, e[10] = o, e[11] = r, e[12] = i, e[13] = l, e[14] = a) : a = e[14];
  let c;
  return e[15] !== s || e[16] !== a ? (c = /* @__PURE__ */ g(fa, { value: s, children: a }), e[15] = s, e[16] = a, e[17] = c) : c = e[17], c;
}
function Zg(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g("div", { "data-slot": "chat-message-avatar", className: "shrink-0", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function su(t) {
  const e = W.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = Cn(fa);
  let i;
  e[3] !== r ? (i = ne(W5({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { "data-slot": "chat-message-content", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function Xg(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(U5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-message-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function K1(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(G5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-message-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function q5(t) {
  const e = W.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = Cn(fa);
  let i;
  e[3] !== r ? (i = ne(Y5({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { "data-slot": "chat-message-group", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function lu(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tone: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const {
    direction: i
  } = Cn(fa), s = r ?? i ?? "inbound";
  let l;
  e[4] !== s ? (l = ne(j5({
    tone: s
  })), e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== n || e[7] !== o || e[8] !== s || e[9] !== l ? (a = /* @__PURE__ */ g("div", { "data-slot": "chat-bubble", "data-tone": s, className: l, ...o, children: n }), e[6] = n, e[7] = o, e[8] = s, e[9] = l, e[10] = a) : a = e[10], a;
}
function Z5(t) {
  const e = W.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    live: r,
    tone: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "polite" : r, l = i === void 0 ? "default" : i;
  let a;
  e[5] !== l ? (a = ne(K5({
    tone: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== s || e[9] !== o || e[10] !== a || e[11] !== l ? (c = /* @__PURE__ */ g("output", { "data-slot": "chat-status", "data-tone": l, "aria-live": s, className: a, ...o, children: n }), e[7] = n, e[8] = s, e[9] = o, e[10] = a, e[11] = l, e[12] = c) : c = e[12], c;
}
const X5 = ae(["inline-flex", "items-center", "justify-center", "shrink-0", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["size-(--spacing-32)"],
      md: ["size-(--spacing-40)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function bt(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: n,
    variant: a,
    intent: o,
    size: i,
    loading: s,
    disabled: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? !1 : s, u = l === void 0 ? !1 : l, d = u || c;
  let f;
  e[8] !== u || e[9] !== o || e[10] !== d || e[11] !== c || e[12] !== i || e[13] !== a ? (f = ne(X5({
    variant: a,
    intent: o,
    size: i
  }), d && "opacity-40 pointer-events-none", u && "cursor-not-allowed", c && !u && "cursor-default"), e[8] = u, e[9] = o, e[10] = d, e[11] = c, e[12] = i, e[13] = a, e[14] = f) : f = e[14];
  const p = d || void 0, m = c || void 0, h = d ? -1 : void 0;
  let b;
  e[15] !== n || e[16] !== c ? (b = c ? /* @__PURE__ */ g(Uu, { size: "sm" }) : /* @__PURE__ */ g(Ue, { name: n, size: "sm", tone: "inherit" }), e[15] = n, e[16] = c, e[17] = b) : b = e[17];
  let v;
  return e[18] !== d || e[19] !== r || e[20] !== i || e[21] !== f || e[22] !== p || e[23] !== m || e[24] !== h || e[25] !== b || e[26] !== a ? (v = /* @__PURE__ */ g(no, { "data-slot": "icon-button", "data-variant": a, "data-size": i, className: f, disabled: d, "aria-disabled": p, "aria-busy": m, tabIndex: h, ...r, children: b }), e[18] = d, e[19] = r, e[20] = i, e[21] = f, e[22] = p, e[23] = m, e[24] = h, e[25] = b, e[26] = a, e[27] = v) : v = e[27], v;
}
const Q5 = ae(["aw-chat-scroller", "group", "relative", "flex", "h-full", "min-h-0", "min-w-0", "flex-1", "flex-col"]), J5 = ae(["min-h-0", "min-w-0", "flex-1", "overflow-x-hidden", "overflow-y-auto", "px-(--spacing-12)", "py-(--spacing-12)", "outline-none", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-button-focus-ring"]), e8 = ae(["flex", "flex-col", "min-w-0", "gap-(--spacing-20)"]), t8 = ae(["min-w-0"]), n8 = ae(["absolute", "bottom-(--spacing-16)", "left-1/2", "z-10", "-translate-x-1/2", "hidden", "group-data-[scrollable~='end']:block"]);
function Qg(t) {
  const e = W.c(19);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    children: n,
    autoScroll: l,
    defaultScrollPosition: a,
    scrollEdgeThreshold: r,
    scrollPreviousItemPeek: s,
    scrollMargin: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !0 : l, u = a === void 0 ? "end" : a;
  let d;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(Q5()), e[8] = d) : d = e[8];
  let f;
  e[9] !== n || e[10] !== o ? (f = /* @__PURE__ */ g(Zr.Root, { "data-slot": "chat-scroller", className: d, ...o, children: n }), e[9] = n, e[10] = o, e[11] = f) : f = e[11];
  let p;
  return e[12] !== c || e[13] !== u || e[14] !== r || e[15] !== i || e[16] !== s || e[17] !== f ? (p = /* @__PURE__ */ g(Zr.Provider, { autoScroll: c, defaultScrollPosition: u, scrollEdgeThreshold: r, scrollPreviousItemPeek: s, scrollMargin: i, children: f }), e[12] = c, e[13] = u, e[14] = r, e[15] = i, e[16] = s, e[17] = f, e[18] = p) : p = e[18], p;
}
function Jg(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(J5()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Zr.Viewport, { "data-slot": "chat-scroller-viewport", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function eh(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(e8()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Zr.Content, { "data-slot": "chat-scroller-content", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Wi(t) {
  const e = W.c(9);
  let n, o, r;
  e[0] !== t ? ({
    messageId: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(t8()), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = /* @__PURE__ */ g(Zr.Item, { "data-slot": "chat-scroller-item", messageId: o, className: i, ...r, children: n }), e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], s;
}
function th(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    "aria-label": o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "Jump to latest message" : o;
  let i;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(n8()), e[3] = i) : i = e[3];
  let s;
  e[4] !== r ? (s = /* @__PURE__ */ g(bt, { icon: "chevron-down", "aria-label": r, variant: "outline", size: "sm" }), e[4] = r, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== s ? (l = /* @__PURE__ */ g("div", { "data-slot": "chat-scroller-jump-to-latest", className: i, children: /* @__PURE__ */ g(Zr.Button, { direction: "end", render: s, ...n }) }), e[6] = n, e[7] = s, e[8] = l) : l = e[8], l;
}
const o8 = {
  default: "border-outline-subtle",
  high: "border-outline opacity-60"
}, r8 = {
  horizontal: {
    "full-width": "",
    inset: "pl-(--spacing-16)",
    "middle-inset": "px-(--spacing-16)"
  },
  vertical: {
    "full-width": "",
    inset: "pt-(--spacing-16)",
    "middle-inset": "py-(--spacing-16)"
  }
}, q1 = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap"]);
function vr(t) {
  const e = W.c(52);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    orientation: i,
    variant: s,
    subheader: r,
    centeredText: n,
    emphasis: l,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "horizontal" : i, c = s === void 0 ? "full-width" : s, u = l === void 0 ? "default" : l, d = a === "vertical", f = o8[u], p = d ? "border-l" : "border-t", m = r8[a][c];
  if (!d && n) {
    let w;
    e[7] !== f || e[8] !== p ? (w = ne("grow", p, f), e[7] = f, e[8] = p, e[9] = w) : w = e[9];
    let R;
    e[10] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[10] = w, e[11] = R) : R = e[11];
    let S;
    e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(q1(), "shrink-0", "text-(length:--font-size-body-small)"), e[12] = S) : S = e[12];
    let E;
    e[13] !== n || e[14] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: n }), e[13] = n, e[14] = S, e[15] = E) : E = e[15];
    let N;
    e[16] !== f || e[17] !== p ? (N = ne("grow", p, f), e[16] = f, e[17] = p, e[18] = N) : N = e[18];
    let I;
    e[19] !== N ? (I = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: N }), e[19] = N, e[20] = I) : I = e[20];
    let M;
    return e[21] !== o || e[22] !== R || e[23] !== E || e[24] !== I ? (M = /* @__PURE__ */ F("div", { ...o, className: "flex items-center gap-(--spacing-6)", children: [
      R,
      E,
      I
    ] }), e[21] = o, e[22] = R, e[23] = E, e[24] = I, e[25] = M) : M = e[25], M;
  }
  if (!d && r) {
    let w;
    e[26] !== f || e[27] !== p ? (w = ne("w-full", p, f), e[26] = f, e[27] = p, e[28] = w) : w = e[28];
    let R;
    e[29] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[29] = w, e[30] = R) : R = e[30];
    let S;
    e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(q1(), "shrink-0", "text-(length:--font-size-body-medium)"), e[31] = S) : S = e[31];
    let E;
    e[32] !== r || e[33] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: r }), e[32] = r, e[33] = S, e[34] = E) : E = e[34];
    let N;
    return e[35] !== o || e[36] !== R || e[37] !== E ? (N = /* @__PURE__ */ F("div", { ...o, className: "flex flex-col gap-(--spacing-4) px-(--spacing-16)", children: [
      R,
      E
    ] }), e[35] = o, e[36] = R, e[37] = E, e[38] = N) : N = e[38], N;
  }
  const h = d ? "flex-col" : "flex-row";
  let b;
  e[39] !== m || e[40] !== h ? (b = ne("flex", h, m), e[39] = m, e[40] = h, e[41] = b) : b = e[41];
  let v;
  e[42] !== f || e[43] !== p ? (v = ne("grow", p, f), e[42] = f, e[43] = p, e[44] = v) : v = e[44];
  let C;
  e[45] !== a || e[46] !== v ? (C = /* @__PURE__ */ g("hr", { "aria-orientation": a, className: v }), e[45] = a, e[46] = v, e[47] = C) : C = e[47];
  let y;
  return e[48] !== o || e[49] !== b || e[50] !== C ? (y = /* @__PURE__ */ g("div", { ...o, className: b, children: C }), e[48] = o, e[49] = b, e[50] = C, e[51] = y) : y = e[51], y;
}
function i8(t) {
  const e = W.c(7);
  let n, o, r, i, s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.3918 80.2045L20.2608 86.5396H24.3507L14.0566 64.5386H10.2275L0 86.5396H3.86238L6.73141 80.2045H17.3918ZM16.1043 77.3364H7.98557L12.0089 68.333L16.0988 77.3364H16.1043ZM41.9423 75.356C41.5483 71.5949 39.0733 69.8474 34.2564 69.8474C29.4395 69.8474 26.5982 71.728 26.5982 74.8623C26.5982 76.5764 27.586 78.0299 29.1731 78.6567C30.2608 79.0839 31.0877 79.2836 34.2231 79.7773C36.4872 80.1286 37.8283 80.3931 38.2464 80.5706C38.8735 80.8369 39.2342 81.3971 39.2342 82.0573C39.2342 83.5773 37.5194 84.4316 34.4173 84.4316C31.3152 84.4316 29.434 83.3443 29.2009 81.264H25.8657C26.4928 85.2249 29.101 86.9723 34.3785 86.9723C39.6559 86.9723 42.5305 85.125 42.5305 81.7244C42.5305 80.271 41.97 79.1172 40.9489 78.3627C39.9945 77.6693 39.4007 77.5362 34.9778 76.8427C32.2697 76.4156 31.6759 76.3157 31.0155 76.0494C30.2886 75.7832 29.7947 75.1896 29.7947 74.5627C29.7947 73.2425 31.5094 72.3882 34.0844 72.3882C37.02 72.3882 38.4406 73.309 38.7014 75.356H41.9367H41.9423ZM61.5039 75.356C61.1099 71.5949 58.6349 69.8474 53.8124 69.8474C48.99 69.8474 46.1543 71.728 46.1543 74.8623C46.1543 76.5764 47.1421 78.0299 48.7292 78.6567C49.8169 79.0839 50.6437 79.2836 53.7791 79.7773C56.0433 80.1286 57.3844 80.3931 57.8024 80.5706C58.4295 80.8369 58.7902 81.3971 58.7902 82.0573C58.7902 83.5773 57.0755 84.4316 53.9734 84.4316C50.8713 84.4316 48.99 83.3443 48.7569 81.264H45.4218C46.0488 85.2249 48.6571 86.9723 53.9345 86.9723C59.212 86.9723 62.0866 85.125 62.0866 81.7244C62.0866 80.271 61.5261 79.1172 60.505 78.3627C59.5505 77.6693 58.9567 77.5362 54.5339 76.8427C51.8257 76.4156 51.232 76.3157 50.5716 76.0494C49.8446 75.7832 49.3507 75.1896 49.3507 74.5627C49.3507 73.2425 51.0655 72.3882 53.6404 72.3882C56.576 72.3882 57.9967 73.309 58.2575 75.356H61.4928H61.5039ZM83.1521 79.3502C83.1521 77.3364 82.919 76.0827 82.3585 74.7014C81.1043 71.667 77.9689 69.853 74.0732 69.853C68.6959 69.853 64.9667 73.3811 64.9667 78.4959C64.9667 83.6106 68.596 86.9723 74.0067 86.9723C78.3296 86.9723 81.232 85.1583 82.8524 81.4637H79.3896C78.5627 83.4441 76.8479 84.4316 74.3063 84.4316C70.7769 84.4316 68.4018 82.4844 68.0688 79.3502H83.1465H83.1521ZM68.1687 76.8427C68.929 73.9747 71.0377 72.3549 74.0455 72.3549C77.0533 72.3549 79.162 73.9692 79.8835 76.8427H68.1687ZM90.9822 65.759H87.7802V70.2801H85.6659V72.9207H87.7802V82.3901C87.7802 84.4704 87.9467 85.1916 88.6071 85.8184C89.3008 86.5119 90.5549 86.8724 92.1698 86.8724C92.9634 86.8724 93.5572 86.8059 94.778 86.6394V83.9656C94.0178 84.0987 93.6903 84.132 93.03 84.132C91.3818 84.132 90.9822 83.7714 90.9822 82.2847V72.9152H94.778V70.2746H90.9822V65.7535V65.759ZM123.069 86.5396L130.494 64.5386H127.031L121.226 82.6841L115.022 64.5386H111.193L105.022 82.6841L99.3785 64.5386H95.5494L102.941 86.5396H106.87L113.041 68.2664L119.345 86.5396H123.074H123.069ZM135.305 75.6556C135.538 73.248 136.92 72.3549 140.422 72.3549C143.391 72.3549 144.811 73.1482 144.811 74.8956C144.811 75.7221 144.417 76.2159 143.524 76.5099C142.697 76.7762 142.203 76.8427 139.301 77.1367C135.905 77.4973 135.178 77.6637 133.99 78.1907C132.469 78.8842 131.515 80.3986 131.515 82.1516C131.515 85.1527 133.923 87 137.852 87C140.788 87 142.836 86.2067 144.817 84.3262C145.444 86.1402 146.371 86.767 148.38 86.767C149.073 86.767 149.467 86.7005 150.061 86.5008V84.3262C149.795 84.3595 149.534 84.3928 149.334 84.3928C148.246 84.426 147.847 83.8657 147.847 82.2792V75.0565C147.847 73.076 147.386 71.9555 146.265 71.1955C144.911 70.269 142.963 69.8419 140.294 69.8419C136.926 69.8419 134.551 70.7017 133.23 72.3826C132.569 73.2092 132.275 74.0635 132.109 75.65H135.311L135.305 75.6556ZM144.806 79.744C144.806 81.2917 144.573 81.9186 143.651 82.8117C142.497 83.899 140.877 84.4593 138.735 84.4593C136.127 84.4593 134.806 83.5995 134.806 81.9519C134.806 80.4652 135.699 79.9049 138.568 79.6109C141.143 79.3446 143.024 78.984 144.806 78.4237V79.744ZM156.748 65.759H153.546V70.2801H151.432V72.9207H153.546V82.3901C153.546 84.4704 153.713 85.1916 154.373 85.8184C155.067 86.5119 156.321 86.8724 157.936 86.8724C158.729 86.8724 159.323 86.8059 160.544 86.6394V83.9656C159.784 84.0987 159.456 84.132 158.796 84.132C157.148 84.132 156.748 83.7714 156.748 82.2847V72.9152H160.544V70.2746H156.748V65.7535V65.759ZM176.759 80.6372C175.999 83.1779 174.351 84.4316 171.709 84.4316C168.08 84.4316 165.871 82.1571 165.871 78.3627C165.871 74.5683 168.019 72.3604 171.681 72.3604C174.223 72.3604 175.938 73.481 176.665 75.6278H179.767C178.94 71.9998 175.938 69.853 171.615 69.853C166.104 69.853 162.669 73.1537 162.669 78.4959C162.669 83.838 166.038 86.9723 171.615 86.9723C176.038 86.9723 179.04 84.6979 179.895 80.6372H176.759ZM183.862 86.5396H187.064V77.0702C187.064 74.596 189.639 72.549 192.775 72.549C193.962 72.549 194.95 72.8486 195.677 73.4422C196.537 74.1356 196.798 74.7957 196.798 76.41V86.5396H200V76.1826C200 73.775 199.573 72.5213 198.452 71.5339C197.231 70.4466 195.45 69.853 193.402 69.853C190.76 69.853 189.145 70.5464 187.064 72.5879V64.5386H183.862V86.5396Z" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.5202 30.3223L58.0352 45.2171H69.2338C71.0429 45.2171 72.8243 44.7344 74.3892 43.8247C75.9541 42.9149 77.2527 41.6001 78.1406 40.0247L83.6345 30.3223H66.5091H66.5202Z" }), r = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78.0688 20.1038L89.3841 40.0356C90.2775 41.6111 91.5705 42.9203 93.1354 43.8301C94.7004 44.7398 96.4762 45.2225 98.2908 45.2169H109.501L83.757 0L78.0744 9.97979C77.1976 11.522 76.7314 13.2639 76.7314 15.039C76.7314 16.8142 77.192 18.5561 78.0688 20.0983V20.1038Z" }), i = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M109.5 0L103.818 9.97979C102.941 11.522 102.48 13.2639 102.48 15.039C102.48 16.8142 102.941 18.5561 103.818 20.0983L115.139 40.0301C116.032 41.6056 117.325 42.9092 118.89 43.8245C120.455 44.7343 122.231 45.2169 124.04 45.2169H135.25L109.5 0Z" }), s = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.245 0L129.562 9.97979C128.685 11.522 128.225 13.2694 128.225 15.039C128.225 16.8086 128.685 18.5561 129.562 20.0983L135.245 30.078L143.807 15.0335L135.245 0Z" }), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s) : (n = e[0], o = e[1], r = e[2], i = e[3], s = e[4]);
  let l;
  return e[5] !== t ? (l = /* @__PURE__ */ F("svg", { width: "200", height: "87", viewBox: "0 0 200 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    n,
    o,
    r,
    i,
    s
  ] }), e[5] = t, e[6] = l) : l = e[6], l;
}
const Z1 = {
  default: "fill-surface-inverse-surface",
  primary: "fill-primary"
}, s8 = {
  default: {
    width: 44,
    height: 23.21
  },
  compact: {
    width: 24.16,
    height: 12.74
  },
  display: {
    width: 90,
    height: 47.47
  },
  stacked: {
    width: 200,
    height: 87
  }
};
function l8(t) {
  const e = W.c(29);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    size: s,
    style: i,
    tone: l,
    "aria-label": o,
    "aria-hidden": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "default" : s, c = !o, u = s8[a], d = l ?? "primary";
  if (a === "stacked") {
    const C = Z1[d], y = n ?? (c ? !0 : void 0), w = c ? void 0 : "img";
    let R;
    e[7] !== i ? (R = {
      flexShrink: 0,
      ...i
    }, e[7] = i, e[8] = R) : R = e[8];
    let S;
    return e[9] !== o || e[10] !== r || e[11] !== C || e[12] !== y || e[13] !== w || e[14] !== R ? (S = /* @__PURE__ */ g(i8, { ...r, className: C, "aria-hidden": y, "aria-label": o, role: w, style: R }), e[9] = o, e[10] = r, e[11] = C, e[12] = y, e[13] = w, e[14] = R, e[15] = S) : S = e[15], S;
  }
  const f = n ?? (c ? !0 : void 0), p = c ? void 0 : "img";
  let m;
  e[16] !== i ? (m = {
    flexShrink: 0,
    ...i
  }, e[16] = i, e[17] = m) : m = e[17];
  const h = Z1[d];
  let b;
  e[18] !== h ? (b = /* @__PURE__ */ g("path", { d: "M10.3174 20.54C9.85932 21.349 9.19472 22.0221 8.3916 22.4902C7.58855 22.9583 6.67561 23.2051 5.74609 23.2051H0L4.35254 15.5615H13.1367L10.3174 20.54ZM26.4014 23.2051H20.6514C19.7228 23.2052 18.8103 22.9593 18.0078 22.4922C17.2054 22.0251 16.5415 21.3532 16.083 20.5459L10.2764 10.3164C9.8266 9.52465 9.59036 8.62933 9.59082 7.71875C9.59128 6.80816 9.82872 5.91337 10.2793 5.12207L13.1934 0L26.4014 23.2051ZM39.6104 23.2021H33.8613C32.9331 23.2021 32.021 22.9562 31.2188 22.4893C30.4164 22.0221 29.7514 21.3504 29.293 20.543L23.4863 10.3135C23.0366 9.52227 22.7998 8.62785 22.7998 7.71777C22.7998 6.8077 23.0366 5.91328 23.4863 5.12207L26.4014 0L39.6104 23.2021ZM44 7.71973L39.6084 15.4395L36.6934 10.3174C36.243 9.52576 36.0068 8.63047 36.0068 7.71973C36.0068 6.80898 36.243 5.91369 36.6934 5.12207L39.6084 0L44 7.71973Z", className: h }), e[18] = h, e[19] = b) : b = e[19];
  let v;
  return e[20] !== o || e[21] !== u.height || e[22] !== u.width || e[23] !== r || e[24] !== f || e[25] !== p || e[26] !== m || e[27] !== b ? (v = /* @__PURE__ */ g("svg", { ...r, width: u.width, height: u.height, viewBox: "0 0 44 23.21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": f, "aria-label": o, role: p, style: m, children: b }), e[20] = o, e[21] = u.height, e[22] = u.width, e[23] = r, e[24] = f, e[25] = p, e[26] = m, e[27] = b, e[28] = v) : v = e[28], v;
}
const Yu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yu.displayName = "MenuPositionerContext");
function cs(t) {
  const e = x.useContext(Yu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : st(33));
  return e;
}
const ju = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ju.displayName = "MenuRootContext");
function oo(t) {
  const e = x.useContext(ju);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : st(36));
  return e;
}
let wn = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Jn.startingStyle] = "startingStyle", t[t.endingStyle = Jn.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t.side = "data-side", t.align = "data-align", t;
})({}), $l = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const a8 = {
  [$l.popupOpen]: ""
}, c8 = {
  [$l.popupOpen]: "",
  [$l.pressed]: ""
}, u8 = {
  [wn.open]: ""
}, d8 = {
  [wn.closed]: ""
}, f8 = {
  [wn.anchorHidden]: ""
}, Sr = {
  open(t) {
    return t ? a8 : null;
  }
}, qi = {
  open(t) {
    return t ? c8 : null;
  }
}, An = {
  open(t) {
    return t ? u8 : d8;
  },
  anchorHidden(t) {
    return t ? f8 : null;
  }
}, nh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (nh.displayName = "ContextMenuRootContext");
function pa(t = !0) {
  const e = x.useContext(nh);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : st(25));
  return e;
}
const At = "none", eo = "trigger-press", Ut = "trigger-hover", gr = "trigger-focus", us = "outside-press", Yo = "item-press", oh = "close-press", X1 = "clear-press", p8 = "chip-remove-press", zr = "input-change", Wo = "input-clear", rh = "input-press", _o = "focus-out", Rr = "escape-key", m8 = "close-watcher", Gr = "list-navigation", g8 = "pointer", ih = "cancel-open", Fi = "sibling-open", h8 = "disabled", ds = "imperative-action", qs = "swipe", b8 = "window-resize";
function Sn({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = x.useRef(t !== void 0), [i, s] = x.useState(e), l = r ? t : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      r !== (t !== void 0) && Zo([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = x.useRef(e);
    x.useEffect(() => {
      !r && Q1(c) !== Q1(e) && Zo([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [e]);
  }
  const a = x.useCallback((c) => {
    r || s(c);
  }, []);
  return [l, a];
}
function Q1(t) {
  let e = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(t, function(i, s) {
      if (!(i === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof s == "bigint")
          return `__bigint__:${s}`;
        if (s !== null && typeof s == "object") {
          const l = n.get(s);
          if (l !== void 0)
            return `__object__:${l}`;
          n.set(s, e), e += 1;
        }
        return s;
      }
    }) ?? `__top__:${typeof t}`;
  } catch {
    return "__unserializable__";
  }
}
const sh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (sh.displayName = "MenuCheckboxItemContext");
const Er = typeof navigator < "u", oc = v8(), lh = x8(), Ku = y8(), qu = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), Zu = (
  // iPads can claim to be MacIntel
  oc.platform === "MacIntel" && oc.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(oc.platform)
), J1 = Er && /firefox/i.test(Ku), ah = Er && /apple/i.test(navigator.vendor), Zi = Er && /android/i.test(lh) || /android/i.test(Ku), ch = Er && lh.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, uh = Ku.includes("jsdom/");
function v8() {
  if (!Er)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function y8() {
  if (!Er)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function x8() {
  if (!Er)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
function C8(t) {
  const {
    closeOnClick: e,
    highlighted: n,
    id: o,
    nodeId: r,
    store: i,
    typingRef: s,
    itemRef: l,
    itemMetadata: a
  } = t, {
    events: c
  } = i.useState("floatingTreeRoot"), u = pa(!0), d = u !== void 0;
  return x.useMemo(() => ({
    id: o,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && s?.current && f.preventDefault();
    },
    onMouseMove(f) {
      r && c.emit("itemhover", {
        nodeId: r,
        target: f.currentTarget
      });
    },
    onClick(f) {
      e && c.emit("close", {
        domEvent: f,
        reason: Yo
      });
    },
    onMouseUp(f) {
      if (u) {
        const p = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && p && Math.abs(f.clientX - p.x) <= 1 && Math.abs(f.clientY - p.y) <= 1 || d && !ch && f.button === 2)
          return;
      }
      l.current && i.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!a || a.type === "regular-item") && l.current.click();
    }
  }), [e, n, o, c, r, i, s, l, u, d, a]);
}
const Xu = {
  type: "regular-item"
};
function ma(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: i,
    typingRef: s = i.context.typingRef,
    nativeButton: l,
    itemMetadata: a,
    nodeId: c
  } = t, u = x.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = qt({
    disabled: n,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  }), p = C8({
    closeOnClick: e,
    highlighted: o,
    id: r,
    nodeId: c,
    store: i,
    typingRef: s,
    itemRef: u,
    itemMetadata: a
  }), m = x.useCallback((b) => cn(p, {
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    }
  }, b, d), [p, d, a]), h = Rn(u, f);
  return x.useMemo(() => ({
    getItemProps: m,
    itemRef: h
  }), [m, h]);
}
const Qu = /* @__PURE__ */ x.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Qu.displayName = "CompositeListContext");
function w8() {
  return x.useContext(Qu);
}
let Ju = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Ao(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: i
  } = t, {
    register: s,
    unregister: l,
    subscribeMapChange: a,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = w8(), f = x.useRef(-1), [p, m] = x.useState(i ?? (r === Ju.GuessFromOrder ? () => {
    if (f.current === -1) {
      const v = d.current;
      d.current += 1, f.current = v;
    }
    return f.current;
  } : -1)), h = x.useRef(null), b = x.useCallback((v) => {
    if (h.current = v, p !== -1 && v !== null && (c.current[p] = v, u)) {
      const C = e !== void 0;
      u.current[p] = C ? e : o?.current?.textContent ?? v.textContent;
    }
  }, [p, c, u, e, o]);
  return ke(() => {
    if (i != null)
      return;
    const v = h.current;
    if (v)
      return s(v, n), () => {
        l(v);
      };
  }, [i, s, l, n]), ke(() => {
    if (i == null)
      return a((v) => {
        const C = h.current ? v.get(h.current)?.index : null;
        C != null && m(C);
      });
  }, [i, a, m]), x.useMemo(() => ({
    ref: b,
    index: p
  }), [p, b]);
}
let ep = 0;
function S8(t, e = "mui") {
  const [n, o] = x.useState(t), r = t || n;
  return x.useEffect(() => {
    n == null && (ep += 1, o(`${e}-${ep}`));
  }, [n, e]), r;
}
const tp = br.useId;
function Lo(t, e) {
  if (tp !== void 0) {
    const n = tp();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return S8(t, e);
}
function Ot(t) {
  return Lo(t, "base-ui");
}
let np = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const ed = {
  checked(t) {
    return t ? {
      [np.checked]: ""
    } : {
      [np.unchecked]: ""
    };
  },
  ...Kt
};
function De(t, e, n, o) {
  let r = !1, i = !1;
  const s = o ?? Et;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      i = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return i;
    },
    trigger: n,
    ...s
  };
}
function Pi(t, e, n) {
  const o = n ?? Et;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const dh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: p,
    ...m
  } = e, h = Ao({
    label: s
  }), b = cs(!0), v = Ot(i), {
    store: C
  } = oo(), y = C.useState("isActive", h.index), w = C.useState("itemProps"), [R, S] = Sn({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: N
  } = ma({
    closeOnClick: c,
    disabled: a,
    highlighted: y,
    id: v,
    store: C,
    nativeButton: l,
    nodeId: b?.context.nodeId,
    itemMetadata: Xu
  }), I = x.useMemo(() => ({
    disabled: a,
    highlighted: y,
    checked: R
  }), [a, y, R]), M = we((k) => {
    const P = {
      ...De(Yo, k.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f?.(!R, P), !P.isCanceled && S((D) => !D);
  }), T = Le("div", e, {
    state: I,
    stateAttributesMapping: ed,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": R,
      onClick: M
    }, m, E],
    ref: [N, n, h.ref]
  });
  return /* @__PURE__ */ g(sh.Provider, {
    value: I,
    children: T
  });
});
process.env.NODE_ENV !== "production" && (dh.displayName = "MenuCheckboxItem");
const fh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = e, f = Ao({
    label: s
  }), p = cs(!0), m = Ot(i), {
    store: h
  } = oo(), b = h.useState("isActive", f.index), v = h.useState("itemProps"), {
    getItemProps: C,
    itemRef: y
  } = ma({
    closeOnClick: c,
    disabled: a,
    highlighted: b,
    id: m,
    store: h,
    nativeButton: l,
    nodeId: p?.context.nodeId,
    itemMetadata: Xu
  });
  return Le("div", e, {
    state: {
      disabled: a,
      highlighted: b
    },
    props: [v, d, C],
    ref: [y, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (fh.displayName = "MenuItem");
function Gt(t) {
  t.preventDefault(), t.stopPropagation();
}
function R8(t) {
  return "nativeEvent" in t;
}
function ph(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : Zi && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function mh(t) {
  return uh ? !1 : !Zi && t.width === 0 && t.height === 0 || Zi && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function Jr(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function gh(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
function E8(t, e) {
  return e != null && !Jr(e) ? 0 : typeof t == "function" ? t() : t;
}
function Hl(t, e, n) {
  const o = E8(t, n);
  return typeof o == "number" ? o : o?.[e];
}
function op(t) {
  return typeof t == "function" ? t() : t;
}
function hh(t, e) {
  return e || t === "click" || t === "mousedown";
}
const td = /* @__PURE__ */ x.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new Pn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (td.displayName = "FloatingDelayGroupContext");
function N8(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = x.useRef(n), i = x.useRef(n), s = x.useRef(null), l = x.useRef(null), a = Bt();
  return /* @__PURE__ */ g(td.Provider, {
    value: x.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: i,
      currentIdRef: s,
      timeoutMs: o,
      currentContextRef: l,
      timeout: a
    }), [o, a]),
    children: e
  });
}
function k8(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    open: r
  } = e, i = x.useContext(td), {
    currentIdRef: s,
    delayRef: l,
    timeoutMs: a,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = i, [p, m] = x.useState(!1);
  return ke(() => {
    function h() {
      m(!1), u.current?.setIsInstantPhase(!1), s.current = null, u.current = null, l.current = c.current;
    }
    if (s.current && !r && s.current === o) {
      if (m(!1), a) {
        const b = o;
        return f.start(a, () => {
          n.select("open") || s.current && s.current !== b || h();
        }), () => {
          f.clear();
        };
      }
      h();
    }
  }, [r, o, s, l, a, c, u, f, n]), ke(() => {
    if (!r)
      return;
    const h = u.current, b = s.current;
    f.clear(), u.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: m
    }, s.current = o, l.current = {
      open: 0,
      close: Hl(c.current, "close")
    }, b !== null && b !== o ? (m(!0), h?.setIsInstantPhase(!0), h?.onOpenChange(!1, De(At))) : (m(!1), h?.setIsInstantPhase(!1));
  }, [r, o, n, s, l, a, c, u, f]), ke(() => () => {
    u.current = null;
  }, [u]), x.useMemo(() => ({
    hasProvider: d,
    delayRef: l,
    isInstantPhase: p
  }), [d, l, p]);
}
function dt(t, e, n, o) {
  return t.addEventListener(e, n, o), () => {
    t.removeEventListener(e, n, o);
  };
}
function Xn(...t) {
  return () => {
    for (let e = 0; e < t.length; e += 1) {
      const n = t[e];
      n && n();
    }
  };
}
function Yt(t) {
  const e = Lt(I8, t).current;
  return e.next = t, ke(e.effect), e;
}
function I8(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
function nt(t) {
  return t?.ownerDocument || document;
}
const bh = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, nr = {
  ...bh,
  position: "fixed",
  top: 0,
  left: 0
}, ii = {
  ...bh,
  position: "absolute"
}, Bn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const [o, r] = x.useState();
  return ke(() => {
    ah && r("button");
  }, []), /* @__PURE__ */ g("span", {
    ...e,
    ref: n,
    style: nr,
    "aria-hidden": o ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Bn.displayName = "FocusGuard");
const au = "data-base-ui-focusable", vh = "active", yh = "selected", xh = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", jo = "ArrowLeft", Ko = "ArrowRight", nd = "ArrowUp", fs = "ArrowDown";
function Xt(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Fe(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && Qr(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function yt(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function zl(t, e) {
  if (!mt(t))
    return !1;
  const n = t;
  if (e.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, o] of e.entries())
    if (Fe(o, n))
      return !o.hasAttribute("data-trigger-disabled");
  return !1;
}
function Yn(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function P8(t) {
  return t.matches("html,body");
}
function ga(t) {
  return wt(t) && t.matches(xh);
}
function Ch(t) {
  return t?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${xh}`) != null;
}
function cu(t) {
  return t ? t.getAttribute("role") === "combobox" && ga(t) : !1;
}
function Bl(t) {
  if (!t || uh)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Xi(t) {
  return t ? t.hasAttribute(au) ? t : t.querySelector(`[${au}]`) || t : null;
}
const M8 = ["top", "right", "bottom", "left"], ei = Math.min, Dn = Math.max, Wl = Math.round, fr = Math.floor, fo = (t) => ({
  x: t,
  y: t
}), T8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function uu(t, e, n) {
  return Dn(t, ei(e, n));
}
function Vo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function In(t) {
  return t.split("-")[0];
}
function or(t) {
  return t.split("-")[1];
}
function od(t) {
  return t === "x" ? "y" : "x";
}
function rd(t) {
  return t === "y" ? "height" : "width";
}
function zn(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function id(t) {
  return od(zn(t));
}
function O8(t, e, n) {
  n === void 0 && (n = !1);
  const o = or(t), r = id(t), i = rd(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Ul(s)), [s, Ul(s)];
}
function D8(t) {
  const e = Ul(t);
  return [du(t), e, du(e)];
}
function du(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const rp = ["left", "right"], ip = ["right", "left"], _8 = ["top", "bottom"], V8 = ["bottom", "top"];
function A8(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? ip : rp : e ? rp : ip;
    case "left":
    case "right":
      return e ? _8 : V8;
    default:
      return [];
  }
}
function L8(t, e, n, o) {
  const r = or(t);
  let i = A8(In(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(du)))), i;
}
function Ul(t) {
  const e = In(t);
  return T8[e] + t.slice(e.length);
}
function F8(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function wh(t) {
  return typeof t != "number" ? F8(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Qi(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Zs(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Ji(t, e) {
  return e < 0 || e >= t.length;
}
function Nl(t, e) {
  return bn(t.current, {
    disabledIndices: e
  });
}
function fu(t, e) {
  return bn(t.current, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function bn(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let i = e;
  do
    i += n ? -r : r;
  while (i >= 0 && i <= t.length - 1 && To(t, i, o));
  return i;
}
function Sh(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  onLoop: r,
  rtl: i,
  cols: s,
  disabledIndices: l,
  minIndex: a,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, p;
  if (e.key === nd ? p = "up" : e.key === fs && (p = "down"), p) {
    const m = [], h = [];
    let b = !1, v = 0;
    {
      let I = null, M = -1;
      t.forEach((T, k) => {
        if (T == null)
          return;
        v += 1;
        const P = T.closest('[role="row"]');
        P && (b = !0), (P !== I || M === -1) && (I = P, M += 1, m[M] = []), m[M].push(k), h[k] = M;
      });
    }
    let C = !1, y = 0;
    if (b)
      for (const I of m) {
        const M = I.length;
        M > y && (y = M), M !== s && (C = !0);
      }
    const w = C && v < t.length, R = y || s, S = (I) => {
      if (!C || u === -1)
        return;
      const M = h[u];
      if (M == null)
        return;
      const T = m[M].indexOf(u), k = I === "up" ? -1 : 1;
      for (let P = M + k, D = 0; D < m.length; D += 1, P += k) {
        if (P < 0 || P >= m.length) {
          if (!o || w)
            return;
          if (P = P < 0 ? m.length - 1 : 0, r) {
            const V = Math.min(T, m[P].length - 1), _ = m[P][V] ?? m[P][0], A = r(e, u, _);
            P = h[A] ?? P;
          }
        }
        const O = m[P];
        for (let V = Math.min(T, O.length - 1); V >= 0; V -= 1) {
          const _ = O[V];
          if (!To(t, _, l))
            return _;
        }
      }
    }, E = (I) => {
      if (!w || u === -1)
        return;
      const M = u % R, T = I === "up" ? -R : R, k = c - c % R, P = fr(c / R) + 1;
      for (let D = u - M + T, O = 0; O < P; O += 1, D += T) {
        if (D < 0 || D > c) {
          if (!o)
            return;
          D = D < 0 ? k : 0;
        }
        const V = Math.min(D + R - 1, c);
        for (let _ = Math.min(D + M, V); _ >= D; _ -= 1)
          if (!To(t, _, l))
            return _;
      }
    };
    d && Gt(e);
    const N = S(p) ?? E(p);
    if (N !== void 0)
      f = N;
    else if (u === -1)
      f = p === "up" ? c : a;
    else if (f = bn(t, {
      startingIndex: u,
      amount: R,
      decrement: p === "up",
      disabledIndices: l
    }), o) {
      if (p === "up" && (u - R < a || f < 0)) {
        const I = u % R, M = c % R, T = c - (M - I);
        M === I ? f = c : f = M > I ? T : T - R, r && (f = r(e, u, f));
      }
      p === "down" && u + R > c && (f = bn(t, {
        startingIndex: u % R - R,
        amount: R,
        disabledIndices: l
      }), r && (f = r(e, u, f)));
    }
    Ji(t, f) && (f = u);
  }
  if (n === "both") {
    const m = fr(u / s);
    e.key === (i ? jo : Ko) && (d && Gt(e), u % s !== s - 1 ? (f = bn(t, {
      startingIndex: u,
      disabledIndices: l
    }), o && Zs(f, s, m) && (f = bn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = bn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Zs(f, s, m) && (f = u)), e.key === (i ? Ko : jo) && (d && Gt(e), u % s !== 0 ? (f = bn(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: l
    }), o && Zs(f, s, m) && (f = bn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = bn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Zs(f, s, m) && (f = u));
    const h = fr(c / s) === m;
    Ji(t, f) && (o && h ? (f = e.key === (i ? Ko : jo) ? c : bn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))) : f = u);
  }
  return f;
}
function Rh(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: i,
    height: s
  }, l) => {
    if (i > e && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${l} is greater than grid columns`);
    let a = !1;
    for (n && (r = 0); !a; ) {
      const c = [];
      for (let u = 0; u < i; u += 1)
        for (let d = 0; d < s; d += 1)
          c.push(r + u + d * e);
      r % e + i <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = l;
      }), a = !0) : r += 1;
    }
  }), [...o];
}
function Eh(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const i = n.indexOf(t), s = e[t];
  switch (r) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * o : i;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function Nh(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function To(t, e, n) {
  if (typeof n == "function" ? n(e) : n?.includes(e) ?? !1)
    return !0;
  const r = t[e];
  return r ? ha(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function $8(t) {
  return t.visibility === "hidden" || t.visibility === "collapse";
}
function ha(t, e = t ? En(t) : null) {
  return !t || !t.isConnected || !e || $8(e) ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : e.display !== "none" && e.display !== "contents";
}
const H8 = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function z8(t) {
  const e = t.assignedSlot;
  if (e)
    return e;
  if (t.parentElement)
    return t.parentElement;
  const n = t.getRootNode();
  return Qr(n) ? n.host : null;
}
function pu(t) {
  for (const e of Array.from(t.children))
    if (xn(e) === "summary")
      return e;
  return null;
}
function B8(t, e) {
  const n = pu(e);
  return !!n && (t === n || Fe(n, t));
}
function kh(t) {
  const e = t ? xn(t) : "";
  return t != null && t.matches(H8) && (e !== "summary" || t.parentElement != null && xn(t.parentElement) === "details" && pu(t.parentElement) === t) && (e !== "details" || pu(t) == null) && (e !== "input" || t.type !== "hidden");
}
function Ih(t) {
  if (!kh(t) || !t.isConnected || t.matches(":disabled"))
    return !1;
  for (let e = t; e; e = z8(e)) {
    const n = e !== t, o = xn(e) === "slot";
    if (e.hasAttribute("inert") || n && xn(e) === "details" && !e.open && !B8(t, e) || e.hasAttribute("hidden") || !o && !W8(e, n))
      return !1;
  }
  return !0;
}
function W8(t, e) {
  const n = En(t);
  return e ? n.display !== "none" : ha(t, n);
}
function Ph(t) {
  const e = t.tabIndex;
  if (e < 0) {
    const n = xn(t);
    if (n === "details" || n === "audio" || n === "video" || wt(t) && t.isContentEditable)
      return 0;
  }
  return e;
}
function rc(t) {
  if (xn(t) !== "input")
    return null;
  const e = t;
  return e.type === "radio" && e.name !== "" ? e : null;
}
function U8(t, e) {
  const n = rc(t);
  if (!n)
    return !0;
  const o = e.find((r) => {
    const i = rc(r);
    return i?.name === n.name && i.form === n.form && i.checked;
  });
  return o ? o === n : e.find((r) => {
    const i = rc(r);
    return i?.name === n.name && i.form === n.form;
  }) === n;
}
function Mh(t) {
  if (wt(t) && xn(t) === "slot") {
    const e = t.assignedElements({
      flatten: !0
    });
    if (e.length > 0)
      return e;
  }
  return wt(t) && t.shadowRoot ? Array.from(t.shadowRoot.children) : Array.from(t.children);
}
function Th(t, e) {
  Mh(t).forEach((n) => {
    kh(n) && e.push(n), Th(n, e);
  });
}
function Oh(t, e, n) {
  Mh(t).forEach((o) => {
    wt(o) && o.matches(e) && n.push(o), Oh(o, e, n);
  });
}
function sd(t) {
  return Ih(t) && Ph(t) >= 0;
}
function Dh(t) {
  const e = [];
  return Th(t, e), e.filter(Ih);
}
function ps(t) {
  const e = Dh(t);
  return e.filter((n) => Ph(n) >= 0 && U8(n, e));
}
function _h(t, e) {
  const n = ps(t), o = n.length;
  if (o === 0)
    return;
  const r = Xt(nt(t)), i = n.indexOf(r), s = i === -1 ? e === 1 ? 0 : o - 1 : i + e;
  return n[s];
}
function ld(t) {
  return _h(nt(t).body, 1) || t;
}
function Vh(t) {
  return _h(nt(t).body, -1) || t;
}
function Ah(t, e) {
  if (!t)
    return null;
  const n = ps(nt(t).body), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const i = (r + e + o) % o;
  return n[i];
}
function G8(t) {
  return Ah(t, 1);
}
function Y8(t) {
  return Ah(t, -1);
}
function Yr(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !Fe(n, o);
}
function j8(t) {
  ps(t).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function sp(t) {
  const e = [];
  Oh(t, "[data-tabindex]", e), e.forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function po(t, e, n = !0) {
  return t.filter((r) => r.parentId === e).flatMap((r) => [...!n || r.context?.open ? [r] : [], ...po(t, r.id, n)]);
}
function lp(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((i) => i.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function es(t) {
  return `data-base-ui-${t}`;
}
let Xs = 0;
function kl(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Xs);
  const i = () => t?.focus({
    preventScroll: n
  });
  if (r)
    return i(), Ct;
  const s = requestAnimationFrame(i);
  return Xs = s, () => {
    Xs === s && (cancelAnimationFrame(s), Xs = 0);
  };
}
const ic = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, ap = "data-base-ui-inert", mu = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let Mi = /* @__PURE__ */ new WeakMap(), sc = 0;
function K8(t) {
  return mu[t];
}
function Lh(t) {
  return t ? Qr(t) ? t.host : Lh(t.parentNode) : null;
}
const lc = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = Lh(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null), cp = (t) => {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    let o = n;
    for (; o && !e.has(o); )
      e.add(o), o = o.parentNode;
  }), e;
}, up = (t, e, n) => {
  const o = [], r = (i) => {
    !i || n.has(i) || Array.from(i.children).forEach((s) => {
      xn(s) !== "script" && (e.has(s) ? r(s) : o.push(s));
    });
  };
  return r(t), o;
};
function q8(t, e, n, o, {
  mark: r = !0,
  markerIgnoreElements: i = []
}) {
  const s = o ? "inert" : n ? "aria-hidden" : null;
  let l = null, a = null;
  const c = lc(e, t), u = r ? lc(e, i) : [], d = new Set(u), f = r ? up(e, cp(c), new Set(c)).filter((h) => !d.has(h)) : [], p = [], m = [];
  if (s) {
    const h = ic[s], b = K8(s);
    a = b, l = h;
    const v = lc(e, Array.from(e.querySelectorAll("[aria-live]"))), C = c.concat(v);
    up(e, cp(C), new Set(C)).forEach((w) => {
      const R = w.getAttribute(s), S = R !== null && R !== "false", E = (h.get(w) || 0) + 1;
      h.set(w, E), p.push(w), E === 1 && S && b.add(w), S || w.setAttribute(s, s === "inert" ? "" : "true");
    });
  }
  return r && f.forEach((h) => {
    const b = (Mi.get(h) || 0) + 1;
    Mi.set(h, b), m.push(h), b === 1 && h.setAttribute(ap, "");
  }), sc += 1, () => {
    l && p.forEach((h) => {
      const v = (l.get(h) || 0) - 1;
      l.set(h, v), v || (!a?.has(h) && s && h.removeAttribute(s), a?.delete(h));
    }), r && m.forEach((h) => {
      const b = (Mi.get(h) || 0) - 1;
      Mi.set(h, b), b || h.removeAttribute(ap);
    }), sc -= 1, sc || (ic.inert = /* @__PURE__ */ new WeakMap(), ic["aria-hidden"] = /* @__PURE__ */ new WeakMap(), mu.inert = /* @__PURE__ */ new WeakSet(), mu["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Mi = /* @__PURE__ */ new WeakMap());
  };
}
function dp(t, e = {}) {
  const {
    ariaHidden: n = !1,
    inert: o = !1,
    mark: r = !0,
    markerIgnoreElements: i = []
  } = e, s = nt(t[0]).body;
  return q8(t, s, n, o, {
    mark: r,
    markerIgnoreElements: i
  });
}
const Z8 = 500, Fh = 500, X8 = {
  style: {
    transition: "none"
  }
}, ad = "data-base-ui-click-trigger", Q8 = "data-base-ui-swipe-ignore", J8 = "data-swipe-ignore", $h = `[${Q8}]`, e6 = `[${J8}]`, cd = {
  fallbackAxisSide: "none"
}, ba = {
  fallbackAxisSide: "end"
}, t6 = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, ud = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (ud.displayName = "PortalContext");
const Hh = () => x.useContext(ud), n6 = es("portal");
function zh(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = Et,
    elementProps: r
  } = t, i = Lo(), l = Hh()?.portalNode, [a, c] = x.useState(null), [u, d] = x.useState(null), f = we((b) => {
    b !== null && d(b);
  }), p = x.useRef(null);
  ke(() => {
    if (n === null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    if (i == null)
      return;
    const b = (n && (Hu(n) ? n : n.current)) ?? l ?? document.body;
    if (b == null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    p.current !== b && (p.current = b, d(null), c(b));
  }, [n, l, i]);
  const m = Le("div", o, {
    ref: [e, f],
    props: [{
      id: i,
      [n6]: ""
    }, r]
  });
  return {
    portalNode: u,
    portalSubtree: a && m ? /* @__PURE__ */ yn.createPortal(m, a) : null
  };
}
const si = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    renderGuards: l,
    style: a,
    ...c
  } = e, {
    portalNode: u,
    portalSubtree: d
  } = zh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: c
  }), f = x.useRef(null), p = x.useRef(null), m = x.useRef(null), h = x.useRef(null), [b, v] = x.useState(null), C = x.useRef(!1), y = b?.modal, w = b?.open, R = typeof l == "boolean" ? l : !!b && !b.modal && b.open && !!u;
  x.useEffect(() => {
    if (!u || y)
      return;
    function E(N) {
      u && N.relatedTarget && Yr(N) && (N.type === "focusin" ? C.current && (sp(u), C.current = !1) : (j8(u), C.current = !0));
    }
    return Xn(dt(u, "focusin", E, !0), dt(u, "focusout", E, !0));
  }, [u, y]), x.useEffect(() => {
    !u || w !== !1 || (sp(u), C.current = !1);
  }, [w, u]);
  const S = x.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: p,
    beforeInsideRef: m,
    afterInsideRef: h,
    portalNode: u,
    setFocusManagerState: v
  }), [u]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [d, /* @__PURE__ */ F(ud.Provider, {
      value: S,
      children: [R && u && /* @__PURE__ */ g(Bn, {
        "data-type": "outside",
        ref: f,
        onFocus: (E) => {
          if (Yr(E, u))
            m.current?.focus();
          else {
            const N = b ? b.domReference : null;
            Vh(N)?.focus();
          }
        }
      }), R && u && /* @__PURE__ */ g("span", {
        "aria-owns": u.id,
        style: t6
      }), u && /* @__PURE__ */ yn.createPortal(o, u), R && u && /* @__PURE__ */ g(Bn, {
        "data-type": "outside",
        ref: p,
        onFocus: (E) => {
          if (Yr(E, u))
            h.current?.focus();
          else {
            const N = b ? b.domReference : null;
            ld(N)?.focus(), b?.closeOnFocusOut && b?.onOpenChange(!1, De(_o, E.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (si.displayName = "FloatingPortal");
function Bh() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class dd {
  nodesRef = {
    current: []
  };
  events = Bh();
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const fd = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (fd.displayName = "FloatingNodeContext");
const pd = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (pd.displayName = "FloatingTreeContext");
const Co = () => x.useContext(fd)?.id || null, rr = (t) => {
  const e = x.useContext(pd);
  return t ?? e;
};
function va(t) {
  const e = Lo(), n = rr(t), o = Co();
  return ke(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function md(t) {
  const {
    children: e,
    id: n
  } = t, o = Co();
  return /* @__PURE__ */ g(fd.Provider, {
    value: x.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function gd(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = Lt(() => n ?? new dd()).current;
  return /* @__PURE__ */ g(pd.Provider, {
    value: o,
    children: e
  });
}
function o6(t, e) {
  const n = St(yt(t));
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const fp = 20;
let Uo = [];
function hd() {
  Uo = Uo.filter((t) => t.deref()?.isConnected);
}
function r6(t) {
  hd(), t && xn(t) !== "body" && (Uo.push(new WeakRef(t)), Uo.length > fp && (Uo = Uo.slice(-fp)));
}
function ac() {
  return hd(), Uo[Uo.length - 1]?.deref();
}
function i6(t) {
  return t ? sd(t) ? t : ps(t)[0] || t : null;
}
function pp(t, e) {
  if (t.hasAttribute("tabindex") && !t.hasAttribute("data-tabindex") || !e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const o = Dh(t).filter((i) => {
    const s = i.getAttribute("data-tabindex") || "";
    return sd(i) || i.hasAttribute("data-tabindex") && !s.startsWith("-");
  }), r = t.getAttribute("tabindex");
  e.current.includes("floating") || o.length === 0 ? r !== "0" && t.setAttribute("tabindex", "0") : (r !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function li(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    initialFocus: r = !0,
    returnFocus: i = !0,
    restoreFocus: s = !1,
    modal: l = !0,
    closeOnFocusOut: a = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: p,
    getInsideElements: m
  } = t, h = "rootStore" in e ? e.rootStore : e, b = h.useState("open"), v = h.useState("domReferenceElement"), C = h.useState("floatingElement"), {
    events: y,
    dataRef: w
  } = h.context, R = we(() => w.current.floatingContext?.nodeId), S = r === !1, E = cu(v) && S, N = x.useRef(["content"]), I = Yt(r), M = Yt(i), T = Yt(c), k = rr(p), P = Hh(), D = x.useRef(!1), O = x.useRef(!1), V = x.useRef(!1), _ = x.useRef(null), A = x.useRef(""), L = x.useRef(""), $ = x.useRef(null), B = x.useRef(null), z = Rn($, f, P?.beforeInsideRef), H = Rn(B, P?.afterInsideRef), K = Bt(), G = Bt(), q = ri(), Q = P != null, U = Xi(C), X = we((J = U) => J ? ps(J) : []), te = we(() => m?.().filter((J) => J != null) ?? []);
  x.useEffect(() => {
    if (o || !l)
      return;
    function J(ce) {
      ce.key === "Tab" && Fe(U, Xt(nt(U))) && X().length === 0 && !E && Gt(ce);
    }
    const ie = nt(U);
    return dt(ie, "keydown", J);
  }, [o, v, U, l, N, E, X]), x.useEffect(() => {
    if (o || !b)
      return;
    const J = nt(U);
    function ie() {
      V.current = !1;
    }
    function ce(se) {
      const me = yt(se), pe = te(), le = Fe(C, me) || Fe(v, me) || Fe(P?.portalNode, me) || pe.some((ge) => ge === me || Fe(ge, me));
      V.current = !le, L.current = se.pointerType || "keyboard", me?.closest(`[${ad}]`) && (O.current = !0);
    }
    function oe() {
      L.current = "keyboard";
    }
    return Xn(dt(J, "pointerdown", ce, !0), dt(J, "pointerup", ie, !0), dt(J, "pointercancel", ie, !0), dt(J, "keydown", oe, !0));
  }, [o, C, v, U, b, P, te]), x.useEffect(() => {
    if (o || !a)
      return;
    const J = nt(U);
    function ie() {
      O.current = !0, G.start(0, () => {
        O.current = !1;
      });
    }
    function ce(pe) {
      const le = yt(pe);
      sd(le) && (_.current = le);
    }
    function oe(pe) {
      const le = pe.relatedTarget, ge = pe.currentTarget, j = yt(pe);
      queueMicrotask(() => {
        const ee = R(), Y = h.context.triggerElements, Z = te(), ue = le?.hasAttribute(es("focus-guard")) && [$.current, B.current, P?.beforeInsideRef.current, P?.afterInsideRef.current, P?.beforeOutsideRef.current, P?.afterOutsideRef.current, Ro(d), Ro(u)].includes(le), fe = !(Fe(v, le) || Fe(C, le) || Fe(le, C) || Fe(P?.portalNode, le) || Z.some((be) => be === le || Fe(be, le)) || le != null && Y.hasElement(le) || Y.hasMatchingElement((be) => Fe(be, le)) || ue || k && (po(k.nodesRef.current, ee).find((be) => Fe(be.context?.elements.floating, le) || Fe(be.context?.elements.domReference, le)) || lp(k.nodesRef.current, ee).find((be) => [be.context?.elements.floating, Xi(be.context?.elements.floating)].includes(le) || be.context?.elements.domReference === le)));
        if (ge === v && U && pp(U, N), s && ge !== v && !ha(j) && Xt(J) === J.body) {
          if (wt(U) && (U.focus(), s === "popup")) {
            q.request(() => {
              U.focus();
            });
            return;
          }
          const be = X(), Ie = _.current, ye = (Ie && be.includes(Ie) ? Ie : null) || be[be.length - 1] || U;
          wt(ye) && ye.focus();
        }
        if (w.current.insideReactTree) {
          w.current.insideReactTree = !1;
          return;
        }
        (E || !l) && le && fe && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (E || le !== ac()) && (D.current = !0, h.setOpen(!1, De(_o, pe)));
      });
    }
    function se() {
      V.current || (w.current.insideReactTree = !0, K.start(0, () => {
        w.current.insideReactTree = !1;
      }));
    }
    const me = wt(v) ? v : null;
    if (!(!C && !me))
      return Xn(me && dt(me, "focusout", oe), me && dt(me, "pointerdown", ie), C && dt(C, "focusin", ce), C && dt(C, "focusout", oe), C && P && dt(C, "focusout", se, !0));
  }, [o, v, C, U, l, k, P, h, a, s, X, E, R, N, w, K, G, q, u, d, te]), x.useEffect(() => {
    if (o || !C || !b)
      return;
    const J = Array.from(P?.portalNode?.querySelectorAll(`[${es("portal")}]`) || []), ce = (k ? lp(k.nodesRef.current, R()) : []).find((ge) => cu(ge.context?.elements.domReference || null))?.context?.elements.domReference, se = [...[C, ...J, $.current, B.current, P?.beforeOutsideRef.current, P?.afterOutsideRef.current, ...te()], ce, Ro(d), Ro(u), E ? v : null].filter((ge) => ge != null), me = dp(se, {
      ariaHidden: l || E,
      mark: !1
    }), pe = [C, ...J].filter((ge) => ge != null), le = dp(pe);
    return () => {
      le(), me();
    };
  }, [b, o, v, C, l, N, P, E, k, R, u, d, te]), ke(() => {
    if (!b || o || !wt(U))
      return;
    const J = nt(U), ie = Xt(J);
    queueMicrotask(() => {
      const ce = I.current, oe = typeof ce == "function" ? ce(T.current || "") : ce;
      if (oe === void 0 || oe === !1 || Fe(U, ie))
        return;
      let me = null;
      const pe = () => (me == null && (me = X(U)), me[0] || U);
      let le;
      oe === !0 || oe === null ? le = pe() : le = Ro(oe), le = le || pe(), kl(le, {
        preventScroll: le === U
      });
    });
  }, [o, b, U, S, X, I, T]), ke(() => {
    if (o || !U)
      return;
    const J = nt(U), ie = Xt(J);
    r6(ie);
    function ce(se) {
      if (se.open || (A.current = o6(se.nativeEvent, L.current)), se.reason === Ut && se.nativeEvent.type === "mouseleave" && (D.current = !0), se.reason === us)
        if (se.nested)
          D.current = !1;
        else if (ph(se.nativeEvent) || mh(se.nativeEvent))
          D.current = !1;
        else {
          let me = !1;
          nt(U).createElement("div").focus({
            get preventScroll() {
              return me = !0, !1;
            }
          }), me ? D.current = !1 : D.current = !0;
        }
    }
    y.on("openchange", ce);
    function oe() {
      const se = M.current;
      let me = typeof se == "function" ? se(A.current) : se;
      if (me === void 0 || me === !1)
        return null;
      if (me === null && (me = !0), typeof me == "boolean") {
        const le = v || ac();
        return le && le.isConnected ? le : null;
      }
      const pe = v || ac();
      return Ro(me) || pe || null;
    }
    return () => {
      y.off("openchange", ce);
      const se = Xt(J), me = te(), pe = Fe(C, se) || me.some((j) => j === se || Fe(j, se)) || k && po(k.nodesRef.current, R(), !1).some((j) => Fe(j.context?.elements.floating, se)), le = M.current, ge = oe();
      queueMicrotask(() => {
        const j = i6(ge), ee = typeof le != "boolean";
        le && !D.current && wt(j) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!ee && j !== se && se !== J.body) || pe) && j.focus({
          preventScroll: !0
        }), D.current = !1;
      });
    };
  }, [o, C, U, M, w, y, k, v, R, te]), ke(() => {
    if (!qu || b || !C)
      return;
    const J = Xt(nt(C));
    !wt(J) || !ga(J) || Fe(C, J) && J.blur();
  }, [b, C]), ke(() => {
    if (!(o || !P))
      return P.setFocusManagerState({
        modal: l,
        closeOnFocusOut: a,
        open: b,
        onOpenChange: h.setOpen,
        domReference: v
      }), () => {
        P.setFocusManagerState(null);
      };
  }, [o, P, l, b, h, a, v]), ke(() => {
    if (!(o || !U))
      return pp(U, N), () => {
        queueMicrotask(hd);
      };
  }, [o, U, N]);
  const re = !o && (l ? !E : !0) && (Q || l);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [re && /* @__PURE__ */ g(Bn, {
      "data-type": "inside",
      ref: z,
      onFocus: (J) => {
        if (l) {
          const ie = X();
          kl(ie[ie.length - 1]);
        } else P?.portalNode && (D.current = !1, Yr(J, P.portalNode) ? ld(v)?.focus() : Ro(d ?? P.beforeOutsideRef)?.focus());
      }
    }), n, re && /* @__PURE__ */ g(Bn, {
      "data-type": "inside",
      ref: H,
      onFocus: (J) => {
        l ? kl(X()[0]) : P?.portalNode && (a && (D.current = !0), Yr(J, P.portalNode) ? Vh(v)?.focus() : Ro(u ?? P.afterOutsideRef)?.focus());
      }
    })]
  });
}
function Nr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: i = "click",
    toggle: s = !0,
    ignoreMouse: l = !1,
    stickIfOpen: a = !0,
    touchOpenDelay: c = 0,
    reason: u = eo
  } = e, d = x.useRef(void 0), f = ri(), p = Bt(), m = x.useMemo(() => ({
    onPointerDown(h) {
      d.current = h.pointerType;
    },
    onMouseDown(h) {
      const b = d.current, v = h.nativeEvent, C = n.select("open");
      if (h.button !== 0 || i === "click" || Jr(b, !0) && l)
        return;
      const y = o.current.openEvent, w = y?.type, R = n.select("domReferenceElement") !== h.currentTarget, S = C && R || !(C && s && (!(y && a) || w === "click" || w === "mousedown")), E = yt(v);
      if (ga(E)) {
        const I = De(u, v, E);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, I);
        }) : n.setOpen(S, I);
        return;
      }
      const N = h.currentTarget;
      f.request(() => {
        const I = De(u, v, N);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, I);
        }) : n.setOpen(S, I);
      });
    },
    onClick(h) {
      if (i === "mousedown-only")
        return;
      const b = d.current;
      if (i === "mousedown" && b) {
        d.current = void 0;
        return;
      }
      if (Jr(b, !0) && l)
        return;
      const v = n.select("open"), C = o.current.openEvent, y = n.select("domReferenceElement") !== h.currentTarget, w = v && y || !(v && s && (!(C && a) || gh(C))), R = De(u, h.nativeEvent, h.currentTarget);
      w && b === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, R);
      }) : n.setOpen(w, R);
    },
    onKeyDown() {
      d.current = void 0;
    }
  }), [o, i, l, n, a, s, f, p, c, u]);
  return x.useMemo(() => r ? {
    reference: m
  } : Et, [r, m]);
}
function s6(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const i = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, s = e.axis === "x" || e.axis === "both", l = e.axis === "y" || e.axis === "both", a = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = i.width, u = i.height, d = i.x, f = i.y;
      return n == null && e.x && s && (n = i.x - e.x), o == null && e.y && l && (o = i.y - e.y), d -= n || 0, f -= o || 0, c = 0, u = 0, !r || a ? (c = e.axis === "y" ? i.width : 0, u = e.axis === "x" ? i.height : 0, d = s && e.x != null ? e.x : d, f = l && e.y != null ? e.y : f) : r && !a && (u = e.axis === "x" ? i.height : u, c = e.axis === "y" ? i.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function mp(t) {
  return t != null && t.clientX != null;
}
function l6(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    enabled: l = !0,
    axis: a = "both"
  } = e, c = x.useRef(!1), u = x.useRef(null), [d, f] = x.useState(), [p, m] = x.useState([]), h = we((w, R, S) => {
    c.current || s.current.openEvent && !mp(s.current.openEvent) || n.set("positionReference", s6(S ?? i, {
      x: w,
      y: R,
      axis: a,
      dataRef: s,
      pointerType: d
    }));
  }), b = we((w) => {
    o ? u.current || m([]) : h(w.clientX, w.clientY, w.currentTarget);
  }), v = Jr(d) ? r : o, C = x.useCallback(() => {
    if (!v || !l)
      return;
    const w = St(r);
    function R(S) {
      const E = yt(S);
      Fe(r, E) ? (u.current?.(), u.current = null) : h(S.clientX, S.clientY);
    }
    if (!s.current.openEvent || mp(s.current.openEvent)) {
      const S = () => {
        u.current?.(), u.current = null;
      };
      return u.current = dt(w, "mousemove", R), S;
    }
    n.set("positionReference", i);
  }, [v, l, r, s, i, n, h]);
  x.useEffect(() => C(), [C, p]), x.useEffect(() => {
    l && !r && (c.current = !1);
  }, [l, r]), x.useEffect(() => {
    !l && o && (c.current = !0);
  }, [l, o]);
  const y = x.useMemo(() => {
    function w(R) {
      f(R.pointerType);
    }
    return {
      onPointerDown: w,
      onPointerEnter: w,
      onMouseMove: b,
      onMouseEnter: b
    };
  }, [b]);
  return x.useMemo(() => l ? {
    reference: y,
    trigger: y
  } : {}, [l, y]);
}
const a6 = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function c6() {
  return !1;
}
function u6(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function kr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), {
    dataRef: i
  } = n.context, {
    enabled: s = !0,
    escapeKey: l = !0,
    outsidePress: a = !0,
    outsidePressEvent: c = "sloppy",
    referencePress: u = c6,
    referencePressEvent: d = "sloppy",
    bubbles: f,
    externalTree: p
  } = e, m = rr(p), h = we(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? h : a, v = b !== !1, C = we(() => c), y = x.useRef(!1), w = x.useRef(!1), R = x.useRef(!1), {
    escapeKey: S,
    outsidePress: E
  } = u6(f), N = x.useRef(null), I = Bt(), M = Bt(), T = we(() => {
    M.clear(), i.current.insideReactTree = !1;
  }), k = x.useRef(!1), P = x.useRef(""), D = we(u), O = we((B) => {
    if (!o || !s || !l || B.key !== "Escape" || k.current)
      return;
    const z = i.current.floatingContext?.nodeId, H = m ? po(m.nodesRef.current, z) : [];
    if (!S && H.length > 0) {
      let q = !0;
      if (H.forEach((Q) => {
        Q.context?.open && !Q.context.dataRef.current.__escapeKeyBubbles && (q = !1);
      }), !q)
        return;
    }
    const K = R8(B) ? B.nativeEvent : B, G = De(Rr, K);
    n.setOpen(!1, G), !S && !G.isPropagationAllowed && B.stopPropagation();
  }), V = we(() => {
    i.current.insideReactTree = !0, M.start(0, T);
  });
  x.useEffect(() => {
    if (!o || !s)
      return;
    i.current.__escapeKeyBubbles = S, i.current.__outsidePressBubbles = E;
    const B = new Pn(), z = new Pn();
    function H() {
      B.clear(), k.current = !0;
    }
    function K() {
      B.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ua() ? 5 : 0,
        () => {
          k.current = !1;
        }
      );
    }
    function G() {
      R.current = !0, z.start(0, () => {
        R.current = !1;
      });
    }
    function q() {
      y.current = !1, w.current = !1;
    }
    function Q() {
      const Y = P.current, Z = Y === "pen" || !Y ? "mouse" : Y, ue = C(), fe = typeof ue == "function" ? ue() : ue;
      return typeof fe == "string" ? fe : fe[Z];
    }
    function U(Y) {
      const Z = Q();
      return Z === "intentional" && Y.type !== "click" || Z === "sloppy" && Y.type === "click";
    }
    function X(Y) {
      const Z = i.current.floatingContext?.nodeId, ue = m && po(m.nodesRef.current, Z).some((fe) => Yn(Y, fe.context?.elements.floating));
      return Yn(Y, n.select("floatingElement")) || Yn(Y, n.select("domReferenceElement")) || ue;
    }
    function te(Y) {
      if (U(Y)) {
        T();
        return;
      }
      if (i.current.insideReactTree) {
        T();
        return;
      }
      const Z = yt(Y), ue = `[${es("inert")}]`, fe = mt(Z) ? Z.getRootNode() : null, be = Array.from((Qr(fe) ? fe : nt(n.select("floatingElement"))).querySelectorAll(ue)), Ie = n.context.triggerElements;
      if (Z && (Ie.hasElement(Z) || Ie.hasMatchingElement((Se) => Fe(Se, Z))))
        return;
      let ye = mt(Z) ? Z : null;
      for (; ye && !uo(ye); ) {
        const Se = ho(ye);
        if (uo(Se) || !mt(Se))
          break;
        ye = Se;
      }
      if (be.length && mt(Z) && !P8(Z) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !Fe(Z, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      be.every((Se) => !Fe(ye, Se)))
        return;
      if (wt(Z) && !("touches" in Y)) {
        const Se = uo(Z), Me = En(Z), Re = /auto|scroll/, Ve = Se || Re.test(Me.overflowX), Ze = Se || Re.test(Me.overflowY), Xe = Ve && Z.clientWidth > 0 && Z.scrollWidth > Z.clientWidth, Be = Ze && Z.clientHeight > 0 && Z.scrollHeight > Z.clientHeight, Ne = Me.direction === "rtl", _e = Be && (Ne ? Y.offsetX <= Z.offsetWidth - Z.clientWidth : Y.offsetX > Z.clientWidth), Pe = Xe && Y.offsetY > Z.clientHeight;
        if (_e || Pe)
          return;
      }
      if (X(Y))
        return;
      if (Q() === "intentional" && R.current) {
        z.clear(), R.current = !1;
        return;
      }
      if (typeof b == "function" && !b(Y))
        return;
      const xe = i.current.floatingContext?.nodeId, de = m ? po(m.nodesRef.current, xe) : [];
      if (de.length > 0) {
        let Se = !0;
        if (de.forEach((Me) => {
          Me.context?.open && !Me.context.dataRef.current.__outsidePressBubbles && (Se = !1);
        }), !Se)
          return;
      }
      n.setOpen(!1, De(us, Y)), T();
    }
    function re(Y) {
      Q() !== "sloppy" || Y.pointerType === "touch" || !n.select("open") || !s || Yn(Y, n.select("floatingElement")) || Yn(Y, n.select("domReferenceElement")) || te(Y);
    }
    function J(Y) {
      if (Q() !== "sloppy" || !n.select("open") || !s || Yn(Y, n.select("floatingElement")) || Yn(Y, n.select("domReferenceElement")))
        return;
      const Z = Y.touches[0];
      Z && (N.current = {
        startTime: Date.now(),
        startX: Z.clientX,
        startY: Z.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, I.start(1e3, () => {
        N.current && (N.current.dismissOnTouchEnd = !1, N.current.dismissOnMouseDown = !1);
      }));
    }
    function ie(Y, Z) {
      const ue = yt(Y);
      if (!ue)
        return;
      const fe = dt(ue, Y.type, () => {
        Z(Y), fe();
      });
    }
    function ce(Y) {
      P.current = "touch", ie(Y, J);
    }
    function oe(Y) {
      I.clear(), Y.type === "pointerdown" && (P.current = Y.pointerType), !(Y.type === "mousedown" && N.current && !N.current.dismissOnMouseDown) && ie(Y, (Z) => {
        Z.type === "pointerdown" ? re(Z) : te(Z);
      });
    }
    function se(Y) {
      if (!y.current)
        return;
      const Z = w.current;
      if (q(), Q() === "intentional") {
        if (Y.type === "pointercancel") {
          Z && G();
          return;
        }
        if (!X(Y)) {
          if (Z) {
            G();
            return;
          }
          typeof b == "function" && !b(Y) || (z.clear(), R.current = !0, T());
        }
      }
    }
    function me(Y) {
      if (Q() !== "sloppy" || !N.current || Yn(Y, n.select("floatingElement")) || Yn(Y, n.select("domReferenceElement")))
        return;
      const Z = Y.touches[0];
      if (!Z)
        return;
      const ue = Math.abs(Z.clientX - N.current.startX), fe = Math.abs(Z.clientY - N.current.startY), be = Math.sqrt(ue * ue + fe * fe);
      be > 5 && (N.current.dismissOnTouchEnd = !0), be > 10 && (te(Y), I.clear(), N.current = null);
    }
    function pe(Y) {
      ie(Y, me);
    }
    function le(Y) {
      Q() !== "sloppy" || !N.current || Yn(Y, n.select("floatingElement")) || Yn(Y, n.select("domReferenceElement")) || (N.current.dismissOnTouchEnd && te(Y), I.clear(), N.current = null);
    }
    function ge(Y) {
      ie(Y, le);
    }
    const j = nt(r), ee = Xn(l && Xn(dt(j, "keydown", O), dt(j, "compositionstart", H), dt(j, "compositionend", K)), v && Xn(dt(j, "click", oe, !0), dt(j, "pointerdown", oe, !0), dt(j, "pointerup", se, !0), dt(j, "pointercancel", se, !0), dt(j, "mousedown", oe, !0), dt(j, "mouseup", se, !0), dt(j, "touchstart", ce, !0), dt(j, "touchmove", pe, !0), dt(j, "touchend", ge, !0)));
    return () => {
      ee(), B.clear(), z.clear(), q(), R.current = !1;
    };
  }, [i, r, l, v, b, o, s, S, E, O, T, C, m, n, I]), x.useEffect(T, [b, T]);
  const _ = x.useMemo(() => ({
    onKeyDown: O,
    [a6[d]]: (B) => {
      D() && n.setOpen(!1, De(eo, B.nativeEvent));
    },
    ...d !== "intentional" && {
      onClick(B) {
        D() && n.setOpen(!1, De(eo, B.nativeEvent));
      }
    }
  }), [O, n, d, D]), A = we((B) => {
    if (!o || !s || B.button !== 0)
      return;
    const z = yt(B.nativeEvent);
    Fe(n.select("floatingElement"), z) && (y.current || (y.current = !0, w.current = !1));
  }), L = we((B) => {
    !o || !s || (B.defaultPrevented || B.nativeEvent.defaultPrevented) && y.current && (w.current = !0);
  }), $ = x.useMemo(() => ({
    onKeyDown: O,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: L,
    onMouseDown: L,
    onClickCapture: V,
    onMouseDownCapture(B) {
      V(), A(B);
    },
    onPointerDownCapture(B) {
      V(), A(B);
    },
    onMouseUpCapture: V,
    onTouchEndCapture: V,
    onTouchMoveCapture: V
  }), [O, V, A, L]);
  return x.useMemo(() => s ? {
    reference: _,
    floating: $,
    trigger: _
  } : {}, [s, _, $]);
}
function gp(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = zn(e), s = id(e), l = rd(s), a = In(e), c = i === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, f = o[l] / 2 - r[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (or(e)) {
    case "start":
      p[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function d6(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = Vo(e, t), m = wh(p), b = l[f ? d === "floating" ? "reference" : "floating" : d], v = Qi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: a
  })), C = d === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = Qi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: a
  }) : C);
  return {
    top: (v.top - R.top + m.top) / w.y,
    bottom: (R.bottom - v.bottom + m.bottom) / w.y,
    left: (v.left - R.left + m.left) / w.x,
    right: (R.right - v.right + m.right) / w.x
  };
}
const f6 = 50, p6 = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = s.detectOverflow ? s : {
    ...s,
    detectOverflow: d6
  }, a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = gp(c, o, a), f = o, p = 0;
  const m = {};
  for (let h = 0; h < i.length; h++) {
    const b = i[h];
    if (!b)
      continue;
    const {
      name: v,
      fn: C
    } = b, {
      x: y,
      y: w,
      data: R,
      reset: S
    } = await C({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = y ?? u, d = w ?? d, m[v] = {
      ...m[v],
      ...R
    }, S && p < f6 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = gp(c, f, a)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: m
  };
}, m6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...b
      } = Vo(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = In(r), C = zn(l), y = In(l) === l, w = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), R = f || (y || !h ? [Ul(l)] : D8(l)), S = m !== "none";
      !f && S && R.push(...L8(l, h, m, w));
      const E = [l, ...R], N = await a.detectOverflow(e, b), I = [];
      let M = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (u && I.push(N[v]), d) {
        const D = O8(r, s, w);
        I.push(N[D[0]], N[D[1]]);
      }
      if (M = [...M, {
        placement: r,
        overflows: I
      }], !I.every((D) => D <= 0)) {
        var T, k;
        const D = (((T = i.flip) == null ? void 0 : T.index) || 0) + 1, O = E[D];
        if (O && (!(d === "alignment" ? C !== zn(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        M.every((A) => zn(A.placement) === C ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: M
            },
            reset: {
              placement: O
            }
          };
        let V = (k = M.filter((_) => _.overflows[0] <= 0).sort((_, A) => _.overflows[1] - A.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var P;
              const _ = (P = M.filter((A) => {
                if (S) {
                  const L = zn(A.placement);
                  return L === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((L) => L > 0).reduce((L, $) => L + $, 0)]).sort((A, L) => A[1] - L[1])[0]) == null ? void 0 : P[0];
              _ && (V = _);
              break;
            }
            case "initialPlacement":
              V = l;
              break;
          }
        if (r !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function hp(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function bp(t) {
  return M8.some((e) => t[e] >= 0);
}
const g6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = Vo(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(e, {
            ...i,
            elementContext: "reference"
          }), l = hp(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: bp(l)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(e, {
            ...i,
            altBoundary: !0
          }), l = hp(s, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: bp(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Wh = /* @__PURE__ */ new Set(["left", "top"]);
async function h6(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = In(n), l = or(n), a = zn(n) === "y", c = Wh.has(s) ? -1 : 1, u = i && a ? -1 : 1, d = Vo(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof m == "number" && (p = l === "end" ? m * -1 : m), a ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const b6 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: l
      } = e, a = await h6(e, t);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, v6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: l = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: C,
              y
            } = v;
            return {
              x: C,
              y
            };
          }
        },
        ...c
      } = Vo(t, e), u = {
        x: n,
        y: o
      }, d = await i.detectOverflow(e, c), f = zn(In(r)), p = od(f);
      let m = u[p], h = u[f];
      if (s) {
        const v = p === "y" ? "top" : "left", C = p === "y" ? "bottom" : "right", y = m + d[v], w = m - d[C];
        m = uu(y, m, w);
      }
      if (l) {
        const v = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", y = h + d[v], w = h - d[C];
        h = uu(y, h, w);
      }
      const b = a.fn({
        ...e,
        [p]: m,
        [f]: h
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [p]: s,
            [f]: l
          }
        }
      };
    }
  };
}, y6 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = e, {
        offset: l = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = Vo(t, e), u = {
        x: n,
        y: o
      }, d = zn(r), f = od(d);
      let p = u[f], m = u[d];
      const h = Vo(l, e), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (a) {
        const y = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[y] + b.mainAxis, R = i.reference[f] + i.reference[y] - b.mainAxis;
        p < w ? p = w : p > R && (p = R);
      }
      if (c) {
        var v, C;
        const y = f === "y" ? "width" : "height", w = Wh.has(In(r)), R = i.reference[d] - i.floating[y] + (w && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (w ? 0 : b.crossAxis), S = i.reference[d] + i.reference[y] + (w ? 0 : ((C = s.offset) == null ? void 0 : C[d]) || 0) - (w ? b.crossAxis : 0);
        m < R ? m = R : m > S && (m = S);
      }
      return {
        [f]: p,
        [d]: m
      };
    }
  };
}, x6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: l
      } = e, {
        apply: a = () => {
        },
        ...c
      } = Vo(t, e), u = await s.detectOverflow(e, c), d = In(r), f = or(r), p = zn(r) === "y", {
        width: m,
        height: h
      } = i.floating;
      let b, v;
      d === "top" || d === "bottom" ? (b = d, v = f === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (v = d, b = f === "end" ? "top" : "bottom");
      const C = h - u.top - u.bottom, y = m - u.left - u.right, w = ei(h - u[b], C), R = ei(m - u[v], y), S = !e.middlewareData.shift;
      let E = w, N = R;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (N = y), (o = e.middlewareData.shift) != null && o.enabled.y && (E = C), S && !f) {
        const M = Dn(u.left, 0), T = Dn(u.right, 0), k = Dn(u.top, 0), P = Dn(u.bottom, 0);
        p ? N = m - 2 * (M !== 0 || T !== 0 ? M + T : Dn(u.left, u.right)) : E = h - 2 * (k !== 0 || P !== 0 ? k + P : Dn(u.top, u.bottom));
      }
      await a({
        ...e,
        availableWidth: N,
        availableHeight: E
      });
      const I = await s.getDimensions(l.floating);
      return m !== I.width || h !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Uh(t) {
  const e = En(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = wt(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, l = Wl(n) !== i || Wl(o) !== s;
  return l && (n = i, o = s), {
    width: n,
    height: o,
    $: l
  };
}
function bd(t) {
  return mt(t) ? t : t.contextElement;
}
function jr(t) {
  const e = bd(t);
  if (!wt(e))
    return fo(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Uh(e);
  let s = (i ? Wl(n.width) : n.width) / o, l = (i ? Wl(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const C6 = /* @__PURE__ */ fo(0);
function Gh(t) {
  const e = St(t);
  return !ua() || !e.visualViewport ? C6 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function w6(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== St(t) ? !1 : e;
}
function yr(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = bd(t);
  let s = fo(1);
  e && (o ? mt(o) && (s = jr(o)) : s = jr(t));
  const l = w6(i, n, o) ? Gh(i) : fo(0);
  let a = (r.left + l.x) / s.x, c = (r.top + l.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (i) {
    const f = St(i), p = o && mt(o) ? St(o) : o;
    let m = f, h = ou(m);
    for (; h && o && p !== m; ) {
      const b = jr(h), v = h.getBoundingClientRect(), C = En(h), y = v.left + (h.clientLeft + parseFloat(C.paddingLeft)) * b.x, w = v.top + (h.clientTop + parseFloat(C.paddingTop)) * b.y;
      a *= b.x, c *= b.y, u *= b.x, d *= b.y, a += y, c += w, m = St(h), h = ou(m);
    }
  }
  return Qi({
    width: u,
    height: d,
    x: a,
    y: c
  });
}
function ya(t, e) {
  const n = da(t).scrollLeft;
  return e ? e.left + n : yr(xo(t)).left + n;
}
function Yh(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - ya(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function S6(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = xo(o), l = e ? ca(e.floating) : !1;
  if (o === s || l && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = fo(1);
  const u = fo(0), d = wt(o);
  if ((d || !d && !i) && ((xn(o) !== "body" || tr(s)) && (a = da(o)), d)) {
    const p = yr(o);
    c = jr(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const f = s && !d && !i ? Yh(s, a) : fo(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - a.scrollTop * c.y + u.y + f.y
  };
}
function R6(t) {
  return Array.from(t.getClientRects());
}
function E6(t) {
  const e = xo(t), n = da(t), o = t.ownerDocument.body, r = Dn(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = Dn(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + ya(t);
  const l = -n.scrollTop;
  return En(o).direction === "rtl" && (s += Dn(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
const vp = 25;
function N6(t, e) {
  const n = St(t), o = xo(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, l = 0, a = 0;
  if (r) {
    i = r.width, s = r.height;
    const u = ua();
    (!u || u && e === "fixed") && (l = r.offsetLeft, a = r.offsetTop);
  }
  const c = ya(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, f = getComputedStyle(d), p = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, m = Math.abs(o.clientWidth - d.clientWidth - p);
    m <= vp && (i -= m);
  } else c <= vp && (i += c);
  return {
    width: i,
    height: s,
    x: l,
    y: a
  };
}
function k6(t, e) {
  const n = yr(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = wt(t) ? jr(t) : fo(1), s = t.clientWidth * i.x, l = t.clientHeight * i.y, a = r * i.x, c = o * i.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function yp(t, e, n) {
  let o;
  if (e === "viewport")
    o = N6(t, n);
  else if (e === "document")
    o = E6(xo(t));
  else if (mt(e))
    o = k6(e, n);
  else {
    const r = Gh(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return Qi(o);
}
function jh(t, e) {
  const n = ho(t);
  return n === e || !mt(n) || uo(n) ? !1 : En(n).position === "fixed" || jh(n, e);
}
function I6(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = Ki(t, [], !1).filter((l) => mt(l) && xn(l) !== "body"), r = null;
  const i = En(t).position === "fixed";
  let s = i ? ho(t) : t;
  for (; mt(s) && !uo(s); ) {
    const l = En(s), a = zu(s);
    !a && l.position === "fixed" && (r = null), (i ? !a && !r : !a && l.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || tr(s) && !a && jh(t, s)) ? o = o.filter((u) => u !== s) : r = l, s = ho(s);
  }
  return e.set(t, o), o;
}
function P6(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? ca(e) ? [] : I6(e, this._c) : [].concat(n), o], l = yp(e, s[0], r);
  let a = l.top, c = l.right, u = l.bottom, d = l.left;
  for (let f = 1; f < s.length; f++) {
    const p = yp(e, s[f], r);
    a = Dn(p.top, a), c = ei(p.right, c), u = ei(p.bottom, u), d = Dn(p.left, d);
  }
  return {
    width: c - d,
    height: u - a,
    x: d,
    y: a
  };
}
function M6(t) {
  const {
    width: e,
    height: n
  } = Uh(t);
  return {
    width: e,
    height: n
  };
}
function T6(t, e, n) {
  const o = wt(e), r = xo(e), i = n === "fixed", s = yr(t, !0, i, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = fo(0);
  function c() {
    a.x = ya(r);
  }
  if (o || !o && !i)
    if ((xn(e) !== "body" || tr(r)) && (l = da(e)), o) {
      const p = yr(e, !0, i, e);
      a.x = p.x + e.clientLeft, a.y = p.y + e.clientTop;
    } else r && c();
  i && !o && r && c();
  const u = r && !o && !i ? Yh(r, l) : fo(0), d = s.left + l.scrollLeft - a.x - u.x, f = s.top + l.scrollTop - a.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function cc(t) {
  return En(t).position === "static";
}
function xp(t, e) {
  if (!wt(t) || En(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return xo(t) === n && (n = n.ownerDocument.body), n;
}
function Kh(t, e) {
  const n = St(t);
  if (ca(t))
    return n;
  if (!wt(t)) {
    let r = ho(t);
    for (; r && !uo(r); ) {
      if (mt(r) && !cc(r))
        return r;
      r = ho(r);
    }
    return n;
  }
  let o = xp(t, e);
  for (; o && D5(o) && cc(o); )
    o = xp(o, e);
  return o && uo(o) && cc(o) && !zu(o) ? n : o || A5(t) || n;
}
const O6 = async function(t) {
  const e = this.getOffsetParent || Kh, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: T6(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function D6(t) {
  return En(t).direction === "rtl";
}
const qh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: S6,
  getDocumentElement: xo,
  getClippingRect: P6,
  getOffsetParent: Kh,
  getElementRects: O6,
  getClientRects: R6,
  getDimensions: M6,
  getScale: jr,
  isElement: mt,
  isRTL: D6
};
function Zh(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function _6(t, e) {
  let n = null, o;
  const r = xo(t);
  function i() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (l || e(), !f || !p)
      return;
    const m = fr(d), h = fr(r.clientWidth - (u + f)), b = fr(r.clientHeight - (d + p)), v = fr(u), y = {
      rootMargin: -m + "px " + -h + "px " + -b + "px " + -v + "px",
      threshold: Dn(0, ei(1, a)) || 1
    };
    let w = !0;
    function R(S) {
      const E = S[0].intersectionRatio;
      if (E !== a) {
        if (!w)
          return s();
        E ? s(!1, E) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Zh(c, t.getBoundingClientRect()) && s(), w = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, y);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function Cp(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = bd(t), u = r || i ? [...c ? Ki(c) : [], ...e ? Ki(e) : []] : [];
  u.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && l ? _6(c, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((v) => {
    let [C] = v;
    C && C.target === c && p && e && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), n();
  }), c && !a && p.observe(c), e && p.observe(e));
  let m, h = a ? yr(t) : null;
  a && b();
  function b() {
    const v = yr(t);
    h && !Zh(h, v) && n(), h = v, m = requestAnimationFrame(b);
  }
  return n(), () => {
    var v;
    u.forEach((C) => {
      r && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), d?.(), (v = p) == null || v.disconnect(), p = null, a && cancelAnimationFrame(m);
  };
}
const V6 = b6, A6 = v6, L6 = m6, F6 = x6, $6 = g6, H6 = y6, z6 = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: qh,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return p6(t, e, {
    ...r,
    platform: i
  });
};
var B6 = typeof document < "u", W6 = function() {
}, Il = B6 ? go : W6;
function Gl(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Gl(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !Gl(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Xh(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wp(t, e) {
  const n = Xh(t);
  return Math.round(e * n) / n;
}
function uc(t) {
  const e = x.useRef(t);
  return Il(() => {
    e.current = t;
  }), e;
}
function U6(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = t, [u, d] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = x.useState(o);
  Gl(f, o) || p(o);
  const [m, h] = x.useState(null), [b, v] = x.useState(null), C = x.useCallback((A) => {
    A !== S.current && (S.current = A, h(A));
  }, []), y = x.useCallback((A) => {
    A !== E.current && (E.current = A, v(A));
  }, []), w = i || m, R = s || b, S = x.useRef(null), E = x.useRef(null), N = x.useRef(u), I = a != null, M = uc(a), T = uc(r), k = uc(c), P = x.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: f
    };
    T.current && (A.platform = T.current), z6(S.current, E.current, A).then((L) => {
      const $ = {
        ...L,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      D.current && !Gl(N.current, $) && (N.current = $, yn.flushSync(() => {
        d($);
      }));
    });
  }, [f, e, n, T, k]);
  Il(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const D = x.useRef(!1);
  Il(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Il(() => {
    if (w && (S.current = w), R && (E.current = R), w && R) {
      if (M.current)
        return M.current(w, R, P);
      P();
    }
  }, [w, R, P, M, I]);
  const O = x.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: C,
    setFloating: y
  }), [C, y]), V = x.useMemo(() => ({
    reference: w,
    floating: R
  }), [w, R]), _ = x.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return A;
    const L = wp(V.floating, u.x), $ = wp(V.floating, u.y);
    return l ? {
      ...A,
      transform: "translate(" + L + "px, " + $ + "px)",
      ...Xh(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: $
    };
  }, [n, l, V.floating, u.x, u.y]);
  return x.useMemo(() => ({
    ...u,
    update: P,
    refs: O,
    elements: V,
    floatingStyles: _
  }), [u, P, O, V, _]);
}
const G6 = (t, e) => {
  const n = V6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, Y6 = (t, e) => {
  const n = A6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, j6 = (t, e) => ({
  fn: H6(t).fn,
  options: [t, e]
}), K6 = (t, e) => {
  const n = L6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, q6 = (t, e) => {
  const n = F6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, Z6 = (t, e) => {
  const n = $6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, he = (t, e, n, o, r, i, ...s) => {
  if (s.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : st(1));
  let l;
  if (t && e)
    l = (a, c, u, d) => {
      const f = t(a, c, u, d);
      return e(f, c, u, d);
    };
  else if (t)
    l = t;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return l;
};
var X6 = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: r } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, Q6 = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: i, inputSelectorResultsCopy: s } = t, l = o(() => ({}), ...r);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, J6 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Yl = /* @__PURE__ */ Symbol("NOT_FOUND");
function e9(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function t9(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function n9(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var Sp = (t) => Array.isArray(t) ? t : [t];
function o9(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return n9(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function Rp(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var r9 = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...J6,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: X6
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: Q6
    }
  };
};
function i9(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : Yl;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function s9(t, e) {
  let n = [];
  function o(l) {
    const a = n.findIndex((c) => e(l, c.key));
    if (a > -1) {
      const c = n[a];
      return a > 0 && (n.splice(a, 1), n.unshift(c)), c.value;
    }
    return Yl;
  }
  function r(l, a) {
    o(l) === Yl && (n.unshift({ key: l, value: a }), n.length > t && n.pop());
  }
  function i() {
    return n;
  }
  function s() {
    n = [];
  }
  return { get: o, put: r, getEntries: i, clear: s };
}
var l9 = (t, e) => t === e;
function a9(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let i = 0; i < r; i++)
      if (!t(n[i], o[i]))
        return !1;
    return !0;
  };
}
function c9(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = l9,
    maxSize: r = 1,
    resultEqualityCheck: i
  } = n, s = a9(o);
  let l = 0;
  const a = r <= 1 ? i9(s) : s9(r, s);
  function c() {
    let u = a.get(arguments);
    if (u === Yl) {
      if (u = t.apply(null, arguments), l++, i) {
        const f = a.getEntries().find(
          (p) => i(p.value, u)
        );
        f && (u = f.value, l !== 0 && l--);
      }
      a.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    a.clear(), c.resetResultsCount();
  }, c.resultsCount = () => l, c.resetResultsCount = () => {
    l = 0;
  }, c;
}
var u9 = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, d9 = typeof WeakRef < "u" ? WeakRef : u9, f9 = 0, Ep = 1;
function Qs() {
  return {
    s: f9,
    v: void 0,
    o: null,
    p: null
  };
}
function Qh(t, e = {}) {
  let n = Qs();
  const { resultEqualityCheck: o } = e;
  let r, i = 0;
  function s() {
    let l = n;
    const { length: a } = arguments;
    for (let d = 0, f = a; d < f; d++) {
      const p = arguments[d];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let m = l.o;
        m === null && (l.o = m = /* @__PURE__ */ new WeakMap());
        const h = m.get(p);
        h === void 0 ? (l = Qs(), m.set(p, l)) : l = h;
      } else {
        let m = l.p;
        m === null && (l.p = m = /* @__PURE__ */ new Map());
        const h = m.get(p);
        h === void 0 ? (l = Qs(), m.set(p, l)) : l = h;
      }
    }
    const c = l;
    let u;
    if (l.s === Ep)
      u = l.v;
    else if (u = t.apply(null, arguments), i++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, i !== 0 && i--), r = typeof u == "object" && u !== null || typeof u == "function" ? new d9(u) : u;
    }
    return c.s = Ep, c.v = u, u;
  }
  return s.clearCache = () => {
    n = Qs(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function Jh(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let i = 0, s = 0, l, a = {}, c = r.pop();
    typeof c == "object" && (a = c, c = r.pop()), e9(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...a
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: p = Qh,
      argsMemoizeOptions: m = [],
      devModeChecks: h = {}
    } = u, b = Sp(f), v = Sp(m), C = o9(r), y = d(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...b);
    let w = !0;
    const R = p(function() {
      s++;
      const E = Rp(
        C,
        arguments
      );
      if (l = y.apply(null, E), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: N, inputStabilityCheck: I } = r9(w, h);
        if (N.shouldRun && N.run(
          c,
          E,
          l
        ), I.shouldRun) {
          const M = Rp(
            C,
            arguments
          );
          I.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: M },
            { memoize: d, memoizeOptions: b },
            arguments
          );
        }
        w && (w = !1);
      }
      return l;
    }, ...v);
    return Object.assign(R, {
      resultFunc: c,
      memoizedResultFunc: y,
      dependencies: C,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: p
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var p9 = /* @__PURE__ */ Jh(Qh), m9 = Object.assign(
  (t, e = p9) => {
    t9(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (i) => t[i]
    );
    return e(
      o,
      (...i) => i.reduce((s, l, a) => (s[n[a]] = l, s), {})
    );
  },
  { withTypes: () => m9 }
);
const g9 = Jh({
  memoize: c9,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), h9 = (...t) => {
  const e = /* @__PURE__ */ new WeakMap();
  let n = 1;
  const o = t[t.length - 1], r = t.length - 1 || 1, i = o.length - r;
  if (i > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : st(2));
  return (l, a, c, u) => {
    let d = l.__cacheKey__;
    d || (d = {
      id: n
    }, l.__cacheKey__ = d, n += 1);
    let f = e.get(d);
    if (!f) {
      let p = t;
      const m = [void 0, void 0, void 0];
      switch (i) {
        case 0:
          break;
        case 1: {
          p = [...t.slice(0, -1), () => m[0], o];
          break;
        }
        case 2: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], o];
          break;
        }
        case 3: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], () => m[2], o];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : st(2));
      }
      f = g9(...p), f.selectorArgs = m, e.set(d, f);
    }
    switch (f.selectorArgs[0] = a, f.selectorArgs[1] = c, f.selectorArgs[2] = u, i) {
      case 0:
        return f(l);
      case 1:
        return f(l, a);
      case 2:
        return f(l, a, c);
      case 3:
        return f(l, a, c, u);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var Js = { exports: {} }, dc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Np;
function b9() {
  if (Np) return dc;
  Np = 1;
  var t = We;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function l(d, f) {
    var p = f(), m = o({ inst: { value: p, getSnapshot: f } }), h = m[0].inst, b = m[1];
    return i(
      function() {
        h.value = p, h.getSnapshot = f, a(h) && b({ inst: h });
      },
      [d, p, f]
    ), r(
      function() {
        return a(h) && b({ inst: h }), d(function() {
          a(h) && b({ inst: h });
        });
      },
      [d]
    ), s(p), p;
  }
  function a(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return dc.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, dc;
}
var fc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kp;
function v9() {
  return kp || (kp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(p, m) {
      return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    function e(p, m) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = m();
      if (!d) {
        var b = m();
        i(h, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      b = s({
        inst: { value: h, getSnapshot: m }
      });
      var v = b[0].inst, C = b[1];
      return a(
        function() {
          v.value = h, v.getSnapshot = m, n(v) && C({ inst: v });
        },
        [p, h, m]
      ), l(
        function() {
          return n(v) && C({ inst: v }), p(function() {
            n(v) && C({ inst: v });
          });
        },
        [p]
      ), c(h), h;
    }
    function n(p) {
      var m = p.getSnapshot;
      p = p.value;
      try {
        var h = m();
        return !i(p, h);
      } catch {
        return !0;
      }
    }
    function o(p, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = We, i = typeof Object.is == "function" ? Object.is : t, s = r.useState, l = r.useEffect, a = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    fc.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), fc;
}
var Ip;
function vd() {
  return Ip || (Ip = 1, process.env.NODE_ENV === "production" ? Js.exports = b9() : Js.exports = v9()), Js.exports;
}
var yd = vd(), el = { exports: {} }, pc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pp;
function y9() {
  if (Pp) return pc;
  Pp = 1;
  var t = We, e = vd();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return pc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var m = i(null);
    if (m.current === null) {
      var h = { hasValue: !1, value: null };
      m.current = h;
    } else h = m.current;
    m = l(
      function() {
        function v(S) {
          if (!C) {
            if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
              var E = h.value;
              if (p(E, S))
                return w = E;
            }
            return w = S;
          }
          if (E = w, o(y, S)) return E;
          var N = f(S);
          return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
        }
        var C = !1, y, w, R = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          R === null ? void 0 : function() {
            return v(R());
          }
        ];
      },
      [u, d, f, p]
    );
    var b = r(c, m[0], m[1]);
    return s(
      function() {
        h.hasValue = !0, h.value = b;
      },
      [b]
    ), a(b), b;
  }, pc;
}
var mc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mp;
function x9() {
  return Mp || (Mp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = We, n = vd(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, i = e.useRef, s = e.useEffect, l = e.useMemo, a = e.useDebugValue;
    mc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var m = i(null);
      if (m.current === null) {
        var h = { hasValue: !1, value: null };
        m.current = h;
      } else h = m.current;
      m = l(
        function() {
          function v(S) {
            if (!C) {
              if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
                var E = h.value;
                if (p(E, S))
                  return w = E;
              }
              return w = S;
            }
            if (E = w, o(y, S))
              return E;
            var N = f(S);
            return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
          }
          var C = !1, y, w, R = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            R === null ? void 0 : function() {
              return v(R());
            }
          ];
        },
        [u, d, f, p]
      );
      var b = r(c, m[0], m[1]);
      return s(
        function() {
          h.hasValue = !0, h.value = b;
        },
        [b]
      ), a(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), mc;
}
var Tp;
function C9() {
  return Tp || (Tp = 1, process.env.NODE_ENV === "production" ? el.exports = y9() : el.exports = x9()), el.exports;
}
var w9 = C9();
const gu = [];
let hu;
function S9() {
  return hu;
}
function R9(t) {
  gu.push(t);
}
function xd(t) {
  const e = (n, o) => {
    const r = Lt(E9).current;
    let i;
    try {
      hu = r;
      for (const s of gu)
        s.before(r);
      i = t(n, o);
      for (const s of gu)
        s.after(r);
      r.didInitialize = !0;
    } finally {
      hu = void 0;
    }
    return i;
  };
  return e.displayName = t.displayName || t.name, e;
}
function e2(t) {
  return /* @__PURE__ */ x.forwardRef(xd(t));
}
function E9() {
  return {
    didInitialize: !1
  };
}
const N9 = Vu(19), k9 = N9 ? P9 : M9;
function ve(t, e, n, o, r) {
  return k9(t, e, n, o, r);
}
function I9(t, e, n, o, r) {
  const i = x.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return yd.useSyncExternalStore(t.subscribe, i, i);
}
R9({
  before(t) {
    t.syncIndex = 0, t.didInitialize || (t.syncTick = 1, t.syncHooks = [], t.didChangeStore = !0, t.getSnapshot = () => {
      let e = !1;
      for (let n = 0; n < t.syncHooks.length; n += 1) {
        const o = t.syncHooks[n], r = o.selector(o.store.state, o.a1, o.a2, o.a3);
        (o.didChange || !Object.is(o.value, r)) && (e = !0, o.value = r, o.didChange = !1);
      }
      return e && (t.syncTick += 1), t.syncTick;
    });
  },
  after(t) {
    t.syncHooks.length > 0 && (t.didChangeStore && (t.didChangeStore = !1, t.subscribe = (e) => {
      const n = /* @__PURE__ */ new Set();
      for (const r of t.syncHooks)
        n.add(r.store);
      const o = [];
      for (const r of n)
        o.push(r.subscribe(e));
      return () => {
        for (const r of o)
          r();
      };
    }), yd.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot));
  }
});
function P9(t, e, n, o, r) {
  const i = S9();
  if (!i)
    return I9(t, e, n, o, r);
  const s = i.syncIndex;
  i.syncIndex += 1;
  let l;
  return i.didInitialize ? (l = i.syncHooks[s], (l.store !== t || l.selector !== e || !Object.is(l.a1, n) || !Object.is(l.a2, o) || !Object.is(l.a3, r)) && (l.store !== t && (i.didChangeStore = !0), l.store = t, l.selector = e, l.a1 = n, l.a2 = o, l.a3 = r, l.didChange = !0)) : (l = {
    store: t,
    selector: e,
    a1: n,
    a2: o,
    a3: r,
    value: e(t.getSnapshot(), n, o, r),
    didChange: !1
  }, i.syncHooks.push(l)), l.value;
}
function M9(t, e, n, o, r) {
  return w9.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (i) => e(i, n, o, r));
}
class Cd {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (e) => (this.listeners.add(e), () => {
    this.listeners.delete(e);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        this.setState({
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || this.setState({
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    this.setState(e);
  }
  use(e, n, o, r) {
    return ve(this, e, n, o, r);
  }
}
class Ir extends Cd {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(e, n = {}, o) {
    super(e), this.context = n, this.selectors = o;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(e, n) {
    x.useDebugValue(e), ke(() => {
      this.state[e] !== n && this.set(e, n);
    }, [e, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(e, n) {
    const o = this;
    ke(() => (o.state[e] !== n && o.set(e, n), () => {
      o.set(e, void 0);
    }), [o, e, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(e) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      x.useDebugValue(e, (s) => Object.keys(s));
      const r = x.useRef(Object.keys(e)).current, i = Object.keys(e);
      (r.length !== i.length || r.some((s, l) => s !== i[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(e);
    ke(() => {
      n.update(e);
    }, [n, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(e, n) {
    x.useDebugValue(e);
    const o = n !== void 0;
    if (ke(() => {
      o && !Object.is(this.state[e], n) && super.setState({
        ...this.state,
        [e]: n
      });
    }, [e, n, o]), process.env.NODE_ENV !== "production") {
      const r = this.controlledValues ??= /* @__PURE__ */ new Map();
      r.has(e) || r.set(e, o);
      const i = r.get(e);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${e.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(e, n, o, r) {
    const i = this.selectors[e];
    return i(this.state, n, o, r);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(e, n, o, r) {
    return x.useDebugValue(e), ve(this, this.selectors[e], n, o, r);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(e, n) {
    x.useDebugValue(e);
    const o = we(n ?? Ct);
    this.context[e] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(e) {
    const n = x.useRef(void 0);
    return n.current === void 0 && (n.current = (o) => {
      this.set(e, o);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(e, n) {
    let o;
    typeof e == "function" ? o = e : o = this.selectors[e];
    let r = o(this.state);
    return n(r, r, this), this.subscribe((i) => {
      const s = o(i);
      if (!Object.is(r, s)) {
        const l = r;
        r = s, n(s, l, this);
      }
    });
  }
}
const T9 = {
  open: he((t) => t.open),
  transitionStatus: he((t) => t.transitionStatus),
  domReferenceElement: he((t) => t.domReferenceElement),
  referenceElement: he((t) => t.positionReference ?? t.referenceElement),
  floatingElement: he((t) => t.floatingElement),
  floatingId: he((t) => t.floatingId)
};
class wd extends Ir {
  constructor(e) {
    const {
      syncOnly: n,
      nested: o,
      onOpenChange: r,
      triggerElements: i,
      ...s
    } = e;
    super({
      ...s,
      positionReference: s.referenceElement,
      domReferenceElement: s.referenceElement
    }, {
      onOpenChange: r,
      dataRef: {
        current: {}
      },
      events: Bh(),
      nested: o,
      triggerElements: i
    }, T9), this.syncOnly = n;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (e, n) => {
    (!e || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    n != null && gh(n)) && (this.context.dataRef.current.openEvent = e ? n : void 0);
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (e, n) => {
    this.syncOpenEvent(e, n.event);
    const o = {
      open: e,
      reason: n.reason,
      nativeEvent: n.event,
      nested: this.context.nested,
      triggerElement: n.trigger
    };
    this.context.events.emit("openchange", o);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (e, n) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e, n);
      return;
    }
    this.dispatchOpenChange(e, n), this.context.onOpenChange?.(e, n);
  };
}
function t2(t, e) {
  const n = x.useRef(null), o = x.useRef(null);
  return x.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const i = n.current, s = o.current, l = e.context.triggerElements.getById(i);
        s && l === s && e.context.triggerElements.delete(i), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function ms(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), i = t2(t, n), s = we((l) => {
    if (i(l), !l || !n.select("open"))
      return;
    const a = n.select("activeTriggerId");
    if (a === t) {
      n.update({
        activeTriggerElement: l,
        ...o
      });
      return;
    }
    a == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: l,
      ...o
    });
  });
  return ke(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: s,
    isMountedByThisTrigger: r
  };
}
function gs(t) {
  const e = t.useState("open");
  ke(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function hs(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: i
  } = to(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: i
  });
  const s = we(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), l = e.useState("preventUnmountingOnClose");
  return Jt({
    enabled: !l,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || s();
    }
  }), {
    forceUnmount: s,
    transitionStatus: i
  };
}
class Pr {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elementsSet.delete(o), this.elementsSet.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elementsSet.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elementsSet.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elementsSet)
      if (e(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(e) {
    return this.idMap.get(e);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function O9() {
  return new wd({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new Pr(),
    floatingId: "",
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function bs() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: O9(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: Et,
    inactiveTriggerProps: Et,
    popupProps: Et
  };
}
const tl = he((t) => t.triggerIdProp ?? t.activeTriggerId), vs = {
  open: he((t) => t.openProp ?? t.open),
  mounted: he((t) => t.mounted),
  transitionStatus: he((t) => t.transitionStatus),
  floatingRootContext: he((t) => t.floatingRootContext),
  preventUnmountingOnClose: he((t) => t.preventUnmountingOnClose),
  payload: he((t) => t.payload),
  activeTriggerId: tl,
  activeTriggerElement: he((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: he((t, e) => e !== void 0 && tl(t) === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: he((t, e) => e !== void 0 && tl(t) === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: he((t, e) => e !== void 0 && tl(t) === e && t.mounted),
  triggerProps: he((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: he((t) => t.popupProps),
  popupElement: he((t) => t.popupElement),
  positionerElement: he((t) => t.positionerElement)
};
function Sd(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = Lo(), i = Co() != null;
  if (process.env.NODE_ENV !== "production") {
    const l = o.reference;
    l && !mt(l) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const s = Lt(() => new wd({
    open: e,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: new Pr(),
    floatingId: r,
    syncOnly: !1,
    nested: i
  })).current;
  return ke(() => {
    const l = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (l.referenceElement = o.reference, l.domReferenceElement = mt(o.reference) ? o.reference : null), o.floating !== void 0 && (l.floatingElement = o.floating), s.update(l);
  }, [e, r, o.reference, o.floating, s]), s.context.onOpenChange = n, s.context.nested = i, s;
}
function D9(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = Sd(t), r = t.rootContext || o, i = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [s, l] = x.useState(null), a = x.useRef(null), c = rr(n);
  ke(() => {
    i.domReference && (a.current = i.domReference);
  }, [i.domReference]);
  const u = U6({
    ...t,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), d = x.useCallback((N) => {
    const I = mt(N) ? {
      getBoundingClientRect: () => N.getBoundingClientRect(),
      getClientRects: () => N.getClientRects(),
      contextElement: N
    } : N;
    l(I), u.refs.setReference(I);
  }, [u.refs]), [f, p] = x.useState(void 0), [m, h] = x.useState(null);
  r.useSyncedValue("referenceElement", f ?? null);
  const b = mt(f) ? f : null;
  r.useSyncedValue("domReferenceElement", f === void 0 ? i.domReference : b), r.useSyncedValue("floatingElement", m);
  const v = x.useCallback((N) => {
    (mt(N) || N === null) && (a.current = N, p(N)), (mt(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    N !== null && !mt(N)) && u.refs.setReference(N);
  }, [u.refs, p]), C = x.useCallback((N) => {
    h(N), u.refs.setFloating(N);
  }, [u.refs]), y = x.useMemo(() => ({
    ...u.refs,
    setReference: v,
    setFloating: C,
    setPositionReference: d,
    domReference: a
  }), [u.refs, v, C, d]), w = x.useMemo(() => ({
    ...u.elements,
    domReference: i.domReference
  }), [u.elements, i.domReference]), R = r.useState("open"), S = r.useState("floatingId"), E = x.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: R,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: y,
    elements: w,
    nodeId: e,
    rootStore: r
  }), [u, y, w, e, r, R, S]);
  return ke(() => {
    r.context.dataRef.current.floatingContext = E;
    const N = c?.nodesRef.current.find((I) => I.id === e);
    N && (N.context = E);
  }), x.useMemo(() => ({
    ...u,
    context: E,
    refs: y,
    elements: w,
    rootStore: r
  }), [u, y, w, E, r]);
}
function ys(t) {
  const {
    popupStore: e,
    treatPopupAsFloatingElement: n = !1,
    onOpenChange: o
  } = t, r = Lo(), i = Co() != null, s = e.useState("open"), l = e.useState("activeTriggerElement"), a = e.useState(n ? "popupElement" : "positionerElement"), c = e.context.triggerElements, u = Lt(() => new wd({
    open: s,
    transitionStatus: void 0,
    referenceElement: l,
    floatingElement: a,
    triggerElements: c,
    onOpenChange: o,
    floatingId: r,
    syncOnly: !0,
    nested: i
  })).current;
  return ke(() => {
    const d = {
      open: s,
      floatingId: r,
      referenceElement: l,
      floatingElement: a
    };
    mt(l) && (d.domReferenceElement = l), u.state.positionReference === u.state.referenceElement && (d.positionReference = l), u.update(d);
  }, [s, r, l, a, u]), u.context.onOpenChange = o, u.context.nested = i, u;
}
const gc = ch && ah;
function Rd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: i = !0,
    delay: s
  } = e, l = x.useRef(!1), a = x.useRef(null), c = Bt(), u = x.useRef(!0);
  x.useEffect(() => {
    const f = n.select("domReferenceElement");
    if (!i)
      return;
    const p = St(f);
    function m() {
      const v = n.select("domReferenceElement");
      !n.select("open") && wt(v) && v === Xt(nt(v)) && (l.current = !0);
    }
    function h() {
      u.current = !0;
    }
    function b() {
      u.current = !1;
    }
    return Xn(dt(p, "blur", m), gc && dt(p, "keydown", h, !0), gc && dt(p, "pointerdown", b, !0));
  }, [n, i]), x.useEffect(() => {
    if (!i)
      return;
    function f(p) {
      if (p.reason === eo || p.reason === Rr) {
        const m = n.select("domReferenceElement");
        mt(m) && (a.current = m, l.current = !0);
      }
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, i, n]);
  const d = x.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, a.current = null;
    },
    onFocus(f) {
      const p = f.currentTarget;
      if (l.current) {
        if (a.current === p)
          return;
        l.current = !1, a.current = null;
      }
      const m = yt(f.nativeEvent);
      if (mt(m)) {
        if (gc && !f.relatedTarget) {
          if (!u.current && !ga(m))
            return;
        } else if (!Bl(m))
          return;
      }
      const h = zl(f.relatedTarget, n.context.triggerElements), {
        nativeEvent: b,
        currentTarget: v
      } = f, C = typeof s == "function" ? s() : s;
      if (n.select("open") && h || C === 0 || C === void 0) {
        n.setOpen(!0, De(gr, b, v));
        return;
      }
      c.start(C, () => {
        l.current || n.setOpen(!0, De(gr, b, v));
      });
    },
    onBlur(f) {
      l.current = !1, a.current = null;
      const p = f.relatedTarget, m = f.nativeEvent, h = mt(p) && p.hasAttribute(es("focus-guard")) && p.getAttribute("data-type") === "outside";
      c.start(0, () => {
        const b = n.select("domReferenceElement"), v = Xt(nt(b));
        !p && v === b || Fe(r.current.floatingContext?.refs.floating.current, v) || Fe(b, v) || h || zl(p ?? v, n.context.triggerElements) || n.setOpen(!1, De(gr, m));
      });
    }
  }), [r, n, c, s]);
  return x.useMemo(() => i ? {
    reference: d,
    trigger: d
  } : {}, [i, d]);
}
class Ed {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new Pn(), this.restTimeout = new Pn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new Ed();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
const jl = /* @__PURE__ */ new WeakMap();
function Kl(t) {
  if (!t.performedPointerEventsMutation)
    return;
  const e = t.pointerEventsScopeElement;
  e && jl.get(e) === t && (t.pointerEventsScopeElement?.style.removeProperty("pointer-events"), t.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), t.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), jl.delete(e)), t.performedPointerEventsMutation = !1, t.pointerEventsScopeElement = null, t.pointerEventsReferenceElement = null, t.pointerEventsFloatingElement = null;
}
function n2(t, e) {
  const {
    scopeElement: n,
    referenceElement: o,
    floatingElement: r
  } = e, i = jl.get(n);
  i && i !== t && Kl(i), Kl(t), t.performedPointerEventsMutation = !0, t.pointerEventsScopeElement = n, t.pointerEventsReferenceElement = o, t.pointerEventsFloatingElement = r, jl.set(n, t), n.style.pointerEvents = "none", o.style.pointerEvents = "auto", r.style.pointerEvents = "auto";
}
function o2(t) {
  const e = Lt(Ed.create).current, n = t.context.dataRef.current;
  return n.hoverInteractionState || (n.hoverInteractionState = e), oi(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
function xa(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), {
    dataRef: s
  } = n.context, {
    enabled: l = !0,
    closeDelay: a = 0,
    nodeId: c
  } = e, u = o2(n), d = rr(), f = Co(), p = we(() => hh(s.current.openEvent?.type, u.interactedInside)), m = we(() => {
    const w = s.current.openEvent?.type;
    return w?.includes("mouse") && w !== "mousedown";
  }), h = we((w) => zl(w, n.context.triggerElements)), b = x.useCallback((w) => {
    const R = Hl(a, "close", u.pointerType), S = () => {
      n.setOpen(!1, De(Ut, w)), d?.events.emit("floating.closed", w);
    };
    R ? u.openChangeTimeout.start(R, S) : (u.openChangeTimeout.clear(), S());
  }, [a, n, u, d]), v = we(() => {
    Kl(u);
  }), C = we((w) => {
    const R = yt(w);
    if (!Ch(R)) {
      u.interactedInside = !1;
      return;
    }
    u.interactedInside = R?.closest("[aria-haspopup]") != null;
  });
  ke(() => {
    o || (u.pointerType = void 0, u.restTimeoutPending = !1, u.interactedInside = !1, v());
  }, [o, u, v]), x.useEffect(() => v, [v]), ke(() => {
    if (l && o && u.handleCloseOptions?.blockPointerEvents && m() && mt(i) && r) {
      const w = i, R = r, S = nt(r), E = d?.nodesRef.current.find((I) => I.id === f)?.context?.elements.floating;
      E && (E.style.pointerEvents = "");
      const N = u.handleCloseOptions?.getScope?.() ?? u.pointerEventsScopeElement ?? E ?? w.closest("[data-rootownerid]") ?? S.body;
      return n2(u, {
        scopeElement: N,
        referenceElement: w,
        floatingElement: R
      }), () => {
        v();
      };
    }
  }, [l, o, i, r, u, m, d, f, v]);
  const y = Bt();
  x.useEffect(() => {
    if (!l)
      return;
    function w() {
      u.openChangeTimeout.clear(), y.clear(), d?.events.off("floating.closed", S), v();
    }
    function R(N) {
      if (d && f && po(d.nodesRef.current, f).length > 0) {
        d.events.on("floating.closed", S);
        return;
      }
      if (h(N.relatedTarget))
        return;
      const I = s.current.floatingContext?.nodeId ?? c, M = N.relatedTarget;
      if (!(d && I && mt(M) && po(d.nodesRef.current, I, !1).some((k) => Fe(k.context?.elements.floating, M)))) {
        if (u.handler) {
          u.handler(N);
          return;
        }
        v(), p() || b(N);
      }
    }
    function S(N) {
      !d || !f || po(d.nodesRef.current, f).length > 0 || y.start(0, () => {
        d.events.off("floating.closed", S), n.setOpen(!1, De(Ut, N)), d.events.emit("floating.closed", N);
      });
    }
    const E = r;
    return Xn(E && dt(E, "mouseenter", w), E && dt(E, "mouseleave", R), E && dt(E, "pointerdown", C, !0), () => {
      d?.events.off("floating.closed", S);
    });
  }, [l, r, n, s, c, p, h, b, v, C, u, d, f, y]);
}
const _9 = {
  current: null
};
function xs(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: i = !0,
    delay: s = 0,
    handleClose: l = null,
    mouseOnly: a = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = _9,
    externalTree: f,
    isActiveTrigger: p = !0,
    getHandleCloseContext: m,
    isClosing: h
  } = e, b = rr(f), v = o2(n), C = x.useRef(!1), y = Yt(l), w = Yt(s), R = Yt(c), S = Yt(i), E = Yt(h);
  p && (v.handleCloseOptions = y.current?.__options);
  const N = we(() => hh(o.current.openEvent?.type, v.interactedInside)), I = we((D) => zl(D, n.context.triggerElements)), M = we((D, O, V) => {
    const _ = n.context.triggerElements;
    if (_.hasElement(O))
      return !D || !Fe(D, O);
    if (!mt(V))
      return !1;
    const A = V;
    return _.hasMatchingElement((L) => Fe(L, A)) && (!D || !Fe(D, A));
  }), T = we((D, O = !0) => {
    const V = Hl(w.current, "close", v.pointerType);
    V ? v.openChangeTimeout.start(V, () => {
      n.setOpen(!1, De(Ut, D)), b?.events.emit("floating.closed", D);
    }) : O && (v.openChangeTimeout.clear(), n.setOpen(!1, De(Ut, D)), b?.events.emit("floating.closed", D));
  }), k = we(() => {
    if (!v.handler)
      return;
    nt(n.select("domReferenceElement")).removeEventListener("mousemove", v.handler), v.handler = void 0;
  }), P = we(() => {
    Kl(v);
  });
  return x.useEffect(() => k, [k]), x.useEffect(() => {
    if (!i)
      return;
    function D(O) {
      O.open ? C.current = !1 : (C.current = O.reason === Ut, k(), v.openChangeTimeout.clear(), v.restTimeout.clear(), v.blockMouseMove = !0, v.restTimeoutPending = !1);
    }
    return r.on("openchange", D), () => {
      r.off("openchange", D);
    };
  }, [i, r, v, k]), x.useEffect(() => {
    if (!i)
      return;
    const D = d.current ?? (p ? n.select("domReferenceElement") : null);
    if (!mt(D))
      return;
    function O(_) {
      if (v.openChangeTimeout.clear(), v.blockMouseMove = !1, a && !Jr(v.pointerType))
        return;
      const A = op(R.current), L = Hl(w.current, "open", v.pointerType), $ = yt(_), B = _.currentTarget ?? null, z = n.select("domReferenceElement");
      let H = B;
      if (mt($) && !n.context.triggerElements.hasElement($)) {
        for (const J of n.context.triggerElements.elements())
          if (Fe(J, $)) {
            H = J;
            break;
          }
      }
      mt(B) && mt(z) && !n.context.triggerElements.hasElement(B) && Fe(B, z) && (H = z);
      const K = H == null ? !1 : M(z, H, $), G = n.select("open"), q = E.current?.() ?? n.select("transitionStatus") === "ending", Q = !G && q && C.current, U = !K && mt(H) && mt(z) && Fe(z, H) && Q, X = A > 0 && !L, te = K && (G || Q) || U, re = !G || K;
      if (te) {
        n.setOpen(!0, De(Ut, _, H));
        return;
      }
      X || (L ? v.openChangeTimeout.start(L, () => {
        re && n.setOpen(!0, De(Ut, _, H));
      }) : re && n.setOpen(!0, De(Ut, _, H)));
    }
    function V(_) {
      if (N()) {
        P();
        return;
      }
      k();
      const A = n.select("domReferenceElement"), L = nt(A);
      v.restTimeout.clear(), v.restTimeoutPending = !1;
      const $ = o.current.floatingContext ?? m?.();
      if (I(_.relatedTarget))
        return;
      if (y.current && $) {
        n.select("open") || v.openChangeTimeout.clear();
        const H = d.current;
        v.handler = y.current({
          ...$,
          tree: b,
          x: _.clientX,
          y: _.clientY,
          onClose() {
            P(), k(), S.current && !N() && H === n.select("domReferenceElement") && T(_, !0);
          }
        }), L.addEventListener("mousemove", v.handler), v.handler(_);
        return;
      }
      (v.pointerType !== "touch" || !Fe(n.select("floatingElement"), _.relatedTarget)) && T(_);
    }
    return u ? Xn(dt(D, "mousemove", O, {
      once: !0
    }), dt(D, "mouseenter", O), dt(D, "mouseleave", V)) : Xn(dt(D, "mouseenter", O), dt(D, "mouseleave", V));
  }, [k, P, o, w, T, n, i, y, v, p, M, N, I, a, u, R, d, b, S, m, E]), x.useMemo(() => {
    if (!i)
      return;
    function D(O) {
      v.pointerType = O.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(O) {
        const {
          nativeEvent: V
        } = O, _ = O.currentTarget, A = n.select("domReferenceElement"), L = n.select("open"), $ = M(A, _, O.target);
        if (a && !Jr(v.pointerType))
          return;
        if (L && $ && v.handleCloseOptions?.blockPointerEvents) {
          const H = n.select("floatingElement");
          if (H) {
            const K = v.handleCloseOptions?.getScope?.() ?? _.ownerDocument.body;
            n2(v, {
              scopeElement: K,
              referenceElement: _,
              floatingElement: H
            });
          }
        }
        const B = op(R.current);
        if (L && !$ || B === 0 || !$ && v.restTimeoutPending && O.movementX ** 2 + O.movementY ** 2 < 2)
          return;
        v.restTimeout.clear();
        function z() {
          if (v.restTimeoutPending = !1, N())
            return;
          const H = n.select("open");
          !v.blockMouseMove && (!H || $) && n.setOpen(!0, De(Ut, V, _));
        }
        v.pointerType === "touch" ? yn.flushSync(() => {
          z();
        }) : $ && L ? z() : (v.restTimeoutPending = !0, v.restTimeout.start(B, z));
      }
    };
  }, [i, v, N, M, a, n, R]);
}
function ro(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), i = x.useCallback(
    (c) => nl(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), s = x.useCallback(
    (c) => nl(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = x.useCallback(
    (c) => nl(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), a = x.useCallback(
    (c) => nl(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return x.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: s,
    getItemProps: l,
    getTriggerProps: a
  }), [i, s, l, a]);
}
function nl(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", i = {};
  n === "floating" && (i.tabIndex = -1, i[au] = "");
  for (const s in t)
    r && t && (s === vh || s === yh) || (i[s] = t[s]);
  for (let s = 0; s < e.length; s += 1) {
    let l;
    const a = e[s]?.[n];
    typeof a == "function" ? l = t ? a(t) : null : l = a, l && Op(i, l, r, o);
  }
  return Op(i, t, r, o), i;
}
function Op(t, e, n, o) {
  for (const r in e) {
    const i = e[r];
    n && (r === vh || r === yh) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof i == "function" && (o.get(r)?.push(i), t[r] = (...s) => o.get(r)?.map((l) => l(...s)).find((l) => l !== void 0))) : t[r] = i);
  }
}
const V9 = "Escape";
function Ca(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function ol(t, e) {
  return Ca(e, t === nd || t === fs, t === jo || t === Ko);
}
function hc(t, e, n) {
  return Ca(e, t === fs, n ? t === jo : t === Ko) || t === "Enter" || t === " " || t === "";
}
function A9(t, e, n) {
  return Ca(e, n ? t === jo : t === Ko, t === fs);
}
function L9(t, e, n, o) {
  const r = n ? t === Ko : t === jo, i = t === nd;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === V9 : Ca(e, r, i);
}
function Nd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    listRef: l,
    activeIndex: a,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: p = !1,
    nested: m = !1,
    rtl: h = !1,
    virtual: b = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: C = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: w = void 0,
    orientation: R = "vertical",
    parentOrientation: S,
    cols: E = 1,
    id: N,
    resetOnPointerLeave: I = !0,
    externalTree: M
  } = e;
  process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), b || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && E > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const T = Xi(r), k = Yt(T), P = Co(), D = rr(M);
  ke(() => {
    s.current.orientation = R;
  }, [s, R]);
  const O = cu(i), V = x.useRef(v), _ = x.useRef(d ?? -1), A = x.useRef(null), L = x.useRef(!0), $ = we((j) => {
    c(_.current === -1 ? null : _.current, j);
  }), B = x.useRef($), z = x.useRef(!!r), H = x.useRef(o), K = x.useRef(!1), G = x.useRef(!1), q = x.useRef(null), Q = Yt(w), U = Yt(o), X = Yt(d), te = Yt(I), re = we(() => {
    function j(ue) {
      b ? D?.events.emit("virtualfocus", ue) : q.current = kl(ue, {
        sync: K.current,
        preventScroll: !0
      });
    }
    const ee = l.current[_.current], Y = G.current;
    ee && j(ee), (K.current ? (ue) => ue() : requestAnimationFrame)(() => {
      const ue = l.current[_.current] || ee;
      if (!ue)
        return;
      ee || j(ue), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      ce && (Y || !L.current) && ue.scrollIntoView?.({
        block: "nearest",
        inline: "nearest"
      });
    });
  });
  ke(() => {
    u && (o && r ? (_.current = d ?? -1, V.current && d != null && (G.current = !0, $())) : z.current && (_.current = -1, B.current()));
  }, [u, o, r, d, $]), ke(() => {
    if (u) {
      if (!o) {
        K.current = !1;
        return;
      }
      if (r)
        if (a == null) {
          if (K.current = !1, X.current != null)
            return;
          if (z.current && (_.current = -1, re()), (!H.current || !z.current) && V.current && (A.current != null || V.current === !0 && A.current == null)) {
            let j = 0;
            const ee = () => {
              l.current[0] == null ? (j < 2 && (j ? requestAnimationFrame : queueMicrotask)(ee), j += 1) : (_.current = A.current == null || hc(A.current, R, h) || m ? Nl(l) : fu(l), A.current = null, $());
            };
            ee();
          }
        } else Ji(l.current, a) || (_.current = a, re(), G.current = !1);
    }
  }, [u, o, r, a, X, m, l, R, h, $, re, Q]), ke(() => {
    if (!u || r || !D || b || !z.current)
      return;
    const j = D.nodesRef.current, ee = j.find((ue) => ue.id === P)?.context?.elements.floating, Y = Xt(nt(r)), Z = j.some((ue) => ue.context && Fe(ue.context.elements.floating, Y));
    ee && !Z && L.current && ee.focus({
      preventScroll: !0
    });
  }, [u, r, D, P, b]), ke(() => {
    B.current = $, H.current = o, z.current = !!r;
  }), ke(() => {
    o || (A.current = null, V.current = v);
  }, [o, v]);
  const J = a != null, ie = we((j) => {
    if (!U.current)
      return;
    const ee = l.current.indexOf(j.currentTarget);
    ee !== -1 && (_.current !== ee || a !== ee) && (_.current = ee, $(j));
  }), ce = x.useMemo(() => ({
    onFocus(ee) {
      K.current = !0, ie(ee);
    },
    onClick: ({
      currentTarget: ee
    }) => ee.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(ee) {
      K.current = !0, G.current = !1, C && ie(ee);
    },
    onPointerLeave(ee) {
      if (!U.current || !L.current || ee.pointerType === "touch")
        return;
      K.current = !0;
      const Y = ee.relatedTarget;
      if (!(!C || l.current.includes(Y)) && te.current && (q.current?.(), q.current = null, _.current = -1, $(ee), !b)) {
        const Z = k.current, ue = Xt(nt(Z));
        Z && Fe(Z, ue) && Z.focus({
          preventScroll: !0
        });
      }
    }
  }), [ie, U, k, C, l, $, te, b]), oe = x.useCallback(() => S ?? D?.nodesRef.current.find((j) => j.id === P)?.context?.dataRef?.current.orientation, [P, D, S]), se = we((j) => {
    if (L.current = !1, K.current = !0, j.which === 229 || !U.current && j.currentTarget === k.current)
      return;
    if (m && L9(j.key, R, h, E)) {
      ol(j.key, oe()) || Gt(j), n.setOpen(!1, De(Gr, j.nativeEvent)), wt(i) && (b ? D?.events.emit("virtualfocus", i) : i.focus());
      return;
    }
    const ee = _.current, Y = Nl(l, w), Z = fu(l, w);
    if (O || (j.key === "Home" && (Gt(j), _.current = Y, $(j)), j.key === "End" && (Gt(j), _.current = Z, $(j))), E > 1) {
      const ue = Array.from({
        length: l.current.length
      }, () => ({
        width: 1,
        height: 1
      })), fe = Rh(ue, E, !1), be = fe.findIndex((xe) => xe != null && !To(l.current, xe, w)), Ie = fe.reduce((xe, de, Se) => de != null && !To(l.current, de, w) ? Se : xe, -1), ye = fe[Sh(fe.map((xe) => xe != null ? l.current[xe] : null), {
        event: j,
        orientation: R,
        loopFocus: p,
        rtl: h,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: Nh([...(typeof w != "function" ? w : null) || l.current.map((xe, de) => To(l.current, de, w) ? de : void 0), void 0], fe),
        minIndex: be,
        maxIndex: Ie,
        prevIndex: Eh(
          _.current > Z ? Y : _.current,
          ue,
          fe,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          j.key === fs ? "bl" : j.key === (h ? jo : Ko) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (ye != null && (_.current = ye, $(j)), R === "both")
        return;
    }
    if (ol(j.key, R)) {
      if (Gt(j), o && !b && Xt(j.currentTarget.ownerDocument) === j.currentTarget) {
        _.current = hc(j.key, R, h) ? Y : Z, $(j);
        return;
      }
      hc(j.key, R, h) ? p ? ee >= Z ? f && ee !== l.current.length ? _.current = -1 : (K.current = !1, _.current = Y) : _.current = bn(l.current, {
        startingIndex: ee,
        disabledIndices: w
      }) : _.current = Math.min(Z, bn(l.current, {
        startingIndex: ee,
        disabledIndices: w
      })) : p ? ee <= Y ? f && ee !== -1 ? _.current = l.current.length : (K.current = !1, _.current = Z) : _.current = bn(l.current, {
        startingIndex: ee,
        decrement: !0,
        disabledIndices: w
      }) : _.current = Math.max(Y, bn(l.current, {
        startingIndex: ee,
        decrement: !0,
        disabledIndices: w
      })), Ji(l.current, _.current) && (_.current = -1), $(j);
    }
  }), me = x.useMemo(() => b && o && J && {
    "aria-activedescendant": `${N}-${a}`
  }, [b, o, J, N, a]), pe = x.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...O ? {} : me,
    onKeyDown(j) {
      if (j.key === "Tab" && j.shiftKey && o && !b) {
        const ee = yt(j.nativeEvent);
        if (ee && !Fe(k.current, ee))
          return;
        Gt(j), n.setOpen(!1, De(_o, j.nativeEvent)), wt(i) && i.focus();
        return;
      }
      se(j);
    },
    onPointerMove() {
      L.current = !0;
    }
  }), [me, se, k, R, O, n, o, b, i]), le = x.useMemo(() => {
    function j(Y) {
      v === "auto" && ph(Y.nativeEvent) && (V.current = !b);
    }
    function ee(Y) {
      V.current = v, v === "auto" && mh(Y.nativeEvent) && (V.current = !0);
    }
    return {
      onKeyDown(Y) {
        const Z = n.select("open");
        L.current = !1;
        const ue = Y.key.startsWith("Arrow"), fe = A9(Y.key, oe(), h), be = ol(Y.key, R), Ie = (m ? fe : be) || Y.key === "Enter" || Y.key.trim() === "";
        if (b && Z)
          return se(Y);
        if (!(!Z && !y && ue)) {
          if (Ie) {
            const ye = ol(Y.key, oe());
            A.current = m && ye ? null : Y.key;
          }
          if (m) {
            fe && (Gt(Y), Z ? (_.current = Nl(l, Q.current), $(Y)) : n.setOpen(!0, De(Gr, Y.nativeEvent, Y.currentTarget)));
            return;
          }
          be && (X.current != null && (_.current = X.current), Gt(Y), !Z && y ? n.setOpen(!0, De(Gr, Y.nativeEvent, Y.currentTarget)) : se(Y), Z && $(Y));
        }
      },
      onFocus(Y) {
        n.select("open") && !b && (_.current = -1, $(Y));
      },
      onPointerDown: ee,
      onPointerEnter: ee,
      onMouseDown: j,
      onClick: j
    };
  }, [se, Q, v, l, m, $, n, y, R, oe, h, X, b]), ge = x.useMemo(() => ({
    ...me,
    ...le
  }), [me, le]);
  return x.useMemo(() => u ? {
    reference: ge,
    floating: pe,
    item: ce,
    trigger: le
  } : {}, [u, ge, pe, le, ce]);
}
const F9 = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function kd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), i = n.useState("domReferenceElement"), s = n.useState("floatingElement"), {
    role: l = "dialog"
  } = e, a = Lo(), c = i?.id || a, u = x.useMemo(() => Xi(s)?.id || r, [s, r]), d = F9.get(l) ?? l, p = Co() != null, m = x.useMemo(() => d === "tooltip" || l === "label" ? Et : {
    "aria-haspopup": d === "alertdialog" ? "dialog" : d,
    "aria-expanded": "false",
    ...d === "listbox" && {
      role: "combobox"
    },
    ...d === "menu" && p && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [d, p, l]), h = x.useMemo(() => d === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: o ? u : void 0
  } : {
    ...m,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? u : void 0,
    ...d === "menu" && {
      id: c
    }
  }, [d, u, o, c, l, m]), b = x.useMemo(() => {
    const C = {
      id: u,
      ...d && {
        role: d
      }
    };
    return d === "tooltip" || l === "label" ? C : {
      ...C,
      ...d === "menu" && {
        "aria-labelledby": c
      }
    };
  }, [d, u, c, l]), v = x.useCallback(({
    active: C,
    selected: y
  }) => {
    const w = {
      role: "option",
      ...C && {
        id: `${u}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...w,
          "aria-selected": y
        };
    }
    return {};
  }, [u, l]);
  return x.useMemo(() => ({
    reference: h,
    floating: b,
    item: v,
    trigger: m
  }), [h, b, m, v]);
}
function Id(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, r = n.useState("open"), {
    listRef: i,
    elementsRef: s,
    activeIndex: l,
    onMatch: a,
    onTypingChange: c,
    enabled: u = !0,
    resetMs: d = 750,
    selectedIndex: f = null
  } = e, p = Bt(), m = x.useRef(""), h = x.useRef(f ?? l ?? -1), b = x.useRef(null);
  ke(() => {
    !r && f !== null || (p.clear(), b.current = null, m.current !== "" && (m.current = ""));
  }, [r, f, p]), ke(() => {
    r && m.current === "" && (h.current = f ?? l ?? -1);
  }, [r, f, l]);
  const v = we((S) => {
    S ? o.current.typing || (o.current.typing = S, c?.(S)) : o.current.typing && (o.current.typing = S, c?.(S));
  }), C = we((S) => {
    function E(O) {
      const V = s?.current[O];
      return !V || ha(V);
    }
    function N(O, V, _ = 0) {
      if (O.length === 0)
        return -1;
      const A = (_ % O.length + O.length) % O.length, L = V.toLocaleLowerCase();
      for (let $ = 0; $ < O.length; $ += 1) {
        const B = (A + $) % O.length;
        if (!(!O[B]?.toLocaleLowerCase().startsWith(L) || !E(B)))
          return B;
      }
      return -1;
    }
    const I = i.current;
    if (m.current.length > 0 && S.key === " " && (Gt(S), v(!0)), m.current.length > 0 && m.current[0] !== " " && N(I, m.current) === -1 && S.key !== " " && v(!1), I == null || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && (Gt(S), v(!0));
    const M = m.current === "";
    M && (h.current = f ?? l ?? -1), I.every((O) => O ? O[0]?.toLocaleLowerCase() !== O[1]?.toLocaleLowerCase() : !0) && m.current === S.key && (m.current = "", h.current = b.current), m.current += S.key, p.start(d, () => {
      m.current = "", h.current = b.current, v(!1);
    });
    const P = ((M ? f ?? l ?? -1 : h.current) ?? 0) + 1, D = N(I, m.current, P);
    D !== -1 ? (a?.(D), b.current = D) : S.key !== " " && (m.current = "", v(!1));
  }), y = we((S) => {
    const E = S.relatedTarget, N = n.select("domReferenceElement"), I = n.select("floatingElement"), M = Fe(N, E), T = Fe(I, E);
    M || T || (p.clear(), m.current = "", h.current = b.current, v(!1));
  }), w = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]), R = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]);
  return x.useMemo(() => u ? {
    reference: w,
    floating: R
  } : {}, [u, w, R]);
}
const Dp = 0.1, $9 = Dp * Dp, Tt = 0.5;
function rl(t, e, n, o, r, i) {
  return o >= e != i >= e && t <= (r - n) * (e - o) / (i - o) + n;
}
function il(t, e, n, o, r, i, s, l, a, c) {
  let u = !1;
  return rl(t, e, n, o, r, i) && (u = !u), rl(t, e, r, i, s, l) && (u = !u), rl(t, e, s, l, a, c) && (u = !u), rl(t, e, a, c, n, o) && (u = !u), u;
}
function H9(t, e, n) {
  return t >= n.x && t <= n.x + n.width && e >= n.y && e <= n.y + n.height;
}
function sl(t, e, n, o, r, i) {
  const s = Math.min(n, r), l = Math.max(n, r), a = Math.min(o, i), c = Math.max(o, i);
  return t >= s && t <= l && e >= a && e <= c;
}
function Cs(t = {}) {
  const {
    blockPointerEvents: e = !1
  } = t, n = new Pn(), o = ({
    x: r,
    y: i,
    placement: s,
    elements: l,
    onClose: a,
    nodeId: c,
    tree: u
  }) => {
    const d = s?.split("-")[0];
    let f = !1, p = null, m = null, h = typeof performance < "u" ? performance.now() : 0;
    function b(C, y) {
      const w = performance.now(), R = w - h;
      if (p === null || m === null || R === 0)
        return p = C, m = y, h = w, !1;
      const S = C - p, E = y - m, N = S * S + E * E, I = R * R * $9;
      return p = C, m = y, h = w, N < I;
    }
    function v() {
      n.clear(), a();
    }
    return function(y) {
      n.clear();
      const w = l.domReference, R = l.floating;
      if (!w || !R || d == null || r == null || i == null)
        return;
      const {
        clientX: S,
        clientY: E
      } = y, N = yt(y), I = y.type === "mouseleave", M = Fe(R, N), T = Fe(w, N);
      if (M && (f = !0, !I))
        return;
      if (T && (f = !1, !I)) {
        f = !0;
        return;
      }
      if (I && mt(y.relatedTarget) && Fe(R, y.relatedTarget))
        return;
      function k() {
        return !!(u && po(u.nodesRef.current, c).length > 0);
      }
      function P() {
        k() || v();
      }
      if (k())
        return;
      const D = w.getBoundingClientRect(), O = R.getBoundingClientRect(), V = r > O.right - O.width / 2, _ = i > O.bottom - O.height / 2, A = O.width > D.width, L = O.height > D.height, $ = (A ? D : O).left, B = (A ? D : O).right, z = (L ? D : O).top, H = (L ? D : O).bottom;
      if (d === "top" && i >= D.bottom - 1 || d === "bottom" && i <= D.top + 1 || d === "left" && r >= D.right - 1 || d === "right" && r <= D.left + 1) {
        P();
        return;
      }
      let K = !1;
      switch (d) {
        case "top":
          K = sl(S, E, $, D.top + 1, B, O.bottom - 1);
          break;
        case "bottom":
          K = sl(S, E, $, O.top + 1, B, D.bottom - 1);
          break;
        case "left":
          K = sl(S, E, O.right - 1, H, D.left + 1, z);
          break;
        case "right":
          K = sl(S, E, D.right - 1, H, O.left + 1, z);
          break;
      }
      if (K)
        return;
      if (f && !H9(S, E, D)) {
        P();
        return;
      }
      if (!I && b(S, E)) {
        P();
        return;
      }
      let G = !1;
      switch (d) {
        case "top": {
          const q = A ? Tt / 2 : Tt * 4, Q = A || V ? r + q : r - q, U = A ? r - q : V ? r + q : r - q, X = i + Tt + 1, te = V || A ? O.bottom - Tt : O.top, re = V ? A ? O.bottom - Tt : O.top : O.bottom - Tt;
          G = il(S, E, Q, X, U, X, O.left, te, O.right, re);
          break;
        }
        case "bottom": {
          const q = A ? Tt / 2 : Tt * 4, Q = A || V ? r + q : r - q, U = A ? r - q : V ? r + q : r - q, X = i - Tt, te = V || A ? O.top + Tt : O.bottom, re = V ? A ? O.top + Tt : O.bottom : O.top + Tt;
          G = il(S, E, Q, X, U, X, O.left, te, O.right, re);
          break;
        }
        case "left": {
          const q = L ? Tt / 2 : Tt * 4, Q = L || _ ? i + q : i - q, U = L ? i - q : _ ? i + q : i - q, X = r + Tt + 1, te = _ || L ? O.right - Tt : O.left, re = _ ? L ? O.right - Tt : O.left : O.right - Tt;
          G = il(S, E, te, O.top, re, O.bottom, X, Q, X, U);
          break;
        }
        case "right": {
          const q = L ? Tt / 2 : Tt * 4, Q = L || _ ? i + q : i - q, U = L ? i - q : _ ? i + q : i - q, X = r - Tt, te = _ || L ? O.left + Tt : O.right, re = _ ? L ? O.left + Tt : O.right : O.left + Tt;
          G = il(S, E, X, Q, X, U, te, O.top, re, O.bottom);
          break;
        }
      }
      G ? f || n.start(40, P) : P();
    };
  };
  return o.__options = {
    ...t,
    blockPointerEvents: e
  }, o;
}
const r2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (r2.displayName = "ToolbarRootContext");
function Pd(t) {
  return x.useContext(r2);
}
const Kr = "ArrowUp", pr = "ArrowDown", ts = "ArrowLeft", qr = "ArrowRight", ws = "Home", Ss = "End", i2 = /* @__PURE__ */ new Set([ts, qr]), z9 = /* @__PURE__ */ new Set([ts, qr, ws, Ss]), s2 = /* @__PURE__ */ new Set([Kr, pr]), B9 = /* @__PURE__ */ new Set([Kr, pr, ws, Ss]), l2 = /* @__PURE__ */ new Set([...i2, ...s2]), W9 = /* @__PURE__ */ new Set([...l2, ws, Ss]), Rs = /* @__PURE__ */ new Set([Kr, pr, ts, qr, ws, Ss]), a2 = "Shift", U9 = "Control", G9 = "Alt", Y9 = "Meta", j9 = /* @__PURE__ */ new Set([a2, U9, G9, Y9]);
function K9(t) {
  return wt(t) && t.tagName === "INPUT";
}
function _p(t) {
  return !!(K9(t) && t.selectionStart != null || wt(t) && t.tagName === "TEXTAREA");
}
function Vp(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, i = t.scrollTop;
  const s = t.clientWidth < t.scrollWidth, l = t.clientHeight < t.scrollHeight;
  if (s && o !== "vertical") {
    const a = Ap(t, e, "left"), c = ll(t), u = ll(e);
    n === "ltr" && (a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : a - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = a - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (a - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = a - u.scrollMarginLeft - c.scrollPaddingLeft : a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (l && o !== "horizontal") {
    const a = Ap(t, e, "top"), c = ll(t), u = ll(e);
    a - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? i = a - u.scrollMarginTop - c.scrollPaddingTop : a + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (i = a + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: i,
    behavior: "auto"
  });
}
function Ap(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function ll(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
function Mr(t) {
  return t === "starting" ? X8 : Et;
}
const q9 = {
  ...An,
  ...Kt
}, c2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a
  } = oo(), {
    side: c,
    align: u
  } = cs(), d = Pd() != null, f = a.useState("open"), p = a.useState("transitionStatus"), m = a.useState("popupProps"), h = a.useState("mounted"), b = a.useState("instantType"), v = a.useState("activeTriggerElement"), C = a.useState("parent"), y = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), R = a.useState("floatingRootContext"), S = a.useState("floatingTreeRoot"), E = a.useState("closeDelay"), N = a.useState("activeTriggerElement"), I = C.type === "context-menu";
  Jt({
    open: f,
    ref: a.context.popupRef,
    onComplete() {
      f && a.context.onOpenChangeComplete?.(!0);
    }
  }), x.useEffect(() => {
    function V(_) {
      a.setOpen(!1, De(_.reason, _.domEvent));
    }
    return S.events.on("close", V), () => {
      S.events.off("close", V);
    };
  }, [S.events, a]);
  const M = a.useState("hoverEnabled"), T = a.useState("disabled");
  xa(R, {
    enabled: M && !T && !I && C.type !== "menubar",
    closeDelay: E
  });
  const k = {
    transitionStatus: p,
    side: c,
    align: u,
    open: f,
    nested: C.type === "menu",
    instant: b
  }, P = x.useCallback((V) => {
    a.set("popupElement", V);
  }, [a]), D = Le("div", e, {
    state: k,
    ref: [n, a.context.popupRef, P],
    stateAttributesMapping: q9,
    props: [m, {
      onKeyDown(V) {
        d && Rs.has(V.key) && V.stopPropagation();
      }
    }, Mr(p), l, {
      "data-rootownerid": w
    }]
  });
  let O = C.type === void 0 || I;
  return (v || C.type === "menubar" && y !== us) && (O = !0), /* @__PURE__ */ g(li, {
    context: R,
    modal: I,
    disabled: !h,
    returnFocus: s === void 0 ? O : s,
    initialFocus: C.type !== "menu",
    restoreFocus: !0,
    externalTree: C.type !== "menubar" ? S : void 0,
    previousFocusableElement: N,
    nextFocusableElement: C.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: C.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (c2.displayName = "MenuPopup");
const Md = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Md.displayName = "MenuPortalContext");
function Z9() {
  const t = x.useContext(Md);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : st(32));
  return t;
}
const u2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = oo();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(Md.Provider, {
    value: o,
    children: /* @__PURE__ */ g(si, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (u2.displayName = "MenuPortal");
function Tr(t) {
  return Vu(19) ? t : t ? "true" : void 0;
}
const d2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (d2.displayName = "DirectionContext");
function Es() {
  return x.useContext(d2)?.direction ?? "ltr";
}
const X9 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = Vo(t, e) || {};
    if (c == null)
      return {};
    const f = wh(u), p = {
      x: n,
      y: o
    }, m = id(r), h = rd(m), b = await s.getDimensions(c), v = m === "y", C = v ? "top" : "left", y = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", R = i.reference[h] + i.reference[m] - p[m] - i.floating[h], S = p[m] - i.reference[m], E = d === "real" ? await s.getOffsetParent?.(c) : l.floating;
    let N = l.floating[w] || i.floating[h];
    (!N || !await s.isElement?.(E)) && (N = l.floating[w] || i.floating[h]);
    const I = R / 2 - S / 2, M = N / 2 - b[h] / 2 - 1, T = Math.min(f[C], M), k = Math.min(f[y], M), P = T, D = N - b[h] - k, O = N / 2 - b[h] / 2 + I, V = uu(P, O, D), _ = !a.arrow && or(r) != null && O !== V && i.reference[h] / 2 - (O < P ? T : k) - b[h] / 2 < 0, A = _ ? O < P ? O - P : O - D : 0;
    return {
      [m]: p[m] + A,
      data: {
        [m]: V,
        centerOffset: O - V - A,
        ..._ && {
          alignmentOffset: A
        }
      },
      reset: _
    };
  }
}), Q9 = (t, e) => ({
  ...X9(t),
  options: [t, e]
}), J9 = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, i = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await Z6().fn(t)).data?.referenceHidden || i
      }
    };
  }
}, Pl = {
  sideX: "left",
  sideY: "top"
}, wa = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: i,
      strategy: s,
      placement: l
    } = t, a = St(r), c = a.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: Pl
      };
    const d = await i.getOffsetParent?.(r);
    let f = {
      width: 0,
      height: 0
    };
    if (s === "fixed" && a?.visualViewport)
      f = {
        width: a.visualViewport.width,
        height: a.visualViewport.height
      };
    else if (d === a) {
      const C = nt(r);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else await i.isElement?.(d) && (f = await i.getDimensions(d));
    const p = In(l);
    let m = e, h = n;
    p === "left" && (m = f.width - (e + o.width)), p === "top" && (h = f.height - (n + o.height));
    const b = p === "left" ? "right" : Pl.sideX, v = p === "top" ? "bottom" : Pl.sideY;
    return {
      x: m,
      y: h,
      data: {
        sideX: b,
        sideY: v
      }
    };
  }
};
function f2(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function Lp(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: f2(e, In(r), n),
    align: or(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function ai(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: i = "center",
    alignOffset: s = 0,
    collisionBoundary: l,
    collisionPadding: a = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: p,
    mounted: m,
    collisionAvoidance: h,
    shiftCrossAxis: b = !1,
    nodeId: v,
    adaptiveOrigin: C,
    lazyFlip: y = !1,
    externalTree: w
  } = t, [R, S] = x.useState(null);
  !m && R !== null && S(null);
  const E = h.side || "flip", N = h.align || "flip", I = h.fallbackAxisSide || "end", M = typeof e == "function" ? e : void 0, T = we(M), k = M ? T : e, P = Yt(e), D = Yt(m), V = Es() === "rtl", _ = R || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": V ? "left" : "right",
    "inline-start": V ? "right" : "left"
  }[o], A = i === "center" ? _ : `${_}-${i}`;
  let L = a;
  const $ = 1, B = o === "bottom" ? $ : 0, z = o === "top" ? $ : 0, H = o === "right" ? $ : 0, K = o === "left" ? $ : 0;
  typeof L == "number" ? L = {
    top: L + B,
    right: L + K,
    bottom: L + z,
    left: L + H
  } : L && (L = {
    top: (L.top || 0) + B,
    right: (L.right || 0) + K,
    bottom: (L.bottom || 0) + z,
    left: (L.left || 0) + H
  });
  const G = {
    boundary: l === "clipping-ancestors" ? "clippingAncestors" : l,
    padding: L
  }, q = x.useRef(null), Q = Yt(r), U = Yt(s), re = [G6((Be) => {
    const Ne = Lp(Be, o, V), _e = typeof Q.current == "function" ? Q.current(Ne) : Q.current, Pe = typeof U.current == "function" ? U.current(Ne) : U.current;
    return {
      mainAxis: _e,
      crossAxis: Pe,
      alignmentAxis: Pe
    };
  }, [typeof r != "function" ? r : 0, typeof s != "function" ? s : 0, V, o])], J = N === "none" && E !== "shift", ie = !J && (c || b || E === "shift"), ce = E === "none" ? null : K6({
    ...G,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: L.top + $,
      right: L.right + $,
      bottom: L.bottom + $,
      left: L.left + $
    },
    mainAxis: !b && E === "flip",
    crossAxis: N === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: I
  }), oe = J ? null : Y6((Be) => {
    const Ne = nt(Be.elements.floating).documentElement;
    return {
      ...G,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: b ? {
        x: 0,
        y: 0,
        width: Ne.clientWidth,
        height: Ne.clientHeight
      } : void 0,
      mainAxis: N !== "none",
      crossAxis: ie,
      limiter: c || b ? void 0 : j6((_e) => {
        if (!q.current)
          return {};
        const {
          width: Pe,
          height: $e
        } = q.current.getBoundingClientRect(), He = zn(In(_e.placement)), Te = He === "y" ? Pe : $e, Rt = He === "y" ? L.left + L.right : L.top + L.bottom;
        return {
          offset: Te / 2 + Rt / 2
        };
      })
    };
  }, [G, c, b, L, N]);
  E === "shift" || N === "shift" || i === "center" ? re.push(oe, ce) : re.push(ce, oe), re.push(q6({
    ...G,
    apply({
      elements: {
        floating: Be
      },
      availableWidth: Ne,
      availableHeight: _e,
      rects: Pe
    }) {
      if (!D.current)
        return;
      const $e = Be.style;
      $e.setProperty("--available-width", `${Ne}px`), $e.setProperty("--available-height", `${_e}px`);
      const He = St(Be).devicePixelRatio || 1, {
        x: Te,
        y: Rt,
        width: rt,
        height: Ce
      } = Pe.reference, Ee = (Math.round((Te + rt) * He) - Math.round(Te * He)) / He, Ae = (Math.round((Rt + Ce) * He) - Math.round(Rt * He)) / He;
      $e.setProperty("--anchor-width", `${Ee}px`), $e.setProperty("--anchor-height", `${Ae}px`);
    }
  }), Q9(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: q.current || nt(q.current).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(Be) {
      const {
        elements: Ne,
        middlewareData: _e,
        placement: Pe,
        rects: $e,
        y: He
      } = Be, Te = In(Pe), Rt = zn(Te), rt = q.current, Ce = _e.arrow?.x || 0, Ee = _e.arrow?.y || 0, Ae = rt?.clientWidth || 0, ze = rt?.clientHeight || 0, it = Ce + Ae / 2, Ye = Ee + ze / 2, Qe = Math.abs(_e.shift?.y || 0), Ge = $e.reference.height / 2, Ke = typeof r == "function" ? r(Lp(Be, o, V)) : r, Je = Qe > Ke, lt = {
        top: `${it}px calc(100% + ${Ke}px)`,
        bottom: `${it}px ${-Ke}px`,
        left: `calc(100% + ${Ke}px) ${Ye}px`,
        right: `${-Ke}px ${Ye}px`
      }[Te], pt = `${it}px ${$e.reference.y + Ge - He}px`;
      return Ne.floating.style.setProperty("--transform-origin", ie && Rt === "y" && Je ? pt : lt), {};
    }
  }, J9, C), ke(() => {
    !m && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [m, p]);
  const se = x.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: me,
    elements: pe,
    x: le,
    y: ge,
    middlewareData: j,
    update: ee,
    placement: Y,
    context: Z,
    isPositioned: ue,
    floatingStyles: fe
  } = D9({
    rootContext: p,
    open: f ? m : void 0,
    placement: A,
    middleware: re,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...Be) => Cp(...Be, se),
    nodeId: v,
    externalTree: w
  }), {
    sideX: be,
    sideY: Ie
  } = j.adaptiveOrigin || Pl, ye = ue ? n : "fixed", xe = x.useMemo(() => {
    const Be = C ? {
      position: ye,
      [be]: le,
      [Ie]: ge
    } : {
      position: ye,
      ...fe
    };
    return ue || (Be.opacity = 0), Be;
  }, [C, ye, be, le, Ie, ge, fe, ue]), de = x.useRef(null);
  ke(() => {
    if (!m)
      return;
    const Be = P.current, Ne = typeof Be == "function" ? Be() : Be, Pe = (Fp(Ne) ? Ne.current : Ne) || null || null;
    Pe !== de.current && (me.setPositionReference(Pe), de.current = Pe);
  }, [m, me, k, P]), x.useEffect(() => {
    if (!m)
      return;
    const Be = P.current;
    typeof Be != "function" && Fp(Be) && Be.current !== de.current && (me.setPositionReference(Be.current), de.current = Be.current);
  }, [m, me, k, P]), x.useEffect(() => {
    if (f && m && pe.domReference && pe.floating)
      return Cp(pe.domReference, pe.floating, ee, se);
  }, [f, m, pe, ee, se]);
  const Se = In(Y), Me = f2(o, Se, V), Re = or(Y) || "center", Ve = !!j.hide?.referenceHidden;
  ke(() => {
    y && m && ue && S(Se);
  }, [y, m, ue, Se]);
  const Ze = x.useMemo(() => ({
    position: "absolute",
    top: j.arrow?.y,
    left: j.arrow?.x
  }), [j.arrow]), Xe = j.arrow?.centerOffset !== 0;
  return x.useMemo(() => ({
    positionerStyles: xe,
    arrowStyles: Ze,
    arrowRef: q,
    arrowUncentered: Xe,
    side: Me,
    align: Re,
    physicalSide: Se,
    anchorHidden: Ve,
    refs: me,
    context: Z,
    isPositioned: ue,
    update: ee
  }), [xe, Ze, q, Xe, Me, Re, Se, Ve, me, Z, ue, ee]);
}
function Fp(t) {
  return t != null && "current" in t;
}
function ci(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, i = we(r), s = x.useRef(0), l = Lt(t7).current, a = Lt(e7).current, [c, u] = x.useState(0), d = x.useRef(c), f = we((v, C) => {
    a.set(v, C ?? null), d.current += 1, u(d.current);
  }), p = we((v) => {
    a.delete(v), d.current += 1, u(d.current);
  }), m = x.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return Array.from(a.keys()).filter((y) => y.isConnected).sort(n7).forEach((y, w) => {
      const R = a.get(y) ?? {};
      v.set(y, {
        ...R,
        index: w
      });
    }), v;
  }, [a, c]);
  ke(() => {
    if (typeof MutationObserver != "function" || m.size === 0)
      return;
    const v = new MutationObserver((C) => {
      const y = /* @__PURE__ */ new Set(), w = (R) => y.has(R) ? y.delete(R) : y.add(R);
      C.forEach((R) => {
        R.removedNodes.forEach(w), R.addedNodes.forEach(w);
      }), y.size === 0 && (d.current += 1, u(d.current));
    });
    return m.forEach((C, y) => {
      y.parentElement && v.observe(y.parentElement, {
        childList: !0
      });
    }), () => {
      v.disconnect();
    };
  }, [m]), ke(() => {
    d.current === c && (n.current.length !== m.size && (n.current.length = m.size), o && o.current.length !== m.size && (o.current.length = m.size), s.current = m.size), i(m);
  }, [i, m, n, o, c]), ke(() => () => {
    n.current = [];
  }, [n]), ke(() => () => {
    o && (o.current = []);
  }, [o]);
  const h = we((v) => (l.add(v), () => {
    l.delete(v);
  }));
  ke(() => {
    l.forEach((v) => v(m));
  }, [l, m]);
  const b = x.useMemo(() => ({
    register: f,
    unregister: p,
    subscribeMapChange: h,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: s
  }), [f, p, h, n, o, s]);
  return /* @__PURE__ */ g(Qu.Provider, {
    value: b,
    children: e
  });
}
function e7() {
  return /* @__PURE__ */ new Map();
}
function t7() {
  return /* @__PURE__ */ new Set();
}
function n7(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const ui = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let i;
  if (o) {
    const s = o.getBoundingClientRect();
    i = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${s.left}px ${s.top}px,${s.left}px ${s.bottom}px,${s.right}px ${s.bottom}px,${s.right}px ${s.top}px,${s.left}px ${s.top}px)`;
  }
  return /* @__PURE__ */ g("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: i
    }
  });
});
process.env.NODE_ENV !== "production" && (ui.displayName = "InternalBackdrop");
function di(t, e, {
  styles: n,
  transitionStatus: o,
  props: r,
  refs: i,
  hidden: s,
  inert: l = !1
}) {
  const a = {
    ...n
  };
  return l && (a.pointerEvents = "none"), Le("div", t, {
    state: e,
    ref: i,
    props: [{
      role: "presentation",
      hidden: s,
      style: a
    }, Mr(o), r],
    stateAttributesMapping: An
  });
}
let $p = {}, Hp = {}, zp = "";
function o7(t) {
  if (typeof document > "u")
    return !1;
  const e = nt(t);
  return St(e).innerWidth - e.documentElement.clientWidth > 0;
}
function r7(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = nt(t), o = n.documentElement, r = n.body, i = tr(o) ? o : r, s = i.style.overflowY, l = o.style.scrollbarGutter;
  o.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
  const a = i.offsetWidth;
  i.style.overflowY = "hidden";
  const c = i.offsetWidth;
  return i.style.overflowY = s, o.style.scrollbarGutter = l, a === c;
}
function i7(t) {
  const e = nt(t), n = e.documentElement, o = e.body, r = tr(n) ? n : o, i = {
    overflowY: r.style.overflowY,
    overflowX: r.style.overflowX
  };
  return Object.assign(r.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(r.style, i);
  };
}
function s7(t) {
  const e = nt(t), n = e.documentElement, o = e.body, r = St(n);
  let i = 0, s = 0, l = !1;
  const a = Wt.create();
  if (qu && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), m = r.getComputedStyle(o), v = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    i = n.scrollTop, s = n.scrollLeft, $p = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, zp = n.style.scrollBehavior, Hp = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const C = n.scrollHeight > n.clientHeight, y = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || m.overflowY === "scroll", R = p.overflowX === "scroll" || m.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), E = Math.max(0, r.innerHeight - o.clientHeight), N = parseFloat(m.marginTop) + parseFloat(m.marginBottom), I = parseFloat(m.marginLeft) + parseFloat(m.marginRight), M = tr(n) ? n : o;
    if (l = r7(t), l) {
      n.style.scrollbarGutter = v, M.style.overflowY = "hidden", M.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: v,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (C || w) && (n.style.overflowY = "scroll"), (y || R) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: N || E ? `calc(100dvh - ${N + E}px)` : "100dvh",
      width: I || S ? `calc(100vw - ${I + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = i, o.scrollLeft = s, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, $p), Object.assign(o.style, Hp), l || (n.scrollTop = i, n.scrollLeft = s, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = zp);
  }
  function d() {
    u(), a.request(c);
  }
  c();
  const f = dt(r, "resize", d);
  return () => {
    a.cancel(), u(), typeof r.removeEventListener == "function" && f();
  };
}
class l7 {
  lockCount = 0;
  restore = null;
  timeoutLock = Pn.create();
  timeoutUnlock = Pn.create();
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = nt(e).documentElement, r = St(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = Ct;
      return;
    }
    const i = Zu || !o7(e);
    this.restore = i ? i7(e) : s7(e);
  }
}
const a7 = new l7();
function p2(t = !0, e = null) {
  ke(() => {
    if (t)
      return a7.acquire(e);
  }, [t, e]);
}
const c7 = 20;
function Sa(t, e, n, o) {
  const [r, i] = x.useState(!1);
  ke(() => {
    if (!t || !e || n == null) {
      i(!1);
      return;
    }
    const s = nt(n).documentElement.clientWidth, l = n.offsetWidth;
    i(s > 0 && l > 0 && l >= s - c7);
  }, [t, e, n]), p2(t && (!e || r), o);
}
const m2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l,
    align: a,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = cd,
    style: v,
    ...C
  } = e, {
    store: y
  } = oo(), w = Z9(), R = pa(!0), S = y.useState("parent"), E = y.useState("floatingRootContext"), N = y.useState("floatingTreeRoot"), I = y.useState("mounted"), M = y.useState("open"), T = y.useState("modal"), k = y.useState("openMethod"), P = y.useState("activeTriggerElement"), D = y.useState("transitionStatus"), O = y.useState("positionerElement"), V = y.useState("instantType"), _ = y.useState("hasViewport"), A = y.useState("lastOpenChangeReason"), L = y.useState("floatingNodeId"), $ = y.useState("floatingParentNodeId"), B = E.useState("domReferenceElement"), z = x.useRef(null), H = la(O, !1, !1);
  let K = o, G = c, q = u, Q = a, U = b;
  S.type === "context-menu" && (K = o ?? S.context?.anchor, Q = Q ?? "start", !l && Q !== "center" && (q = e.alignOffset ?? 2, G = e.sideOffset ?? -5));
  let X = l, te = Q;
  S.type === "menu" ? (X = X ?? "inline-end", te = te ?? "start", U = e.collisionAvoidance ?? ba) : S.type === "menubar" && (X = X ?? "bottom", te = te ?? "start");
  const re = S.type === "context-menu", J = ai({
    anchor: K,
    floatingRootContext: E,
    positionMethod: R ? "fixed" : r,
    mounted: I,
    side: X,
    sideOffset: G,
    align: te,
    alignOffset: q,
    arrowPadding: re ? 0 : p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    nodeId: L,
    keepMounted: w,
    disableAnchorTracking: h,
    collisionAvoidance: U,
    shiftCrossAxis: re && !("side" in U && U.side === "flip"),
    externalTree: N,
    adaptiveOrigin: _ ? wa : void 0
  });
  x.useEffect(() => {
    function ge(j) {
      j.open && (j.parentNodeId === L && y.set("hoverEnabled", !1), j.nodeId !== L && j.parentNodeId === y.select("floatingParentNodeId") && y.setOpen(!1, De(Fi)));
    }
    return N.events.on("menuopenchange", ge), () => {
      N.events.off("menuopenchange", ge);
    };
  }, [y, N.events, L]), x.useEffect(() => {
    if (y.select("floatingParentNodeId") == null)
      return;
    function ge(j) {
      if (j.open || j.nodeId !== y.select("floatingParentNodeId"))
        return;
      const ee = j.reason ?? Fi;
      y.setOpen(!1, De(ee));
    }
    return N.events.on("menuopenchange", ge), () => {
      N.events.off("menuopenchange", ge);
    };
  }, [N.events, y]);
  const ie = Bt();
  x.useEffect(() => {
    M || ie.clear();
  }, [M, ie]), x.useEffect(() => {
    function ge(j) {
      if (!(!M || j.nodeId !== y.select("floatingParentNodeId")))
        if (j.target && P && P !== j.target) {
          const ee = y.select("closeDelay");
          ee > 0 ? ie.isStarted() || ie.start(ee, () => {
            y.setOpen(!1, De(Fi));
          }) : y.setOpen(!1, De(Fi));
        } else
          ie.clear();
    }
    return N.events.on("itemhover", ge), () => {
      N.events.off("itemhover", ge);
    };
  }, [N.events, M, P, y, ie]), x.useEffect(() => {
    const ge = {
      open: M,
      nodeId: L,
      parentNodeId: $,
      reason: y.select("lastOpenChangeReason")
    };
    N.events.emit("menuopenchange", ge);
  }, [N.events, M, y, L, $]), ke(() => {
    const ge = B, j = z.current;
    if (ge && (z.current = ge), j && ge && ge !== j) {
      y.set("instantType", void 0);
      const ee = new AbortController();
      return H(() => {
        y.set("instantType", "trigger-change");
      }, ee.signal), () => {
        ee.abort();
      };
    }
  }, [B, H, y]);
  const ce = {
    open: M,
    side: J.side,
    align: J.align,
    anchorHidden: J.anchorHidden,
    nested: S.type === "menu",
    instant: V
  }, oe = S.type === "menubar" && S.context.modal;
  Sa(M && (oe || T && A !== Ut), k === "touch", O, P);
  const me = di(e, ce, {
    styles: J.positionerStyles,
    transitionStatus: D,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !I,
    inert: !M
  }), pe = I && S.type !== "menu" && (S.type !== "menubar" && T && A !== Ut || S.type === "menubar" && S.context.modal);
  let le = null;
  return S.type === "menubar" ? le = S.context.contentElement : S.type === void 0 && (le = P), /* @__PURE__ */ F(Yu.Provider, {
    value: J,
    children: [pe && /* @__PURE__ */ g(ui, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: Tr(!M),
      cutout: le
    }), /* @__PURE__ */ g(md, {
      id: L,
      children: /* @__PURE__ */ g(ci, {
        elementsRef: y.context.itemDomElements,
        labelsRef: y.context.itemLabels,
        children: me
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (m2.displayName = "MenuPositioner");
const Td = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Td.displayName = "MenuRadioGroupContext");
function u7() {
  const t = x.useContext(Td);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : st(34));
  return t;
}
const g2 = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i,
    defaultValue: s,
    onValueChange: l,
    disabled: a = !1,
    style: c,
    ...u
  } = e, [d, f] = Sn({
    controlled: i,
    default: s,
    name: "MenuRadioGroup"
  }), p = we(l), m = we((C, y) => {
    p?.(C, y), !y.isCanceled && f(C);
  }), b = Le("div", e, {
    state: {
      disabled: a
    },
    ref: n,
    props: {
      role: "group",
      "aria-disabled": a || void 0,
      ...u
    }
  }), v = x.useMemo(() => ({
    value: d,
    setValue: m,
    disabled: a
  }), [d, m, a]);
  return /* @__PURE__ */ g(Td.Provider, {
    value: v,
    children: b
  });
}));
process.env.NODE_ENV !== "production" && (g2.displayName = "MenuRadioGroup");
const Od = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Od.displayName = "MenuRadioItemContext");
function d7() {
  const t = x.useContext(Od);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : st(35));
  return t;
}
const h2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = e, p = Ao({
    label: s
  }), m = cs(!0), h = Ot(i), {
    store: b
  } = oo(), v = b.useState("isActive", p.index), C = b.useState("itemProps"), {
    value: y,
    setValue: w,
    disabled: R
  } = u7(), S = R || a, E = y === u, {
    getItemProps: N,
    itemRef: I
  } = ma({
    closeOnClick: c,
    disabled: S,
    highlighted: v,
    id: h,
    store: b,
    nativeButton: l,
    nodeId: m?.context.nodeId,
    itemMetadata: Xu
  }), M = x.useMemo(() => ({
    disabled: S,
    highlighted: v,
    checked: E
  }), [S, v, E]), T = we((P) => {
    const D = {
      ...De(Yo, P.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, D);
  }), k = Le("div", e, {
    state: M,
    stateAttributesMapping: ed,
    props: [C, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: T
    }, f, N],
    ref: [I, n, p.ref]
  });
  return /* @__PURE__ */ g(Od.Provider, {
    value: M,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (h2.displayName = "MenuRadioItem");
const b2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = d7(), c = x.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = to(a.checked);
  Jt({
    open: a.checked,
    ref: c,
    onComplete() {
      a.checked || d(!1);
    }
  });
  const f = {
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: u
  };
  return Le("span", e, {
    state: f,
    stateAttributesMapping: ed,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...l
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (b2.displayName = "MenuRadioItemIndicator");
function Or(t) {
  const e = x.useRef(!0);
  e.current && (e.current = !1, t());
}
const v2 = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (v2.displayName = "MenubarContext");
function y2(t) {
  return x.useContext(v2);
}
function f7(t) {
  const e = x.useRef(""), n = x.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: x.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r ? t(r, r.pointerType) : t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function ko(t, e) {
  const n = x.useRef(t), o = we(e);
  ke(() => {
    n.current !== t && o(n.current);
  }, [t, o]), ke(() => {
    n.current = t;
  }, [t]);
}
function Ns(t) {
  const [e, n] = x.useState(null), o = we((s, l) => {
    t || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (Zu ? "touch" : ""));
  });
  ko(t, (s) => {
    s && !t && n(null);
  });
  const {
    onClick: r,
    onPointerDown: i
  } = f7(o);
  return x.useMemo(() => ({
    openMethod: e,
    triggerProps: {
      onClick: r,
      onPointerDown: i
    }
  }), [e, r, i]);
}
const p7 = {
  ...vs,
  disabled: he((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: he((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  openMethod: he((t) => t.openMethod),
  allowMouseEnter: he((t) => t.allowMouseEnter),
  stickIfOpen: he((t) => t.stickIfOpen),
  parent: he((t) => t.parent),
  rootId: he((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: he((t) => t.activeIndex),
  isActive: he((t, e) => t.activeIndex === e),
  hoverEnabled: he((t) => t.hoverEnabled),
  instantType: he((t) => t.instantType),
  lastOpenChangeReason: he((t) => t.openChangeReason),
  floatingTreeRoot: he((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: he((t) => t.floatingNodeId),
  floatingParentNodeId: he((t) => t.floatingParentNodeId),
  itemProps: he((t) => t.itemProps),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport),
  keyboardEventRelay: he((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class Dd extends Ir {
  constructor(e) {
    super({
      ...m7(),
      ...e
    }, {
      positionerRef: /* @__PURE__ */ x.createRef(),
      popupRef: /* @__PURE__ */ x.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new Pr()
    }, p7), this.unsubscribeParentListener = this.observe("parent", (n) => {
      if (this.unsubscribeParentListener?.(), n.type === "menu") {
        let o = n.store.select("rootId"), r = n.store.select("floatingTreeRoot"), i = n.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = n.store.subscribe(() => {
          const s = n.store.select("rootId"), l = n.store.select("floatingTreeRoot"), a = n.store.select("keyboardEventRelay");
          o === s && r === l && i === a || (o = s, r = l, i = a, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = n.store.context.allowMouseUpTriggerRef;
        return;
      }
      n.type !== void 0 && (this.context.allowMouseUpTriggerRef = n.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(e, n) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: e,
      eventDetails: n
    });
  }
  static useStore(e, n) {
    const o = Lt(() => new Dd(n)).current;
    return e ?? o;
  }
  unsubscribeParentListener = null;
}
function m7() {
  return {
    ...bs(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new dd(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: Et,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const _d = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (_d.displayName = "MenuSubmenuRootContext");
function x2() {
  return x.useContext(_d);
}
const fi = xd(function(e) {
  const {
    children: n,
    open: o,
    onOpenChange: r,
    onOpenChangeComplete: i,
    defaultOpen: s = !1,
    disabled: l = !1,
    modal: a,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: p,
    triggerId: m,
    defaultTriggerId: h = null,
    highlightItemOnHover: b = !0
  } = e, v = pa(!0), C = oo(!0), y = y2(!0), w = x2(), R = x.useMemo(() => w && C ? {
    type: "menu",
    store: C.store
  } : y ? {
    type: "menubar",
    context: y
  } : v && !C ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, C, y, w]), S = Dd.useStore(p?.store, {
    open: s,
    openProp: o,
    activeTriggerId: h,
    triggerIdProp: m,
    parent: R
  });
  Or(() => {
    o === void 0 && S.state.open === !1 && s === !0 && S.update({
      open: !0,
      activeTriggerId: h
    });
  }), S.useControlledProp("openProp", o), S.useControlledProp("triggerIdProp", m), S.useContextCallback("onOpenChangeComplete", i);
  const E = S.useState("floatingTreeRoot"), N = va(E), I = Co();
  ke(() => {
    v && !C ? S.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: N,
      floatingParentNodeId: I
    }) : C && S.update({
      floatingNodeId: N,
      floatingParentNodeId: I
    });
  }, [v, C, N, I, S]);
  const M = S.useState("open"), T = S.useState("activeTriggerElement"), k = S.useState("positionerElement"), P = S.useState("hoverEnabled"), D = S.useState("disabled"), O = S.useState("lastOpenChangeReason"), V = S.useState("parent"), _ = S.useState("activeIndex"), A = S.useState("payload"), L = S.useState("floatingParentNodeId"), $ = x.useRef(null), B = L != null;
  process.env.NODE_ENV !== "production" && V.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: z,
    triggerProps: H
  } = Ns(M);
  S.useSyncedValues({
    disabled: l,
    modal: V.type === void 0 ? a : void 0,
    openMethod: z,
    rootId: Lo()
  }), gs(S);
  const {
    forceUnmount: K
  } = hs(M, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  }), G = x.useRef(V.type !== "context-menu"), q = Bt();
  x.useEffect(() => {
    if (M || ($.current = null), V.type === "context-menu") {
      if (!M) {
        q.clear(), G.current = !1;
        return;
      }
      q.start(500, () => {
        G.current = !0;
      });
    }
  }, [q, M, V.type]), ke(() => {
    !M && !P && S.set("hoverEnabled", !0);
  }, [M, P, S]);
  const Q = x.useRef(!0), U = Bt(), X = we((de, Se) => {
    const Me = Se.reason;
    if (M === de && Se.trigger === T && O === Me || (Se.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !de && Se.trigger == null && (Se.trigger = T ?? void 0), r?.(de, Se), Se.isCanceled))
      return;
    S.state.floatingRootContext.dispatchOpenChange(de, Se);
    const Re = Se.event;
    if (de === !1 && Re?.type === "click" && Re.pointerType === "touch" && !Q.current)
      return;
    if (!de && _ !== null) {
      const Ne = S.context.itemDomElements.current[_];
      queueMicrotask(() => {
        Ne?.setAttribute("tabindex", "-1");
      });
    }
    de && Me === gr ? (Q.current = !1, U.start(300, () => {
      Q.current = !0;
    })) : (Q.current = !0, U.clear());
    const Ve = (Me === eo || Me === Yo) && Re.detail === 0 && Re?.isTrusted, Ze = !de && (Me === Rr || Me == null), Xe = {
      open: de,
      openChangeReason: Me
    };
    $.current = Se.event ?? null;
    const Be = Se.trigger?.id ?? null;
    (Be || de) && (Xe.activeTriggerId = Be, Xe.activeTriggerElement = Se.trigger ?? null), S.update(Xe), V.type === "menubar" && (Me === gr || Me === _o || Me === Ut || Me === Gr || Me === Fi) ? S.set("instantType", "group") : Ve || Ze ? S.set("instantType", Ve ? "click" : "dismiss") : S.set("instantType", void 0);
  }), te = x.useCallback(() => {
    S.setOpen(!1, De(ds));
  }, [S]);
  x.useImperativeHandle(d, () => ({
    unmount: K,
    close: te
  }), [K, te]);
  let re;
  V.type === "context-menu" && (re = V.context), x.useImperativeHandle(re?.positionerRef, () => k, [k]), x.useImperativeHandle(re?.actionsRef, () => ({
    setOpen: X
  }), [X]);
  const J = ys({
    popupStore: S,
    onOpenChange: X
  }), ie = J.context.events;
  x.useEffect(() => {
    const de = ({
      open: Se,
      eventDetails: Me
    }) => X(Se, Me);
    return ie.on("setOpen", de), () => {
      ie?.off("setOpen", de);
    };
  }, [ie, X]);
  const ce = kr(J, {
    enabled: !D,
    bubbles: {
      escapeKey: f && V.type === "menu"
    },
    outsidePress() {
      return V.type !== "context-menu" || $.current?.type === "contextmenu" ? !0 : G.current;
    },
    externalTree: B ? E : void 0
  }), oe = kd(J, {
    role: "menu"
  }), se = Es(), me = x.useCallback((de) => {
    S.select("activeIndex") !== de && S.set("activeIndex", de);
  }, [S]), pe = Nd(J, {
    enabled: !D,
    listRef: S.context.itemDomElements,
    activeIndex: _,
    nested: V.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: V.type === "menubar" ? V.context.orientation : void 0,
    rtl: se === "rtl",
    disabledIndices: Hn,
    onNavigate: me,
    openOnArrowKeyDown: V.type !== "context-menu",
    externalTree: B ? E : void 0,
    focusItemOnHover: b
  }), le = x.useCallback((de) => {
    S.context.typingRef.current = de;
  }, [S]), ge = Id(J, {
    listRef: S.context.itemLabels,
    elementsRef: S.context.itemDomElements,
    activeIndex: _,
    resetMs: Z8,
    onMatch: (de) => {
      M && de !== _ && S.set("activeIndex", de);
    },
    onTypingChange: le
  }), {
    getReferenceProps: j,
    getFloatingProps: ee,
    getItemProps: Y,
    getTriggerProps: Z
  } = ro([ce, oe, pe, ge]), ue = x.useMemo(() => {
    const de = cn(j(), {
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, H);
    return delete de.role, de;
  }, [j, S, H]), fe = x.useMemo(() => {
    const de = Z();
    if (!de)
      return de;
    const Se = cn(de, H);
    return delete Se.role, delete Se["aria-controls"], Se;
  }, [Z, H]), be = x.useMemo(() => ee({
    onMouseMove() {
      S.set("allowMouseEnter", !0), V.type === "menu" && S.set("hoverEnabled", !1);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(de) {
      const Se = S.select("keyboardEventRelay");
      Se && !de.isPropagationStopped() && Se(de);
    }
  }), [ee, V.type, S]), Ie = x.useMemo(() => Y(), [Y]);
  S.useSyncedValues({
    floatingRootContext: J,
    activeTriggerProps: ue,
    inactiveTriggerProps: fe,
    popupProps: be,
    itemProps: Ie
  });
  const ye = x.useMemo(() => ({
    store: S,
    parent: R
  }), [S, R]), xe = /* @__PURE__ */ g(ju.Provider, {
    value: ye,
    children: typeof n == "function" ? n({
      payload: A
    }) : n
  });
  return V.type === void 0 || V.type === "context-menu" ? /* @__PURE__ */ g(gd, {
    externalTree: E,
    children: xe
  }) : xe;
});
process.env.NODE_ENV !== "production" && (fi.displayName = "MenuRoot");
function g7(t) {
  const e = oo().store, n = x.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ g(_d.Provider, {
    value: n,
    children: /* @__PURE__ */ g(fi, {
      ...t
    })
  });
}
function Vd(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return e;
  const n = St(t), o = n.getComputedStyle(t, "::before"), r = n.getComputedStyle(t, "::after");
  if (!(o.content !== "none" || r.content !== "none"))
    return e;
  const s = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, a = parseFloat(r.width) || 0, c = parseFloat(r.height) || 0, u = Math.max(e.width, s, a), d = Math.max(e.height, l, c), f = u - e.width, p = d - e.height;
  return {
    left: e.left - f / 2,
    right: e.right + f / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
function C2(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Wu(), {
    ref: r,
    index: i
  } = Ao(t), s = n === i, l = x.useRef(null), a = Rn(r, l);
  return {
    compositeProps: x.useMemo(() => ({
      tabIndex: s ? 0 : -1,
      onFocus() {
        o(i);
      },
      onMouseMove() {
        const u = l.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !s && !d && u.focus();
      }
    }), [s, o, i, e]),
    compositeRef: a,
    index: i
  };
}
function Ad(t) {
  const {
    render: e,
    className: n,
    style: o,
    state: r = Et,
    props: i = Hn,
    refs: s = Hn,
    metadata: l,
    stateAttributesMapping: a,
    tag: c = "div",
    ...u
  } = t, {
    compositeProps: d,
    compositeRef: f
  } = C2({
    metadata: l
  });
  return Le(c, t, {
    state: r,
    ref: [...s, f],
    props: [d, ...i, u],
    stateAttributesMapping: a
  });
}
function w2(t) {
  if (wt(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!uo(t))
    return w2(ho(t));
}
function S2(t, e) {
  const n = x.useRef(null), o = we((i) => {
    yn.flushSync(() => {
      t.setOpen(!1, De(_o, i.nativeEvent, i.currentTarget));
    }), Y8(n.current)?.focus();
  }), r = we((i) => {
    const s = t.select("positionerElement");
    if (s && Yr(i, s))
      t.context.beforeContentFocusGuardRef.current?.focus();
    else {
      yn.flushSync(() => {
        t.setOpen(!1, De(_o, i.nativeEvent, i.currentTarget));
      });
      let l = G8(t.context.triggerFocusTargetRef.current || e.current);
      for (; l !== null && Fe(s, l); ) {
        const a = l;
        if (l = ld(l), l === a)
          break;
      }
      l?.focus();
    }
  });
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: o,
    handleFocusTargetFocus: r
  };
}
function h7(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = x.useRef(!1);
  return x.useMemo(() => e ? {
    onMouseDown: (i) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, nt(i.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (i) => {
      r.current && (r.current = !1, i.preventBaseUIHandler());
    }
  } : Et, [e, n, o]);
}
const al = 2, R2 = e2(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    openOnHover: a,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    style: p,
    ...m
  } = e, h = oo(!0), b = d?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : st(85));
  const v = Ot(l), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), S = v7(), E = Wu(!0), N = rr(), I = x.useMemo(() => N ?? new dd(), [N]), M = va(I), T = Co(), {
    registerTrigger: k,
    isMountedByThisTrigger: P
  } = ms(v, R, b, {
    payload: f,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: I,
    floatingNodeId: M,
    floatingParentNodeId: T,
    keyboardEventRelay: E?.relayKeyboardEvent
  }), D = S.type === "menubar", O = b.useState("disabled"), V = i || O || D && S.context.disabled, {
    getButtonProps: _,
    buttonRef: A
  } = qt({
    disabled: V,
    native: s
  });
  x.useEffect(() => {
    !w && S.type === void 0 && (b.context.allowMouseUpTriggerRef.current = !1);
  }, [b, w, S.type]);
  const L = x.useRef(null), $ = Bt(), B = we((pe) => {
    if (!L.current)
      return;
    $.clear(), b.context.allowMouseUpTriggerRef.current = !1;
    const le = pe.target;
    if (Fe(L.current, le) || Fe(b.select("positionerElement"), le) || le === L.current || le != null && w2(le) === b.select("rootId"))
      return;
    const ge = Vd(L.current);
    pe.clientX >= ge.left - al && pe.clientX <= ge.right + al && pe.clientY >= ge.top - al && pe.clientY <= ge.bottom + al || I.events.emit("close", {
      domEvent: pe,
      reason: ih
    });
  });
  x.useEffect(() => {
    w && b.select("lastOpenChangeReason") === Ut && nt(L.current).addEventListener("mouseup", B, {
      once: !0
    });
  }, [w, B, b]);
  const z = D && S.context.hasSubmenuOpen, K = xs(y, {
    enabled: (a ?? z) && !V && S.type !== "context-menu" && (!D || z && !P),
    handleClose: Cs({
      blockPointerEvents: !D
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: R,
    externalTree: I,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), G = b7(w, b.select("lastOpenChangeReason")), q = Nr(y, {
    enabled: !V && S.type !== "context-menu",
    event: w && D ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? G : !1
  }), Q = Rd(y, {
    enabled: !V && z
  }), U = h7({
    open: w,
    enabled: D,
    mouseDownAction: "open"
  }), X = ro([q, Q]), te = {
    disabled: V,
    open: w
  }, re = b.useState("triggerProps", P), J = [L, n, A, k, R], ie = [X.getReferenceProps(), K ?? Et, re, {
    "aria-haspopup": "menu",
    id: v,
    onMouseDown: (pe) => {
      if (b.select("open"))
        return;
      $.start(200, () => {
        b.context.allowMouseUpTriggerRef.current = !0;
      }), nt(pe.currentTarget).addEventListener("mouseup", B, {
        once: !0
      });
    }
  }, D ? {
    role: "menuitem"
  } : {}, U, m, _], {
    preFocusGuardRef: ce,
    handlePreFocusGuardFocus: oe,
    handleFocusTargetFocus: se
  } = S2(b, R), me = Le("button", e, {
    enabled: !D,
    stateAttributesMapping: qi,
    state: te,
    ref: J,
    props: ie
  });
  return D ? /* @__PURE__ */ g(Ad, {
    tag: "button",
    render: o,
    className: r,
    style: p,
    state: te,
    refs: J,
    props: ie,
    stateAttributesMapping: qi
  }) : w ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(Bn, {
      ref: ce,
      onFocus: oe
    }, `${v}-pre-focus-guard`), /* @__PURE__ */ g(x.Fragment, {
      children: me
    }, v), /* @__PURE__ */ g(Bn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: se
    }, `${v}-post-focus-guard`)]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: me
  }, v);
});
process.env.NODE_ENV !== "production" && (R2.displayName = "MenuTrigger");
function b7(t, e) {
  const n = Bt(), [o, r] = x.useState(!1);
  return ke(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(Fh, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function v7() {
  const t = pa(!0), e = oo(!0), n = y2();
  return x.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
function y7(t) {
  const [e, n] = x.useState({
    current: t,
    previous: null
  });
  return t !== e.current && n({
    current: t,
    previous: e.current
  }), e.previous;
}
function E2(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
const N2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: i,
    id: s,
    nativeButton: l = !1,
    openOnHover: a = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    style: f,
    ...p
  } = e, m = Ao(), h = cs(), {
    store: b
  } = oo(), v = Ot(s), C = b.useState("open"), y = b.useState("floatingRootContext"), w = b.useState("floatingTreeRoot"), R = t2(v, b), S = x.useCallback((q) => {
    const Q = R(q);
    return q !== null && b.select("open") && b.select("activeTriggerId") == null && b.update({
      activeTriggerId: v,
      activeTriggerElement: q,
      closeDelay: u
    }), Q;
  }, [R, u, b, v]), E = x.useRef(null), N = x.useCallback((q) => {
    E.current = q, b.set("activeTriggerElement", q);
  }, [b]);
  process.env.NODE_ENV !== "production" && ke(() => {
    const q = E.current;
    if (q && E2(q) && !d) {
      const Q = br.captureOwnerStack?.() || "";
      sa(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${Q}`);
    }
  });
  const I = x2();
  if (!I?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : st(37));
  b.useSyncedValue("closeDelay", u);
  const M = I.parentMenu, T = M.useState("itemProps"), k = M.useState("isActive", m.index), P = x.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      M.set("activeIndex", m.index);
    }
  }), [M, m.index]), D = b.useState("disabled"), O = d || D, {
    getItemProps: V,
    itemRef: _
  } = ma({
    closeOnClick: !1,
    disabled: O,
    highlighted: k,
    id: v,
    store: b,
    typingRef: M.context.typingRef,
    nativeButton: l,
    itemMetadata: P,
    nodeId: h?.context.nodeId
  }), A = b.useState("hoverEnabled"), L = M.useState("allowMouseEnter"), $ = xs(y, {
    enabled: A && a && !O,
    handleClose: Cs({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: L ? {
      open: c,
      close: u
    } : 0,
    triggerElementRef: E,
    externalTree: w,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), B = Nr(y, {
    enabled: !O,
    event: "mousedown",
    toggle: !a,
    ignoreMouse: a,
    stickIfOpen: !1
  }), z = ro([B]), H = b.useState("triggerProps", !0);
  return delete H.id, Le("div", e, {
    state: {
      disabled: O,
      highlighted: k,
      open: C
    },
    stateAttributesMapping: Sr,
    props: [z.getReferenceProps(), $, H, T, {
      tabIndex: C || k ? 0 : -1,
      onBlur() {
        k && M.set("activeIndex", null);
      }
    }, p, V],
    ref: [n, m.ref, _, S, N]
  });
});
process.env.NODE_ENV !== "production" && (N2.displayName = "MenuSubmenuTrigger");
const Ld = yo({
  blockingLayerHost: null,
  portalHost: null
});
function en() {
  return Cn(Ld).portalHost ?? void 0;
}
function x7() {
  return Cn(Ld).blockingLayerHost ?? void 0;
}
function C7() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const w7 = ae(["rounded-(--radius-sm)", "border", "border-solid", "border-menu-default-outline", "bg-menu-default-background", "shadow-elevation-3", "p-(--spacing-4)", "flex", "flex-col", "max-h-[min(20rem,calc(100vh-2rem))]", "overflow-y-auto", "overscroll-contain", "outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"], {
  variants: {
    size: {
      sm: "w-[180px]",
      md: "w-[296px]",
      lg: "w-[400px]",
      anchor: "w-[var(--anchor-width)]",
      trigger: "w-[max(180px,var(--anchor-width))] max-w-[calc(100vw-var(--spacing-16))]",
      auto: "w-auto min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), S7 = ae(["flex", "h-[36px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[selected]:bg-menu-item-selected", "data-[checked]:bg-menu-item-selected", "[&[data-highlighted]:active]:bg-menu-item-pressed", "[&[data-selected]:active]:bg-menu-item-pressed", "[&[data-checked]:active]:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "data-[disabled]:hover:bg-transparent"], {
  variants: {
    tone: {
      default: "",
      destructive: ["text-menu-text-destructive", "[&_svg]:text-menu-icon-destructive"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
}), R7 = ne("flex", "h-(--spacing-24)", "w-full", "items-center", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-4)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle", "select-none", "data-[disabled]:text-menu-text-disabled-sub");
function pi({
  size: t,
  className: e
}) {
  return ne(w7({
    size: t
  }), e);
}
function xr(t) {
  const e = W.c(19), {
    children: n,
    leadingIcon: o,
    endSection: r,
    checked: i,
    checkbox: s,
    submenu: l
  } = t;
  let a;
  e[0] !== s || e[1] !== i ? (a = s && /* @__PURE__ */ g(E7, { checked: i }), e[0] = s, e[1] = i, e[2] = a) : a = e[2];
  let c;
  e[3] !== o ? (c = o && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit" }) }), e[3] = o, e[4] = c) : c = e[4];
  let u;
  e[5] !== n ? (u = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[5] = n, e[6] = u) : u = e[6];
  let d;
  e[7] !== s || e[8] !== i ? (d = i && !s && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ue, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[7] = s, e[8] = i, e[9] = d) : d = e[9];
  let f;
  e[10] !== r || e[11] !== l ? (f = l ? /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ue, { name: "chevron-right", size: "xs", tone: "inherit" }) }) : r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[10] = r, e[11] = l, e[12] = f) : f = e[12];
  let p;
  return e[13] !== a || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F(_t, { children: [
    a,
    c,
    u,
    d,
    f
  ] }), e[13] = a, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function E7(t) {
  const e = W.c(7), {
    checked: n
  } = t, o = n ? "" : void 0, r = n ? "" : void 0;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "h-(--icon-xs)", "w-(--icon-xs)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-[1.5px]", "border-checkbox-outline-default-border", "bg-surface-container-lowest", "text-transparent", "transition-colors", "duration-200", "ease-in-out", "data-[checked]:border-transparent", "data-[checked]:bg-checkbox-filled-default-background", "data-[checked]:text-surface-container-lowest", "[[data-disabled]_&]:border-transparent", "[[data-disabled]_&]:bg-checkbox-filled-disabled-background", "[[data-disabled]_&]:text-surface-container-lowest"), e[0] = i) : i = e[0];
  let s;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("span", { className: "h-[calc(var(--icon-xs)*0.8)] w-[calc(var(--icon-xs)*0.8)]", children: /* @__PURE__ */ g(C7, {}) }), e[1] = s) : s = e[1];
  let l;
  e[2] !== r ? (l = /* @__PURE__ */ g("span", { "data-checked": r, className: i, children: s }), e[2] = r, e[3] = l) : l = e[3];
  let a;
  return e[4] !== o || e[5] !== l ? (a = /* @__PURE__ */ g("span", { "aria-hidden": "true", "data-checked": o, className: "inline-flex h-(--icon-sm) w-(--icon-sm) shrink-0 items-center justify-center", children: l }), e[4] = o, e[5] = l, e[6] = a) : a = e[6], a;
}
function bo({
  tone: t,
  className: e
}) {
  return ne(S7({
    tone: t
  }), e);
}
const N7 = 13;
function Fd(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(fi, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function qo(t) {
  const e = W.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g(R2, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function Dr(t) {
  const e = W.c(29);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    side: l,
    align: a,
    sideOffset: c,
    alignOffset: u,
    size: s,
    className: o,
    positionerClassName: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = l === void 0 ? "bottom" : l, f = a === void 0 ? "start" : a, p = c === void 0 ? 4 : c, m = u === void 0 ? 0 : u, h = en();
  let b;
  e[10] !== r ? (b = ne("z-[var(--z-layer-popover)]", r), e[10] = r, e[11] = b) : b = e[11];
  let v;
  e[12] !== o || e[13] !== s ? (v = pi({
    size: s,
    className: o
  }), e[12] = o, e[13] = s, e[14] = v) : v = e[14];
  let C;
  e[15] !== n || e[16] !== i || e[17] !== v ? (C = /* @__PURE__ */ g(c2, { className: v, ...i, children: n }), e[15] = n, e[16] = i, e[17] = v, e[18] = C) : C = e[18];
  let y;
  e[19] !== f || e[20] !== m || e[21] !== d || e[22] !== p || e[23] !== b || e[24] !== C ? (y = /* @__PURE__ */ g(m2, { side: d, align: f, sideOffset: p, alignOffset: m, className: b, children: C }), e[19] = f, e[20] = m, e[21] = d, e[22] = p, e[23] = b, e[24] = C, e[25] = y) : y = e[25];
  let w;
  return e[26] !== h || e[27] !== y ? (w = /* @__PURE__ */ g(u2, { container: h, children: y }), e[26] = h, e[27] = y, e[28] = w) : w = e[28], w;
}
function hr(t) {
  const e = W.c(36);
  let n, o, r, i, s, l, a;
  if (e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    submenu: l,
    tone: a,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]), l != null) {
    let f;
    if (e[8] !== s) {
      const {
        closeOnClick: C,
        ...y
      } = s;
      f = y, e[8] = s, e[9] = f;
    } else
      f = e[9];
    let p;
    e[10] !== o || e[11] !== a ? (p = bo({
      tone: a,
      className: o
    }), e[10] = o, e[11] = a, e[12] = p) : p = e[12];
    let m;
    e[13] !== n || e[14] !== i ? (m = /* @__PURE__ */ g(xr, { leadingIcon: i, submenu: !0, children: n }), e[13] = n, e[14] = i, e[15] = m) : m = e[15];
    let h;
    e[16] !== p || e[17] !== m || e[18] !== f ? (h = /* @__PURE__ */ g(N2, { className: p, ...f, children: m }), e[16] = p, e[17] = m, e[18] = f, e[19] = h) : h = e[19];
    let b;
    e[20] !== l ? (b = /* @__PURE__ */ g(Dr, { side: "right", align: "start", sideOffset: N7, alignOffset: -4, size: "sm", children: l }), e[20] = l, e[21] = b) : b = e[21];
    let v;
    return e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F(g7, { children: [
      h,
      b
    ] }), e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
  }
  let c;
  e[25] !== o || e[26] !== a ? (c = bo({
    tone: a,
    className: o
  }), e[25] = o, e[26] = a, e[27] = c) : c = e[27];
  let u;
  e[28] !== n || e[29] !== r || e[30] !== i ? (u = /* @__PURE__ */ g(xr, { leadingIcon: i, endSection: r, children: n }), e[28] = n, e[29] = r, e[30] = i, e[31] = u) : u = e[31];
  let d;
  return e[32] !== s || e[33] !== c || e[34] !== u ? (d = /* @__PURE__ */ g(fh, { className: c, ...s, children: u }), e[32] = s, e[33] = c, e[34] = u, e[35] = d) : d = e[35], d;
}
function $d(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(g2, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Hd(t) {
  const e = W.c(21);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o ? (l = bo({
    className: o
  }), e[6] = o, e[7] = l) : l = e[7];
  let a;
  e[8] !== i ? (a = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ue, { name: i, size: "xs", tone: "inherit" }) }), e[8] = i, e[9] = a) : a = e[9];
  let c;
  e[10] !== n ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g(b2, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ue, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[12] = u) : u = e[12];
  let d;
  e[13] !== r ? (d = r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[13] = r, e[14] = d) : d = e[14];
  let f;
  return e[15] !== s || e[16] !== l || e[17] !== a || e[18] !== c || e[19] !== d ? (f = /* @__PURE__ */ F(h2, { className: l, ...s, children: [
    a,
    c,
    u,
    d
  ] }), e[15] = s, e[16] = l, e[17] = a, e[18] = c, e[19] = d, e[20] = f) : f = e[20], f;
}
function k7(t) {
  const e = W.c(19);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: o,
    leadingIcon: s,
    endSection: i,
    checked: n,
    className: r,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== r ? (a = bo({
    className: r
  }), e[7] = r, e[8] = a) : a = e[8];
  let c;
  e[9] !== n || e[10] !== o || e[11] !== i || e[12] !== s ? (c = /* @__PURE__ */ g(xr, { leadingIcon: s, endSection: i, checked: n, checkbox: !0, children: o }), e[9] = n, e[10] = o, e[11] = i, e[12] = s, e[13] = c) : c = e[13];
  let u;
  return e[14] !== n || e[15] !== l || e[16] !== a || e[17] !== c ? (u = /* @__PURE__ */ g(dh, { checked: n, className: a, ...l, children: c }), e[14] = n, e[15] = l, e[16] = a, e[17] = c, e[18] = u) : u = e[18], u;
}
function bu(t) {
  const e = W.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    disabled: r,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r ? "" : void 0, l = r || void 0;
  let a;
  e[5] !== o ? (a = ne(R7, o), e[5] = o, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== i || e[9] !== s || e[10] !== l || e[11] !== a ? (c = /* @__PURE__ */ g("div", { role: "presentation", "data-disabled": s, "aria-disabled": l, className: a, ...i, children: n }), e[7] = n, e[8] = i, e[9] = s, e[10] = l, e[11] = a, e[12] = c) : c = e[12], c;
}
const zd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zd.displayName = "TooltipRootContext");
function ks(t) {
  const e = x.useContext(zd);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : st(72));
  return e;
}
const I7 = {
  ...vs,
  disabled: he((t) => t.disabled),
  instantType: he((t) => t.instantType),
  isInstantPhase: he((t) => t.isInstantPhase),
  trackCursorAxis: he((t) => t.trackCursorAxis),
  disableHoverablePopup: he((t) => t.disableHoverablePopup),
  lastOpenChangeReason: he((t) => t.openChangeReason),
  closeOnClick: he((t) => t.closeOnClick),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport)
};
class Bd extends Ir {
  constructor(e) {
    super({
      ...P7(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Pr()
    }, I7);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Ut, i = e && o === gr, s = !e && (o === eo || o === Rr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e,
        openChangeReason: o
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Ut && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? yn.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Lt(() => new Bd(n)).current, r = e ?? o, i = ys({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function P7() {
  return {
    ...bs(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Wd = xd(function(e) {
  const {
    disabled: n = !1,
    defaultOpen: o = !1,
    open: r,
    disableHoverablePopup: i = !1,
    trackCursorAxis: s = "none",
    actionsRef: l,
    onOpenChange: a,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: p
  } = e, m = Bd.useStore(u?.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d
  });
  Or(() => {
    r === void 0 && m.state.open === !1 && o === !0 && m.update({
      open: !0,
      activeTriggerId: f
    });
  }), m.useControlledProp("openProp", r), m.useControlledProp("triggerIdProp", d), m.useContextCallback("onOpenChange", a), m.useContextCallback("onOpenChangeComplete", c);
  const h = m.useState("open"), b = !n && h, v = m.useState("activeTriggerId"), C = m.useState("payload");
  m.useSyncedValues({
    trackCursorAxis: s,
    disableHoverablePopup: i
  }), ke(() => {
    h && n && m.setOpen(!1, De(h8));
  }, [h, n, m]), m.useSyncedValue("disabled", n), gs(m);
  const {
    forceUnmount: y,
    transitionStatus: w
  } = hs(b, m), R = m.select("floatingRootContext"), S = m.useState("isInstantPhase"), E = m.useState("instantType"), N = m.useState("lastOpenChangeReason"), I = x.useRef(null);
  ke(() => {
    w === "ending" && N === At || w !== "ending" && S ? (E !== "delay" && (I.current = E), m.set("instantType", "delay")) : I.current !== null && (m.set("instantType", I.current), I.current = null);
  }, [w, S, N, E, m]), ke(() => {
    b && v == null && m.set("payload", void 0);
  }, [m, v, b]);
  const M = x.useCallback(() => {
    m.setOpen(!1, De(ds));
  }, [m]);
  x.useImperativeHandle(l, () => ({
    unmount: y,
    close: M
  }), [y, M]);
  const T = kr(R, {
    enabled: !n,
    referencePress: () => m.select("closeOnClick")
  }), k = l6(R, {
    enabled: !n && s !== "none",
    axis: s === "none" ? void 0 : s
  }), {
    getReferenceProps: P,
    getFloatingProps: D,
    getTriggerProps: O
  } = ro([T, k]), V = x.useMemo(() => P(), [P]), _ = x.useMemo(() => O(), [O]), A = x.useMemo(() => D(), [D]);
  return m.useSyncedValues({
    activeTriggerProps: V,
    inactiveTriggerProps: _,
    popupProps: A
  }), /* @__PURE__ */ g(zd.Provider, {
    value: m,
    children: typeof p == "function" ? p({
      payload: C
    }) : p
  });
});
process.env.NODE_ENV !== "production" && (Wd.displayName = "TooltipRoot");
const Ud = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ud.displayName = "TooltipProviderContext");
function M7() {
  return x.useContext(Ud);
}
let T7 = (function(t) {
  return t[t.popupOpen = $l.popupOpen] = "popupOpen", t.triggerDisabled = "data-trigger-disabled", t;
})({});
const O7 = 600, Gd = e2(function(e, n) {
  const {
    className: o,
    render: r,
    handle: i,
    payload: s,
    disabled: l,
    delay: a,
    closeOnClick: c = !0,
    closeDelay: u,
    id: d,
    style: f,
    ...p
  } = e, m = ks(!0), h = i?.store ?? m;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : st(82));
  const b = Ot(d), v = h.useState("isTriggerActive", b), C = h.useState("isOpenedByTrigger", b), y = h.useState("floatingRootContext"), w = x.useRef(null), R = a ?? O7, S = u ?? 0, {
    registerTrigger: E,
    isMountedByThisTrigger: N
  } = ms(b, w, h, {
    payload: s,
    closeOnClick: c,
    closeDelay: S
  }), I = M7(), {
    delayRef: M,
    isInstantPhase: T,
    hasProvider: k
  } = k8(y, {
    open: C
  });
  h.useSyncedValue("isInstantPhase", T);
  const P = h.useState("disabled"), D = l ?? P, O = h.useState("trackCursorAxis"), V = h.useState("disableHoverablePopup"), _ = xs(y, {
    enabled: !D,
    mouseOnly: !0,
    move: !1,
    handleClose: !V && O !== "both" ? Cs() : null,
    restMs() {
      const z = I?.delay, H = typeof M.current == "object" ? M.current.open : void 0;
      let K = R;
      return k && (H !== 0 ? K = a ?? z ?? R : K = 0), K;
    },
    delay() {
      const z = typeof M.current == "object" ? M.current.close : void 0;
      let H = S;
      return u == null && k && (H = z), {
        close: H
      };
    },
    triggerElementRef: w,
    isActiveTrigger: v,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), A = Rd(y, {
    enabled: !D
  }).reference, L = {
    open: C
  }, $ = h.useState("triggerProps", N);
  return Le("button", e, {
    state: L,
    ref: [n, E, w],
    props: [_, A, $, {
      onPointerDown() {
        h.set("closeOnClick", c);
      },
      id: b,
      [T7.triggerDisabled]: D ? "" : void 0
    }, p],
    stateAttributesMapping: Sr
  });
});
process.env.NODE_ENV !== "production" && (Gd.displayName = "TooltipTrigger");
const Yd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yd.displayName = "TooltipPortalContext");
function D7() {
  const t = x.useContext(Yd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : st(70));
  return t;
}
const Ra = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    style: l,
    ...a
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = zh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: a
  });
  return !u && !c ? null : /* @__PURE__ */ F(x.Fragment, {
    children: [u, c && /* @__PURE__ */ yn.createPortal(o, c)]
  });
});
process.env.NODE_ENV !== "production" && (Ra.displayName = "FloatingPortalLite");
const jd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return ks().useState("mounted") || o ? /* @__PURE__ */ g(Yd.Provider, {
    value: o,
    children: /* @__PURE__ */ g(Ra, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (jd.displayName = "TooltipPortal");
const Kd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Kd.displayName = "TooltipPositionerContext");
function k2() {
  const t = x.useContext(Kd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : st(71));
  return t;
}
const qd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "top",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = ba,
    style: v,
    ...C
  } = e, y = ks(), w = D7(), R = y.useState("open"), S = y.useState("mounted"), E = y.useState("trackCursorAxis"), N = y.useState("disableHoverablePopup"), I = y.useState("floatingRootContext"), M = y.useState("instantType"), T = y.useState("transitionStatus"), k = y.useState("hasViewport"), P = ai({
    anchor: i,
    positionMethod: s,
    floatingRootContext: I,
    mounted: S,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    arrowPadding: p,
    disableAnchorTracking: h,
    keepMounted: w,
    collisionAvoidance: b,
    adaptiveOrigin: k ? wa : void 0
  }), D = x.useMemo(() => ({
    open: R,
    side: P.side,
    align: P.align,
    anchorHidden: P.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : M
  }), [R, P.side, P.align, P.anchorHidden, E, M]), O = di(e, D, {
    styles: P.positionerStyles,
    transitionStatus: T,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !S,
    inert: !R || E === "both" || N
  });
  return /* @__PURE__ */ g(Kd.Provider, {
    value: P,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (qd.displayName = "TooltipPositioner");
const _7 = {
  ...An,
  ...Kt
}, Zd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = ks(), {
    side: a,
    align: c
  } = k2(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  Jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = l.useState("disabled"), b = l.useState("closeDelay");
  return xa(m, {
    enabled: !h,
    closeDelay: b
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Mr(f), s],
    stateAttributesMapping: _7
  });
});
process.env.NODE_ENV !== "production" && (Zd.displayName = "TooltipPopup");
const Xd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = ks(), a = l.useState("open"), c = l.useState("instantType"), {
    arrowRef: u,
    side: d,
    align: f,
    arrowUncentered: p,
    arrowStyles: m
  } = k2();
  return Le("div", e, {
    state: {
      open: a,
      side: d,
      align: f,
      uncentered: p,
      instant: c
    },
    ref: [n, u],
    props: [{
      style: m,
      "aria-hidden": !0
    }, s],
    stateAttributesMapping: An
  });
});
process.env.NODE_ENV !== "production" && (Xd.displayName = "TooltipArrow");
const I2 = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, i = x.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), s = x.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ g(Ud.Provider, {
    value: i,
    children: /* @__PURE__ */ g(N8, {
      delay: s,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (I2.displayName = "TooltipProvider");
const P2 = "z-[var(--z-layer-tooltip)]", M2 = 5, T2 = 9, O2 = ne("max-w-[240px]", "rounded-(--radius-sm)", "px-(--spacing-12) py-(--spacing-8)", "bg-surface-inverse-surface", "text-text-inverse", "shadow-elevation-2", "font-(family-name:--font-family-body)", "transition-opacity duration-150 ease-in-out", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0"), D2 = ne("text-(length:--font-size-label-small)", "leading-(--font-line-height-16)"), _2 = ne("text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "mt-(--spacing-4)"), V2 = ne("bg-surface-inverse-surface", "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)", "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)", "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)", "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)", "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]", "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]", "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]", "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]");
function Xo(t) {
  const e = W.c(30), {
    children: n,
    label: o,
    description: r,
    endSection: i,
    side: s,
    align: l,
    disabled: a,
    showArrow: c
  } = t, u = s === void 0 ? "top" : s, d = l === void 0 ? "center" : l, f = a === void 0 ? !1 : a, p = c === void 0 ? !0 : c, m = en();
  let h;
  e[0] !== n ? (h = /* @__PURE__ */ g(Gd, { render: n }), e[0] = n, e[1] = h) : h = e[1];
  const b = p ? T2 : M2;
  let v;
  e[2] !== p ? (v = p && /* @__PURE__ */ g(Xd, { "data-slot": "tooltip-arrow", className: V2 }), e[2] = p, e[3] = v) : v = e[3];
  const C = r ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let y;
  e[4] !== C ? (y = ne(D2, C), e[4] = C, e[5] = y) : y = e[5];
  let w;
  e[6] !== o || e[7] !== y ? (w = /* @__PURE__ */ g("p", { className: y, children: o }), e[6] = o, e[7] = y, e[8] = w) : w = e[8];
  let R;
  e[9] !== i || e[10] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-8)", children: [
    w,
    i
  ] }), e[9] = i, e[10] = w, e[11] = R) : R = e[11];
  let S;
  e[12] !== r ? (S = r && /* @__PURE__ */ g("p", { className: _2, children: r }), e[12] = r, e[13] = S) : S = e[13];
  let E;
  e[14] !== R || e[15] !== S || e[16] !== v ? (E = /* @__PURE__ */ F(Zd, { className: O2, children: [
    v,
    R,
    S
  ] }), e[14] = R, e[15] = S, e[16] = v, e[17] = E) : E = e[17];
  let N;
  e[18] !== d || e[19] !== u || e[20] !== E || e[21] !== b ? (N = /* @__PURE__ */ g(qd, { side: u, align: d, sideOffset: b, className: P2, children: E }), e[18] = d, e[19] = u, e[20] = E, e[21] = b, e[22] = N) : N = e[22];
  let I;
  e[23] !== m || e[24] !== N ? (I = /* @__PURE__ */ g(jd, { container: m, children: N }), e[23] = m, e[24] = N, e[25] = I) : I = e[25];
  let M;
  return e[26] !== f || e[27] !== I || e[28] !== h ? (M = /* @__PURE__ */ F(Wd, { disabled: f, children: [
    h,
    I
  ] }), e[26] = f, e[27] = I, e[28] = h, e[29] = M) : M = e[29], M;
}
function Is() {
  const t = W.c(10), [e, n] = x.useState(!1);
  let o, r;
  t[0] !== e ? (o = () => {
    if (!e)
      return;
    const u = function() {
      n(!1);
    };
    return document.addEventListener("mouseup", u), document.addEventListener("dragend", u), window.addEventListener("blur", u), () => {
      document.removeEventListener("mouseup", u), document.removeEventListener("dragend", u), window.removeEventListener("blur", u);
    };
  }, r = [e], t[0] = e, t[1] = o, t[2] = r) : (o = t[1], r = t[2]), x.useEffect(o, r);
  const i = e ? "" : void 0;
  let s, l;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = (u) => {
    u.defaultPrevented || u.button !== 0 || n(!0);
  }, l = () => n(!1), t[3] = s, t[4] = l) : (s = t[3], l = t[4]);
  let a;
  t[5] !== i ? (a = {
    "data-mouse-down": i,
    onMouseDown: s,
    onMouseUp: l
  }, t[5] = i, t[6] = a) : a = t[6];
  let c;
  return t[7] !== e || t[8] !== a ? (c = {
    mouseDown: e,
    triggerMouseDownProps: a
  }, t[7] = e, t[8] = a, t[9] = c) : c = t[9], c;
}
function V7(t) {
  const e = W.c(17), {
    align: n,
    disabled: o,
    items: r,
    size: i,
    tooltip: s,
    variant: l,
    ...a
  } = t, c = n === void 0 ? "end" : n, u = o === void 0 ? !1 : o, d = i === void 0 ? "md" : i, f = l === void 0 ? "default" : l, [p, m] = x.useState(!1), {
    triggerMouseDownProps: h
  } = Is();
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = function(T) {
    m(T);
  }, e[0] = b) : b = e[0];
  const v = b, C = F7({
    disabled: u,
    isOpen: p,
    props: a,
    size: d,
    tooltip: s,
    triggerMouseDownProps: h,
    variant: f
  }), y = f === "combo" && "gap-(--spacing-4)";
  let w;
  e[1] !== y ? (w = ne("inline-flex items-center", y), e[1] = y, e[2] = w) : w = e[2];
  let R;
  e[3] !== w || e[4] !== C ? (R = /* @__PURE__ */ g("div", { className: w, children: C }), e[3] = w, e[4] = C, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] !== r ? (E = r.map(A7), e[6] = r, e[7] = E) : E = e[7];
  let N;
  e[8] !== c || e[9] !== E ? (N = /* @__PURE__ */ g(Dr, { align: c, sideOffset: 5, size: "trigger", children: E }), e[8] = c, e[9] = E, e[10] = N) : N = e[10];
  let I;
  return e[11] !== u || e[12] !== v || e[13] !== p || e[14] !== N || e[15] !== S ? (I = /* @__PURE__ */ F(Fd, { open: p, onOpenChange: v, disabled: u, modal: !1, children: [
    S,
    N
  ] }), e[11] = u, e[12] = v, e[13] = p, e[14] = N, e[15] = S, e[16] = I) : I = e[16], I;
}
function A7(t) {
  return t.type === "subheader" ? /* @__PURE__ */ g(bu, { disabled: t.disabled, children: t.label }, t.id) : L7(t);
}
function Bp(t) {
  return /* @__PURE__ */ g(hr, { disabled: t.disabled, endSection: t.endSection, leadingIcon: t.leadingIcon, onClick: t.onSelect, tone: t.tone, children: t.label }, t.id);
}
function L7(t) {
  return t.submenuItems ? /* @__PURE__ */ g(hr, { disabled: t.disabled, leadingIcon: t.leadingIcon, tone: t.tone, submenu: t.submenuItems.map(Bp), children: t.label }, t.id) : Bp(t);
}
function F7({
  disabled: t,
  isOpen: e,
  props: n,
  size: o,
  tooltip: r,
  triggerMouseDownProps: i,
  variant: s
}) {
  const l = o === "lg" ? "md" : o, a = o === "lg" ? {
    width: 44,
    height: 44
  } : void 0;
  if (s === "combo") {
    const {
      buttonVariant: p = "outline",
      label: m,
      onPrimaryAction: h
    } = n, b = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(bt, { "aria-label": `${m} menu`, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: l, style: a, variant: p, ...i }) });
    return /* @__PURE__ */ F(_t, { children: [
      /* @__PURE__ */ g(j1, { disabled: t, onClick: h, size: o, variant: p, children: m }),
      r ? /* @__PURE__ */ g(Xo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: b }) }) : b
    ] });
  }
  if (s === "overflow") {
    const {
      "aria-label": p,
      icon: m = "ellipsis-dots"
    } = n, h = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(bt, { "aria-label": p, disabled: t, icon: m, size: l, style: a, variant: "outline", ...i }) });
    return r ? /* @__PURE__ */ g(Xo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: h }) }) : h;
  }
  const {
    "aria-label": c,
    label: u
  } = n, d = {};
  c && (d["aria-label"] = c);
  const f = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(j1, { ...d, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: o, variant: "outline", ...i, children: u }) });
  return r ? $7(f, r) : f;
}
function $7(t, e) {
  return /* @__PURE__ */ g(Xo, { label: e, side: "top", align: "end", showArrow: !0, children: t });
}
const H7 = {
  xs: "size-(--spacing-40)",
  sm: "size-[60px]",
  md: "size-(--spacing-80)",
  lg: "size-[104px]",
  xl: "size-[120px]"
}, z7 = {
  xs: 40,
  sm: 60,
  md: 80,
  lg: 104,
  xl: 120
}, B7 = {
  xs: "6 6",
  sm: "8 6",
  md: "8 6",
  lg: "8 6",
  xl: "8 6"
}, W7 = {
  xs: 4,
  sm: 4,
  md: 0,
  lg: 2,
  xl: 0
};
function ql(t) {
  const e = W.c(21), {
    size: n,
    fullWidth: o,
    src: r,
    alt: i,
    selected: s,
    onClick: l,
    "aria-label": a,
    onImageError: c
  } = t, u = n === void 0 ? "md" : n, f = (o === void 0 ? !1 : o) ? "aspect-square w-full" : H7[u], p = u === "sm" ? "focus-visible:ring-offset-1" : "focus-visible:ring-offset-2", m = !!l, h = s !== void 0, b = s === !1 && "opacity-50", v = s && "outline-solid outline-2 outline-primary outline-offset-2";
  let C;
  e[0] !== p || e[1] !== m || e[2] !== f || e[3] !== b || e[4] !== v ? (C = ne("relative inline-flex items-center justify-center shrink-0 overflow-hidden", f, "rounded-(--radius-sm)", b, v, m && ["cursor-pointer", "focus-visible:outline-none", "focus-visible:ring-2", p, "focus-visible:ring-datavis-blue-30"]), e[0] = p, e[1] = m, e[2] = f, e[3] = b, e[4] = v, e[5] = C) : C = e[5];
  const y = C;
  let w;
  e[6] !== i || e[7] !== c || e[8] !== u || e[9] !== f || e[10] !== r ? (w = r ? /* @__PURE__ */ g("img", { src: r, alt: i, className: ne(f, "object-cover"), onError: c }) : /* @__PURE__ */ F("div", { "data-slot": "thumbnail-frame", className: ne(f, "relative flex items-center justify-center rounded-(--radius-sm) bg-surface-container-lowest text-icon-main"), children: [
    /* @__PURE__ */ g(U7, { size: u }),
    /* @__PURE__ */ g(Ue, { name: "image-regular", size: u, tone: "inherit" })
  ] }), e[6] = i, e[7] = c, e[8] = u, e[9] = f, e[10] = r, e[11] = w) : w = e[11];
  const R = w;
  if (m) {
    const E = h ? s : void 0;
    let N;
    return e[12] !== a || e[13] !== l || e[14] !== y || e[15] !== E || e[16] !== R ? (N = /* @__PURE__ */ g(no, { type: "button", className: y, "aria-label": a, "aria-pressed": E, onClick: l, children: R }), e[12] = a, e[13] = l, e[14] = y, e[15] = E, e[16] = R, e[17] = N) : N = e[17], N;
  }
  let S;
  return e[18] !== y || e[19] !== R ? (S = /* @__PURE__ */ g("div", { className: y, children: R }), e[18] = y, e[19] = R, e[20] = S) : S = e[20], S;
}
function U7(t) {
  const e = W.c(12), {
    size: n
  } = t, o = z7[n], r = o - 0.5, i = r - 3.5, s = B7[n], l = W7[n], a = `M 4 ${0.5} H ${i} A ${3.5} ${3.5} 0 0 1 ${r} 4`, c = `M ${r} 4 V ${i} A ${3.5} ${3.5} 0 0 1 ${i} ${r}`, u = `M ${i} ${r} H 4 A ${3.5} ${3.5} 0 0 1 ${0.5} ${i}`, d = `M ${0.5} ${i} V 4 A ${3.5} ${3.5} 0 0 1 4 ${0.5}`;
  let f;
  e[0] !== a || e[1] !== c || e[2] !== u || e[3] !== d ? (f = [a, c, u, d], e[0] = a, e[1] = c, e[2] = u, e[3] = d, e[4] = f) : f = e[4];
  const p = f, m = `0 0 ${o} ${o}`;
  let h;
  e[5] !== s || e[6] !== l || e[7] !== p ? (h = p.map((v) => /* @__PURE__ */ g("path", { "data-slot": "thumbnail-empty-stroke", className: "stroke-outline-subtle", d: v, strokeDasharray: s, strokeDashoffset: l, strokeLinecap: "butt", strokeLinejoin: "miter", strokeWidth: "1" }, v)), e[5] = s, e[6] = l, e[7] = p, e[8] = h) : h = e[8];
  let b;
  return e[9] !== m || e[10] !== h ? (b = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", viewBox: m, children: h }), e[9] = m, e[10] = h, e[11] = b) : b = e[11], b;
}
const mi = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative"
}, gi = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
}, G7 = {
  ...gi,
  justify: "text-justify"
}, hi = {
  true: "truncate",
  false: ""
}, Oo = {
  regular: "font-(number:--font-weight-regular)",
  medium: "font-(number:--font-weight-medium)",
  semibold: "font-(number:--font-weight-semibold)",
  bold: "font-(number:--font-weight-bold)"
}, A2 = {
  true: "italic",
  false: "not-italic"
}, Y7 = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4"
}, j7 = ae(["font-(family-name:--font-family-body)", "text-(length:--font-size-body-small)", "leading-(--line-height-16)", "font-(number:--font-weight-regular)"], {
  variants: {
    tone: mi,
    align: gi,
    truncate: hi
  },
  defaultVariants: {
    tone: "default"
  }
});
function qO({
  tone: t,
  align: e,
  truncate: n,
  as: o = "span",
  ...r
}) {
  return x.createElement(o, {
    className: j7({
      tone: t,
      align: e,
      truncate: n
    }),
    ...r
  });
}
const K7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-lg)", "leading-(--line-height-64)", "tracking-[-0.25px]"],
      md: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-md)", "leading-(--line-height-52)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-sm)", "leading-(--line-height-44)", "tracking-normal"]
    },
    tone: mi,
    align: gi,
    truncate: hi,
    weight: Oo
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), q7 = {
  lg: "h1",
  md: "h1",
  sm: "h2"
};
function ZO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? q7[t] : "h1", a = i || l;
  return x.createElement(a, {
    className: K7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const Z7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-lg)", "leading-(--line-height-40)", "tracking-normal"],
      md: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-md)", "leading-(--line-height-36)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-sm)", "leading-(--line-height-32)", "tracking-normal"]
    },
    tone: mi,
    align: gi,
    truncate: hi,
    weight: {
      medium: Oo.medium,
      semibold: Oo.semibold,
      bold: Oo.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), X7 = {
  lg: "h2",
  md: "h3",
  sm: "h4"
};
function XO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? X7[t] : "h3", a = i || l;
  return x.createElement(a, {
    className: Z7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const Q7 = ae("font-(family-name:--font-family-label)", {
  variants: {
    size: {
      lg: ["text-(length:--font-size-label-lg)", "leading-(--line-height-20)"],
      md: ["text-(length:--font-size-label-md)", "leading-(--line-height-20)"],
      sm: ["text-(length:--font-size-label-sm)", "leading-(--line-height-16)"],
      xs: ["text-(length:--font-size-label-xs)", "leading-(--line-height-16)"]
    },
    tone: mi,
    align: gi,
    truncate: hi,
    weight: Oo,
    italic: A2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "semibold",
    italic: !1
  }
});
function mo({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "semibold",
  italic: i = !1,
  as: s = "span",
  ...l
}) {
  return x.createElement(s, {
    className: Q7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r,
      italic: i
    }),
    ...l
  });
}
const J7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-lg)", "leading-(--line-height-24)", "tracking-[0.5px]"],
      md: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-md)", "leading-(--line-height-20)", "tracking-[0.25px]"],
      sm: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-sm)", "leading-(--line-height-16)", "tracking-[0.4px]"]
    },
    tone: mi,
    align: G7,
    truncate: hi,
    lineClamp: Y7,
    weight: Oo,
    italic: A2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "regular",
    italic: !1
  }
});
function an({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  lineClamp: r,
  weight: i = "regular",
  italic: s = !1,
  as: l = "p",
  ...a
}) {
  return x.createElement(l, {
    className: J7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      lineClamp: r,
      weight: i,
      italic: s
    }),
    ...a
  });
}
const ey = ae("", {
  variants: {
    size: {
      xl: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xl)", "tracking-normal"],
      lg: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "tracking-[0.15px]"],
      md: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "tracking-[0.15px]"],
      sm: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-sm)", "tracking-[0.1px]"],
      xs: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xs)", "leading-(--line-height-16)", "tracking-[0.1px]"]
    },
    tone: mi,
    align: gi,
    truncate: hi,
    weight: {
      medium: Oo.medium,
      semibold: Oo.semibold,
      bold: Oo.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), ty = {
  xl: "h4",
  lg: "h5",
  md: "h5",
  sm: "h6",
  xs: "h6"
};
function Mn({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? ty[t] : "h5", a = i || l;
  return x.createElement(a, {
    className: ey({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const ny = ae(["flex", "h-full", "min-h-0", "min-w-0", "w-full", "flex-col", "overflow-hidden", "bg-surface", "pb-(--spacing-20)", "pt-(--spacing-10)"]), oy = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-16)", "px-(--spacing-10)"]), ry = ae(["flex", "shrink-0", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-8)", "py-(--spacing-8)"]), iy = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-20)"]), sy = ae(["flex", "shrink-0", "items-start", "gap-(--spacing-20)", "px-(--spacing-10)"]), ly = ae(["flex", "min-w-0", "flex-1", "flex-col", "items-start", "gap-(--spacing-4)"]), ay = ae(["flex", "w-full", "flex-wrap", "items-center", "gap-x-(--spacing-6)", "gap-y-(--spacing-2)"]), cy = ae(["flex", "flex-1", "min-h-0", "min-w-0", "flex-col", "gap-(--spacing-12)", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface-low", "px-(--spacing-4)", "pb-(--spacing-4)"]), uy = ae(["flex", "w-full", "max-w-[580px]", "min-w-0", "self-center", "flex-col"]), dy = ae(["flex", "w-full", "flex-col", "gap-(--spacing-20)", "py-(--spacing-10)"]), fy = ae(["flex", "min-w-0", "flex-col"], {
  variants: {
    informative: {
      true: "gap-(--spacing-12)",
      false: "gap-(--spacing-6)"
    }
  },
  defaultVariants: {
    informative: !1
  }
}), py = ae(["flex", "h-full", "min-h-0", "w-(--spacing-40)", "shrink-0", "flex-col", "items-center"]), my = ae(["w-(--spacing-2)", "flex-1", "bg-outline-variant"]);
function L2(t) {
  const e = W.c(6), {
    steps: n
  } = t;
  let o, r;
  if (e[0] !== n) {
    const s = n.filter(vy);
    o = n.filter(by).map(hy), r = s.length > 0 ? /* @__PURE__ */ g("ol", { className: "m-0 w-full list-decimal pl-(--spacing-20) text-(length:--font-size-body-medium) leading-(--font-line-height-20)", children: s.map(gy) }) : null, e[0] = n, e[1] = o, e[2] = r;
  } else
    o = e[1], r = e[2];
  let i;
  return e[3] !== o || e[4] !== r ? (i = /* @__PURE__ */ F(_t, { children: [
    o,
    r
  ] }), e[3] = o, e[4] = r, e[5] = i) : i = e[5], i;
}
function gy(t) {
  return /* @__PURE__ */ F("li", { value: t.number, children: [
    t.content,
    t.substeps?.length ? /* @__PURE__ */ g(L2, { steps: t.substeps }) : null
  ] }, t.id);
}
function hy(t) {
  return /* @__PURE__ */ g(an, { size: "md", children: t.content }, t.id);
}
function by(t) {
  return t.isLeadIn;
}
function vy(t) {
  return !t.isLeadIn;
}
function yy(t) {
  const e = W.c(24), {
    content: n,
    detail: o,
    actions: r
  } = t, i = "title" in n ? n.title : void 0, s = "body" in n ? n.body : void 0, l = n.type === "observation" || n.type === "next-step" || n.type === "recommended-procedure", a = l ? "informative" : void 0;
  let c;
  e[0] !== l ? (c = fy({
    informative: l
  }), e[0] = l, e[1] = c) : c = e[1];
  let u;
  e[2] !== i ? (u = i ? /* @__PURE__ */ g(Mn, { size: "md", children: i }) : null, e[2] = i, e[3] = u) : u = e[3];
  let d;
  e[4] !== s || e[5] !== n.steps || e[6] !== n.type ? (d = n.type === "recommended-procedure" ? /* @__PURE__ */ g(L2, { steps: n.steps }) : s ? /* @__PURE__ */ g(an, { size: "md", children: s }) : null, e[4] = s, e[5] = n.steps, e[6] = n.type, e[7] = d) : d = e[7];
  let f;
  e[8] !== n ? (f = "completion" in n && n.completion ? /* @__PURE__ */ g(an, { size: "md", weight: "semibold", children: n.completion }) : null, e[8] = n, e[9] = f) : f = e[9];
  let p;
  e[10] !== o ? (p = o ? /* @__PURE__ */ g("div", { children: o }) : null, e[10] = o, e[11] = p) : p = e[11];
  let m;
  e[12] !== r ? (m = r ? /* @__PURE__ */ g("div", { className: "flex w-full items-center", children: r }) : null, e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ F("div", { className: c, children: [
    u,
    d,
    f,
    p,
    m
  ] }), e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  let b;
  return e[21] !== a || e[22] !== h ? (b = /* @__PURE__ */ g(lu, { tone: a, children: h }), e[21] = a, e[22] = h, e[23] = b) : b = e[23], b;
}
function xy(t) {
  const e = W.c(35), {
    alert: n,
    isCurrentUser: o,
    showConnector: r,
    renderAlertDetail: i,
    renderAlertActions: s
  } = t, l = o ? "outbound" : "inbound";
  let a;
  e[0] !== n.author.initials || e[1] !== n.author.name || e[2] !== n.author.type ? (a = /* @__PURE__ */ g(Xr, { variant: n.author.type, initials: n.author.initials, "aria-label": n.author.name }), e[0] = n.author.initials, e[1] = n.author.name, e[2] = n.author.type, e[3] = a) : a = e[3];
  const c = a;
  let u;
  e[4] !== c || e[5] !== o || e[6] !== r ? (u = o ? null : /* @__PURE__ */ g(Zg, { children: r ? /* @__PURE__ */ F("div", { className: py(), children: [
    /* @__PURE__ */ g("div", { className: "-mb-(--spacing-16) flex w-full items-center pb-(--spacing-24)", children: c }),
    /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "asset-alert-chat-connector-divider", className: my() })
  ] }) : /* @__PURE__ */ g("div", { className: "pb-(--spacing-24)", children: c }) }), e[4] = c, e[5] = o, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== n.author.name ? (d = /* @__PURE__ */ g(mo, { size: "lg", weight: "medium", children: n.author.name }), e[8] = n.author.name, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.author.type ? (f = n.author.type === "internal" ? /* @__PURE__ */ g(l8, { size: "compact", "aria-hidden": "true", "data-slot": "asset-alert-chat-author-logo" }) : null, e[10] = n.author.type, e[11] = f) : f = e[11];
  let p;
  e[12] !== n.timestamp ? (p = n.timestamp ? /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ g(mo, { size: "xs", tone: "subtle", weight: "semibold", children: "•" }),
    /* @__PURE__ */ g(mo, { size: "lg", tone: "subtle", weight: "medium", children: n.timestamp })
  ] }) : null, e[12] = n.timestamp, e[13] = p) : p = e[13];
  let m;
  e[14] !== d || e[15] !== f || e[16] !== p ? (m = /* @__PURE__ */ F(Xg, { children: [
    d,
    f,
    p
  ] }), e[14] = d, e[15] = f, e[16] = p, e[17] = m) : m = e[17];
  let h;
  e[18] !== n || e[19] !== i ? (h = i?.(n), e[18] = n, e[19] = i, e[20] = h) : h = e[20];
  let b;
  e[21] !== n || e[22] !== s ? (b = s?.(n), e[21] = n, e[22] = s, e[23] = b) : b = e[23];
  let v;
  e[24] !== n.content || e[25] !== h || e[26] !== b ? (v = /* @__PURE__ */ g(q5, { children: /* @__PURE__ */ g(yy, { content: n.content, detail: h, actions: b }) }), e[24] = n.content, e[25] = h, e[26] = b, e[27] = v) : v = e[27];
  let C;
  e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F(su, { children: [
    m,
    v
  ] }), e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  let y;
  return e[31] !== l || e[32] !== C || e[33] !== u ? (y = /* @__PURE__ */ F(iu, { direction: l, children: [
    u,
    C
  ] }), e[31] = l, e[32] = C, e[33] = u, e[34] = y) : y = e[34], y;
}
function Cy(t, e) {
  return t.author.type === "internal" && e?.author.type === "internal" && t.author.id === e.author.id && !e.dateLabel;
}
function wy(t) {
  const e = W.c(4), {
    messageId: n,
    hasAuxiliaryContent: o
  } = t, {
    scrollToEnd: r
  } = Du(), i = at(n);
  let s, l;
  return e[0] !== n || e[1] !== r ? (s = () => {
    n && i.current !== n && r(), i.current = n;
  }, l = [n, r], e[0] = n, e[1] = r, e[2] = s, e[3] = l) : (s = e[2], l = e[3]), Nt(s, l), Sy(o), null;
}
function Sy(t) {
  const e = W.c(4), {
    scrollToMessage: n
  } = Du();
  let o, r;
  e[0] !== t || e[1] !== n ? (o = () => {
    t && n("asset-alert-chat-auxiliary-content", {
      align: "start"
    });
  }, r = [t, n], e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (o = e[2], r = e[3]), Nt(o, r);
}
function QO({
  title: t,
  titleAccessory: e,
  assetSummary: n,
  sections: o,
  alerts: r,
  currentUserId: i,
  activeSectionId: s,
  onSectionChange: l,
  headerMenuItems: a,
  onClose: c,
  renderAlertDetail: u,
  renderAlertActions: d,
  composer: f,
  auxiliaryContent: p
}) {
  const m = $t(), h = `asset-alert-${m}-details`, [b, v] = qe(!1), C = new Set(o.map((k) => k.id)), y = new Map(o.map((k) => [k.id, `asset-alert-${m}-${k.id}`])), w = /* @__PURE__ */ new Set(), R = r.map((k) => {
    const P = k.sectionId, D = P && C.has(P) && !w.has(P) ? y.get(P) : void 0;
    return P && D && w.add(P), {
      alert: k,
      anchorId: D
    };
  }), S = n5(o.filter((k) => w.has(k.id)).map((k) => y.get(k.id) ?? k.id)), E = at(S.activeId), N = r.reduce((k, P) => P.author.id === i ? P.id : k, void 0), I = s === void 0 ? S.activeId : w.has(s) ? y.get(s) : void 0;
  function M(k) {
    S.scrollRef.current = k;
  }
  function T(k) {
    E.current = k, S.onActiveChange(k);
    const P = o.find((D) => y.get(D.id) === k);
    P && l?.(P.id);
  }
  return Nt(() => {
    if (E.current === S.activeId)
      return;
    E.current = S.activeId;
    const k = o.find((P) => y.get(P.id) === S.activeId);
    k && l?.(k.id);
  }, [S.activeId, l, y, o]), /* @__PURE__ */ g("section", { "aria-label": typeof t == "string" ? t : "Asset alert chat", className: ny(), "data-slot": "asset-alert-chat", children: /* @__PURE__ */ F("div", { className: oy(), children: [
    /* @__PURE__ */ F("header", { className: ry(), "data-slot": "asset-alert-chat-header", children: [
      /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 flex-wrap items-center gap-(--spacing-8)", children: [
        /* @__PURE__ */ g(Mn, { as: "h2", size: "lg", truncate: !0, children: t }),
        e
      ] }),
      /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-10)", children: [
        a?.length ? /* @__PURE__ */ g(V7, { label: "View", items: a, size: "sm" }) : null,
        c ? /* @__PURE__ */ g(bt, { icon: "x-close", variant: "ghost", size: "md", "aria-label": "Close asset chat", onClick: c }) : null
      ] })
    ] }),
    /* @__PURE__ */ F("div", { className: iy(), children: [
      n ? /* @__PURE__ */ F("div", { className: sy(), "data-slot": "asset-alert-chat-summary", children: [
        /* @__PURE__ */ g(ql, { ...n.thumbnail, size: b ? "xl" : "sm" }),
        /* @__PURE__ */ F("div", { className: ly(), children: [
          /* @__PURE__ */ g(Mn, { as: "h3", size: "sm", truncate: !0, children: n.name }),
          /* @__PURE__ */ g("div", { id: h, hidden: !b, className: "flex w-full flex-col items-start gap-(--spacing-10)", children: b ? /* @__PURE__ */ F(_t, { children: [
            n.metrics.length > 0 ? /* @__PURE__ */ g("div", { className: ay(), children: n.metrics.map((k, P) => /* @__PURE__ */ F("span", { className: "contents", children: [
              P > 0 ? /* @__PURE__ */ g("span", { className: "inline-flex h-(--spacing-16) w-(--spacing-2) shrink-0 items-stretch self-center", children: /* @__PURE__ */ g(vr, { orientation: "vertical" }) }) : null,
              /* @__PURE__ */ F("span", { className: "inline-flex h-(--spacing-24) min-w-0 items-center gap-(--spacing-4)", children: [
                /* @__PURE__ */ F(an, { as: "span", size: "md", tone: "subtle", truncate: !0, children: [
                  k.label,
                  ":"
                ] }),
                /* @__PURE__ */ g("span", { children: /* @__PURE__ */ g(an, { as: "span", size: "md", truncate: !0, children: k.value }) })
              ] })
            ] }, k.id)) }) : null,
            n.status ? /* @__PURE__ */ g(Wn, { ...n.status }) : null
          ] }) : null }),
          /* @__PURE__ */ g(pn, { variant: "ghost", size: "sm", icon: b ? "chevron-up" : "chevron-down", "aria-controls": h, "aria-expanded": b, onClick: () => v((k) => !k), children: b ? "Hide Details" : "View Details" })
        ] })
      ] }) : null,
      o.length > 0 ? /* @__PURE__ */ g(e5, { orientation: "horizontal", activeId: I, onActiveChange: T, scrollRef: S.scrollRef, startScrollLock: S.startScrollLock, children: o.map((k) => /* @__PURE__ */ g(Jv, { targetId: y.get(k.id) ?? k.id, disabled: !w.has(k.id), children: k.label }, k.id)) }) : null,
      /* @__PURE__ */ F("div", { className: cy(), children: [
        /* @__PURE__ */ F(Qg, { defaultScrollPosition: "end", children: [
          /* @__PURE__ */ F(Jg, { ref: M, "aria-label": "Asset alert transcript", children: [
            /* @__PURE__ */ F(eh, { children: [
              R.length === 0 ? /* @__PURE__ */ g("div", { className: "flex min-h-full items-center justify-center text-center", children: /* @__PURE__ */ g(an, { tone: "subtle", children: "No alerts to display." }) }) : R.map(({
                alert: k,
                anchorId: P
              }, D) => {
                const O = R[D + 1]?.alert, V = /* @__PURE__ */ g(xy, { alert: k, isCurrentUser: k.author.id === i, showConnector: Cy(k, O), renderAlertDetail: u, renderAlertActions: d });
                return /* @__PURE__ */ g(Wi, { id: P, messageId: k.id, children: /* @__PURE__ */ g("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ F("div", { className: uy(), "data-slot": "asset-alert-chat-alerts", children: [
                  k.dateLabel ? /* @__PURE__ */ F("div", { className: dy(), children: [
                    /* @__PURE__ */ g(vr, { centeredText: k.dateLabel }),
                    V
                  ] }) : null,
                  k.dateLabel ? null : V
                ] }) }) }, k.id);
              }),
              p ? /* @__PURE__ */ g(Wi, { messageId: "asset-alert-chat-auxiliary-content", "data-slot": "asset-alert-chat-auxiliary-content", children: p }) : null
            ] }),
            /* @__PURE__ */ g(wy, { messageId: N, hasAuxiliaryContent: !!p })
          ] }),
          /* @__PURE__ */ g(th, {})
        ] }),
        f ? /* @__PURE__ */ g("div", { className: "px-(--spacing-4)", children: f }) : null
      ] })
    ] })
  ] }) });
}
function Ps(t, e) {
  const n = typeof window < "u" && typeof window.matchMedia < "u";
  t = t.replace(/^@media( ?)/m, "");
  const {
    defaultMatches: o = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: i = null,
    noSsr: s = !1
  } = e, l = x.useCallback(() => o, [o]), a = x.useMemo(() => {
    if (s && r)
      return () => r(t).matches;
    if (i !== null) {
      const {
        matches: f
      } = i(t);
      return () => f;
    }
    return l;
  }, [l, t, i, s, r]), [c, u] = x.useMemo(() => {
    if (r === null)
      return [l, () => () => {
      }];
    const f = r(t);
    return [() => f.matches, (p) => dt(f, "change", p)];
  }, [l, r, t]), d = yd.useSyncExternalStore(u, c, a);
  return process.env.NODE_ENV !== "production" && x.useDebugValue({
    query: t,
    match: d
  }), d;
}
const Ms = {
  belowSm: "(width < 600px)",
  belowMd: "(width < 905px)"
}, Ry = ae(["inline-flex", "rounded-full"], {
  variants: {
    tone: {
      urgent: "bg-error",
      activity: "bg-primary",
      info: "bg-informative"
    },
    variant: {
      dot: "size-(--spacing-6)",
      pill: "items-center justify-center min-w-(--spacing-16) h-(--spacing-16) px-(--spacing-4) py-[3px]"
    }
  },
  defaultVariants: {
    tone: "urgent",
    variant: "dot"
  }
}), Ey = ae(["font-(family-name:--font-family-body)", "font-normal", "text-(length:--font-size-body-small)", "leading-[11px]", "text-center"], {
  variants: {
    tone: {
      urgent: "text-error-on-error",
      activity: "text-primary-on-primary",
      info: "text-text-inverse"
    }
  },
  defaultVariants: {
    tone: "urgent"
  }
});
function vu(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    tone: l,
    count: r,
    visible: a,
    "aria-hidden": n,
    "aria-label": o,
    style: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "urgent" : l, u = a === void 0 ? !0 : a, d = r === void 0;
  let f;
  e[8] !== r || e[9] !== d ? (f = d ? void 0 : String(r).slice(0, 3), e[8] = r, e[9] = d, e[10] = f) : f = e[10];
  const p = f, m = !u || !o || n === !0 || n === "true" ? !0 : void 0, h = d ? "dot" : "pill";
  let b;
  e[11] !== h || e[12] !== c ? (b = Ry({
    tone: c,
    variant: h
  }), e[11] = h, e[12] = c, e[13] = b) : b = e[13];
  let v;
  e[14] !== s || e[15] !== u ? (v = u ? s : {
    ...s,
    visibility: "hidden"
  }, e[14] = s, e[15] = u, e[16] = v) : v = e[16];
  let C;
  e[17] !== p || e[18] !== d || e[19] !== c ? (C = !d && /* @__PURE__ */ g("span", { className: Ey({
    tone: c
  }), children: p }), e[17] = p, e[18] = d, e[19] = c, e[20] = C) : C = e[20];
  let y;
  return e[21] !== o || e[22] !== m || e[23] !== i || e[24] !== b || e[25] !== v || e[26] !== C ? (y = /* @__PURE__ */ g("span", { ...i, role: "img", "aria-hidden": m, "aria-label": o, className: b, style: v, children: C }), e[21] = o, e[22] = m, e[23] = i, e[24] = b, e[25] = v, e[26] = C, e[27] = y) : y = e[27], y;
}
const Qd = yo("none"), Ny = ae(["grid", "h-full", "min-h-0", "min-w-0", "w-full", "overflow-hidden", "relative", "rounded-(--radius-md)", "after:pointer-events-none", "after:absolute", "after:inset-0", "after:z-10", "after:rounded-(--radius-md)", "after:border", "after:border-outline-subtle", "after:content-['']", "bg-surface", "shadow-elevation-4", "text-text-default", "max-sm:grid-cols-1"], {
  variants: {
    sidebar: {
      none: "grid-cols-[minmax(0,1fr)]",
      expanded: "grid-cols-[240px_minmax(0,1fr)]",
      collapsed: "grid-cols-[64px_minmax(0,1fr)]"
    }
  },
  defaultVariants: {
    sidebar: "none"
  }
}), ky = ae(["min-h-0", "min-w-0", "overflow-hidden", "relative", "after:pointer-events-none", "after:absolute", "after:inset-y-0", "after:right-0", "after:border-r", "after:border-outline-subtle", "after:content-['']", "bg-surface", "max-sm:hidden"], {
  variants: {
    sidebar: {
      expanded: "block",
      collapsed: "block",
      none: "hidden"
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), Iy = ae([], {
  variants: {
    sidebar: {
      expanded: ["flex", "items-center", "justify-between"],
      collapsed: ["relative", "flex", "w-(--spacing-48)", "justify-center"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), Py = ae([], {
  variants: {
    sidebar: {
      expanded: "shrink-0",
      collapsed: ["absolute", "-right-(--spacing-4)", "-top-(--spacing-4)"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), My = ae(["flex", "min-w-0", "min-h-0", "flex-col", "bg-surface"]), Ty = ae(["flex", "shrink-0", "items-center", "gap-(--spacing-12)", "border-b", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)"]), Oy = ae(["min-h-0", "flex-1", "overflow-hidden"]), Dy = ae(["shrink-0", "min-w-0", "bg-surface", "p-(--spacing-16)"]);
function Wp(t) {
  const e = W.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    sidebar: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ?? "none";
  let s;
  e[4] !== i ? (s = ne(Ny({
    sidebar: i
  })), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== n || e[7] !== o || e[8] !== i || e[9] !== s ? (l = /* @__PURE__ */ g("section", { "data-slot": "chat-panel", "data-sidebar": i, className: s, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s, e[10] = l) : l = e[10];
  let a;
  return e[11] !== i || e[12] !== l ? (a = /* @__PURE__ */ g(Qd, { value: i, children: l }), e[11] = i, e[12] = l, e[13] = a) : a = e[13], a;
}
function _y(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = Cn(Qd);
  let i;
  e[3] !== r ? (i = ne(ky({
    sidebar: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("aside", { "data-slot": "chat-panel-sidebar", className: i, ...o, children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function Up(t) {
  const e = W.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    badge: n,
    children: o,
    sidebar: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = Cn(Qd), l = i ?? (s === "collapsed" ? "collapsed" : "expanded");
  let a;
  e[5] !== l ? (a = ne(Iy({
    sidebar: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] !== n || e[8] !== l ? (c = n && /* @__PURE__ */ g("span", { className: ne(Py({
    sidebar: l
  })), "data-slot": "chat-panel-sidebar-badge", children: /* @__PURE__ */ g(vu, { count: n.count, tone: n.tone, "aria-label": n.label }) }), e[7] = n, e[8] = l, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("header", { "data-slot": "chat-panel-sidebar-header", "data-sidebar": l, className: a, ...r, children: [
    o,
    c
  ] }), e[10] = o, e[11] = r, e[12] = l, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
function Gp(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(My()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-main", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function JO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Ty()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-panel-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Yp(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Oy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-body", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Vy(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Dy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-panel-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Ay() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ F("output", { className: "inline-flex items-center gap-[5px] rounded-(--radius-xl) bg-surface-container px-[14px] py-(--spacing-10)", "aria-label": "AI is typing", children: [
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" })
  ] }), t[0] = e) : e = t[0], e;
}
const Ly = 4;
function Ti(t) {
  if (!t) return 0;
  const e = t.getBoundingClientRect().width;
  return e > 0 ? e : t.offsetWidth;
}
function Fy(t) {
  const e = Number.parseFloat(getComputedStyle(t).columnGap);
  return Number.isFinite(e) ? e : Ly;
}
function $y(t, e) {
  return t.reduce((o, r) => o + r, 0) + Math.max(0, t.length - 1) * e;
}
function jp({
  itemWidths: t,
  reservedStartWidth: e,
  reservedEndWidth: n,
  overflowWidth: o
}) {
  return [...e > 0 ? [e] : [], ...t, ...o && o > 0 ? [o] : [], ...n > 0 ? [n] : []];
}
function Kp(t, e, n, o) {
  if (t.length === 0) return !0;
  if (o <= 1) return $y(t, n) <= e;
  let r = 1, i = 0;
  for (const s of t) {
    const l = i === 0 ? s : i + n + s;
    if (l <= e || i === 0) {
      i = l;
      continue;
    }
    if (r += 1, i = s, r > o) return !1;
  }
  return !0;
}
function Jd({
  items: t,
  maxRows: e = 1,
  minVisibleItems: n = t.length > 0 ? 1 : 0
}) {
  const o = at(null), r = at(null), i = at(null), s = at(null), l = at([]), a = at({}), c = at(() => {
  }), [u, d] = qe(Number.POSITIVE_INFINITY), f = t.length === 0 ? 0 : Math.max(n, Math.min(u, t.length)), p = t.slice(0, f), m = t.length - p.length;
  return c.current = () => {
    const h = o.current;
    function b(E) {
      d((N) => N === E ? N : E);
    }
    if (!h || t.length <= n) {
      b(t.length);
      return;
    }
    const v = Ti(h), C = Fy(h), y = Ti(i.current), w = Ti(s.current), R = t.map((E, N) => Ti(l.current[N])), S = jp({
      itemWidths: R,
      reservedStartWidth: y,
      reservedEndWidth: w
    });
    if (Kp(S, v, C, e)) {
      b(t.length);
      return;
    }
    for (let E = t.length - 1; E >= n; E -= 1) {
      const N = t.length - E, I = Ti(a.current[N]), M = jp({
        itemWidths: R.slice(0, E),
        reservedStartWidth: y,
        reservedEndWidth: w,
        overflowWidth: I
      });
      if (Kp(M, v, C, e)) {
        b(E);
        return;
      }
    }
    b(n);
  }, go(() => {
    c.current();
  }), go(() => {
    const h = o.current;
    if (typeof ResizeObserver > "u" || !h) return;
    const b = new ResizeObserver(() => {
      c.current();
    });
    return b.observe(h), r.current && b.observe(r.current), () => b.disconnect();
  }, []), {
    containerRef: o,
    measuringContainerRef: r,
    reservedStartRef: i,
    reservedEndRef: s,
    itemRefs: l,
    overflowRefs: a,
    visibleItems: p,
    overflowCount: m
  };
}
function Hy(t) {
  const e = W.c(26);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    fileName: n,
    variant: a,
    imageSrc: r,
    imageAlt: o,
    onRemove: i,
    removeAriaLabel: l,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  let c;
  e[8] !== o || e[9] !== r || e[10] !== a ? (c = a === "file" ? /* @__PURE__ */ g("span", { className: "inline-flex size-(--spacing-20) shrink-0 items-center justify-center gap-(--spacing-4) rounded-(--radius-sm) bg-chip-neutral-container px-(--spacing-6) py-(--spacing-4)", children: /* @__PURE__ */ g(Ue, { name: "document", size: "xs", tone: "inherit" }) }) : /* @__PURE__ */ g("img", { alt: o, src: r, className: "size-(--spacing-20) shrink-0 rounded-(--radius-xs) object-cover" }), e[8] = o, e[9] = r, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== n ? (u = /* @__PURE__ */ g("span", { title: n, className: "max-w-[100px] shrink-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-16) font-(--font-weight-medium) tracking-(--font-letter-spacing-default)", children: n }), e[12] = n, e[13] = u) : u = e[13];
  const d = l ?? `Remove ${n}`;
  let f;
  e[14] !== i ? (f = (b) => {
    b.stopPropagation(), i(b);
  }, e[14] = i, e[15] = f) : f = e[15];
  let p;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }), e[16] = p) : p = e[16];
  let m;
  e[17] !== d || e[18] !== f ? (m = /* @__PURE__ */ g("button", { "data-slot": "chat-attachment-remove", type: "button", "aria-label": d, className: "inline-flex shrink-0 cursor-pointer items-center rounded-(--radius-xs) text-icon-main focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: f, children: p }), e[17] = d, e[18] = f, e[19] = m) : m = e[19];
  let h;
  return e[20] !== s || e[21] !== c || e[22] !== u || e[23] !== m || e[24] !== a ? (h = /* @__PURE__ */ F("span", { "data-slot": "chat-attachment", "data-variant": a, className: "inline-flex h-(--spacing-28) items-center gap-(--spacing-8) rounded-(--radius-sm) bg-chip-neutral-container px-(--spacing-6) py-(--spacing-4) text-chip-neutral-label", ...s, children: [
    c,
    u,
    m
  ] }), e[20] = s, e[21] = c, e[22] = u, e[23] = m, e[24] = a, e[25] = h) : h = e[25], h;
}
const zy = ae("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});
function eD(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== r ? (i = ne(zy({
    size: r
  })), e[4] = r, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
const F2 = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)"
}, $2 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, By = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, Wy = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse"
}, Uy = ae("flex flex-row", {
  variants: {
    align: $2,
    justify: By,
    gap: F2,
    wrap: Wy
  },
  defaultVariants: {
    gap: 8,
    align: "center"
  }
});
function Cr(t) {
  const e = W.c(18);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    gap: r,
    align: n,
    justify: i,
    wrap: a,
    grow: l,
    children: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !1 : l;
  let u;
  e[8] !== n || e[9] !== r || e[10] !== c || e[11] !== i || e[12] !== a ? (u = ne(Uy({
    gap: r,
    align: n,
    justify: i,
    wrap: a
  }), c && "[&>*]:flex-1"), e[8] = n, e[9] = r, e[10] = c, e[11] = i, e[12] = a, e[13] = u) : u = e[13];
  let d;
  return e[14] !== o || e[15] !== s || e[16] !== u ? (d = /* @__PURE__ */ g("div", { className: u, ...s, children: o }), e[14] = o, e[15] = s, e[16] = u, e[17] = d) : d = e[17], d;
}
const Gy = ae("flex flex-col", {
  variants: {
    align: $2,
    gap: F2,
    fullWidth: {
      true: "w-full",
      false: null
    }
  },
  defaultVariants: {
    gap: 16,
    fullWidth: !1
  }
});
function Qo(t) {
  const e = W.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    gap: r,
    align: n,
    fullWidth: s,
    children: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s;
  let a;
  e[6] !== n || e[7] !== l || e[8] !== r ? (a = ne(Gy({
    gap: r,
    align: n,
    fullWidth: l
  })), e[6] = n, e[7] = l, e[8] = r, e[9] = a) : a = e[9];
  let c;
  return e[10] !== o || e[11] !== i || e[12] !== a ? (c = /* @__PURE__ */ g("div", { className: a, ...i, children: o }), e[10] = o, e[11] = i, e[12] = a, e[13] = c) : c = e[13], c;
}
const ef = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ef.displayName = "PopoverRootContext");
function Ts(t) {
  const e = x.useContext(ef);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : st(47));
  return e;
}
function Yy() {
  return {
    ...bs(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const jy = {
  ...vs,
  disabled: he((t) => t.disabled),
  instantType: he((t) => t.instantType),
  openMethod: he((t) => t.openMethod),
  openChangeReason: he((t) => t.openChangeReason),
  modal: he((t) => t.modal),
  focusManagerModal: he((t) => t.focusManagerModal),
  stickIfOpen: he((t) => t.stickIfOpen),
  titleElementId: he((t) => t.titleElementId),
  descriptionElementId: he((t) => t.descriptionElementId),
  openOnHover: he((t) => t.openOnHover),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport)
};
class tf extends Ir {
  constructor(e) {
    const n = {
      ...Yy(),
      ...e
    };
    n.open && e?.mounted === void 0 && (n.mounted = !0), super(n, {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      stickIfOpenTimeout: new Pn(),
      triggerElements: new Pr()
    }, jy);
  }
  setOpen = (e, n) => {
    const o = n.reason === Ut, r = n.reason === eo && n.event.detail === 0, i = !e && (n.reason === Rr || n.reason == null);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const s = () => {
      const l = {
        open: e,
        openChangeReason: n.reason
      }, a = n.trigger?.id ?? null;
      (a || e) && (l.activeTriggerId = a, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(Fh, () => {
      this.set("stickIfOpen", !1);
    }), yn.flushSync(s)) : s(), r || i ? this.set("instantType", r ? "click" : "dismiss") : n.reason === _o ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(e, n) {
    const o = Lt(() => new tf(n)).current, r = e ?? o;
    return oi(o.disposeEffect), r;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function qp({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    modal: s = !1,
    handle: l,
    triggerId: a,
    defaultTriggerId: c = null
  } = t, u = tf.useStore(l?.store, {
    modal: s,
    open: o,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: a
  });
  Or(() => {
    n === void 0 && u.state.open === !1 && o === !0 && u.update({
      open: !0,
      activeTriggerId: c
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", a);
  const d = u.useState("open"), f = u.useState("payload");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", i);
  const {
    openMethod: p,
    triggerProps: m
  } = Ns(d);
  gs(u);
  const {
    forceUnmount: h
  } = hs(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  x.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, De(ds));
  }, [u]);
  x.useImperativeHandle(t.actionsRef, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = ys({
    popupStore: u,
    onOpenChange: u.setOpen
  }), C = kr(v, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: s === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), y = kd(v), {
    getReferenceProps: w,
    getFloatingProps: R,
    getTriggerProps: S
  } = ro([C, y]), E = x.useMemo(() => w(m), [w, m]), N = x.useMemo(() => S(m), [S, m]), I = x.useMemo(() => R(), [R]);
  u.useSyncedValues({
    modal: s,
    openMethod: p,
    activeTriggerProps: E,
    inactiveTriggerProps: N,
    popupProps: I,
    floatingRootContext: v,
    nested: Co() != null
  });
  const M = x.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ g(ef.Provider, {
    value: M,
    children: typeof e == "function" ? e({
      payload: f
    }) : e
  });
}
function nf(t) {
  return Ts(!0) ? /* @__PURE__ */ g(qp, {
    props: t
  }) : /* @__PURE__ */ g(gd, {
    children: /* @__PURE__ */ g(qp, {
      props: t
    })
  });
}
const Ky = 300, Ea = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    handle: l,
    payload: a,
    openOnHover: c = !1,
    delay: u = Ky,
    closeDelay: d = 0,
    id: f,
    style: p,
    ...m
  } = e, h = Ts(!0), b = l?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : st(74));
  const v = Ot(f), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: E
  } = ms(v, R, b, {
    payload: a,
    disabled: i,
    openOnHover: c,
    closeDelay: d
  }), N = b.useState("openChangeReason"), I = b.useState("stickIfOpen"), M = b.useState("openMethod"), T = b.useState("focusManagerModal"), k = xs(y, {
    enabled: y != null && c && (M !== "touch" || N !== eo),
    mouseOnly: !0,
    move: !1,
    handleClose: Cs(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: R,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), P = Nr(y, {
    enabled: y != null,
    stickIfOpen: I
  }), D = ro([P]), O = b.useState("triggerProps", E), V = {
    disabled: i,
    open: w
  }, {
    getButtonProps: _,
    buttonRef: A
  } = qt({
    disabled: i,
    native: s
  }), L = x.useMemo(() => ({
    open(K) {
      return K && N === eo ? qi.open(K) : Sr.open(K);
    }
  }), [N]), $ = Le("button", e, {
    state: V,
    ref: [A, n, S, R],
    props: [D.getReferenceProps(), k, O, {
      [ad]: "",
      id: v
    }, m, _],
    stateAttributesMapping: L
  }), {
    preFocusGuardRef: B,
    handlePreFocusGuardFocus: z,
    handleFocusTargetFocus: H
  } = S2(b, R);
  return C && !T ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(Bn, {
      ref: B,
      onFocus: z
    }), /* @__PURE__ */ g(x.Fragment, {
      children: $
    }, v), /* @__PURE__ */ g(Bn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: H
    })]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: $
  }, v);
});
process.env.NODE_ENV !== "production" && (Ea.displayName = "PopoverTrigger");
const of = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (of.displayName = "PopoverPortalContext");
function qy() {
  const t = x.useContext(of);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : st(45));
  return t;
}
const Na = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Ts();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(of.Provider, {
    value: o,
    children: /* @__PURE__ */ g(si, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Na.displayName = "PopoverPortal");
const rf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (rf.displayName = "PopoverPositionerContext");
function Zy() {
  const t = x.useContext(rf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : st(46));
  return t;
}
const ka = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = ba,
    style: v,
    ...C
  } = e, {
    store: y
  } = Ts(), w = qy(), R = va(), S = y.useState("floatingRootContext"), E = y.useState("mounted"), N = y.useState("open"), I = y.useState("openChangeReason"), M = y.useState("activeTriggerElement"), T = y.useState("modal"), k = y.useState("openMethod"), P = y.useState("positionerElement"), D = y.useState("instantType"), O = y.useState("transitionStatus"), V = y.useState("hasViewport"), _ = x.useRef(null), A = la(P, !1, !1), L = ai({
    anchor: i,
    floatingRootContext: S,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: V ? wa : void 0
  }), $ = S.useState("domReferenceElement");
  ke(() => {
    const K = $, G = _.current;
    if (K && (_.current = K), G && K && K !== G) {
      y.set("instantType", void 0);
      const q = new AbortController();
      return A(() => {
        y.set("instantType", "trigger-change");
      }, q.signal), () => {
        q.abort();
      };
    }
  }, [$, A, y]);
  const B = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    instant: D
  };
  Sa(N && T === !0 && I !== Ut, k === "touch", P, M);
  const z = x.useCallback((K) => {
    y.set("positionerElement", K);
  }, [y]), H = di(e, B, {
    styles: L.positionerStyles,
    transitionStatus: O,
    props: C,
    refs: [n, z],
    hidden: !E,
    inert: !N
  });
  return /* @__PURE__ */ F(rf.Provider, {
    value: L,
    children: [E && T === !0 && I !== Ut && /* @__PURE__ */ g(ui, {
      ref: y.context.internalBackdropRef,
      inert: Tr(!N),
      cutout: M
    }), /* @__PURE__ */ g(md, {
      id: R,
      children: H
    })]
  });
});
process.env.NODE_ENV !== "production" && (ka.displayName = "PopoverPositioner");
const H2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (H2.displayName = "ClosePartContext");
function Xy() {
  const [t, e] = x.useState(0), n = we(() => (e((r) => r + 1), () => {
    e((r) => Math.max(0, r - 1));
  }));
  return {
    context: x.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: t > 0
  };
}
function Qy(t) {
  const {
    value: e,
    children: n
  } = t;
  return /* @__PURE__ */ g(H2.Provider, {
    value: e,
    children: n
  });
}
const Jy = {
  ...An,
  ...Kt
}, Ia = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: i,
    finalFocus: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = Ts(), u = Zy(), d = Pd() != null, {
    context: f,
    hasClosePart: p
  } = Xy(), m = c.useState("open"), h = c.useState("openMethod"), b = c.useState("instantType"), v = c.useState("transitionStatus"), C = c.useState("popupProps"), y = c.useState("titleElementId"), w = c.useState("descriptionElementId"), R = c.useState("modal"), S = c.useState("mounted"), E = c.useState("openChangeReason"), N = c.useState("activeTriggerElement"), I = c.useState("floatingRootContext");
  Jt({
    open: m,
    ref: c.context.popupRef,
    onComplete() {
      m && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const M = c.useState("disabled"), T = c.useState("openOnHover"), k = c.useState("closeDelay");
  xa(I, {
    enabled: T && !M,
    closeDelay: k
  });
  function P(L) {
    return L === "touch" ? c.context.popupRef.current : !0;
  }
  const D = i === void 0 ? P : i, O = {
    open: m,
    side: u.side,
    align: u.align,
    instant: b,
    transitionStatus: v
  }, V = R !== !1 && p;
  c.useSyncedValue("focusManagerModal", V);
  const _ = x.useCallback((L) => {
    c.set("popupElement", L);
  }, [c]), A = Le("div", e, {
    state: O,
    ref: [n, c.context.popupRef, _],
    props: [C, {
      "aria-labelledby": y,
      "aria-describedby": w,
      onKeyDown(L) {
        d && Rs.has(L.key) && L.stopPropagation();
      }
    }, Mr(v), a],
    stateAttributesMapping: Jy
  });
  return /* @__PURE__ */ g(li, {
    context: I,
    openInteractionType: h,
    modal: V,
    disabled: !S || E === Ut,
    initialFocus: D,
    returnFocus: s,
    restoreFocus: "popup",
    previousFocusableElement: wt(N) ? N : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ g(Qy, {
      value: f,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && (Ia.displayName = "PopoverPopup");
function ex(t) {
  const e = W.c(4), {
    open: n,
    onOpenChange: o,
    children: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== o || e[2] !== n ? (i = /* @__PURE__ */ g(nf, { open: n, onOpenChange: o, modal: !1, children: r }), e[0] = r, e[1] = o, e[2] = n, e[3] = i) : i = e[3], i;
}
function tx(t) {
  const e = W.c(5), {
    render: n,
    openOnHover: o,
    delay: r,
    closeDelay: i
  } = t;
  let s;
  return e[0] !== i || e[1] !== r || e[2] !== o || e[3] !== n ? (s = /* @__PURE__ */ g(Ea, { render: n, openOnHover: o, delay: r, closeDelay: i }), e[0] = i, e[1] = r, e[2] = o, e[3] = n, e[4] = s) : s = e[4], s;
}
function nx(t) {
  const e = W.c(13), {
    children: n,
    side: o,
    align: r,
    sideOffset: i,
    className: s,
    positionerClassName: l,
    finalFocus: a
  } = t, c = o === void 0 ? "bottom" : o, u = r === void 0 ? "start" : r, d = i === void 0 ? 4 : i, f = en();
  let p;
  e[0] !== n || e[1] !== s || e[2] !== a ? (p = /* @__PURE__ */ g(Ia, { className: s, finalFocus: a, children: n }), e[0] = n, e[1] = s, e[2] = a, e[3] = p) : p = e[3];
  let m;
  e[4] !== u || e[5] !== l || e[6] !== c || e[7] !== d || e[8] !== p ? (m = /* @__PURE__ */ g(ka, { side: c, align: u, sideOffset: d, className: l, children: p }), e[4] = u, e[5] = l, e[6] = c, e[7] = d, e[8] = p, e[9] = m) : m = e[9];
  let h;
  return e[10] !== f || e[11] !== m ? (h = /* @__PURE__ */ g(Na, { container: f, children: m }), e[10] = f, e[11] = m, e[12] = h) : h = e[12], h;
}
const z2 = ne("rounded-(--radius-sm)", "border border-solid border-outline-subtle", "bg-surface-container-lowest", "text-text-default", "shadow-elevation-3", "font-(family-name:--font-family-body)", "origin-(--transform-origin)", "transition-[opacity,transform]", "duration-200", "ease-in-out", "will-change-[opacity,transform]", "[&[data-starting-style]]:scale-95", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:scale-95", "[&[data-ending-style]]:opacity-0"), ox = ae([
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-(--spacing-4)",
  "h-(--spacing-24)",
  "rounded-(--radius-sm)",
  "px-(--spacing-6)",
  "py-(--spacing-4)",
  "border",
  "border-solid",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "font-(family-name:--font-family-body)",
  "font-(number:--font-weight-medium)",
  "text-(length:--font-size-label-medium)",
  "leading-(--font-line-height-16)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Default state
  "bg-tag-default-background",
  "border-tag-default-outline",
  "text-tag-default-text",
  // Hover state
  "hover:bg-tag-hover-background",
  "hover:border-tag-hover-outline",
  // Pressed state
  "active:bg-tag-pressed-background",
  "active:border-tag-pressed-outline",
  // Focus state
  "focus-visible:ring-2",
  "focus-visible:ring-offset-1",
  "focus-visible:ring-offset-tag-default-background",
  "focus-visible:ring-tag-focus-ring"
]), rx = {
  neutral: "text-tag-icon-default",
  brand: "text-tag-icon-brand",
  positive: "text-tag-icon-positive",
  warning: "text-tag-icon-warning",
  negative: "text-tag-icon-negative"
};
function ns(t) {
  const e = W.c(20);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    icon: o,
    iconTone: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "neutral" : i, a = s === void 0 ? !1 : s, c = o ? l : void 0;
  let u;
  e[6] !== a ? (u = ne(ox(), a && "opacity-50 pointer-events-none cursor-default"), e[6] = a, e[7] = u) : u = e[7];
  const d = a || void 0, f = a ? -1 : void 0;
  let p;
  e[8] !== o || e[9] !== l ? (p = o && /* @__PURE__ */ g("span", { className: ne("inline-flex items-center", rx[l]), children: /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit" }) }), e[8] = o, e[9] = l, e[10] = p) : p = e[10];
  let m;
  return e[11] !== n || e[12] !== a || e[13] !== r || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F(no, { "data-slot": "tag", "data-icon-tone": c, className: u, disabled: a, "aria-disabled": d, tabIndex: f, ...r, children: [
    p,
    n
  ] }), e[11] = n, e[12] = a, e[13] = r, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
const ix = ae(["flex", "min-w-0", "w-full", "flex-col"]), sx = ae(["relative", "flex", "min-w-0", "flex-col", "gap-(--spacing-32)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):focus-within]:border-input-active-outline", "[&_[data-slot=icon-button]]:text-icon-main"], {
  variants: {
    hasAlert: {
      true: ["rounded-t-none"],
      false: []
    },
    disabled: {
      true: ["opacity-50", "cursor-not-allowed", "[&_textarea]:cursor-not-allowed", "[&_[data-slot=button]:disabled]:opacity-100", "[&_[data-slot=icon-button]:disabled]:opacity-100"],
      false: []
    }
  },
  defaultVariants: {
    hasAlert: !1,
    disabled: !1
  }
}), lx = ae(["[&>div]:rounded-b-none"]), ax = ne(z2, "w-[280px]", "p-0"), cx = ae(["min-w-0", "w-full", "[field-sizing:content]", "max-h-(--spacing-128)", "outline-none", "bg-transparent", "resize-none", "overflow-y-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder"]), ux = ae(["flex", "min-w-0", "w-full", "flex-col", "gap-(--spacing-16)"]), dx = ae(["relative", "flex", "flex-col", "gap-(--spacing-12)"]), fx = ae(["inline-flex", "h-(--spacing-24)", "items-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-label-sm)", "leading-(--font-line-height-16)", "text-text-subtle", "uppercase"]), px = ae(["flex", "flex-wrap", "items-center", "gap-(--spacing-8)"]), mx = ae(["flex", "items-center", "gap-(--spacing-32)"], {
  variants: {
    showUpload: {
      true: "justify-between",
      false: "justify-end"
    }
  },
  defaultVariants: {
    showUpload: !0
  }
}), gx = {
  suggestedUpdates: "Suggested Updates",
  show: "Show",
  hide: "Hide",
  send: "Send",
  showSuggestedUpdates: "Show suggested updates",
  hideSuggestedUpdates: "Hide suggested updates"
};
function hx(t) {
  const e = W.c(76), {
    value: n,
    onChange: o,
    placeholder: r,
    "aria-label": i,
    disabled: s,
    autoFocus: l,
    onSend: a,
    clearOnSend: c,
    onUpload: u,
    showUpload: d,
    alert: f,
    attachments: p,
    suggestedUpdates: m,
    labels: h
  } = t, b = i === void 0 ? "Message" : i, v = c === void 0 ? !0 : c, C = d === void 0 ? !0 : d;
  let y;
  e[0] !== m ? (y = m === void 0 ? [] : m, e[0] = m, e[1] = y) : y = e[1];
  const w = y;
  let R;
  e[2] !== h ? (R = {
    ...gx,
    ...h
  }, e[2] = h, e[3] = R) : R = e[3];
  const S = R, E = at(null), [N, I] = qe(!1);
  let M;
  e[4] !== n ? (M = n.trim(), e[4] = n, e[5] = M) : M = e[5];
  const T = M.length > 0, k = s || !a || !T;
  let P;
  e[6] !== l ? (P = l ? {
    autoFocus: !0
  } : void 0, e[6] = l, e[7] = P) : P = e[7];
  const D = P;
  let O, V;
  e[8] !== l || e[9] !== s ? (V = () => {
    l && !s && E.current?.focus();
  }, O = [l, s], e[8] = l, e[9] = s, e[10] = O, e[11] = V) : (O = e[10], V = e[11]), Nt(V, O);
  let _;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = function(fe) {
    const be = E.current;
    if (!be)
      return;
    Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set?.call(be, fe), be.dispatchEvent(new Event("input", {
      bubbles: !0
    }));
  }, e[12] = _) : _ = e[12];
  const A = _;
  let L;
  e[13] !== v || e[14] !== k || e[15] !== a ? (L = function() {
    k || (a?.(), E.current?.focus(), v && A(""));
  }, e[13] = v, e[14] = k, e[15] = a, e[16] = L) : L = e[16];
  const $ = L;
  let B;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = function(fe) {
    A(fe.value), E.current?.focus();
  }, e[17] = B) : B = e[17];
  const z = B;
  let H;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = function() {
    I(vx);
  }, e[18] = H) : H = e[18];
  const K = H;
  let G;
  e[19] !== $ || e[20] !== k || e[21] !== a ? (G = function(fe) {
    if (fe.key === "Escape") {
      fe.currentTarget.blur();
      return;
    }
    if (fe.key === "Enter" && !fe.shiftKey && !fe.nativeEvent.isComposing && a) {
      if (fe.preventDefault(), k)
        return;
      $();
    }
  }, e[19] = $, e[20] = k, e[21] = a, e[22] = G) : G = e[22];
  const q = G, Q = !!f;
  let U;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = ix(), e[23] = U) : U = e[23];
  let X;
  e[24] !== f || e[25] !== Q ? (X = Q ? /* @__PURE__ */ g("div", { className: lx(), children: f }) : null, e[24] = f, e[25] = Q, e[26] = X) : X = e[26];
  const te = s || void 0;
  let re;
  e[27] !== s || e[28] !== Q ? (re = sx({
    disabled: s,
    hasAlert: Q
  }), e[27] = s, e[28] = Q, e[29] = re) : re = e[29];
  let J;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = ux(), e[30] = J) : J = e[30];
  let ie;
  e[31] !== s || e[32] !== S || e[33] !== w || e[34] !== N ? (ie = w.length > 0 && /* @__PURE__ */ g(xx, { disabled: s, labels: S, suggestedUpdates: w, suggestedUpdatesCollapsed: N, onToggleSuggestedUpdates: K, onSelectSuggestedUpdate: z }), e[31] = s, e[32] = S, e[33] = w, e[34] = N, e[35] = ie) : ie = e[35];
  let ce;
  e[36] !== p ? (ce = p ?? [], e[36] = p, e[37] = ce) : ce = e[37];
  let oe;
  e[38] !== s || e[39] !== ce ? (oe = /* @__PURE__ */ g(yx, { attachments: ce, disabled: s, textareaRef: E }), e[38] = s, e[39] = ce, e[40] = oe) : oe = e[40];
  let se;
  e[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = cx(), e[41] = se) : se = e[41];
  let me;
  e[42] !== b || e[43] !== D || e[44] !== s || e[45] !== q || e[46] !== o || e[47] !== r || e[48] !== n ? (me = /* @__PURE__ */ g("textarea", { ref: E, rows: 1, value: n, onChange: o, onKeyDown: q, placeholder: r, disabled: s, "aria-label": b, ...D, className: se }), e[42] = b, e[43] = D, e[44] = s, e[45] = q, e[46] = o, e[47] = r, e[48] = n, e[49] = me) : me = e[49];
  let pe;
  e[50] !== ie || e[51] !== oe || e[52] !== me ? (pe = /* @__PURE__ */ F("div", { className: J, children: [
    ie,
    oe,
    me
  ] }), e[50] = ie, e[51] = oe, e[52] = me, e[53] = pe) : pe = e[53];
  let le;
  e[54] !== C ? (le = mx({
    showUpload: C
  }), e[54] = C, e[55] = le) : le = e[55];
  let ge;
  e[56] !== s || e[57] !== u || e[58] !== C ? (ge = C && /* @__PURE__ */ g(bt, { icon: "upload", variant: "ghost", size: "sm", "aria-label": "Upload file", disabled: s, onClick: u }), e[56] = s, e[57] = u, e[58] = C, e[59] = ge) : ge = e[59];
  let j;
  e[60] !== $ || e[61] !== k || e[62] !== S.send ? (j = /* @__PURE__ */ g(pn, { type: "button", variant: "primary", size: "sm", icon: "send", disabled: k, onMouseDown: bx, onClick: $, children: S.send }), e[60] = $, e[61] = k, e[62] = S.send, e[63] = j) : j = e[63];
  let ee;
  e[64] !== le || e[65] !== ge || e[66] !== j ? (ee = /* @__PURE__ */ F("div", { className: le, children: [
    ge,
    j
  ] }), e[64] = le, e[65] = ge, e[66] = j, e[67] = ee) : ee = e[67];
  let Y;
  e[68] !== te || e[69] !== re || e[70] !== pe || e[71] !== ee ? (Y = /* @__PURE__ */ F("div", { "data-disabled": te, className: re, children: [
    pe,
    ee
  ] }), e[68] = te, e[69] = re, e[70] = pe, e[71] = ee, e[72] = Y) : Y = e[72];
  let Z;
  return e[73] !== X || e[74] !== Y ? (Z = /* @__PURE__ */ F("div", { className: U, children: [
    X,
    Y
  ] }), e[73] = X, e[74] = Y, e[75] = Z) : Z = e[75], Z;
}
function bx(t) {
  return t.preventDefault();
}
function vx(t) {
  return !t;
}
function yx(t) {
  const e = W.c(30), {
    attachments: n,
    disabled: o,
    textareaRef: r
  } = t;
  let i;
  e[0] !== n ? (i = {
    items: n,
    minVisibleItems: 0
  }, e[0] = n, e[1] = i) : i = e[1];
  const {
    containerRef: s,
    measuringContainerRef: l,
    itemRefs: a,
    overflowRefs: c,
    visibleItems: u,
    overflowCount: d
  } = Jd(i), f = n.slice(u.length), [p, m] = qe(!1);
  let h;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ new Map(), e[2] = h) : h = e[2];
  const b = at(h), v = at(null), [C, y] = qe(null);
  let w, R;
  e[3] !== d ? (w = () => {
    d === 0 && m(!1);
  }, R = [d], e[3] = d, e[4] = w, e[5] = R) : (w = e[4], R = e[5]), Nt(w, R);
  let S, E;
  e[6] !== n || e[7] !== C || e[8] !== r ? (S = () => {
    if (!C || n.some((K) => {
      const {
        id: G
      } = K;
      return G === C.removedId;
    }))
      return;
    y(null), ((C.neighborId ? b.current.get(C.neighborId)?.querySelector("button") : void 0) ?? (C.neighborId ? v.current : void 0) ?? r.current)?.focus();
  }, E = [n, C, r], e[6] = n, e[7] = C, e[8] = r, e[9] = S, e[10] = E) : (S = e[9], E = e[10]), Nt(S, E);
  const N = function(K, G) {
    const q = G ? f : n, Q = q.findIndex((U) => U.id === K);
    return q[Q + 1] ?? q[Q - 1];
  }, I = function(K, G) {
    const q = G === void 0 ? !1 : G, {
      id: Q,
      onRemove: U,
      ...X
    } = K;
    return /* @__PURE__ */ g(Hy, { ...X, onRemove: (te) => {
      if (te.detail === 0) {
        const re = N(Q, q), J = re ? b.current.get(re.id)?.querySelector("button") : void 0;
        q && J ? J.focus() : q || y({
          removedId: Q,
          neighborId: re?.id
        });
      }
      U(te);
    } });
  }, M = n.length === 0 && "hidden";
  let T;
  e[11] !== M ? (T = ne("relative flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-10)", M), e[11] = M, e[12] = T) : T = e[12];
  const k = u.map((H) => /* @__PURE__ */ g("span", { ref: (K) => {
    K ? b.current.set(H.id, K) : b.current.delete(H.id);
  }, className: "inline-flex w-max shrink-0", children: I(H) }, H.id));
  let P;
  e[13] !== o || e[14] !== p || e[15] !== d ? (P = d > 0 && /* @__PURE__ */ g(tx, { openOnHover: !0, delay: 0, closeDelay: 200, render: /* @__PURE__ */ F(ns, { ref: v, type: "button", disabled: o, "aria-label": `${d} more ${d === 1 ? "attachment" : "attachments"}`, "aria-expanded": p, children: [
    "+",
    d
  ] }) }), e[13] = o, e[14] = p, e[15] = d, e[16] = P) : P = e[16];
  let D;
  e[17] !== d || e[18] !== r ? (D = d === 0 ? () => r.current : void 0, e[17] = d, e[18] = r, e[19] = D) : D = e[19];
  let O;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = /* @__PURE__ */ g(Mn, { size: "md", weight: "semibold", children: "Uploaded Attachments" }), e[20] = O) : O = e[20];
  const V = "true", _ = !0, A = "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", L = "inline-flex w-max items-center gap-(--spacing-10)", $ = n.map((H, K) => /* @__PURE__ */ g("span", { ref: (G) => {
    a.current[K] = G;
  }, "data-chat-textarea-measure": "attachment", "data-chat-textarea-measure-index": K, className: "inline-flex w-max shrink-0", children: I(H) }, H.id));
  let B;
  if (e[21] !== n || e[22] !== c) {
    let H;
    e[24] !== c ? (H = (K, G) => {
      const q = G + 1;
      return /* @__PURE__ */ g("span", { ref: (Q) => {
        c.current[q] = Q;
      }, "data-chat-textarea-measure": "overflow", "data-chat-textarea-measure-count": q, className: "inline-flex w-max", children: /* @__PURE__ */ F(ns, { disabled: !0, children: [
        "+",
        q
      ] }) }, q);
    }, e[24] = c, e[25] = H) : H = e[25], B = n.map(H), e[21] = n, e[22] = c, e[23] = B;
  } else
    B = e[23];
  let z;
  return e[26] !== l || e[27] !== $ || e[28] !== B ? (z = /* @__PURE__ */ g("div", { "aria-hidden": V, inert: _, className: A, children: /* @__PURE__ */ F("div", { ref: l, className: L, children: [
    $,
    B
  ] }) }), e[26] = l, e[27] = $, e[28] = B, e[29] = z) : z = e[29], /* @__PURE__ */ F("div", { ref: s, "data-chat-textarea-attachments": !0, className: T, inert: o || void 0, children: [
    k,
    /* @__PURE__ */ F(ex, { open: p && d > 0, onOpenChange: m, children: [
      P,
      /* @__PURE__ */ g(nx, { align: "end", side: "top", sideOffset: 8, className: ax, positionerClassName: "z-[var(--z-layer-popover)]", finalFocus: D, children: /* @__PURE__ */ F("fieldset", { "aria-label": "Uploaded Attachments", inert: o || void 0, className: "flex flex-col gap-(--spacing-10) px-(--spacing-16) pt-(--spacing-10) pb-(--spacing-16)", children: [
        O,
        /* @__PURE__ */ g(Qo, { gap: 8, align: "start", children: f.map((H) => /* @__PURE__ */ g("span", { ref: (K) => {
          K ? b.current.set(H.id, K) : b.current.delete(H.id);
        }, className: "inline-flex w-max", children: I(H, !0) }, H.id)) })
      ] }) })
    ] }),
    z
  ] });
}
function xx(t) {
  const e = W.c(40), {
    disabled: n,
    labels: o,
    suggestedUpdates: r,
    suggestedUpdatesCollapsed: i,
    onToggleSuggestedUpdates: s,
    onSelectSuggestedUpdate: l
  } = t;
  let a;
  e[0] !== r ? (a = {
    items: r,
    maxRows: 2,
    minVisibleItems: 0
  }, e[0] = r, e[1] = a) : a = e[1];
  const {
    containerRef: c,
    measuringContainerRef: u,
    reservedStartRef: d,
    reservedEndRef: f,
    itemRefs: p,
    visibleItems: m
  } = Jd(a);
  let h;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = dx(), e[2] = h) : h = e[2];
  let b;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = px(), e[3] = b) : b = e[3];
  let v;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = fx(), e[4] = v) : v = e[4];
  let C;
  e[5] !== o.suggestedUpdates || e[6] !== d ? (C = /* @__PURE__ */ g("span", { ref: d, className: v, children: o.suggestedUpdates }), e[5] = o.suggestedUpdates, e[6] = d, e[7] = C) : C = e[7];
  let y;
  e[8] !== n || e[9] !== l || e[10] !== i || e[11] !== m ? (y = !i && m.map((O) => /* @__PURE__ */ g(ns, { type: "button", disabled: n, onClick: () => l(O), children: O.label }, `${O.label}-${O.value}`)), e[8] = n, e[9] = l, e[10] = i, e[11] = m, e[12] = y) : y = e[12];
  const w = i ? "eye-watching" : "eye-slash-regular", R = i ? o.showSuggestedUpdates : o.hideSuggestedUpdates, S = !i, E = i ? o.show : o.hide;
  let N;
  e[13] !== n || e[14] !== s || e[15] !== E || e[16] !== w || e[17] !== R || e[18] !== S ? (N = /* @__PURE__ */ g(pn, { type: "button", variant: "ghost", size: "sm", icon: w, "aria-label": R, "aria-expanded": S, disabled: n, onClick: s, children: E }), e[13] = n, e[14] = s, e[15] = E, e[16] = w, e[17] = R, e[18] = S, e[19] = N) : N = e[19];
  let I;
  e[20] !== f || e[21] !== N ? (I = /* @__PURE__ */ g("span", { ref: f, className: "inline-flex", children: N }), e[20] = f, e[21] = N, e[22] = I) : I = e[22];
  let M;
  e[23] !== c || e[24] !== I || e[25] !== C || e[26] !== y ? (M = /* @__PURE__ */ F("div", { ref: c, className: b, children: [
    C,
    y,
    I
  ] }), e[23] = c, e[24] = I, e[25] = C, e[26] = y, e[27] = M) : M = e[27];
  let T;
  if (e[28] !== p || e[29] !== r) {
    let O;
    e[31] !== p ? (O = (V, _) => /* @__PURE__ */ g("span", { ref: (A) => {
      p.current[_] = A;
    }, className: "inline-flex w-max", children: /* @__PURE__ */ g(ns, { type: "button", disabled: !0, children: V.label }) }, `${V.label}-${V.value}`), e[31] = p, e[32] = O) : O = e[32], T = r.map(O), e[28] = p, e[29] = r, e[30] = T;
  } else
    T = e[30];
  let k;
  e[33] !== u || e[34] !== T ? (k = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ g("div", { ref: u, className: "inline-flex w-max items-center gap-(--spacing-8)", children: T }) }), e[33] = u, e[34] = T, e[35] = k) : k = e[35];
  let P;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ g(vr, {}), e[36] = P) : P = e[36];
  let D;
  return e[37] !== M || e[38] !== k ? (D = /* @__PURE__ */ F("div", { className: h, children: [
    M,
    k,
    P
  ] }), e[37] = M, e[38] = k, e[39] = D) : D = e[39], D;
}
let Zp = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const Pa = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Br = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, Cx = {
  disabled: !1,
  ...Br
}, io = {
  valid(t) {
    return t === null ? null : t ? {
      [Zp.valid]: ""
    } : {
      [Zp.invalid]: ""
    };
  }
}, sf = /* @__PURE__ */ x.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: Pa,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: Ct,
  disabled: void 0,
  touched: Br.touched,
  setTouched: Ct,
  dirty: Br.dirty,
  setDirty: Ct,
  filled: Br.filled,
  setFilled: Ct,
  focused: Br.focused,
  setFocused: Ct,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: Cx,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: Ct,
  validation: {
    getValidationProps: (t = Et) => t,
    getInputValidationProps: (t = Et) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (sf.displayName = "FieldRootContext");
function mn(t = !0) {
  const e = x.useContext(sf);
  if (e.setValidityData === Ct && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : st(28));
  return e;
}
const B2 = /* @__PURE__ */ x.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (B2.displayName = "FieldsetRootContext");
function W2(t = !1) {
  const e = x.useContext(B2);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : st(86));
  return e;
}
const U2 = /* @__PURE__ */ x.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: Ct,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (U2.displayName = "FormContext");
function Fo() {
  return x.useContext(U2);
}
const lf = /* @__PURE__ */ x.createContext({
  controlId: void 0,
  registerControlId: Ct,
  labelId: void 0,
  setLabelId: Ct,
  messageIds: [],
  setMessageIds: Ct,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (lf.displayName = "LabelableContext");
function Nn() {
  return x.useContext(lf);
}
const G2 = function(e) {
  const n = Ot(), o = e.controlId === void 0 ? n : e.controlId, [r, i] = x.useState(o), [s, l] = x.useState(e.labelId), [a, c] = x.useState([]), u = Lt(() => /* @__PURE__ */ new Map()), {
    messageIds: d
  } = Nn(), f = we((h, b) => {
    const v = u.current;
    if (b === void 0) {
      v.delete(h);
      return;
    }
    v.set(h, b), i((C) => {
      if (v.size === 0)
        return;
      let y;
      for (const w of v.values()) {
        if (C !== void 0 && w === C)
          return C;
        y === void 0 && (y = w);
      }
      return y;
    });
  }), p = x.useCallback((h) => cn({
    "aria-describedby": d.concat(a).join(" ") || void 0
  }, h), [d, a]), m = x.useMemo(() => ({
    controlId: r,
    registerControlId: f,
    labelId: s,
    setLabelId: l,
    messageIds: a,
    setMessageIds: c,
    getDescriptionProps: p
  }), [r, f, s, l, a, c, p]);
  return /* @__PURE__ */ g(lf.Provider, {
    value: m,
    children: e.children
  });
};
process.env.NODE_ENV !== "production" && (G2.displayName = "LabelableProvider");
function af(t, e, n, o = !0, r) {
  const [i, s] = x.useState(), l = Ot(r ? `${r}-label` : void 0), a = t ?? e ?? i;
  return ke(() => {
    const c = t || e || !o ? void 0 : wx(n.current, l);
    i !== c && s(c);
  }), a;
}
function wx(t, e) {
  const n = Sx(t);
  if (n)
    return !n.id && e && (n.id = e), n.id || void 0;
}
function Sx(t) {
  if (!t)
    return;
  const e = t.parentElement;
  if (e && e.tagName === "LABEL")
    return e;
  const n = t.id;
  if (n) {
    const r = t.nextElementSibling;
    if (r && r.htmlFor === n)
      return r;
  }
  const o = t.labels;
  return o && o[0];
}
function _r(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    registerControlId: i
  } = Nn(), s = Ot(e), l = n ? r : void 0, a = Lt(() => /* @__PURE__ */ Symbol("labelable-control")), c = x.useRef(!1), u = x.useRef(e != null), d = we(() => {
    !c.current || i === Ct || (c.current = !1, i(a.current, void 0));
  });
  return ke(() => {
    if (i === Ct)
      return;
    let f;
    if (n) {
      const p = o?.current;
      mt(p) && p.closest("label") != null ? f = e ?? null : f = l ?? s;
    } else if (e != null)
      u.current = !0, f = e;
    else if (u.current)
      f = s;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, i(a.current, f);
  }, [e, o, l, i, n, s, a, d]), x.useEffect(() => d, [d]), r ?? s;
}
function Rx(t, e) {
  const n = Ot(t);
  return ke(() => (e(n), () => {
    e(void 0);
  }), [n, e]), n;
}
function Ex(t = {}) {
  const {
    id: e,
    fallbackControlId: n,
    native: o = !1,
    setLabelId: r,
    focusControl: i
  } = t, {
    controlId: s,
    setLabelId: l
  } = Nn(), a = we((p) => {
    l(p), r?.(p);
  }), c = Rx(e, a), u = s ?? n;
  function d(p) {
    if (i) {
      i(p, u);
      return;
    }
    if (!u)
      return;
    const m = nt(p.currentTarget).getElementById(u);
    wt(m) && Nx(m);
  }
  function f(p) {
    yt(p.nativeEvent)?.closest("button,input,select,textarea") || (!p.defaultPrevented && p.detail > 1 && p.preventDefault(), !o && d(p));
  }
  return o ? {
    id: c,
    htmlFor: u ?? void 0,
    onMouseDown: f
  } : {
    id: c,
    onClick: f,
    onPointerDown(p) {
      p.preventDefault();
    }
  };
}
function Nx(t) {
  t.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: !0
  });
}
function Zl(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const Ml = Object.keys(Pa);
function kx(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let e = !1;
  for (const n of Ml)
    n !== "valid" && (n === "valueMissing" && (e = t[n]), t[n] && (e = !1));
  return e;
}
function Ix(t) {
  const {
    formRef: e,
    clearErrors: n
  } = Fo(), {
    setValidityData: o,
    validate: r,
    validityData: i,
    validationDebounceTime: s,
    invalid: l,
    markedDirtyRef: a,
    state: c,
    name: u,
    shouldValidateOnChange: d
  } = t, {
    controlId: f,
    getDescriptionProps: p
  } = Nn(), m = Bt(), h = x.useRef(null), b = we(async (y, w = !1) => {
    const R = h.current;
    if (!R)
      return;
    if (w) {
      if (c.valid !== !1)
        return;
      const P = R.validity;
      if (!P.valueMissing) {
        const O = {
          value: y,
          state: {
            ...Pa,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: i.initialValue
        };
        if (R.setCustomValidity(""), f) {
          const V = e.current.fields.get(f);
          V && e.current.fields.set(f, {
            ...V,
            ...Zl(O, !1)
            // invalid = false
          });
        }
        o(O);
        return;
      }
      const D = Ml.reduce((O, V) => (O[V] = P[V], O), {});
      if (!D.valid && !kx(D))
        return;
    }
    function S(P) {
      const D = Ml.reduce((V, _) => (V[_] = P.validity[_], V), {});
      let O = !1;
      for (const V of Ml)
        if (V !== "valid") {
          if (V === "valueMissing" && D[V])
            O = !0;
          else if (D[V])
            return D;
        }
      return O && !a.current && (D.valid = !0, D.valueMissing = !1), D;
    }
    m.clear();
    let E = null, N = [];
    const I = S(R);
    let M;
    const T = d();
    if (R.validationMessage && !T)
      M = R.validationMessage, N = [R.validationMessage];
    else {
      const P = Array.from(e.current.fields.values()).reduce((O, V) => (V.name && (O[V.name] = V.getValue()), O), {}), D = r(y, P);
      typeof D == "object" && D !== null && "then" in D ? E = await D : E = D, E !== null ? (I.valid = !1, I.customError = !0, Array.isArray(E) ? (N = E, R.setCustomValidity(E.join(`
`))) : E && (N = [E], R.setCustomValidity(E))) : T && (R.setCustomValidity(""), I.customError = !1, R.validationMessage ? (M = R.validationMessage, N = [R.validationMessage]) : R.validity.valid && !I.valid && (I.valid = !0));
    }
    const k = {
      value: y,
      state: I,
      error: M ?? (Array.isArray(E) ? E[0] : E ?? ""),
      errors: N,
      initialValue: i.initialValue
    };
    if (f) {
      const P = e.current.fields.get(f);
      P && e.current.fields.set(f, {
        ...P,
        // Keep Form-level errors part of overall field validity for submit blocking/focus logic.
        ...Zl(k, l)
      });
    }
    o(k);
  }), v = x.useCallback((y = {}) => cn(p, c.valid === !1 ? {
    "aria-invalid": !0
  } : Et, y), [p, c.valid]), C = x.useCallback((y = {}) => cn({
    onChange(w) {
      if (w.nativeEvent.defaultPrevented)
        return;
      if (n(u), !d()) {
        b(w.currentTarget.value, !0);
        return;
      }
      const R = w.currentTarget;
      if (R.value === "") {
        b(R.value);
        return;
      }
      m.clear(), s ? m.start(s, () => {
        b(R.value);
      }) : b(R.value);
    }
  }, v(y)), [v, n, u, m, b, s, d]);
  return x.useMemo(() => ({
    getValidationProps: v,
    getInputValidationProps: C,
    inputRef: h,
    commit: b
  }), [v, C, b]);
}
function Px(t) {
  const {
    commit: e,
    invalid: n,
    markedDirtyRef: o,
    name: r,
    setValidityData: i,
    validityData: s
  } = t, {
    formRef: l
  } = Fo(), a = x.useRef(null), c = x.useRef(null), u = x.useRef(null), d = we(() => {
    const b = c.current;
    if (b)
      return b.getValue ? b.getValue() : b.value;
  }), f = we((b = !0) => {
    const v = c.current;
    if (!v)
      return;
    let C = v.value;
    C === void 0 && (C = d()), o.current = !0, b ? yn.flushSync(() => e(C)) : e(C);
  });
  function p() {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: Zl(s, n),
      validate: f
    });
  }
  function m(b = c.current?.id) {
    b && l.current.fields.delete(b);
  }
  function h() {
    const b = c.current;
    if (!b)
      return;
    let v = b.value;
    v === void 0 && (v = d()), s.initialValue === null && v !== null && i((C) => ({
      ...C,
      initialValue: v
    }));
  }
  return ke(() => {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: Zl(s, n),
      validate: f
    });
  }, [l, d, n, r, f, s]), ke(() => {
    const b = l.current.fields;
    return () => {
      const v = c.current?.id;
      v && b.delete(v);
    };
  }, [l]), we((b, v) => {
    if (!v) {
      a.current === b && (a.current = null, m(), c.current = null);
      return;
    }
    const C = c.current?.id;
    a.current = b, c.current = v, C && C !== v.id && m(C), h(), p();
  });
}
const Y2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    errors: o,
    validationMode: r,
    submitAttemptedRef: i
  } = Fo(), {
    render: s,
    className: l,
    validate: a,
    validationDebounceTime: c = 0,
    validationMode: u = r,
    name: d,
    disabled: f = !1,
    invalid: p,
    dirty: m,
    touched: h,
    actionsRef: b,
    style: v,
    ...C
  } = e, {
    disabled: y
  } = W2(), w = we(a || (() => null)), R = y || f, [S, E] = x.useState(!1), [N, I] = x.useState(!1), [M, T] = x.useState(!1), [k, P] = x.useState(!1), D = m ?? N, O = h ?? S, V = x.useRef(!1), _ = we((re) => {
    m === void 0 && (re && (V.current = !0), I(re));
  }), A = we((re) => {
    h === void 0 && E(re);
  }), L = we(() => u === "onChange" || u === "onSubmit" && i.current), $ = !!d && Object.hasOwn(o, d) && o[d] !== void 0, B = p === !0 || $, [z, H] = x.useState({
    state: Pa,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), K = !B && z.state.valid, G = x.useMemo(() => ({
    disabled: R,
    touched: O,
    dirty: D,
    valid: K,
    filled: M,
    focused: k
  }), [R, O, D, K, M, k]), q = Ix({
    setValidityData: H,
    validate: w,
    validityData: z,
    validationDebounceTime: c,
    invalid: B,
    markedDirtyRef: V,
    state: G,
    name: d,
    shouldValidateOnChange: L
  }), Q = x.useCallback(() => {
    V.current = !0, q.commit(z.value);
  }, [q, z]), U = Px({
    commit: q.commit,
    invalid: B,
    markedDirtyRef: V,
    name: d,
    setValidityData: H,
    validityData: z
  });
  x.useImperativeHandle(b, () => ({
    validate: Q
  }), [Q]);
  const X = x.useMemo(() => ({
    invalid: B,
    name: d,
    validityData: z,
    setValidityData: H,
    disabled: R,
    touched: O,
    setTouched: A,
    dirty: D,
    setDirty: _,
    filled: M,
    setFilled: T,
    focused: k,
    setFocused: P,
    validate: w,
    validationMode: u,
    validationDebounceTime: c,
    shouldValidateOnChange: L,
    state: G,
    markedDirtyRef: V,
    registerFieldControl: U,
    validation: q
  }), [B, d, z, R, O, A, D, _, M, T, k, P, w, u, c, L, G, U, q]), te = Le("div", e, {
    ref: n,
    state: G,
    props: C,
    stateAttributesMapping: io
  });
  return /* @__PURE__ */ g(sf.Provider, {
    value: X,
    children: te
  });
});
process.env.NODE_ENV !== "production" && (Y2.displayName = "FieldRootInner");
const Vr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(G2, {
    children: /* @__PURE__ */ g(Y2, {
      ...e,
      ref: n
    })
  });
});
process.env.NODE_ENV !== "production" && (Vr.displayName = "FieldRoot");
const j2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    nativeLabel: l = !0,
    ...a
  } = e, c = mn(!1), {
    labelId: u
  } = Nn(), d = x.useRef(null), f = Ex({
    id: u ?? s,
    native: l
  });
  return process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!d.current)
      return;
    const m = d.current.tagName === "LABEL";
    if (l) {
      if (!m) {
        const h = br.captureOwnerStack?.() || "";
        Zo(`<Field.Label> expected a <label> element because the \`nativeLabel\` prop is true. Rendering a non-<label> disables native label association, so \`htmlFor\` will not work. Use a real <label> in the \`render\` prop, or set \`nativeLabel\` to \`false\`.${h}`);
      }
    } else if (m) {
      const h = br.captureOwnerStack?.() || "";
      Zo(`<Field.Label> expected a non-<label> element because the \`nativeLabel\` prop is false. Rendering a <label> assumes native label behavior while Base UI treats it as non-native, which can cause unexpected pointer behavior. Use a non-<label> in the \`render\` prop, or set \`nativeLabel\` to \`true\`.${h}`);
    }
  }, [l]), Le("label", e, {
    ref: [n, d],
    state: c.state,
    props: [f, a],
    stateAttributesMapping: io
  });
});
process.env.NODE_ENV !== "production" && (j2.displayName = "FieldLabel");
const Mx = {
  ...io,
  ...Kt
}, Ar = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    match: s,
    style: l,
    ...a
  } = e, c = Ot(r), {
    validityData: u,
    state: d,
    name: f
  } = mn(!1), {
    setMessageIds: p
  } = Nn(), {
    errors: m
  } = Fo(), h = f ? m[f] : null, b = typeof s == "string";
  let v = !1;
  s === !0 ? v = !0 : b ? v = !!u.state[s] : v = !!h || u.state.valid === !1;
  const {
    mounted: C,
    transitionStatus: y,
    setMounted: w
  } = to(v);
  ke(() => {
    if (!(!v || !c))
      return p((O) => O.concat(c)), () => {
        p((O) => O.filter((V) => V !== c));
      };
  }, [v, c, p]);
  const R = x.useRef(null), [S, E] = x.useState(null), [N, I] = x.useState(null), M = u.errors.length > 1 ? /* @__PURE__ */ g("ul", {
    children: u.errors.map((O) => /* @__PURE__ */ g("li", {
      children: O
    }, O))
  }) : u.error, T = b ? M : h || M;
  let k = u.error;
  h != null ? k = Array.isArray(h) ? JSON.stringify(h) : h : u.errors.length > 1 && (k = JSON.stringify(u.errors)), v && k !== N && (I(k), E(T)), Jt({
    open: v,
    ref: R,
    onComplete() {
      v || w(!1);
    }
  });
  const P = {
    ...d,
    transitionStatus: y
  }, D = Le("div", e, {
    ref: [n, R],
    state: P,
    props: [{
      id: c,
      children: v ? T : S
    }, a],
    stateAttributesMapping: Mx,
    enabled: C
  });
  return C ? D : null;
});
process.env.NODE_ENV !== "production" && (Ar.displayName = "FieldError");
const bi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    style: s,
    ...l
  } = e, a = Ot(r), c = mn(!1), {
    setMessageIds: u
  } = Nn();
  return ke(() => {
    if (a)
      return u((f) => f.concat(a)), () => {
        u((f) => f.filter((p) => p !== a));
      };
  }, [a, u]), Le("p", e, {
    ref: n,
    state: c.state,
    props: [{
      id: a
    }, l],
    stateAttributesMapping: io
  });
});
process.env.NODE_ENV !== "production" && (bi.displayName = "FieldDescription");
function vi(t, e) {
  const {
    enabled: n = !0,
    getValue: o,
    id: r,
    value: i
  } = e, {
    registerFieldControl: s
  } = mn(), l = x.useRef(null);
  l.current || (l.current = /* @__PURE__ */ Symbol()), ke(() => {
    const a = l.current;
    if (!(!a || !n))
      return s(a, {
        controlRef: t,
        getValue: o,
        id: r,
        value: i
      }), () => {
        s(a, void 0);
      };
  }, [t, n, o, r, s, i]);
}
const cf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    name: s,
    value: l,
    disabled: a = !1,
    onValueChange: c,
    defaultValue: u,
    autoFocus: d = !1,
    style: f,
    ...p
  } = e, {
    state: m,
    name: h,
    disabled: b,
    setTouched: v,
    setDirty: C,
    validityData: y,
    setFocused: w,
    setFilled: R,
    validationMode: S,
    validation: E
  } = mn(), N = b || a, I = h ?? s, M = {
    ...m,
    disabled: N
  }, {
    labelId: T
  } = Nn(), k = _r({
    id: i
  });
  ke(() => {
    const L = l != null;
    E.inputRef.current?.value || L && l !== "" ? R(!0) : L && l === "" && R(!1);
  }, [E.inputRef, R, l]);
  const P = x.useRef(null);
  ke(() => {
    d && P.current === Xt(nt(P.current)) && w(!0);
  }, [d, w]);
  const [D] = Sn({
    controlled: l,
    default: u,
    name: "FieldControl",
    state: "value"
  }), O = l !== void 0, V = O ? D : void 0, _ = we(() => E.inputRef.current?.value);
  return vi(E.inputRef, {
    id: k,
    value: V,
    getValue: _
  }), Le("input", e, {
    ref: [n, P],
    state: M,
    props: [{
      id: k,
      disabled: N,
      name: I,
      ref: E.inputRef,
      "aria-labelledby": T,
      autoFocus: d,
      ...O ? {
        value: V
      } : {
        defaultValue: u
      },
      onChange(L) {
        const $ = L.currentTarget.value;
        c?.($, De(At, L.nativeEvent)), C($ !== y.initialValue), R($ !== "");
      },
      onFocus() {
        w(!0);
      },
      onBlur(L) {
        v(!0), w(!1), S === "onBlur" && E.commit(L.currentTarget.value);
      },
      onKeyDown(L) {
        L.currentTarget.tagName === "INPUT" && L.key === "Enter" && (v(!0), E.commit(L.currentTarget.value));
      }
    }, E.getInputValidationProps(), p],
    stateAttributesMapping: io
  });
});
process.env.NODE_ENV !== "production" && (cf.displayName = "FieldControl");
const K2 = /* @__PURE__ */ x.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && (K2.displayName = "FieldItemContext");
function q2() {
  return x.useContext(K2);
}
const Z2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Z2.displayName = "CheckboxGroupContext");
function Tx(t = !0) {
  const e = x.useContext(Z2);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : st(3));
  return e;
}
function Ox(t) {
  const e = W.c(46);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: o,
    description: n,
    icon: i,
    size: s,
    side: l,
    align: a,
    disabled: c,
    showArrow: u,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = i === void 0 ? "circle-info" : i, f = s === void 0 ? "sm" : s, p = l === void 0 ? "top" : l, m = a === void 0 ? "center" : a, h = c === void 0 ? !1 : c, b = u === void 0 ? !0 : u, v = en(), C = h ? -1 : 0, y = h && "opacity-40 pointer-events-none";
  let w;
  e[10] !== y ? (w = ne("inline-flex items-center justify-center", "cursor-default transition-colors duration-200", "rounded-(--radius-sm)", "text-icon-main", "hover:text-primary", "focus-visible:text-primary", "focus-visible:outline-none focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", y), e[10] = y, e[11] = w) : w = e[11];
  let R;
  e[12] !== d || e[13] !== f ? (R = /* @__PURE__ */ g(Ue, { name: d, size: f, tone: "inherit" }), e[12] = d, e[13] = f, e[14] = R) : R = e[14];
  let S;
  e[15] !== o || e[16] !== r || e[17] !== R || e[18] !== C || e[19] !== w ? (S = /* @__PURE__ */ g(Gd, { render: /* @__PURE__ */ g("span", { role: "img", tabIndex: C, "aria-label": o, ...r, className: w, children: R }) }), e[15] = o, e[16] = r, e[17] = R, e[18] = C, e[19] = w, e[20] = S) : S = e[20];
  const E = b ? T2 : M2;
  let N;
  e[21] !== b ? (N = b && /* @__PURE__ */ g(Xd, { "data-slot": "tooltip-arrow", className: V2 }), e[21] = b, e[22] = N) : N = e[22];
  const I = n ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let M;
  e[23] !== I ? (M = ne(D2, I), e[23] = I, e[24] = M) : M = e[24];
  let T;
  e[25] !== o || e[26] !== M ? (T = /* @__PURE__ */ g("p", { className: M, children: o }), e[25] = o, e[26] = M, e[27] = T) : T = e[27];
  let k;
  e[28] !== n ? (k = n && /* @__PURE__ */ g("p", { className: _2, children: n }), e[28] = n, e[29] = k) : k = e[29];
  let P;
  e[30] !== N || e[31] !== T || e[32] !== k ? (P = /* @__PURE__ */ F(Zd, { className: O2, children: [
    N,
    T,
    k
  ] }), e[30] = N, e[31] = T, e[32] = k, e[33] = P) : P = e[33];
  let D;
  e[34] !== m || e[35] !== p || e[36] !== E || e[37] !== P ? (D = /* @__PURE__ */ g(qd, { side: p, align: m, sideOffset: E, className: P2, children: P }), e[34] = m, e[35] = p, e[36] = E, e[37] = P, e[38] = D) : D = e[38];
  let O;
  e[39] !== v || e[40] !== D ? (O = /* @__PURE__ */ g(jd, { container: v, children: D }), e[39] = v, e[40] = D, e[41] = O) : O = e[41];
  let V;
  return e[42] !== h || e[43] !== S || e[44] !== O ? (V = /* @__PURE__ */ F(Wd, { disabled: h, children: [
    S,
    O
  ] }), e[42] = h, e[43] = S, e[44] = O, e[45] = V) : V = e[45], V;
}
function yi(t) {
  const e = W.c(11), {
    htmlFor: n,
    label: o,
    required: r,
    tooltip: i
  } = t;
  let s;
  e[0] !== r ? (s = r && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-required", children: "*" }), e[0] = r, e[1] = s) : s = e[1];
  let l;
  e[2] !== n || e[3] !== o || e[4] !== s ? (l = /* @__PURE__ */ F(j2, { htmlFor: n, className: "flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default", children: [
    o,
    s
  ] }), e[2] = n, e[3] = o, e[4] = s, e[5] = l) : l = e[5];
  let a;
  e[6] !== i ? (a = i && /* @__PURE__ */ g(Ox, { label: i, size: "xs" }), e[6] = i, e[7] = a) : a = e[7];
  let c;
  return e[8] !== l || e[9] !== a ? (c = /* @__PURE__ */ F("div", { className: "flex items-center justify-between mb-(--spacing-4)", children: [
    l,
    a
  ] }), e[8] = l, e[9] = a, e[10] = c) : c = e[10], c;
}
const Dx = ae(["relative", "flex", "w-full", "min-h-[132px]", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:not([data-disabled=true]):not(:focus-within):not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not([data-disabled=true]):focus-within:not(:has([readonly]))]:border-input-active-outline"], {
  variants: {
    hasError: {
      true: ["border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    hasError: !1
  }
}), _x = ae(["flex-1", "min-w-0", "w-full", "min-h-[98px]", "border-0", "outline-none", "bg-transparent", "resize-y", "overflow-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "read-only:cursor-default", "read-only:resize-none"]);
function Xp(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.join(",") : "";
}
function tD(t) {
  const e = W.c(86);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h, b, v, C, y, w;
  e[0] !== t ? ({
    id: a,
    label: c,
    error: l,
    tooltip: y,
    required: v,
    disabled: s,
    readOnly: b,
    maxLength: u,
    value: w,
    defaultValue: i,
    placeholder: m,
    tabIndex: C,
    onChange: d,
    onKeyDown: f,
    onMouseDown: p,
    "aria-describedby": n,
    "aria-label": o,
    "aria-labelledby": r,
    ...h
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18], w = e[19]);
  const R = $t(), S = a ?? R;
  let E;
  e[20] !== i ? (E = () => Xp(i), e[20] = i, e[21] = E) : E = e[21];
  const [N, I] = qe(E), M = w !== void 0, T = !!l, k = u !== void 0 && !T, P = !b || T || k, D = `${S}-footer`;
  let O;
  e[22] !== n || e[23] !== D || e[24] !== T || e[25] !== k ? (O = [n, T || k ? D : void 0].filter(Boolean).join(" ") || void 0, e[22] = n, e[23] = D, e[24] = T, e[25] = k, e[26] = O) : O = e[26];
  const V = O, _ = c || r ? o : o ?? "Text area";
  let A;
  e[27] !== N || e[28] !== M || e[29] !== w ? (A = M ? Xp(w) : N, e[27] = N, e[28] = M, e[29] = w, e[30] = A) : A = e[30];
  const L = A;
  let $;
  e[31] !== M || e[32] !== d ? ($ = function(le) {
    M || I(le.currentTarget.value), d?.(le);
  }, e[31] = M, e[32] = d, e[33] = $) : $ = e[33];
  const B = $;
  let z;
  e[34] !== f ? (z = function(le) {
    f?.(le), !le.defaultPrevented && le.key === "Escape" && le.currentTarget.blur();
  }, e[34] = f, e[35] = z) : z = e[35];
  const H = z;
  let K;
  e[36] !== c || e[37] !== v || e[38] !== S || e[39] !== y ? (K = c && /* @__PURE__ */ g(yi, { htmlFor: S, label: c, required: v, tooltip: y }), e[36] = c, e[37] = v, e[38] = S, e[39] = y, e[40] = K) : K = e[40];
  const G = s || void 0;
  let q;
  e[41] !== s || e[42] !== T ? (q = ne(Dx({
    hasError: T
  }), !T && "[&:has([readonly])]:border-input-readonly-outline", s && "opacity-50 cursor-not-allowed"), e[41] = s, e[42] = T, e[43] = q) : q = e[43];
  const Q = b ? void 0 : m, U = b ? -1 : C;
  let X;
  e[44] !== p || e[45] !== b ? (X = (pe) => {
    p?.(pe), b && !pe.defaultPrevented && pe.preventDefault();
  }, e[44] = p, e[45] = b, e[46] = X) : X = e[46];
  const te = v || void 0, re = T || void 0, J = b || void 0;
  let ie;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = _x(), e[47] = ie) : ie = e[47];
  let ce;
  e[48] !== _ || e[49] !== r || e[50] !== i || e[51] !== V || e[52] !== s || e[53] !== B || e[54] !== H || e[55] !== u || e[56] !== h || e[57] !== b || e[58] !== v || e[59] !== U || e[60] !== X || e[61] !== te || e[62] !== re || e[63] !== J || e[64] !== Q || e[65] !== S || e[66] !== w ? (ce = /* @__PURE__ */ g(cf, { render: /* @__PURE__ */ g("textarea", { ...h, id: S, value: w, defaultValue: i, placeholder: Q, required: v, disabled: s, readOnly: b, maxLength: u, tabIndex: U, onChange: B, onKeyDown: H, onMouseDown: X, "aria-label": _, "aria-labelledby": r, "aria-required": te, "aria-invalid": re, "aria-readonly": J, "aria-describedby": V, className: ie }) }), e[48] = _, e[49] = r, e[50] = i, e[51] = V, e[52] = s, e[53] = B, e[54] = H, e[55] = u, e[56] = h, e[57] = b, e[58] = v, e[59] = U, e[60] = X, e[61] = te, e[62] = re, e[63] = J, e[64] = Q, e[65] = S, e[66] = w, e[67] = ce) : ce = e[67];
  let oe;
  e[68] !== ce || e[69] !== G || e[70] !== q ? (oe = /* @__PURE__ */ g("div", { "data-disabled": G, className: q, children: ce }), e[68] = ce, e[69] = G, e[70] = q, e[71] = oe) : oe = e[71];
  let se;
  e[72] !== l || e[73] !== D || e[74] !== T || e[75] !== u || e[76] !== k || e[77] !== P || e[78] !== L ? (se = P && /* @__PURE__ */ F("div", { "data-testid": "textarea-footer", className: "flex justify-between items-center min-h-(--spacing-20) mt-(--spacing-4) gap-(--spacing-8)", children: [
    /* @__PURE__ */ g("div", { className: "flex-1 min-w-0", children: T && /* @__PURE__ */ g(Ar, { id: D, match: !0, className: "truncate text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-error-text", children: l }) }),
    k && /* @__PURE__ */ F("span", { id: D, "aria-live": "polite", className: "shrink-0 text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting whitespace-nowrap", children: [
      L.length,
      "/",
      u
    ] })
  ] }), e[72] = l, e[73] = D, e[74] = T, e[75] = u, e[76] = k, e[77] = P, e[78] = L, e[79] = se) : se = e[79];
  let me;
  return e[80] !== s || e[81] !== T || e[82] !== oe || e[83] !== se || e[84] !== K ? (me = /* @__PURE__ */ F(Vr, { invalid: T, disabled: s, className: "flex flex-col w-full", children: [
    K,
    oe,
    se
  ] }), e[80] = s, e[81] = T, e[82] = oe, e[83] = se, e[84] = K, e[85] = me) : me = e[85], me;
}
function Vx({
  onSendMessage: t,
  value: e,
  onChange: n,
  disabled: o,
  autoFocus: r,
  alert: i,
  placeholder: s = "Ask anything...",
  initialValue: l = ""
}) {
  const [a, c] = qe(l), u = e !== void 0, d = e ?? a, f = at(0), p = at(d), m = at(/* @__PURE__ */ new Map());
  p.current = d, Nt(() => () => {
    m.current.forEach(({
      controller: w
    }) => {
      w.abort();
    }), m.current.clear();
  }, []);
  function h(w) {
    u || c(w), n?.(w);
  }
  function b(w) {
    const R = w.target.value;
    f.current += 1, h(R);
  }
  function v(w, R) {
    m.current.get(w) === R && m.current.delete(w);
  }
  async function C(w, R, S) {
    try {
      await t(w, S.controller.signal), m.current.get(w) === S && f.current === R && p.current.trim() === w && h("");
    } catch {
    } finally {
      v(w, S);
    }
  }
  function y() {
    const w = d.trim();
    if (!w) {
      h("");
      return;
    }
    if (m.current.has(w)) return;
    const R = {
      controller: new AbortController()
    };
    m.current.set(w, R);
    const S = f.current;
    C(w, S, R);
  }
  return /* @__PURE__ */ g(hx, { value: d, onChange: b, onSend: y, clearOnSend: !1, disabled: o, autoFocus: r, alert: i, placeholder: s, showUpload: !1 });
}
const X2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(cf, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (X2.displayName = "Input");
const Ax = ae(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:has([readonly])]:cursor-default", "[&:not(:has([readonly])):not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-hover-outline", "[&:not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not(:has([readonly]))]:focus-within:border-input-active-outline", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    size: {
      xs: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Qp = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-input-text-default"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"],
      md: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"]
    },
    italic: {
      true: "italic",
      false: "not-italic"
    }
  },
  defaultVariants: {
    size: "md",
    italic: !1
  }
});
function Lx(t) {
  const e = W.c(69);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h, b, v, C, y;
  e[0] !== t ? ({
    size: f,
    italic: p,
    label: i,
    leadingIcon: s,
    trailingIcon: C,
    trailingAction: v,
    unit: y,
    description: n,
    error: r,
    tooltip: b,
    reserveSubtextSpace: m,
    required: d,
    disabled: o,
    readOnly: u,
    placeholder: a,
    tabIndex: h,
    onMouseDown: l,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18]);
  const w = f === void 0 ? "md" : f, R = p === void 0 ? !1 : p, S = m === void 0 ? !0 : m, E = !!r, N = s || v || y ? void 0 : C;
  let I;
  e[19] !== i || e[20] !== d || e[21] !== b ? (I = i && /* @__PURE__ */ g(yi, { label: i, required: d, tooltip: b }), e[19] = i, e[20] = d, e[21] = b, e[22] = I) : I = e[22];
  let M;
  e[23] !== o || e[24] !== E || e[25] !== w ? (M = ne(Ax({
    size: w
  }), !E && "[&:has([readonly])]:border-input-readonly-outline", o && "opacity-50", E && ["border-input-error-outline", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-error-outline"]), e[23] = o, e[24] = E, e[25] = w, e[26] = M) : M = e[26];
  let T;
  e[27] !== s ? (T = s && /* @__PURE__ */ g(Ue, { name: s, size: "sm", tone: "inherit" }), e[27] = s, e[28] = T) : T = e[28];
  const k = u ? -1 : h, P = u ? void 0 : a, D = u || void 0;
  let O;
  e[29] !== l || e[30] !== u ? (O = (H) => {
    l?.(H), u && !H.defaultPrevented && H.preventDefault();
  }, e[29] = l, e[30] = u, e[31] = O) : O = e[31];
  const V = d || void 0;
  let _;
  e[32] !== E || e[33] !== R || e[34] !== w ? (_ = ne("flex-1", "min-w-0", "outline-none", Qp({
    size: w,
    italic: R
  }), "placeholder:text-text-subtle", E && "text-input-error-text"), e[32] = E, e[33] = R, e[34] = w, e[35] = _) : _ = e[35];
  let A;
  e[36] !== c || e[37] !== u || e[38] !== d || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== k || e[43] !== P || e[44] !== D ? (A = /* @__PURE__ */ g(X2, { ...c, required: d, readOnly: u, tabIndex: k, placeholder: P, "aria-readonly": D, onMouseDown: O, "aria-required": V, className: _ }), e[36] = c, e[37] = u, e[38] = d, e[39] = O, e[40] = V, e[41] = _, e[42] = k, e[43] = P, e[44] = D, e[45] = A) : A = e[45];
  let L;
  e[46] !== o || e[47] !== u || e[48] !== N || e[49] !== w || e[50] !== v || e[51] !== y ? (L = !u && v ? /* @__PURE__ */ g(bt, { ...v, disabled: o || v.disabled, size: "sm", type: "button", variant: "ghost" }) : y ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) shrink-0", children: [
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-default-outline select-none", children: "|" }),
    /* @__PURE__ */ g("span", { className: ne(Qp({
      size: w,
      italic: !1
    }), "text-input-text-supporting whitespace-nowrap"), children: y })
  ] }) : !u && N ? /* @__PURE__ */ g(Ue, { name: N, size: "sm", tone: "inherit" }) : null, e[46] = o, e[47] = u, e[48] = N, e[49] = w, e[50] = v, e[51] = y, e[52] = L) : L = e[52];
  let $;
  e[53] !== A || e[54] !== L || e[55] !== M || e[56] !== T ? ($ = /* @__PURE__ */ F("div", { className: M, children: [
    T,
    A,
    L
  ] }), e[53] = A, e[54] = L, e[55] = M, e[56] = T, e[57] = $) : $ = e[57];
  let B;
  e[58] !== n || e[59] !== r || e[60] !== E || e[61] !== S ? (B = (S || E || n) && /* @__PURE__ */ g("div", { "data-testid": "input-subtext-row", className: ne("mt-(--spacing-4)", S && "min-h-(--spacing-20)"), children: E ? /* @__PURE__ */ g(Ar, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: r }) : n ? /* @__PURE__ */ g(bi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: n }) : null }), e[58] = n, e[59] = r, e[60] = E, e[61] = S, e[62] = B) : B = e[62];
  let z;
  return e[63] !== o || e[64] !== E || e[65] !== $ || e[66] !== B || e[67] !== I ? (z = /* @__PURE__ */ F(Vr, { invalid: E, disabled: o, className: "flex flex-col w-full", children: [
    I,
    $,
    B
  ] }), e[63] = o, e[64] = E, e[65] = $, e[66] = B, e[67] = I, e[68] = z) : z = e[68], z;
}
const Q2 = ae(["flex", "flex-col", "items-start", "min-w-0", "gap-(--spacing-10)", "rounded-(--radius-sm)", "px-(--spacing-8)", "py-(--spacing-10)", "w-full"]), Fx = ["Wrong answer", "Slow response", "Incomplete", "Other"];
function J2(t, e) {
  const n = W.c(30), {
    rating: o,
    onSubmit: r,
    onRateResponse: i,
    defaultValue: s,
    submittedDuration: l,
    defaultSubmitted: a
  } = t, c = l === void 0 ? 4e3 : l, u = a === void 0 ? !1 : a, [d, f] = qe(o), [p, m] = qe(s), [h, b] = qe(""), [v, C] = qe(!1), [y, w] = qe(u ? "submitted" : "idle"), R = at(c), S = at(e);
  let E, N;
  n[0] !== u || n[1] !== s || n[2] !== o || n[3] !== e || n[4] !== c ? (E = () => {
    S.current !== e && (S.current = e, f(o), m(s), b(""), C(!1), w(u ? "submitted" : "idle"), R.current = c);
  }, N = [u, s, o, e, c], n[0] = u, n[1] = s, n[2] = o, n[3] = e, n[4] = c, n[5] = E, n[6] = N) : (E = n[5], N = n[6]), Nt(E, N);
  let I, M;
  n[7] !== y ? (I = () => {
    if (y !== "submitted")
      return;
    const A = window.setTimeout(() => {
      w("dismissed");
    }, R.current);
    return () => window.clearTimeout(A);
  }, M = [y], n[7] = y, n[8] = I, n[9] = M) : (I = n[8], M = n[9]), Nt(I, M);
  let T;
  n[10] !== i || n[11] !== r || n[12] !== y || n[13] !== c ? (T = function(L) {
    if (!(y !== "idle" || i === void 0 && r === void 0)) {
      if (f(L), i?.(L), L === -1 && r) {
        C(!0);
        return;
      }
      L === 1 && i === void 0 && r?.(L), R.current = c, w("submitted");
    }
  }, n[10] = i, n[11] = r, n[12] = y, n[13] = c, n[14] = T) : T = n[14];
  const k = T;
  let P;
  n[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = function(L) {
    L !== "Other" && b(""), m(L);
  }, n[15] = P) : P = n[15];
  const D = P;
  let O;
  n[16] !== h || n[17] !== r || n[18] !== p || n[19] !== d || n[20] !== c ? (O = function() {
    !r || p === void 0 || (R.current = c, r(d, p === "Other" && h.trim() || p), w("submitted"));
  }, n[16] = h, n[17] = r, n[18] = p, n[19] = d, n[20] = c, n[21] = O) : O = n[21];
  const V = O;
  let _;
  return n[22] !== h || n[23] !== v || n[24] !== p || n[25] !== k || n[26] !== d || n[27] !== y || n[28] !== V ? (_ = {
    selectedRating: d,
    reason: p,
    feedbackText: h,
    isReasonsOpen: v,
    status: y,
    selectRating: k,
    selectReason: D,
    setFeedbackText: b,
    submitFeedback: V
  }, n[22] = h, n[23] = v, n[24] = p, n[25] = k, n[26] = d, n[27] = y, n[28] = V, n[29] = _) : _ = n[29], _;
}
function e0(t) {
  const e = W.c(16), {
    feedbackState: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("legend", { className: "sr-only", children: "Response feedback" }), e[0] = o) : o = e[0];
  const r = n.selectedRating === 1, i = n.status !== "idle";
  let s;
  e[1] !== n ? (s = () => n.selectRating(1), e[1] = n, e[2] = s) : s = e[2];
  let l;
  e[3] !== r || e[4] !== i || e[5] !== s ? (l = /* @__PURE__ */ g(bt, { icon: "thumbs-up", variant: "ghost", size: "sm", "aria-label": "Helpful response", "aria-pressed": r, disabled: i, onClick: s }), e[3] = r, e[4] = i, e[5] = s, e[6] = l) : l = e[6];
  const a = n.selectedRating === -1, c = n.status !== "idle";
  let u;
  e[7] !== n ? (u = () => n.selectRating(-1), e[7] = n, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== c || e[11] !== u ? (d = /* @__PURE__ */ g(bt, { icon: "thumbs-down", variant: "ghost", size: "sm", "aria-label": "Unhelpful response", "aria-pressed": a, disabled: c, onClick: u }), e[9] = a, e[10] = c, e[11] = u, e[12] = d) : d = e[12];
  let f;
  return e[13] !== l || e[14] !== d ? (f = /* @__PURE__ */ F("fieldset", { className: "m-0 flex items-center gap-(--spacing-4) border-0 p-0", children: [
    o,
    l,
    d
  ] }), e[13] = l, e[14] = d, e[15] = f) : f = e[15], f;
}
function $x(t) {
  const e = W.c(4), {
    children: n,
    selected: o,
    onClick: r
  } = t;
  let i;
  return e[0] !== n || e[1] !== r || e[2] !== o ? (i = /* @__PURE__ */ g("span", { "data-slot": "assistant-chat-feedback-reason", className: "contents [&_button[aria-pressed=true]]:bg-tag-pressed-background [&_button[aria-pressed=true]]:border-tag-pressed-outline", children: /* @__PURE__ */ g(ns, { "aria-pressed": o, onClick: r, children: n }) }), e[0] = n, e[1] = r, e[2] = o, e[3] = i) : i = e[3], i;
}
function t0(t) {
  const e = W.c(19), {
    feedbackState: n,
    allowWrittenFeedback: o,
    submitDisabled: r,
    className: i
  } = t, s = r === void 0 ? !1 : r;
  let l;
  e[0] !== i ? (l = ne(Q2(), i), e[0] = i, e[1] = l) : l = e[1];
  let a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(mo, { size: "lg", children: "Share Feedback" }), e[2] = a) : a = e[2];
  let c;
  e[3] !== n ? (c = Fx.map((m) => /* @__PURE__ */ g($x, { selected: n.reason === m, onClick: () => n.selectReason(m), children: m }, m)), e[3] = n, e[4] = c) : c = e[4];
  let u;
  e[5] !== c ? (u = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-start gap-(--spacing-10)", children: [
    a,
    /* @__PURE__ */ g("div", { className: "flex w-full flex-wrap gap-(--spacing-4) sm:w-max", children: c })
  ] }), e[5] = c, e[6] = u) : u = e[6];
  let d;
  e[7] !== o || e[8] !== n ? (d = o && n.reason === "Other" ? /* @__PURE__ */ g("div", { className: "min-w-0 w-full [&_input]:truncate", children: /* @__PURE__ */ g(Lx, { size: "sm", label: "Please provide details:", placeholder: "What was not helpful?", reserveSubtextSpace: !1, value: n.feedbackText, onChange: (m) => n.setFeedbackText(m.target.value) }) }) : null, e[7] = o, e[8] = n, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.reason || e[11] !== n.submitFeedback || e[12] !== s ? (f = n.reason !== void 0 ? /* @__PURE__ */ g(pn, { size: "sm", variant: "outline", disabled: s, onClick: n.submitFeedback, children: "Submit" }) : null, e[10] = n.reason, e[11] = n.submitFeedback, e[12] = s, e[13] = f) : f = e[13];
  let p;
  return e[14] !== l || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback-details", className: l, children: [
    u,
    d,
    f
  ] }), e[14] = l, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function n0(t) {
  const e = W.c(5), {
    className: n
  } = t;
  let o;
  e[0] !== n ? (o = ne(Q2(), n), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(an, { children: "Thanks! We’ve received your feedback." }), e[2] = r) : r = e[2];
  let i;
  return e[3] !== o ? (i = /* @__PURE__ */ g("output", { "data-slot": "assistant-chat-feedback", className: o, "aria-live": "polite", children: r }), e[3] = o, e[4] = i) : i = e[4], i;
}
function nD(t) {
  const e = W.c(13);
  let n, o;
  e[0] !== t ? ({
    allowWrittenFeedback: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? !0 : o, i = J2(n);
  if (i.status === "dismissed")
    return null;
  if (i.status === "submitted") {
    let c;
    return e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(n0, {}), e[3] = c) : c = e[3], c;
  }
  let s;
  e[4] !== i ? (s = /* @__PURE__ */ g(e0, { feedbackState: i }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== r || e[7] !== i || e[8] !== n ? (l = i.isReasonsOpen ? /* @__PURE__ */ g(t0, { feedbackState: i, allowWrittenFeedback: r, submitDisabled: n.onSubmit === void 0 }) : null, e[6] = r, e[7] = i, e[8] = n, e[9] = l) : l = e[9];
  let a;
  return e[10] !== s || e[11] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback", className: "contents", children: [
    s,
    l
  ] }), e[10] = s, e[11] = l, e[12] = a) : a = e[12], a;
}
const Hx = ae(["flex", "items-center", "justify-between", "gap-(--spacing-12)", "w-full", "px-(--spacing-12)", "max-sm:gap-(--spacing-8)", "max-sm:px-(--spacing-8)"], {
  variants: {
    minimized: {
      false: ["py-(--spacing-16)", "max-sm:py-(--spacing-12)", "bg-ai-panel-header-expanded", "relative", "after:pointer-events-none", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:border-b", "after:border-solid", "after:border-outline-subtle", "after:content-['']", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"],
      true: ["py-(--spacing-8)", "bg-ai-panel-header-minimized", "[background-origin:padding-box,border-box]", "[background-clip:padding-box,border-box]", "border", "border-solid", "border-transparent", "shadow-elevation-7", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"]
    }
  },
  defaultVariants: {
    minimized: !1
  }
});
function bc(t) {
  const e = W.c(50), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    minimized: i,
    onClose: s,
    onMinimize: l,
    onExpand: a,
    onNewConversation: c,
    isNewConversationDisabled: u,
    onOpenHistory: d,
    onBack: f,
    mobileHistoryControlRef: p
  } = t, m = i === void 0 ? !1 : i, h = u === void 0 ? !1 : u;
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    defaultMatches: !1
  }, e[0] = b) : b = e[0];
  const v = Ps(Ms.belowSm, b), C = m && !v;
  let y;
  e[1] !== C ? (y = ne(Hx({
    minimized: C
  })), e[1] = C, e[2] = y) : y = e[2];
  const w = C ? "" : void 0;
  let R;
  e[3] !== C || e[4] !== o ? (R = o ?? /* @__PURE__ */ g("div", { className: ne("flex shrink-0 items-center justify-center rounded-(--radius-sm)", C ? "relative size-(--icon-md) overflow-clip" : "size-(--spacing-40) p-(--spacing-4)"), children: /* @__PURE__ */ g(_u, { size: C ? "md" : "lg" }) }), e[3] = C, e[4] = o, e[5] = R) : R = e[5];
  const S = C ? "sm" : "md";
  let E;
  e[6] !== S || e[7] !== n ? (E = /* @__PURE__ */ g("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ g(Mn, { as: "h2", size: S, truncate: !0, children: n }) }), e[6] = S, e[7] = n, e[8] = E) : E = e[8];
  let N;
  e[9] !== r ? (N = r ? /* @__PURE__ */ g("span", { className: "shrink-0", children: r }) : null, e[9] = r, e[10] = N) : N = e[10];
  let I;
  e[11] !== E || e[12] !== N ? (I = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
    E,
    N
  ] }), e[11] = E, e[12] = N, e[13] = I) : I = e[13];
  let M;
  e[14] !== I || e[15] !== R ? (M = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-12)", children: [
    R,
    I
  ] }), e[14] = I, e[15] = R, e[16] = M) : M = e[16];
  let T;
  e[17] !== C || e[18] !== p || e[19] !== f ? (T = !C && f && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(bt, { ref: p, icon: "arrow-left", variant: "ghost", size: "sm", "aria-label": "Back to chat", onClick: f }) }), e[17] = C, e[18] = p, e[19] = f, e[20] = T) : T = e[20];
  let k;
  e[21] !== C || e[22] !== h || e[23] !== c ? (k = !C && c && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(bt, { icon: "edit-pen", variant: "ghost", size: "sm", "aria-label": "New chat", onClick: c, disabled: h }) }), e[21] = C, e[22] = h, e[23] = c, e[24] = k) : k = e[24];
  let P;
  e[25] !== C || e[26] !== p || e[27] !== f || e[28] !== d ? (P = !C && !f && d && /* @__PURE__ */ g("span", { className: "sm:hidden", children: /* @__PURE__ */ g(bt, { ref: p, icon: "clock-seven", variant: "ghost", size: "sm", "aria-label": "Open chat history", onClick: d }) }), e[25] = C, e[26] = p, e[27] = f, e[28] = d, e[29] = P) : P = e[29];
  let D;
  e[30] !== C || e[31] !== l ? (D = !C && /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(bt, { icon: "minus", variant: "ghost", size: "sm", "aria-label": "Minimize", onClick: l }) }), e[30] = C, e[31] = l, e[32] = D) : D = e[32];
  let O;
  e[33] !== C || e[34] !== a ? (O = C && /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(bt, { icon: "expand-regular", variant: "ghost", size: "sm", "aria-label": "Expand", onClick: a }) }), e[33] = C, e[34] = a, e[35] = O) : O = e[35];
  let V;
  e[36] !== s ? (V = /* @__PURE__ */ g(bt, { icon: "x-close", variant: "ghost", size: "sm", "aria-label": "Close", onClick: s }), e[36] = s, e[37] = V) : V = e[37];
  let _;
  e[38] !== T || e[39] !== k || e[40] !== P || e[41] !== D || e[42] !== O || e[43] !== V ? (_ = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
    T,
    k,
    P,
    D,
    O,
    V
  ] }), e[38] = T, e[39] = k, e[40] = P, e[41] = D, e[42] = O, e[43] = V, e[44] = _) : _ = e[44];
  let A;
  return e[45] !== M || e[46] !== _ || e[47] !== y || e[48] !== w ? (A = /* @__PURE__ */ F("header", { className: y, "data-slot": "assistant-chat-header", "data-minimized": w, children: [
    M,
    _
  ] }), e[45] = M, e[46] = _, e[47] = y, e[48] = w, e[49] = A) : A = e[49], A;
}
function uf(t) {
  const e = W.c(11), {
    size: n
  } = t, [o] = qe(zx), r = n === "fullPage" && "size-[100px]", i = n === "blocking" && "size-(--icon-xxl)", s = n === "xs" && "size-(--icon-xs)";
  let l;
  e[0] !== r || e[1] !== i || e[2] !== s ? (l = ne("aw-loading-animation shrink-0", r, i, s), e[0] = r, e[1] = i, e[2] = s, e[3] = l) : l = e[3];
  const a = `${o}ms`;
  let c;
  e[4] !== a ? (c = {
    animationDelay: a
  }, e[4] = a, e[5] = c) : c = e[5];
  let u, d;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("path", { className: "fill-outline-subtle opacity-40", d: "M4.8 24c0 10.605 8.595 19.2 19.2 19.2 8.085 0 15-4.995 17.835-12.068-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.128-2.123 5.31-7.313 9.06-13.38 9.06-7.95 0-14.4-6.45-14.4-14.4 0-7.95 6.45-14.4 14.4-14.4.698 0 1.388.053 2.063.143-1.313-.188-2.22-1.403-2.033-2.715.188-1.29 1.365-2.198 2.655-2.048a19.262 19.262 0 0 0-2.685-.188C13.395 4.793 4.8 13.388 4.8 23.993V24Z" }), d = /* @__PURE__ */ g("path", { className: "fill-primary-fixed", d: "M24.023 7.027c.187-1.312 1.402-2.22 2.715-2.032C36.045 6.33 43.2 14.325 43.2 24c0 2.513-.488 4.92-1.365 7.133-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.12.66-1.65 1.028-3.45 1.028-5.348 0-7.253-5.363-13.253-12.338-14.258-1.313-.188-2.22-1.403-2.033-2.715h-.015Z" }), e[6] = u, e[7] = d) : (u = e[6], d = e[7]);
  let f;
  return e[8] !== l || e[9] !== c ? (f = /* @__PURE__ */ F("svg", { "aria-hidden": "true", className: l, "data-slot": "loading-animation", fill: "none", style: c, viewBox: "0 0 48 48", children: [
    u,
    d
  ] }), e[8] = l, e[9] = c, e[10] = f) : f = e[10], f;
}
function zx() {
  return -(Date.now() % 1e3);
}
function o0(t) {
  const e = W.c(6), {
    label: n
  } = t, o = n ?? "Loading";
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(uf, { size: "blocking" }), e[0] = r) : r = e[0];
  let i;
  e[1] !== n ? (i = n && /* @__PURE__ */ g(mo, { align: "center", size: "xs", children: n }), e[1] = n, e[2] = i) : i = e[2];
  let s;
  return e[3] !== o || e[4] !== i ? (s = /* @__PURE__ */ F("output", { "aria-label": o, className: "flex flex-col items-center gap-(--spacing-8) rounded-(--radius-sm) bg-surface-container-lowest px-(--spacing-24) py-(--spacing-16)", "data-slot": "blocking-action-status", tabIndex: -1, children: [
    r,
    i
  ] }), e[3] = o, e[4] = i, e[5] = s) : s = e[5], s;
}
function oD(t) {
  const e = W.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    open: r,
    label: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r || void 0, l = r || void 0;
  let a;
  e[5] !== n || e[6] !== s || e[7] !== l ? (a = /* @__PURE__ */ g("div", { "aria-busy": s, inert: l, children: n }), e[5] = n, e[6] = s, e[7] = l, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== r ? (c = r && /* @__PURE__ */ g("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-surface-scrim", "data-slot": "blocking-action-overlay-scrim", children: /* @__PURE__ */ g(o0, { label: o }) }), e[9] = o, e[10] = r, e[11] = c) : c = e[11];
  let u;
  return e[12] !== i || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("div", { ...i, className: "relative", "data-slot": "blocking-action-overlay", children: [
    a,
    c
  ] }), e[12] = i, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
const r0 = ae(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "rounded-(--radius-sm)", "focus-visible:ring-2", "focus-visible:ring-(--color-inline-link-focus-ring)", "focus-visible:ring-offset-(--spacing-4)", "active:bg-(--color-inline-link-pressed-bg)"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-title-xs)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"],
      md: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    },
    variant: {
      contextual: ["text-(--color-inline-link-contextual)", "no-underline", "hover:underline", "underline-offset-4"],
      navigational: ["text-(--color-inline-link-navigational)", "text-start", "underline", "underline-offset-4", "hover:text-(--color-inline-link-navigational-hover)"]
    },
    destructive: {
      true: ["text-(--color-text-destructive)", "hover:text-(--color-text-destructive)"]
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none"]
    }
  },
  defaultVariants: {
    size: "md",
    variant: "contextual"
  }
}), Bx = "https://www.assetwatch.com/privacy-policy";
function Wx(t) {
  const e = W.c(4), {
    href: n,
    label: o
  } = t;
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = r0({
    size: "xs",
    variant: "contextual"
  }), e[0] = r) : r = e[0];
  let i;
  return e[1] !== n || e[2] !== o ? (i = /* @__PURE__ */ g("a", { className: r, href: n, target: "_blank", rel: "noopener noreferrer", children: o }), e[1] = n, e[2] = o, e[3] = i) : i = e[3], i;
}
function Ux({
  year: t = (/* @__PURE__ */ new Date()).getFullYear(),
  privacyPolicyHref: e = Bx,
  privacyPolicyLabel: n = "Privacy Policy"
}) {
  return /* @__PURE__ */ F("footer", { className: "flex h-(--spacing-32) w-full items-center justify-start gap-(--spacing-8)", children: [
    /* @__PURE__ */ F("span", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-xs) leading-(--font-line-height-16) font-(number:--font-weight-regular) text-text-default", children: [
      "© ",
      t,
      " AssetWatch"
    ] }),
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "h-(--spacing-16) border-l border-outline-subtle" }),
    /* @__PURE__ */ g(Wx, { href: e, label: n })
  ] });
}
function i0() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("output", { "aria-label": "Loading", tabIndex: -1, children: /* @__PURE__ */ g(uf, { size: "fullPage" }) }), t[0] = e) : e = t[0], e;
}
function rD(t) {
  const e = W.c(5);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g(i0, {}), e[2] = o) : o = e[2];
  let r;
  return e[3] !== n ? (r = /* @__PURE__ */ g("div", { ...n, "aria-busy": "true", className: "flex min-h-dvh items-center justify-center bg-surface-low p-(--spacing-24)", "data-slot": "full-page-loading", children: o }), e[3] = n, e[4] = r) : r = e[4], r;
}
const df = yo(null);
function ff() {
  return Cn(df);
}
function iD() {
  const t = Cn(df);
  if (!t)
    throw new Error("useAppShell must be used within AppShell.");
  return t;
}
function Gx(t) {
  const e = W.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tabs: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ? "shrink-0 flex min-h-0 max-h-[50dvh] flex-col bg-surface" : "shrink-0 max-h-[50dvh] overflow-y-auto border-b border-outline-subtle bg-surface p-(--spacing-24)";
  let s;
  e[4] !== n || e[5] !== r ? (s = r ? /* @__PURE__ */ g("div", { className: "min-h-0 overflow-y-auto px-(--spacing-24) pt-(--spacing-24) pb-(--spacing-20)", children: n }) : n, e[4] = n, e[5] = r, e[6] = s) : s = e[6];
  let l;
  e[7] !== r ? (l = r && /* @__PURE__ */ g("div", { className: "shrink-0", children: r }), e[7] = r, e[8] = l) : l = e[8];
  let a;
  return e[9] !== o || e[10] !== i || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ F("header", { "data-slot": "page-header", ...o, className: i, children: [
    s,
    l
  ] }), e[9] = o, e[10] = i, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function s0(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    modifier: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "items-center", "justify-center", "gap-(--spacing-4)", "rounded-(--radius-sm)", "border-[0.5px]", "border-solid", "border-menu-hotkey-outline", "bg-menu-hotkey-background", "px-(--spacing-6)", "py-(--spacing-4)", "font-(family-name:--font-family-body)", "text-(length:--font-size-label-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-surface-on-surface-variant", "whitespace-nowrap", "not-italic", "select-none"), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = o && /* @__PURE__ */ g("span", { children: o }), e[5] = o, e[6] = s) : s = e[6];
  let l;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (l = /* @__PURE__ */ F("kbd", { "data-slot": "kbd", className: i, ...r, children: [
    s,
    n
  ] }), e[7] = n, e[8] = r, e[9] = s, e[10] = l) : l = e[10], l;
}
const Yx = ae(["inline-flex", "h-(--spacing-40)", "w-full", "min-w-0", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-left", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "max-sm:hidden"]), jx = ae(["inline-flex", "size-(--spacing-40)", "items-center", "justify-between", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring"]), Kx = {
  left: {
    collapse: "arrow-left-shrink-sidebar",
    expand: "arrow-right-expand-sidebar"
  },
  right: {
    collapse: "arrow-right-expand-sidebar",
    expand: "arrow-left-shrink-sidebar"
  }
};
function yu(t) {
  const e = W.c(34);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    collapsed: n,
    collapseDirection: l,
    onClick: o,
    onToggle: r,
    shortcut: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "left" : l, c = n ? "Expand Panel" : "Collapse Panel", u = Kx[a][n ? "expand" : "collapse"];
  let d;
  e[7] !== o || e[8] !== r ? (d = function(y) {
    o?.(y), r();
  }, e[7] = o, e[8] = r, e[9] = d) : d = e[9];
  const f = d;
  if (!n) {
    let C;
    e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = Yx(), e[10] = C) : C = e[10];
    let y;
    e[11] !== u ? (y = /* @__PURE__ */ g(Ue, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[11] = u, e[12] = y) : y = e[12];
    let w;
    e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: "Collapse Panel" }), e[13] = w) : w = e[13];
    let R;
    e[14] !== y ? (R = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
      y,
      w
    ] }), e[14] = y, e[15] = R) : R = e[15];
    let S;
    return e[16] !== f || e[17] !== c || e[18] !== i || e[19] !== R ? (S = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !0, "aria-label": c, className: C, onClick: f, type: "button", children: R }), e[16] = f, e[17] = c, e[18] = i, e[19] = R, e[20] = S) : S = e[20], S;
  }
  let p;
  e[21] !== s ? (p = s ? /* @__PURE__ */ g(s0, { "aria-hidden": "true", children: s }) : void 0, e[21] = s, e[22] = p) : p = e[22];
  let m;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = jx(), e[23] = m) : m = e[23];
  let h;
  e[24] !== u ? (h = /* @__PURE__ */ g(Ue, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[24] = u, e[25] = h) : h = e[25];
  let b;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== h ? (b = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !1, "aria-label": c, className: m, onClick: f, type: "button", children: h }), e[26] = f, e[27] = c, e[28] = i, e[29] = h, e[30] = b) : b = e[30];
  let v;
  return e[31] !== p || e[32] !== b ? (v = /* @__PURE__ */ g("span", { className: "max-sm:hidden", children: /* @__PURE__ */ g(Xo, { align: "center", endSection: p, label: "Expand", showArrow: !1, side: "right", children: b }) }), e[31] = p, e[32] = b, e[33] = v) : v = e[33], v;
}
const qx = [
  "grid",
  "h-dvh",
  "min-h-0",
  "overflow-hidden",
  "bg-surface",
  "grid-rows-[auto_minmax(0,1fr)]",
  "transition-[grid-template-columns]",
  "duration-200",
  "ease-in-out",
  "[--app-shell-sidebar-expanded-width:260px]",
  "[--app-shell-sidebar-collapsed-width:72px]",
  "[--app-shell-sidebar-width:var(--app-shell-sidebar-expanded-width)]",
  "data-[sidebar-collapsed]:[--app-shell-sidebar-width:var(--app-shell-sidebar-collapsed-width)]",
  "grid-cols-[var(--app-shell-sidebar-width)_minmax(0,1fr)]",
  "[&>[data-slot=top-bar]]:col-span-2",
  // Keep the header brand region at the expanded width when the sidebar collapses.
  "[&_[data-slot=top-bar-leading]]:w-(--app-shell-sidebar-expanded-width)",
  "max-sm:grid-cols-1",
  "max-sm:[&>[data-slot=top-bar]]:col-span-1",
  "max-sm:[&_[data-slot=top-bar-leading]]:w-auto"
].join(" "), l0 = "[", a0 = "assetwatch:app-shell:sidebar-collapsed";
function Zx() {
  if (typeof window > "u") return !1;
  try {
    return window.localStorage.getItem(a0) === "true";
  } catch {
    return !1;
  }
}
function Jp(t) {
  try {
    window.localStorage.setItem(a0, String(t));
  } catch {
  }
}
function Xx(t) {
  return t instanceof HTMLElement ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable : !1;
}
function sD({
  children: t,
  ...e
}) {
  const n = Ps(Ms.belowSm, {
    defaultMatches: !1
  }), [o, r] = qe(Zx), [i, s] = qe(!1), [l, a] = qe([]), c = at(0), u = l.at(-1), d = en(), f = x7();
  function p(b) {
    r(b), Jp(b);
  }
  function m(b) {
    const v = c.current;
    return c.current += 1, a((C) => [...C, {
      ...b,
      id: v
    }]), () => {
      a((C) => C.filter((y) => y.id !== v));
    };
  }
  Nt(() => {
    if (n) return;
    function b(v) {
      if (v.defaultPrevented || v.isComposing || v.metaKey || v.ctrlKey || v.altKey || v.shiftKey || Xx(v.target) || v.key !== l0)
        return;
      v.preventDefault();
      const C = !o;
      r(C), Jp(C);
    }
    return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
  }, [o, n]), Nt(() => {
    if (d)
      return d.inert = !!u, () => {
        d.inert = !1;
      };
  }, [u, d]);
  const h = u ? /* @__PURE__ */ g("div", { className: "fixed inset-0 z-[var(--z-layer-blocking)] flex items-center justify-center bg-surface-scrim", "data-slot": "app-shell-blocking-overlay", children: /* @__PURE__ */ g(o0, { label: u.label }) }) : null;
  return /* @__PURE__ */ g(df, { value: {
    desktopSidebarCollapsed: o,
    beginBlockingAction: m,
    isMobile: n,
    mobileNavigationOpen: i,
    setDesktopSidebarCollapsed: p,
    setMobileNavigationOpen: s
  }, children: /* @__PURE__ */ F("div", { className: "relative h-dvh", children: [
    /* @__PURE__ */ g("div", { ...e, "aria-busy": u ? !0 : void 0, className: qx, "data-sidebar-collapsed": o ? "" : void 0, "data-slot": "app-shell", inert: u ? !0 : void 0, children: t }),
    h && (f ? l4(h, f) : h)
  ] }) });
}
function lD(t) {
  const e = W.c(30);
  let n, o, r, i, s, l, a, c;
  if (e[0] !== t ? ({
    banner: n,
    pageHeader: r,
    pageHeaderTabs: i,
    privacyPolicyLabel: l,
    privacyPolicyHref: s,
    children: o,
    pending: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]), c === void 0 ? !1 : c) {
    let v;
    e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ g("main", { "aria-busy": "true", className: "flex min-h-0 min-w-0 items-center justify-center overflow-y-auto bg-surface-low p-(--spacing-24)", children: /* @__PURE__ */ g(i0, {}) }), e[9] = v) : v = e[9];
    let C;
    return e[10] !== a ? (C = /* @__PURE__ */ g("div", { ...a, className: "grid min-h-0 min-w-0 grid-rows-[minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: v }), e[10] = a, e[11] = C) : C = e[11], C;
  }
  let d;
  e[12] !== n ? (d = n && /* @__PURE__ */ g(Qo, { "data-slot": "app-shell-banner", fullWidth: !0, gap: 0, children: n }), e[12] = n, e[13] = d) : d = e[13];
  let f;
  e[14] !== r || e[15] !== i ? (f = r && /* @__PURE__ */ g(Gx, { tabs: i, "data-slot": "app-shell-page-header", children: r }), e[14] = r, e[15] = i, e[16] = f) : f = e[16];
  let p;
  e[17] !== o ? (p = /* @__PURE__ */ g("div", { className: "min-w-0 grow", children: o }), e[17] = o, e[18] = p) : p = e[18];
  let m;
  e[19] !== s || e[20] !== l ? (m = /* @__PURE__ */ g("div", { className: "mt-(--spacing-32) shrink-0", children: /* @__PURE__ */ g(Ux, { privacyPolicyHref: s, privacyPolicyLabel: l }) }), e[19] = s, e[20] = l, e[21] = m) : m = e[21];
  let h;
  e[22] !== p || e[23] !== m ? (h = /* @__PURE__ */ F("main", { className: "row-start-3 flex min-h-0 min-w-0 flex-col overflow-y-auto bg-surface-low px-(--spacing-24) pt-(--spacing-24)", "data-slot": "app-shell-content-body", children: [
    p,
    m
  ] }), e[22] = p, e[23] = m, e[24] = h) : h = e[24];
  let b;
  return e[25] !== a || e[26] !== d || e[27] !== f || e[28] !== h ? (b = /* @__PURE__ */ F("div", { ...a, className: "relative z-0 grid min-h-0 min-w-0 grid-cols-[minmax(0,1fr)] grid-rows-[auto_auto_minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: [
    d,
    f,
    h
  ] }), e[25] = a, e[26] = d, e[27] = f, e[28] = h, e[29] = b) : b = e[29], b;
}
function aD(t) {
  const e = W.c(7);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const o = ff();
  if (!o)
    throw new Error("AppShellMobileNavigationTrigger must be rendered within AppShell.");
  if (!o.isMobile)
    return null;
  let r;
  e[2] !== o ? (r = () => o.setMobileNavigationOpen(!0), e[2] = o, e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== r ? (i = /* @__PURE__ */ g(bt, { ...n, "aria-label": "Open navigation", icon: "menu-hamburger", onClick: r, variant: "ghost" }), e[4] = n, e[5] = r, e[6] = i) : i = e[6], i;
}
function Qx(t) {
  const e = W.c(11);
  let n, o;
  e[0] !== t ? ({
    onClick: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = ff();
  if (!r)
    throw new Error("AppShellSidebarToggle must be rendered within AppShell.");
  if (r.isMobile)
    return null;
  const {
    desktopSidebarCollapsed: i,
    setDesktopSidebarCollapsed: s
  } = r;
  let l;
  e[3] !== i || e[4] !== s ? (l = () => s(!i), e[3] = i, e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== i || e[7] !== n || e[8] !== o || e[9] !== l ? (a = /* @__PURE__ */ g(yu, { ...o, collapsed: i, onClick: n, onToggle: l, shortcut: l0 }), e[6] = i, e[7] = n, e[8] = o, e[9] = l, e[10] = a) : a = e[10], a;
}
function Jx(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, i = e !== void 0, [s, l] = Sn({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: c,
    transitionStatus: u
  } = to(s, !0, !0), [d, f] = x.useState(s), [{
    height: p,
    width: m
  }, h] = x.useState({
    height: void 0,
    width: void 0
  }), b = Ot(), [v, C] = x.useState(), y = v ?? b, [w, R] = x.useState(!1), [S, E] = x.useState(!1), N = x.useRef(null), I = x.useRef(null), M = x.useRef(null), T = x.useRef(null), k = la(T, !1), P = we((D) => {
    const O = !s, V = De(eo, D.nativeEvent);
    if (o(O, V), V.isCanceled)
      return;
    const _ = T.current;
    I.current === "css-animation" && _ != null && _.style.removeProperty("animation-name"), !w && !S && (I.current != null && I.current !== "css-animation" && !a && O && c(!0), I.current === "css-animation" && (!d && O && f(!0), !a && O && c(!0))), l(O), I.current === "none" && a && !O && c(!1);
  });
  return ke(() => {
    i && I.current === "none" && !s && c(!1);
  }, [i, s, e, c]), x.useMemo(() => ({
    abortControllerRef: N,
    animationTypeRef: I,
    disabled: r,
    handleTrigger: P,
    height: p,
    mounted: a,
    open: s,
    panelId: y,
    panelRef: T,
    runOnceAnimationsFinish: k,
    setDimensions: h,
    setHiddenUntilFound: R,
    setKeepMounted: E,
    setMounted: c,
    setOpen: l,
    setPanelIdState: C,
    setVisible: f,
    transitionDimensionRef: M,
    transitionStatus: u,
    visible: d,
    width: m
  }), [N, I, r, P, p, a, s, y, T, k, h, R, E, c, l, f, M, u, d, m]);
}
const pf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (pf.displayName = "CollapsibleRootContext");
function c0() {
  const t = x.useContext(pf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : st(15));
  return t;
}
let Ui = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Jn.startingStyle] = "startingStyle", t[t.endingStyle = Jn.endingStyle] = "endingStyle", t;
})({}), eC = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const tC = {
  [Ui.open]: ""
}, nC = {
  [Ui.closed]: ""
}, oC = {
  open(t) {
    return t ? {
      [eC.panelOpen]: ""
    } : null;
  }
}, rC = {
  open(t) {
    return t ? tC : nC;
  }
}, u0 = {
  ...rC,
  ...Kt
}, mf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: i = !1,
    disabled: s = !1,
    onOpenChange: l,
    open: a,
    style: c,
    ...u
  } = e, d = we(l), f = Jx({
    open: a,
    defaultOpen: i,
    onOpenChange: d,
    disabled: s
  }), p = x.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), m = x.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: p
  }), [f, d, p]), h = Le("div", e, {
    state: p,
    ref: n,
    props: u,
    stateAttributesMapping: u0
  });
  return /* @__PURE__ */ g(pf.Provider, {
    value: m,
    children: h
  });
});
process.env.NODE_ENV !== "production" && (mf.displayName = "CollapsibleRoot");
const iC = {
  ...oC,
  ...Kt
}, Xl = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: i,
    state: s,
    disabled: l
  } = c0(), {
    className: a,
    disabled: c = l,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, {
    getButtonProps: h,
    buttonRef: b
  } = qt({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), v = x.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: i
  }), [o, r, i]);
  return Le("button", e, {
    state: s,
    ref: [n, b],
    props: [v, m, h],
    stateAttributesMapping: iC
  });
});
process.env.NODE_ENV !== "production" && (Xl.displayName = "CollapsibleTrigger");
let sC = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function lC(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: i,
    keepMounted: s,
    id: l,
    mounted: a,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: p,
    setMounted: m,
    setOpen: h,
    setVisible: b,
    transitionDimensionRef: v,
    visible: C,
    width: y
  } = t, w = x.useRef(!1), R = x.useRef(null), S = x.useRef(u), E = x.useRef(u), N = ri(), I = x.useMemo(() => n.current === "css-animation" ? !C : !u && !a, [u, a, C, n]), M = we((k) => {
    if (!k)
      return;
    if (n.current == null || v.current == null) {
      const O = getComputedStyle(k), V = O.animationName !== "none" && O.animationName !== "", _ = O.transitionDuration !== "0s" && O.transitionDuration !== "";
      V && _ ? process.env.NODE_ENV !== "production" && sa("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : O.animationName === "none" && O.transitionDuration !== "0s" ? n.current = "css-transition" : O.animationName !== "none" && O.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", k.getAttribute(sC.orientation) === "horizontal" || O.transitionProperty.indexOf("width") > -1 ? v.current = "width" : v.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || y === void 0) && (p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), E.current && k.style.setProperty("transition-duration", "0s"));
    let P = -1, D = -1;
    return P = Wt.request(() => {
      E.current = !1, D = Wt.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      Wt.cancel(P), Wt.cancel(D);
    };
  }), T = Rn(o, d, M);
  return ke(() => {
    if (n.current !== "css-transition")
      return;
    const k = d.current;
    if (!k)
      return;
    let P = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const D = {
        "justify-content": k.style.justifyContent,
        "align-items": k.style.alignItems,
        "align-content": k.style.alignContent,
        "justify-items": k.style.justifyItems
      };
      Object.keys(D).forEach((O) => {
        k.style.setProperty(O, "initial", "important");
      }), !E.current && !s && k.setAttribute(Ui.startingStyle, ""), p({
        height: k.scrollHeight,
        width: k.scrollWidth
      }), P = Wt.request(() => {
        Object.entries(D).forEach(([O, V]) => {
          V === "" ? k.style.removeProperty(O) : k.style.setProperty(O, V);
        });
      });
    } else {
      if (k.scrollHeight === 0 && k.scrollWidth === 0)
        return;
      p({
        height: k.scrollHeight,
        width: k.scrollWidth
      });
      const D = new AbortController();
      e.current = D;
      const O = D.signal;
      let V = null;
      const _ = Ui.endingStyle;
      return V = new MutationObserver((A) => {
        A.some(($) => $.type === "attributes" && $.attributeName === _) && (V?.disconnect(), V = null, f(() => {
          p({
            height: 0,
            width: 0
          }), k.style.removeProperty("content-visibility"), m(!1), e.current === D && (e.current = null);
        }, O));
      }), V.observe(k, {
        attributes: !0,
        attributeFilter: [_]
      }), () => {
        V?.disconnect(), N.cancel(), e.current === D && (D.abort(), e.current = null);
      };
    }
    return () => {
      Wt.cancel(P);
    };
  }, [e, n, N, i, s, a, u, d, f, p, m]), ke(() => {
    if (n.current !== "css-animation")
      return;
    const k = d.current;
    k && (R.current = k.style.animationName || R.current, k.style.setProperty("animation-name", "none"), p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), !S.current && !w.current && k.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), m(!0), b(!0)) : (e.current = new AbortController(), f(() => {
      m(!1), b(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, f, p, m, b, C]), oi(() => {
    const k = Wt.request(() => {
      S.current = !1;
    });
    return () => Wt.cancel(k);
  }), ke(() => {
    if (!i)
      return;
    const k = d.current;
    if (!k)
      return;
    let P = -1, D = -1;
    return u && w.current && (k.style.transitionDuration = "0s", p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), P = Wt.request(() => {
      w.current = !1, D = Wt.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      Wt.cancel(P), Wt.cancel(D);
    };
  }, [i, u, d, p]), ke(() => {
    const k = d.current;
    k && i && I && (k.setAttribute("hidden", "until-found"), n.current === "css-transition" && k.setAttribute(Ui.startingStyle, ""));
  }, [i, I, n, d]), x.useEffect(function() {
    const P = d.current;
    if (!P)
      return;
    function D(O) {
      w.current = !0, h(!0), c(!0, De(At, O));
    }
    return dt(P, "beforematch", D);
  }, [c, d, h]), x.useMemo(() => ({
    props: {
      hidden: I,
      id: l,
      ref: T
    }
  }), [I, l, T]);
}
let em = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const gf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: i,
    render: s,
    id: l,
    style: a,
    ...c
  } = e;
  process.env.NODE_ENV !== "production" && ke(() => {
    r && i === !1 && sa("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, i]);
  const {
    abortControllerRef: u,
    animationTypeRef: d,
    height: f,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelId: b,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setHiddenUntilFound: w,
    setKeepMounted: R,
    setMounted: S,
    setPanelIdState: E,
    setOpen: N,
    setVisible: I,
    state: M,
    transitionDimensionRef: T,
    visible: k,
    width: P,
    transitionStatus: D
  } = c0(), O = r ?? !1, V = i ?? !1;
  ke(() => {
    if (l)
      return E(l), () => {
        E(void 0);
      };
  }, [l, E]), ke(() => {
    w(O);
  }, [w, O]), ke(() => {
    R(V);
  }, [R, V]);
  const {
    props: _
  } = lC({
    abortControllerRef: u,
    animationTypeRef: d,
    externalRef: n,
    height: f,
    hiddenUntilFound: O,
    id: b,
    keepMounted: V,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setMounted: S,
    setOpen: N,
    setVisible: I,
    transitionDimensionRef: T,
    visible: k,
    width: P
  });
  Jt({
    open: h && D === "idle",
    ref: v,
    onComplete() {
      h && y({
        height: void 0,
        width: void 0
      });
    }
  });
  const A = x.useMemo(() => ({
    ...M,
    transitionStatus: D
  }), [M, D]), L = Le("div", e, {
    state: A,
    ref: [n, v],
    props: [_, {
      style: {
        [em.collapsiblePanelHeight]: f === void 0 ? "auto" : `${f}px`,
        [em.collapsiblePanelWidth]: P === void 0 ? "auto" : `${P}px`
      }
    }, c],
    stateAttributesMapping: u0
  });
  return V || O || p ? L : null;
});
process.env.NODE_ENV !== "production" && (gf.displayName = "CollapsiblePanel");
function Ma(t) {
  return Le(t.defaultTagName ?? "div", t, t);
}
const hf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (hf.displayName = "DialogRootContext");
function kn(t) {
  const e = x.useContext(hf);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : st(27));
  return e;
}
let ln = /* @__PURE__ */ (function(t) {
  return t.nestedDrawers = "--nested-drawers", t.height = "--drawer-height", t.frontmostHeight = "--drawer-frontmost-height", t.swipeMovementX = "--drawer-swipe-movement-x", t.swipeMovementY = "--drawer-swipe-movement-y", t.snapPointOffset = "--drawer-snap-point-offset", t.swipeStrength = "--drawer-swipe-strength", t;
})({}), Io = /* @__PURE__ */ (function(t) {
  return t.swipeProgress = "--drawer-swipe-progress", t;
})({});
const aC = {
  ...An,
  ...Kt
}, d0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = kn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: aC,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        pointerEvents: c ? void 0 : "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        [Io.swipeProgress]: "0",
        [ln.swipeStrength]: "1"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (d0.displayName = "DrawerBackdrop");
const ti = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, {
    store: c
  } = kn(), u = c.useState("open");
  function d(h) {
    u && c.setOpen(!1, De(oh, h.nativeEvent));
  }
  const {
    getButtonProps: f,
    buttonRef: p
  } = qt({
    disabled: i,
    native: s
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, p],
    props: [{
      onClick: d
    }, a, f]
  });
});
process.env.NODE_ENV !== "production" && (ti.displayName = "DialogClose");
const f0 = ti, p0 = "data-drawer-content", m0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e;
  return kn(), Le("div", e, {
    ref: n,
    props: [{
      [p0]: ""
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (m0.displayName = "DrawerContent");
const os = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = kn(), c = Ot(s);
  return a.useSyncedValueWithCleanup("descriptionElementId", c), Le("p", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (os.displayName = "DialogDescription");
const cC = os, g0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (g0.displayName = "DrawerProviderContext");
function h0(t) {
  return x.useContext(g0);
}
let Kn = (function(t) {
  return t[t.open = wn.open] = "open", t[t.closed = wn.closed] = "closed", t[t.startingStyle = wn.startingStyle] = "startingStyle", t[t.endingStyle = wn.endingStyle] = "endingStyle", t.expanded = "data-expanded", t.nestedDrawerOpen = "data-nested-drawer-open", t.nestedDrawerSwiping = "data-nested-drawer-swiping", t.swipeDismiss = "data-swipe-dismiss", t.swipeDirection = "data-swipe-direction", t.swiping = "data-swiping", t;
})({});
const bf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (bf.displayName = "DialogPortalContext");
function vf() {
  const t = x.useContext(bf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : st(26));
  return t;
}
const yf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (yf.displayName = "DrawerRootContext");
function Ta(t) {
  const e = x.useContext(yf);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DrawerRootContext is missing. Drawer parts must be placed within <Drawer.Root>." : st(90));
  return e;
}
function Zt(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
function tm(t, e, n) {
  if (!Number.isFinite(e) || e <= 0)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t <= 1 ? Zt(t, 0, 1) * e : t : null;
  const o = t.trim();
  if (o.endsWith("px")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r : null;
  }
  if (o.endsWith("rem")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r * n : null;
  }
  return null;
}
function uC(t, e) {
  let n = null, o = 1 / 0;
  for (const r of e) {
    const i = Math.abs(r.height - t);
    i < o && (o = i, n = r);
  }
  return n;
}
function b0() {
  const {
    store: t
  } = kn(), {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r
  } = Ta(), i = t.useState("viewportElement"), [s, l] = x.useState(0), [a, c] = x.useState(16), u = we(() => {
    const m = nt(i).documentElement;
    i && l(i.offsetHeight), i || l(m.clientHeight);
    const h = parseFloat(getComputedStyle(m).fontSize);
    Number.isFinite(h) && c(h);
  });
  ke(() => {
    if (u(), !i || typeof ResizeObserver != "function")
      return;
    const p = new ResizeObserver(u);
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [u, i]);
  const d = x.useMemo(() => {
    if (!e || e.length === 0 || s <= 0 || r <= 0)
      return [];
    const p = Math.min(r, s);
    if (!Number.isFinite(p) || p <= 0)
      return [];
    const m = e.map((v) => {
      const C = tm(v, s, a);
      if (C === null || !Number.isFinite(C))
        return null;
      const y = Zt(C, 0, p);
      return {
        value: v,
        height: y,
        offset: Math.max(0, r - y)
      };
    }).filter((v) => !!v);
    if (m.length <= 1)
      return m;
    const h = [], b = [];
    for (let v = m.length - 1; v >= 0; v -= 1) {
      const C = m[v];
      b.some((w) => Math.abs(w - C.height) <= 1) || (b.push(C.height), h.push(C));
    }
    return h.reverse(), h;
  }, [r, a, e, s]), f = x.useMemo(() => {
    if (n === void 0)
      return d[0];
    if (n === null)
      return;
    const p = d.find((v) => Object.is(v.value, n));
    if (p)
      return p;
    const m = Math.min(r, s), h = tm(n, s, a);
    if (h === null || !Number.isFinite(h))
      return;
    const b = Zt(h, 0, m);
    return uC(b, d) ?? void 0;
  }, [n, r, d, a, s]);
  return {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r,
    viewportHeight: s,
    resolvedSnapPoints: d,
    activeSnapPointOffset: f?.offset ?? null
  };
}
const xf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (xf.displayName = "DrawerViewportContext");
function dC(t) {
  return x.useContext(xf);
}
let nm = !1;
function fC() {
  nm || (typeof CSS < "u" && "registerProperty" in CSS && ([ln.swipeMovementX, ln.swipeMovementY, ln.snapPointOffset].forEach((t) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<length>",
        inherits: !1,
        initialValue: "0px"
      });
    } catch {
    }
  }), [{
    name: Io.swipeProgress,
    initialValue: "0"
  }, {
    name: ln.swipeStrength,
    initialValue: "1"
  }].forEach(({
    name: t,
    initialValue: e
  }) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<number>",
        inherits: !1,
        initialValue: e
      });
    } catch {
    }
  })), nm = !0);
}
const pC = {
  ...An,
  ...Kt,
  expanded(t) {
    return t ? {
      [Kn.expanded]: ""
    } : null;
  },
  nestedDrawerOpen(t) {
    return t ? {
      [Kn.nestedDrawerOpen]: ""
    } : null;
  },
  nestedDrawerSwiping(t) {
    return t ? {
      [Kn.nestedDrawerSwiping]: ""
    } : null;
  },
  swipeDirection(t) {
    return t ? {
      [Kn.swipeDirection]: t
    } : null;
  },
  swiping(t) {
    return t ? {
      [Kn.swiping]: ""
    } : null;
  }
}, v0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = kn(), {
    swipeDirection: u,
    frontmostHeight: d,
    hasNestedDrawer: f,
    nestedSwiping: p,
    nestedSwipeProgressStore: m,
    onPopupHeightChange: h,
    notifyParentFrontmostHeight: b,
    notifyParentHasNestedDrawer: v
  } = Ta(), C = c.useState("descriptionElementId"), y = c.useState("disablePointerDismissal"), w = c.useState("floatingRootContext"), R = c.useState("popupProps"), S = c.useState("modal"), E = c.useState("mounted"), N = c.useState("nested"), I = c.useState("nestedOpenDrawerCount"), M = c.useState("transitionStatus"), T = c.useState("open"), k = c.useState("openMethod"), P = c.useState("titleElementId"), D = c.useState("role"), O = I > 0, V = dC(), _ = V?.swiping ?? !1, A = V?.swipeStrength ?? null, {
    snapPoints: L,
    activeSnapPoint: $,
    activeSnapPointOffset: B
  } = b0();
  vf();
  const [z, H] = x.useState(0), K = x.useRef(0);
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (V)
      return;
    const ce = br.captureOwnerStack?.() || "";
    Zo(`<Drawer.Popup> expected to be rendered within <Drawer.Viewport>. Omitting the viewport disables drawer swipe handling and touch scroll locking. Wrap <Drawer.Popup> in <Drawer.Viewport>.${ce}`);
  }, [V]);
  const G = we(() => {
    const ce = c.context.popupRef.current;
    if (!ce)
      return;
    const oe = ce.offsetHeight;
    if (K.current > 0 && d > K.current && oe > K.current)
      return;
    if (K.current > 0 && f) {
      const pe = K.current;
      H(pe), h(pe);
      return;
    }
    const me = oe;
    me !== K.current && (K.current = me, H(me), h(me));
  });
  ke(() => {
    if (!E) {
      K.current = 0, H(0), h(0);
      return;
    }
    const ce = c.context.popupRef.current;
    if (!ce || (fC(), G(), typeof ResizeObserver != "function"))
      return;
    const oe = new ResizeObserver(G);
    return oe.observe(ce), () => {
      oe.disconnect();
    };
  }, [G, E, O, h, c.context.popupRef]), ke(() => {
    const ce = c.context.popupRef, oe = () => {
      const me = ce.current;
      if (!me)
        return;
      const pe = m.getSnapshot();
      pe > 0 ? me.style.setProperty(Io.swipeProgress, `${pe}`) : me.style.setProperty(Io.swipeProgress, "0");
    };
    oe();
    const se = m.subscribe(oe);
    return () => {
      se();
      const me = ce.current;
      me && me.style.setProperty(Io.swipeProgress, "0");
    };
  }, [m, c.context.popupRef]), x.useEffect(() => {
    if (T)
      return b?.(d), () => {
        b?.(0);
      };
  }, [d, T, b]), x.useEffect(() => v ? (v(T || M === "ending"), () => {
    v(!1);
  }) : void 0, [v, T, M]), Jt({
    open: T,
    ref: c.context.popupRef,
    onComplete() {
      T && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const q = i === void 0 ? c.context.popupRef : i, Q = {
    open: T,
    nested: N,
    transitionStatus: M,
    expanded: $ === 1,
    nestedDrawerOpen: O,
    nestedDrawerSwiping: p,
    swipeDirection: u,
    swiping: _
  };
  let U;
  z && !(!f && M !== "ending") && (U = `${z}px`);
  const te = L && L.length > 0 && (u === "down" || u === "up");
  let re = null;
  te && B !== null && (re = u === "up" ? -B : B);
  let J = V ? V.getDragStyles() : Et;
  if (te && u === "down") {
    const ce = B ?? 0, oe = Number.parseFloat(String(J[ln.swipeMovementY] ?? 0)), se = Number.isFinite(oe) ? ce + oe : ce, me = se < 0;
    if (_ && me && Number.isFinite(oe)) {
      const pe = Math.abs(se), ge = -Math.sqrt(pe) - ce;
      J = {
        ...J,
        transform: void 0,
        [ln.swipeMovementY]: `${ge}px`
      };
    } else
      J = {
        ...J,
        transform: void 0
      };
  }
  const ie = Le("div", e, {
    state: Q,
    props: [R, {
      "aria-labelledby": P,
      "aria-describedby": C,
      role: D,
      tabIndex: -1,
      hidden: !E,
      onKeyDown(ce) {
        Rs.has(ce.key) && ce.stopPropagation();
      },
      style: {
        ...J,
        [Io.swipeProgress]: "0",
        [ln.nestedDrawers]: I,
        [ln.height]: U,
        [ln.snapPointOffset]: typeof re == "number" ? `${re}px` : "0px",
        [ln.frontmostHeight]: d ? `${d}px` : void 0,
        [ln.swipeStrength]: typeof A == "number" && Number.isFinite(A) && A > 0 ? `${A}` : "1"
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: pC
  });
  return /* @__PURE__ */ g(li, {
    context: w,
    openInteractionType: k,
    disabled: !E,
    closeOnFocusOut: !y,
    initialFocus: q,
    returnFocus: r,
    modal: S !== !1,
    restoreFocus: "popup",
    children: ie
  });
});
process.env.NODE_ENV !== "production" && (v0.displayName = "DrawerPopup");
const Lr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = kn(), s = i.useState("mounted"), l = i.useState("modal"), a = i.useState("open");
  return s || o ? /* @__PURE__ */ g(bf.Provider, {
    value: o,
    children: /* @__PURE__ */ F(si, {
      ref: n,
      ...r,
      children: [s && l === !0 && /* @__PURE__ */ g(ui, {
        ref: i.context.internalBackdropRef,
        inert: Tr(!a)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Lr.displayName = "DialogPortal");
const mC = Lr, gC = {
  ...An,
  ...Kt
}, Os = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = kn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: gC,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (Os.displayName = "DialogBackdrop");
let hC = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), bC = (function(t) {
  return t[t.open = wn.open] = "open", t[t.closed = wn.closed] = "closed", t[t.startingStyle = wn.startingStyle] = "startingStyle", t[t.endingStyle = wn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const vC = {
  ...An,
  ...Kt,
  nestedDialogOpen(t) {
    return t ? {
      [bC.nestedDialogOpen]: ""
    } : null;
  }
}, xi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = kn(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), p = c.useState("popupProps"), m = c.useState("modal"), h = c.useState("mounted"), b = c.useState("nested"), v = c.useState("nestedOpenDialogCount"), C = c.useState("open"), y = c.useState("openMethod"), w = c.useState("titleElementId"), R = c.useState("transitionStatus"), S = c.useState("role");
  vf(), Jt({
    open: C,
    ref: c.context.popupRef,
    onComplete() {
      C && c.context.onOpenChangeComplete?.(!0);
    }
  });
  function E(k) {
    return k === "touch" ? c.context.popupRef.current : !0;
  }
  const N = i === void 0 ? E : i, I = v > 0, T = Le("div", e, {
    state: {
      open: C,
      nested: b,
      transitionStatus: R,
      nestedDialogOpen: I
    },
    props: [p, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": u ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !h,
      onKeyDown(k) {
        Rs.has(k.key) && k.stopPropagation();
      },
      style: {
        [hC.nestedDialogs]: v
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: vC
  });
  return /* @__PURE__ */ g(li, {
    context: f,
    openInteractionType: y,
    disabled: !h,
    closeOnFocusOut: !d,
    initialFocus: N,
    returnFocus: r,
    modal: m !== !1,
    restoreFocus: "popup",
    children: T
  });
});
process.env.NODE_ENV !== "production" && (xi.displayName = "DialogPopup");
function yC(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o,
    isDrawer: r
  } = t, i = e.useState("open"), s = e.useState("disablePointerDismissal"), l = e.useState("modal"), a = e.useState("popupElement"), {
    openMethod: c,
    triggerProps: u
  } = Ns(i);
  gs(e);
  const {
    forceUnmount: d
  } = hs(i, e), f = x.useCallback(() => {
    e.setOpen(!1, De(ds));
  }, [e]);
  x.useImperativeHandle(o, () => ({
    unmount: d,
    close: f
  }), [d, f]);
  const p = ys({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0
  }), [m, h] = x.useState(0), [b, v] = x.useState(0), C = m === 0, y = kd(p), w = kr(p, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: l === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(T) {
      if (!e.context.outsidePressEnabledRef.current || "button" in T && T.button !== 0 || "touches" in T && T.touches.length !== 1)
        return !1;
      const k = yt(T);
      if (C && !s) {
        const P = k;
        return l && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === P || e.context.backdropRef.current === P || Fe(P, a) && !P?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: C
  });
  p2(i && l === !0, a);
  const {
    getReferenceProps: R,
    getFloatingProps: S,
    getTriggerProps: E
  } = ro([y, w]);
  e.useContextCallback("onNestedDialogOpen", (T, k) => {
    h(T), v(k);
  }), e.useContextCallback("onNestedDialogClose", () => {
    h(0), v(0);
  }), x.useEffect(() => (n?.onNestedDialogOpen && i && n.onNestedDialogOpen(m + 1, b + (r ? 1 : 0)), n?.onNestedDialogClose && !i && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && i && n.onNestedDialogClose();
  }), [r, i, m, b, n]);
  const N = x.useMemo(() => R(u), [R, u]), I = x.useMemo(() => E(u), [E, u]), M = x.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: c,
    activeTriggerProps: N,
    inactiveTriggerProps: I,
    popupProps: M,
    floatingRootContext: p,
    nestedOpenDialogCount: m,
    nestedOpenDrawerCount: b
  });
}
const xC = {
  ...vs,
  modal: he((t) => t.modal),
  nested: he((t) => t.nested),
  nestedOpenDialogCount: he((t) => t.nestedOpenDialogCount),
  nestedOpenDrawerCount: he((t) => t.nestedOpenDrawerCount),
  disablePointerDismissal: he((t) => t.disablePointerDismissal),
  openMethod: he((t) => t.openMethod),
  descriptionElementId: he((t) => t.descriptionElementId),
  titleElementId: he((t) => t.titleElementId),
  viewportElement: he((t) => t.viewportElement),
  role: he((t) => t.role)
};
class Cf extends Ir {
  constructor(e) {
    super(CC(e), {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: new Pr(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, xC);
  }
  setOpen = (e, n) => {
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, !e && n.trigger == null && this.state.activeTriggerId != null && (n.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const o = {
      open: e
    }, r = n.trigger?.id ?? null;
    (r || e) && (o.activeTriggerId = r, o.activeTriggerElement = n.trigger ?? null), this.update(o);
  };
  static useStore(e, n) {
    const o = Lt(() => new Cf(n)).current;
    return e ?? o;
  }
}
function CC(t = {}) {
  return {
    ...bs(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...t
  };
}
const Ql = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Ql.displayName = "IsDrawerContext");
function Ci(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, f = kn(!0), p = x.useContext(Ql), m = !!f, h = Cf.useStore(c?.store, {
    open: o,
    openProp: n,
    activeTriggerId: d,
    triggerIdProp: u,
    modal: l,
    disablePointerDismissal: s,
    nested: m
  });
  Or(() => {
    n === void 0 && h.state.open === !1 && o === !0 && h.update({
      open: !0,
      activeTriggerId: d
    });
  }), h.useControlledProp("openProp", n), h.useControlledProp("triggerIdProp", u), h.useSyncedValues({
    disablePointerDismissal: s,
    nested: m,
    modal: l
  }), h.useContextCallback("onOpenChange", r), h.useContextCallback("onOpenChangeComplete", i);
  const b = h.useState("payload");
  yC({
    store: h,
    actionsRef: a,
    parentContext: f?.store.context,
    isDrawer: p
  });
  const v = x.useMemo(() => ({
    store: h
  }), [h]);
  return /* @__PURE__ */ g(Ql.Provider, {
    value: !1,
    children: /* @__PURE__ */ g(hf.Provider, {
      value: v,
      children: typeof e == "function" ? e({
        payload: b
      }) : e
    })
  });
}
let om = (function(t) {
  return t[t.open = wn.open] = "open", t[t.closed = wn.closed] = "closed", t[t.startingStyle = wn.startingStyle] = "startingStyle", t[t.endingStyle = wn.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const wC = {
  ...An,
  ...Kt,
  nested(t) {
    return t ? {
      [om.nested]: ""
    } : null;
  },
  nestedDialogOpen(t) {
    return t ? {
      [om.nestedDialogOpen]: ""
    } : null;
  }
}, wi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    style: s,
    ...l
  } = e, a = vf(), {
    store: c
  } = kn(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), p = c.useState("nestedOpenDialogCount"), m = c.useState("mounted"), h = p > 0;
  return Le("div", e, {
    enabled: a || m,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: h
    },
    ref: [n, c.useStateSetter("viewportElement")],
    stateAttributesMapping: wC,
    props: [{
      role: "presentation",
      hidden: !m,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (wi.displayName = "DialogViewport");
const rs = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = kn(), c = Ot(s);
  return a.useSyncedValueWithCleanup("titleElementId", c), Le("h2", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (rs.displayName = "DialogTitle");
const y0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = kn(!0), p = c?.store ?? f?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : st(79));
  const m = Ot(l), h = p.useState("floatingRootContext"), b = p.useState("isOpenedByTrigger", m), v = x.useRef(null), {
    registerTrigger: C,
    isMountedByThisTrigger: y
  } = ms(m, v, p, {
    payload: a
  }), {
    getButtonProps: w,
    buttonRef: R
  } = qt({
    disabled: i,
    native: s
  }), S = Nr(h, {
    enabled: h != null
  }), E = ro([S]), N = {
    disabled: i,
    open: b
  }, I = p.useState("triggerProps", y);
  return Le("button", e, {
    state: N,
    ref: [R, n, C, v],
    props: [E.getReferenceProps(), I, {
      [ad]: "",
      id: m
    }, d, w],
    stateAttributesMapping: Sr
  });
});
process.env.NODE_ENV !== "production" && (y0.displayName = "DialogTrigger");
var rm, im;
function SC(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    swipeDirection: f = "down",
    snapToSequentialPoints: p = !1,
    snapPoints: m,
    snapPoint: h,
    defaultSnapPoint: b,
    onSnapPointChange: v
  } = t, C = we(v), y = Ta(!0), w = y?.onNestedSwipeProgressChange, R = y?.onNestedFrontmostHeightChange, S = y?.onNestedSwipingChange, E = y?.onNestedDrawerPresenceChange, [N, I] = x.useState(0), [M, T] = x.useState(0), [k, P] = x.useState(!1), [D, O] = x.useState(!1), [V] = x.useState(RC), _ = b !== void 0 ? b : m?.[0] ?? null, A = h !== void 0, [L, $] = Sn({
    controlled: h,
    default: _,
    name: "Drawer",
    state: "snapPoint"
  }), B = x.useRef(!1), z = we((J, ie) => {
    const ce = ie ?? De(At);
    C?.(J, ce), !ce.isCanceled && $(J);
  }), H = x.useMemo(() => A || !m || m.length === 0 ? L : L === null || !m.some((J) => Object.is(J, L)) ? _ : L, [L, A, _, m]), K = we((J) => {
    I(J), !B.current && J > 0 && T(J);
  }), G = we((J) => {
    if (J > 0) {
      B.current = !0, T(J);
      return;
    }
    B.current = !1, N > 0 && T(N);
  }), q = we((J) => {
    P(J);
  }), Q = we((J) => {
    V.set(J), w?.(J);
  }), U = we((J) => {
    O(J), S?.(J);
  }), X = we((J, ie) => {
    r?.(J, ie), !ie.isCanceled && !J && m && m.length > 0 && z(_, De(ie.reason, ie.event, ie.trigger));
  }), te = x.useMemo(() => ({
    swipeDirection: f,
    snapToSequentialPoints: p,
    snapPoints: m,
    activeSnapPoint: H,
    setActiveSnapPoint: z,
    frontmostHeight: M,
    popupHeight: N,
    hasNestedDrawer: k,
    nestedSwiping: D,
    nestedSwipeProgressStore: V,
    onNestedDrawerPresenceChange: q,
    onPopupHeightChange: K,
    onNestedFrontmostHeightChange: G,
    onNestedSwipingChange: U,
    onNestedSwipeProgressChange: Q,
    notifyParentFrontmostHeight: R,
    notifyParentSwipingChange: S,
    notifyParentSwipeProgressChange: w,
    notifyParentHasNestedDrawer: E
  }), [H, M, k, D, V, E, w, S, R, q, G, Q, U, K, N, z, m, p, f]), re = typeof e == "function" ? (J) => /* @__PURE__ */ F(x.Fragment, {
    children: [rm || (rm = /* @__PURE__ */ g(sm, {})), e(J)]
  }) : /* @__PURE__ */ F(x.Fragment, {
    children: [im || (im = /* @__PURE__ */ g(sm, {})), e]
  });
  return /* @__PURE__ */ g(yf.Provider, {
    value: te,
    children: /* @__PURE__ */ g(Ql.Provider, {
      value: !0,
      children: /* @__PURE__ */ g(Ci, {
        open: n,
        defaultOpen: o,
        onOpenChange: X,
        onOpenChangeComplete: i,
        disablePointerDismissal: s,
        modal: l,
        actionsRef: a,
        handle: c,
        triggerId: u,
        defaultTriggerId: d,
        children: re
      })
    })
  });
}
function RC() {
  let t = 0;
  const e = /* @__PURE__ */ new Set();
  return {
    getSnapshot: () => t,
    set(n) {
      const o = Number.isFinite(n) ? n : 0;
      o !== t && (t = o, e.forEach((r) => {
        r();
      }));
    },
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    }
  };
}
function sm() {
  const t = Lo(), e = h0(), n = kn(!1), o = n.store.useState("open"), r = n.store.useState("nestedOpenDialogCount"), i = n.store.useState("popupElement"), s = r === 0;
  return x.useEffect(() => {
    if (!(!e || t == null))
      return () => {
        e.removeDrawer(t);
      };
  }, [t, e]), x.useEffect(() => {
    t != null && e?.setDrawerOpen(t, o);
  }, [t, o, e]), x.useEffect(() => {
    if (!o || !s || !Zi)
      return;
    const a = St(i).CloseWatcher;
    if (!a)
      return;
    function c(f) {
      n.store.select("open") && n.store.setOpen(!1, De(m8, f));
    }
    const u = new a(), d = dt(u, "close", c);
    return () => {
      d(), u.destroy();
    };
  }, [n.store, s, o, i]), null;
}
function xu(t, e) {
  const n = En(t);
  if (e === "vertical") {
    const r = n.overflowY;
    return (r === "auto" || r === "scroll") && t.scrollHeight > t.clientHeight;
  }
  const o = n.overflowX;
  return (o === "auto" || o === "scroll") && t.scrollWidth > t.clientWidth;
}
function EC(t, e, n) {
  let o = t;
  for (; o && o !== e; ) {
    for (const r of n)
      if (xu(o, r))
        return !0;
    o = o.parentElement;
  }
  return !1;
}
function Wr(t, e, n = "vertical") {
  let o = wt(t) ? t : null;
  for (; o && o !== e; ) {
    if (xu(o, n))
      return o;
    o = o.parentElement;
  }
  return xu(e, n) ? e : null;
}
function Tl(t, e, n) {
  return typeof t?.elementFromPoint == "function" ? t.elementFromPoint(e, n) : null;
}
const NC = 40, kC = 10, IC = 1, PC = 50, lm = 16, MC = 80, TC = 'button,a,input,select,textarea,label,[role="button"]';
function vc(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function OC(t) {
  const n = St(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
function cl(t) {
  return Number.isFinite(t) && t > 0 ? t : null;
}
function DC(t) {
  return t % 2 === 1;
}
function yc(t, e, n) {
  const o = t[n];
  if (typeof o == "function")
    try {
      o.call(t, e);
    } catch (r) {
      if (r && typeof r == "object" && "name" in r && r.name === "NotFoundError")
        return;
      throw r;
    }
}
function _C(t) {
  const {
    enabled: e,
    directions: n,
    elementRef: o,
    movementCssVars: r,
    canStart: i,
    ignoreSelectorWhenTouch: s = !0,
    ignoreScrollableAncestors: l = !1,
    swipeThreshold: a,
    onDismiss: c,
    onProgress: u,
    onCancel: d,
    onSwipeStart: f,
    onRelease: p,
    onSwipingChange: m,
    trackDrag: h = !0
  } = t, b = TC, v = n.length === 1 ? n[0] : void 0, C = Math.max(0, typeof a == "number" ? a : NC), y = n.includes("left"), w = n.includes("right"), R = n.includes("up"), S = n.includes("down"), E = y || w, N = R || S, I = x.useMemo(() => {
    const Ce = [];
    return N && Ce.push("vertical"), E && Ce.push("horizontal"), Ce;
  }, [E, N]), [M, T] = x.useState(void 0), [k, P] = x.useState(!1), [D, O] = x.useState(!1), [V, _] = x.useState(!1), [A, L] = x.useState({
    x: 0,
    y: 0
  }), [$, B] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [z, H] = x.useState(null), K = x.useRef({
    x: 0,
    y: 0
  }), G = x.useRef({
    x: 0,
    y: 0
  }), q = x.useRef(null), Q = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), U = x.useRef(void 0), X = x.useRef(0), te = x.useRef(!1), re = x.useRef({
    x: 0,
    y: 0
  }), J = x.useRef(!1), ie = x.useRef(!1), ce = x.useRef(null), oe = x.useRef(!1), se = x.useRef(!1), me = x.useRef({
    width: 0,
    height: 0
  }), pe = x.useRef(0), le = x.useRef(C), ge = x.useRef(null), j = x.useRef(null), ee = x.useRef({
    x: 0,
    y: 0
  }), Y = x.useRef(null), Z = x.useRef(!1), ue = we((Ce) => {
    Z.current !== Ce && (Z.current = Ce, P(Ce), m?.(Ce));
  });
  function fe(Ce) {
    if (!Ce)
      return;
    if (typeof a != "function") {
      le.current = C;
      return;
    }
    const Ee = o.current;
    if (!Ee)
      return;
    const Ae = a({
      element: Ee,
      direction: Ce
    });
    le.current = Math.max(0, Ae);
  }
  const be = we((Ce, Ee) => {
    const Ae = Number.isFinite(Ce) ? Zt(Ce, 0, 1) : 0, ze = Ae !== pe.current;
    let it = !1;
    if (Ee) {
      const Ye = Y.current;
      it = !Ye || Ye.deltaX !== Ee.deltaX || Ye.deltaY !== Ee.deltaY || Ye.direction !== Ee.direction;
    }
    !ze && !it || (pe.current = Ae, Ee ? Y.current = Ee : ze && (Y.current = null), u?.(Ae, Ee));
  });
  function Ie(Ce, Ee) {
    if (Ee === null)
      return;
    const Ae = j.current;
    if (Ae && Ee > Ae.time) {
      const ze = Math.max(Ee - Ae.time, lm);
      ee.current = {
        x: (Ce.x - Ae.x) / ze,
        y: (Ce.y - Ae.y) / ze
      };
    }
    j.current = {
      x: Ce.x,
      y: Ce.y,
      time: Ee
    };
  }
  const ye = x.useCallback(() => {
    T(void 0), ue(!1), O(!1), _(!1), L({
      x: 0,
      y: 0
    }), B({
      x: 0,
      y: 0,
      scale: 1
    }), H(null), be(0), le.current = C, K.current = {
      x: 0,
      y: 0
    }, G.current = {
      x: 0,
      y: 0
    }, Q.current = {
      x: 0,
      y: 0,
      scale: 1
    }, U.current = void 0, X.current = 0, te.current = !1, re.current = {
      x: 0,
      y: 0
    }, J.current = !1, q.current = null, ie.current = !1, ce.current = null, oe.current = !1, se.current = !1, me.current = {
      width: 0,
      height: 0
    }, ge.current = null, j.current = null, ee.current = {
      x: 0,
      y: 0
    }, Y.current = null;
  }, [ue, C, be]);
  x.useEffect(() => {
    typeof a != "function" && (le.current = C);
  }, [C, a]);
  function xe(Ce) {
    if ("touches" in Ce) {
      const Ee = Ce.touches[0];
      return Ee ? {
        x: Ee.clientX,
        y: Ee.clientY
      } : null;
    }
    return {
      x: Ce.clientX,
      y: Ce.clientY
    };
  }
  function de(Ce) {
    return "touches" in Ce ? !0 : Ce.pointerType === "touch";
  }
  function Se(Ce, Ee) {
    const Ae = nt(o.current);
    return Tl(Ae, Ce.x, Ce.y) ?? yt(Ee);
  }
  function Me(Ce, Ee) {
    return E && !N ? Wr(Ce, Ee, "horizontal") : N && !E ? Wr(Ce, Ee, "vertical") : Wr(Ce, Ee, "vertical") ?? Wr(Ce, Ee, "horizontal");
  }
  function Re(Ce, Ee, Ae) {
    oe.current = !1;
    const ze = de(Ce), it = Se(Ee, Ce.nativeEvent), Qe = nt(o.current).body, Ge = ze && Qe ? Me(it, Qe) : null, Ke = Ae?.ignoreScrollableTarget ?? !1;
    if (Ge && !Ke || (oe.current = !!(Ge && Ke), (it ? it.closest(b) : !1) && (!ze || s)))
      return !1;
    const lt = o.current;
    if (l && lt && it && I.length > 0 && !(Ae?.ignoreScrollableAncestors ?? !1) && EC(it, lt, I))
      return !1;
    if (te.current = !1, U.current = void 0, X.current = 0, K.current = Ee, ge.current = cl(Ce.timeStamp), re.current = Ee, q.current = Ee, lt) {
      me.current = {
        width: lt.offsetWidth,
        height: lt.offsetHeight
      }, fe(v);
      const pt = OC(lt);
      Q.current = pt, G.current = {
        x: pt.x,
        y: pt.y
      }, B(pt), L({
        x: pt.x,
        y: pt.y
      }), Ie({
        x: pt.x,
        y: pt.y
      }, ge.current), "touches" in Ce || yc(lt, Ce.pointerId, "setPointerCapture");
    }
    return f?.(Ce.nativeEvent), ue(!0), O(!1), H(null), J.current = !0, be(0), !0;
  }
  function Ve() {
    Ze(), oe.current = !1, q.current = null;
  }
  function Ze() {
    ie.current = !1, ce.current = null;
  }
  function Xe(Ce) {
    if (Ve(), !Z.current)
      return;
    ue(!1), O(!1), H(null);
    const Ee = h ? $ : Q.current;
    G.current = {
      x: Ee.x,
      y: Ee.y
    }, L({
      x: Ee.x,
      y: Ee.y
    }), T(void 0), se.current = !1;
    const Ae = o.current;
    Ae && yc(Ae, Ce.pointerId, "releasePointerCapture"), be(0, {
      deltaX: 0,
      deltaY: 0,
      direction: void 0
    }), d?.(Ce.nativeEvent);
  }
  function Be(Ce, Ee) {
    const Ae = (Qe) => Qe >= 0 ? Qe ** 0.5 : -(Math.abs(Qe) ** 0.5), ze = (Qe, Ge, Ke) => !Ge && Qe < 0 || !Ke && Qe > 0 ? Ae(Qe) : Qe, it = E ? ze(Ce, y, w) : Ae(Ce), Ye = N ? ze(Ee, R, S) : Ae(Ee);
    return {
      x: it,
      y: Ye
    };
  }
  function Ne(Ce, Ee, Ae) {
    const ze = Math.abs(Ee), it = Math.abs(Ae);
    if (N && Ae !== 0 && (!E || it >= ze)) {
      const Ge = Math.max(0, Ce.scrollHeight - Ce.clientHeight), Ke = Ce.scrollTop <= 0, Je = Ce.scrollTop >= Ge, lt = Ae > 0, pt = Ae < 0;
      return lt && Ke && S || pt && Je && R;
    }
    if (E && Ee !== 0 && (!N || ze > it)) {
      const Ge = Math.max(0, Ce.scrollWidth - Ce.clientWidth), Ke = Ce.scrollLeft <= 0, Je = Ce.scrollLeft >= Ge, lt = Ee > 0, pt = Ee < 0;
      return lt && Ke && w || pt && Je && y;
    }
    return null;
  }
  const _e = we((Ce) => {
    if (!e || Ce.defaultPrevented || Ce.nativeEvent.defaultPrevented || !("touches" in Ce) && Ce.button !== 0)
      return;
    const Ee = xe(Ce);
    !Ee || (ie.current = !0, ce.current = Ee, oe.current = !1, se.current = !1, !(i ? i(Ee, {
      nativeEvent: Ce.nativeEvent,
      direction: v
    }) : !0)) || Re(Ce, Ee) && Ze();
  });
  function Pe(Ce, Ee, Ae) {
    if (!e || !Z.current)
      return;
    const ze = yt(Ce.nativeEvent);
    if (de(Ce) && !oe.current) {
      const Vt = Ce.currentTarget;
      if (Me(ze, Vt))
        return;
    }
    if ("touches" in Ce || Ce.preventDefault(), J.current) {
      K.current = Ee;
      const Vt = cl(Ce.timeStamp);
      Vt !== null && (ge.current = Vt), J.current = !1;
    }
    const it = Ee.x, Ye = Ee.y, Qe = Ae.x, Ge = Ae.y;
    (Ge < 0 && Ye > re.current.y || Ge > 0 && Ye < re.current.y) && (re.current = {
      x: re.current.x,
      y: Ye
    }), (Qe < 0 && it > re.current.x || Qe > 0 && it < re.current.x) && (re.current = {
      x: it,
      y: re.current.y
    });
    const Ke = it - K.current.x, Je = Ye - K.current.y, lt = Ye - re.current.y, pt = it - re.current.x;
    if (!D && Math.sqrt(Ke * Ke + Je * Je) >= IC && (O(!0), z === null && E && N)) {
      const gn = Math.abs(Ke), gt = Math.abs(Je);
      H(gn > gt ? "horizontal" : "vertical");
    }
    let ht;
    if (!U.current)
      z === "vertical" ? Je > 0 ? ht = "down" : Je < 0 && (ht = "up") : z === "horizontal" ? Ke > 0 ? ht = "right" : Ke < 0 && (ht = "left") : Math.abs(Ke) >= Math.abs(Je) ? ht = Ke > 0 ? "right" : "left" : ht = Je > 0 ? "down" : "up", ht && (ht === "left" && y || ht === "right" && w || ht === "up" && R || ht === "down" && S) && (U.current = ht, X.current = vc(ht, Ke, Je), T(ht), fe(ht));
    else {
      const Vt = U.current, gn = vc(Vt, pt, lt);
      gn > le.current ? (te.current = !1, T(Vt)) : !(y && w) && !(R && S) && X.current - gn >= kC && (te.current = !0);
    }
    const It = Be(Ke, Je);
    let ot = Q.current.x, Pt = Q.current.y;
    z === "horizontal" ? E && (ot += It.x) : (z === "vertical" || E && (ot += It.x), N && (Pt += It.y)), G.current = {
      x: ot,
      y: Pt
    }, h && L({
      x: ot,
      y: Pt
    }), Ie({
      x: ot,
      y: Pt
    }, cl(Ce.timeStamp));
    const un = ot - Q.current.x, jt = Pt - Q.current.y, rn = U.current, tn = v ?? U.current;
    if (!tn) {
      be(0, {
        deltaX: un,
        deltaY: jt,
        direction: rn
      });
      return;
    }
    const nn = tn === "left" || tn === "right" ? me.current.width : me.current.height, Ht = Q.current.scale || 1;
    if (nn <= 0 || Ht <= 0) {
      be(0, {
        deltaX: un,
        deltaY: jt,
        direction: rn
      });
      return;
    }
    const dn = vc(tn, ot - Q.current.x, Pt - Q.current.y);
    if (dn <= 0) {
      be(0, {
        deltaX: un,
        deltaY: jt,
        direction: rn
      });
      return;
    }
    be(dn / (nn * Ht), {
      deltaX: un,
      deltaY: jt,
      direction: rn
    });
  }
  const $e = we((Ce) => {
    const Ee = xe(Ce);
    if (!Ee)
      return;
    if (!("touches" in Ce)) {
      const it = DC(Ce.buttons);
      it && (se.current = !0);
      const Ye = Ce.buttons === 0 && se.current;
      if (Ce.buttons !== 0 && !it || Ye) {
        Xe(Ce);
        return;
      }
    }
    if (!k && ie.current) {
      if (!de(Ce) && (Ce.defaultPrevented || Ce.nativeEvent.defaultPrevented)) {
        Ve();
        return;
      }
      if (i ? i(Ee, {
        nativeEvent: Ce.nativeEvent,
        direction: v
      }) : !0) {
        const Ye = ce.current;
        let Qe = !1;
        if (de(Ce)) {
          const Ke = o.current;
          if (Ye && Ke) {
            const Je = Se(Ee, Ce.nativeEvent), pt = nt(Ke).body, ht = pt ? Me(Je, pt) : null;
            if (ht && (Fe(Ke, ht) || Fe(ht, Ke))) {
              const It = Ee.x - Ye.x, ot = Ee.y - Ye.y, Pt = Ne(ht, It, ot);
              if (Pt === !1)
                return;
              Pt === !0 && (Qe = !0);
            }
          }
        }
        Re(Ce, Ee, {
          ignoreScrollableTarget: Qe,
          ignoreScrollableAncestors: Qe
        }) && (Ye && Qe ? (Ze(), K.current = Ye, re.current = Ye, q.current = Ye, J.current = !1) : (Ze(), oe.current = !1));
      }
    }
    const Ae = q.current, ze = Ae === null ? {
      x: 0,
      y: 0
    } : {
      x: Ee.x - Ae.x,
      y: Ee.y - Ae.y
    };
    q.current = Ee, Pe(Ce, Ee, ze);
  }), He = we((Ce) => {
    if (!e)
      return;
    const Ee = G.current, Ae = Q.current, ze = Ee.x - Ae.x, it = Ee.y - Ae.y, Ye = {
      deltaX: ze,
      deltaY: it,
      direction: M ?? U.current
    };
    if (!Z.current) {
      Ve(), be(0, Ye);
      return;
    }
    ue(!1), O(!1), H(null), Ve(), se.current = !1;
    const Qe = o.current;
    Qe && ("touches" in Ce || yc(Qe, Ce.pointerId, "releasePointerCapture"));
    const Ge = ze, Ke = it, Je = ge.current, lt = cl(Ce.timeStamp), pt = Je !== null && lt !== null && lt > Je ? lt - Je : 0, ht = pt > 0 ? Math.max(pt, PC) : 0, It = ht > 0 ? Ge / ht : 0, ot = ht > 0 ? Ke / ht : 0;
    let Pt = ee.current.x, un = ee.current.y;
    const jt = j.current;
    if (jt && lt !== null && lt >= jt.time) {
      const dn = lt - jt.time;
      if (dn <= MC) {
        const Vt = Math.max(dn, lm), gn = Ee.x - jt.x, gt = Ee.y - jt.y, vt = gn / Vt, Ft = gt / Vt;
        vt !== 0 && (Pt = vt), Ft !== 0 && (un = Ft);
      } else
        Pt = 0, un = 0;
    }
    const rn = p?.({
      event: Ce.nativeEvent,
      direction: M ?? U.current,
      deltaX: Ge,
      deltaY: Ke,
      velocityX: It,
      velocityY: ot,
      releaseVelocityX: Pt,
      releaseVelocityY: un
    }), tn = typeof rn == "boolean";
    if (te.current && !tn) {
      G.current = {
        x: Ae.x,
        y: Ae.y
      }, L({
        x: Ae.x,
        y: Ae.y
      }), T(void 0), be(0, Ye);
      return;
    }
    let nn = !1, Ht;
    if (tn)
      nn = rn, Ht = M ?? U.current ?? v;
    else
      for (const dn of n) {
        switch (dn) {
          case "right":
            Ge > le.current && (nn = !0, Ht = "right");
            break;
          case "left":
            Ge < -le.current && (nn = !0, Ht = "left");
            break;
          case "down":
            Ke > le.current && (nn = !0, Ht = "down");
            break;
          case "up":
            Ke < -le.current && (nn = !0, Ht = "up");
            break;
        }
        if (nn)
          break;
      }
    nn && Ht ? (T(Ht), _(!0), c?.(Ce.nativeEvent, {
      direction: Ht
    })) : (G.current = {
      x: Ae.x,
      y: Ae.y
    }, L({
      x: Ae.x,
      y: Ae.y
    }), T(void 0), be(0, Ye));
  }), Te = x.useCallback(() => {
    const Ce = h ? A : G.current, Ee = h ? $ : Q.current;
    if (!k && Ce.x === Ee.x && Ce.y === Ee.y && !V)
      return {
        [r.x]: "0px",
        [r.y]: "0px"
      };
    const Ae = Ce.x - Ee.x, ze = Ce.y - Ee.y;
    return {
      transition: k ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: k ? `translateX(${Ce.x}px) translateY(${Ce.y}px) scale(${Ee.scale})` : void 0,
      [r.x]: `${Ae}px`,
      [r.y]: `${ze}px`
    };
  }, [V, A, $, k, r, h]), Rt = x.useCallback(() => e ? {
    onPointerDown: _e,
    onPointerMove: $e,
    onPointerUp: He,
    onPointerCancel: He
  } : {}, [e, He, $e, _e]), rt = x.useCallback(() => e ? {
    onTouchStart: _e,
    onTouchMove: $e,
    onTouchEnd: He,
    onTouchCancel: He
  } : {}, [e, He, $e, _e]);
  return {
    swiping: k,
    swipeDirection: M,
    dragDismissed: V,
    getPointerProps: Rt,
    getTouchProps: rt,
    getDragStyles: Te,
    reset: ye
  };
}
const VC = rs, AC = y0, Cu = 10, am = 0.5, cm = 0.5, LC = 300, um = 4, dm = 0.2, FC = 4, xc = 80, fm = 360, Cc = 0.1, pm = 1, $C = `[${p0}]`, x0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    children: s,
    ...l
  } = e, {
    store: a
  } = kn(), {
    swipeDirection: c,
    notifyParentSwipingChange: u,
    notifyParentSwipeProgressChange: d,
    frontmostHeight: f,
    snapToSequentialPoints: p
  } = Ta(), h = h0()?.visualStateStore, b = a.useState("open"), v = a.useState("mounted"), C = a.useState("nested"), y = a.useState("nestedOpenDrawerCount"), w = a.useState("viewportElement"), R = a.useState("popupElement"), S = y > 0, E = c === "left" || c === "right" ? "horizontal" : "vertical", N = E === "vertical", I = N ? "horizontal" : "vertical", {
    snapPoints: M,
    resolvedSnapPoints: T,
    activeSnapPoint: k,
    activeSnapPointOffset: P,
    setActiveSnapPoint: D,
    popupHeight: O
  } = b0(), [V, _] = x.useState(null), A = x.useRef(void 0), L = x.useRef(null), $ = ri(), B = x.useRef(!1), z = x.useRef(""), H = x.useRef(!1), K = x.useRef(!1), G = x.useRef(null), q = x.useMemo(() => {
    if (!M || M.length < 2 || c !== "down" && c !== "up" || T.length < 2)
      return null;
    const j = T.map((fe) => fe.offset).filter((fe) => Number.isFinite(fe)).sort((fe, be) => fe - be);
    if (j.length < 2)
      return null;
    const ee = j[0], Y = j[1], Z = j[j.length - 1];
    let ue = Y - ee;
    if (!Number.isFinite(ue) || ue <= 0) {
      const fe = Z - ee;
      if (!Number.isFinite(fe) || fe <= 0)
        return null;
      ue = fe;
    }
    return {
      minOffset: ee,
      range: ue
    };
  }, [T, M, c]), Q = x.useMemo(() => !q || P === null ? null : Zt((P - q.minOffset) / q.range, 0, 1), [P, q]), U = x.useMemo(() => M && M.length > 0 && (c === "down" || c === "up") ? c === "down" ? ["down", "up"] : ["up", "down"] : [c], [M, c]), X = we((j) => {
    mm(a.context.popupRef.current, a.context.backdropRef.current, j);
  }), te = we(() => {
    X(!1), a.context.popupRef.current?.removeAttribute(Jn.endingStyle), _(null);
  }), re = we(() => {
    B.current && (B.current = !1, u?.(!1));
  }), J = we(({
    resolvedProgress: j,
    shouldTrackProgress: ee,
    notifyParent: Y
  }) => {
    const Z = b && !C && ee, ue = Z ? j : 0, fe = b && ee ? j : 0;
    Y && d && (d(fe), fe <= 0 && re()), h?.set({
      swipeProgress: ue,
      frontmostHeight: ue > 0 ? f : 0
    });
    const be = a.context.backdropRef.current;
    if (be) {
      if (!Z || ue <= 0) {
        be.style.setProperty(Io.swipeProgress, "0"), be.style.removeProperty(ln.height);
        return;
      }
      be.style.setProperty(Io.swipeProgress, `${ue}`), f > 0 ? be.style.setProperty(ln.height, `${f}px`) : be.style.removeProperty(ln.height);
    }
  });
  function ie({
    direction: j,
    deltaX: ee,
    deltaY: Y,
    velocityX: Z,
    velocityY: ue,
    releaseVelocityX: fe,
    releaseVelocityY: be
  }) {
    if (!j)
      return null;
    const Ie = a.context.popupRef.current;
    if (!Ie)
      return null;
    const ye = j === "left" || j === "right" ? Ie.offsetWidth : Ie.offsetHeight;
    if (!Number.isFinite(ye) || ye <= 0)
      return null;
    const xe = j === "left" || j === "right" ? ee : Y, de = M && M.length > 0 ? P ?? 0 : 0;
    let Se = 0;
    j === "down" ? Se = de : j === "up" && (Se = -de);
    const Me = Se + xe, Re = j === "left" || j === "up" ? -Me : Me, Ve = Math.max(0, ye - Re);
    if (!Number.isFinite(Ve) || Ve <= 0)
      return null;
    const Ze = j === "left" || j === "right" ? fe : be, Xe = j === "left" || j === "right" ? Z : ue, Be = Math.abs(Ze) > 0 && Number.isFinite(Ze) ? Ze : Xe, Ne = j === "left" || j === "up" ? -Be : Be;
    if (!Number.isFinite(Ne) || Ne <= dm)
      return null;
    const _e = Zt(Ne, dm, FC), Pe = Zt(Ve / _e, xc, fm);
    if (!Number.isFinite(Pe))
      return null;
    const $e = (Pe - xc) / (fm - xc), He = Zt(Cc + $e * (pm - Cc), Cc, pm);
    return !Number.isFinite(He) || He <= 0 ? null : He;
  }
  function ce(j) {
    if (B.current || !j)
      return;
    const ee = j.direction ?? c, Y = ee === "left" || ee === "right" ? j.deltaX : j.deltaY;
    !Number.isFinite(Y) || Math.abs(Y) < Cu || (B.current = !0, u?.(!0));
  }
  const oe = _C({
    enabled: v && !S,
    directions: U,
    elementRef: a.context.popupRef,
    ignoreSelectorWhenTouch: !1,
    ignoreScrollableAncestors: !0,
    movementCssVars: {
      x: ln.swipeMovementX,
      y: ln.swipeMovementY
    },
    onSwipeStart(j) {
      if ("touches" in j || "pointerType" in j && j.pointerType === "touch")
        return;
      const ee = a.context.popupRef.current;
      if (!ee)
        return;
      const Z = nt(ee).getSelection?.();
      if (!Z || Z.isCollapsed)
        return;
      const ue = mt(Z.anchorNode) ? Z.anchorNode : Z.anchorNode?.parentElement, fe = mt(Z.focusNode) ? Z.focusNode : Z.focusNode?.parentElement;
      !Fe(ee, ue) && !Fe(ee, fe) || Z.removeAllRanges();
    },
    onSwipingChange(j) {
      gm(a.context.backdropRef.current, j), !j && !d && re();
    },
    swipeThreshold({
      element: j,
      direction: ee
    }) {
      return hm(j, ee);
    },
    canStart(j, ee) {
      const Y = a.context.popupRef.current;
      if (!Y)
        return !1;
      const Z = Y.ownerDocument, ue = Tl(Z, j.x, j.y);
      if (!ue || !Fe(Y, ue))
        return !1;
      const fe = ee.nativeEvent;
      return !(("touches" in fe || "pointerType" in fe && fe.pointerType === "touch") && vm(Z, Y) || fe.type === "touchstart" && wc(ue));
    },
    onProgress(j, ee) {
      ce(ee);
      const Y = ee?.direction ?? oe.swipeDirection, Z = Y === void 0 || Y === c, ue = !!(M && M.length > 0), be = ue && (c === "down" || c === "up") || !ue || c === "left" || c === "right" || Z;
      let Ie = j;
      if (q && O > 0) {
        if (ee && Number.isFinite(ee.deltaY)) {
          const ye = P ?? q.minOffset, xe = Zt(ye + ee.deltaY, 0, O);
          Ie = Zt((xe - q.minOffset) / q.range, 0, 1);
        } else if (Q !== null)
          Ie = Q;
        else if (Y === "down" || Y === "up") {
          const ye = j * O, xe = P ?? q.minOffset, de = Y === "down" ? xe + ye : xe - ye;
          Ie = Zt((de - q.minOffset) / q.range, 0, 1);
        }
      }
      J({
        resolvedProgress: Ie,
        shouldTrackProgress: be,
        notifyParent: !0
      });
    },
    onRelease({
      event: j,
      deltaX: ee,
      deltaY: Y,
      direction: Z,
      velocityX: ue,
      velocityY: fe,
      releaseVelocityX: be,
      releaseVelocityY: Ie
    }) {
      const ye = {
        deltaX: ee,
        deltaY: Y,
        velocityX: ue,
        velocityY: fe,
        releaseVelocityX: be,
        releaseVelocityY: Ie
      };
      function xe(rt) {
        const Ce = a.context.popupRef.current;
        Ce && (re(), X(!0), Ce.style.removeProperty("transition"), Ce.setAttribute(Jn.endingStyle, ""), yn.flushSync(() => {
          _(ie({
            direction: rt,
            ...ye
          }));
        }));
      }
      if (!M || M.length === 0) {
        if (!Z) {
          te();
          return;
        }
        const rt = a.context.popupRef.current;
        if (!rt) {
          te();
          return;
        }
        const Ce = hm(rt, Z), Ee = Z === "left" || Z === "right" ? ee : Y;
        if (!Number.isFinite(Ee)) {
          te();
          return;
        }
        const Ae = Z === "left" || Z === "up" ? -Ee : Ee;
        if (Ae <= 0)
          return te(), !1;
        const ze = Z === "left" || Z === "right" ? ue : fe;
        if ((Z === "left" || Z === "up" ? -ze : ze) >= am && Ae > 0)
          return xe(Z), !0;
        const Ye = Ae > Ce;
        return Ye ? xe(Z) : te(), Ye;
      }
      if (c !== "down" && c !== "up") {
        te();
        return;
      }
      if (!O || T.length === 0) {
        te();
        return;
      }
      const de = c === "down" ? Y : -Y;
      if (!Number.isFinite(de)) {
        te();
        return;
      }
      const Se = Math.sign(de), Me = c === "down" ? Ie : -Ie, Re = c === "down" ? fe : -fe;
      let Ve = Number.isFinite(Me) ? Me : Re;
      if (Se !== 0 && Math.abs(de) >= Cu && Number.isFinite(Ve)) {
        const rt = Math.sign(Ve);
        rt !== 0 && rt !== Se && (Ve = Re);
      }
      const Ze = P ?? 0, Xe = Zt(Ze + de, 0, O), Be = Number.isFinite(Ve) && Math.abs(Ve) >= cm ? Zt(Ve, -um, um) * LC : 0, Ne = p ? Xe : Zt(Xe + Be, 0, O), _e = De(qs, j), Pe = () => (A.current = k, D?.(null, _e), xe(c), !0);
      if (p) {
        const rt = [...T].sort((Je, lt) => Je.offset - lt.offset);
        if (rt.length === 0)
          return te(), !1;
        let Ce = 0, Ee = Math.abs(Ze - rt[0].offset);
        for (let Je = 1; Je < rt.length; Je += 1) {
          const lt = Math.abs(Ze - rt[Je].offset);
          lt < Ee && (Ee = lt, Ce = Je);
        }
        let Ae = rt[0];
        Ee = Math.abs(Ne - Ae.offset);
        for (const Je of rt) {
          const lt = Math.abs(Ne - Je.offset);
          lt < Ee && (Ee = lt, Ae = Je);
        }
        const ze = Math.sign(Ve), it = Se !== 0 && ze !== 0 && ze === Se && Math.abs(Ve) >= cm;
        let Ye = Ne;
        if (it) {
          const Je = Zt(Ce + Se, 0, rt.length - 1);
          if (Je !== Ce) {
            const lt = rt[Je];
            (Se > 0 ? Ne < lt.offset : Ne > lt.offset) && (Ae = lt, Ye = lt.offset);
          } else if (Se > 0)
            return Pe();
        }
        const Ge = Math.abs(Ye - O), Ke = Math.abs(Ye - Ae.offset);
        return Ge < Ke ? Pe() : (D?.(Ae.value, _e), te(), !1);
      }
      if (Ve >= am && de > 0)
        return Pe();
      let $e = T[0], He = Math.abs(Ne - $e.offset);
      for (const rt of T) {
        const Ce = Math.abs(Ne - rt.offset);
        Ce < He && (He = Ce, $e = rt);
      }
      return Math.abs(Ne - O) < He ? Pe() : (D?.($e.value, _e), te(), !1);
    },
    onDismiss(j) {
      h?.set({
        swipeProgress: 0,
        frontmostHeight: 0
      });
      const ee = a.context.backdropRef.current;
      ee && (ee.style.setProperty(Io.swipeProgress, "0"), ee.style.removeProperty(ln.height));
      const Y = De(qs, j);
      if (a.setOpen(!1, Y), Y.isCanceled) {
        const Z = A.current;
        Z !== void 0 && D?.(Z, De(qs, j)), A.current = void 0, L.current?.(), te();
        return;
      }
      if (a.select("open")) {
        const Z = j;
        $.request(() => {
          if (a.select("open")) {
            const ue = A.current;
            ue !== void 0 && D?.(ue, De(qs, Z)), A.current = void 0, te(), L.current?.();
          } else
            A.current = void 0;
        });
        return;
      }
      A.current = void 0, X(!0);
    }
  }), se = oe.getPointerProps(), me = oe.getTouchProps(), pe = oe.reset;
  L.current = pe, x.useEffect(() => {
    const j = w ?? R;
    if (!j)
      return;
    const ee = j, Y = nt(ee), Z = St(Y);
    function ue(fe) {
      if (K.current)
        return;
      const be = G.current, Ie = fe.touches[0];
      if (!Ie || !be)
        return;
      const ye = N ? Ie.clientY - be.lastY : Ie.clientX - be.lastX;
      if (C0(fe, Z)) {
        be.allowSwipe = !1, ar(be, Ie);
        return;
      }
      if (fe.touches.length === 2) {
        ar(be, Ie);
        return;
      }
      if (vm(Y, ee) || !b || !v || S) {
        ar(be, Ie);
        return;
      }
      if (WC(be, Ie, N)) {
        ar(be, Ie);
        return;
      }
      const de = be.scrollTarget;
      if (!de || de === Y.documentElement || de === Y.body) {
        fe.cancelable && fe.preventDefault(), ar(be, Ie);
        return;
      }
      if (!UC(de, E)) {
        fe.cancelable && fe.preventDefault(), ar(be, Ie);
        return;
      }
      const Me = ye;
      if (Me !== 0) {
        const Re = YC(de, E, c, Me);
        be.allowSwipe ? fe.cancelable && fe.preventDefault() : fe.cancelable && Re ? (be.allowSwipe = !0, fe.preventDefault()) : be.allowSwipe = !1;
      }
      ar(be, Ie);
    }
    return dt(Y, "touchmove", ue, {
      passive: !1,
      capture: !0
    });
  }, [v, S, b, R, N, E, c, w]), x.useEffect(() => {
    if (!q || oe.swiping)
      return;
    J({
      resolvedProgress: !b || C ? 0 : Q ?? 0,
      shouldTrackProgress: !0,
      notifyParent: !1
    });
  }, [J, f, C, d, b, Q, q, oe.swiping, a, h]), x.useEffect(() => {
    if (d)
      return b || d(0), () => {
        d(0);
      };
  }, [d, b]), x.useEffect(() => {
    b && (pe(), te());
  }, [te, b, pe]), x.useEffect(() => () => {
    h?.set({
      swipeProgress: 0,
      frontmostHeight: 0
    }), gm(a.context.backdropRef.current, !1), re();
  }, [re, a, h]);
  const le = x.useMemo(() => ({
    swiping: oe.swiping,
    getDragStyles: oe.getDragStyles,
    swipeStrength: V ?? null,
    setSwipeDismissed(j) {
      mm(a.context.popupRef.current, a.context.backdropRef.current, j);
    }
  }), [a, oe.getDragStyles, oe.swiping, V]);
  function ge() {
    K.current = !1, G.current = null, z.current = "", H.current = !1;
  }
  return /* @__PURE__ */ g(wi, {
    ref: n,
    className: o,
    render: r,
    ...cn(l, {
      onPointerDown(j) {
        if (z.current = j.pointerType, H.current = j.pointerType === "pen", !b || !v || S)
          return;
        const ee = nt(j.currentTarget), Y = Tl(ee, j.clientX, j.clientY);
        wc(Y) || HC(Y) || j.pointerType !== "touch" && se.onPointerDown?.(j);
      },
      onPointerMove(j) {
        j.pointerType !== "touch" && se.onPointerMove?.(j);
      },
      onPointerUp(j) {
        z.current === j.pointerType && (z.current = ""), j.pointerType !== "touch" && se.onPointerUp?.(j);
      },
      onPointerCancel(j) {
        z.current === j.pointerType && (z.current = ""), j.pointerType !== "touch" && se.onPointerCancel?.(j);
      },
      onTouchStart(j) {
        if (z.current === "pen" && H.current) {
          H.current = !1, K.current = !1, G.current = null;
          return;
        }
        if (!b || !v || S) {
          K.current = !1, G.current = null;
          return;
        }
        const Y = j.touches[0];
        if (!Y)
          return;
        if (ym(j)) {
          K.current = !1, G.current = null;
          return;
        }
        const Z = nt(j.currentTarget), ue = Tl(Z, Y.clientX, Y.clientY);
        if (K.current = wc(ue), K.current) {
          G.current = null;
          return;
        }
        const fe = w ?? R, be = yt(j.nativeEvent), Ie = mt(be) ? be : null;
        if (fe && Ie && !Fe(fe, Ie)) {
          K.current = !0, G.current = null;
          return;
        }
        let ye = null, xe = !1;
        fe && Ie && (ye = Wr(Ie, fe, E), xe = Wr(Ie, fe, I) != null);
        let de = null;
        ye && (de = GC(ye, E, c) ? null : !1), G.current = {
          startX: Y.clientX,
          startY: Y.clientY,
          lastX: Y.clientX,
          lastY: Y.clientY,
          scrollTarget: ye,
          hasCrossAxisScrollableContent: xe,
          allowSwipe: de,
          preserveNativeCrossAxisScroll: !1
        }, me.onTouchStart?.(j);
      },
      onTouchMove(j) {
        if (K.current || ym(j))
          return;
        const ee = G.current;
        ee?.preserveNativeCrossAxisScroll || ee?.allowSwipe === !1 || ee?.scrollTarget != null && !ee.allowSwipe || me.onTouchMove?.(j);
      },
      onTouchEnd(j) {
        ge(), me.onTouchEnd?.(j);
      },
      onTouchCancel(j) {
        ge(), me.onTouchCancel?.(j);
      },
      // Drawer popups use drawer-specific nested state attributes.
      // Suppress DialogViewport's generic nested dialog attribute.
      "data-nested-dialog-open": void 0
    }),
    children: /* @__PURE__ */ g(xf.Provider, {
      value: le,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (x0.displayName = "DrawerViewport");
function mm(t, e, n) {
  if (n) {
    t?.setAttribute(Kn.swipeDismiss, ""), e?.setAttribute(Kn.swipeDismiss, "");
    return;
  }
  t?.removeAttribute(Kn.swipeDismiss), e?.removeAttribute(Kn.swipeDismiss);
}
function gm(t, e) {
  if (t) {
    if (e) {
      t.setAttribute(Kn.swiping, "");
      return;
    }
    t.removeAttribute(Kn.swiping);
  }
}
function wc(t) {
  return !!t?.closest($h);
}
function HC(t) {
  return !!t?.closest($C);
}
function hm(t, e) {
  const n = e === "left" || e === "right" ? t.offsetWidth : t.offsetHeight;
  return Math.max(n * 0.5, Cu);
}
function bm(t, e) {
  return t instanceof e.HTMLInputElement && t.type === "range";
}
function zC(t) {
  return mt(t) ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" : !1;
}
function BC(t, e) {
  const n = mt(t.anchorNode) ? t.anchorNode : t.anchorNode?.parentElement, o = mt(t.focusNode) ? t.focusNode : t.focusNode?.parentElement;
  return t.containsNode(e, !0) || Fe(e, n) || Fe(e, o);
}
function vm(t, e) {
  const n = Xt(t);
  if (!!(n && Fe(e, n)) && zC(n)) {
    const {
      selectionStart: i,
      selectionEnd: s
    } = n;
    if (i != null && s != null && i < s)
      return !0;
  }
  const r = t.getSelection?.();
  return !r || r.isCollapsed ? !1 : BC(r, e);
}
function C0(t, e) {
  const n = t.composedPath();
  return n ? n.some((o) => bm(o, e)) : bm(yt(t), e);
}
function ym(t) {
  return C0(t.nativeEvent, St(t.currentTarget));
}
function ar(t, e) {
  t.lastX = e.clientX, t.lastY = e.clientY;
}
function WC(t, e, n) {
  if (t.preserveNativeCrossAxisScroll)
    return !0;
  if (t.allowSwipe === !0 || !t.hasCrossAxisScrollableContent)
    return !1;
  const o = n ? e.clientY - t.startY : e.clientX - t.startX, r = n ? e.clientX - t.startX : e.clientY - t.startY, i = Math.abs(o), s = Math.abs(r);
  return s < 6 || s <= i + 2 ? !1 : (t.preserveNativeCrossAxisScroll = !0, !0);
}
function UC(t, e) {
  return e === "vertical" ? t.scrollHeight > t.clientHeight : t.scrollWidth > t.clientWidth;
}
function w0(t, e) {
  if (e === "vertical") {
    const o = Math.max(0, t.scrollHeight - t.clientHeight);
    return {
      offset: t.scrollTop,
      max: o
    };
  }
  const n = Math.max(0, t.scrollWidth - t.clientWidth);
  return {
    offset: t.scrollLeft,
    max: n
  };
}
function GC(t, e, n) {
  const {
    offset: o,
    max: r
  } = w0(t, e), i = S0(n, e);
  return i === null ? !1 : i ? o <= 0 : o >= r;
}
function YC(t, e, n, o) {
  const {
    offset: r,
    max: i
  } = w0(t, e), s = S0(n, e);
  return s === null || !(s ? o > 0 : o < 0) ? !1 : s ? r <= 0 : r >= i;
}
function S0(t, e) {
  return e === "vertical" ? t === "down" ? !0 : t === "up" ? !1 : null : t === "right" ? !0 : t === "left" ? !1 : null;
}
const R0 = yo({
  responsive: !0,
  side: "right",
  isBottomSheet: !1
}), jC = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "transition-opacity", "duration-200", "data-ending-style:opacity-0", "data-starting-style:opacity-0"]), KC = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "flex", "pointer-events-none"], {
  variants: {
    side: {
      left: "justify-start",
      right: "justify-end"
    },
    isBottomSheet: {
      false: null,
      true: "items-end justify-center"
    },
    responsive: {
      false: null,
      true: "max-md:items-end max-md:justify-center"
    }
  }
}), qC = ae(["pointer-events-auto", "flex", "h-dvh", "max-h-dvh", "min-w-0", "flex-col", "overflow-hidden", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-4", "outline-none", "transition-transform", "duration-200", "ease-out"], {
  variants: {
    size: {
      default: ["[--drawer-size:640px]", "w-[min(100vw,var(--drawer-size))]"],
      small: ["[--drawer-size:560px]", "w-[min(100vw,var(--drawer-size))]"]
    },
    side: {
      left: ["data-ending-style:-translate-x-full", "data-starting-style:-translate-x-full"],
      right: ["data-ending-style:translate-x-full", "data-starting-style:translate-x-full"]
    },
    contentVariant: {
      default: null,
      navigation: "border-0"
    },
    isBottomSheet: {
      false: null,
      true: ["h-auto", "min-h-[230px]", "max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "w-full", "rounded-t-(--radius-sm)", "data-ending-style:translate-x-0", "data-ending-style:translate-y-full", "data-starting-style:translate-x-0", "data-starting-style:translate-y-full"]
    },
    responsive: {
      false: null,
      true: ["max-md:h-auto", "max-md:min-h-[230px]", "max-md:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-md:w-full", "max-md:rounded-t-(--radius-sm)", "max-md:data-ending-style:translate-x-0", "max-md:data-ending-style:translate-y-full", "max-md:data-starting-style:translate-x-0", "max-md:data-starting-style:translate-y-full"]
    }
  },
  defaultVariants: {
    size: "default"
  }
}), ZC = ae(["flex", "min-h-0", "flex-1", "flex-col", "overflow-hidden", "bg-surface"], {
  variants: {
    variant: {
      default: ["gap-(--spacing-16)", "pt-(--spacing-10)"],
      navigation: ["gap-0", "pt-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), XC = ae(["flex", "shrink-0", "items-start", "justify-between", "gap-(--spacing-2)", "bg-surface", "mx-(--spacing-10)", "p-(--spacing-8)"]), QC = ae(["flex", "min-w-0", "flex-1", "items-start", "gap-(--spacing-8)"]), JC = ae(["flex", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-4)"]), ew = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), tw = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), nw = ae(["min-h-0", "flex-1", "overflow-y-auto", "px-(--spacing-20)", "max-md:pb-[env(safe-area-inset-bottom)]"]), ow = ae(["flex", "flex-col"], {
  variants: {
    gap: {
      none: "gap-0",
      md: "gap-(--spacing-20)"
    }
  },
  defaultVariants: {
    gap: "md"
  }
}), rw = ae(["flex", "min-h-(--spacing-80)", "shrink-0", "items-center", "justify-end", "gap-(--spacing-10)", "border-t", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)", "max-md:pb-[calc(var(--spacing-16)_+_env(safe-area-inset-bottom))]"]);
function iw(t) {
  const e = W.c(19);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r, i, s;
  e[3] !== o ? ({
    side: i,
    responsive: s,
    ...r
  } = o, e[3] = o, e[4] = r, e[5] = i, e[6] = s) : (r = e[4], i = e[5], s = e[6]);
  const l = i === void 0 ? "right" : i, a = s === void 0 ? !0 : s;
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    defaultMatches: !1
  }, e[7] = c) : c = e[7];
  const u = Ps(Ms.belowMd, c), d = a && u;
  let f;
  e[8] !== d || e[9] !== a || e[10] !== l ? (f = {
    responsive: a,
    side: l,
    isBottomSheet: d
  }, e[8] = d, e[9] = a, e[10] = l, e[11] = f) : f = e[11];
  const p = d ? "down" : l === "left" ? "left" : "right";
  let m;
  e[12] !== n || e[13] !== r || e[14] !== p ? (m = /* @__PURE__ */ g(SC, { modal: !0, swipeDirection: p, ...r, children: n }), e[12] = n, e[13] = r, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== f || e[17] !== m ? (h = /* @__PURE__ */ g(R0, { value: f, children: m }), e[16] = f, e[17] = m, e[18] = h) : h = e[18], h;
}
function cD(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(AC, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function sw(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(f0, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function lw(t) {
  const e = W.c(33);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    size: r,
    contentVariant: i,
    initialFocus: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "default" : i, a = s === void 0 ? !0 : s, c = en(), {
    responsive: u,
    side: d,
    isBottomSheet: f
  } = Cn(R0);
  let p;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g(d0, { className: ne(jC()) }), e[6] = p) : p = e[6];
  let m;
  e[7] !== f || e[8] !== u || e[9] !== d ? (m = ne(KC({
    responsive: u,
    side: d,
    isBottomSheet: f
  })), e[7] = f, e[8] = u, e[9] = d, e[10] = m) : m = e[10];
  let h;
  e[11] !== l || e[12] !== f || e[13] !== u || e[14] !== d || e[15] !== r ? (h = ne(qC({
    responsive: u,
    size: r,
    side: d,
    isBottomSheet: f,
    contentVariant: l
  })), e[11] = l, e[12] = f, e[13] = u, e[14] = d, e[15] = r, e[16] = h) : h = e[16];
  let b;
  e[17] !== l ? (b = ne(ZC({
    variant: l
  })), e[17] = l, e[18] = b) : b = e[18];
  let v;
  e[19] !== n || e[20] !== b ? (v = /* @__PURE__ */ g(m0, { className: b, children: n }), e[19] = n, e[20] = b, e[21] = v) : v = e[21];
  let C;
  e[22] !== a || e[23] !== o || e[24] !== h || e[25] !== v ? (C = /* @__PURE__ */ g(v0, { "aria-modal": "true", initialFocus: a, className: h, ...o, children: v }), e[22] = a, e[23] = o, e[24] = h, e[25] = v, e[26] = C) : C = e[26];
  let y;
  e[27] !== m || e[28] !== C ? (y = /* @__PURE__ */ g(x0, { className: m, children: C }), e[27] = m, e[28] = C, e[29] = y) : y = e[29];
  let w;
  return e[30] !== c || e[31] !== y ? (w = /* @__PURE__ */ F(mC, { container: c, children: [
    p,
    y
  ] }), e[30] = c, e[31] = y, e[32] = w) : w = e[32], w;
}
function uD(t) {
  const e = W.c(36);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    title: a,
    subtitle: s,
    leadingIcon: r,
    accessory: n,
    actions: o,
    closeLabel: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "Close drawer" : l;
  let u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = ne(XC()), e[8] = u) : u = e[8];
  let d;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(QC()), e[9] = d) : d = e[9];
  let f;
  e[10] !== r ? (f = r && /* @__PURE__ */ g("span", { className: "mt-(--spacing-4) inline-flex shrink-0 text-icon-main", children: /* @__PURE__ */ g(Ue, { name: r, size: "sm", tone: "inherit" }) }), e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne(JC()), e[12] = p) : p = e[12];
  let m;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = ne(ew()), e[13] = m) : m = e[13];
  let h;
  e[14] !== a ? (h = /* @__PURE__ */ g(VC, { className: m, children: a }), e[14] = a, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-8)", children: [
    h,
    n
  ] }), e[16] = n, e[17] = h, e[18] = b) : b = e[18];
  let v;
  e[19] !== s ? (v = s && /* @__PURE__ */ g(cC, { className: ne(tw()), children: s }), e[19] = s, e[20] = v) : v = e[20];
  let C;
  e[21] !== b || e[22] !== v ? (C = /* @__PURE__ */ F("div", { className: p, children: [
    b,
    v
  ] }), e[21] = b, e[22] = v, e[23] = C) : C = e[23];
  let y;
  e[24] !== C || e[25] !== f ? (y = /* @__PURE__ */ F("div", { className: d, children: [
    f,
    C
  ] }), e[24] = C, e[25] = f, e[26] = y) : y = e[26];
  let w;
  e[27] !== c ? (w = /* @__PURE__ */ g(f0, { render: /* @__PURE__ */ g(bt, { icon: "x-close", "aria-label": c, variant: "ghost", size: "md" }) }), e[27] = c, e[28] = w) : w = e[28];
  let R;
  e[29] !== o || e[30] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-8)", children: [
    o,
    w
  ] }), e[29] = o, e[30] = w, e[31] = R) : R = e[31];
  let S;
  return e[32] !== i || e[33] !== y || e[34] !== R ? (S = /* @__PURE__ */ F("div", { className: u, ...i, children: [
    y,
    R
  ] }), e[32] = i, e[33] = y, e[34] = R, e[35] = S) : S = e[35], S;
}
function dD(t) {
  const e = W.c(13);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    gap: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(nw()), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = ne(ow({
    gap: o
  })), e[5] = o, e[6] = s) : s = e[6];
  let l;
  e[7] !== n || e[8] !== s ? (l = /* @__PURE__ */ g("div", { className: s, children: n }), e[7] = n, e[8] = s, e[9] = l) : l = e[9];
  let a;
  return e[10] !== r || e[11] !== l ? (a = /* @__PURE__ */ g("div", { className: i, ...r, children: l }), e[10] = r, e[11] = l, e[12] = a) : a = e[12], a;
}
function fD(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(rw()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const Ds = yo({
  collapsed: !1
});
function wf() {
  return Cn(Ds);
}
const aw = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface", "border-r", "border-outline-subtle", "text-menu-text-default", "transition-[width]", "duration-200", "ease-in-out", "overflow-hidden"], {
  variants: {
    collapsed: {
      false: null,
      true: null
    },
    inAppShell: {
      false: null,
      true: ["relative", "z-10", "w-(--app-shell-sidebar-width)", "data-[hover-expanded]:w-(--app-shell-sidebar-expanded-width)"]
    }
  },
  compoundVariants: [{
    collapsed: !1,
    inAppShell: !1,
    className: "w-[260px]"
  }, {
    collapsed: !0,
    inAppShell: !1,
    className: "w-[72px]"
  }]
}), cw = ae("sticky bottom-0 z-10 mt-auto flex shrink-0 bg-surface", {
  variants: {
    collapsed: {
      false: "w-full",
      true: "w-(--spacing-40) justify-center"
    }
  }
}), Sf = ae(["group/sidebar-item", "relative", "inline-flex", "items-center", "border-0", "rounded-[var(--radius-sm)]", "text-left", "no-underline", "outline-none", "select-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "font-[family-name:var(--font-family-label)]", "font-[number:var(--font-weight-medium)]", "text-[length:var(--font-size-label-large)]", "leading-[var(--font-line-height-24)]", "tracking-[var(--font-letter-spacing-default)]", "text-menu-icon-default", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "disabled:cursor-not-allowed", "disabled:opacity-50", "disabled:pointer-events-none"], {
  variants: {
    collapsed: {
      false: ["h-(--spacing-40)", "w-full", "min-w-0", "justify-between", "gap-[var(--spacing-8)]", "px-(--spacing-10)", "py-[var(--spacing-12)]"],
      true: ["size-(--spacing-40)", "justify-center", "p-(--spacing-10)"]
    },
    selected: {
      false: "bg-transparent",
      true: ["bg-menu-item-selected", "text-menu-text-default", "hover:bg-menu-item-selected"]
    },
    variant: {
      item: "",
      subItem: ""
    }
  },
  compoundVariants: [{
    selected: !0,
    variant: "item",
    className: ["before:absolute", "before:left-[-16px]", "before:top-1/2", "before:h-(--spacing-24)", "before:w-[2px]", "before:-translate-y-1/2", "before:bg-primary", "before:rounded-r-[2px]", "before:content-['']"]
  }]
}), uw = ae(["overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "opacity-100", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0", "transition-[height,opacity]", "duration-200", "ease-out", "motion-reduce:transition-none"]), dw = "flex size-(--icon-sm) shrink-0 items-center justify-center", fw = ["pointer-events-none", "absolute", "left-[-16px]", "top-1/2", "h-(--spacing-24)", "w-[2px]", "-translate-y-1/2", "rounded-r-[2px]", "bg-primary"].join(" ");
function pD(t) {
  const e = W.c(64);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    collapsed: a,
    "aria-label": c,
    children: n,
    onMouseEnter: i,
    onMouseLeave: s,
    mobileHeaderLeading: r,
    mobileHeaderActions: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = a === void 0 ? !1 : a, d = c === void 0 ? "Main navigation" : c, f = ff(), [p, m] = qe(!1), h = at(!1), b = at(!1), v = f?.desktopSidebarCollapsed ?? u, C = at(v), y = f?.isMobile ?? !1, w = !y && v && !p;
  let R, S;
  e[9] !== v ? (R = () => {
    v ? !C.current && v && h.current && (b.current = !0, m(!1)) : (m(!1), b.current = !1), C.current = v;
  }, S = [v], e[9] = v, e[10] = R, e[11] = S) : (R = e[10], S = e[11]), Nt(R, S);
  let E;
  e[12] !== f || e[13] !== y ? (E = y ? () => f?.setMobileNavigationOpen(!1) : void 0, e[12] = f, e[13] = y, e[14] = E) : E = e[14];
  let N;
  e[15] !== w || e[16] !== E ? (N = {
    collapsed: w,
    closeMobileNavigation: E
  }, e[15] = w, e[16] = E, e[17] = N) : N = e[17];
  const I = w ? "" : void 0, M = p ? "" : void 0, T = !!f;
  let k;
  e[18] !== w || e[19] !== T ? (k = aw({
    collapsed: w,
    inAppShell: T
  }), e[18] = w, e[19] = T, e[20] = k) : k = e[20];
  const P = `${k}${y ? " w-full border-r-0" : ""}`;
  let D;
  e[21] !== i || e[22] !== v ? (D = (X) => {
    i?.(X), h.current = !0, v && !b.current && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget)) && m(!0);
  }, e[21] = i, e[22] = v, e[23] = D) : D = e[23];
  let O;
  e[24] !== s || e[25] !== v ? (O = (X) => {
    s?.(X), h.current = !1;
    const te = b.current;
    if (b.current = !1, v && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget))) {
      if (te) {
        m(!1);
        return;
      }
      m(!1);
    }
  }, e[24] = s, e[25] = v, e[26] = O) : O = e[26];
  let V;
  e[27] !== f || e[28] !== y ? (V = f && !y && /* @__PURE__ */ g("div", { className: "shrink-0 px-(--spacing-16) pt-(--spacing-24)", children: /* @__PURE__ */ g(Qx, {}) }), e[27] = f, e[28] = y, e[29] = V) : V = e[29];
  let _;
  e[30] !== n ? (_ = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto overscroll-contain", "data-slot": "sidebar-navigation", children: /* @__PURE__ */ g("div", { className: "flex min-h-full flex-col gap-(--spacing-8) px-(--spacing-16) py-(--spacing-16)", children: n }) }), e[30] = n, e[31] = _) : _ = e[31];
  let A;
  e[32] !== d || e[33] !== l || e[34] !== P || e[35] !== D || e[36] !== O || e[37] !== V || e[38] !== _ || e[39] !== I || e[40] !== M ? (A = /* @__PURE__ */ F("nav", { ...l, "aria-label": d, "data-collapsed": I, "data-hover-expanded": M, className: P, "data-slot": "sidebar", onMouseEnter: D, onMouseLeave: O, children: [
    V,
    _
  ] }), e[32] = d, e[33] = l, e[34] = P, e[35] = D, e[36] = O, e[37] = V, e[38] = _, e[39] = I, e[40] = M, e[41] = A) : A = e[41];
  let L;
  e[42] !== A || e[43] !== N ? (L = /* @__PURE__ */ g(Ds, { value: N, children: A }), e[42] = A, e[43] = N, e[44] = L) : L = e[44];
  const $ = L;
  if (!y || !f)
    return $;
  let B;
  e[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = {
    width: "75vw"
  }, e[45] = B) : B = e[45];
  let z;
  e[46] !== r ? (z = /* @__PURE__ */ g("div", { className: "min-w-0", children: r }), e[46] = r, e[47] = z) : z = e[47];
  let H;
  e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ g(sw, { render: /* @__PURE__ */ g(bt, { "aria-label": "Close navigation", icon: "x-close", variant: "outline" }) }), e[48] = H) : H = e[48];
  let K;
  e[49] !== o ? (K = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-12)", children: [
    o,
    H
  ] }), e[49] = o, e[50] = K) : K = e[50];
  let G;
  e[51] !== z || e[52] !== K ? (G = /* @__PURE__ */ F("div", { className: "flex h-[68px] shrink-0 items-center justify-between gap-(--spacing-12) border-b border-outline-subtle bg-surface px-(--spacing-24)", children: [
    z,
    K
  ] }), e[51] = z, e[52] = K, e[53] = G) : G = e[53];
  let q;
  e[54] !== $ ? (q = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1", children: $ }), e[54] = $, e[55] = q) : q = e[55];
  let Q;
  e[56] !== d || e[57] !== G || e[58] !== q ? (Q = /* @__PURE__ */ F(lw, { "aria-label": d, contentVariant: "navigation", style: B, children: [
    G,
    q
  ] }), e[56] = d, e[57] = G, e[58] = q, e[59] = Q) : Q = e[59];
  let U;
  return e[60] !== f.mobileNavigationOpen || e[61] !== f.setMobileNavigationOpen || e[62] !== Q ? (U = /* @__PURE__ */ g(iw, { open: f.mobileNavigationOpen, onOpenChange: f.setMobileNavigationOpen, responsive: !1, side: "left", children: Q }), e[60] = f.mobileNavigationOpen, e[61] = f.setMobileNavigationOpen, e[62] = Q, e[63] = U) : U = e[63], U;
}
function mD(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    collapsed: r
  } = Cn(Ds);
  let i;
  e[3] !== r ? (i = cw({
    collapsed: r
  }), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("div", { ...o, className: i, "data-slot": "sidebar-footer", children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function pw(t) {
  const e = W.c(6), {
    leading: n
  } = t;
  if (!n)
    return null;
  if (n.type === "icon") {
    let i;
    return e[0] !== n.name ? (i = /* @__PURE__ */ g(Ue, { name: n.name, size: "sm", tone: "inherit", "aria-hidden": !0, "data-slot": "sidebar-item-icon" }), e[0] = n.name, e[1] = i) : i = e[1], i;
  }
  const o = n.variant ?? "external";
  let r;
  return e[2] !== n.initials || e[3] !== n.src || e[4] !== o ? (r = /* @__PURE__ */ g(Xr, { initials: n.initials, size: "xs", src: n.src, variant: o }), e[2] = n.initials, e[3] = n.src, e[4] = o, e[5] = r) : r = e[5], r;
}
function Rf(t) {
  const e = W.c(21), {
    label: n,
    leading: o,
    badge: r,
    selected: i,
    variant: s,
    collapsed: l,
    trailing: a
  } = t, c = i === void 0 ? !1 : i, u = s === void 0 ? "item" : s;
  let d;
  e[0] !== o || e[1] !== c || e[2] !== u ? (d = u === "subItem" ? /* @__PURE__ */ g("span", { "aria-hidden": !0, className: dw, "data-slot": "sidebar-item-dot", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "relative z-[2] size-(--icon-sm)", viewBox: "0 0 20 20", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation item indicator" }),
    /* @__PURE__ */ g("circle", { className: c ? "fill-primary-on-container" : "fill-outline-subtle", cx: "10", cy: "10", "data-slot": "sidebar-item-dot-indicator", r: "2" })
  ] }) }) : /* @__PURE__ */ g(pw, { leading: o }), e[0] = o, e[1] = c, e[2] = u, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== n ? (f = !l && /* @__PURE__ */ g("span", { className: "min-w-0 truncate", "data-slot": "sidebar-item-label", title: n, children: n }), e[4] = l, e[5] = n, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-[var(--spacing-8)]", children: [
    d,
    f
  ] }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let m;
  e[10] !== r || e[11] !== l ? (m = !l && r && /* @__PURE__ */ g("span", { className: "ml-auto shrink-0", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(vu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[10] = r, e[11] = l, e[12] = m) : m = e[12];
  const h = !l && a;
  let b;
  e[13] !== r || e[14] !== l ? (b = l && r && /* @__PURE__ */ g("span", { className: "absolute right-(--spacing-2) top-(--spacing-2)", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(vu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[13] = r, e[14] = l, e[15] = b) : b = e[15];
  let v;
  return e[16] !== p || e[17] !== m || e[18] !== h || e[19] !== b ? (v = /* @__PURE__ */ F(_t, { children: [
    p,
    m,
    h,
    b
  ] }), e[16] = p, e[17] = m, e[18] = h, e[19] = b, e[20] = v) : v = e[20], v;
}
function Ol(t) {
  const e = W.c(24), {
    collapsed: n,
    closeMobileNavigation: o
  } = Cn(Ds);
  let r, i, s, l, a, c, u;
  if (e[0] !== o || e[1] !== n || e[2] !== t) {
    const {
      itemId: h,
      label: b,
      leading: v,
      selected: C,
      badge: y,
      tooltip: w,
      variant: R,
      collapsed: S,
      ...E
    } = t;
    i = b, u = w;
    const N = C === void 0 ? !1 : C, I = R === void 0 ? "item" : R;
    r = S === void 0 ? n : S;
    const M = Sf({
      collapsed: r,
      selected: N,
      variant: I
    });
    let T;
    e[10] !== y || e[11] !== r || e[12] !== i || e[13] !== v || e[14] !== N || e[15] !== I ? (T = /* @__PURE__ */ g(Rf, { label: i, leading: v, badge: y, selected: N, variant: I, collapsed: r }), e[10] = y, e[11] = r, e[12] = i, e[13] = v, e[14] = N, e[15] = I, e[16] = T) : T = e[16];
    const k = T, {
      render: P,
      href: D,
      target: O,
      rel: V,
      onClick: _,
      ...A
    } = E;
    if (D === void 0 && P === void 0)
      throw new Error("SidebarItem requires either an href or render prop.");
    const L = O === "_blank" && !V ? "noopener noreferrer" : V;
    c = Ma, s = "a", l = P, a = cn(A, {
      ...D !== void 0 && {
        href: D
      },
      ...O !== void 0 && {
        target: O
      },
      ...L !== void 0 && {
        rel: L
      },
      onClick: ($) => {
        _?.($), o?.();
      },
      "data-sidebar-item": h,
      "aria-label": i,
      "aria-current": N ? "page" : void 0,
      className: M,
      children: k
    }), e[0] = o, e[1] = n, e[2] = t, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[17] !== s || e[18] !== l || e[19] !== a ? (d = {
    defaultTagName: s,
    render: l,
    props: a
  }, e[17] = s, e[18] = l, e[19] = a, e[20] = d) : d = e[20];
  const f = c(d);
  if (!r || u === !1)
    return f;
  const p = u ?? i;
  let m;
  return e[21] !== f || e[22] !== p ? (m = /* @__PURE__ */ g(Xo, { label: p, side: "right", align: "center", children: f }), e[21] = f, e[22] = p, e[23] = m) : m = e[23], m;
}
function mw(t) {
  const e = W.c(34);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: i,
    leading: s,
    selected: c,
    badge: n,
    tooltip: u,
    collapsed: o,
    hasSelectedChild: r,
    open: l,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = c === void 0 ? !1 : c, f = d ? "page" : void 0;
  let p;
  e[10] !== o || e[11] !== d ? (p = Sf({
    collapsed: o,
    selected: d,
    variant: "item"
  }), e[10] = o, e[11] = d, e[12] = p) : p = e[12];
  let m;
  e[13] !== r ? (m = r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: fw, "data-slot": "sidebar-group-current-indicator" }), e[13] = r, e[14] = m) : m = e[14];
  const h = l ? "chevron-up" : "chevron-down";
  let b;
  e[15] !== h ? (b = /* @__PURE__ */ g(Ue, { name: h, size: "xs", tone: "secondary", "aria-hidden": !0 }), e[15] = h, e[16] = b) : b = e[16];
  let v;
  e[17] !== n || e[18] !== o || e[19] !== i || e[20] !== s || e[21] !== d || e[22] !== b ? (v = /* @__PURE__ */ g(Rf, { label: i, leading: s, badge: n, selected: d, collapsed: o, trailing: b }), e[17] = n, e[18] = o, e[19] = i, e[20] = s, e[21] = d, e[22] = b, e[23] = v) : v = e[23];
  let C;
  e[24] !== i || e[25] !== a || e[26] !== f || e[27] !== p || e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F("button", { ...a, "aria-label": i, "aria-current": f, className: p, type: "button", children: [
    m,
    v
  ] }), e[24] = i, e[25] = a, e[26] = f, e[27] = p, e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  const y = C;
  if (!o || u === !1)
    return y;
  const w = u ?? i;
  let R;
  return e[31] !== y || e[32] !== w ? (R = /* @__PURE__ */ g(Xo, { label: w, side: "right", align: "center", children: y }), e[31] = y, e[32] = w, e[33] = R) : R = e[33], R;
}
function gw(t) {
  const e = W.c(3), {
    children: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "pointer-events-none absolute top-[24px] bottom-[20px] left-(--spacing-10) z-[1] w-(--icon-sm)", "data-slot": "sidebar-group-connector", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "size-full", preserveAspectRatio: "none", viewBox: "0 0 20 100", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation connector" }),
    /* @__PURE__ */ g("line", { className: "stroke-outline-subtle", vectorEffect: "non-scaling-stroke", x1: "10", x2: "10", y1: "0", y2: "100" })
  ] }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("div", { className: "relative flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-group-items", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function hw(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-static-group-items", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function bw(t) {
  const e = W.c(13), {
    label: n,
    leading: o,
    badge: r,
    tooltip: i,
    collapsed: s
  } = t;
  let l;
  e[0] !== s ? (l = Sf({
    collapsed: s,
    selected: !1,
    variant: "item"
  }), e[0] = s, e[1] = l) : l = e[1];
  const a = `${l} !cursor-default hover:bg-transparent active:bg-transparent`;
  let c;
  e[2] !== r || e[3] !== s || e[4] !== n || e[5] !== o ? (c = /* @__PURE__ */ g(Rf, { label: n, leading: o, badge: r, collapsed: s }), e[2] = r, e[3] = s, e[4] = n, e[5] = o, e[6] = c) : c = e[6];
  let u;
  e[7] !== a || e[8] !== c ? (u = /* @__PURE__ */ g("div", { className: a, children: c }), e[7] = a, e[8] = c, e[9] = u) : u = e[9];
  const d = u;
  if (!s || i === !1)
    return d;
  const f = i ?? n;
  let p;
  return e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ g(Xo, { label: f, side: "right", align: "center", children: d }), e[10] = d, e[11] = f, e[12] = p) : p = e[12], p;
}
function xm(t) {
  const e = W.c(35), {
    itemId: n,
    label: o,
    leading: r,
    selected: i,
    hasSelectedChild: s,
    badge: l,
    tooltip: a,
    collapsed: c,
    collapsible: u,
    open: d,
    defaultOpen: f,
    onOpenChange: p,
    children: m
  } = t, h = i === void 0 ? !1 : i, b = s === void 0 ? !1 : s, v = u === void 0 ? !0 : u, C = f === void 0 ? !1 : f, {
    collapsed: y
  } = Cn(Ds), w = c ?? y, [R, S] = qe(C), E = d !== void 0, N = E ? d : R;
  let I;
  e[0] !== E || e[1] !== p ? (I = function(A) {
    E || S(A), p?.(A);
  }, e[0] = E, e[1] = p, e[2] = I) : I = e[2];
  const M = I;
  let T;
  e[3] !== l || e[4] !== w || e[5] !== b || e[6] !== o || e[7] !== r || e[8] !== N || e[9] !== h || e[10] !== a ? (T = /* @__PURE__ */ g(mw, { label: o, leading: r, selected: h, hasSelectedChild: b, badge: l, tooltip: a, collapsed: w, open: N }), e[3] = l, e[4] = w, e[5] = b, e[6] = o, e[7] = r, e[8] = N, e[9] = h, e[10] = a, e[11] = T) : T = e[11];
  const k = T;
  if (!v) {
    let _;
    e[12] !== l || e[13] !== w || e[14] !== o || e[15] !== r || e[16] !== a ? (_ = /* @__PURE__ */ g(bw, { label: o, leading: r, badge: l, tooltip: a, collapsed: w }), e[12] = l, e[13] = w, e[14] = o, e[15] = r, e[16] = a, e[17] = _) : _ = e[17];
    let A;
    e[18] !== m ? (A = /* @__PURE__ */ g(hw, { children: m }), e[18] = m, e[19] = A) : A = e[19];
    let L;
    return e[20] !== n || e[21] !== _ || e[22] !== A ? (L = /* @__PURE__ */ F("div", { "data-sidebar-group": n, children: [
      _,
      A
    ] }), e[20] = n, e[21] = _, e[22] = A, e[23] = L) : L = e[23], L;
  }
  let P;
  e[24] !== k ? (P = /* @__PURE__ */ g(Xl, { render: k }), e[24] = k, e[25] = P) : P = e[25];
  let D;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = uw(), e[26] = D) : D = e[26];
  let O;
  e[27] !== m ? (O = /* @__PURE__ */ g(gf, { className: D, "data-slot": "sidebar-group-panel", children: /* @__PURE__ */ g(gw, { children: m }) }), e[27] = m, e[28] = O) : O = e[28];
  let V;
  return e[29] !== M || e[30] !== n || e[31] !== N || e[32] !== P || e[33] !== O ? (V = /* @__PURE__ */ F(mf, { "data-sidebar-group": n, open: N, onOpenChange: M, children: [
    P,
    O
  ] }), e[29] = M, e[30] = n, e[31] = N, e[32] = P, e[33] = O, e[34] = V) : V = e[34], V;
}
const vw = ae(["@container/modal w-[min(calc(100vw_-_(var(--spacing-16)_*_2)),var(--modal-size))]", "max-w-(--modal-size)", "min-w-0", "max-h-[calc(100vh_-_var(--spacing-32))]", "flex flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5", "p-(--spacing-20)", "outline-none", "max-sm:min-h-[230px]", "max-sm:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-sm:w-full", "max-sm:max-w-none", "max-sm:rounded-b-none", "max-sm:pb-[calc(var(--spacing-20)_+_env(safe-area-inset-bottom))]"], {
  variants: {
    size: {
      sm: "[--modal-size:320px]",
      md: "[--modal-size:600px]",
      lg: "[--modal-size:1100px]"
    }
  }
}), yw = ae(["shrink-0 h-auto mt-(--spacing-20) flex gap-(--spacing-16)", "[&>*]:max-w-full [&>*]:h-auto [&>*]:min-h-(--spacing-40) [&>*]:min-w-0", "[&>*]:whitespace-normal [&>*]:[overflow-wrap:anywhere]", "[&>*]:flex-wrap", "[&_:is(button,a)]:max-w-full [&_:is(button,a)]:min-w-0 [&_:is(button,a)]:h-auto [&_:is(button,a)]:min-h-(--spacing-40)", "[&_:is(button,a)]:whitespace-normal [&_:is(button,a)]:[overflow-wrap:anywhere]", "@max-[480px]/modal:flex-col-reverse @max-[480px]/modal:items-stretch @max-[480px]/modal:[&>*]:w-full"], {
  variants: {
    size: {
      sm: "flex-col-reverse items-stretch [&>*]:w-full",
      md: "flex-wrap items-center justify-end",
      lg: "flex-wrap items-center justify-end"
    }
  }
}), xw = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), Cw = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]);
function wu(t) {
  const e = W.c(37), {
    open: n,
    onOpenChange: o,
    title: r,
    description: i,
    dismissible: s,
    size: l,
    children: a,
    footer: c
  } = t, u = s === void 0 ? !0 : s, d = en(), f = l ?? "md";
  let p;
  e[0] !== u || e[1] !== o ? (p = (P, D) => {
    if (!u && !P && (D.reason === "escape-key" || D.reason === "outside-press")) {
      D.cancel();
      return;
    }
    o(P);
  }, e[0] = u, e[1] = o, e[2] = p) : p = e[2];
  const m = p, h = !u;
  let b;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(Os, { className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }), e[3] = b) : b = e[3];
  let v;
  e[4] !== f ? (v = ne(vw({
    size: f
  })), e[4] = f, e[5] = v) : v = e[5];
  let C;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ne(xw()), e[6] = C) : C = e[6];
  let y;
  e[7] !== r ? (y = /* @__PURE__ */ g(rs, { className: C, children: r }), e[7] = r, e[8] = y) : y = e[8];
  let w;
  e[9] !== u ? (w = u && /* @__PURE__ */ g(ti, { render: /* @__PURE__ */ g(bt, { icon: "x-close", "aria-label": "Close", variant: "ghost", size: "sm" }) }), e[9] = u, e[10] = w) : w = e[10];
  let R;
  e[11] !== y || e[12] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
    y,
    w
  ] }), e[11] = y, e[12] = w, e[13] = R) : R = e[13];
  let S;
  e[14] !== i ? (S = i && /* @__PURE__ */ g(os, { className: ne(Cw()), children: i }), e[14] = i, e[15] = S) : S = e[15];
  let E;
  e[16] !== S || e[17] !== R ? (E = /* @__PURE__ */ F("div", { className: "shrink-0 flex flex-col gap-(--spacing-6)", children: [
    R,
    S
  ] }), e[16] = S, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== a ? (N = a && /* @__PURE__ */ g("div", { className: "min-h-0 mt-(--spacing-20) overflow-y-auto", children: a }), e[19] = a, e[20] = N) : N = e[20];
  let I;
  e[21] !== c || e[22] !== f ? (I = c && /* @__PURE__ */ g("div", { className: ne(yw({
    size: f
  })), children: c }), e[21] = c, e[22] = f, e[23] = I) : I = e[23];
  let M;
  e[24] !== E || e[25] !== N || e[26] !== I || e[27] !== v ? (M = /* @__PURE__ */ g(wi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-center justify-center max-sm:items-end", children: /* @__PURE__ */ F(xi, { "aria-modal": "true", className: v, children: [
    E,
    N,
    I
  ] }) }), e[24] = E, e[25] = N, e[26] = I, e[27] = v, e[28] = M) : M = e[28];
  let T;
  e[29] !== d || e[30] !== M ? (T = /* @__PURE__ */ F(Lr, { container: d, children: [
    b,
    M
  ] }), e[29] = d, e[30] = M, e[31] = T) : T = e[31];
  let k;
  return e[32] !== m || e[33] !== n || e[34] !== T || e[35] !== h ? (k = /* @__PURE__ */ g(Ci, { open: n, onOpenChange: m, modal: !0, disablePointerDismissal: h, children: T }), e[32] = m, e[33] = n, e[34] = T, e[35] = h, e[36] = k) : k = e[36], k;
}
function ww() {
  if (typeof document > "u") return null;
  const t = document.getElementById("aw-local-development-context")?.textContent;
  if (!t) return null;
  try {
    const e = JSON.parse(t);
    return !e || typeof e != "object" || !("appName" in e) || typeof e.appName != "string" || !("branch" in e) || typeof e.branch != "string" || !("worktree" in e) || typeof e.worktree != "string" || !("worktreePath" in e) || typeof e.worktreePath != "string" || !("apiTargets" in e) || !Array.isArray(e.apiTargets) || !e.apiTargets.every((n) => typeof n == "string") ? null : e;
  } catch {
    return null;
  }
}
function Sw(t) {
  return [`App: ${t.appName}`, `Branch: ${t.branch}`, `Worktree: ${t.worktreePath}`, `Frontend: ${window.location.origin}`, `API targets: ${t.apiTargets.join(", ") || "No local proxy configured"}`, "Frontend checkout and API code are independent; worktree frontends may share a backend."].join(`
`);
}
function Rw() {
  const t = W.c(15), [e, n] = qe(!1), [o, r] = qe("");
  let i, s, l, a;
  if (t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    l = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      if (i = ww(), !i) {
        l = null;
        break e;
      }
      a = ["brand", "informative", "positive", "warning"], s = Array.from(i.worktreePath).reduce(Nw, 0);
    }
    t[0] = i, t[1] = s, t[2] = l, t[3] = a;
  } else
    i = t[0], s = t[1], l = t[2], a = t[3];
  if (l !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return l;
  const u = a[s % a.length];
  let d;
  t[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = async function() {
    try {
      if (!i)
        return;
      await navigator.clipboard.writeText(Sw(i)), r("Copied");
    } catch {
      r("Could not copy. Select the details to copy manually.");
    }
  }, t[4] = d) : d = t[4];
  const f = d;
  let p;
  t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ F(pn, { variant: "ghost", size: "sm", "aria-label": `Local development context: ${i.appName}, ${i.worktree}`, onClick: () => {
    r(""), n(!0);
  }, children: [
    /* @__PURE__ */ g(Wn, { tone: u, label: "LOCAL" }),
    /* @__PURE__ */ F("span", { className: "hidden max-w-[160px] truncate sm:inline min-[1200px]:max-w-[240px]", children: [
      i.appName,
      " · ",
      i.worktree
    ] })
  ] }), t[5] = p) : p = t[5];
  let m;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", icon: "copy-regular", disabled: !navigator.clipboard?.writeText, onClick: () => {
    f();
  }, children: "Copy context" }), t[6] = m) : m = t[6];
  let h;
  t[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ F("dl", { className: "grid min-w-0 grid-cols-[auto_minmax(0,1fr)] gap-x-(--spacing-16) gap-y-(--spacing-8) text-(length:--font-size-body-medium) text-text-default [&>dd]:break-words", children: [
    /* @__PURE__ */ g("dt", { children: "App" }),
    /* @__PURE__ */ g("dd", { children: i.appName }),
    /* @__PURE__ */ g("dt", { children: "Branch" }),
    /* @__PURE__ */ g("dd", { children: i.branch }),
    /* @__PURE__ */ g("dt", { children: "Worktree" }),
    /* @__PURE__ */ g("dd", { children: i.worktreePath }),
    /* @__PURE__ */ g("dt", { children: "Frontend" }),
    /* @__PURE__ */ g("dd", { children: window.location.origin }),
    /* @__PURE__ */ g("dt", { children: "API targets" }),
    /* @__PURE__ */ g("dd", { children: i.apiTargets.length ? i.apiTargets.map(Ew) : "No local proxy configured; check the app’s API configuration." })
  ] }), t[7] = h) : h = t[7];
  let b;
  t[8] !== o ? (b = o && /* @__PURE__ */ g(an, { size: "sm", role: "status", children: o }), t[8] = o, t[9] = b) : b = t[9];
  let v;
  t[10] !== b ? (v = /* @__PURE__ */ F(Qo, { children: [
    h,
    b
  ] }), t[10] = b, t[11] = v) : v = t[11];
  let C;
  return t[12] !== e || t[13] !== v ? (C = /* @__PURE__ */ F(_t, { children: [
    p,
    /* @__PURE__ */ g(wu, { open: e, onOpenChange: n, title: "Local development context", description: "Frontend checkout and API code are independent. Worktree frontends may share a backend.", footer: m, children: v })
  ] }), t[12] = e, t[13] = v, t[14] = C) : C = t[14], C;
}
function Ew(t) {
  return /* @__PURE__ */ g("div", { children: t }, t);
}
function Nw(t, e) {
  return t + e.charCodeAt(0);
}
const kw = ["flex", "h-(--spacing-64)", "w-full", "items-center", "bg-surface", "border-b", "border-outline-subtle", "max-sm:h-[68px]"], Iw = ["flex", "h-full", "min-w-0", "shrink-0", "transition-[width]", "duration-200", "ease-in-out", "items-center", "border-r", "border-outline-subtle", "px-(--spacing-16)", "max-sm:border-r-0", "max-sm:px-(--spacing-24)"], Pw = ["hidden", "h-full", "min-w-0", "flex-1", "items-center", "overflow-hidden", "px-(--spacing-24)", "sm:flex"], Mw = ["ml-auto", "flex", "h-full", "shrink-0", "items-center", "gap-(--spacing-12)", "pr-(--spacing-24)", "max-sm:gap-(--spacing-20)"];
function gD(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = kw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { ...o, className: r, "data-slot": "top-bar", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function hD(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Iw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-leading", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function bD(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Pw.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-content", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function vD(t) {
  const e = W.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Mw.join(" "), e[3] = r) : r = e[3];
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ g(Rw, {}), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ F("div", { ...o, className: r, "data-slot": "top-bar-actions", children: [
    i,
    n
  ] }), e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
const Tw = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface"]), Ow = ae(["flex", "w-full", "min-w-0", "flex-col", "gap-(--spacing-4)", "rounded-(--radius-sm)", "px-0", "py-(--spacing-4)", "text-left", "cursor-pointer", "hover:bg-surface-hover", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring"], {
  variants: {
    active: {
      true: "bg-surface-container",
      false: null
    }
  },
  defaultVariants: {
    active: !1
  }
});
function E0(t) {
  const e = W.c(17), {
    conversations: n,
    activeConversationId: o,
    onSelectConversation: r
  } = t;
  let i, s, l, a, c;
  if (e[0] !== o || e[1] !== n || e[2] !== r) {
    const f = n.reduce(Dw, {});
    l = "assistant-chat-sidebar-content", a = "flex h-full min-h-0 flex-1 flex-col", e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("div", { className: "px-(--spacing-12) max-sm:px-(--spacing-20)", children: /* @__PURE__ */ g(mo, { size: "lg", children: "Chat History" }) }), e[8] = c) : c = e[8], i = "min-h-0 flex-1 overflow-y-auto px-(--spacing-12) pt-(--spacing-16)", s = n.length === 0 ? /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-center gap-(--spacing-12) px-(--spacing-12) text-center", children: [
      /* @__PURE__ */ g(Ue, { name: "message", size: "md", tone: "secondary", "aria-hidden": !0 }),
      /* @__PURE__ */ g(an, { tone: "subtle", children: "Your chat history will appear here" })
    ] }) : Object.entries(f).map((p) => {
      const [m, h] = p;
      return /* @__PURE__ */ F("section", { className: "mb-(--spacing-16)", children: [
        /* @__PURE__ */ g("div", { className: "px-(--spacing-8)", children: /* @__PURE__ */ g(mo, { size: "sm", tone: "subtle", children: m }) }),
        /* @__PURE__ */ g("div", { className: "mt-(--spacing-10) flex flex-col gap-(--spacing-4) px-(--spacing-8)", children: h.map((b) => /* @__PURE__ */ F("button", { type: "button", "aria-current": b.id === o ? "page" : void 0, className: Ow({
          active: b.id === o
        }), onClick: () => r(b.id), children: [
          /* @__PURE__ */ F("span", { className: "flex items-start justify-between gap-(--spacing-8)", children: [
            /* @__PURE__ */ g("span", { className: "[&>span]:block min-w-0 flex-1 [&>span]:leading-(--font-line-height-20)", children: /* @__PURE__ */ g(Mn, { as: "span", size: "sm", truncate: !0, children: b.title }) }),
            b.timestamp ? /* @__PURE__ */ g("span", { className: "shrink-0 whitespace-nowrap", children: /* @__PURE__ */ g(an, { as: "span", size: "sm", tone: "subtle", children: b.timestamp }) }) : null
          ] }),
          b.preview ? /* @__PURE__ */ g(an, { as: "span", size: "sm", tone: "subtle", truncate: !0, children: b.preview }) : null
        ] }, b.id)) })
      ] }, m);
    }), e[0] = o, e[1] = n, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a, e[7] = c;
  } else
    i = e[3], s = e[4], l = e[5], a = e[6], c = e[7];
  let u;
  e[9] !== i || e[10] !== s ? (u = /* @__PURE__ */ g("div", { className: i, children: s }), e[9] = i, e[10] = s, e[11] = u) : u = e[11];
  let d;
  return e[12] !== l || e[13] !== a || e[14] !== c || e[15] !== u ? (d = /* @__PURE__ */ F("div", { "data-slot": l, className: a, children: [
    c,
    u
  ] }), e[12] = l, e[13] = a, e[14] = c, e[15] = u, e[16] = d) : d = e[16], d;
}
function Dw(t, e) {
  const n = e.groupLabel ?? "Conversations", o = t[n] ?? [];
  return o.push(e), t[n] = o, t;
}
function _w(t) {
  const e = W.c(20), {
    conversations: n,
    activeConversationId: o,
    collapsed: r,
    onNewConversation: i,
    isNewConversationDisabled: s,
    onSelectConversation: l,
    onToggle: a,
    collapseDirection: c,
    badge: u,
    newConversationLabel: d
  } = t, f = r === void 0 ? !1 : r, p = s === void 0 ? !1 : s, m = d === void 0 ? "New chat" : d;
  let h;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = Tw(), e[0] = h) : h = e[0];
  let b;
  e[1] !== u || e[2] !== c || e[3] !== f || e[4] !== a ? (b = f ? null : /* @__PURE__ */ g("div", { className: "h-[72px] pb-(--spacing-8) pl-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ g(Up, { badge: u, sidebar: "expanded", children: /* @__PURE__ */ g(yu, { collapsed: !1, collapseDirection: c, onToggle: a }) }) }), e[1] = u, e[2] = c, e[3] = f, e[4] = a, e[5] = b) : b = e[5];
  let v;
  e[6] !== o || e[7] !== u || e[8] !== c || e[9] !== f || e[10] !== n || e[11] !== p || e[12] !== m || e[13] !== i || e[14] !== l || e[15] !== a ? (v = f ? /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto px-(--spacing-4) pb-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-between", children: [
    /* @__PURE__ */ g(Up, { badge: u, sidebar: "collapsed", children: /* @__PURE__ */ g(yu, { collapsed: !0, collapseDirection: c, onToggle: a }) }),
    /* @__PURE__ */ g("div", { className: "flex size-(--spacing-48) items-center justify-center", children: /* @__PURE__ */ g(bt, { icon: "edit-pen", variant: "outline", size: "md", "aria-label": m, onClick: i, disabled: p }) })
  ] }) }) : /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ g(E0, { conversations: n, activeConversationId: o, onSelectConversation: l }),
    /* @__PURE__ */ g("div", { className: "mt-auto px-(--spacing-12) pb-(--spacing-24) pt-(--spacing-12)", children: /* @__PURE__ */ g(pn, { variant: "outline", size: "md", icon: "edit-pen", fullWidth: !0, onClick: i, disabled: p, children: m }) })
  ] }), e[6] = o, e[7] = u, e[8] = c, e[9] = f, e[10] = n, e[11] = p, e[12] = m, e[13] = i, e[14] = l, e[15] = a, e[16] = v) : v = e[16];
  let C;
  return e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-sidebar", className: h, children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19], C;
}
const Cm = ne("relative", "flex", "flex-col", "items-start", "w-full", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"), Sc = {
  none: "p-0",
  compact: "p-(--spacing-12)",
  comfortable: "px-(--spacing-20) py-(--spacing-16)"
}, Vw = ne("flex", "w-full", "items-stretch", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:rounded-r-none", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:rounded-none", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:last-child:not(:first-child)>[data-slot=card]]:rounded-l-none"), Aw = ne("flex", "min-w-0", "flex-1", "[&>[data-slot=card]]:h-full"), Lw = ne("cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "text-left", "hover:bg-surface-hover", "active:bg-surface-container-highest", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"), Fw = ne("has-[[data-slot=card-link]]:isolate", "has-[[data-slot=card-link]]:cursor-pointer", "has-[[data-slot=card-link]]:transition-colors", "has-[[data-slot=card-link]]:hover:bg-surface-hover", "has-[[data-slot=card-link]:active]:bg-surface-container-highest", "has-[[data-slot=card-link]:focus-visible]:ring-2", "has-[[data-slot=card-link]:focus-visible]:ring-button-focus-ring", "has-[[data-slot=card-link]:focus-visible]:ring-offset-1", "has-[[data-slot=card-link]:focus-visible]:ring-offset-surface", "has-[[data-slot=card-link]]:[&_:is(button,a:not([data-slot=card-link]),input,select,textarea,summary,[role=button],[role=link])]:relative", "has-[[data-slot=card-link]]:[&_:is(button,a:not([data-slot=card-link]),input,select,textarea,summary,[role=button],[role=link])]:z-20"), $w = ne("flex", "w-full", "flex-col", "items-start", "overflow-hidden", "rounded-(--radius-sm)"), Hw = {
  brand: "bg-primary",
  positive: "bg-positive",
  warning: "bg-accessibility-warning",
  negative: "bg-negative",
  informative: "bg-informative"
};
function zw(t) {
  const e = W.c(4), {
    tone: n
  } = t, o = Hw[n];
  let r;
  e[0] !== o ? (r = ne("pointer-events-none absolute -top-px -left-px -right-px z-10 h-(--spacing-8) rounded-tl-(--radius-sm) rounded-tr-(--radius-sm)", o), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-border-fill", className: r }), e[2] = r, e[3] = i) : i = e[3], i;
}
function N0(t) {
  return ia(t) && t.type === zw;
}
function yD(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { "data-slot": "card-image-slot", className: "w-full shrink-0 overflow-hidden", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function xD(t) {
  const e = W.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ra.map(n, Bw), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-group", className: Vw, ...o, children: r }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function Bw(t) {
  return /* @__PURE__ */ g("div", { "data-slot": "card-group-item", className: Aw, children: t });
}
function wr(t) {
  const e = W.c(26);
  let n, o, r, i, s, l, a;
  if (e[0] !== t) {
    a = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        children: m,
        fillHeight: h,
        padding: b,
        ...v
      } = t;
      l = v;
      const C = h === void 0 ? !1 : h;
      s = b === void 0 ? "comfortable" : b;
      let y;
      if (e[8] !== m) {
        const S = ra.toArray(m);
        n = S.filter(N0), r = n.length > 0, y = S.filter(Ww), e[8] = m, e[9] = n, e[10] = r, e[11] = y;
      } else
        n = e[9], r = e[10], y = e[11];
      const w = y;
      let R;
      if (e[12] !== m || e[13] !== w || e[14] !== r || e[15] !== s ? (R = r ? /* @__PURE__ */ g("div", { "data-slot": "card-content", className: ne($w, Sc[s]), children: w }) : m, e[12] = m, e[13] = w, e[14] = r, e[15] = s, e[16] = R) : R = e[16], o = R, i = C ? "h-full" : null, "onClick" in l && l.onClick !== void 0) {
        const {
          onClick: S,
          disabled: E,
          ...N
        } = l;
        a = /* @__PURE__ */ F(no, { "data-slot": "card", className: ne(Cm, r ? "overflow-visible" : "overflow-hidden", !r && Sc[s], i, Lw, E && "opacity-50 pointer-events-none"), onClick: S, disabled: E, "aria-disabled": E || void 0, ...N, children: [
          n,
          o
        ] });
        break e;
      }
    }
    e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7];
  if (a !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return a;
  const c = r ? "overflow-visible" : "overflow-hidden", u = !r && Sc[s];
  let d;
  e[17] !== i || e[18] !== c || e[19] !== u ? (d = ne(Cm, c, u, i, Fw), e[17] = i, e[18] = c, e[19] = u, e[20] = d) : d = e[20];
  const f = l;
  let p;
  return e[21] !== n || e[22] !== o || e[23] !== d || e[24] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "card", className: d, ...f, children: [
    n,
    o
  ] }), e[21] = n, e[22] = o, e[23] = d, e[24] = f, e[25] = p) : p = e[25], p;
}
function Ww(t) {
  return !N0(t);
}
function CD(t) {
  const e = W.c(9);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Ma, n = "a", o = l, r = cn(a, {
      "data-slot": "card-link",
      className: "text-left outline-none after:absolute after:inset-0 after:z-10 after:rounded-(--radius-sm) after:content-['']"
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], i(s);
}
const Uw = ae(["grid", "w-full", "grid-cols-2", "gap-(--spacing-12)"]);
function wD(t) {
  const e = W.c(18), {
    title: n,
    description: o,
    templates: r,
    onSelectTemplate: i
  } = t;
  let s;
  e[0] !== n ? (s = /* @__PURE__ */ g("h2", { className: "text-center font-(family-name:--font-family-headline) text-(length:--font-size-title-xl) font-(number:--font-weight-semibold) leading-(--font-line-height-28) tracking-(--font-letter-spacing-default) text-text-default", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = o ? /* @__PURE__ */ g(an, { tone: "subtle", children: o }) : null, e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== s || e[5] !== l ? (a = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-center gap-(--spacing-8) pt-(--spacing-12) text-center", children: [
    s,
    l
  ] }), e[4] = s, e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = Uw(), e[7] = c) : c = e[7];
  let u;
  if (e[8] !== i || e[9] !== r) {
    let p;
    e[11] !== i ? (p = (m) => /* @__PURE__ */ g(wr, { fillHeight: !0, padding: "none", "aria-label": m.title, onClick: () => i(m), children: /* @__PURE__ */ g("div", { className: "flex h-full w-full flex-col p-(--spacing-16)", children: m.content ?? /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-12)", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full items-start justify-between gap-(--spacing-12)", children: [
        /* @__PURE__ */ g("span", { className: "text-icon-main", children: m.icon ?? /* @__PURE__ */ g(Ue, { name: "sparkles", size: "md" }) }),
        m.action ? /* @__PURE__ */ g("span", { className: "shrink-0", children: m.action }) : null
      ] }),
      /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-col gap-(--spacing-4)", children: [
        /* @__PURE__ */ g(Mn, { as: "h3", size: "xs", children: m.title }),
        m.description ? /* @__PURE__ */ g(an, { size: "sm", tone: "subtle", children: m.description }) : null
      ] })
    ] }) }) }, m.id), e[11] = i, e[12] = p) : p = e[12], u = r.map(p), e[8] = i, e[9] = r, e[10] = u;
  } else
    u = e[10];
  let d;
  e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[13] = u, e[14] = d) : d = e[14];
  let f;
  return e[15] !== a || e[16] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-template-picker", className: "flex w-full max-w-[368px] flex-col items-center gap-(--spacing-20)", children: [
    a,
    d
  ] }), e[15] = a, e[16] = d, e[17] = f) : f = e[17], f;
}
function Gw(t) {
  const e = W.c(53), {
    message: n,
    renderMessageContent: o,
    feedback: r,
    feedbackProps: i,
    feedbackResetKey: s
  } = t;
  let l;
  e[0] !== n || e[1] !== o ? (l = o ? o(n) : n.content, e[0] = n, e[1] = o, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== i ? (c = i ?? {}, e[3] = i, e[4] = c) : c = e[4];
  const u = J2(c, s), d = n.role === "assistant" && r === void 0 && i !== void 0;
  let f;
  e[5] !== u || e[6] !== d ? (f = d && u.status === "idle" ? /* @__PURE__ */ g(e0, { feedbackState: u }) : null, e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  const p = f;
  let m;
  e[8] !== r || e[9] !== i || e[10] !== u || e[11] !== d ? (m = d ? u.status === "submitted" ? /* @__PURE__ */ g(n0, {}) : u.status === "idle" && u.isReasonsOpen ? /* @__PURE__ */ g(t0, { feedbackState: u, allowWrittenFeedback: i.allowWrittenFeedback ?? !0, submitDisabled: i.onSubmit === void 0 }) : null : r, e[8] = r, e[9] = i, e[10] = u, e[11] = d, e[12] = m) : m = e[12];
  const h = m, b = n.role === "user";
  if (n.role === "system") {
    const D = typeof a == "string" || typeof a == "number";
    let O;
    e[13] !== a || e[14] !== D || e[15] !== n.statusTone ? (O = D ? /* @__PURE__ */ g(Z5, { tone: n.statusTone ?? "informative", children: a }) : /* @__PURE__ */ g(lu, { tone: "system", children: a }), e[13] = a, e[14] = D, e[15] = n.statusTone, e[16] = O) : O = e[16];
    let V;
    e[17] !== n.actions ? (V = n.actions ? /* @__PURE__ */ g(K1, { children: n.actions }) : null, e[17] = n.actions, e[18] = V) : V = e[18];
    let _;
    return e[19] !== O || e[20] !== V ? (_ = /* @__PURE__ */ g(iu, { direction: "inbound", children: /* @__PURE__ */ F(su, { children: [
      O,
      V
    ] }) }), e[19] = O, e[20] = V, e[21] = _) : _ = e[21], _;
  }
  const v = b ? "outbound" : "inbound";
  let C;
  e[22] !== b || e[23] !== n.avatar ? (C = b ? null : /* @__PURE__ */ g(Zg, { children: n.avatar ?? /* @__PURE__ */ g(Xr, { variant: "ai", size: "md" }) }), e[22] = b, e[23] = n.avatar, e[24] = C) : C = e[24];
  const y = n.author ?? (b ? "You" : "Assistant");
  let w;
  e[25] !== y ? (w = /* @__PURE__ */ g(mo, { size: "lg", children: y }), e[25] = y, e[26] = w) : w = e[26];
  let R;
  e[27] !== n.timestamp ? (R = n.timestamp ? /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ g(mo, { size: "xs", tone: "subtle", children: "•" }),
    /* @__PURE__ */ g(mo, { size: "lg", tone: "subtle", children: n.timestamp })
  ] }) : null, e[27] = n.timestamp, e[28] = R) : R = e[28];
  let S;
  e[29] !== w || e[30] !== R ? (S = /* @__PURE__ */ F(Xg, { children: [
    w,
    R
  ] }), e[29] = w, e[30] = R, e[31] = S) : S = e[31];
  let E;
  e[32] !== a ? (E = /* @__PURE__ */ g(lu, { children: a }), e[32] = a, e[33] = E) : E = e[33];
  let N;
  e[34] !== p || e[35] !== n.actions ? (N = n.actions || p ? /* @__PURE__ */ g(K1, { children: /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-4)", children: [
    n.actions,
    p
  ] }) }) : null, e[34] = p, e[35] = n.actions, e[36] = N) : N = e[36];
  let I;
  e[37] !== S || e[38] !== E || e[39] !== N ? (I = /* @__PURE__ */ F(su, { children: [
    S,
    E,
    N
  ] }), e[37] = S, e[38] = E, e[39] = N, e[40] = I) : I = e[40];
  let M;
  e[41] !== b ? (M = b ? null : /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "w-[28px] shrink-0" }), e[41] = b, e[42] = M) : M = e[42];
  let T;
  e[43] !== I || e[44] !== M || e[45] !== v || e[46] !== C ? (T = /* @__PURE__ */ F(iu, { direction: v, children: [
    C,
    I,
    M
  ] }), e[43] = I, e[44] = M, e[45] = v, e[46] = C, e[47] = T) : T = e[47];
  let k;
  e[48] !== h ? (k = h ? /* @__PURE__ */ g("div", { children: h }) : null, e[48] = h, e[49] = k) : k = e[49];
  let P;
  return e[50] !== T || e[51] !== k ? (P = /* @__PURE__ */ F("div", { className: "flex min-w-0 w-full flex-col gap-(--spacing-4)", children: [
    T,
    k
  ] }), e[50] = T, e[51] = k, e[52] = P) : P = e[52], P;
}
function wm(t) {
  const e = W.c(6), {
    messageId: n,
    scrollPosition: o
  } = t, {
    scrollToEnd: r,
    scrollToMessage: i
  } = Du(), s = at(n);
  let l, a;
  return e[0] !== n || e[1] !== o || e[2] !== r || e[3] !== i ? (l = () => {
    n && s.current !== n && (o === "end" ? r() : i(n, {
      align: "start"
    })), s.current = n;
  }, a = [n, o, r, i], e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = l, e[5] = a) : (l = e[4], a = e[5]), Nt(l, a), null;
}
function SD(t) {
  const e = W.c(114), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    conversations: i,
    activeConversationId: s,
    messages: l,
    isResponding: a,
    sidebar: c,
    templatePicker: u,
    feedback: d,
    feedbackRating: f,
    feedbackResetKey: p,
    conversationDate: m,
    minimized: h,
    onClose: b,
    onExpand: v,
    onMinimize: C,
    onSidebarToggle: y,
    sidebarBadge: w,
    collapseDirection: R,
    onNewConversation: S,
    onSelectConversation: E,
    onSendMessage: N,
    renderMessageContent: I,
    onSubmitFeedback: M,
    onRateResponse: T,
    composerProps: k
  } = t;
  let P;
  e[0] !== i ? (P = i === void 0 ? [] : i, e[0] = i, e[1] = P) : P = e[1];
  const D = P, O = a === void 0 ? !1 : a, V = h === void 0 ? !1 : h, _ = $t();
  let A;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = {
    defaultMatches: !1
  }, e[2] = A) : A = e[2];
  const L = Ps(Ms.belowSm, A), $ = V && !L, B = l.length === 0, [z, H] = qe(!1), [K, G] = qe(0);
  let q;
  e[3] !== k?.initialValue ? (q = () => k?.initialValue ?? "", e[3] = k?.initialValue, e[4] = q) : q = e[4];
  const [Q, U] = qe(q), X = at(s), te = at(null), re = at(null), J = `${_}-conversation-date`, ie = `${_}-responding`;
  let ce;
  e[5] !== l ? (ce = [...l].reverse().find(Kw)?.id, e[5] = l, e[6] = ce) : ce = e[6];
  const oe = ce;
  let se;
  e[7] !== l ? (se = [...l].reverse().find(jw)?.id, e[7] = l, e[8] = se) : se = e[8];
  const me = se, pe = p ?? `${s ?? "conversation"}:${me ?? "response"}`;
  let le, ge;
  e[9] !== L || e[10] !== c ? (ge = () => {
    (!L || !c) && H(!1);
  }, le = [L, c], e[9] = L, e[10] = c, e[11] = le, e[12] = ge) : (le = e[11], ge = e[12]), Nt(ge, le);
  let j, ee;
  e[13] !== s ? (j = () => {
    X.current !== s && (U(""), X.current = s);
  }, ee = [s], e[13] = s, e[14] = j, e[15] = ee) : (j = e[14], ee = e[15]), Nt(j, ee);
  let Y;
  e[16] !== L ? (Y = () => {
    !L || re.current === null || (te.current?.focus(), re.current = null);
  }, e[16] = L, e[17] = Y) : Y = e[17], go(Y);
  let Z;
  e[18] !== f || e[19] !== T || e[20] !== M ? (Z = M || T ? {
    rating: f,
    onRateResponse: T,
    onSubmit: M
  } : void 0, e[18] = f, e[19] = T, e[20] = M, e[21] = Z) : Z = e[21];
  const ue = Z;
  let fe;
  e[22] !== L || e[23] !== z || e[24] !== S ? (fe = () => {
    L && z && (re.current = "history"), H(!1), U(""), G(Yw), S?.();
  }, e[22] = L, e[23] = z, e[24] = S, e[25] = fe) : fe = e[25];
  const be = fe;
  let Ie;
  e[26] !== L || e[27] !== z || e[28] !== E ? (Ie = (Ge) => {
    L && z && (re.current = "history"), H(!1), E?.(Ge);
  }, e[26] = L, e[27] = z, e[28] = E, e[29] = Ie) : Ie = e[29];
  const ye = Ie;
  let xe;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = () => {
    re.current = "back", H(!0);
  }, e[30] = xe) : xe = e[30];
  const de = xe;
  let Se;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Se = () => {
    re.current = "history", H(!1);
  }, e[31] = Se) : Se = e[31];
  const Me = Se;
  let Re;
  e[32] !== s || e[33] !== D || e[34] !== L || e[35] !== B || e[36] !== o || e[37] !== z || e[38] !== b || e[39] !== v || e[40] !== C || e[41] !== ye || e[42] !== c || e[43] !== be || e[44] !== n || e[45] !== r ? (Re = c && L ? /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: !z, children: /* @__PURE__ */ g(Wp, { children: /* @__PURE__ */ F(Gp, { children: [
    /* @__PURE__ */ g(bc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: be, isNewConversationDisabled: B, onBack: Me, mobileHistoryControlRef: z ? te : void 0 }),
    /* @__PURE__ */ g(Yp, { children: /* @__PURE__ */ g("div", { className: "flex h-full min-h-0 flex-col pt-(--spacing-16)", children: /* @__PURE__ */ g(E0, { conversations: D, activeConversationId: s, onSelectConversation: ye }) }) })
  ] }) }) }) : null, e[32] = s, e[33] = D, e[34] = L, e[35] = B, e[36] = o, e[37] = z, e[38] = b, e[39] = v, e[40] = C, e[41] = ye, e[42] = c, e[43] = be, e[44] = n, e[45] = r, e[46] = Re) : Re = e[46];
  const Ve = Re, Ze = $ || !!(c && L && z);
  let Xe;
  e[47] !== s || e[48] !== R || e[49] !== D || e[50] !== B || e[51] !== y || e[52] !== ye || e[53] !== c || e[54] !== w || e[55] !== be ? (Xe = c ? /* @__PURE__ */ g(_y, { children: /* @__PURE__ */ g(_w, { conversations: D, activeConversationId: s, collapsed: c === "collapsed", onNewConversation: be, isNewConversationDisabled: B, onSelectConversation: ye, onToggle: y, collapseDirection: R, badge: w }) }) : null, e[47] = s, e[48] = R, e[49] = D, e[50] = B, e[51] = y, e[52] = ye, e[53] = c, e[54] = w, e[55] = be, e[56] = Xe) : Xe = e[56];
  const Be = c ? be : void 0, Ne = c ? de : void 0, _e = z ? void 0 : te;
  let Pe;
  e[57] !== B || e[58] !== o || e[59] !== b || e[60] !== v || e[61] !== C || e[62] !== Be || e[63] !== Ne || e[64] !== _e || e[65] !== n || e[66] !== r ? (Pe = /* @__PURE__ */ g(bc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: Be, isNewConversationDisabled: B, onOpenHistory: Ne, mobileHistoryControlRef: _e }), e[57] = B, e[58] = o, e[59] = b, e[60] = v, e[61] = C, e[62] = Be, e[63] = Ne, e[64] = _e, e[65] = n, e[66] = r, e[67] = Pe) : Pe = e[67];
  let $e;
  e[68] !== ue || e[69] !== pe || e[70] !== m || e[71] !== J || e[72] !== d || e[73] !== O || e[74] !== me || e[75] !== oe || e[76] !== l || e[77] !== I || e[78] !== ie || e[79] !== u ? ($e = /* @__PURE__ */ g(Yp, { children: !O && l.length === 0 && u ? /* @__PURE__ */ F("div", { className: "relative h-full min-h-0", children: [
    /* @__PURE__ */ g("div", { className: "flex h-full min-h-0 flex-col items-center overflow-y-auto px-(--spacing-12) pb-[58px] pt-(--spacing-12)", children: u }),
    /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "pointer-events-none absolute inset-x-0 bottom-0 h-[58px] bg-gradient-to-b from-surface/0 to-surface" })
  ] }) : /* @__PURE__ */ F(Qg, { children: [
    /* @__PURE__ */ F(Jg, { "aria-label": "Conversation", children: [
      /* @__PURE__ */ F(eh, { children: [
        m ? /* @__PURE__ */ g(Wi, { messageId: J, children: /* @__PURE__ */ g("div", { className: "py-(--spacing-10)", children: /* @__PURE__ */ g(vr, { centeredText: m, emphasis: "high" }) }) }) : null,
        l.map((Ge) => /* @__PURE__ */ g(Wi, { messageId: Ge.id, children: /* @__PURE__ */ g(Gw, { message: Ge, renderMessageContent: I, feedback: Ge.id === me ? d : void 0, feedbackProps: Ge.id === me ? ue : void 0, feedbackResetKey: pe }) }, Ge.id)),
        O ? /* @__PURE__ */ g(Wi, { messageId: ie, children: /* @__PURE__ */ g(Ay, {}) }) : null
      ] }),
      /* @__PURE__ */ g(wm, { messageId: oe, scrollPosition: "end" }),
      /* @__PURE__ */ g(wm, { messageId: me, scrollPosition: "start" })
    ] }),
    /* @__PURE__ */ g(th, {})
  ] }) }), e[68] = ue, e[69] = pe, e[70] = m, e[71] = J, e[72] = d, e[73] = O, e[74] = me, e[75] = oe, e[76] = l, e[77] = I, e[78] = ie, e[79] = u, e[80] = $e) : $e = e[80];
  const He = `${s ?? "conversation"}:${K}`;
  let Te;
  e[81] !== k || e[82] !== Q || e[83] !== N || e[84] !== He ? (Te = /* @__PURE__ */ g(Vy, { children: /* @__PURE__ */ g("div", { className: "-mx-(--spacing-4) -mb-(--spacing-4)", children: /* @__PURE__ */ g(Vx, { ...k, autoFocus: !0, value: Q, onChange: U, onSendMessage: N }, He) }) }), e[81] = k, e[82] = Q, e[83] = N, e[84] = He, e[85] = Te) : Te = e[85];
  let Rt;
  e[86] !== Pe || e[87] !== $e || e[88] !== Te ? (Rt = /* @__PURE__ */ F(Gp, { children: [
    Pe,
    $e,
    Te
  ] }), e[86] = Pe, e[87] = $e, e[88] = Te, e[89] = Rt) : Rt = e[89];
  let rt;
  e[90] !== c || e[91] !== Xe || e[92] !== Rt ? (rt = /* @__PURE__ */ F(Wp, { sidebar: c, children: [
    Xe,
    Rt
  ] }), e[90] = c, e[91] = Xe, e[92] = Rt, e[93] = rt) : rt = e[93];
  let Ce;
  e[94] !== Ze || e[95] !== rt ? (Ce = /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: Ze, children: rt }), e[94] = Ze, e[95] = rt, e[96] = Ce) : Ce = e[96];
  const Ee = Ce;
  let Ae;
  e[97] !== Ee || e[98] !== Ve ? (Ae = /* @__PURE__ */ F(_t, { children: [
    Ve,
    Ee
  ] }), e[97] = Ee, e[98] = Ve, e[99] = Ae) : Ae = e[99];
  const ze = Ae;
  let it;
  e[100] !== ze || e[101] !== $ ? (it = /* @__PURE__ */ g("div", { className: "contents", hidden: $, children: ze }), e[100] = ze, e[101] = $, e[102] = it) : it = e[102];
  let Ye;
  e[103] !== $ || e[104] !== o || e[105] !== b || e[106] !== v || e[107] !== C || e[108] !== n || e[109] !== r ? (Ye = $ ? /* @__PURE__ */ g(bc, { title: n, leadingAccessory: o, titleAccessory: r, minimized: !0, onClose: b, onMinimize: C, onExpand: v }) : null, e[103] = $, e[104] = o, e[105] = b, e[106] = v, e[107] = C, e[108] = n, e[109] = r, e[110] = Ye) : Ye = e[110];
  let Qe;
  return e[111] !== it || e[112] !== Ye ? (Qe = /* @__PURE__ */ F(_t, { children: [
    it,
    Ye
  ] }), e[111] = it, e[112] = Ye, e[113] = Qe) : Qe = e[113], Qe;
}
function Yw(t) {
  return t + 1;
}
function jw(t) {
  return t.role === "assistant";
}
function Kw(t) {
  return t.role === "user";
}
const qw = ae(["fixed", "z-[var(--z-layer-assistant)]", "outline-none", "right-(--spacing-20)", "max-sm:right-(--spacing-12)", "max-sm:left-auto", "max-sm:top-[172px]", "max-sm:bottom-auto", "max-sm:m-0", "max-sm:h-[min(700px,calc(100dvh-188px))]", "max-sm:w-[min(350px,calc(100vw-var(--spacing-24)))]"], {
  variants: {
    minimized: {
      true: ["bottom-0", "w-[242px]"],
      false: ["bottom-(--spacing-12)", "h-[min(624px,calc(100dvh-var(--spacing-80)))]"]
    },
    sidebar: {
      expanded: null,
      collapsed: null
    }
  },
  compoundVariants: [{
    minimized: !1,
    sidebar: "expanded",
    class: "w-[634px]"
  }, {
    minimized: !1,
    sidebar: "collapsed",
    class: "w-[456px]"
  }],
  defaultVariants: {
    minimized: !1,
    sidebar: "collapsed"
  }
});
function RD(t) {
  const e = W.c(20), {
    open: n,
    onOpenChange: o,
    "aria-label": r,
    children: i,
    minimized: s,
    sidebar: l
  } = t, a = s === void 0 ? !1 : s, c = l === void 0 ? "collapsed" : l, u = en(), [d, f] = qe(n);
  let p;
  e[0] !== o ? (p = (R, S) => {
    const E = S?.reason === "outside-press" || S?.reason === "focus-out";
    if (!R && E) {
      S.cancel();
      return;
    }
    o(R);
  }, e[0] = o, e[1] = p) : p = e[1];
  const m = p;
  let h, b;
  e[2] !== n ? (h = () => {
    n && f(!0);
  }, b = [n], e[2] = n, e[3] = h, e[4] = b) : (h = e[3], b = e[4]), Nt(h, b);
  let v;
  e[5] !== a || e[6] !== c ? (v = qw({
    minimized: a,
    sidebar: c
  }), e[5] = a, e[6] = c, e[7] = v) : v = e[7];
  let C;
  e[8] !== r || e[9] !== i || e[10] !== v ? (C = /* @__PURE__ */ g(xi, { "data-slot": "assistant-chat-dialog", "aria-label": r, className: v, children: i }), e[8] = r, e[9] = i, e[10] = v, e[11] = C) : C = e[11];
  let y;
  e[12] !== d || e[13] !== u || e[14] !== C ? (y = /* @__PURE__ */ g(Lr, { container: u, keepMounted: d, children: C }), e[12] = d, e[13] = u, e[14] = C, e[15] = y) : y = e[15];
  let w;
  return e[16] !== m || e[17] !== n || e[18] !== y ? (w = /* @__PURE__ */ g(Ci, { open: n, onOpenChange: m, modal: !1, disablePointerDismissal: !0, children: y }), e[16] = m, e[17] = n, e[18] = y, e[19] = w) : w = e[19], w;
}
const Zw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
};
function Xw(t) {
  const e = W.c(2), {
    count: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "flex w-[60px] items-center justify-center rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-6) font-(family-name:--font-family-title) font-(number:--font-weight-bold) text-(length:--font-size-headline-xsmall) leading-(--font-line-height-24) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function ED(t) {
  const e = W.c(40);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    count: r,
    actionItemName: n,
    priority: s,
    priorityLabel: l,
    buttonLabel: o,
    onButtonClick: i,
    style: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  let u;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    defaultMatches: !1
  }, e[9] = u) : u = e[9];
  const d = Ps(Ms.belowSm, u);
  let f;
  e[10] !== c ? (f = {
    width: "100%",
    ...c
  }, e[10] = c, e[11] = f) : f = e[11];
  const p = f;
  let m;
  e[12] !== r ? (m = /* @__PURE__ */ g(Xw, { count: r }), e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== n ? (h = /* @__PURE__ */ g(Mn, { size: "md", as: "h3", children: n }), e[14] = n, e[15] = h) : h = e[15];
  const b = Zw[s];
  let v;
  e[16] !== l || e[17] !== b ? (v = /* @__PURE__ */ g(Wn, { tone: b, icon: "priority", label: l }), e[16] = l, e[17] = b, e[18] = v) : v = e[18];
  let C;
  e[19] !== m || e[20] !== h || e[21] !== v ? (C = /* @__PURE__ */ F(Cr, { gap: 12, align: "center", wrap: "nowrap", children: [
    m,
    h,
    v
  ] }), e[19] = m, e[20] = h, e[21] = v, e[22] = C) : C = e[22];
  let y;
  e[23] !== o || e[24] !== d || e[25] !== i ? (y = !d && /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", onClick: i, children: o }), e[23] = o, e[24] = d, e[25] = i, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Cr, { justify: "between", align: "center", wrap: "nowrap", children: [
    C,
    y
  ] }) }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  if (d) {
    const E = `${o} ${n}`;
    let N;
    return e[30] !== p || e[31] !== R || e[32] !== i || e[33] !== a || e[34] !== E ? (N = /* @__PURE__ */ g(wr, { ...a, "aria-label": E, padding: "compact", style: p, onClick: i, children: R }), e[30] = p, e[31] = R, e[32] = i, e[33] = a, e[34] = E, e[35] = N) : N = e[35], N;
  }
  let S;
  return e[36] !== p || e[37] !== R || e[38] !== a ? (S = /* @__PURE__ */ g(wr, { ...a, padding: "compact", style: p, children: R }), e[36] = p, e[37] = R, e[38] = a, e[39] = S) : S = e[39], S;
}
const Qw = {
  positive: "text-positive",
  negative: "text-negative"
}, Jw = "text-text-subtle";
function k0(t) {
  const e = W.c(16), {
    label: n,
    showIcon: o
  } = t, r = o === void 0 ? !0 : o, {
    value: i
  } = t, s = i === void 0, l = !s && (!("tone" in t) || t.tone === void 0), a = s || l;
  let c = Jw, u = "trend-no-change", d = "sm";
  !a && t.tone && t.direction && (c = Qw[t.tone], u = t.direction === "up" ? "trend-up" : "trend-down", d = "md");
  const f = `inline-flex items-center gap-(--spacing-4) ${c}`;
  let p;
  e[0] !== u || e[1] !== d || e[2] !== s || e[3] !== r ? (p = r ? s ? /* @__PURE__ */ g("span", { className: "inline-block w-(--icon-sm) text-center font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: "--" }) : /* @__PURE__ */ g(Ue, { name: u, size: d, tone: "inherit" }) : null, e[0] = u, e[1] = d, e[2] = s, e[3] = r, e[4] = p) : p = e[4];
  let m;
  e[5] !== i ? (m = i ? /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: i }) : null, e[5] = i, e[6] = m) : m = e[6];
  let h;
  e[7] !== f || e[8] !== p || e[9] !== m ? (h = /* @__PURE__ */ F("span", { className: f, children: [
    p,
    m
  ] }), e[7] = f, e[8] = p, e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] !== n ? (b = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = b) : b = e[12];
  let v;
  return e[13] !== h || e[14] !== b ? (v = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-4)", children: [
    h,
    b
  ] }), e[13] = h, e[14] = b, e[15] = v) : v = e[15], v;
}
const eS = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-title-lg)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "positive"
  }
});
function tS(t) {
  const e = W.c(5), {
    value: n,
    tone: o
  } = t;
  let r;
  e[0] !== o ? (r = eS({
    tone: o
  }), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r || e[3] !== n ? (i = /* @__PURE__ */ g("span", { className: r, children: n }), e[2] = r, e[3] = n, e[4] = i) : i = e[4], i;
}
function ND(t) {
  const e = W.c(26);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: o,
    value: l,
    tone: i,
    detail: n,
    trend: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== n ? (a = n ? /* @__PURE__ */ F("span", { className: "font-(number:--font-weight-semibold) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: [
    " ",
    n
  ] }) : null, e[7] = n, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== a ? (c = /* @__PURE__ */ F(Mn, { size: "sm", as: "h3", children: [
    o,
    a
  ] }), e[9] = o, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== i || e[13] !== l ? (u = /* @__PURE__ */ g(tS, { value: l, tone: i }), e[12] = i, e[13] = l, e[14] = u) : u = e[14];
  let d;
  e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(Cr, { justify: "between", align: "center", wrap: "nowrap", children: [
    c,
    u
  ] }), e[15] = c, e[16] = u, e[17] = d) : d = e[17];
  let f;
  e[18] !== s ? (f = s ? /* @__PURE__ */ g(k0, { ...s }) : null, e[18] = s, e[19] = f) : f = e[19];
  let p;
  e[20] !== d || e[21] !== f ? (p = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Qo, { gap: 8, children: [
    d,
    f
  ] }) }), e[20] = d, e[21] = f, e[22] = p) : p = e[22];
  let m;
  return e[23] !== r || e[24] !== p ? (m = /* @__PURE__ */ g(wr, { ...r, padding: "compact", children: p }), e[23] = r, e[24] = p, e[25] = m) : m = e[25], m;
}
const nS = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
}, oS = ae(["font-(family-name:--font-family-headline)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-headline-large)", "leading-(--font-line-height-40)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function rS(t) {
  const e = W.c(5), {
    value: n,
    tone: o
  } = t, r = o === void 0 ? "neutral" : o;
  let i;
  e[0] !== r ? (i = oS({
    tone: r
  }), e[0] = r, e[1] = i) : i = e[1];
  let s;
  return e[2] !== i || e[3] !== n ? (s = /* @__PURE__ */ g("span", { className: i, children: n }), e[2] = i, e[3] = n, e[4] = s) : s = e[4], s;
}
function kD(t) {
  const e = W.c(43);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    label: r,
    value: f,
    tone: c,
    trend: d,
    supportingInfo: a,
    actionLabel: n,
    onActionClick: i,
    actionRender: o,
    priority: s,
    fillHeight: u,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "neutral" : c, m = u === void 0 ? !1 : u, h = m ? "flex h-full w-full flex-col justify-center" : "w-full";
  let b;
  e[12] !== r ? (b = /* @__PURE__ */ g(Mn, { size: "md", as: "h3", truncate: !0, children: r }), e[12] = r, e[13] = b) : b = e[13];
  let v;
  e[14] !== n || e[15] !== o || e[16] !== i || e[17] !== s ? (v = n && (i || o) ? /* @__PURE__ */ g(bt, { render: o, variant: "outline", size: "sm", icon: "arrow-up-right", "aria-label": n, onClick: i }) : s ? /* @__PURE__ */ g(Ue, { name: "priority", size: "sm", tone: nS[s] }) : null, e[14] = n, e[15] = o, e[16] = i, e[17] = s, e[18] = v) : v = e[18];
  let C;
  e[19] !== b || e[20] !== v ? (C = /* @__PURE__ */ g("div", { className: "h-(--spacing-32)", children: /* @__PURE__ */ F(Cr, { justify: "between", align: "start", wrap: "nowrap", children: [
    b,
    v
  ] }) }), e[19] = b, e[20] = v, e[21] = C) : C = e[21];
  let y;
  e[22] !== p || e[23] !== f ? (y = /* @__PURE__ */ g(rS, { value: f, tone: p }), e[22] = p, e[23] = f, e[24] = y) : y = e[24];
  let w;
  e[25] !== d ? (w = d ? /* @__PURE__ */ g(k0, { ...d }) : null, e[25] = d, e[26] = w) : w = e[26];
  let R;
  e[27] !== a ? (R = a ? /* @__PURE__ */ g("div", { className: "w-full", children: a }) : null, e[27] = a, e[28] = R) : R = e[28];
  let S;
  e[29] !== y || e[30] !== w || e[31] !== R ? (S = /* @__PURE__ */ F(Qo, { gap: 6, children: [
    y,
    w,
    R
  ] }), e[29] = y, e[30] = w, e[31] = R, e[32] = S) : S = e[32];
  let E;
  e[33] !== S || e[34] !== C ? (E = /* @__PURE__ */ F(Qo, { gap: 12, children: [
    C,
    S
  ] }), e[33] = S, e[34] = C, e[35] = E) : E = e[35];
  let N;
  e[36] !== E || e[37] !== h ? (N = /* @__PURE__ */ g("div", { className: h, children: E }), e[36] = E, e[37] = h, e[38] = N) : N = e[38];
  let I;
  return e[39] !== m || e[40] !== l || e[41] !== N ? (I = /* @__PURE__ */ g(wr, { fillHeight: m, ...l, children: N }), e[39] = m, e[40] = l, e[41] = N, e[42] = I) : I = e[42], I;
}
function ID(t) {
  const e = W.c(41);
  let n;
  e[0] !== t.chipLabel || e[1] !== t.mpCount || e[2] !== t.mpCountLabel || e[3] !== t.variant ? (n = t.variant === "add" ? /* @__PURE__ */ g(Wn, { tone: "informative", label: t.chipLabel ?? "Recommended" }) : t.mpCount != null ? /* @__PURE__ */ g(Wn, { tone: "neutral", label: t.mpCountLabel ?? (t.mpCount === 1 ? "1 MP" : `${t.mpCount} MPs`) }) : null, e[0] = t.chipLabel, e[1] = t.mpCount, e[2] = t.mpCountLabel, e[3] = t.variant, e[4] = n) : n = e[4];
  const o = n, {
    serviceName: r,
    icon: i,
    variant: s,
    showIcon: l
  } = t, a = s === void 0 ? "default" : s, c = l === void 0 ? !0 : l;
  let u;
  e[5] !== i ? (u = /* @__PURE__ */ g(Ue, { name: i, size: "sm", tone: "neutral", "aria-hidden": !0 }), e[5] = i, e[6] = u) : u = e[6];
  let d;
  e[7] !== r ? (d = /* @__PURE__ */ g(Mn, { size: "sm", as: "h3", children: r }), e[7] = r, e[8] = d) : d = e[8];
  let f;
  e[9] !== u || e[10] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-start gap-(--spacing-4)", children: [
    u,
    d
  ] }), e[9] = u, e[10] = d, e[11] = f) : f = e[11];
  let p;
  e[12] !== f || e[13] !== o ? (p = /* @__PURE__ */ F(Cr, { gap: 8, justify: "between", wrap: "wrap", align: "start", children: [
    f,
    o
  ] }), e[12] = f, e[13] = o, e[14] = p) : p = e[14];
  let m;
  e[15] !== a || e[16] !== c ? (m = a === "add" ? /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-center gap-(--spacing-10) border border-dashed border-outline-subtle bg-surface py-(--spacing-6)", children: [
    c ? /* @__PURE__ */ g(Ue, { name: "marketplace", size: "md", tone: "neutral", "aria-hidden": !0 }) : null,
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-24) text-text-default", children: "Add" })
  ] }) : null, e[15] = a, e[16] = c, e[17] = m) : m = e[17];
  let h;
  e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Qo, { gap: 12, children: [
    p,
    m
  ] }) }), e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  const b = h;
  if (t.onClick) {
    let R, S, E;
    if (e[21] !== t) {
      const {
        serviceName: M,
        icon: T,
        variant: k,
        chipLabel: P,
        mpCount: D,
        mpCountLabel: O,
        showIcon: V,
        onClick: _,
        style: A,
        ...L
      } = t;
      S = _, E = A, R = L, e[21] = t, e[22] = R, e[23] = S, e[24] = E;
    } else
      R = e[22], S = e[23], E = e[24];
    let N;
    e[25] !== E ? (N = {
      width: "100%",
      ...E
    }, e[25] = E, e[26] = N) : N = e[26];
    let I;
    return e[27] !== R || e[28] !== b || e[29] !== S || e[30] !== N ? (I = /* @__PURE__ */ g(wr, { ...R, onClick: S, padding: "compact", style: N, children: b }), e[27] = R, e[28] = b, e[29] = S, e[30] = N, e[31] = I) : I = e[31], I;
  }
  let v, C;
  if (e[32] !== t) {
    const {
      serviceName: R,
      icon: S,
      variant: E,
      chipLabel: N,
      mpCount: I,
      mpCountLabel: M,
      showIcon: T,
      onClick: k,
      style: P,
      ...D
    } = t;
    C = P, v = D, e[32] = t, e[33] = v, e[34] = C;
  } else
    v = e[33], C = e[34];
  let y;
  e[35] !== C ? (y = {
    width: "100%",
    ...C
  }, e[35] = C, e[36] = y) : y = e[36];
  let w;
  return e[37] !== b || e[38] !== v || e[39] !== y ? (w = /* @__PURE__ */ g(wr, { ...v, padding: "compact", style: y, children: b }), e[37] = b, e[38] = v, e[39] = y, e[40] = w) : w = e[40], w;
}
const iS = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
function sS() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "data-slot": "empty-state-pattern", "aria-hidden": "true", viewBox: "0 0 336 336", fill: "none", className: "pointer-events-none absolute top-1/2 left-1/2 size-[336px] max-w-none -translate-x-1/2 -translate-y-1/2 text-outline-subtle", children: /* @__PURE__ */ F("g", { stroke: "currentColor", children: [
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "167.5", strokeOpacity: "0" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "143.5", strokeOpacity: "0.04" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "119.5", strokeOpacity: "0.24" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "95.5", strokeOpacity: "0.48" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "71.5", strokeOpacity: "0.67" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "47.5", strokeOpacity: "0.88" })
  ] }) }), t[0] = e) : e = t[0], e;
}
function Sm({
  icon: t,
  title: e,
  description: n,
  actions: o,
  headingLevel: r = 2,
  variant: i = "default",
  outlined: s = i === "compact",
  iconTone: l
}) {
  const a = iS[r];
  return /* @__PURE__ */ F("section", { "data-slot": "empty-state", className: ne(i === "compact" ? "relative flex aspect-square w-full flex-col items-center justify-center gap-(--spacing-12) overflow-hidden" : "relative mx-auto flex w-full flex-col items-center overflow-hidden py-(--spacing-128)", i === "default" && !s && "max-w-[856px]", s && "rounded-(--radius-sm) border border-solid border-outline-subtle"), children: [
    i === "compact" ? /* @__PURE__ */ g("div", { className: `flex size-(--spacing-40) items-center justify-center rounded-full ${l === "negative" ? "bg-negative-container" : "bg-surface-container-low"}`, children: /* @__PURE__ */ g(Ue, { name: t, size: "xs", tone: l, "aria-hidden": !0 }) }) : /* @__PURE__ */ F("div", { className: "relative flex size-[48px] items-center justify-center", children: [
      /* @__PURE__ */ g(sS, {}),
      /* @__PURE__ */ g("div", { className: "relative z-10", children: /* @__PURE__ */ g(Ue, { name: t, size: "md", "aria-hidden": !0 }) })
    ] }),
    /* @__PURE__ */ F("div", { className: i === "compact" ? "flex w-full flex-col items-center px-(--spacing-12) text-center" : "relative mt-(--spacing-20) flex w-full max-w-[500px] flex-col items-center px-(--spacing-32) text-center", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-6)", children: [
        /* @__PURE__ */ g(a, { className: i === "compact" ? "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default" : "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-24) text-text-default", children: e }),
        n ? /* @__PURE__ */ g("p", { className: i === "compact" ? "m-0 whitespace-pre-line font-(family-name:--font-family-title) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtle" : "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-subtle", children: n }) : null
      ] }),
      o ? /* @__PURE__ */ g("div", { className: i === "compact" ? "mt-(--spacing-20) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)" : "mt-(--spacing-32) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)", children: o }) : null
    ] })
  ] });
}
function lS(t) {
  const e = W.c(6), {
    title: n,
    action: o,
    headingLevel: r
  } = t, s = `h${r === void 0 ? 2 : r}`;
  let l;
  e[0] !== s || e[1] !== n ? (l = /* @__PURE__ */ g(Mn, { as: s, children: n }), e[0] = s, e[1] = n, e[2] = l) : l = e[2];
  let a;
  return e[3] !== o || e[4] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "section-header", className: "flex min-h-(--spacing-32) w-full items-center justify-between gap-(--spacing-12) leading-(--font-line-height-24)", children: [
    l,
    o
  ] }), e[3] = o, e[4] = l, e[5] = a) : a = e[5], a;
}
const aS = {
  title: "Asset Gallery",
  viewAll: "View All",
  noImagesFound: "No Images Found",
  emptyDescription: "At least one image is required for every asset.",
  addImages: "Add Images",
  loadingError: "Loading Error",
  loadingErrorDescription: `We had a problem loading this media.
Try refreshing the page or checking back later.`,
  refresh: "Refresh"
};
function cS(t) {
  return JSON.stringify(t.map(({
    id: e,
    src: n
  }) => [e, n]));
}
function uS(t) {
  return Promise.all(t.map((e) => new Promise((n, o) => {
    const r = new Image();
    r.onload = () => n(), r.onerror = () => o(new Error(`Unable to load ${e}`)), r.src = e;
  }))).then(() => {
  });
}
function PD(t) {
  const e = W.c(35), {
    images: n,
    onViewAll: o,
    onAddImages: r,
    onRefresh: i,
    hasLoadingError: s,
    showThumbnails: l,
    labels: a
  } = t, c = s === void 0 ? !1 : s, u = l === void 0 ? !0 : l, [d, f] = qe(), [p, m] = qe(0), h = at(0);
  let b;
  e[0] !== n ? (b = cS(n), e[0] = n, e[1] = b) : b = e[1];
  const v = b, C = at(v), [y, w] = qe(v);
  let R, S;
  e[2] !== v ? (R = () => (C.current = v, h.current = h.current + 1, () => {
    h.current = h.current + 1;
  }), S = [v], e[2] = v, e[3] = R, e[4] = S) : (R = e[3], S = e[4]), go(R, S), y !== v && (w(v), f(void 0), m(mS));
  let E;
  e[5] !== a ? (E = {
    ...aS,
    ...a
  }, e[5] = a, e[6] = E) : E = e[6];
  const N = E, I = c || d?.imageSetKey === v && d.retryId === p;
  let M;
  if (e[7] !== v || e[8] !== d || e[9] !== c || e[10] !== I || e[11] !== n || e[12] !== N.addImages || e[13] !== N.emptyDescription || e[14] !== N.loadingError || e[15] !== N.loadingErrorDescription || e[16] !== N.noImagesFound || e[17] !== N.refresh || e[18] !== N.title || e[19] !== N.viewAll || e[20] !== r || e[21] !== i || e[22] !== o || e[23] !== p || e[24] !== u) {
    const T = n.slice(0, 4);
    let k;
    e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = (_, A) => {
      f({
        imageSetKey: _,
        retryId: A
      });
    }, e[26] = k) : k = e[26];
    const P = k, D = () => {
      if (c) {
        i?.();
        return;
      }
      if (!(d?.imageSetKey === v && d.retryId === p))
        return;
      const A = h.current = h.current + 1, L = [...new Set(T.slice(0, u ? 4 : 1).map(pS))], $ = uS(L);
      i?.(), $.then(() => {
        A !== h.current || C.current !== v || (m(fS), f(void 0));
      }, dS);
    };
    let O;
    e[27] !== I || e[28] !== n.length || e[29] !== N.viewAll || e[30] !== o ? (O = n.length > 0 && !I && o ? /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", icon: "arrow-up-right", onClick: o, children: N.viewAll }) : void 0, e[27] = I, e[28] = n.length, e[29] = N.viewAll, e[30] = o, e[31] = O) : O = e[31];
    let V;
    e[32] !== N.title || e[33] !== O ? (V = /* @__PURE__ */ g(lS, { title: N.title, action: O }), e[32] = N.title, e[33] = O, e[34] = V) : V = e[34], M = /* @__PURE__ */ F("div", { "data-slot": "contextual-asset-gallery", className: "flex w-[320px] max-w-full flex-col gap-(--spacing-10)", children: [
      V,
      I ? /* @__PURE__ */ g(Sm, { variant: "compact", icon: "wifi-exclamation-sharp-solid", iconTone: "negative", title: N.loadingError, description: N.loadingErrorDescription, actions: /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", icon: "sync", onClick: D, children: N.refresh }) }) : n.length === 0 ? /* @__PURE__ */ g(Sm, { variant: "compact", icon: "image-regular", title: N.noImagesFound, description: N.emptyDescription, actions: /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", icon: "add-plus", onClick: r, children: N.addImages }) }) : /* @__PURE__ */ F(_t, { children: [
        /* @__PURE__ */ g(ql, { size: "lg", fullWidth: !0, src: T[0].src, alt: T[0].alt, onImageError: () => P(v, p) }, `${T[0].id}-${p}`),
        u && T.length > 1 ? /* @__PURE__ */ g("div", { className: "grid grid-cols-3 gap-(--spacing-4)", children: T.slice(1).map((_) => /* @__PURE__ */ g(ql, { size: "lg", fullWidth: !0, src: _.src, alt: _.alt, onImageError: () => P(v, p) }, `${_.id}-${p}`)) }) : null
      ] })
    ] }), e[7] = v, e[8] = d, e[9] = c, e[10] = I, e[11] = n, e[12] = N.addImages, e[13] = N.emptyDescription, e[14] = N.loadingError, e[15] = N.loadingErrorDescription, e[16] = N.noImagesFound, e[17] = N.refresh, e[18] = N.title, e[19] = N.viewAll, e[20] = r, e[21] = i, e[22] = o, e[23] = p, e[24] = u, e[25] = M;
  } else
    M = e[25];
  return M;
}
function dS() {
}
function fS(t) {
  return t + 1;
}
function pS(t) {
  return t.src;
}
function mS(t) {
  return t + 1;
}
const Ef = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Ef.displayName = "SelectRootContext");
const Nf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Nf.displayName = "SelectFloatingContext");
function $o() {
  const t = x.useContext(Ef);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : st(60));
  return t;
}
function I0() {
  const t = x.useContext(Nf);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : st(61));
  return t;
}
const P0 = (t, e) => Object.is(t, e);
function vo(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function M0(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : vo(e, o, n));
}
function Do(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : vo(o, e, n));
}
function T0(t, e, n) {
  return t.filter((o) => !vo(e, o, n));
}
function Jl(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function kf(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function O0(t) {
  if (!Array.isArray(t))
    return t != null && "null" in t;
  const e = t;
  if (kf(e)) {
    for (const n of e)
      for (const o of n.items)
        if (o && o.value == null && o.label != null)
          return !0;
    return !1;
  }
  for (const n of e)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function fn(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return Jl(t);
}
function qn(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? Jl(t.value) : Jl(t);
}
function D0(t, e, n) {
  function o() {
    return fn(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = e, i = kf(r) ? r.flatMap((s) => s.items) : r;
    if (t == null || typeof t != "object") {
      const s = i.find((l) => l.value === t);
      return s && s.label != null ? s.label : o();
    }
    if ("value" in t) {
      const s = i.find((l) => l && l.value === t.value);
      if (s && s.label != null)
        return s.label;
    }
  }
  return o();
}
function gS(t, e, n) {
  return t.reduce((o, r, i) => (i > 0 && o.push(", "), o.push(/* @__PURE__ */ g(x.Fragment, {
    children: D0(r, e, n)
  }, i)), o), []);
}
const ft = {
  id: he((t) => t.id),
  labelId: he((t) => t.labelId),
  modal: he((t) => t.modal),
  multiple: he((t) => t.multiple),
  items: he((t) => t.items),
  itemToStringLabel: he((t) => t.itemToStringLabel),
  itemToStringValue: he((t) => t.itemToStringValue),
  isItemEqualToValue: he((t) => t.isItemEqualToValue),
  value: he((t) => t.value),
  hasSelectedValue: he((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : qn(e, o) !== "";
  }),
  hasNullItemLabel: he((t, e) => e ? O0(t.items) : !1),
  open: he((t) => t.open),
  mounted: he((t) => t.mounted),
  forceMount: he((t) => t.forceMount),
  transitionStatus: he((t) => t.transitionStatus),
  openMethod: he((t) => t.openMethod),
  activeIndex: he((t) => t.activeIndex),
  selectedIndex: he((t) => t.selectedIndex),
  isActive: he((t, e) => t.activeIndex === e),
  isSelected: he((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((i) => vo(n, i, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : vo(n, r, o);
  }),
  isSelectedByFocus: he((t, e) => t.selectedIndex === e),
  popupProps: he((t) => t.popupProps),
  triggerProps: he((t) => t.triggerProps),
  triggerElement: he((t) => t.triggerElement),
  positionerElement: he((t) => t.positionerElement),
  listElement: he((t) => t.listElement),
  scrollUpArrowVisible: he((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: he((t) => t.scrollDownArrowVisible),
  hasScrollArrows: he((t) => t.hasScrollArrows)
}, Eo = 1;
function _0(t, e) {
  return Math.max(0, t - e);
}
function hS(t, e) {
  if (e <= 0)
    return 0;
  const n = Zt(t, 0, e), o = n, r = e - n, i = o <= Eo, s = r <= Eo;
  return i && s ? o <= r ? 0 : e : i ? 0 : s ? e : n;
}
function V0(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: i,
    defaultOpen: s = !1,
    onOpenChange: l,
    name: a,
    form: c,
    autoComplete: u,
    disabled: d = !1,
    readOnly: f = !1,
    required: p = !1,
    modal: m = !0,
    actionsRef: h,
    inputRef: b,
    onOpenChangeComplete: v,
    items: C,
    multiple: y = !1,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S = P0,
    highlightItemOnHover: E = !0,
    children: N
  } = t, {
    clearErrors: I
  } = Fo(), {
    setDirty: M,
    setTouched: T,
    setFocused: k,
    shouldValidateOnChange: P,
    validityData: D,
    setFilled: O,
    name: V,
    disabled: _,
    validation: A,
    validationMode: L
  } = mn(), $ = _r({
    id: e
  }), B = _ || d, z = V ?? a, [H, K] = Sn({
    controlled: n,
    default: y ? o ?? Hn : o,
    name: "Select",
    state: "value"
  }), [G, q] = Sn({
    controlled: i,
    default: s,
    name: "Select",
    state: "open"
  }), Q = x.useRef([]), U = x.useRef([]), X = x.useRef(null), te = x.useRef(null), re = x.useRef(0), J = x.useRef(null), ie = x.useRef([]), ce = x.useRef(!1), oe = x.useRef(!1), se = x.useRef(null), me = x.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), pe = x.useRef(!1), {
    mounted: le,
    setMounted: ge,
    transitionStatus: j
  } = to(G), {
    openMethod: ee,
    triggerProps: Y
  } = Ns(G), Z = Lt(() => new Cd({
    id: $,
    labelId: void 0,
    modal: m,
    multiple: y,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S,
    value: H,
    open: G,
    mounted: le,
    transitionStatus: j,
    items: C,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, ue = ve(Z, ft.activeIndex), fe = ve(Z, ft.selectedIndex), be = ve(Z, ft.triggerElement), Ie = ve(Z, ft.positionerElement), ye = y7(ee), xe = ee ?? ye, de = x.useMemo(() => y && Array.isArray(H) && H.length === 0 ? "" : qn(H, R), [y, H, R]), Se = x.useMemo(() => y && Array.isArray(H) ? H.map((Ge) => qn(Ge, R)) : qn(H, R), [y, H, R]), Me = Yt(Z.state.triggerElement), Re = we(() => Se);
  vi(Me, {
    id: $,
    value: H,
    getValue: Re
  });
  const Ve = x.useRef(H);
  ke(() => {
    H !== Ve.current && Z.set("forceMount", !0);
  }, [Z, H]), ke(() => {
    O(y ? Array.isArray(H) && H.length > 0 : H != null);
  }, [y, H, O]), ke(function() {
    if (G)
      return;
    const Ke = ie.current;
    if (y) {
      const lt = Array.isArray(H) ? H : [];
      if (lt.length === 0) {
        Z.set("selectedIndex", null);
        return;
      }
      const pt = lt[lt.length - 1], ht = Do(Ke, pt, S);
      Z.set("selectedIndex", ht === -1 ? null : ht);
      return;
    }
    const Je = Do(Ke, H, S);
    Z.set("selectedIndex", Je === -1 ? null : Je);
  }, [y, G, H, ie, S, Z]), ko(H, () => {
    I(z), M(H !== D.initialValue), P() ? A.commit(H) : A.commit(H, !0);
  });
  const Ze = we((Ge, Ke) => {
    if (l?.(Ge, Ke), !Ke.isCanceled && (q(Ge), !Ge && (Ke.reason === _o || Ke.reason === us) && (T(!0), k(!1), L === "onBlur" && A.commit(H)), !Ge && Z.state.activeIndex !== null)) {
      const Je = Q.current[Z.state.activeIndex];
      queueMicrotask(() => {
        Je?.setAttribute("tabindex", "-1");
      });
    }
  }), Xe = we(() => {
    ge(!1), Z.update({
      activeIndex: null,
      openMethod: null
    }), v?.(!1);
  });
  Jt({
    enabled: !h,
    open: G,
    ref: X,
    onComplete() {
      G || Xe();
    }
  }), x.useImperativeHandle(h, () => ({
    unmount: Xe
  }), [Xe]);
  const Be = we((Ge, Ke) => {
    r?.(Ge, Ke), !Ke.isCanceled && K(Ge);
  }), Ne = we(() => {
    const Ge = Z.state.listElement || X.current;
    if (!Ge)
      return;
    const Ke = _0(Ge.scrollHeight, Ge.clientHeight), Je = hS(Ge.scrollTop, Ke), lt = Je > 0, pt = Je < Ke;
    Z.state.scrollUpArrowVisible !== lt && Z.set("scrollUpArrowVisible", lt), Z.state.scrollDownArrowVisible !== pt && Z.set("scrollDownArrowVisible", pt);
  }), _e = Sd({
    open: G,
    onOpenChange: Ze,
    elements: {
      reference: be,
      floating: Ie
    }
  }), Pe = Nr(_e, {
    enabled: !f && !B,
    event: "mousedown"
  }), $e = kr(_e, {
    bubbles: !1
  }), He = Nd(_e, {
    enabled: !f && !B,
    listRef: Q,
    activeIndex: ue,
    selectedIndex: fe,
    disabledIndices: Hn,
    onNavigate(Ge) {
      Ge === null && !G || Z.set("activeIndex", Ge);
    },
    focusItemOnHover: E
  }), Te = Id(_e, {
    enabled: !f && !B && (G || !y),
    listRef: U,
    activeIndex: ue,
    selectedIndex: fe,
    onMatch(Ge) {
      G ? Z.set("activeIndex", Ge) : Be(ie.current[Ge], De("none"));
    },
    onTypingChange(Ge) {
      ce.current = Ge;
    }
  }), {
    getReferenceProps: Rt,
    getFloatingProps: rt,
    getItemProps: Ce
  } = ro([Pe, $e, He, Te]), Ee = x.useMemo(() => cn(Rt(), Y, $ ? {
    id: $
  } : Et), [Rt, Y, $]);
  Or(() => {
    Z.update({
      popupProps: rt(),
      triggerProps: Ee
    });
  }), ke(() => {
    Z.update({
      id: $,
      modal: m,
      multiple: y,
      value: H,
      open: G,
      mounted: le,
      transitionStatus: j,
      popupProps: rt(),
      triggerProps: Ee,
      items: C,
      itemToStringLabel: w,
      itemToStringValue: R,
      isItemEqualToValue: S,
      openMethod: xe
    });
  }, [Z, $, m, y, H, G, le, j, rt, Ee, C, w, R, S, xe]);
  const Ae = x.useMemo(() => ({
    store: Z,
    name: z,
    required: p,
    disabled: B,
    readOnly: f,
    multiple: y,
    highlightItemOnHover: E,
    setValue: Be,
    setOpen: Ze,
    listRef: Q,
    popupRef: X,
    scrollHandlerRef: te,
    handleScrollArrowVisibility: Ne,
    scrollArrowsMountedCountRef: re,
    getItemProps: Ce,
    events: _e.context.events,
    valueRef: J,
    valuesRef: ie,
    labelsRef: U,
    typingRef: ce,
    selectionRef: me,
    selectedItemTextRef: se,
    validation: A,
    onOpenChangeComplete: v,
    keyboardActiveRef: oe,
    alignItemWithTriggerActiveRef: pe,
    initialValueRef: Ve
  }), [Z, z, p, B, f, y, E, Be, Ze, Ce, _e.context.events, A, v, Ne]), ze = Rn(b, A.inputRef), it = y && Array.isArray(H) && H.length > 0, Ye = y ? void 0 : z, Qe = x.useMemo(() => !y || !Array.isArray(H) || !z ? null : H.map((Ge) => {
    const Ke = qn(Ge, R);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: c,
      name: z,
      value: Ke
    }, Ke);
  }), [y, H, c, z, R]);
  return /* @__PURE__ */ g(Ef.Provider, {
    value: Ae,
    children: /* @__PURE__ */ F(Nf.Provider, {
      value: _e,
      children: [N, /* @__PURE__ */ g("input", {
        ...A.getInputValidationProps({
          onFocus() {
            Z.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ge) {
            if (Ge.nativeEvent.defaultPrevented)
              return;
            const Ke = Ge.currentTarget.value, Je = De(At, Ge.nativeEvent);
            function lt() {
              if (y)
                return;
              const pt = ie.current.find((ht) => qn(ht, R).toLowerCase() === Ke.toLowerCase() || fn(ht, w).toLowerCase() === Ke.toLowerCase());
              pt != null && (M(pt !== D.initialValue), Be(pt, Je), P() && A.commit(pt));
            }
            Z.set("forceMount", !0), queueMicrotask(lt);
          }
        }),
        id: $ && Ye == null ? `${$}-hidden-input` : void 0,
        form: c,
        name: Ye,
        autoComplete: u,
        value: de,
        disabled: B,
        required: p && !it,
        readOnly: f,
        ref: ze,
        style: z ? ii : nr,
        tabIndex: -1,
        "aria-hidden": !0,
        suppressHydrationWarning: !0
      }), Qe]
    })
  });
}
function If(t, e) {
  return t ?? e;
}
const ul = 2, bS = 400, Rm = 200, vS = {
  ...qi,
  ...io,
  value: () => null
}, Pf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    disabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    setTouched: u,
    setFocused: d,
    validationMode: f,
    state: p,
    disabled: m
  } = mn(), {
    labelId: h
  } = Nn(), {
    store: b,
    setOpen: v,
    selectionRef: C,
    validation: y,
    readOnly: w,
    required: R,
    alignItemWithTriggerActiveRef: S,
    disabled: E,
    keyboardActiveRef: N
  } = $o(), I = m || E || s, M = ve(b, ft.open), T = ve(b, ft.value), k = ve(b, ft.triggerProps), P = ve(b, ft.positionerElement), D = ve(b, ft.listElement), O = ve(b, ft.id), V = ve(b, ft.labelId), _ = ve(b, ft.hasSelectedValue), A = !_ && M, L = ve(b, ft.hasNullItemLabel, A), $ = i ?? O, B = If(h, V);
  _r({
    id: $
  });
  const z = Yt(P), H = x.useRef(null), {
    getButtonProps: K,
    buttonRef: G
  } = qt({
    disabled: I,
    native: l
  }), q = we((oe) => {
    b.set("triggerElement", oe);
  }), Q = Rn(n, H, G, q), U = Bt(), X = Bt(), te = Bt(), re = Bt();
  x.useEffect(() => {
    if (M)
      return !(_ || L) ? te.start(bS, () => {
        C.current.allowUnselectedMouseUp = !0, C.current.allowSelectedMouseUp = !0;
      }) : re.start(Rm, () => {
        C.current.allowUnselectedMouseUp = !0, te.start(Rm, () => {
          C.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        te.clear(), re.clear();
      };
    C.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, X.clear();
  }, [M, _, L, C, X, te, re]);
  const J = x.useMemo(() => D?.id ?? Xi(P)?.id, [D, P]), ie = cn(k, {
    id: $,
    role: "combobox",
    "aria-expanded": M ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": M ? J : void 0,
    "aria-labelledby": B,
    "aria-readonly": w || void 0,
    "aria-required": R || void 0,
    tabIndex: I ? -1 : 0,
    ref: Q,
    onFocus(oe) {
      d(!0), M && S.current && v(!1, De(At, oe.nativeEvent)), U.start(0, () => {
        b.set("forceMount", !0);
      });
    },
    onBlur(oe) {
      Fe(P, oe.relatedTarget) || (u(!0), d(!1), f === "onBlur" && y.commit(T));
    },
    onPointerMove() {
      N.current = !1;
    },
    onKeyDown() {
      N.current = !0;
    },
    onMouseDown(oe) {
      if (M)
        return;
      const se = nt(oe.currentTarget);
      function me(pe) {
        if (!H.current)
          return;
        const le = pe.target;
        if (Fe(H.current, le) || Fe(z.current, le) || le === H.current)
          return;
        const ge = Vd(H.current);
        pe.clientX >= ge.left - ul && pe.clientX <= ge.right + ul && pe.clientY >= ge.top - ul && pe.clientY <= ge.bottom + ul || v(!1, De(ih, pe));
      }
      X.start(0, () => {
        se.addEventListener("mouseup", me, {
          once: !0
        });
      });
    }
  }, y.getValidationProps, c, K);
  ie.role = "combobox";
  const ce = {
    ...p,
    open: M,
    disabled: I,
    value: T,
    readOnly: w,
    placeholder: !_
  };
  return Le("button", e, {
    ref: [n, H],
    state: ce,
    stateAttributesMapping: vS,
    props: ie
  });
});
process.env.NODE_ENV !== "production" && (Pf.displayName = "SelectTrigger");
const yS = {
  value: () => null
}, A0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    placeholder: s,
    style: l,
    ...a
  } = e, {
    store: c,
    valueRef: u
  } = $o(), d = ve(c, ft.value), f = ve(c, ft.items), p = ve(c, ft.itemToStringLabel), m = ve(c, ft.hasSelectedValue), h = !m && s != null && i == null, b = ve(c, ft.hasNullItemLabel, h), v = {
    value: d,
    placeholder: !m
  };
  let C = null;
  return typeof i == "function" ? C = i(d) : i != null ? C = i : !m && s != null && !b ? C = s : Array.isArray(d) ? C = gS(d, f, p) : C = D0(d, f, p), Le("span", e, {
    state: v,
    ref: [n, u],
    props: [{
      children: C
    }, a],
    stateAttributesMapping: yS
  });
});
process.env.NODE_ENV !== "production" && (A0.displayName = "SelectValue");
const L0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l
  } = $o(), c = {
    open: ve(l, ft.open)
  };
  return Le("span", e, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, s],
    stateAttributesMapping: Sr
  });
});
process.env.NODE_ENV !== "production" && (L0.displayName = "SelectIcon");
const F0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (F0.displayName = "SelectPortalContext");
const Mf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    store: o
  } = $o(), r = ve(o, ft.mounted), i = ve(o, ft.forceMount);
  return r || i ? /* @__PURE__ */ g(F0.Provider, {
    value: !0,
    children: /* @__PURE__ */ g(si, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Mf.displayName = "SelectPortal");
const Tf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Tf.displayName = "SelectPositionerContext");
function $0() {
  const t = x.useContext(Tf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : st(59));
  return t;
}
function ea(t, e) {
  t && Object.assign(t.style, e);
}
const H0 = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, xS = {
  position: "fixed"
}, Of = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h,
    alignItemWithTrigger: b = !0,
    collisionAvoidance: v = cd,
    style: C,
    ...y
  } = e, {
    store: w,
    listRef: R,
    labelsRef: S,
    alignItemWithTriggerActiveRef: E,
    selectedItemTextRef: N,
    valuesRef: I,
    initialValueRef: M,
    popupRef: T,
    setValue: k
  } = $o(), P = I0(), D = ve(w, ft.open), O = ve(w, ft.mounted), V = ve(w, ft.modal), _ = ve(w, ft.value), A = ve(w, ft.openMethod), L = ve(w, ft.positionerElement), $ = ve(w, ft.triggerElement), B = ve(w, ft.isItemEqualToValue), z = ve(w, ft.transitionStatus), H = x.useRef(null), K = x.useRef(null), [G, q] = x.useState(b), Q = O && G && A !== "touch";
  !O && G !== b && q(b), ke(() => {
    O || (ft.scrollUpArrowVisible(w.state) && w.set("scrollUpArrowVisible", !1), ft.scrollDownArrowVisible(w.state) && w.set("scrollDownArrowVisible", !1));
  }, [w, O]), x.useImperativeHandle(E, () => Q), Sa((Q || V) && D, A === "touch", L, $);
  const U = ai({
    anchor: o,
    floatingRootContext: P,
    positionMethod: r,
    mounted: O,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h ?? Q,
    collisionAvoidance: v,
    keepMounted: !0
  }), X = Q ? "none" : U.side, te = Q ? xS : U.positionerStyles, re = {
    open: D,
    side: X,
    align: U.align,
    anchorHidden: U.anchorHidden
  }, J = we((me) => {
    w.set("positionerElement", me);
  }), ie = di(e, re, {
    styles: te,
    transitionStatus: z,
    props: y,
    refs: [n, J],
    hidden: !O,
    inert: !D
  }), ce = x.useRef(0), oe = we((me) => {
    if (me.size === 0 && ce.current === 0 || I.current.length === 0)
      return;
    const pe = ce.current;
    if (ce.current = me.size, me.size === pe)
      return;
    const le = De(At);
    if (pe !== 0 && !w.state.multiple && _ !== null && Do(I.current, _, B) === -1) {
      const j = M.current, Y = j != null && Do(I.current, j, B) !== -1 ? j : null;
      k(Y, le), Y === null && (w.set("selectedIndex", null), N.current = null);
    }
    if (pe !== 0 && w.state.multiple && Array.isArray(_)) {
      const ge = (ee) => Do(I.current, ee, B) !== -1, j = _.filter((ee) => ge(ee));
      (j.length !== _.length || j.some((ee) => !M0(_, ee, B))) && (k(j, le), j.length === 0 && (w.set("selectedIndex", null), N.current = null));
    }
    if (D && Q) {
      w.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const ge = {
        height: ""
      };
      ea(L, ge), ea(T.current, ge);
    }
  }), se = x.useMemo(() => ({
    ...U,
    side: X,
    alignItemWithTriggerActive: Q,
    setControlledAlignItemWithTrigger: q,
    scrollUpArrowRef: H,
    scrollDownArrowRef: K
  }), [U, X, Q, q]);
  return /* @__PURE__ */ g(ci, {
    elementsRef: R,
    labelsRef: S,
    onMapChange: oe,
    children: /* @__PURE__ */ F(Tf.Provider, {
      value: se,
      children: [O && V && /* @__PURE__ */ g(ui, {
        inert: Tr(!D),
        cutout: $
      }), ie]
    })
  });
});
process.env.NODE_ENV !== "production" && (Of.displayName = "SelectPositioner");
const dl = "base-ui-disable-scrollbar", ta = {
  className: dl,
  getElement(t) {
    return /* @__PURE__ */ g("style", {
      nonce: t,
      href: dl,
      precedence: "base-ui:low",
      children: `.${dl}{scrollbar-width:none}.${dl}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (ta.getElement.displayName = "styleDisableScrollbar.getElement");
const z0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (z0.displayName = "CSPContext");
const CS = {
  disableStyleElements: !1
};
function wS() {
  return x.useContext(z0) ?? CS;
}
const SS = {
  ...An,
  ...Kt
}, Df = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a,
    popupRef: c,
    onOpenChangeComplete: u,
    setOpen: d,
    valueRef: f,
    selectedItemTextRef: p,
    keyboardActiveRef: m,
    multiple: h,
    handleScrollArrowVisibility: b,
    scrollHandlerRef: v,
    listRef: C,
    highlightItemOnHover: y
  } = $o(), {
    side: w,
    align: R,
    alignItemWithTriggerActive: S,
    isPositioned: E,
    setControlledAlignItemWithTrigger: N,
    scrollDownArrowRef: I,
    scrollUpArrowRef: M
  } = $0(), T = Pd() != null, k = I0(), P = Es(), {
    nonce: D,
    disableStyleElements: O
  } = wS(), V = ve(a, ft.id), _ = ve(a, ft.open), A = ve(a, ft.mounted), L = ve(a, ft.popupProps), $ = ve(a, ft.transitionStatus), B = ve(a, ft.triggerElement), z = ve(a, ft.positionerElement), H = ve(a, ft.listElement), K = x.useRef(!1), G = x.useRef(!1), q = x.useRef({}), Q = ri(), U = we((J) => {
    if (!z || !c.current || !G.current)
      return;
    if (K.current || !S) {
      b();
      return;
    }
    const ie = z.style.top === "0px", ce = z.style.bottom === "0px";
    if (!ie && !ce) {
      b();
      return;
    }
    const oe = Nm(z), se = $i(z.getBoundingClientRect().height, "y", oe), me = nt(z), pe = getComputedStyle(z), le = parseFloat(pe.marginTop), ge = parseFloat(pe.marginBottom), j = Em(getComputedStyle(c.current)), ee = Math.min(me.documentElement.clientHeight - le - ge, j), Y = J.scrollTop, Z = fl(J);
    let ue = 0, fe = null, be = !1, Ie = !1;
    const ye = (Me) => {
      z.style.height = `${Me}px`;
    }, xe = (Me, Re) => {
      const Ve = Zt(Me, 0, ee - se);
      Ve > 0 && ye(se + Ve), J.scrollTop = Re, ee - (se + Ve) <= Eo && (K.current = !0), b();
    }, de = ie ? Z - Y : Y, Se = Math.min(se + de, ee);
    if (ue = Se, de <= Eo) {
      xe(de, ie ? Z : 0);
      return;
    }
    if (ee - Se > Eo)
      ie ? Ie = !0 : fe = 0;
    else if (be = !0, ce && Y < Z) {
      const Me = se + de - ee;
      fe = Y - (de - Me);
    }
    if (ue = Math.ceil(ue), ue !== 0 && ye(ue), Ie || fe != null) {
      const Me = fl(J), Re = Ie ? Me : Zt(fe, 0, Me);
      Math.abs(J.scrollTop - Re) > Eo && (J.scrollTop = Re);
    }
    (be || ue >= ee - Eo) && (K.current = !0), b();
  });
  x.useImperativeHandle(v, () => U, [U]), Jt({
    open: _,
    ref: c,
    onComplete() {
      _ && u?.(!0);
    }
  });
  const X = {
    open: _,
    transitionStatus: $,
    side: w,
    align: R
  };
  ke(() => {
    !z || !c.current || Object.keys(q.current).length || (q.current = {
      top: z.style.top || "0",
      left: z.style.left || "0",
      right: z.style.right,
      height: z.style.height,
      bottom: z.style.bottom,
      minHeight: z.style.minHeight,
      maxHeight: z.style.maxHeight,
      marginTop: z.style.marginTop,
      marginBottom: z.style.marginBottom
    });
  }, [c, z]), ke(() => {
    _ || S || (G.current = !1, K.current = !1, ea(z, q.current));
  }, [_, S, z, c]), ke(() => {
    const J = c.current;
    if (!_ || !B || !z || !J || S && !E || a.state.transitionStatus === "ending")
      return;
    if (!S) {
      G.current = !0, Q.request(b), J.style.removeProperty("--transform-origin");
      return;
    }
    const ie = RS(J);
    J.style.removeProperty("--transform-origin");
    try {
      const ce = p.current, oe = f.current, se = getComputedStyle(z), me = getComputedStyle(J), pe = nt(B), le = St(z), ge = Nm(B), j = pl(B.getBoundingClientRect(), ge), ee = pl(z.getBoundingClientRect(), ge), Y = j.height, Z = H || J, ue = Z.scrollHeight, fe = parseFloat(me.borderBottomWidth), be = parseFloat(se.marginTop) || 10, Ie = parseFloat(se.marginBottom) || 10, ye = parseFloat(se.minHeight) || 100, xe = Em(me), de = 5, Se = 5, Me = 20, Re = pe.documentElement.clientHeight - be - Ie, Ve = pe.documentElement.clientWidth, Ze = Re - j.bottom + Y;
      let Xe, Be = P === "rtl" ? j.right - ee.width : j.left, Ne = 0;
      if (ce && oe) {
        const ze = pl(oe.getBoundingClientRect(), ge);
        Xe = pl(ce.getBoundingClientRect(), ge), Be = ee.left + (P === "rtl" ? ze.right - Xe.right : ze.left - Xe.left);
        const it = ze.top - j.top + ze.height / 2;
        Ne = Xe.top - ee.top + Xe.height / 2 - it;
      }
      const _e = Ze + Ne + Ie + fe;
      let Pe = Math.min(Re, _e);
      const $e = Re - be - Ie, He = _e - Pe, Te = Ve - Se;
      z.style.left = `${Zt(Be, de, Te - ee.width)}px`, z.style.height = `${Pe}px`, z.style.maxHeight = "auto", z.style.marginTop = `${be}px`, z.style.marginBottom = `${Ie}px`, J.style.height = "100%";
      const Rt = fl(Z), rt = He >= Rt - Eo;
      rt && (Pe = Math.min(Re, ee.height) - (He - Rt));
      const Ce = j.top < Me || j.bottom > Re - Me || Math.ceil(Pe) + Eo < Math.min(ue, ye), Ee = (le.visualViewport?.scale ?? 1) !== 1 && qu;
      if (Ce || Ee) {
        G.current = !0, ea(z, q.current), N(!1);
        return;
      }
      const Ae = Math.max(ye, Pe);
      if (rt) {
        const ze = Math.max(0, Re - _e);
        z.style.top = ee.height >= $e ? "0" : `${ze}px`, z.style.height = `${Pe}px`, Z.scrollTop = fl(Z);
      } else
        z.style.bottom = "0", Z.scrollTop = He;
      if (Xe) {
        const ze = ee.top, it = ee.height, Ye = Xe.top + Xe.height / 2, Qe = it > 0 ? (Ye - ze) / it * 100 : 50, Ge = Zt(Qe, 0, 100);
        J.style.setProperty("--transform-origin", `50% ${Ge}%`);
      }
      (Ae === Re || Pe >= xe) && (K.current = !0), b(), y && a.state.selectedIndex === null && a.state.activeIndex === null && C.current[0] != null && a.set("activeIndex", 0), G.current = !0;
    } finally {
      ie();
    }
  }, [a, _, z, B, f, p, c, b, S, N, Q, I, M, H, C, y, P, E]), x.useEffect(() => {
    if (!S || !z || !_)
      return;
    const J = St(z);
    function ie(ce) {
      d(!1, De(b8, ce));
    }
    return dt(J, "resize", ie);
  }, [d, S, z, _]);
  const te = {
    ...H ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": h || void 0,
      id: `${V}-list`
    },
    onKeyDown(J) {
      m.current = !0, T && Rs.has(J.key) && J.stopPropagation();
    },
    onMouseMove() {
      m.current = !1;
    },
    onScroll(J) {
      H || U(J.currentTarget);
    },
    ...S && {
      style: H ? {
        height: "100%"
      } : H0
    }
  }, re = Le("div", e, {
    ref: [n, c],
    state: X,
    stateAttributesMapping: SS,
    props: [L, te, Mr($), {
      className: !H && S ? ta.className : void 0
    }, l]
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!O && ta.getElement(D), /* @__PURE__ */ g(li, {
      context: k,
      modal: !1,
      disabled: !A,
      returnFocus: s,
      restoreFocus: !0,
      children: re
    })]
  });
});
process.env.NODE_ENV !== "production" && (Df.displayName = "SelectPopup");
function Em(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
function fl(t) {
  return _0(t.scrollHeight, t.clientHeight);
}
function Nm(t) {
  return qh.getScale(t);
}
function $i(t, e, n) {
  return t / n[e];
}
function pl(t, e) {
  return Qi({
    x: $i(t.x, "x", e),
    y: $i(t.y, "y", e),
    width: $i(t.width, "x", e),
    height: $i(t.height, "y", e)
  });
}
const km = [["transform", "none"], ["scale", "1"], ["translate", "0 0"]];
function RS(t) {
  const {
    style: e
  } = t, n = {};
  for (const [o, r] of km)
    n[o] = e.getPropertyValue(o), e.setProperty(o, r, "important");
  return () => {
    for (const [o] of km) {
      const r = n[o];
      r ? e.setProperty(o, r) : e.removeProperty(o);
    }
  };
}
const _f = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l,
    scrollHandlerRef: a
  } = $o(), {
    alignItemWithTriggerActive: c
  } = $0(), u = ve(l, ft.hasScrollArrows), d = ve(l, ft.openMethod), f = ve(l, ft.multiple), m = {
    id: `${ve(l, ft.id)}-list`,
    role: "listbox",
    "aria-multiselectable": f || void 0,
    onScroll(b) {
      a.current?.(b.currentTarget);
    },
    ...c && {
      style: H0
    },
    className: u && d !== "touch" ? ta.className : void 0
  }, h = we((b) => {
    l.set("listElement", b);
  });
  return Le("div", e, {
    ref: [n, h],
    props: [m, s]
  });
});
process.env.NODE_ENV !== "production" && (_f.displayName = "SelectList");
const Vf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vf.displayName = "SelectItemContext");
function Af() {
  const t = x.useContext(Vf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : st(57));
  return t;
}
const Lf = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    label: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(null), f = Ao({
    label: s,
    textRef: d,
    indexGuessBehavior: Ju.GuessFromOrder
  }), {
    store: p,
    getItemProps: m,
    setOpen: h,
    setValue: b,
    selectionRef: v,
    typingRef: C,
    valuesRef: y,
    multiple: w,
    selectedItemTextRef: R
  } = $o(), S = ve(p, ft.isActive, f.index), E = ve(p, ft.isSelected, f.index, i), N = ve(p, ft.isSelectedByFocus, f.index), I = ve(p, ft.isItemEqualToValue), M = f.index, T = M !== -1, k = x.useRef(null), P = Yt(M);
  ke(() => {
    if (!T)
      return;
    const G = y.current;
    return G[M] = i, () => {
      delete G[M];
    };
  }, [T, M, i, y]), ke(() => {
    if (!T)
      return;
    const G = p.state.value;
    let q = G;
    w && Array.isArray(G) && G.length > 0 && (q = G[G.length - 1]), q !== void 0 && vo(i, q, I) && (p.set("selectedIndex", M), d.current && (R.current = d.current));
  }, [T, M, w, I, p, i, R]);
  const D = {
    disabled: l,
    selected: E,
    highlighted: S
  }, O = m({
    active: S,
    selected: E
  });
  O.id = void 0;
  const V = x.useRef(null), _ = x.useRef("mouse"), A = x.useRef(!1), {
    getButtonProps: L,
    buttonRef: $
  } = qt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function B(G) {
    const q = p.state.value;
    if (w) {
      const Q = Array.isArray(q) ? q : [], U = E ? T0(Q, i, I) : [...Q, i];
      b(U, De(Yo, G));
    } else
      b(i, De(Yo, G)), h(!1, De(Yo, G));
  }
  const z = {
    role: "option",
    "aria-selected": E,
    tabIndex: S ? 0 : -1,
    onTouchStart() {
      v.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(G) {
      V.current = G.key, p.set("activeIndex", M), G.key === " " && C.current && G.preventDefault();
    },
    onClick(G) {
      A.current = !1, !(G.type === "keydown" && V.current === null) && (l || G.type === "keydown" && V.current === " " && C.current || _.current !== "touch" && !S || (V.current = null, B(G.nativeEvent)));
    },
    onPointerEnter(G) {
      _.current = G.pointerType;
    },
    onPointerDown(G) {
      _.current = G.pointerType, A.current = !0;
    },
    onMouseUp() {
      if (l)
        return;
      if (A.current) {
        A.current = !1;
        return;
      }
      const G = !v.current.allowSelectedMouseUp && E, q = !v.current.allowUnselectedMouseUp && !E;
      G || q || _.current !== "touch" && !S || k.current?.click();
    }
  }, H = Le("div", e, {
    ref: [$, n, f.ref, k],
    state: D,
    props: [O, z, u, L]
  }), K = x.useMemo(() => ({
    selected: E,
    indexRef: P,
    textRef: d,
    selectedByFocus: N,
    hasRegistered: T
  }), [E, P, d, N, T]);
  return /* @__PURE__ */ g(Vf.Provider, {
    value: K,
    children: H
  });
}));
process.env.NODE_ENV !== "production" && (Lf.displayName = "SelectItem");
const B0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Af();
  return o || r ? /* @__PURE__ */ g(W0, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (B0.displayName = "SelectItemIndicator");
const W0 = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    style: r,
    keepMounted: i,
    ...s
  } = t, {
    selected: l
  } = Af(), a = x.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = to(l), f = Le("span", t, {
    ref: [e, a],
    state: {
      selected: l,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, s],
    stateAttributesMapping: Kt
  });
  return Jt({
    open: l,
    ref: a,
    onComplete() {
      l || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (W0.displayName = "Inner");
const Ff = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: i,
    hasRegistered: s
  } = Af(), {
    selectedItemTextRef: l
  } = $o(), {
    className: a,
    render: c,
    style: u,
    ...d
  } = e, f = x.useCallback((m) => {
    if (!m || !s)
      return;
    const h = l.current === null || !l.current.isConnected;
    (i || h && o.current === 0) && (l.current = m);
  }, [l, o, i, s]);
  return Le("div", e, {
    ref: [f, n, r],
    props: d
  });
}));
process.env.NODE_ENV !== "production" && (Ff.displayName = "SelectItemText");
function ES(t) {
  const e = W.c(54), {
    id: n,
    options: o,
    value: r,
    selectedOption: i,
    onValueChange: s,
    open: l,
    onOpenChange: a,
    disabled: c,
    readOnly: u,
    required: d,
    name: f,
    placeholder: p,
    label: m,
    "data-testid": h,
    renderValue: b,
    renderOption: v,
    popupWidth: C,
    triggerClassName: y
  } = t, w = en(), R = m || n ? void 0 : u ? "Select option" : p ?? "Select option", S = d || void 0, E = u || void 0, N = u ? -1 : void 0, I = !i && !b && "text-input-text-placeholder";
  let M;
  e[0] !== I ? (M = ne("min-w-0 flex-1 truncate text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", I), e[0] = I, e[1] = M) : M = e[1];
  let T;
  e[2] !== p || e[3] !== u || e[4] !== b || e[5] !== i ? (T = b ? b(i) : i?.label ?? (u ? null : p), e[2] = p, e[3] = u, e[4] = b, e[5] = i, e[6] = T) : T = e[6];
  let k;
  e[7] !== M || e[8] !== T ? (k = /* @__PURE__ */ g("span", { className: M, children: T }), e[7] = M, e[8] = T, e[9] = k) : k = e[9];
  let P;
  e[10] !== h || e[11] !== u ? (P = !u && /* @__PURE__ */ g("span", { "data-testid": h ? `${h}-trigger` : void 0, className: "inline-flex shrink-0", children: /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[10] = h, e[11] = u, e[12] = P) : P = e[12];
  let D;
  e[13] !== h || e[14] !== n || e[15] !== R || e[16] !== S || e[17] !== E || e[18] !== N || e[19] !== k || e[20] !== P || e[21] !== y ? (D = /* @__PURE__ */ F(Pf, { id: n, "data-testid": h, className: y, "aria-label": R, "aria-required": S, "aria-readonly": E, tabIndex: N, children: [
    k,
    P
  ] }), e[13] = h, e[14] = n, e[15] = R, e[16] = S, e[17] = E, e[18] = N, e[19] = k, e[20] = P, e[21] = y, e[22] = D) : D = e[22];
  const O = C === "content" ? "w-auto min-w-(--anchor-width)" : "w-(--anchor-width) min-w-[180px]";
  let V;
  e[23] !== O ? (V = ne("z-[var(--z-layer-popover)] max-w-[calc(100vw-var(--spacing-16))]", O), e[23] = O, e[24] = V) : V = e[24];
  let _;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = pi({
    size: "auto"
  }), e[25] = _) : _ = e[25];
  const A = h ? `${h}-options` : void 0;
  let L;
  if (e[26] !== o || e[27] !== v || e[28] !== r) {
    let K;
    e[30] !== v || e[31] !== r ? (K = (G) => /* @__PURE__ */ F(Lf, { value: G.value, disabled: G.disabled, className: bo({}), children: [
      G.icon && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ue, { name: G.icon, size: "xs", tone: "inherit" }) }),
      /* @__PURE__ */ g(xr, { checked: G.value === r, children: /* @__PURE__ */ g(Ff, { children: v ? v(G) : G.label }) })
    ] }, G.value), e[30] = v, e[31] = r, e[32] = K) : K = e[32], L = o.map(K), e[26] = o, e[27] = v, e[28] = r, e[29] = L;
  } else
    L = e[29];
  let $;
  e[33] !== A || e[34] !== L ? ($ = /* @__PURE__ */ g(Df, { className: _, children: /* @__PURE__ */ g(_f, { "data-testid": A, className: "flex flex-col outline-none", children: L }) }), e[33] = A, e[34] = L, e[35] = $) : $ = e[35];
  let B;
  e[36] !== V || e[37] !== $ ? (B = /* @__PURE__ */ g(Of, { alignItemWithTrigger: !1, sideOffset: 4, className: V, children: $ }), e[36] = V, e[37] = $, e[38] = B) : B = e[38];
  let z;
  e[39] !== w || e[40] !== B ? (z = /* @__PURE__ */ g(Mf, { container: w, children: B }), e[39] = w, e[40] = B, e[41] = z) : z = e[41];
  let H;
  return e[42] !== c || e[43] !== f || e[44] !== a || e[45] !== s || e[46] !== l || e[47] !== o || e[48] !== u || e[49] !== d || e[50] !== D || e[51] !== z || e[52] !== r ? (H = /* @__PURE__ */ F(V0, { value: r, onValueChange: s, open: l, onOpenChange: a, disabled: c, readOnly: u, required: d, name: f, items: o, modal: !1, children: [
    D,
    z
  ] }), e[42] = c, e[43] = f, e[44] = a, e[45] = s, e[46] = l, e[47] = o, e[48] = u, e[49] = d, e[50] = D, e[51] = z, e[52] = r, e[53] = H) : H = e[53], H;
}
const $f = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && ($f.displayName = "ComboboxRootContext");
const Hf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hf.displayName = "ComboboxFloatingContext");
const zf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zf.displayName = "ComboboxDerivedItemsContext");
const Bf = /* @__PURE__ */ x.createContext("");
process.env.NODE_ENV !== "production" && (Bf.displayName = "ComboboxInputValueContext");
function Tn() {
  const t = x.useContext($f);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : st(22));
  return t;
}
function Oa() {
  const t = x.useContext(Hf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : st(23));
  return t;
}
function wo() {
  const t = x.useContext(zf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : st(24));
  return t;
}
function Wf() {
  return x.useContext(Bf);
}
const Oe = {
  id: he((t) => t.id),
  labelId: he((t) => t.labelId),
  items: he((t) => t.items),
  selectedValue: he((t) => t.selectedValue),
  hasSelectionChips: he((t) => {
    const e = t.selectedValue;
    return Array.isArray(e) && e.length > 0;
  }),
  hasSelectedValue: he((t) => {
    const {
      selectedValue: e,
      selectionMode: n
    } = t;
    return e == null ? !1 : n === "multiple" && Array.isArray(e) ? e.length > 0 : !0;
  }),
  hasNullItemLabel: he((t, e) => e ? O0(t.items) : !1),
  open: he((t) => t.open),
  mounted: he((t) => t.mounted),
  forceMounted: he((t) => t.forceMounted),
  inline: he((t) => t.inline),
  activeIndex: he((t) => t.activeIndex),
  selectedIndex: he((t) => t.selectedIndex),
  isActive: he((t, e) => t.activeIndex === e),
  isSelected: he((t, e) => {
    const n = t.isItemEqualToValue, o = t.selectedValue;
    return Array.isArray(o) ? o.some((r) => vo(e, r, n)) : vo(e, o, n);
  }),
  transitionStatus: he((t) => t.transitionStatus),
  popupProps: he((t) => t.popupProps),
  inputProps: he((t) => t.inputProps),
  triggerProps: he((t) => t.triggerProps),
  getItemProps: he((t) => t.getItemProps),
  positionerElement: he((t) => t.positionerElement),
  listElement: he((t) => t.listElement),
  triggerElement: he((t) => t.triggerElement),
  inputElement: he((t) => t.inputElement),
  inputGroupElement: he((t) => t.inputGroupElement),
  popupSide: he((t) => t.popupSide),
  openMethod: he((t) => t.openMethod),
  inputInsidePopup: he((t) => t.inputInsidePopup),
  selectionMode: he((t) => t.selectionMode),
  name: he((t) => t.name),
  form: he((t) => t.form),
  disabled: he((t) => t.disabled),
  readOnly: he((t) => t.readOnly),
  required: he((t) => t.required),
  grid: he((t) => t.grid),
  virtualized: he((t) => t.virtualized),
  itemToStringLabel: he((t) => t.itemToStringLabel),
  isItemEqualToValue: he((t) => t.isItemEqualToValue),
  modal: he((t) => t.modal),
  autoHighlight: he((t) => t.autoHighlight),
  submitOnItemClick: he((t) => t.submitOnItemClick)
};
function NS(t, e) {
  return (n, o) => {
    if (n == null)
      return !1;
    const r = fn(n, e);
    return t.contains(r, o);
  };
}
function kS(t, e, n) {
  return (o, r) => {
    if (o == null)
      return !1;
    if (!r)
      return !0;
    const i = fn(o, e), s = n != null ? fn(n, e) : "";
    return s && t.contains(s, r) && s.length === r.length ? !0 : t.contains(i, r);
  };
}
const Im = /* @__PURE__ */ new Map();
function IS(t = {}) {
  const e = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...t
  }, n = `${U0(t.locale)}|${JSON.stringify(e)}`, o = Im.get(n);
  if (o)
    return o;
  const r = new Intl.Collator(t.locale, e), i = {
    contains(s, l, a) {
      if (!l)
        return !0;
      const c = fn(s, a);
      for (let u = 0; u <= c.length - l.length; u += 1)
        if (r.compare(c.slice(u, u + l.length), l) === 0)
          return !0;
      return !1;
    },
    startsWith(s, l, a) {
      if (!l)
        return !0;
      const c = fn(s, a);
      return r.compare(c.slice(0, l.length), l) === 0;
    },
    endsWith(s, l, a) {
      if (!l)
        return !0;
      const c = fn(s, a), u = l.length;
      return c.length >= u && r.compare(c.slice(c.length - u), l) === 0;
    }
  };
  return Im.set(n, i), i;
}
function U0(t) {
  return Array.isArray(t) ? t.map((e) => U0(e)).join(",") : t == null ? "" : String(t);
}
const G0 = IS, Y0 = /* @__PURE__ */ Symbol("none"), cr = {
  value: Y0,
  index: -1
};
function j0(t) {
  const {
    id: e,
    onOpenChangeComplete: n,
    defaultSelectedValue: o = null,
    selectedValue: r,
    onSelectedValueChange: i,
    defaultInputValue: s,
    inputValue: l,
    open: a,
    defaultOpen: c = !1,
    selectionMode: u = "none",
    onItemHighlighted: d,
    name: f,
    form: p,
    disabled: m = !1,
    readOnly: h = !1,
    required: b = !1,
    inputRef: v,
    grid: C = !1,
    items: y,
    filteredItems: w,
    filter: R,
    openOnInputClick: S = !0,
    autoHighlight: E = !1,
    keepHighlight: N = !1,
    highlightItemOnHover: I = !0,
    loopFocus: M = !0,
    itemToStringLabel: T,
    itemToStringValue: k,
    isItemEqualToValue: P = P0,
    virtualized: D = !1,
    inline: O = !1,
    fillInputOnItemPress: V = !0,
    modal: _ = !1,
    limit: A = -1,
    autoComplete: L = "list",
    formAutoComplete: $,
    locale: B,
    submitOnItemClick: z = !1
  } = t, {
    clearErrors: H
  } = Fo(), {
    setDirty: K,
    validityData: G,
    shouldValidateOnChange: q,
    setFilled: Q,
    name: U,
    disabled: X,
    setTouched: te,
    setFocused: re,
    validationMode: J,
    validation: ie
  } = mn(), ce = _r({
    id: e
  }), oe = G0({
    locale: B
  }), [se, me] = x.useState(!1), [pe, le] = x.useState(null), ge = x.useRef([]), j = x.useRef([]), ee = x.useRef(null), Y = x.useRef(null), Z = x.useRef(null), ue = x.useRef(null), fe = x.useRef(null), be = x.useRef(!0), Ie = x.useRef(!1), ye = x.useRef(null), xe = x.useRef(null), de = x.useRef(null), Se = x.useRef(cr), Me = x.useRef(null), Re = x.useRef([]), Ve = x.useRef([]), Ze = X || m, Xe = U ?? f, Be = u === "multiple", Ne = u === "single", _e = l !== void 0 || s !== void 0, Pe = y !== void 0, $e = w !== void 0;
  let He;
  E === "always" ? He = "always" : He = E ? "input-change" : !1;
  const [Te, Rt] = Sn({
    controlled: r,
    default: Be ? o ?? Hn : o,
    name: "Combobox",
    state: "selectedValue"
  }), rt = x.useMemo(() => R === null ? () => !0 : R !== void 0 ? R : Ne && !se ? kS(oe, T, Te) : NS(oe, T), [R, Ne, Te, se, oe, T]), Ce = Lt(() => _e ? s ?? "" : Ne ? fn(Te, T) : "").current, [Ee, Ae] = Sn({
    controlled: l,
    default: Ce,
    name: "Combobox",
    state: "inputValue"
  }), [ze, it] = Sn({
    controlled: a,
    default: c,
    name: "Combobox",
    state: "open"
  }), Ye = kf(y), Qe = pe ?? (Ee === "" ? "" : String(Ee).trim()), Ge = Ne ? fn(Te, T) : "", Ke = Ne && !se && Qe !== "" && Ge !== "" && Ge.length === Qe.length && oe.contains(Ge, Qe), Je = Ke ? "" : Qe, lt = Pe && $e && Ke, pt = x.useMemo(() => y ? Ye ? y.flatMap((je) => je.items) : y : Hn, [y, Ye]), ht = x.useMemo(() => {
    if (w && !lt)
      return w;
    if (!y)
      return Hn;
    if (Ye) {
      const et = y, xt = [];
      let Mt = 0;
      for (const sn of et) {
        if (A > -1 && Mt >= A)
          break;
        const on = Je === "" ? sn.items : sn.items.filter((Us) => rt(Us, Je, T));
        if (on.length === 0)
          continue;
        const sr = A > -1 ? A - Mt : 1 / 0, Ho = on.slice(0, sr);
        if (Ho.length > 0) {
          const Us = {
            ...sn,
            items: Ho
          };
          xt.push(Us), Mt += Ho.length;
        }
      }
      return xt;
    }
    if (Je === "")
      return A > -1 ? pt.slice(0, A) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        pt
      );
    const je = [];
    for (const et of pt) {
      if (A > -1 && je.length >= A)
        break;
      rt(et, Je, T) && je.push(et);
    }
    return je;
  }, [w, lt, y, Ye, Je, A, rt, T, pt]), It = x.useMemo(() => Ye ? ht.flatMap((et) => et.items) : ht, [ht, Ye]), ot = Lt(() => new Cd({
    id: ce,
    labelId: void 0,
    selectedValue: Te,
    open: ze,
    filter: rt,
    query: Qe,
    items: y,
    selectionMode: u,
    listRef: ge,
    labelsRef: j,
    popupRef: ee,
    emptyRef: fe,
    inputRef: Y,
    startDismissRef: Z,
    endDismissRef: ue,
    keyboardActiveRef: be,
    chipsContainerRef: ye,
    clearRef: xe,
    valuesRef: Re,
    allValuesRef: Ve,
    selectionEventRef: de,
    name: Xe,
    form: p,
    disabled: Ze,
    readOnly: h,
    required: b,
    grid: C,
    isGrouped: Ye,
    virtualized: D,
    openOnInputClick: S,
    itemToStringLabel: T,
    isItemEqualToValue: P,
    modal: _,
    autoHighlight: He,
    submitOnItemClick: z,
    hasInputValue: _e,
    mounted: !1,
    forceMounted: !1,
    transitionStatus: "idle",
    inline: O,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    inputProps: {},
    triggerProps: {},
    positionerElement: null,
    listElement: null,
    triggerElement: null,
    inputElement: null,
    inputGroupElement: null,
    popupSide: null,
    openMethod: null,
    inputInsidePopup: !0,
    onOpenChangeComplete: n || Ct,
    // Placeholder callbacks replaced on first render
    setOpen: Ct,
    setInputValue: Ct,
    setSelectedValue: Ct,
    setIndices: Ct,
    onItemHighlighted: Ct,
    handleSelection: Ct,
    getItemProps: () => Et,
    forceMount: Ct,
    requestSubmit: Ct
  })).current, Pt = u === "none" ? Ee : Te, un = x.useMemo(() => u === "none" ? Pt : Array.isArray(Te) ? Te.map((je) => qn(je, k)) : qn(Te, k), [Pt, k, u, Te]), jt = we(d), rn = we(n), tn = ve(ot, Oe.activeIndex), nn = ve(ot, Oe.selectedIndex), Ht = ve(ot, Oe.positionerElement), dn = ve(ot, Oe.listElement), Vt = ve(ot, Oe.triggerElement), gn = ve(ot, Oe.inputElement), gt = ve(ot, Oe.inputGroupElement), vt = ve(ot, Oe.inline), Ft = ve(ot, Oe.inputInsidePopup), Un = Yt(Vt), {
    mounted: ir,
    setMounted: Ni,
    transitionStatus: Ua
  } = to(ze), {
    openMethod: F1,
    triggerProps: Ga
  } = Ns(ze), Y3 = we(() => un);
  vi(Ft ? Un : Y, {
    id: ce,
    value: Pt,
    getValue: Y3
  });
  const zs = we(() => {
    y ? j.current = It.map((je) => fn(je, T)) : ot.set("forceMounted", !0);
  }), j3 = x.useRef(Te);
  ke(() => {
    Te !== j3.current && zs();
  }, [zs, Te]);
  const Gn = we((je) => {
    ot.update(je);
    const et = je.type || "none";
    if (je.activeIndex !== void 0)
      if (je.activeIndex === null)
        Se.current !== cr && (Se.current = cr, jt(void 0, Pi(et, void 0, {
          index: -1
        })));
      else {
        const xt = Re.current[je.activeIndex];
        Se.current = {
          value: xt,
          index: je.activeIndex
        }, jt(xt, Pi(et, void 0, {
          index: je.activeIndex
        }));
      }
  }), so = we((je, et) => {
    if (Ie.current = et.reason === Wo, t.onInputValueChange?.(je, et), !et.isCanceled) {
      if (et.reason === zr) {
        const xt = et.event, Mt = xt.inputType;
        if (xt.type === "compositionend" || Mt != null && Mt !== "" && Mt !== "insertReplacementText") {
          const on = je.trim() !== "";
          on && me(!0), Me.current = {
            hasQuery: on
          }, on && He && ot.state.activeIndex == null && ot.set("activeIndex", 0);
        }
      }
      Ae(je);
    }
  }), ki = we((je, et) => {
    if (ze !== je && (et.reason === "escape-key" && Pe && It.length === 0 && !ot.state.emptyRef.current && et.allowPropagation(), t.onOpenChange?.(je, et), !et.isCanceled && (!je && se && (Ne ? (vt || le(Qe), Qe === "" && me(!1)) : Be && (vt || Ft ? Gn({
      activeIndex: null
    }) : le(Qe), so("", De(Wo, et.event)))), it(je), !je && Ft && (et.reason === _o || et.reason === us) && (te(!0), re(!1), J === "onBlur")))) {
      const xt = u === "none" ? Ee : Te;
      ie.commit(xt);
    }
  }), Bs = we((je, et) => {
    if (i?.(je, et), et.isCanceled)
      return;
    Rt(je), (u === "none" && ee.current && V || Ne && !ot.state.inputInsidePopup) && so(fn(je, T), De(et.reason, et.event)), Ne && je != null && et.reason !== zr && se && !vt && le(Qe);
  }), K3 = we((je, et) => {
    let xt = et;
    if (xt === void 0) {
      if (tn === null)
        return;
      xt = Re.current[tn];
    }
    const Mt = yt(je), sn = de.current ?? je;
    de.current = null;
    const on = De(Yo, sn), sr = Mt?.closest("a")?.getAttribute("href");
    if (sr) {
      sr.startsWith("#") && ki(!1, on);
      return;
    }
    if (Be) {
      const Ho = Array.isArray(Te) ? Te : [], s4 = M0(Ho, xt, ot.state.isItemEqualToValue) ? T0(Ho, xt, ot.state.isItemEqualToValue) : [...Ho, xt];
      if (Bs(s4, on), !(Y.current ? Y.current.value.trim() !== "" : !1))
        return;
      ot.state.inputInsidePopup ? so("", De(Wo, on.event)) : ki(!1, on);
    } else
      Bs(xt, on), ki(!1, on);
  }), Ya = we(() => {
    if (!ot.state.submitOnItemClick)
      return;
    const je = ie.inputRef.current?.form ?? ot.state.inputElement?.form;
    je && typeof je.requestSubmit == "function" && je.requestSubmit();
  }), ja = we(() => {
    if (Ni(!1), rn?.(!1), me(!1), le(null), Gn(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), Be && Y.current && Y.current.value !== "" && !Ie.current && so("", De(Wo)), Ne)
      if (ot.state.inputInsidePopup)
        Y.current && Y.current.value !== "" && so("", De(Wo));
      else {
        const je = fn(Te, T);
        Y.current && Y.current.value !== je && so(je, De(je === "" ? Wo : At));
      }
  }), q3 = x.useMemo(() => vt && Ht ? {
    current: Ht.closest('[role="dialog"]')
  } : ee, [vt, Ht]);
  Jt({
    enabled: !t.actionsRef,
    open: ze,
    ref: q3,
    onComplete() {
      ze || ja();
    }
  }), x.useImperativeHandle(t.actionsRef, () => ({
    unmount: ja
  }), [ja]), ke(function() {
    if (ze || u === "none")
      return;
    const et = y ? pt : Ve.current;
    if (Be) {
      const xt = Array.isArray(Te) ? Te : [], Mt = xt[xt.length - 1], sn = Do(et, Mt, P);
      Gn({
        selectedIndex: sn === -1 ? null : sn
      });
    } else {
      const xt = Do(et, Te, P);
      Gn({
        selectedIndex: xt === -1 ? null : xt
      });
    }
  }, [ze, Te, y, u, pt, Be, P, Gn]), ke(() => {
    y && (Re.current = It, ge.current.length = It.length);
  }, [y, It]), ke(() => {
    const je = Me.current;
    if (je && (je.hasQuery ? He && ot.set("activeIndex", 0) : He === "always" && ot.set("activeIndex", 0), Me.current = null), !ze && !vt)
      return;
    const xt = Pe || $e ? It : Re.current, Mt = ot.state.activeIndex;
    if (Mt == null) {
      if (He === "always" && xt.length > 0) {
        ot.set("activeIndex", 0);
        return;
      }
      Se.current !== cr && (Se.current = cr, ot.state.onItemHighlighted(void 0, Pi(At, void 0, {
        index: -1
      })));
      return;
    }
    if (Mt >= xt.length) {
      Se.current !== cr && (Se.current = cr, ot.state.onItemHighlighted(void 0, Pi(At, void 0, {
        index: -1
      }))), ot.set("activeIndex", null);
      return;
    }
    const sn = xt[Mt], on = Se.current.value, sr = on !== Y0 && vo(sn, on, ot.state.isItemEqualToValue);
    (Se.current.index !== Mt || !sr) && (Se.current = {
      value: sn,
      index: Mt
    }, ot.state.onItemHighlighted(sn, Pi(At, void 0, {
      index: Mt
    })));
  }, [tn, He, $e, Pe, It, vt, ze, ot]), ke(() => {
    if (u === "none") {
      Q(String(Ee) !== "");
      return;
    }
    Q(Be ? Array.isArray(Te) && Te.length > 0 : Te != null);
  }, [Q, u, Ee, Te, Be]), x.useEffect(() => {
    Pe && He && It.length === 0 && Gn({
      activeIndex: null
    });
  }, [Pe, He, It.length, Gn]), ko(Qe, () => {
    !ze || Qe === "" || Qe === String(Ce) || me(!0);
  }), ko(Te, () => {
    if (u !== "none" && (H(Xe), K(Te !== G.initialValue), q() ? ie.commit(Te) : ie.commit(Te, !0), Ne && !_e && !Ft)) {
      const je = fn(Te, T);
      Ee !== je && so(je, De(At));
    }
  }), ko(Ee, () => {
    u === "none" && (H(Xe), K(Ee !== G.initialValue), q() ? ie.commit(Ee) : ie.commit(Ee, !0));
  }), ko(y, () => {
    if (!Ne || _e || Ft || se)
      return;
    const je = fn(Te, T);
    Ee !== je && so(je, De(At));
  });
  const Ws = Sd({
    open: vt ? !0 : ze,
    onOpenChange: ki,
    elements: {
      reference: Ft ? Vt : gn,
      floating: Ht
    }
  });
  let Ka, qa;
  vt || (Ka = C ? "grid" : "listbox", qa = ze ? "true" : "false");
  const Z3 = x.useMemo(() => {
    const je = gn?.tagName === "INPUT", et = gn == null || je, xt = et || ze, Mt = et ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return xt && (Mt.role = "combobox", Mt["aria-expanded"] = qa, Mt["aria-haspopup"] = Ka, Mt["aria-controls"] = ze ? dn?.id : void 0, Mt["aria-autocomplete"] = L), {
      reference: Mt,
      floating: {
        role: "presentation"
      }
    };
  }, [gn, ze, qa, Ka, dn?.id, L]), X3 = Nr(Ws, {
    enabled: !h && !Ze && S,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: Ft ? 0 : 100,
    reason: rh
  }), Q3 = kr(Ws, {
    enabled: !h && !Ze && !vt,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: vt ? !0 : void 0,
    outsidePress(je) {
      const et = yt(je);
      return !Fe(Vt, et) && !Fe(xe.current, et) && !Fe(ye.current, et) && !Fe(gt, et);
    }
  }), J3 = Nd(Ws, {
    enabled: !h && !Ze,
    id: ce,
    listRef: ge,
    activeIndex: tn,
    selectedIndex: nn,
    virtual: !0,
    loopFocus: M,
    allowEscape: M && !He,
    focusItemOnOpen: se || u === "none" && !He ? !1 : "auto",
    focusItemOnHover: I,
    resetOnPointerLeave: !N,
    // `cols` > 1 enables grid navigation.
    // Since <Combobox.Row> infers column sizes (and is required when building a grid),
    // it works correctly even with a value of `2`.
    // Floating UI tests don't require `role="row"` wrappers, so retains the number API.
    cols: C ? 2 : 1,
    orientation: C ? "horizontal" : void 0,
    disabledIndices: Hn,
    onNavigate(je, et) {
      !et && !ze || Ua === "ending" || Gn(et ? {
        activeIndex: je,
        type: be.current ? "keyboard" : "pointer"
      } : {
        activeIndex: je
      });
    }
  }), {
    getReferenceProps: Za,
    getFloatingProps: Xa,
    getItemProps: Qa
  } = ro([Z3, X3, Q3, J3]);
  Or(() => {
    ot.update({
      inline: O,
      popupProps: Xa(),
      inputProps: Za(),
      triggerProps: Ga,
      getItemProps: Qa,
      setOpen: ki,
      setInputValue: so,
      setSelectedValue: Bs,
      setIndices: Gn,
      onItemHighlighted: jt,
      handleSelection: K3,
      forceMount: zs,
      requestSubmit: Ya
    });
  }), ke(() => {
    ot.update({
      id: ce,
      selectedValue: Te,
      open: ze,
      mounted: ir,
      transitionStatus: Ua,
      items: y,
      inline: O,
      popupProps: Xa(),
      inputProps: Za(),
      triggerProps: Ga,
      openMethod: F1,
      getItemProps: Qa,
      selectionMode: u,
      name: Xe,
      form: p,
      disabled: Ze,
      readOnly: h,
      required: b,
      grid: C,
      isGrouped: Ye,
      virtualized: D,
      onOpenChangeComplete: rn,
      openOnInputClick: S,
      itemToStringLabel: T,
      modal: _,
      autoHighlight: He,
      isItemEqualToValue: P,
      submitOnItemClick: z,
      hasInputValue: _e,
      requestSubmit: Ya
    });
  }, [ot, ce, Te, ze, ir, Ua, y, Xa, Za, Qa, F1, Ga, u, Xe, Ze, h, b, ie, C, Ye, D, rn, S, T, _, P, z, _e, O, Ya, He, p]);
  const e4 = Rn(v, ie.inputRef), t4 = x.useMemo(() => ({
    query: Qe,
    hasItems: Pe,
    filteredItems: ht,
    flatFilteredItems: It
  }), [Qe, Pe, ht, It]), n4 = x.useMemo(() => Array.isArray(Pt) ? "" : qn(Pt, k), [Pt, k]), o4 = Be && Array.isArray(Te) && Te.length > 0, Ja = Be || u === "none" ? void 0 : Xe, r4 = x.useMemo(() => !Be || !Array.isArray(Te) || !Xe ? null : Te.map((je) => {
    const et = qn(je, k);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: p,
      name: Xe,
      value: et
    }, et);
  }), [Be, Te, p, Xe, k]), i4 = /* @__PURE__ */ F(x.Fragment, {
    children: [t.children, /* @__PURE__ */ g("input", {
      ...ie.getInputValidationProps({
        // Move focus when the hidden input is focused.
        onFocus() {
          if (Ft) {
            Vt?.focus();
            return;
          }
          (Y.current || Vt)?.focus();
        },
        // Handle browser autofill.
        onChange(je) {
          if (je.nativeEvent.defaultPrevented)
            return;
          const et = je.currentTarget.value, xt = De(At, je.nativeEvent);
          function Mt() {
            if (Be)
              return;
            if (u === "none") {
              K(et !== G.initialValue), so(et, xt), q() && ie.commit(et);
              return;
            }
            const sn = Re.current.find((on) => qn(on, k).toLowerCase() === et.toLowerCase() || fn(on, T).toLowerCase() === et.toLowerCase());
            sn != null && (K(sn !== G.initialValue), Bs?.(sn, xt), q() && ie.commit(sn));
          }
          y ? Mt() : (zs(), queueMicrotask(Mt));
        }
      }),
      id: ce && Ja == null ? `${ce}-hidden-input` : void 0,
      form: p,
      name: Ja,
      autoComplete: $,
      disabled: Ze,
      required: b && !o4,
      readOnly: h,
      value: n4,
      ref: e4,
      style: Ja ? ii : nr,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), r4]
  });
  return /* @__PURE__ */ g($f.Provider, {
    value: ot,
    children: /* @__PURE__ */ g(Hf.Provider, {
      value: Ws,
      children: /* @__PURE__ */ g(zf.Provider, {
        value: t4,
        children: /* @__PURE__ */ g(Bf.Provider, {
          value: Ee,
          children: i4
        })
      })
    })
  });
}
function Uf(t) {
  const {
    multiple: e = !1,
    defaultValue: n,
    value: o,
    onValueChange: r,
    autoComplete: i,
    ...s
  } = t;
  return /* @__PURE__ */ g(j0, {
    ...s,
    selectionMode: e ? "multiple" : "single",
    selectedValue: o,
    defaultSelectedValue: n,
    onSelectedValueChange: r,
    formAutoComplete: i
  });
}
const Gf = {
  ...qi,
  ...io,
  popupSide: (t) => t ? {
    "data-popup-side": t
  } : null,
  listEmpty: (t) => t ? {
    "data-list-empty": ""
  } : null
}, Yf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yf.displayName = "ComboboxChipsContext");
function K0() {
  return x.useContext(Yf);
}
const jf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (jf.displayName = "ComboboxPositionerContext");
function Kf(t) {
  const e = x.useContext(jf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : st(21));
  return e;
}
const qf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = Tn(), {
    buttonRef: r,
    getButtonProps: i
  } = qt({
    native: !1
  }), s = Rn(n, r), l = we((c) => {
    o.state.setOpen(!1, De(oh, c.nativeEvent, c.currentTarget));
  }), a = i({
    onClick: l
  });
  return /* @__PURE__ */ g("span", {
    ref: s,
    ...a,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: ii
  });
});
process.env.NODE_ENV !== "production" && (qf.displayName = "ComboboxInternalDismissButton");
const _s = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    id: s,
    style: l,
    ...a
  } = e, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: p,
    validation: m
  } = mn(), {
    labelId: h
  } = Nn(), b = K0(), C = !!Kf(!0), y = Tn(), {
    filteredItems: w
  } = wo(), R = Wf(), S = Es(), E = ve(y, Oe.required), N = ve(y, Oe.disabled), I = ve(y, Oe.readOnly), M = ve(y, Oe.name), T = ve(y, Oe.form), k = ve(y, Oe.selectionMode), P = ve(y, Oe.autoHighlight), D = ve(y, Oe.inputProps), O = ve(y, Oe.triggerProps), V = ve(y, Oe.open), _ = ve(y, Oe.mounted), A = ve(y, Oe.selectedValue), L = ve(y, Oe.popupSide), $ = ve(y, Oe.positionerElement), B = ve(y, Oe.id), z = ve(y, Oe.inline), H = ve(y, Oe.modal), K = !!P, G = _ && $ ? L : null, q = u || N || i, Q = w.length === 0, U = C || z, X = !U || H, te = Ot(s ?? (U ? void 0 : B)), re = If(h, void 0), J = C ? Br : c, [ie, ce] = x.useState(null), oe = x.useRef(!1), se = x.useRef(null), me = x.useRef(!1), pe = we((Y) => {
    const Z = C || y.state.inline;
    Z && !y.state.hasInputValue && y.state.setInputValue("", De(At)), y.update({
      inputElement: Y,
      inputInsidePopup: Z
    });
  }), le = C || !m ? a : m.getValidationProps(a), ge = {
    ...J,
    open: V,
    disabled: q,
    readOnly: I,
    popupSide: G,
    listEmpty: Q
  };
  function j(Y) {
    if (!b)
      return;
    let Z;
    const {
      highlightedChipIndex: ue
    } = b, fe = b.chipsRef.current.length;
    if (ue !== void 0) {
      if (Y.key === "ArrowLeft")
        Y.preventDefault(), ue > 0 ? Z = ue - 1 : Z = void 0;
      else if (Y.key === "ArrowRight")
        Y.preventDefault(), ue < fe - 1 ? Z = ue + 1 : Z = void 0;
      else if (Y.key === "Backspace" || Y.key === "Delete") {
        Y.preventDefault();
        const be = ue >= A.length - 1 ? A.length - 2 : ue;
        Z = be >= 0 ? be : void 0, y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: "keyboard"
        });
      }
      return Z;
    }
    return Y.key === "ArrowLeft" && (Y.currentTarget.selectionStart ?? 0) === 0 && A.length > 0 ? (Y.preventDefault(), Z = fe > 0 ? fe - 1 : void 0) : Y.key === "Backspace" && Y.currentTarget.value === "" && A.length > 0 && (y.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: "keyboard"
    }), Y.preventDefault()), Z;
  }
  const ee = Le("input", e, {
    state: ge,
    ref: [n, y.state.inputRef, pe],
    props: [D, O, {
      type: "text",
      value: e.value ?? ie ?? R,
      "aria-readonly": I || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": re,
      disabled: q,
      readOnly: I,
      required: k === "none" ? E : void 0,
      form: T,
      ...k === "none" && M && {
        name: M
      },
      id: te,
      onFocus() {
        if (f(!0), !z || !me.current)
          return;
        me.current = !1;
        const Y = se.current;
        Y == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(y.state.valuesRef.current, Y) || y.state.setIndices({
          activeIndex: Y
        });
      },
      onBlur() {
        d(!0), f(!1);
        const Y = y.state.activeIndex;
        if (z && Y !== null && P !== "always" && (se.current = Y, me.current = !0, y.state.setIndices({
          activeIndex: null
        })), p === "onBlur") {
          const Z = k === "none" ? R : A;
          m.commit(Z);
        }
      },
      onCompositionStart(Y) {
        Zi || (oe.current = !0, ce(Y.currentTarget.value));
      },
      onCompositionEnd(Y) {
        oe.current = !1;
        const Z = Y.currentTarget.value;
        ce(null), y.state.setInputValue(Z, De(zr, Y.nativeEvent));
      },
      onChange(Y) {
        const Z = Y.nativeEvent.inputType, ue = !Z || Z === "insertReplacementText", fe = oe.current || !ue;
        if (oe.current) {
          const xe = Y.currentTarget.value;
          ce(xe), xe === "" && !y.state.openOnInputClick && !y.state.inputInsidePopup && y.state.setOpen(!1, De(Wo, Y.nativeEvent));
          const de = xe.trim(), Se = K && de !== "";
          !I && !q && de && fe && (y.state.setOpen(!0, De(zr, Y.nativeEvent)), K || y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          })), V && y.state.activeIndex !== null && !Se && y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          });
          return;
        }
        y.state.setInputValue(Y.currentTarget.value, De(zr, Y.nativeEvent));
        const be = Y.currentTarget.value === "", Ie = De(Wo, Y.nativeEvent);
        be && !y.state.inputInsidePopup && (k === "single" && y.state.setSelectedValue(null, Ie), y.state.openOnInputClick || y.state.setOpen(!1, Ie));
        const ye = Y.currentTarget.value.trim();
        !I && !q && ye && fe && (y.state.setOpen(!0, De(zr, Y.nativeEvent)), K || y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        })), V && y.state.activeIndex !== null && !K && y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        });
      },
      onKeyDown(Y) {
        if (q || I || Y.ctrlKey || Y.shiftKey || Y.altKey || Y.metaKey)
          return;
        y.state.keyboardActiveRef.current = !0;
        const Z = Y.currentTarget, ue = Z.scrollWidth - Z.clientWidth, fe = S === "rtl";
        if (Y.key === "Home") {
          Gt(Y);
          const ye = J1 && fe ? Z.value.length : 0;
          Z.setSelectionRange(ye, ye), Z.scrollLeft = 0;
          return;
        }
        if (Y.key === "End") {
          Gt(Y);
          const ye = J1 && fe ? 0 : Z.value.length;
          Z.setSelectionRange(ye, ye), Z.scrollLeft = fe ? -ue : ue;
          return;
        }
        if (!_ && Y.key === "Escape") {
          const ye = k === "multiple" && Array.isArray(A) ? A.length === 0 : A === null, xe = De(Rr, Y.nativeEvent), de = k === "multiple" ? [] : null;
          y.state.setInputValue("", xe), y.state.setSelectedValue(de, xe), !ye && !y.state.inline && !xe.isPropagationAllowed && Y.stopPropagation();
          return;
        }
        if (b && Y.key === "Backspace" && Z.value === "" && b.highlightedChipIndex === void 0 && Array.isArray(A) && A.length > 0) {
          const ye = b.chipsRef.current.length, xe = ye > 0 ? ye - 1 : A.length - 1, de = A.filter((Se, Me) => Me !== xe);
          y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          }), y.state.setSelectedValue(de, De(At, Y.nativeEvent));
          return;
        }
        const be = b?.highlightedChipIndex !== void 0, Ie = j(Y);
        if (b?.setHighlightedChipIndex(Ie), Ie !== void 0 ? b?.chipsRef.current[Ie]?.focus() : be && y.state.inputRef.current?.focus(), Y.which !== 229 && Y.key === "Enter" && V) {
          const ye = y.state.activeIndex, xe = Y.nativeEvent;
          if (ye === null) {
            if (z)
              return;
            y.state.setOpen(!1, De(At, xe));
            return;
          }
          Gt(Y);
          const de = y.state.listRef.current[ye];
          de && (y.state.selectionEventRef.current = xe, de.click(), y.state.selectionEventRef.current = null);
        }
      },
      onPointerMove() {
        y.state.keyboardActiveRef.current = !1;
      },
      onPointerDown() {
        y.state.keyboardActiveRef.current = !1;
      }
    }, le],
    stateAttributesMapping: Gf
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [V && X && /* @__PURE__ */ g(qf, {
      ref: y.state.startDismissRef
    }), ee]
  });
});
process.env.NODE_ENV !== "production" && (_s.displayName = "ComboboxInput");
function q0(t, e, n, o, r) {
  if (t.baseUIHandlerPrevented || o)
    return;
  const i = yt(t.nativeEvent), s = mt(i) ? i : null;
  s !== t.currentTarget && (r?.(s) || Ch(s)) || (t.preventDefault(), !n && (e.state.inputRef.current?.focus(), e.state.openOnInputClick && e.state.setOpen(!0, De(rh, t.nativeEvent))));
}
const Da = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = mn(), a = Tn(), {
    filteredItems: c
  } = wo(), u = ve(a, Oe.open), d = ve(a, Oe.mounted), f = ve(a, Oe.popupSide), p = ve(a, Oe.positionerElement), m = ve(a, Oe.disabled), h = ve(a, Oe.readOnly), b = ve(a, Oe.hasSelectedValue), v = ve(a, Oe.selectionMode), C = d && p ? f : null, y = m, w = c.length === 0, S = {
    ...l,
    open: u,
    disabled: y,
    readOnly: h,
    popupSide: C,
    listEmpty: w,
    placeholder: v === "none" ? !1 : !b
  }, E = we((N) => {
    a.set("inputGroupElement", N);
  });
  return Le("div", e, {
    ref: [n, E],
    props: [{
      role: "group",
      onMouseDown(N) {
        q0(N, a, y, h, (I) => Fe(a.state.chipsContainerRef.current, I));
      }
    }, s],
    state: S,
    stateAttributesMapping: Gf
  });
});
process.env.NODE_ENV !== "production" && (Da.displayName = "ComboboxInputGroup");
const ml = 2, _a = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    nativeButton: i = !0,
    disabled: s = !1,
    id: l,
    style: a,
    ...c
  } = e, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: p,
    validationMode: m,
    validation: h
  } = mn(), {
    labelId: b
  } = Nn(), v = Tn(), {
    filteredItems: C
  } = wo(), y = ve(v, Oe.selectionMode), w = ve(v, Oe.disabled), R = ve(v, Oe.readOnly), S = ve(v, Oe.required), E = ve(v, Oe.mounted), N = ve(v, Oe.popupSide), I = ve(v, Oe.positionerElement), M = ve(v, Oe.listElement), T = ve(v, Oe.triggerProps), k = ve(v, Oe.triggerElement), P = ve(v, Oe.inputInsidePopup), D = ve(v, Oe.id), O = ve(v, Oe.labelId), V = ve(v, Oe.open), _ = ve(v, Oe.selectedValue), A = ve(v, Oe.activeIndex), L = ve(v, Oe.selectedIndex), $ = ve(v, Oe.hasSelectedValue), B = Oa(), z = Wf(), H = Bt(), K = d || w || s, G = C.length === 0, q = E && I ? N : null;
  _r({
    id: P ? l : void 0
  });
  const Q = P ? l ?? D : l, U = If(b, O), X = x.useRef("");
  function te(le) {
    X.current = le.pointerType;
  }
  const re = B.useState("domReferenceElement");
  x.useEffect(() => {
    P && k && k !== re && B.set("domReferenceElement", k);
  }, [k, re, B, P]);
  const {
    reference: J
  } = Id(B, {
    enabled: !V && !R && !w && y === "single",
    listRef: v.state.labelsRef,
    activeIndex: A,
    selectedIndex: L,
    onMatch(le) {
      const ge = v.state.valuesRef.current[le];
      ge !== void 0 && v.state.setSelectedValue(ge, De("none"));
    }
  }), {
    reference: ie
  } = Nr(B, {
    enabled: !R && !w,
    event: "mousedown"
  }), {
    buttonRef: ce,
    getButtonProps: oe
  } = qt({
    native: i,
    disabled: K
  }), se = {
    ...u,
    open: V,
    disabled: K,
    popupSide: q,
    listEmpty: G,
    placeholder: y === "none" ? !1 : !$
  }, me = we((le) => {
    v.set("triggerElement", le);
  });
  return Le("button", e, {
    ref: [n, ce, me],
    state: se,
    props: [T, ie, J, {
      id: Q,
      tabIndex: P ? 0 : -1,
      role: P ? "combobox" : void 0,
      "aria-expanded": V ? "true" : "false",
      "aria-haspopup": P ? "dialog" : "listbox",
      "aria-controls": V ? M?.id : void 0,
      "aria-required": P && S || void 0,
      "aria-labelledby": U,
      onPointerDown: te,
      onPointerEnter: te,
      onFocus() {
        p(!0), !(K || R) && H.start(0, v.state.forceMount);
      },
      onBlur(le) {
        if (!Fe(I, le.relatedTarget) && (f(!0), p(!1), m === "onBlur")) {
          const ge = y === "none" ? z : _;
          h.commit(ge);
        }
      },
      onMouseDown(le) {
        if (K || R || (P || B.set("domReferenceElement", le.currentTarget), v.state.forceMount(), X.current !== "touch" && (v.state.inputRef.current?.focus(), P || le.preventDefault()), V))
          return;
        const ge = nt(le.currentTarget);
        function j(ee) {
          if (!k)
            return;
          const Y = yt(ee), Z = v.state.positionerElement, ue = v.state.listElement;
          if (Fe(k, Y) || Fe(Z, Y) || Fe(ue, Y) || Y === k)
            return;
          const fe = Vd(k), be = ee.clientX >= fe.left - ml && ee.clientX <= fe.right + ml, Ie = ee.clientY >= fe.top - ml && ee.clientY <= fe.bottom + ml;
          be && Ie || v.state.setOpen(!1, De("cancel-open", ee));
        }
        P && ge.addEventListener("mouseup", j, {
          once: !0
        });
      },
      onKeyDown(le) {
        K || R || (le.key === "ArrowDown" || le.key === "ArrowUp") && (Gt(le), v.state.setOpen(!0, De(Gr, le.nativeEvent)), v.state.inputRef.current?.focus());
      }
    }, h ? h.getValidationProps(c) : c, oe],
    stateAttributesMapping: Gf
  });
});
process.env.NODE_ENV !== "production" && (_a.displayName = "ComboboxTrigger");
const Zf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Zf.displayName = "GroupCollectionContext");
function PS() {
  return x.useContext(Zf);
}
function MS(t) {
  const {
    children: e,
    items: n
  } = t, o = x.useMemo(() => ({
    items: n
  }), [n]);
  return /* @__PURE__ */ g(Zf.Provider, {
    value: o,
    children: e
  });
}
function Z0(t) {
  const {
    children: e
  } = t, {
    filteredItems: n
  } = wo(), o = PS(), r = o ? o.items : n;
  return r ? /* @__PURE__ */ g(x.Fragment, {
    children: r.map(e)
  }) : null;
}
const Vs = /* @__PURE__ */ x.forwardRef(function(e, n) {
  var o;
  const {
    render: r,
    className: i,
    style: s,
    children: l,
    ...a
  } = e, c = Tn(), u = Oa(), d = !!Kf(!0), {
    filteredItems: f,
    hasItems: p
  } = wo(), m = ve(c, Oe.selectionMode), h = ve(c, Oe.grid), b = ve(c, Oe.popupProps), v = ve(c, Oe.virtualized), C = m === "multiple", y = f.length === 0, w = we((M) => {
    c.set("positionerElement", M);
  }), R = we((M) => {
    c.set("listElement", M);
  }), S = x.useMemo(() => typeof l == "function" ? o || (o = /* @__PURE__ */ g(Z0, {
    children: l
  })) : l, [l]), E = {
    empty: y
  }, N = u.useState("floatingId"), I = Le("div", e, {
    state: E,
    ref: [n, R, d ? null : w],
    props: [b, {
      children: S,
      tabIndex: -1,
      id: N,
      role: h ? "grid" : "listbox",
      "aria-multiselectable": C ? "true" : void 0,
      onKeyDown(M) {
        if (!(c.state.disabled || c.state.readOnly) && M.key === "Enter") {
          const T = c.state.activeIndex;
          if (T == null)
            return;
          Gt(M);
          const k = M.nativeEvent, P = c.state.listRef.current[T];
          P && (c.state.selectionEventRef.current = k, P.click(), c.state.selectionEventRef.current = null);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, a]
  });
  return v ? I : /* @__PURE__ */ g(ci, {
    elementsRef: c.state.listRef,
    labelsRef: p ? void 0 : c.state.labelsRef,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (Vs.displayName = "ComboboxList");
const TS = "⁠", OS = 200;
function DS(t) {
  const e = t.ownerDocument.createTreeWalker(t, NodeFilter.SHOW_TEXT);
  let n = null;
  for (; e.nextNode(); ) {
    const o = e.currentNode;
    o.nodeValue !== "" && (n = o);
  }
  return n;
}
function X0() {
  const t = Bt(), e = x.useRef(null);
  return x.useEffect(() => {
    if (Zu)
      return;
    const n = e.current;
    if (n == null)
      return;
    const o = DS(n);
    if (o == null)
      return;
    const r = o.nodeValue ?? "", i = `${r}${TS}`;
    return o.nodeValue = i, t.start(OS, () => {
      o.nodeValue === i && (o.nodeValue = r);
    }), () => {
      t.clear(), o.nodeValue === i && (o.nodeValue = r);
    };
  }, [e, t]), e;
}
const Q0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, a = X0();
  return Le("div", e, {
    ref: [n, a],
    props: [{
      children: s,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Q0.displayName = "ComboboxStatus");
const Xf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xf.displayName = "ComboboxPortalContext");
function _S() {
  const t = x.useContext(Xf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : st(20));
  return t;
}
const Va = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, i = Tn(), s = ve(i, Oe.mounted), l = ve(i, Oe.forceMounted);
  return s || o || l ? /* @__PURE__ */ g(Xf.Provider, {
    value: o,
    children: /* @__PURE__ */ g(si, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Va.displayName = "ComboboxPortal");
const Aa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = cd,
    style: v,
    ...C
  } = e, y = Tn(), {
    filteredItems: w
  } = wo(), R = Oa(), S = _S(), E = ve(y, Oe.modal), N = ve(y, Oe.open), I = ve(y, Oe.mounted), M = ve(y, Oe.openMethod), T = ve(y, Oe.positionerElement), k = ve(y, Oe.triggerElement), P = ve(y, Oe.inputElement), D = ve(y, Oe.inputGroupElement), O = ve(y, Oe.inputInsidePopup), V = ve(y, Oe.transitionStatus), _ = w.length === 0, L = ai({
    anchor: i ?? (O ? k : D ?? P),
    floatingRootContext: R,
    positionMethod: s,
    mounted: I,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: S,
    collisionAvoidance: b,
    lazyFlip: !0
  });
  Sa(N && E, M === "touch", T, k);
  const $ = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    empty: _
  };
  ke(() => {
    y.set("popupSide", L.side);
  }, [y, L.side]);
  const B = we((H) => {
    y.set("positionerElement", H);
  }), z = di(e, $, {
    styles: L.positionerStyles,
    transitionStatus: V,
    props: C,
    refs: [n, B],
    hidden: !I,
    inert: !N
  });
  return /* @__PURE__ */ F(jf.Provider, {
    value: L,
    children: [I && E && /* @__PURE__ */ g(ui, {
      inert: Tr(!N),
      cutout: D ?? P ?? k
    }), z]
  });
});
process.env.NODE_ENV !== "production" && (Aa.displayName = "ComboboxPositioner");
const VS = {
  ...An,
  ...Kt
}, La = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    initialFocus: s,
    finalFocus: l,
    ...a
  } = e, c = Tn(), u = Kf(), d = Oa(), {
    filteredItems: f
  } = wo(), p = ve(c, Oe.mounted), m = ve(c, Oe.open), h = ve(c, Oe.openMethod), b = ve(c, Oe.transitionStatus), v = ve(c, Oe.inputInsidePopup), C = ve(c, Oe.inputElement), y = ve(c, Oe.modal), w = f.length === 0;
  Jt({
    open: m,
    ref: c.state.popupRef,
    onComplete() {
      m && c.state.onOpenChangeComplete(!0);
    }
  });
  const R = {
    open: m,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: b,
    empty: w
  }, S = Le("div", e, {
    state: R,
    ref: [n, c.state.popupRef],
    props: [{
      role: v ? "dialog" : "presentation",
      tabIndex: -1,
      onFocus(T) {
        const k = yt(T.nativeEvent);
        h !== "touch" && (Fe(c.state.listElement, k) || k === T.currentTarget) && c.state.inputRef.current?.focus();
      }
    }, Mr(b), a],
    stateAttributesMapping: VS
  }), N = s === void 0 ? v ? (T) => T === "touch" ? c.state.popupRef.current : C : !1 : s;
  let I;
  l != null ? I = l : I = v ? void 0 : !1;
  const M = !v || y;
  return /* @__PURE__ */ g(li, {
    context: d,
    disabled: !p,
    modal: M,
    openInteractionType: h,
    initialFocus: N,
    returnFocus: I,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [S, M && /* @__PURE__ */ g(qf, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (La.displayName = "ComboboxPopup");
const Qf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qf.displayName = "ComboboxGroupContext");
function AS() {
  const t = x.useContext(Qf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : st(18));
  return t;
}
const J0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    items: s,
    ...l
  } = e, [a, c] = x.useState(), u = x.useMemo(() => ({
    labelId: a,
    setLabelId: c,
    items: s
  }), [a, c, s]), d = Le("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": a
    }, l]
  }), f = /* @__PURE__ */ g(Qf.Provider, {
    value: u,
    children: d
  });
  return s ? /* @__PURE__ */ g(MS, {
    items: s,
    children: f
  }) : f;
});
process.env.NODE_ENV !== "production" && (J0.displayName = "ComboboxGroup");
const eb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    setLabelId: a
  } = AS(), c = Ot(s);
  return ke(() => (a(c), () => {
    a(void 0);
  }), [c, a]), Le("div", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (eb.displayName = "ComboboxGroupLabel");
const tb = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (tb.displayName = "ComboboxItemContext");
const Jf = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Jf.displayName = "ComboboxRowContext");
function LS() {
  return x.useContext(Jf);
}
const As = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    index: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(!1), f = x.useRef(null), p = Ao({
    index: s,
    textRef: f,
    indexGuessBehavior: Ju.GuessFromOrder
  }), m = Tn(), h = LS(), {
    flatFilteredItems: b,
    hasItems: v
  } = wo(), C = ve(m, Oe.open), y = ve(m, Oe.selectionMode), w = ve(m, Oe.readOnly), R = ve(m, Oe.virtualized), S = ve(m, Oe.isItemEqualToValue), E = y !== "none", N = s ?? (R ? Do(b, i, S) : p.index), I = p.index !== -1, M = ve(m, Oe.id), T = ve(m, Oe.isActive, N), k = ve(m, Oe.isSelected, i), P = ve(m, Oe.getItemProps), D = x.useRef(null), O = M != null && I ? `${M}-${N}` : void 0, V = k && E;
  ke(() => {
    if (!(I && (R || s != null)))
      return;
    const q = m.state.listRef.current;
    return q[N] = D.current, () => {
      delete q[N];
    };
  }, [I, R, N, s, m]), ke(() => {
    if (!I || v)
      return;
    const G = m.state.valuesRef.current;
    return G[N] = i, y !== "none" && m.state.allValuesRef.current.push(i), () => {
      delete G[N];
    };
  }, [I, v, N, i, m, y]), ke(() => {
    if (!C) {
      d.current = !1;
      return;
    }
    if (!I || v)
      return;
    const G = m.state.selectedValue, q = Array.isArray(G) ? G[G.length - 1] : G;
    vo(i, q, S) && m.set("selectedIndex", N);
  }, [I, v, C, m, N, i, S]);
  const _ = {
    disabled: l,
    selected: V,
    highlighted: T
  }, A = P({
    active: T,
    selected: V
  });
  A.id = void 0, A.onFocus = void 0;
  const {
    getButtonProps: L,
    buttonRef: $
  } = qt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function B(G) {
    function q() {
      m.state.handleSelection(G, i);
    }
    m.state.submitOnItemClick ? (yn.flushSync(q), m.state.requestSubmit()) : q();
  }
  const z = {
    id: O,
    role: h ? "gridcell" : "option",
    "aria-selected": E ? V : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(G) {
      d.current = !0, G.preventDefault();
    },
    onMouseDown(G) {
      G.preventDefault();
    },
    onClick(G) {
      l || w || B(G.nativeEvent);
    },
    onMouseUp(G) {
      const q = d.current;
      d.current = !1, !(l || w || G.button !== 0 || q || !T) && B(G.nativeEvent);
    }
  }, H = Le("div", e, {
    ref: [$, n, p.ref, D],
    state: _,
    props: [A, z, u, L]
  }), K = x.useMemo(() => ({
    selected: V,
    textRef: f
  }), [V, f]);
  return /* @__PURE__ */ g(tb.Provider, {
    value: K,
    children: H
  });
}));
process.env.NODE_ENV !== "production" && (As.displayName = "ComboboxItem");
const nb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Tn(), a = ve(l, Oe.open), c = ve(l, Oe.hasSelectionChips), [u, d] = x.useState(void 0);
  a && u !== void 0 && d(void 0);
  const f = x.useRef([]), p = Le("div", e, {
    ref: [n, l.state.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [c ? {
      role: "toolbar"
    } : Et, {
      onMouseDown(h) {
        q0(h, l, l.state.disabled, l.state.readOnly);
      }
    }, s]
  }), m = x.useMemo(() => ({
    highlightedChipIndex: u,
    setHighlightedChipIndex: d,
    chipsRef: f
  }), [u, d, f]);
  return /* @__PURE__ */ g(Yf.Provider, {
    value: m,
    children: /* @__PURE__ */ g(ci, {
      elementsRef: f,
      children: p
    })
  });
});
process.env.NODE_ENV !== "production" && (nb.displayName = "ComboboxChips");
const e1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (e1.displayName = "ComboboxChipContext");
function FS() {
  const t = x.useContext(e1);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "useComboboxChipContext must be used within a ComboboxChip" : st(17));
  return t;
}
const ob = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Tn(), {
    setHighlightedChipIndex: a,
    chipsRef: c
  } = K0(), u = ve(l, Oe.disabled), d = ve(l, Oe.readOnly), f = ve(l, Oe.selectedValue), {
    ref: p,
    index: m
  } = Ao();
  function h(y) {
    let w = m;
    if (y.key === "ArrowLeft")
      y.preventDefault(), m > 0 ? w = m - 1 : w = void 0;
    else if (y.key === "ArrowRight")
      y.preventDefault(), m < c.current.length - 1 ? w = m + 1 : w = void 0;
    else if (y.key === "Backspace" || y.key === "Delete") {
      const R = m >= f.length - 1 ? f.length - 2 : m;
      w = R >= 0 ? R : void 0, Gt(y), l.state.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: "keyboard"
      }), l.state.setSelectedValue(f.filter((S, E) => E !== m), De(At, y.nativeEvent));
    } else y.key === "Enter" || y.key === " " ? (Gt(y), w = void 0) : y.key === "ArrowDown" || y.key === "ArrowUp" ? (Gt(y), l.state.setOpen(!0, De(Gr, y.nativeEvent)), w = void 0) : (
      // Check for printable characters (letters, numbers, symbols)
      y.key.length === 1 && !y.ctrlKey && !y.metaKey && !y.altKey && (w = void 0)
    );
    return w;
  }
  const v = Le("div", e, {
    ref: [n, p],
    state: {
      disabled: u
    },
    props: [{
      tabIndex: -1,
      "aria-disabled": u || void 0,
      "aria-readonly": d || void 0,
      onKeyDown(y) {
        if (u || d)
          return;
        const w = h(y);
        yn.flushSync(() => {
          a(w);
        }), w === void 0 ? l.state.inputRef.current?.focus() : c.current[w]?.focus();
      }
    }, s]
  }), C = x.useMemo(() => ({
    index: m
  }), [m]);
  return /* @__PURE__ */ g(e1.Provider, {
    value: C,
    children: v
  });
});
process.env.NODE_ENV !== "production" && (ob.displayName = "ComboboxChip");
const rb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, c = Tn(), {
    index: u
  } = FS(), d = ve(c, Oe.disabled), f = ve(c, Oe.readOnly), p = ve(c, Oe.selectedValue), m = ve(c, Oe.isItemEqualToValue), h = d || i, {
    buttonRef: b,
    getButtonProps: v
  } = qt({
    native: s,
    disabled: h || f,
    focusableWhenDisabled: !0
  }), C = {
    disabled: h
  };
  function y(S) {
    const E = c.state.activeIndex;
    if (E == null)
      return;
    const N = Do(c.state.valuesRef.current, S, m);
    N !== -1 && E === N && c.state.setIndices({
      activeIndex: null,
      type: c.state.keyboardActiveRef.current ? "keyboard" : "pointer"
    });
  }
  function w(S) {
    const E = De(p8, S.nativeEvent), N = p[u];
    return y(N), c.state.setSelectedValue(p.filter((I, M) => M !== u), E), c.state.inputRef.current?.focus(), E;
  }
  return Le("button", e, {
    ref: [n, b],
    state: C,
    props: [{
      tabIndex: -1,
      onMouseDown(S) {
        S.preventDefault();
      },
      onClick(S) {
        if (h || f)
          return;
        w(S).isPropagationAllowed || S.stopPropagation();
      },
      onKeyDown(S) {
        h || f || (S.key === "Enter" || S.key === " ") && (w(S).isPropagationAllowed || Gt(S));
      }
    }, a, v]
  });
});
process.env.NODE_ENV !== "production" && (rb.displayName = "ComboboxChipRemove");
const ib = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Le("div", e, {
    ref: n,
    props: [{
      role: "row"
    }, s]
  });
  return /* @__PURE__ */ g(Jf.Provider, {
    value: !0,
    children: l
  });
});
process.env.NODE_ENV !== "production" && (ib.displayName = "ComboboxRow");
const sb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, {
    filteredItems: a
  } = wo(), c = Tn(), u = X0(), d = a.length === 0 ? s : null;
  return Le("div", e, {
    ref: [n, c.state.emptyRef, u],
    props: [{
      children: d,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (sb.displayName = "ComboboxEmpty");
const $S = {
  ...Kt,
  ...Sr
}, t1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    keepMounted: l = !1,
    style: a,
    ...c
  } = e, {
    disabled: u
  } = mn(), d = Tn(), f = ve(d, Oe.selectionMode), p = ve(d, Oe.disabled), m = ve(d, Oe.readOnly), h = ve(d, Oe.open), b = ve(d, Oe.selectedValue), v = ve(d, Oe.hasSelectionChips), C = Wf();
  let y = !1;
  f === "none" ? y = C !== "" : f === "single" ? y = b != null : y = v;
  const w = u || p || i, {
    buttonRef: R,
    getButtonProps: S
  } = qt({
    native: s,
    disabled: w
  }), {
    mounted: E,
    transitionStatus: N,
    setMounted: I
  } = to(y), M = {
    disabled: w,
    open: h,
    transitionStatus: N
  };
  Jt({
    open: y,
    ref: d.state.clearRef,
    onComplete() {
      y || I(!1);
    }
  });
  const T = Le("button", e, {
    state: M,
    ref: [n, R, d.state.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(P) {
        P.preventDefault();
      },
      onClick(P) {
        if (w || m)
          return;
        const D = d.state.keyboardActiveRef;
        d.state.setInputValue("", De(X1, P.nativeEvent)), f !== "none" ? (d.state.setSelectedValue(Array.isArray(b) ? [] : null, De(X1, P.nativeEvent)), d.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: D.current ? "keyboard" : "pointer"
        })) : d.state.setIndices({
          activeIndex: null,
          type: D.current ? "keyboard" : "pointer"
        }), d.state.inputRef.current?.focus();
      }
    }, c, S],
    stateAttributesMapping: $S
  });
  return l || E ? T : null;
});
process.env.NODE_ENV !== "production" && (t1.displayName = "ComboboxClear");
function HS() {
  return wo().filteredItems;
}
function zS(t) {
  const e = W.c(65), {
    id: n,
    options: o,
    selectedOption: r,
    onValueChange: i,
    open: s,
    onOpenChange: l,
    disabled: a,
    readOnly: c,
    required: u,
    name: d,
    placeholder: f,
    label: p,
    "data-testid": m,
    renderValue: h,
    renderOption: b,
    popupWidth: v,
    triggerClassName: C
  } = t, y = en(), [w, R] = qe(""), S = r ?? null;
  let E;
  e[0] !== i ? (E = (ce, oe) => i(ce?.value ?? null, oe), e[0] = i, e[1] = E) : E = e[1];
  const N = s ? w : r?.label ?? "";
  let I;
  e[2] !== l ? (I = (ce) => {
    l(ce), ce && R("");
  }, e[2] = l, e[3] = I) : I = e[3];
  const M = a && "cursor-not-allowed";
  let T;
  e[4] !== M || e[5] !== C ? (T = ne(C, "relative", "[&:not([data-readonly])]:focus-within:border-input-active-outline", M), e[4] = M, e[5] = C, e[6] = T) : T = e[6];
  let k;
  e[7] !== s || e[8] !== f || e[9] !== c || e[10] !== h || e[11] !== r ? (k = !s && /* @__PURE__ */ g("span", { className: ne("pointer-events-none absolute inset-y-0 left-(--spacing-10) flex min-w-0 items-center text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", c ? "right-(--spacing-10)" : "right-(--spacing-32)"), children: h ? h(r) : r ? /* @__PURE__ */ g("span", { className: "truncate", children: r.label }) : c ? null : /* @__PURE__ */ g("span", { className: "truncate text-input-text-placeholder", children: f }) }), e[7] = s, e[8] = f, e[9] = c, e[10] = h, e[11] = r, e[12] = k) : k = e[12];
  const P = p || n ? void 0 : c ? "Select option" : f ?? "Select option", D = u || void 0, O = c ? -1 : void 0, V = !s && "text-transparent caret-transparent";
  let _;
  e[13] !== V ? (_ = ne("min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", V), e[13] = V, e[14] = _) : _ = e[14];
  const A = s ? "Search" : void 0;
  let L;
  e[15] !== c ? (L = (ce) => {
    c && ce.preventDefault();
  }, e[15] = c, e[16] = L) : L = e[16];
  let $;
  e[17] !== m || e[18] !== n || e[19] !== O || e[20] !== _ || e[21] !== A || e[22] !== L || e[23] !== P || e[24] !== D ? ($ = /* @__PURE__ */ g(_s, { id: n, "data-testid": m, "aria-label": P, "aria-required": D, tabIndex: O, className: _, placeholder: A, onFocus: BS, onMouseDown: L }), e[17] = m, e[18] = n, e[19] = O, e[20] = _, e[21] = A, e[22] = L, e[23] = P, e[24] = D, e[25] = $) : $ = e[25];
  let B;
  e[26] !== m || e[27] !== c ? (B = !c && /* @__PURE__ */ g(_a, { "data-testid": m ? `${m}-trigger` : void 0, "aria-label": "Open options", className: "inline-flex shrink-0 text-input-text-default outline-none", children: /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[26] = m, e[27] = c, e[28] = B) : B = e[28];
  let z;
  e[29] !== $ || e[30] !== B || e[31] !== T || e[32] !== k ? (z = /* @__PURE__ */ F(Da, { className: T, children: [
    k,
    $,
    B
  ] }), e[29] = $, e[30] = B, e[31] = T, e[32] = k, e[33] = z) : z = e[33];
  const H = v === "content" ? "w-auto min-w-(--anchor-width) max-w-[calc(100vw-var(--spacing-16))]" : "w-(--anchor-width) min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]";
  let K;
  e[34] !== H ? (K = ne("z-[var(--z-layer-popover)]", H), e[34] = H, e[35] = K) : K = e[35];
  let G;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = pi({
    size: "auto"
  }), e[36] = G) : G = e[36];
  const q = m ? `${m}-options` : void 0;
  let Q;
  e[37] !== b || e[38] !== r?.value ? (Q = (ce) => /* @__PURE__ */ F(As, { value: ce, disabled: ce.disabled, className: bo({}), children: [
    ce.icon && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ue, { name: ce.icon, size: "xs", tone: "inherit" }) }),
    /* @__PURE__ */ g(xr, { checked: ce.value === r?.value, children: b ? b(ce) : ce.label })
  ] }, ce.value), e[37] = b, e[38] = r?.value, e[39] = Q) : Q = e[39];
  let U;
  e[40] !== q || e[41] !== Q ? (U = /* @__PURE__ */ g(Vs, { "data-testid": q, className: "flex flex-col outline-none", children: Q }), e[40] = q, e[41] = Q, e[42] = U) : U = e[42];
  let X;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (X = /* @__PURE__ */ g(sb, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[43] = X) : X = e[43];
  let te;
  e[44] !== U ? (te = /* @__PURE__ */ F(La, { className: G, children: [
    U,
    X
  ] }), e[44] = U, e[45] = te) : te = e[45];
  let re;
  e[46] !== K || e[47] !== te ? (re = /* @__PURE__ */ g(Aa, { sideOffset: 4, className: K, children: te }), e[46] = K, e[47] = te, e[48] = re) : re = e[48];
  let J;
  e[49] !== y || e[50] !== re ? (J = /* @__PURE__ */ g(Va, { container: y, children: re }), e[49] = y, e[50] = re, e[51] = J) : J = e[51];
  let ie;
  return e[52] !== a || e[53] !== d || e[54] !== s || e[55] !== o || e[56] !== c || e[57] !== u || e[58] !== S || e[59] !== z || e[60] !== E || e[61] !== J || e[62] !== N || e[63] !== I ? (ie = /* @__PURE__ */ F(Uf, { value: S, onValueChange: E, disabled: a, readOnly: c, required: u, name: d, modal: !1, items: o, isItemEqualToValue: GS, itemToStringLabel: US, itemToStringValue: WS, open: s, inputValue: N, onInputValueChange: R, onOpenChange: I, children: [
    z,
    J
  ] }), e[52] = a, e[53] = d, e[54] = s, e[55] = o, e[56] = c, e[57] = u, e[58] = S, e[59] = z, e[60] = E, e[61] = J, e[62] = N, e[63] = I, e[64] = ie) : ie = e[64], ie;
}
function BS(t) {
  return t.currentTarget.select();
}
function WS(t) {
  return t.value;
}
function US(t) {
  return t.label;
}
function GS(t, e) {
  return t.value === e.value;
}
const YS = ae(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "data-[disabled]:cursor-not-allowed", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function n1(t) {
  const e = W.c(52), {
    id: n,
    options: o,
    value: r,
    onChange: i,
    defaultValue: s,
    placeholder: l,
    size: a,
    label: c,
    tooltip: u,
    required: d,
    description: f,
    error: p,
    disabled: m,
    readOnly: h,
    reserveSubtextSpace: b,
    name: v,
    "data-testid": C,
    renderValue: y,
    renderOption: w,
    popupWidth: R,
    searchable: S
  } = t, E = a === void 0 ? "md" : a, N = h === void 0 ? !1 : h, I = b === void 0 ? !0 : b, M = R === void 0 ? "anchor" : R, T = S === void 0 ? !1 : S, k = !!p, D = I || k || !!f, O = r !== void 0, [V, _] = qe(s ?? null), [A, L] = qe(!1), $ = A && !N;
  let B, z;
  e[0] !== N ? (B = () => {
    N && L(!1);
  }, z = [N], e[0] = N, e[1] = B, e[2] = z) : (B = e[1], z = e[2]), Nt(B, z);
  const H = O ? r : V;
  let K;
  if (e[3] !== H || e[4] !== o) {
    let ce;
    e[6] !== H ? (ce = (oe) => oe.value === H, e[6] = H, e[7] = ce) : ce = e[7], K = o.find(ce), e[3] = H, e[4] = o, e[5] = K;
  } else
    K = e[5];
  const G = K;
  let q;
  e[8] !== H || e[9] !== O || e[10] !== i || e[11] !== d ? (q = function(oe, se) {
    const pe = se.reason === "item-press" && !d && H !== null && oe === H ? null : oe;
    i?.(pe, se), !O && !se.isCanceled && _(pe);
  }, e[8] = H, e[9] = O, e[10] = i, e[11] = d, e[12] = q) : q = e[12];
  const Q = q;
  let U;
  e[13] !== m || e[14] !== k || e[15] !== E ? (U = ne(YS({
    size: E
  }), !k && "data-[readonly]:border-input-readonly-outline", m && "opacity-50", k && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[13] = m, e[14] = k, e[15] = E, e[16] = U) : U = e[16];
  const X = U;
  let te;
  e[17] !== c || e[18] !== d || e[19] !== u ? (te = c && /* @__PURE__ */ g(yi, { label: c, required: d, tooltip: u }), e[17] = c, e[18] = d, e[19] = u, e[20] = te) : te = e[20];
  let re;
  e[21] !== H || e[22] !== C || e[23] !== m || e[24] !== Q || e[25] !== n || e[26] !== $ || e[27] !== c || e[28] !== v || e[29] !== o || e[30] !== l || e[31] !== M || e[32] !== N || e[33] !== w || e[34] !== y || e[35] !== d || e[36] !== T || e[37] !== G || e[38] !== X ? (re = T ? /* @__PURE__ */ g(zS, { id: n, options: o, selectedOption: G, onValueChange: Q, open: $, onOpenChange: L, disabled: m, readOnly: N, required: d, name: v, placeholder: l, label: c, "data-testid": C, renderValue: y, renderOption: w, popupWidth: M, triggerClassName: X }) : /* @__PURE__ */ g(ES, { id: n, options: o, value: H, selectedOption: G, onValueChange: Q, open: $, onOpenChange: L, disabled: m, readOnly: N, required: d, name: v, placeholder: l, label: c, "data-testid": C, renderValue: y, renderOption: w, popupWidth: M, triggerClassName: X }), e[21] = H, e[22] = C, e[23] = m, e[24] = Q, e[25] = n, e[26] = $, e[27] = c, e[28] = v, e[29] = o, e[30] = l, e[31] = M, e[32] = N, e[33] = w, e[34] = y, e[35] = d, e[36] = T, e[37] = G, e[38] = X, e[39] = re) : re = e[39];
  let J;
  e[40] !== f || e[41] !== p || e[42] !== k || e[43] !== I || e[44] !== D ? (J = D && /* @__PURE__ */ g("div", { "data-testid": "select-subtext-row", className: ne("mt-(--spacing-4)", I && "min-h-(--spacing-20)"), children: k ? /* @__PURE__ */ g(Ar, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: p }) : f ? /* @__PURE__ */ g(bi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: f }) : null }), e[40] = f, e[41] = p, e[42] = k, e[43] = I, e[44] = D, e[45] = J) : J = e[45];
  let ie;
  return e[46] !== m || e[47] !== k || e[48] !== te || e[49] !== re || e[50] !== J ? (ie = /* @__PURE__ */ F(Vr, { invalid: k, disabled: m, className: "flex flex-col w-full", children: [
    te,
    re,
    J
  ] }), e[46] = m, e[47] = k, e[48] = te, e[49] = re, e[50] = J, e[51] = ie) : ie = e[51], ie;
}
function MD(t) {
  const e = W.c(27), {
    label: n,
    options: o,
    value: r,
    onChange: i,
    placeholder: s,
    disabled: l,
    "data-testid": a
  } = t, {
    collapsed: c
  } = wf(), u = $t(), d = c ? "sr-only" : "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle uppercase";
  let f;
  e[0] !== n || e[1] !== u || e[2] !== d ? (f = /* @__PURE__ */ g("label", { htmlFor: u, className: d, children: n }), e[0] = n, e[1] = u, e[2] = d, e[3] = f) : f = e[3];
  let p;
  e[4] !== c ? (p = c ? /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }) : null, e[4] = c, e[5] = p) : p = e[5];
  const m = c ? "flex w-full justify-center" : void 0, h = c ? "w-[calc(var(--spacing-40)+var(--spacing-20))] shrink-0" : void 0;
  let b;
  e[6] !== i ? (b = (R) => i(R), e[6] = i, e[7] = b) : b = e[7];
  let v;
  e[8] !== a || e[9] !== l || e[10] !== o || e[11] !== s || e[12] !== u || e[13] !== b || e[14] !== r ? (v = /* @__PURE__ */ g(n1, { id: u, searchable: !0, "data-testid": a, disabled: l, placeholder: s, options: o, popupWidth: "content", reserveSubtextSpace: !1, value: r, onChange: b }), e[8] = a, e[9] = l, e[10] = o, e[11] = s, e[12] = u, e[13] = b, e[14] = r, e[15] = v) : v = e[15];
  let C;
  e[16] !== h || e[17] !== v ? (C = /* @__PURE__ */ g("div", { className: h, children: v }), e[16] = h, e[17] = v, e[18] = C) : C = e[18];
  let y;
  e[19] !== m || e[20] !== C ? (y = /* @__PURE__ */ g("div", { className: m, children: C }), e[19] = m, e[20] = C, e[21] = y) : y = e[21];
  let w;
  return e[22] !== n || e[23] !== f || e[24] !== p || e[25] !== y ? (w = /* @__PURE__ */ F("section", { "aria-label": n, className: "flex flex-col gap-(--spacing-4)", children: [
    f,
    p,
    y
  ] }), e[22] = n, e[23] = f, e[24] = p, e[25] = y, e[26] = w) : w = e[26], w;
}
const jS = ae(["w-full", "flex", "items-start", "justify-between", "gap-(--spacing-24)", "p-(--spacing-12)", "rounded-(--radius-sm)"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), KS = {
  neutral: "circle-info",
  informative: "circle-info",
  positive: "circle-check",
  warning: "warning",
  negative: "warning"
};
function Pm(t) {
  const e = W.c(33);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: s,
    title: l,
    subtext: i,
    action: n,
    onDismiss: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "neutral" : s, c = a === "negative", u = !!(n || o), d = c ? "alert" : "note", f = c ? "assertive" : void 0;
  let p;
  e[7] !== a ? (p = ne(jS({
    tone: a
  })), e[7] = a, e[8] = p) : p = e[8];
  const m = KS[a];
  let h;
  e[9] !== m ? (h = /* @__PURE__ */ g(Ue, { name: m, size: "md", tone: "inherit" }), e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    color: "inherit"
  }, e[11] = b) : b = e[11];
  let v;
  e[12] !== l ? (v = /* @__PURE__ */ g(Mn, { as: "span", size: "sm", style: b, children: l }), e[12] = l, e[13] = v) : v = e[13];
  let C;
  e[14] !== i ? (C = i ? /* @__PURE__ */ g(an, { as: "span", size: "sm", style: {
    color: "inherit"
  }, children: i }) : null, e[14] = i, e[15] = C) : C = e[15];
  let y;
  e[16] !== v || e[17] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) min-w-0", children: [
    v,
    C
  ] }), e[16] = v, e[17] = C, e[18] = y) : y = e[18];
  let w;
  e[19] !== y || e[20] !== h ? (w = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    h,
    y
  ] }), e[19] = y, e[20] = h, e[21] = w) : w = e[21];
  let R;
  e[22] !== n || e[23] !== u || e[24] !== o ? (R = u ? /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    o ? /* @__PURE__ */ g(bt, { icon: "x-close", "aria-label": "Dismiss alert", variant: "ghost", size: "sm", onClick: o }) : null
  ] }) : null, e[22] = n, e[23] = u, e[24] = o, e[25] = R) : R = e[25];
  let S;
  return e[26] !== r || e[27] !== w || e[28] !== R || e[29] !== d || e[30] !== f || e[31] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...r, children: [
    w,
    R
  ] }), e[26] = r, e[27] = w, e[28] = R, e[29] = d, e[30] = f, e[31] = p, e[32] = S) : S = e[32], S;
}
function qS(t) {
  const e = W.c(14), {
    stableCount: n,
    watchingCount: o,
    maintenanceCount: r
  } = t, i = n + o + r;
  if (i === 0) {
    let p;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "h-(--spacing-8) w-full rounded-(--radius-none) bg-surface-inverse-surface/20" }), e[0] = p) : p = e[0], p;
  }
  const s = n / i * 100, l = o / i * 100, a = r / i * 100;
  let c;
  e[1] !== n || e[2] !== s ? (c = n > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-stable", className: "h-full rounded-(--radius-none) bg-datavis-crit-green", style: {
    width: `${s}%`
  } }), e[1] = n, e[2] = s, e[3] = c) : c = e[3];
  let u;
  e[4] !== o || e[5] !== l ? (u = o > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-watching", className: "h-full rounded-(--radius-none) bg-datavis-crit-yellow", style: {
    width: `${l}%`
  } }), e[4] = o, e[5] = l, e[6] = u) : u = e[6];
  let d;
  e[7] !== r || e[8] !== a ? (d = r > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-maintenance", className: "h-full rounded-(--radius-none) bg-datavis-crit-red", style: {
    width: `${a}%`
  } }), e[7] = r, e[8] = a, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ F("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "flex h-(--spacing-8) w-full gap-(--spacing-6)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
const Dl = 6, ZS = 4;
function XS(t) {
  return ZS / (2 * Math.PI * t) * 360;
}
function Mm(t, e, n, o) {
  const r = (o - 90) * Math.PI / 180;
  return {
    x: t + n * Math.cos(r),
    y: e + n * Math.sin(r)
  };
}
function QS(t, e, n, o, r) {
  const i = Mm(t, e, n, r), s = Mm(t, e, n, o), l = r - o > 180 ? 1 : 0;
  return `M ${i.x} ${i.y} A ${n} ${n} 0 ${l} 0 ${s.x} ${s.y}`;
}
const JS = ["Stable", "Watching", "Maintenance Recommended"], eR = ["stroke-datavis-crit-green", "stroke-datavis-crit-yellow", "stroke-datavis-crit-red"];
function tR(t) {
  const e = W.c(51), {
    size: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t, l = n / 2, a = n / 2, c = (n - Dl) / 2, u = r + i + s, d = u === 0;
  let f;
  e[0] !== d || e[1] !== u ? (f = d ? "--" : u >= 1e4 ? `${Math.round(u / 1e3)}k` : String(u), e[0] = d, e[1] = u, e[2] = f) : f = e[2];
  const p = f, m = n >= 80 ? "var(--font-size-title-xl)" : "var(--font-size-title-sm)", h = n >= 80 ? "var(--font-size-title-sm)" : "var(--font-size-title-xs)", b = a - 4;
  let v;
  e[3] !== p || e[4] !== m || e[5] !== l || e[6] !== b ? (v = /* @__PURE__ */ g("text", { x: l, y: b, textAnchor: "middle", dominantBaseline: "auto", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: m, className: "fill-text-default", "data-testid": "asset-status-donut-count", children: p }), e[3] = p, e[4] = m, e[5] = l, e[6] = b, e[7] = v) : v = e[7];
  const C = a + 4;
  let y;
  e[8] !== l || e[9] !== C || e[10] !== o || e[11] !== h ? (y = /* @__PURE__ */ g("text", { x: l, y: C, textAnchor: "middle", dominantBaseline: "hanging", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: h, className: "fill-text-subtext", "data-testid": "asset-status-donut-unit", children: o }), e[8] = l, e[9] = C, e[10] = o, e[11] = h, e[12] = y) : y = e[12];
  let w;
  e[13] !== v || e[14] !== y ? (w = /* @__PURE__ */ F(_t, { children: [
    v,
    y
  ] }), e[13] = v, e[14] = y, e[15] = w) : w = e[15];
  const R = w;
  if (d) {
    let V;
    e[16] !== l || e[17] !== a || e[18] !== c ? (V = /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: "stroke-surface-inverse-surface/20", strokeWidth: Dl }), e[16] = l, e[17] = a, e[18] = c, e[19] = V) : V = e[19];
    let _;
    return e[20] !== R || e[21] !== n || e[22] !== V ? (_ = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": "No asset status data available", "data-testid": "asset-status-donut", children: [
      V,
      R
    ] }), e[20] = R, e[21] = n, e[22] = V, e[23] = _) : _ = e[23], _;
  }
  let S;
  e[24] !== s || e[25] !== r || e[26] !== i ? (S = [r, i, s].map(rR).filter(oR), e[24] = s, e[25] = r, e[26] = i, e[27] = S) : S = e[27];
  const E = S;
  let N;
  e[28] !== c || e[29] !== E.length ? (N = E.length > 1 ? XS(c) : 0, e[28] = c, e[29] = E.length, e[30] = N) : N = e[30];
  const I = N, T = 360 - E.length * I;
  let k;
  if (e[31] !== T || e[32] !== l || e[33] !== a || e[34] !== I || e[35] !== c || e[36] !== E || e[37] !== u) {
    k = [];
    let V = 0;
    for (const _ of E) {
      const A = _.count / u * T;
      k.push({
        path: QS(l, a, c, V, V + A),
        strokeClassName: _.strokeClassName,
        label: `${_.label}: ${_.count}`
      }), V = V + (A + I);
    }
    e[31] = T, e[32] = l, e[33] = a, e[34] = I, e[35] = c, e[36] = E, e[37] = u, e[38] = k;
  } else
    k = e[38];
  const P = `Asset status: ${r} stable, ${i} watching, ${s} maintenance`;
  let D;
  e[39] !== k || e[40] !== l || e[41] !== a || e[42] !== c || e[43] !== E[0] || e[44] !== E.length ? (D = E.length === 1 ? /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: E[0].strokeClassName, strokeWidth: Dl, "aria-label": `${E[0].label}: ${E[0].count}`, "data-testid": "asset-status-donut-segment" }) : k.map(nR), e[39] = k, e[40] = l, e[41] = a, e[42] = c, e[43] = E[0], e[44] = E.length, e[45] = D) : D = e[45];
  let O;
  return e[46] !== R || e[47] !== n || e[48] !== D || e[49] !== P ? (O = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": P, "data-testid": "asset-status-donut", children: [
    D,
    R
  ] }), e[46] = R, e[47] = n, e[48] = D, e[49] = P, e[50] = O) : O = e[50], O;
}
function nR(t) {
  return /* @__PURE__ */ g("path", { d: t.path, fill: "none", className: t.strokeClassName, strokeWidth: Dl, "aria-label": t.label, "data-testid": "asset-status-donut-segment" }, t.label);
}
function oR(t) {
  return t.count > 0;
}
function rR(t, e) {
  return {
    count: t,
    strokeClassName: eR[e],
    label: JS[e]
  };
}
const iR = {
  md: "var(--font-size-title-sm)",
  sm: "var(--font-size-title-xs)"
};
function Rc(t) {
  const e = W.c(20), {
    size: n,
    icon: o,
    iconColor: r,
    chipTone: i,
    label: s,
    count: l
  } = t;
  let a;
  e[0] !== o ? (a = /* @__PURE__ */ g(Ue, { name: o, size: "xs", tone: "inherit" }), e[0] = o, e[1] = a) : a = e[1];
  let c;
  e[2] !== r || e[3] !== a ? (c = /* @__PURE__ */ g("span", { className: r, "aria-hidden": "true", children: a }), e[2] = r, e[3] = a, e[4] = c) : c = e[4];
  const u = iR[n];
  let d;
  e[5] !== u ? (d = {
    fontSize: u
  }, e[5] = u, e[6] = d) : d = e[6];
  let f;
  e[7] !== s || e[8] !== d ? (f = /* @__PURE__ */ g("span", { className: "truncate font-(family-name:--font-family-title) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default", style: d, children: s }), e[7] = s, e[8] = d, e[9] = f) : f = e[9];
  let p;
  e[10] !== c || e[11] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) min-w-0", children: [
    c,
    f
  ] }), e[10] = c, e[11] = f, e[12] = p) : p = e[12];
  const m = n === "md" ? o : void 0;
  let h;
  e[13] !== i || e[14] !== l || e[15] !== m ? (h = /* @__PURE__ */ g(Wn, { tone: i, icon: m, label: l }), e[13] = i, e[14] = l, e[15] = m, e[16] = h) : h = e[16];
  let b;
  return e[17] !== p || e[18] !== h ? (b = /* @__PURE__ */ F("div", { className: "grid w-full grid-cols-[minmax(0,1fr)_max-content] items-center gap-(--spacing-8)", "data-testid": "asset-status-key-row", children: [
    p,
    h
  ] }), e[17] = p, e[18] = h, e[19] = b) : b = e[19], b;
}
function Tm(t) {
  const e = W.c(19), {
    labels: n,
    size: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t;
  let l;
  e[0] !== n ? (l = n === void 0 ? {
    stable: "Stable",
    watching: "Watching",
    maintenance: "Maintenance Recommended"
  } : n, e[0] = n, e[1] = l) : l = e[1];
  const a = l, u = `flex w-full min-w-0 flex-col ${o === "md" ? "gap-(--spacing-6)" : "gap-(--spacing-4)"}`;
  let d;
  e[2] !== a.stable || e[3] !== o || e[4] !== r ? (d = /* @__PURE__ */ g(Rc, { size: o, icon: "circle-check", iconColor: "text-datavis-crit-green", chipTone: "positive", label: a.stable, count: r }), e[2] = a.stable, e[3] = o, e[4] = r, e[5] = d) : d = e[5];
  let f;
  e[6] !== a.watching || e[7] !== o || e[8] !== i ? (f = /* @__PURE__ */ g(Rc, { size: o, icon: "eye-watching", iconColor: "text-datavis-crit-yellow", chipTone: "warning", label: a.watching, count: i }), e[6] = a.watching, e[7] = o, e[8] = i, e[9] = f) : f = e[9];
  let p;
  e[10] !== a.maintenance || e[11] !== s || e[12] !== o ? (p = /* @__PURE__ */ g(Rc, { size: o, icon: "maintenance", iconColor: "text-datavis-crit-red", chipTone: "negative", label: a.maintenance, count: s }), e[10] = a.maintenance, e[11] = s, e[12] = o, e[13] = p) : p = e[13];
  let m;
  return e[14] !== u || e[15] !== d || e[16] !== f || e[17] !== p ? (m = /* @__PURE__ */ F("div", { className: u, "data-testid": "asset-status-key", children: [
    d,
    f,
    p
  ] }), e[14] = u, e[15] = d, e[16] = f, e[17] = p, e[18] = m) : m = e[18], m;
}
const sR = {
  md: 88,
  sm: 80
};
function lR({
  stableCount: t,
  watchingCount: e,
  maintenanceCount: n
}) {
  const o = [t < 0 ? "stableCount" : null, e < 0 ? "watchingCount" : null, n < 0 ? "maintenanceCount" : null].filter((r) => r !== null);
  if (o.length > 0)
    throw new RangeError(`AssetStatusCard counts cannot be negative: ${o.join(", ")}`);
}
function aR(t) {
  return t.borderBoxSize[0]?.inlineSize ?? t.contentRect.width;
}
function TD(t) {
  const e = W.c(24), {
    variant: n,
    stretch: o,
    unit: r,
    stableCount: i,
    watchingCount: s,
    maintenanceCount: l,
    labels: a,
    emptyStateTitle: c
  } = t, u = o === void 0 ? !0 : o, d = c === void 0 ? "No available asset status data. Check back later." : c;
  lR({
    stableCount: i,
    watchingCount: s,
    maintenanceCount: l
  });
  const f = at(null), [p, m] = qe("md"), h = n === "donut", b = i + s + l, v = b === 0, C = h ? "p-(--spacing-12)" : "p-(--spacing-20)";
  let y, w;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = () => {
    const M = f.current;
    if (!M || typeof ResizeObserver > "u")
      return;
    const T = (P) => {
      m(P <= 380 ? "sm" : "md");
    };
    T(M.getBoundingClientRect().width);
    const k = new ResizeObserver((P) => {
      const [D] = P;
      D && T(aR(D));
    });
    return k.observe(M), () => {
      k.disconnect();
    };
  }, w = [], e[0] = y, e[1] = w) : (y = e[0], w = e[1]), Nt(y, w);
  const R = u ? "h-full" : "h-fit";
  let S;
  e[2] !== C || e[3] !== R ? (S = ne("flex w-full min-w-0 flex-col gap-(--spacing-16) rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1", R, C), e[2] = C, e[3] = R, e[4] = S) : S = e[4];
  let E;
  e[5] !== h || e[6] !== v || e[7] !== b || e[8] !== r ? (E = !h && /* @__PURE__ */ F("div", { className: "flex items-baseline gap-(--spacing-6)", "data-testid": "asset-status-card-header", children: [
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xl) leading-(--font-line-height-28) text-text-default", children: v ? "--" : b }),
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-regular) text-(length:--font-size-title-md) leading-(--font-line-height-24) text-text-subtext", children: r })
  ] }), e[5] = h, e[6] = v, e[7] = b, e[8] = r, e[9] = E) : E = e[9];
  let N;
  e[10] !== d || e[11] !== h || e[12] !== v || e[13] !== a || e[14] !== l || e[15] !== p || e[16] !== i || e[17] !== r || e[18] !== s ? (N = h ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g("div", { className: "shrink-0", children: /* @__PURE__ */ g(tR, { size: sR[p], unit: r, stableCount: i, watchingCount: s, maintenanceCount: l }) }),
    v ? /* @__PURE__ */ g(Pm, { tone: "neutral", title: d }) : /* @__PURE__ */ g(Tm, { labels: a, size: p, stableCount: i, watchingCount: s, maintenanceCount: l })
  ] }) : /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g(qS, { stableCount: i, watchingCount: s, maintenanceCount: l }),
    v ? /* @__PURE__ */ g(Pm, { tone: "neutral", title: d }) : /* @__PURE__ */ g(Tm, { labels: a, size: p, stableCount: i, watchingCount: s, maintenanceCount: l })
  ] }), e[10] = d, e[11] = h, e[12] = v, e[13] = a, e[14] = l, e[15] = p, e[16] = i, e[17] = r, e[18] = s, e[19] = N) : N = e[19];
  let I;
  return e[20] !== S || e[21] !== E || e[22] !== N ? (I = /* @__PURE__ */ F("div", { ref: f, "data-testid": "asset-status-card", className: S, children: [
    E,
    N
  ] }), e[20] = S, e[21] = E, e[22] = N, e[23] = I) : I = e[23], I;
}
const o1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (o1.displayName = "PreviewCardRootContext");
function Ls(t) {
  const e = x.useContext(o1);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PreviewCardRootContext is missing. PreviewCard parts must be placed within <PreviewCard.Root>." : st(50));
  return e;
}
const cR = 600, lb = 300, uR = {
  ...vs,
  instantType: he((t) => t.instantType),
  hasViewport: he((t) => t.hasViewport)
};
class r1 extends Ir {
  constructor(e) {
    super({
      ...dR(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Pr(),
      closeDelayRef: {
        current: lb
      }
    }, uR);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Ut, i = e && o === gr, s = !e && (o === eo || o === Rr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Ut && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? yn.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Lt(() => new r1(n)).current, r = e ?? o, i = ys({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function dR() {
  return {
    ...bs(),
    instantType: void 0,
    hasViewport: !1
  };
}
function Om(t) {
  const {
    open: e,
    defaultOpen: n = !1,
    onOpenChange: o,
    onOpenChangeComplete: r,
    actionsRef: i,
    handle: s,
    triggerId: l,
    defaultTriggerId: a = null,
    children: c
  } = t, u = r1.useStore(s?.store, {
    open: n,
    openProp: e,
    activeTriggerId: a,
    triggerIdProp: l
  });
  Or(() => {
    e === void 0 && u.state.open === !1 && n === !0 && u.update({
      open: !0,
      activeTriggerId: a
    });
  }), u.useControlledProp("openProp", e), u.useControlledProp("triggerIdProp", l), u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", r);
  const d = u.useState("open"), f = u.select("floatingRootContext"), p = u.useState("activeTriggerId"), m = u.useState("payload");
  gs(u);
  const {
    forceUnmount: h
  } = hs(d, u);
  ke(() => {
    d && p == null && u.set("payload", void 0);
  }, [u, p, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, De(ds));
  }, [u]);
  x.useImperativeHandle(i, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = kr(f), {
    getReferenceProps: C,
    getTriggerProps: y,
    getFloatingProps: w
  } = ro([v]), R = x.useMemo(() => C(), [C]), S = x.useMemo(() => y(), [y]), E = x.useMemo(() => w(), [w]);
  return u.useSyncedValues({
    activeTriggerProps: R,
    inactiveTriggerProps: S,
    popupProps: E
  }), /* @__PURE__ */ g(o1.Provider, {
    value: u,
    children: typeof c == "function" ? c({
      payload: m
    }) : c
  });
}
function fR(t) {
  return Ls(!0) ? /* @__PURE__ */ g(Om, {
    ...t
  }) : /* @__PURE__ */ g(gd, {
    children: /* @__PURE__ */ g(Om, {
      ...t
    })
  });
}
const i1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (i1.displayName = "PreviewCardPortalContext");
function pR() {
  const t = x.useContext(i1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Portal> is missing." : st(48));
  return t;
}
const ab = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Ls().useState("mounted") || o ? /* @__PURE__ */ g(i1.Provider, {
    value: o,
    children: /* @__PURE__ */ g(Ra, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (ab.displayName = "PreviewCardPortal");
const cb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    delay: i,
    closeDelay: s,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = Ls(!0), p = c?.store ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Trigger> must be either used within a <PreviewCard.Root> component or provided with a handle." : st(89));
  const m = Ot(l), h = p.useState("isTriggerActive", m), b = p.useState("isOpenedByTrigger", m), v = p.useState("floatingRootContext"), C = x.useRef(null), y = i ?? cR, w = s ?? lb, {
    registerTrigger: R,
    isMountedByThisTrigger: S
  } = ms(m, C, p, {
    payload: a
  });
  ke(() => {
    S && (p.context.closeDelayRef.current = w);
  }, [p, S, w]);
  const E = xs(v, {
    mouseOnly: !0,
    move: !1,
    handleClose: Cs(),
    delay: () => ({
      open: y,
      close: w
    }),
    triggerElementRef: C,
    isActiveTrigger: h,
    isClosing: () => p.select("transitionStatus") === "ending"
  }), N = Rd(v, {
    delay: y
  }), I = {
    open: b
  }, M = p.useState("triggerProps", S);
  return Le("a", e, {
    state: I,
    ref: [n, R, C],
    props: [E, N.reference, M, {
      id: m
    }, d],
    stateAttributesMapping: Sr
  });
});
process.env.NODE_ENV !== "production" && (cb.displayName = "PreviewCardTrigger");
const s1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (s1.displayName = "PreviewCardPositionerContext");
function mR() {
  const t = x.useContext(s1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Popup> and <PreviewCard.Arrow> must be used within the <PreviewCard.Positioner> component" : st(49));
  return t;
}
const ub = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = ba,
    style: v,
    ...C
  } = e, y = Ls(), w = pR(), R = va(), S = y.useState("open"), E = y.useState("mounted"), N = y.useState("floatingRootContext"), I = y.useState("instantType"), M = y.useState("transitionStatus"), T = y.useState("hasViewport"), k = ai({
    anchor: i,
    floatingRootContext: N,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: T ? wa : void 0
  }), P = {
    open: S,
    side: k.side,
    align: k.align,
    anchorHidden: k.anchorHidden,
    instant: I
  }, D = di(e, P, {
    styles: k.positionerStyles,
    transitionStatus: M,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !S
  });
  return /* @__PURE__ */ g(s1.Provider, {
    value: k,
    children: /* @__PURE__ */ g(md, {
      id: R,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (ub.displayName = "PreviewCardPositioner");
const gR = {
  ...An,
  ...Kt
}, db = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Ls(), {
    side: a,
    align: c
  } = mR(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  Jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = we(() => l.context.closeDelayRef.current);
  return xa(m, {
    closeDelay: h
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Mr(f), s],
    stateAttributesMapping: gR
  });
});
process.env.NODE_ENV !== "production" && (db.displayName = "PreviewCardPopup");
const hR = "z-[var(--z-layer-popover)]";
function bR(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(fR, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function vR(t) {
  const e = W.c(8);
  let n, o, r;
  e[0] !== t ? ({
    render: o,
    delay: r,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? 0 : r;
  let s;
  return e[4] !== i || e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ g(cb, { render: o, delay: i, ...n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
function yR(t) {
  const e = W.c(21);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: n,
    className: o,
    side: i,
    align: s,
    sideOffset: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "bottom" : i, c = s === void 0 ? "center" : s, u = l === void 0 ? 8 : l, d = en();
  let f;
  e[7] !== o ? (f = ne(z2, o), e[7] = o, e[8] = f) : f = e[8];
  let p;
  e[9] !== n || e[10] !== f ? (p = /* @__PURE__ */ g(db, { className: f, children: n }), e[9] = n, e[10] = f, e[11] = p) : p = e[11];
  let m;
  e[12] !== c || e[13] !== r || e[14] !== a || e[15] !== u || e[16] !== p ? (m = /* @__PURE__ */ g(ub, { side: a, align: c, sideOffset: u, className: hR, ...r, children: p }), e[12] = c, e[13] = r, e[14] = a, e[15] = u, e[16] = p, e[17] = m) : m = e[17];
  let h;
  return e[18] !== d || e[19] !== m ? (h = /* @__PURE__ */ g(ab, { container: d, children: m }), e[18] = d, e[19] = m, e[20] = h) : h = e[20], h;
}
const xR = {
  operational: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  critical: "bg-datavis-crit-red",
  inactive: "bg-surface-container-high"
}, CR = 32, Dm = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], wR = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function SR(t) {
  if (t < 1 || t > 12)
    throw new RangeError(`AssetTimeline requires between 1 and 12 consecutive months. Received ${t}.`);
}
function RR(t, e) {
  const n = /* @__PURE__ */ new Date(), o = n.getMonth(), r = n.getFullYear();
  return Array.from({
    length: t
  }, (i, s) => {
    const l = t - s - 1, a = new Date(r, o - l, 1), c = a.getMonth(), u = a.getFullYear();
    return {
      narrowLabel: e?.(a, "narrow") ?? Dm[c].slice(0, 1),
      shortLabel: e?.(a, "short") ?? Dm[c],
      longLabel: e?.(a, "long") ?? `${wR[c]} ${u}`,
      key: `${u}-${c}`
    };
  });
}
function fb(t) {
  return t.markerCount ?? t.events?.length ?? 0;
}
function ER(t) {
  const e = t.reduce((o, r) => (o[r.severity] += 1, o), {
    operational: 0,
    warning: 0,
    critical: 0,
    inactive: 0
  }), n = (o, r) => `${o} ${r} ${o === 1 ? "month" : "months"}`;
  return `Asset timeline: ${n(e.operational, "operational")}, ${n(e.warning, "warning")}, ${n(e.critical, "critical")}, ${n(e.inactive, "inactive")}.`;
}
function _m(t, e) {
  const n = fb(t), o = n === 1 ? "1 event" : `${n} events`;
  return n > 0 ? `${e.longLabel}: ${t.severity}, ${o}` : `${e.longLabel}: ${t.severity}, no events`;
}
function NR(t) {
  const e = W.c(3), {
    count: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("svg", { "aria-hidden": "true", viewBox: "0 0 8 8", className: "size-(--spacing-8) fill-informative group-focus-visible/asset-timeline-marker:fill-primary-on-primary", children: /* @__PURE__ */ g("path", { d: "M4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8ZM4 2.5C4.39782 2.5 4.77936 2.65804 5.06066 2.93934C5.34196 3.22064 5.5 3.60218 5.5 4C5.5 4.39782 5.34196 4.77936 5.06066 5.06066C4.77936 5.34196 4.39782 5.5 4 5.5C3.60218 5.5 3.22064 5.34196 2.93934 5.06066C2.65804 4.77936 2.5 4.39782 2.5 4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5Z" }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-marker", className: "inline-flex h-(--spacing-20) min-w-(--spacing-32) items-center justify-center gap-(--spacing-2) rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-6) font-(family-name:--font-family-label) font-(number:--font-weight-medium) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-default group-hover/asset-timeline-marker:bg-surface-container group-focus-visible/asset-timeline-marker:bg-primary group-focus-visible/asset-timeline-marker:text-primary-on-primary", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function kR(t) {
  const e = W.c(6), {
    count: n,
    ariaLabel: o,
    onClick: r
  } = t;
  let i;
  e[0] !== n ? (i = /* @__PURE__ */ g(NR, { count: n }), e[0] = n, e[1] = i) : i = e[1];
  let s;
  return e[2] !== o || e[3] !== r || e[4] !== i ? (s = /* @__PURE__ */ g("button", { type: "button", "aria-label": o, "data-testid": "asset-timeline-event-marker", "data-test-id": "asset-timeline-event-marker", className: "group/asset-timeline-marker cursor-pointer rounded-(--radius-xs) border-0 bg-transparent p-0 outline-none", onClick: r, children: i }), e[2] = o, e[3] = r, e[4] = i, e[5] = s) : s = e[5], s;
}
function IR(t) {
  const e = W.c(41), {
    month: n,
    meta: o,
    monthIndex: r,
    renderHoverCard: i,
    onMonthClick: s
  } = t, l = fb(n);
  let a, c;
  e[0] !== o.longLabel || e[1] !== o.shortLabel || e[2] !== n || e[3] !== r || e[4] !== i ? (a = {
    month: n,
    monthIndex: r,
    monthLabel: o.shortLabel,
    monthLongLabel: o.longLabel
  }, c = i?.(a), e[0] = o.longLabel, e[1] = o.shortLabel, e[2] = n, e[3] = r, e[4] = i, e[5] = a, e[6] = c) : (a = e[5], c = e[6]);
  const u = c;
  let d;
  e[7] !== u || e[8] !== o || e[9] !== n ? (d = u ? {} : {
    role: "img",
    "aria-label": _m(n, o)
  }, e[7] = u, e[8] = o, e[9] = n, e[10] = d) : d = e[10];
  const f = xR[n.severity];
  let p;
  e[11] !== f ? (p = ne("flex h-(--spacing-12) w-full", f), e[11] = f, e[12] = p) : p = e[12];
  let m;
  e[13] !== u || e[14] !== o || e[15] !== n ? (m = u ? /* @__PURE__ */ F(bR, { children: [
    /* @__PURE__ */ g(vR, { delay: 0, closeDelay: 0, render: /* @__PURE__ */ g("button", { type: "button", "aria-label": _m(n, o), className: "block h-full w-full cursor-pointer border-0 bg-transparent p-0 text-center outline-none focus-visible:ring-(--spacing-2) focus-visible:ring-button-focus-ring focus-visible:ring-offset-(--focus-ring-offset) focus-visible:ring-offset-surface" }) }),
    /* @__PURE__ */ g(yR, { className: "overflow-hidden", sideOffset: CR, children: u })
  ] }) : null, e[13] = u, e[14] = o, e[15] = n, e[16] = m) : m = e[16];
  let h;
  e[17] !== d || e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-fill", "data-test-id": "asset-timeline-fill", ...d, className: p, children: m }), e[17] = d, e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  const b = h;
  let v;
  e[21] !== o.narrowLabel ? (v = /* @__PURE__ */ g("span", { className: "@min-[48px]/asset-timeline-month:hidden", children: o.narrowLabel }), e[21] = o.narrowLabel, e[22] = v) : v = e[22];
  let C;
  e[23] !== o.shortLabel ? (C = /* @__PURE__ */ g("span", { className: "hidden @min-[48px]/asset-timeline-month:inline", children: o.shortLabel }), e[23] = o.shortLabel, e[24] = C) : C = e[24];
  let y;
  e[25] !== v || e[26] !== C ? (y = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "pt-(--spacing-4) font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtle", children: [
    v,
    C
  ] }), e[25] = v, e[26] = C, e[27] = y) : y = e[27];
  const w = y;
  let R;
  e[28] !== l || e[29] !== o.longLabel || e[30] !== a || e[31] !== s ? (R = l > 0 ? /* @__PURE__ */ g(kR, { count: l, ariaLabel: `${o.longLabel}: ${l} monthly events`, onClick: () => s?.(a) }) : null, e[28] = l, e[29] = o.longLabel, e[30] = a, e[31] = s, e[32] = R) : R = e[32];
  const S = R;
  let E;
  e[33] !== b || e[34] !== w ? (E = /* @__PURE__ */ F(_t, { children: [
    b,
    w
  ] }), e[33] = b, e[34] = w, e[35] = E) : E = e[35];
  const N = E;
  let I;
  e[36] !== S ? (I = S ? /* @__PURE__ */ g("span", { className: "absolute bottom-(--spacing-40)", children: S }) : null, e[36] = S, e[37] = I) : I = e[37];
  let M;
  return e[38] !== I || e[39] !== N ? (M = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-month", "data-test-id": "asset-timeline-month", className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-month-content", className: "relative flex w-full flex-col items-center pt-(--spacing-24)", children: [
    I,
    N
  ] }) }), e[38] = I, e[39] = N, e[40] = M) : M = e[40], M;
}
function OD(t) {
  const e = W.c(30);
  let n, o, r, i, s;
  e[0] !== t ? ({
    months: i,
    ariaLabel: n,
    className: o,
    formatMonthLabel: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]), SR(i.length);
  const l = "renderHoverCard" in s ? s.renderHoverCard : void 0, a = "onMonthClick" in s ? s.onMonthClick : void 0;
  let c;
  e[6] !== r || e[7] !== i.length ? (c = RR(i.length, r), e[6] = r, e[7] = i.length, e[8] = c) : c = e[8];
  const u = c, d = `repeat(${i.length}, minmax(0, 1fr))`;
  let f;
  e[9] !== d ? (f = {
    gridTemplateColumns: d
  }, e[9] = d, e[10] = f) : f = e[10];
  const p = f;
  let m;
  e[11] !== n || e[12] !== i ? (m = n ?? ER(i), e[11] = n, e[12] = i, e[13] = m) : m = e[13];
  let h;
  e[14] !== o ? (h = ne("grid w-full min-w-0 items-end gap-x-(--spacing-1)", o), e[14] = o, e[15] = h) : h = e[15];
  let b;
  if (e[16] !== u || e[17] !== i || e[18] !== a || e[19] !== l) {
    let C;
    e[21] !== u || e[22] !== a || e[23] !== l ? (C = (y, w) => /* @__PURE__ */ g(IR, { month: y, meta: u[w], monthIndex: w, renderHoverCard: l, onMonthClick: a }, u[w].key), e[21] = u, e[22] = a, e[23] = l, e[24] = C) : C = e[24], b = i.map(C), e[16] = u, e[17] = i, e[18] = a, e[19] = l, e[20] = b;
  } else
    b = e[20];
  let v;
  return e[25] !== p || e[26] !== m || e[27] !== h || e[28] !== b ? (v = /* @__PURE__ */ g("section", { "data-testid": "asset-timeline", "data-test-id": "asset-timeline", "aria-label": m, className: h, style: p, children: b }), e[25] = p, e[26] = m, e[27] = h, e[28] = b, e[29] = v) : v = e[29], v;
}
const Ur = {
  complete: "complete",
  partial: "partial",
  failed: "failed",
  unknown: "unknown"
}, Hi = {
  complete: "Complete",
  partial: "Partial",
  failed: "Failed",
  unknown: "Unknown"
}, PR = {
  loadingReleaseInfo: "Loading release info...",
  copyRecord: "Copy record",
  openSsm: "Open SSM",
  openSsmAriaLabel: "Open SSM parameter",
  recordUnavailable: "Record unavailable",
  copyPrefix: "Copy",
  rows: {
    tag: "Tag",
    status: "Status",
    sha: "SHA",
    requestedRef: "Requested ref",
    deployedAt: "Deployed at",
    ssmParameter: "SSM parameter",
    selected: "Selected",
    deployed: "Deployed",
    failed: "Failed",
    terraform: "Terraform",
    api: "API",
    frontend: "Frontend"
  },
  links: {
    githubTag: "GitHub tag",
    githubCommit: "GitHub commit",
    workflowRun: "Workflow run"
  },
  status: Hi,
  values: {
    unknown: "unknown",
    none: "none",
    notSelected: "not selected",
    deployed: "deployed"
  }
}, DD = {
  [Ur.complete]: {
    label: Hi.complete,
    icon: "circle-check",
    iconTone: "positive"
  },
  [Ur.failed]: {
    label: Hi.failed,
    icon: "circle-exclamation",
    iconTone: "negative"
  },
  [Ur.partial]: {
    label: Hi.partial,
    icon: "warning",
    iconTone: "warning"
  },
  [Ur.unknown]: {
    label: Hi.unknown,
    icon: "circle-info",
    iconTone: "neutral"
  }
};
function Vm(t, e = "unknown") {
  return t ? t.slice(0, 12) : e;
}
function MR(t) {
  return t ?? Ur.unknown;
}
function TR(t, e) {
  return e[t];
}
function OR(t, e) {
  if (!e)
    return "";
  const n = encodeURIComponent(encodeURIComponent(e));
  return `https://${t}.console.aws.amazon.com/systems-manager/parameters/${n}/description?region=${t}`;
}
function DR({
  appName: t,
  environment: e,
  recordParameterName: n,
  commitId: o,
  branchName: r,
  releaseTag: i
}) {
  return {
    app: t,
    environment: e,
    parameterName: n,
    status: Ur.unknown,
    sourceSha: o,
    requestedRef: r,
    releaseTag: i,
    selectedParts: [],
    deployedParts: [],
    failedParts: [],
    parts: {
      terraform: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      api: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      frontend: {
        selected: !1,
        result: "unknown",
        deployed: !1
      }
    }
  };
}
function Ec(t, e) {
  return !t || t.length === 0 ? e : t.join(", ");
}
function _R(t, e) {
  if (!t)
    return e;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? t : n.toLocaleString();
}
function Nc(t, e) {
  return t ? t.selected ? t.deployed ? e.deployed : t.result ?? e.unknown : e.notSelected : e.unknown;
}
function kc(t) {
  const e = W.c(23);
  let n, o, r, i, s, l, a, c, u;
  if (e[0] !== t) {
    const {
      size: p,
      destructive: m,
      disabled: h,
      children: b,
      ...v
    } = t;
    n = b, s = v;
    const C = p === void 0 ? "md" : p, y = m === void 0 ? !1 : m;
    r = h === void 0 ? !1 : h, i = "onClick" in t && t.onClick !== void 0 && !("href" in t && t.href !== void 0), o = r0({
      size: C,
      variant: i ? "navigational" : "contextual",
      destructive: y,
      disabled: r
    });
    const {
      render: w,
      href: R,
      target: S,
      rel: E,
      ...N
    } = i ? {} : s, I = S === "_blank" && !E ? "noopener noreferrer" : E;
    u = Ma, l = "a", a = w, c = cn(N, {
      ...R !== void 0 && {
        href: R
      },
      ...S !== void 0 && {
        target: S
      },
      ...I !== void 0 && {
        rel: I
      },
      ...r && {
        href: void 0,
        tabIndex: -1,
        onClick: VR
      },
      "aria-disabled": r || void 0,
      className: o,
      children: n
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[10] !== l || e[11] !== a || e[12] !== c ? (d = {
    defaultTagName: l,
    render: a,
    props: c
  }, e[10] = l, e[11] = a, e[12] = c, e[13] = d) : d = e[13];
  const f = u(d);
  if (i) {
    const p = s;
    let m, h;
    e[14] !== p ? ({
      onClick: h,
      ...m
    } = p, e[14] = p, e[15] = m, e[16] = h) : (m = e[15], h = e[16]);
    const b = m, v = r ? void 0 : h, C = r || void 0;
    let y;
    return e[17] !== n || e[18] !== o || e[19] !== b || e[20] !== v || e[21] !== C ? (y = /* @__PURE__ */ g("button", { ...b, type: "button", onClick: v, "aria-disabled": C, className: o, children: n }), e[17] = n, e[18] = o, e[19] = b, e[20] = v, e[21] = C, e[22] = y) : y = e[22], y;
  }
  return f;
}
function VR(t) {
  return t.preventDefault();
}
function AR(t) {
  const e = W.c(13), {
    display: n,
    labels: o
  } = t;
  let r;
  e[0] !== n.githubTagUrl || e[1] !== o ? (r = n.githubTagUrl ? /* @__PURE__ */ g(kc, { href: n.githubTagUrl, target: "_blank", rel: "noreferrer", children: o.links.githubTag }) : null, e[0] = n.githubTagUrl, e[1] = o, e[2] = r) : r = e[2];
  let i;
  e[3] !== n.githubCommitUrl || e[4] !== o ? (i = n.githubCommitUrl ? /* @__PURE__ */ g(kc, { href: n.githubCommitUrl, target: "_blank", rel: "noreferrer", children: o.links.githubCommit }) : null, e[3] = n.githubCommitUrl, e[4] = o, e[5] = i) : i = e[5];
  let s;
  e[6] !== n.record.workflowRunUrl || e[7] !== o ? (s = n.record.workflowRunUrl ? /* @__PURE__ */ g(kc, { href: n.record.workflowRunUrl, target: "_blank", rel: "noreferrer", children: o.links.workflowRun }) : null, e[6] = n.record.workflowRunUrl, e[7] = o, e[8] = s) : s = e[8];
  let l;
  return e[9] !== r || e[10] !== i || e[11] !== s ? (l = /* @__PURE__ */ F("div", { className: "flex flex-wrap gap-(--spacing-12)", children: [
    r,
    i,
    s
  ] }), e[9] = r, e[10] = i, e[11] = s, e[12] = l) : l = e[12], l;
}
function $n(t) {
  const e = W.c(17), {
    label: n,
    value: o,
    copyValue: r,
    copiedLabel: i,
    copyPrefix: s,
    onCopy: l,
    unknownValue: a,
    noneValue: c
  } = t, u = r ?? o, d = typeof navigator < "u" && !!navigator.clipboard?.writeText, f = !!(u && u !== a && u !== c), p = i === n;
  let m;
  e[0] !== n ? (m = /* @__PURE__ */ g("div", { className: "max-sm:col-span-2", children: /* @__PURE__ */ g(an, { as: "div", size: "sm", tone: "subtle", children: n }) }), e[0] = n, e[1] = m) : m = e[1];
  const h = o || a;
  let b;
  e[2] !== h ? (b = /* @__PURE__ */ g("code", { className: "min-w-0 truncate rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-4) font-mono text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: h }), e[2] = h, e[3] = b) : b = e[3];
  const v = p ? "check-mark" : "copy-regular", C = `${s} ${n}`, y = !f || !d;
  let w;
  e[4] !== n || e[5] !== l || e[6] !== u ? (w = () => {
    l(u, n);
  }, e[4] = n, e[5] = l, e[6] = u, e[7] = w) : w = e[7];
  let R;
  e[8] !== v || e[9] !== C || e[10] !== y || e[11] !== w ? (R = /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: v, "aria-label": C, disabled: y, onClick: w }), e[8] = v, e[9] = C, e[10] = y, e[11] = w, e[12] = R) : R = e[12];
  let S;
  return e[13] !== m || e[14] !== b || e[15] !== R ? (S = /* @__PURE__ */ F("div", { className: "grid grid-cols-[128px_minmax(0,1fr)_var(--spacing-32)] items-center gap-(--spacing-8) border-b border-outline-subtle py-(--spacing-8) last:border-b-0 max-sm:grid-cols-[1fr_var(--spacing-32)]", children: [
    m,
    b,
    R
  ] }), e[13] = m, e[14] = b, e[15] = R, e[16] = S) : S = e[16], S;
}
function LR(t) {
  const e = W.c(76), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t, s = r.rows.selected;
  let l;
  e[0] !== n.record.selectedParts || e[1] !== r.values.none ? (l = Ec(n.record.selectedParts, r.values.none), e[0] = n.record.selectedParts, e[1] = r.values.none, e[2] = l) : l = e[2];
  let a;
  e[3] !== o || e[4] !== r.copyPrefix || e[5] !== r.rows.selected || e[6] !== r.values.none || e[7] !== r.values.unknown || e[8] !== i || e[9] !== l ? (a = /* @__PURE__ */ g($n, { label: s, value: l, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[3] = o, e[4] = r.copyPrefix, e[5] = r.rows.selected, e[6] = r.values.none, e[7] = r.values.unknown, e[8] = i, e[9] = l, e[10] = a) : a = e[10];
  const c = r.rows.deployed;
  let u;
  e[11] !== n.record.deployedParts || e[12] !== r.values.none ? (u = Ec(n.record.deployedParts, r.values.none), e[11] = n.record.deployedParts, e[12] = r.values.none, e[13] = u) : u = e[13];
  let d;
  e[14] !== o || e[15] !== r.copyPrefix || e[16] !== r.rows.deployed || e[17] !== r.values.none || e[18] !== r.values.unknown || e[19] !== i || e[20] !== u ? (d = /* @__PURE__ */ g($n, { label: c, value: u, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[14] = o, e[15] = r.copyPrefix, e[16] = r.rows.deployed, e[17] = r.values.none, e[18] = r.values.unknown, e[19] = i, e[20] = u, e[21] = d) : d = e[21];
  const f = r.rows.failed;
  let p;
  e[22] !== n.record.failedParts || e[23] !== r.values.none ? (p = Ec(n.record.failedParts, r.values.none), e[22] = n.record.failedParts, e[23] = r.values.none, e[24] = p) : p = e[24];
  let m;
  e[25] !== o || e[26] !== r.copyPrefix || e[27] !== r.rows.failed || e[28] !== r.values.none || e[29] !== r.values.unknown || e[30] !== i || e[31] !== p ? (m = /* @__PURE__ */ g($n, { label: f, value: p, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[25] = o, e[26] = r.copyPrefix, e[27] = r.rows.failed, e[28] = r.values.none, e[29] = r.values.unknown, e[30] = i, e[31] = p, e[32] = m) : m = e[32];
  const h = r.rows.terraform, b = n.record.parts?.terraform;
  let v;
  e[33] !== r.values || e[34] !== b ? (v = Nc(b, r.values), e[33] = r.values, e[34] = b, e[35] = v) : v = e[35];
  const C = n.record.parts?.terraform?.sha;
  let y;
  e[36] !== o || e[37] !== r.copyPrefix || e[38] !== r.rows.terraform || e[39] !== r.values.none || e[40] !== r.values.unknown || e[41] !== i || e[42] !== v || e[43] !== C ? (y = /* @__PURE__ */ g($n, { label: h, value: v, copyValue: C, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[36] = o, e[37] = r.copyPrefix, e[38] = r.rows.terraform, e[39] = r.values.none, e[40] = r.values.unknown, e[41] = i, e[42] = v, e[43] = C, e[44] = y) : y = e[44];
  const w = r.rows.api, R = n.record.parts?.api;
  let S;
  e[45] !== r.values || e[46] !== R ? (S = Nc(R, r.values), e[45] = r.values, e[46] = R, e[47] = S) : S = e[47];
  const E = n.record.parts?.api?.image ?? n.record.apiImage;
  let N;
  e[48] !== o || e[49] !== r.copyPrefix || e[50] !== r.rows.api || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i || e[54] !== S || e[55] !== E ? (N = /* @__PURE__ */ g($n, { label: w, value: S, copyValue: E, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[48] = o, e[49] = r.copyPrefix, e[50] = r.rows.api, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = S, e[55] = E, e[56] = N) : N = e[56];
  const I = r.rows.frontend, M = n.record.parts?.frontend;
  let T;
  e[57] !== r.values || e[58] !== M ? (T = Nc(M, r.values), e[57] = r.values, e[58] = M, e[59] = T) : T = e[59];
  const k = n.record.parts?.frontend?.cloudfrontDistributionId ?? n.record.frontendCloudfrontDistributionId;
  let P;
  e[60] !== o || e[61] !== r.copyPrefix || e[62] !== r.rows.frontend || e[63] !== r.values.none || e[64] !== r.values.unknown || e[65] !== i || e[66] !== T || e[67] !== k ? (P = /* @__PURE__ */ g($n, { label: I, value: T, copyValue: k, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[60] = o, e[61] = r.copyPrefix, e[62] = r.rows.frontend, e[63] = r.values.none, e[64] = r.values.unknown, e[65] = i, e[66] = T, e[67] = k, e[68] = P) : P = e[68];
  let D;
  return e[69] !== y || e[70] !== N || e[71] !== P || e[72] !== a || e[73] !== d || e[74] !== m ? (D = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    a,
    d,
    m,
    y,
    N,
    P
  ] }), e[69] = y, e[70] = N, e[71] = P, e[72] = a, e[73] = d, e[74] = m, e[75] = D) : D = e[75], D;
}
function FR(t) {
  const e = W.c(62), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t;
  let s;
  e[0] !== o || e[1] !== n.displayTag || e[2] !== r.copyPrefix || e[3] !== r.rows.tag || e[4] !== r.values.none || e[5] !== r.values.unknown || e[6] !== i ? (s = /* @__PURE__ */ g($n, { label: r.rows.tag, value: n.displayTag, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[0] = o, e[1] = n.displayTag, e[2] = r.copyPrefix, e[3] = r.rows.tag, e[4] = r.values.none, e[5] = r.values.unknown, e[6] = i, e[7] = s) : s = e[7];
  const l = r.rows.status;
  let a;
  e[8] !== n.status || e[9] !== r.status ? (a = TR(n.status, r.status), e[8] = n.status, e[9] = r.status, e[10] = a) : a = e[10];
  let c;
  e[11] !== o || e[12] !== r.copyPrefix || e[13] !== r.rows.status || e[14] !== r.values.none || e[15] !== r.values.unknown || e[16] !== i || e[17] !== a ? (c = /* @__PURE__ */ g($n, { label: l, value: a, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[11] = o, e[12] = r.copyPrefix, e[13] = r.rows.status, e[14] = r.values.none, e[15] = r.values.unknown, e[16] = i, e[17] = a, e[18] = c) : c = e[18];
  let u;
  e[19] !== o || e[20] !== n.shortSha || e[21] !== n.sourceSha || e[22] !== r.copyPrefix || e[23] !== r.rows.sha || e[24] !== r.values.none || e[25] !== r.values.unknown || e[26] !== i ? (u = /* @__PURE__ */ g($n, { label: r.rows.sha, value: n.shortSha, copyValue: n.sourceSha, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[19] = o, e[20] = n.shortSha, e[21] = n.sourceSha, e[22] = r.copyPrefix, e[23] = r.rows.sha, e[24] = r.values.none, e[25] = r.values.unknown, e[26] = i, e[27] = u) : u = e[27];
  const d = n.record.requestedRef ?? r.values.unknown;
  let f;
  e[28] !== o || e[29] !== r.copyPrefix || e[30] !== r.rows.requestedRef || e[31] !== r.values.none || e[32] !== r.values.unknown || e[33] !== i || e[34] !== d ? (f = /* @__PURE__ */ g($n, { label: r.rows.requestedRef, value: d, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[28] = o, e[29] = r.copyPrefix, e[30] = r.rows.requestedRef, e[31] = r.values.none, e[32] = r.values.unknown, e[33] = i, e[34] = d, e[35] = f) : f = e[35];
  const p = r.rows.deployedAt;
  let m;
  e[36] !== n.record.deployedAt || e[37] !== r.values.unknown ? (m = _R(n.record.deployedAt, r.values.unknown), e[36] = n.record.deployedAt, e[37] = r.values.unknown, e[38] = m) : m = e[38];
  let h;
  e[39] !== o || e[40] !== r.copyPrefix || e[41] !== r.rows.deployedAt || e[42] !== r.values.none || e[43] !== r.values.unknown || e[44] !== i || e[45] !== m ? (h = /* @__PURE__ */ g($n, { label: p, value: m, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[39] = o, e[40] = r.copyPrefix, e[41] = r.rows.deployedAt, e[42] = r.values.none, e[43] = r.values.unknown, e[44] = i, e[45] = m, e[46] = h) : h = e[46];
  let b;
  e[47] !== o || e[48] !== n.parameterName || e[49] !== r.copyPrefix || e[50] !== r.rows.ssmParameter || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i ? (b = /* @__PURE__ */ g($n, { label: r.rows.ssmParameter, value: n.parameterName, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[47] = o, e[48] = n.parameterName, e[49] = r.copyPrefix, e[50] = r.rows.ssmParameter, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = b) : b = e[54];
  let v;
  return e[55] !== s || e[56] !== h || e[57] !== b || e[58] !== c || e[59] !== u || e[60] !== f ? (v = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    s,
    c,
    u,
    f,
    h,
    b
  ] }), e[55] = s, e[56] = h, e[57] = b, e[58] = c, e[59] = u, e[60] = f, e[61] = v) : v = e[61], v;
}
function _D({
  open: t,
  onOpenChange: e,
  appName: n,
  appLabel: o = n,
  labels: r = PR,
  environment: i = "local",
  branchName: s = "local",
  commitId: l = "local",
  releaseTag: a = "",
  recordParameterName: c = `/assetwatch/deployments/${i}/${n}`,
  record: u,
  isRecordLoading: d = !1,
  isRecordUnavailable: f = !1,
  awsRegion: p = "us-east-2",
  repoFullName: m = "AssetWatch1/fullstack.assetwatch",
  modalTitle: h = `${o} Release Info`,
  modalDescription: b = `Current ${o} release information for this environment.`
}) {
  const [v, C] = qe(null), y = typeof navigator < "u" && !!navigator.clipboard?.writeText;
  async function w(V, _) {
    !V || !y || (await navigator.clipboard.writeText(V), C(_), window.setTimeout(() => C(null), 1600));
  }
  if (d)
    return /* @__PURE__ */ g(wu, { open: t, onOpenChange: e, title: h, description: b, children: /* @__PURE__ */ F(Cr, { gap: 8, children: [
      /* @__PURE__ */ g(Uu, { size: "sm" }),
      /* @__PURE__ */ g(an, { size: "sm", tone: "subtle", children: r.loadingReleaseInfo })
    ] }) });
  const R = u ?? DR({
    appName: n,
    environment: i,
    recordParameterName: c,
    commitId: l,
    branchName: s,
    releaseTag: a
  }), S = MR(R.status), E = R.releaseTag || a || `${R.environment ?? "local"}-${Vm(R.sourceSha, r.values.unknown)}`, N = R.sourceSha ?? l, I = Vm(N, r.values.unknown), M = R.parameterName || c || r.values.unknown, T = OR(p, M), k = JSON.stringify(R, null, 2), P = R.releaseTag ? `https://github.com/${m}/tree/${R.releaseTag}` : "", D = N && N !== "local" ? `https://github.com/${m}/commit/${N}` : "", O = {
    appLabel: o,
    environment: R.environment ?? i,
    status: S,
    displayTag: E,
    sourceSha: N,
    shortSha: I,
    parameterName: M,
    ssmConsoleUrl: T,
    recordJson: k,
    githubTagUrl: P,
    githubCommitUrl: D,
    record: R
  };
  return /* @__PURE__ */ g(wu, { open: t, onOpenChange: e, title: h, description: b, footer: /* @__PURE__ */ F(Cr, { gap: 8, children: [
    /* @__PURE__ */ g(pn, { variant: "outline", size: "sm", icon: v === "record" ? "check-mark" : "copy-regular", disabled: !y, onClick: () => {
      w(O.recordJson, "record");
    }, children: r.copyRecord }),
    O.ssmConsoleUrl ? /* @__PURE__ */ g(pn, { variant: "primary", size: "sm", icon: "arrow-up-right", render: /* @__PURE__ */ g("a", { href: O.ssmConsoleUrl, target: "_blank", rel: "noreferrer", "aria-label": r.openSsmAriaLabel, children: r.openSsm }), children: r.openSsm }) : null
  ] }), children: /* @__PURE__ */ F(Qo, { gap: 16, children: [
    f ? /* @__PURE__ */ g(an, { size: "sm", tone: "warning", children: r.recordUnavailable }) : null,
    /* @__PURE__ */ g(FR, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(LR, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(AR, { display: O, labels: r }),
    /* @__PURE__ */ g("pre", { className: "max-h-[220px] overflow-auto rounded-(--radius-sm) border border-outline-subtle bg-surface-container p-(--spacing-12) text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: O.recordJson })
  ] }) });
}
function $R(t) {
  return t.split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0]).join("").toUpperCase();
}
function VD(t) {
  const e = W.c(27), {
    company: n,
    selected: o,
    onSettingsClick: r
  } = t, i = o === void 0 ? !1 : o, {
    collapsed: s,
    closeMobileNavigation: l
  } = wf(), a = n.facilityCount === void 0 ? void 0 : n.facilityCount + (n.facilityCount === 1 ? " facility" : " facilities"), c = `relative flex h-[60px] min-w-0 items-center gap-(--spacing-6) rounded-(--radius-sm) border border-outline-subtle px-(--spacing-10)${i ? " bg-menu-item-selected" : " bg-surface"}${s ? " w-[60px] shrink-0 justify-center" : " w-full"}`, u = n.name;
  let d;
  e[0] !== n.name ? (d = $R(n.name), e[0] = n.name, e[1] = d) : d = e[1];
  let f;
  e[2] !== n.logoUrl || e[3] !== n.name || e[4] !== d ? (f = /* @__PURE__ */ g(Xr, { "aria-label": u, initials: d, src: n.logoUrl, variant: "external" }), e[2] = n.logoUrl, e[3] = n.name, e[4] = d, e[5] = f) : f = e[5];
  let p;
  e[6] !== s || e[7] !== n.name || e[8] !== a || e[9] !== r ? (p = !s && /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ F("span", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ g("span", { className: "block truncate text-(length:--font-size-label-large) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-menu-text-default", children: n.name }),
      a && /* @__PURE__ */ g("span", { className: "block text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: a })
    ] }),
    r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "shrink-0", children: /* @__PURE__ */ g(Ue, { name: "settings-cog", size: "sm", tone: "secondary" }) })
  ] }), e[6] = s, e[7] = n.name, e[8] = a, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ F(_t, { children: [
    f,
    p
  ] }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  const h = m;
  if (r) {
    const v = `Open ${n.name} settings`, C = i ? "page" : void 0, y = `${c} cursor-pointer text-left outline-none transition-colors duration-200 ease-in-out ${i ? "hover:bg-menu-item-selected" : "hover:bg-menu-item-hover"} focus-visible:ring-2 focus-visible:ring-menu-focus-ring focus-visible:ring-inset`, w = i || void 0;
    let R;
    e[14] !== l || e[15] !== r ? (R = () => {
      r(), l?.();
    }, e[14] = l, e[15] = r, e[16] = R) : R = e[16];
    let S;
    return e[17] !== h || e[18] !== w || e[19] !== R || e[20] !== v || e[21] !== C || e[22] !== y ? (S = /* @__PURE__ */ g("button", { "aria-label": v, "aria-current": C, className: y, "data-slot": "company-navigation", "data-selected": w, onClick: R, type: "button", children: h }), e[17] = h, e[18] = w, e[19] = R, e[20] = v, e[21] = C, e[22] = y, e[23] = S) : S = e[23], S;
  }
  let b;
  return e[24] !== c || e[25] !== h ? (b = /* @__PURE__ */ g("div", { className: c, "data-slot": "company-navigation", children: h }), e[24] = c, e[25] = h, e[26] = b) : b = e[26], b;
}
function Am(t) {
  if (t)
    return {
      ...t,
      tone: t.tone === "neutral" ? "activity" : t.tone
    };
}
function Gi(t) {
  return t.replace(/^\s*(?:\([^)]*\)\s*[-–—]?\s*)+/, "").split(/\s+/).filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
function HR(t) {
  const e = W.c(36), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    collapsed: a
  } = t;
  let c;
  e[0] !== n ? (c = function(p) {
    return n.find((m) => m.id === p);
  }, e[0] = n, e[1] = c) : c = e[1];
  const u = c;
  let d;
  if (e[2] !== s || e[3] !== a || e[4] !== n || e[5] !== l || e[6] !== u || e[7] !== i || e[8] !== r || e[9] !== o) {
    const f = u(o), p = f ? l?.(f) ?? [] : [];
    let m;
    e[11] !== a || e[12] !== n.length ? (m = a ? /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }) : /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
      "FACILITIES (",
      n.length,
      ")"
    ] }), e[11] = a, e[12] = n.length, e[13] = m) : m = e[13];
    const h = a ? "flex w-full justify-center" : void 0, b = a ? "w-[60px] shrink-0" : void 0;
    let v;
    e[14] !== n ? (v = n.map(zR), e[14] = n, e[15] = v) : v = e[15];
    let C;
    e[16] !== a || e[17] !== u ? (C = (N) => N ? /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(Xr, { initials: Gi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      !a && /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }) : null, e[16] = a, e[17] = u, e[18] = C) : C = e[18];
    let y;
    e[19] !== u ? (y = (N) => /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(Xr, { initials: Gi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }), e[19] = u, e[20] = y) : y = e[20];
    let w;
    e[21] !== i || e[22] !== r ? (w = (N) => {
      N && (r ?? i)(N);
    }, e[21] = i, e[22] = r, e[23] = w) : w = e[23];
    let R;
    e[24] !== o || e[25] !== v || e[26] !== C || e[27] !== y || e[28] !== w ? (R = /* @__PURE__ */ g(n1, { searchable: !0, options: v, required: !0, popupWidth: "content", reserveSubtextSpace: !1, size: "md", value: o, renderValue: C, renderOption: y, onChange: w }), e[24] = o, e[25] = v, e[26] = C, e[27] = y, e[28] = w, e[29] = R) : R = e[29];
    let S;
    e[30] !== R || e[31] !== b ? (S = /* @__PURE__ */ g("div", { className: b, children: R }), e[30] = R, e[31] = b, e[32] = S) : S = e[32];
    let E;
    e[33] !== S || e[34] !== h ? (E = /* @__PURE__ */ g("div", { className: h, children: S }), e[33] = S, e[34] = h, e[35] = E) : E = e[35], d = /* @__PURE__ */ F("section", { "aria-label": `Facilities (${n.length})`, children: [
      m,
      E,
      f && p.length > 0 && /* @__PURE__ */ g("div", { className: "mt-(--spacing-4) flex flex-col gap-(--spacing-4)", children: p.map((N) => /* @__PURE__ */ g(Ol, { itemId: N.id, label: N.label, badge: N.badge, leading: N.icon ? {
        type: "icon",
        name: N.icon
      } : void 0, href: N.render ? void 0 : N.href ?? "#", render: N.render, onClick: (I) => {
        i(f.id), N.onClick?.(I);
      }, selected: f.id === o && N.id === s, variant: "item" }, N.id)) })
    ] }), e[2] = s, e[3] = a, e[4] = n, e[5] = l, e[6] = u, e[7] = i, e[8] = r, e[9] = o, e[10] = d;
  } else
    d = e[10];
  return d;
}
function zR(t) {
  return {
    value: t.id,
    label: t.name
  };
}
function AD(t) {
  const e = W.c(85), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    expandedFacilityId: a,
    initialExpandedFacilityId: c,
    onExpandedFacilityChange: u
  } = t, {
    collapsed: d
  } = wf(), [f, p] = qe(c), m = "expandedFacilityId" in t, h = m ? a : f, b = at(!1), v = at(o);
  let C;
  e[0] !== m || e[1] !== u ? (C = function(P) {
    m || p(P), u?.(P);
  }, e[0] = m, e[1] = u, e[2] = C) : C = e[2];
  const y = C;
  let w, R;
  if (e[3] !== h || e[4] !== n || e[5] !== m || e[6] !== u || e[7] !== o ? (w = () => {
    if (m || n.length < 2 || n.length > 5)
      return;
    const k = !b.current;
    b.current = !0;
    const P = v.current !== o;
    v.current = o, (k && h === void 0 || P || h !== void 0 && !n.some((D) => D.id === h)) && (m || p(o), u?.(o));
  }, R = [h, n, m, u, o], e[3] = h, e[4] = n, e[5] = m, e[6] = u, e[7] = o, e[8] = w, e[9] = R) : (w = e[8], R = e[9]), Nt(w, R), n.length === 0)
    return null;
  if (n.length === 1) {
    const k = n[0];
    let P, D, O, V, _, A, L, $, B;
    if (e[10] !== s || e[11] !== l || e[12] !== k || e[13] !== i || e[14] !== o) {
      const K = l?.(k) ?? [];
      let G;
      e[24] !== k.alertBadge ? (G = Am(k.alertBadge), e[24] = k.alertBadge, e[25] = G) : G = e[25];
      const q = G;
      D = k.name, P = xm, O = !1, V = k.id, _ = k.name, A = q;
      let Q;
      e[26] !== s ? (Q = (te) => te.id === s, e[26] = s, e[27] = Q) : Q = e[27], L = K.some(Q);
      let U;
      e[28] !== k.name ? (U = Gi(k.name), e[28] = k.name, e[29] = U) : U = e[29], e[30] !== k.avatarUrl || e[31] !== U ? ($ = {
        type: "avatar",
        initials: U,
        src: k.avatarUrl
      }, e[30] = k.avatarUrl, e[31] = U, e[32] = $) : $ = e[32];
      let X;
      e[33] !== s || e[34] !== k.id || e[35] !== i || e[36] !== o ? (X = (te) => /* @__PURE__ */ g(Ol, { itemId: te.id, label: te.label, badge: te.badge, leading: te.icon ? {
        type: "icon",
        name: te.icon
      } : void 0, href: te.render ? void 0 : te.href ?? "#", render: te.render, onClick: (re) => {
        i(k.id), te.onClick?.(re);
      }, selected: k.id === o && te.id === s, variant: "item" }, te.id), e[33] = s, e[34] = k.id, e[35] = i, e[36] = o, e[37] = X) : X = e[37], B = K.map(X), e[10] = s, e[11] = l, e[12] = k, e[13] = i, e[14] = o, e[15] = P, e[16] = D, e[17] = O, e[18] = V, e[19] = _, e[20] = A, e[21] = L, e[22] = $, e[23] = B;
    } else
      P = e[15], D = e[16], O = e[17], V = e[18], _ = e[19], A = e[20], L = e[21], $ = e[22], B = e[23];
    let z;
    e[38] !== P || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== A || e[43] !== L || e[44] !== $ || e[45] !== B ? (z = /* @__PURE__ */ g(P, { collapsible: O, itemId: V, label: _, badge: A, hasSelectedChild: L, leading: $, children: B }), e[38] = P, e[39] = O, e[40] = V, e[41] = _, e[42] = A, e[43] = L, e[44] = $, e[45] = B, e[46] = z) : z = e[46];
    let H;
    return e[47] !== D || e[48] !== z ? (H = /* @__PURE__ */ g("section", { "aria-label": D, children: z }), e[47] = D, e[48] = z, e[49] = H) : H = e[49], H;
  }
  if (n.length > 5) {
    let k;
    return e[50] !== s || e[51] !== d || e[52] !== n || e[53] !== l || e[54] !== i || e[55] !== r || e[56] !== o ? (k = /* @__PURE__ */ g(HR, { facilities: n, selectedFacilityId: o, onFacilitySelect: r, onFacilityChange: i, activeItemId: s, facilitySubNavItems: l, collapsed: d }), e[50] = s, e[51] = d, e[52] = n, e[53] = l, e[54] = i, e[55] = r, e[56] = o, e[57] = k) : k = e[57], k;
  }
  const S = `Facilities (${n.length})`;
  let E;
  e[58] !== d || e[59] !== n.length ? (E = !d && /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
    "FACILITIES (",
    n.length,
    ")"
  ] }), e[58] = d, e[59] = n.length, e[60] = E) : E = e[60];
  let N;
  e[61] !== d ? (N = d && /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }), e[61] = d, e[62] = N) : N = e[62];
  let I;
  if (e[63] !== s || e[64] !== h || e[65] !== n || e[66] !== l || e[67] !== i || e[68] !== o || e[69] !== y) {
    let k;
    e[71] !== s || e[72] !== h || e[73] !== l || e[74] !== i || e[75] !== o || e[76] !== y ? (k = (P) => {
      const D = l?.(P) ?? [], O = Am(P.alertBadge), V = P.id === o && D.some((A) => A.id === s), _ = P.id === h;
      return D.length ? /* @__PURE__ */ g(xm, { itemId: P.id, label: P.name, badge: O, leading: {
        type: "avatar",
        initials: Gi(P.name),
        src: P.avatarUrl
      }, hasSelectedChild: V, open: _, onOpenChange: (A) => {
        const L = A ? P.id : void 0;
        y(L);
      }, children: D.map((A) => /* @__PURE__ */ g(Ol, { itemId: A.id, label: A.label, badge: A.badge, leading: A.icon ? {
        type: "icon",
        name: A.icon
      } : void 0, href: A.render ? void 0 : A.href ?? "#", render: A.render, onClick: (L) => {
        i(P.id), A.onClick?.(L);
      }, selected: P.id === o && A.id === s, variant: "subItem" }, A.id)) }, P.id) : /* @__PURE__ */ g(Ol, { itemId: P.id, label: P.name, leading: {
        type: "avatar",
        initials: Gi(P.name),
        src: P.avatarUrl
      }, href: "#", badge: O, selected: P.id === o, onClick: (A) => {
        A.preventDefault(), i(P.id);
      } }, P.id);
    }, e[71] = s, e[72] = h, e[73] = l, e[74] = i, e[75] = o, e[76] = y, e[77] = k) : k = e[77], I = n.map(k), e[63] = s, e[64] = h, e[65] = n, e[66] = l, e[67] = i, e[68] = o, e[69] = y, e[70] = I;
  } else
    I = e[70];
  let M;
  e[78] !== I ? (M = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-4)", children: I }), e[78] = I, e[79] = M) : M = e[79];
  let T;
  return e[80] !== S || e[81] !== E || e[82] !== N || e[83] !== M ? (T = /* @__PURE__ */ F("section", { "aria-label": S, className: "flex flex-col gap-(--spacing-4)", children: [
    E,
    N,
    M
  ] }), e[80] = S, e[81] = E, e[82] = N, e[83] = M, e[84] = T) : T = e[84], T;
}
const pb = yo(void 0);
function BR(t) {
  return t === "light" || t === "dark" || t === "system";
}
function Lm() {
  return typeof window > "u" || !window.matchMedia ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function WR(t, e) {
  if (typeof window > "u")
    return e;
  try {
    const n = localStorage.getItem(t);
    return BR(n) ? n : e;
  } catch {
    return e;
  }
}
function UR(t) {
  const e = W.c(21), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, i = o === void 0 ? "light" : o, s = r === void 0 ? "assetwatch-ui-theme" : r;
  let l;
  e[0] !== i || e[1] !== s ? (l = () => WR(s, i), e[0] = i, e[1] = s, e[2] = l) : l = e[2];
  const [a, c] = qe(l), [u, d] = qe(Lm), f = a === "system" ? u : a;
  let p, m;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = () => {
    if (!window.matchMedia)
      return;
    const E = window.matchMedia("(prefers-color-scheme: dark)"), N = () => d(Lm());
    return E.addEventListener("change", N), () => E.removeEventListener("change", N);
  }, m = [], e[3] = p, e[4] = m) : (p = e[3], m = e[4]), Nt(p, m);
  let h, b;
  e[5] !== f ? (h = () => {
    const E = window.document.documentElement;
    E.classList.remove("light", "dark"), E.classList.add(f);
  }, b = [f], e[5] = f, e[6] = h, e[7] = b) : (h = e[6], b = e[7]), Nt(h, b);
  let v;
  e[8] !== s ? (v = (E) => {
    localStorage.setItem(s, E), c(E);
  }, e[8] = s, e[9] = v) : v = e[9];
  const C = v;
  let y;
  e[10] !== f || e[11] !== C ? (y = () => {
    C(f === "light" ? "dark" : "light");
  }, e[10] = f, e[11] = C, e[12] = y) : y = e[12];
  const w = y;
  let R;
  e[13] !== f || e[14] !== C || e[15] !== a || e[16] !== w ? (R = {
    theme: a,
    resolvedTheme: f,
    setTheme: C,
    toggleTheme: w
  }, e[13] = f, e[14] = C, e[15] = a, e[16] = w, e[17] = R) : R = e[17];
  let S;
  return e[18] !== n || e[19] !== R ? (S = /* @__PURE__ */ g(pb.Provider, { value: R, children: n }), e[18] = n, e[19] = R, e[20] = S) : S = e[20], S;
}
function GR() {
  const t = Ig(pb);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
const LD = {
  openMenuAriaLabel: "Open account menu",
  engineeringOnly: "Engineering Only",
  appearance: "Theme",
  matchBrowser: "Match Browser",
  light: "Light",
  dark: "Dark",
  currentArtifact: "Current artifact",
  signOut: "Sign out"
}, YR = [{
  value: "system",
  label: "matchBrowser"
}, {
  value: "light",
  label: "light"
}, {
  value: "dark",
  label: "dark"
}];
function FD(t) {
  const e = W.c(19), {
    additionalContent: n,
    labels: o,
    engineeringOnly: r,
    engineeringContent: i,
    onOpenArtifact: s,
    onSignOut: l
  } = t, a = r === void 0 ? !1 : r, {
    theme: c,
    setTheme: u
  } = GR();
  let d;
  e[0] !== o.openMenuAriaLabel ? (d = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(bt, { "aria-label": o.openMenuAriaLabel, icon: "user", size: "md", variant: "outline" }) }), e[0] = o.openMenuAriaLabel, e[1] = d) : d = e[1];
  let f;
  e[2] !== o.signOut || e[3] !== l ? (f = /* @__PURE__ */ g(hr, { "data-testid": "nav-sign-out", leadingIcon: "logout-exit", onClick: l, tone: "destructive", children: o.signOut }), e[2] = o.signOut, e[3] = l, e[4] = f) : f = e[4];
  let p;
  e[5] !== i || e[6] !== a || e[7] !== o || e[8] !== s || e[9] !== u || e[10] !== c ? (p = a ? /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ g(bu, { children: o.engineeringOnly }),
    /* @__PURE__ */ g(hr, { leadingIcon: "settings-cog", submenu: /* @__PURE__ */ F($d, { value: c, onValueChange: (b) => u(b), children: [
      /* @__PURE__ */ g(bu, { children: o.appearance }),
      YR.map((b) => {
        const {
          value: v,
          label: C
        } = b;
        return /* @__PURE__ */ g(Hd, { value: v, children: o[C] }, v);
      })
    ] }), children: o.appearance }),
    s ? /* @__PURE__ */ g(hr, { leadingIcon: "document", onClick: s, children: o.currentArtifact }) : null,
    i
  ] }) : null, e[5] = i, e[6] = a, e[7] = o, e[8] = s, e[9] = u, e[10] = c, e[11] = p) : p = e[11];
  let m;
  e[12] !== n || e[13] !== f || e[14] !== p ? (m = /* @__PURE__ */ F(Dr, { align: "end", size: "sm", children: [
    n,
    f,
    p
  ] }), e[12] = n, e[13] = f, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== d || e[17] !== m ? (h = /* @__PURE__ */ F(Fd, { children: [
    d,
    m
  ] }), e[16] = d, e[17] = m, e[18] = h) : h = e[18], h;
}
const jR = ae(["rounded-(--radius-sm)", "border border-outline-subtle", "bg-surface-container-lowest", "flex flex-col"], {
  variants: {
    padding: {
      compact: "py-(--spacing-12) px-(--spacing-6)",
      standard: "p-(--spacing-12)"
    },
    elevated: {
      true: "shadow-elevation-1",
      false: null
    }
  },
  defaultVariants: {
    padding: "standard",
    elevated: !1
  }
}), KR = ae(["w-full", "flex flex-col", "[overflow:clip]", "rounded-(--radius-sm)", "border-[0.5px] border-outline-subtle", "bg-surface-container-low", "text-text-default"], {
  variants: {
    padding: {
      none: "p-0",
      compact: "p-(--spacing-8) gap-(--spacing-8)"
    }
  },
  defaultVariants: {
    padding: "compact"
  }
}), qR = ae(["min-w-0 truncate", "font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "font-medium", "leading-(--line-height-24)", "text-text-default"]), ZR = ae(["w-full min-w-0", "flex gap-(--spacing-24) items-start overflow-hidden"]);
function mb(t) {
  const e = W.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: i,
    elevated: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o || e[7] !== r || e[8] !== i ? (l = ne(jR({
    padding: i,
    elevated: r
  }), o), e[6] = o, e[7] = r, e[8] = i, e[9] = l) : l = e[9];
  let a;
  return e[10] !== n || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ g("div", { className: l, ...s, "data-slot": "content-container-root", children: n }), e[10] = n, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function gb(t) {
  const e = W.c(12);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] !== o || e[6] !== r ? (s = ne(KR({
    padding: r
  }), o), e[5] = o, e[6] = r, e[7] = s) : s = e[7];
  let l;
  return e[8] !== n || e[9] !== i || e[10] !== s ? (l = /* @__PURE__ */ g("div", { className: s, ...i, "data-slot": "content-container-body", children: n }), e[8] = n, e[9] = i, e[10] = s, e[11] = l) : l = e[11], l;
}
function hb(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne("w-full", o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...r, "data-slot": "content-container-footer", children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
function XR(t) {
  const e = W.c(20), {
    main: n,
    start: o,
    titleAccessory: r,
    actions: i,
    summary: s
  } = t;
  let l;
  e[0] !== o ? (l = o && /* @__PURE__ */ g("div", { "data-slot": "content-container-start-accessory", className: "flex shrink-0 items-center", children: o }), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = r && /* @__PURE__ */ g("div", { "data-slot": "content-container-title-accessory", className: "flex shrink-0 items-center", children: r }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== n || e[5] !== a ? (c = /* @__PURE__ */ F("div", { "data-slot": "content-container-main", className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    a
  ] }), e[4] = n, e[5] = a, e[6] = c) : c = e[6];
  let u;
  e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-left", className: "flex flex-1 gap-(--spacing-8) items-center min-w-0", children: [
    l,
    c
  ] }), e[7] = l, e[8] = c, e[9] = u) : u = e[9];
  let d;
  e[10] !== i ? (d = i && /* @__PURE__ */ g("div", { "data-slot": "content-container-actions", className: "flex shrink-0 gap-(--spacing-8) items-center justify-end", children: i }), e[10] = i, e[11] = d) : d = e[11];
  let f;
  e[12] !== u || e[13] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "content-container-header", className: "flex items-center gap-(--spacing-8) w-full", children: [
    u,
    d
  ] }), e[12] = u, e[13] = d, e[14] = f) : f = e[14];
  let p;
  e[15] !== s ? (p = s && /* @__PURE__ */ g("div", { "data-slot": "content-container-summary", className: ZR(), children: s }), e[15] = s, e[16] = p) : p = e[16];
  let m;
  return e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-wrapper", className: "flex flex-col gap-(--spacing-8) w-full", children: [
    f,
    p
  ] }), e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
function bb(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne(qR(), o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("span", { className: i, ...r, children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const QR = ae(["hover:bg-surface-container-low", "cursor-pointer", "transition-colors duration-200 ease-in-out", "has-[:focus-visible]:[outline-width:var(--spacing-2)]", "has-[:focus-visible]:outline-solid", "has-[:focus-visible]:outline-tertiary-tertiary", "has-[:focus-visible]:[outline-offset:3px]", "data-[disabled]:opacity-50", "data-[disabled]:cursor-default"]), JR = ae(["w-full", "flex items-center gap-(--spacing-8)", "cursor-pointer", "min-h-(--spacing-24)", "text-left", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), eE = ae(["group", "flex size-(--spacing-32) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "cursor-pointer", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), tE = ae(["w-full", "min-w-0", "overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "mt-(--spacing-12)", "[&[data-starting-style]]:mt-0", "[&[data-ending-style]]:mt-0", "transition-[height,margin-top] duration-150 ease-in-out", "motion-reduce:transition-none"]), nE = ["[data-accordion-panel-content]", "[data-accordion-ignore-shell-click]", "button", "a", "input", "label", "select", "textarea", "[role='button']", "[role='link']", "[role='menuitem']", "[role='option']", "[role='switch']", "[role='checkbox']", "[role='radio']"].join(",");
function oE(t) {
  return t instanceof Element ? t.closest(nE) === null : !1;
}
function $D(t) {
  const e = W.c(66);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    open: a,
    defaultOpen: r,
    onOpenChange: l,
    title: f,
    startAccessory: u,
    titleAccessory: p,
    actions: n,
    summary: d,
    children: o,
    footer: s,
    disabled: i,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  let m;
  e[13] !== r ? (m = () => r ?? !1, e[13] = r, e[14] = m) : m = e[14];
  const [h, b] = qe(m), v = a !== void 0, C = v ? a : h;
  let y;
  e[15] !== v || e[16] !== l ? (y = function(U) {
    v || b(U), l?.(U);
  }, e[15] = v, e[16] = l, e[17] = y) : y = e[17];
  const w = y;
  let R;
  e[18] !== i || e[19] !== C || e[20] !== w ? (R = function(U) {
    i || !oE(U.target) || w(!C);
  }, e[18] = i, e[19] = C, e[20] = w, e[21] = R) : R = e[21];
  const S = R, E = i ? "" : void 0;
  let N;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = QR(), e[22] = N) : N = e[22];
  let I;
  e[23] !== u ? (I = u && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: u }), e[23] = u, e[24] = I) : I = e[24];
  let M;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = JR(), e[25] = M) : M = e[25];
  let T;
  e[26] !== f ? (T = /* @__PURE__ */ g("h3", { className: "flex min-w-0 flex-1 m-0", children: /* @__PURE__ */ g(Xl, { className: M, onClick: iE, children: /* @__PURE__ */ g(bb, { className: "flex-1", children: f }) }) }), e[26] = f, e[27] = T) : T = e[27];
  let k;
  e[28] !== p ? (k = p && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: p }), e[28] = p, e[29] = k) : k = e[29];
  let P;
  e[30] !== T || e[31] !== k ? (P = /* @__PURE__ */ F("div", { className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    T,
    k
  ] }), e[30] = T, e[31] = k, e[32] = P) : P = e[32];
  let D;
  e[33] !== n ? (D = n && /* @__PURE__ */ g("div", { "data-accordion-ignore-shell-click": "", className: "flex shrink-0 items-center", children: n }), e[33] = n, e[34] = D) : D = e[34];
  let O;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = eE(), e[35] = O) : O = e[35];
  let V;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ g("span", { className: "flex group-data-[panel-open]:hidden", children: /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "md", tone: "secondary" }) }), e[36] = V) : V = e[36];
  let _;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ F(Xl, { "aria-label": "Toggle accordion", "data-slot": "accordion-chevron-trigger", className: O, onClick: rE, children: [
    V,
    /* @__PURE__ */ g("span", { className: "hidden group-data-[panel-open]:flex", children: /* @__PURE__ */ g(Ue, { name: "chevron-up", size: "md", tone: "secondary" }) })
  ] }), e[37] = _) : _ = e[37];
  let A;
  e[38] !== P || e[39] !== D || e[40] !== I ? (A = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8) w-full", children: [
    I,
    P,
    D,
    _
  ] }), e[38] = P, e[39] = D, e[40] = I, e[41] = A) : A = e[41];
  let L;
  e[42] !== d ? (L = d && /* @__PURE__ */ g("div", { className: "w-full min-w-0", children: d }), e[42] = d, e[43] = L) : L = e[43];
  let $;
  e[44] !== A || e[45] !== L ? ($ = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) w-full", children: [
    A,
    L
  ] }), e[44] = A, e[45] = L, e[46] = $) : $ = e[46];
  let B;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = tE(), e[47] = B) : B = e[47];
  let z;
  e[48] !== o ? (z = /* @__PURE__ */ g(gb, { children: o }), e[48] = o, e[49] = z) : z = e[49];
  let H;
  e[50] !== s ? (H = s && /* @__PURE__ */ g(hb, { children: s }), e[50] = s, e[51] = H) : H = e[51];
  let K;
  e[52] !== z || e[53] !== H ? (K = /* @__PURE__ */ g(gf, { className: B, children: /* @__PURE__ */ F("div", { "data-accordion-panel-content": "", className: "flex flex-col gap-(--spacing-4) cursor-default", children: [
    z,
    H
  ] }) }), e[52] = z, e[53] = H, e[54] = K) : K = e[54];
  let G;
  e[55] !== S || e[56] !== $ || e[57] !== K || e[58] !== E ? (G = /* @__PURE__ */ F(mb, { padding: "standard", "data-disabled": E, className: N, onClick: S, children: [
    $,
    K
  ] }), e[55] = S, e[56] = $, e[57] = K, e[58] = E, e[59] = G) : G = e[59];
  let q;
  return e[60] !== i || e[61] !== C || e[62] !== c || e[63] !== w || e[64] !== G ? (q = /* @__PURE__ */ g(mf, { ...c, open: C, onOpenChange: w, disabled: i, className: "group", children: G }), e[60] = i, e[61] = C, e[62] = c, e[63] = w, e[64] = G, e[65] = q) : q = e[65], q;
}
function rE(t) {
  return t.stopPropagation();
}
function iE(t) {
  return t.stopPropagation();
}
const sE = ae(["flex", "w-full", "items-center", "justify-between", "px-(--spacing-24)", "py-(--spacing-16)", "rounded-(--radius-sm)", "relative", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-px", "after:bg-outline-subtle"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function HD(t) {
  const e = W.c(35);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: r,
    tone: l,
    title: a,
    description: o,
    action: n,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "neutral" : l, u = c === "negative", d = u ? "alert" : "status", f = u ? "assertive" : "polite";
  let p;
  e[8] !== c ? (p = ne(sE({
    tone: c
  })), e[8] = c, e[9] = p) : p = e[9];
  let m;
  e[10] !== r ? (m = /* @__PURE__ */ g(Ue, { name: r, size: "md", tone: "inherit" }), e[10] = r, e[11] = m) : m = e[11];
  let h;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    color: "inherit"
  }, e[12] = h) : h = e[12];
  let b;
  e[13] !== a ? (b = /* @__PURE__ */ g(Mn, { as: "span", size: "md", style: h, children: a }), e[13] = a, e[14] = b) : b = e[14];
  let v;
  e[15] !== o ? (v = o ? /* @__PURE__ */ g(an, { as: "span", size: "md", style: {
    color: "inherit"
  }, children: o }) : null, e[15] = o, e[16] = v) : v = e[16];
  let C;
  e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { className: "min-w-0 flex flex-col gap-(--spacing-8)", children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  e[20] !== m || e[21] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    m,
    C
  ] }), e[20] = m, e[21] = C, e[22] = y) : y = e[22];
  let w;
  e[23] !== i ? (w = i ? /* @__PURE__ */ g(bt, { icon: "x-close", "aria-label": "Dismiss banner", variant: "ghost", size: "sm", onClick: i }) : null, e[23] = i, e[24] = w) : w = e[24];
  let R;
  e[25] !== n || e[26] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    w
  ] }), e[25] = n, e[26] = w, e[27] = R) : R = e[27];
  let S;
  return e[28] !== s || e[29] !== y || e[30] !== R || e[31] !== d || e[32] !== f || e[33] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...s, children: [
    y,
    R
  ] }), e[28] = s, e[29] = y, e[30] = R, e[31] = d, e[32] = f, e[33] = p, e[34] = S) : S = e[34], S;
}
function zD(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("nav", { "aria-label": "Breadcrumb", "data-slot": "breadcrumb", className: "w-full min-w-0", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function BD({
  children: t,
  ref: e,
  ...n
}) {
  const o = at(null), r = at(null), i = at(() => {
  }), [s, l] = qe(!1), a = ra.toArray(t), c = a.filter(vb), u = a.filter(cE), d = uE(t), f = c.length > 2 && a.length === c.length + u.length;
  i.current = function() {
    const b = o.current, v = r.current;
    if (!f || !b || !v) {
      l(!1);
      return;
    }
    const C = b.getBoundingClientRect().width, y = v.getBoundingClientRect().width;
    l(C > 0 && y > C);
  };
  function p(h) {
    o.current = h, typeof e == "function" ? e(h) : e && (e.current = h);
  }
  go(() => {
    i.current();
  }), go(() => {
    const h = o.current;
    if (!h || typeof ResizeObserver > "u")
      return;
    const b = new ResizeObserver(() => {
      i.current();
    });
    return b.observe(h), () => {
      b.disconnect();
    };
  }, []);
  const m = s && f ? [c[0], Fm(u[0], "breadcrumb-overflow-leading-separator"), /* @__PURE__ */ g(dE, { items: c.slice(1, -1) }, "breadcrumb-overflow"), Fm(u[0], "breadcrumb-overflow-trailing-separator"), c.at(-1)] : t;
  return /* @__PURE__ */ F(_t, { children: [
    /* @__PURE__ */ g("ol", { ...n, ref: p, "data-slot": "breadcrumb-list", "data-collapsed": s && f ? "" : void 0, className: "flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-8) overflow-hidden p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: m }),
    f && /* @__PURE__ */ g("ol", { ref: r, "aria-hidden": "true", inert: !0, "data-slot": "breadcrumb-list-measurement", className: "pointer-events-none invisible absolute flex w-max flex-nowrap items-center gap-(--spacing-8) p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: d })
  ] });
}
function lE(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-item", className: "inline-flex min-w-0 items-center", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function aE(t) {
  const e = W.c(10);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Ma, n = "a", o = l;
    let c;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ["text-breadcrumb-text-inactive", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "no-underline", "block", "min-w-0", "max-w-full", "truncate", "whitespace-nowrap", "cursor-pointer", "transition-[color,text-decoration-color]", "hover:underline", "hover:[text-decoration-skip-ink:none]", "active:text-breadcrumb-text-inactive-pressed", "active:underline", "active:[text-decoration-skip-ink:none]", "active:[text-decoration-style:solid]", "outline-none", "focus-visible:[outline:var(--spacing-2)_solid_var(--color-breadcrumb-focus-ring)]", "focus-visible:outline-offset-[3px]", "rounded-(--radius-sm)"], e[5] = c) : c = e[5], r = cn(a, {
      className: c.join(" ")
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = s) : s = e[9], i(s);
}
function WD(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("span", { "data-slot": "breadcrumb-page", "aria-current": "page", className: "block min-w-0 max-w-full truncate text-breadcrumb-text-active font-family-body font-semibold", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function vb(t) {
  return ia(t) && t.type === lE;
}
function cE(t) {
  return ia(t) && t.type === xb;
}
function yb(t) {
  return ia(t) && t.type === aE;
}
function Fm(t, e) {
  return t ? Xc(t, {
    key: e
  }) : /* @__PURE__ */ g(xb, {}, e);
}
function uE(t) {
  return ra.map(t, (e) => !vb(e) || !yb(e.props.children) ? e : Xc(e, {
    children: Xc(e.props.children, {
      tabIndex: -1
    })
  }));
}
function dE(t) {
  const e = W.c(10), {
    items: n
  } = t, [o, r] = qe(!1), i = n.length, s = `Show ${i} hidden breadcrumb ${i === 1 ? "level" : "levels"}`;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(bt, { "aria-label": s, icon: "ellipsis-dots-horiz", size: "sm", variant: "ghost" }) }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  e[2] !== n ? (a = n.map(fE), e[2] = n, e[3] = a) : a = e[3];
  let c;
  e[4] !== a ? (c = /* @__PURE__ */ g(Dr, { align: "start", size: "sm", children: a }), e[4] = a, e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-overflow", className: "inline-flex shrink-0", children: /* @__PURE__ */ F(Fd, { modal: !1, open: o, onOpenChange: r, children: [
    l,
    c
  ] }) }), e[6] = o, e[7] = l, e[8] = c, e[9] = u) : u = e[9], u;
}
function fE(t, e) {
  return /* @__PURE__ */ g(pE, { item: t }, t.key ?? e);
}
function pE(t) {
  const e = W.c(4), {
    item: n
  } = t, o = n.props.children;
  if (yb(o)) {
    let i;
    return e[0] !== o ? (i = /* @__PURE__ */ g(hr, { render: o, children: o.props.children }), e[0] = o, e[1] = i) : i = e[1], i;
  }
  let r;
  return e[2] !== o ? (r = /* @__PURE__ */ g(hr, { disabled: !0, children: o }), e[2] = o, e[3] = r) : r = e[3], r;
}
function xb(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-separator", "aria-hidden": "true", className: "text-breadcrumb-separator font-family-label font-medium shrink-0 select-none", ...t, children: "/" }), e[0] = t, e[1] = n) : n = e[1], n;
}
function UD(t) {
  const e = W.c(16), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    actions: i,
    summary: s,
    children: l,
    footer: a
  } = t;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ g("h3", { className: "flex min-w-0 m-0", children: /* @__PURE__ */ g(bb, { children: n }) }), e[0] = n, e[1] = c) : c = e[1];
  let u;
  e[2] !== i || e[3] !== o || e[4] !== s || e[5] !== c || e[6] !== r ? (u = /* @__PURE__ */ g(XR, { main: c, start: o, titleAccessory: r, actions: i, summary: s }), e[2] = i, e[3] = o, e[4] = s, e[5] = c, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== l ? (d = /* @__PURE__ */ g(gb, { padding: "none", className: "min-h-(--spacing-80)", children: l }), e[8] = l, e[9] = d) : d = e[9];
  let f;
  e[10] !== a ? (f = a && /* @__PURE__ */ g(hb, { "data-card-container-slot": "footer", children: a }), e[10] = a, e[11] = f) : f = e[11];
  let p;
  return e[12] !== u || e[13] !== d || e[14] !== f ? (p = /* @__PURE__ */ g(mb, { elevated: !0, padding: "standard", children: /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-12) w-full", children: [
    u,
    d,
    f
  ] }) }), e[12] = u, e[13] = d, e[14] = f, e[15] = p) : p = e[15], p;
}
const mE = 2, gE = 32, hE = 3;
function bE(t) {
  return !x.isValidElement(t) || t.type !== ql ? t : x.cloneElement(t, {
    selected: t.props.selected ?? !1
  });
}
function Cb(t) {
  return t.clientWidth || t.getBoundingClientRect().width;
}
function vE(t) {
  return Math.max(t.scrollWidth, t.getBoundingClientRect().width);
}
function yE(t) {
  const e = gE * mE;
  return Math.max(0, t - e);
}
function xE(t, e) {
  const n = Cb(t), o = Array.from(e.children).filter((i) => i instanceof HTMLElement);
  if (n <= 0 || o.length === 0) return o.length;
  let r = 0;
  for (const i of o) {
    const s = i.offsetWidth || i.getBoundingClientRect().width;
    if (s <= 0) return o.length;
    if (i.offsetLeft + s > n) break;
    r += 1;
  }
  return Math.max(1, r);
}
function GD({
  children: t,
  ...e
}) {
  const n = x.useRef(null), o = x.useRef(null), r = x.useRef(null), i = x.useRef(() => {
  }), [s, l] = x.useState(!1), [a, c] = x.useState(0), [u, d] = x.useState(Number.POSITIVE_INFINITY), f = x.Children.toArray(t), p = f.length, m = p > 0 ? a % p : 0, h = f.map((y, w) => ({
    child: bE(y),
    key: w
  })), b = s ? [...h.slice(m), ...h.slice(0, m)] : h;
  i.current = () => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R) return;
    const S = Cb(y), E = vE(R), N = yE(S), I = E > S, M = p >= hE && E > N, T = p > 1 && S > 0 && (I || M);
    l(T), d(T ? xE(w, R) : p), T || c(0);
  }, x.useLayoutEffect(() => {
    i.current();
  }), x.useLayoutEffect(() => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R || typeof ResizeObserver > "u")
      return;
    const S = new ResizeObserver(() => {
      i.current();
    });
    return S.observe(y), S.observe(w), S.observe(R), () => S.disconnect();
  }, []);
  const v = () => {
    p !== 0 && c((y) => (y + 1) % p);
  };
  return /* @__PURE__ */ F("div", { ...e, ref: n, "data-slot": "carousel", className: s ? "flex w-full items-center" : "flex w-full items-center gap-(--spacing-10)", children: [
    s && /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "chevron-left", "aria-label": "Previous Images", onClick: () => {
      p !== 0 && c((y) => (y - 1 + p) % p);
    } }),
    /* @__PURE__ */ g("div", { ref: o, "data-slot": "carousel-viewport", className: s ? "min-w-0 flex-1 overflow-hidden" : "min-w-0 max-w-full overflow-hidden", children: /* @__PURE__ */ g("div", { ref: r, "data-slot": "carousel-track", className: "relative flex w-max items-center gap-(--spacing-10) p-(--spacing-4)", children: b.map(({
      child: y,
      key: w
    }, R) => {
      const S = s && R >= u;
      return /* @__PURE__ */ g("div", { "data-slot": "carousel-item", className: "shrink-0", inert: S ? !0 : void 0, "aria-hidden": S || void 0, children: y }, w);
    }) }) }),
    s && /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "chevron-right", "aria-label": "Next Images", onClick: v })
  ] });
}
function YD(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(z5, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
async function CE(t, e) {
  if (navigator.clipboard?.write && typeof ClipboardItem < "u")
    try {
      await navigator.clipboard.write([new ClipboardItem({
        "text/html": new Blob([e], {
          type: "text/html"
        }),
        "text/plain": new Blob([t], {
          type: "text/plain"
        })
      })]);
      return;
    } catch {
    }
  if (!navigator.clipboard?.writeText)
    throw new Error("Clipboard API is unavailable.");
  await navigator.clipboard.writeText(t);
}
function jD({
  content: t,
  onCopy: e,
  onCopyError: n,
  copyLabel: o = "Copy message",
  copiedLabel: r = "Copied message",
  ...i
}) {
  const [s, l] = qe("default"), a = at(null);
  Nt(() => () => {
    a.current !== null && clearTimeout(a.current);
  }, []);
  async function c() {
    try {
      if (t.html)
        await CE(t.text, t.html);
      else {
        if (!navigator.clipboard?.writeText)
          throw new Error("Clipboard API is unavailable.");
        await navigator.clipboard.writeText(t.text);
      }
    } catch (d) {
      l("error"), n?.(d);
      return;
    }
    l("copied"), a.current !== null && clearTimeout(a.current), a.current = setTimeout(() => l("default"), 3e3), e?.();
  }
  const u = s === "copied";
  return /* @__PURE__ */ g(bt, { "data-slot": "chat-copy-button", "data-copy-state": s, icon: u ? "check-mark" : "copy-regular", "aria-label": u ? r : o, variant: "ghost", size: "sm", onClick: c, ...i });
}
let $m = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
function wE(t) {
  return x.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [$m.checked]: ""
      } : {
        [$m.unchecked]: ""
      };
    },
    ...io
  }), [t.indeterminate]);
}
const wb = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (wb.displayName = "CheckboxRootContext");
const SE = "data-parent", Sb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i = !1,
    "aria-labelledby": s,
    disabled: l = !1,
    form: a,
    id: c,
    indeterminate: u = !1,
    inputRef: d,
    name: f,
    onCheckedChange: p,
    parent: m = !1,
    readOnly: h = !1,
    render: b,
    required: v = !1,
    uncheckedValue: C,
    value: y,
    nativeButton: w = !1,
    style: R,
    ...S
  } = e, {
    clearErrors: E
  } = Fo(), {
    disabled: N,
    name: I,
    setDirty: M,
    setFilled: T,
    setFocused: k,
    setTouched: P,
    state: D,
    validationMode: O,
    validityData: V,
    shouldValidateOnChange: _,
    validation: A
  } = mn(), L = q2(), {
    labelId: $,
    controlId: B,
    registerControlId: z,
    getDescriptionProps: H
  } = Nn(), K = Tx(), G = K?.parent, q = G && K.allValues, Q = N || L.disabled || K?.disabled || l, U = I ?? f, X = y ?? U, te = Ot(), re = Ot();
  let J = B;
  q ? J = m ? re : `${G.id}-${X}` : c && (J = c);
  let ie = {};
  q && (m ? ie = K.parent.getParentProps() : X && (ie = K.parent.getChildProps(X)));
  const ce = we(p), {
    checked: oe = o,
    indeterminate: se = u,
    onCheckedChange: me,
    ...pe
  } = ie, le = K?.value, ge = K?.setValue, j = K?.defaultValue, ee = x.useRef(null), Y = Lt(() => /* @__PURE__ */ Symbol("checkbox-control")), Z = x.useRef(!1), {
    getButtonProps: ue,
    buttonRef: fe
  } = qt({
    disabled: Q,
    native: w
  }), be = K?.validation ?? A, [Ie, ye] = Sn({
    controlled: X && le && !m ? le.includes(X) : oe,
    default: X && j && !m ? j.includes(X) : i,
    name: "Checkbox",
    state: "checked"
  });
  ke(() => {
    z !== Ct && (Z.current = !0, z(Y.current, J));
  }, [J, K, z, m, Y]), x.useEffect(() => {
    const Ne = Y.current;
    return () => {
      !Z.current || z === Ct || (Z.current = !1, z(Ne, void 0));
    };
  }, [z, Y]), vi(ee, {
    enabled: !K,
    id: te,
    value: Ie
  });
  const xe = x.useRef(null), de = Rn(d, xe, be.inputRef), Se = af(s, $, xe, !w, J ?? void 0);
  ke(() => {
    xe.current && (xe.current.indeterminate = se, Ie && T(!0));
  }, [Ie, se, T]), ko(Ie, () => {
    K && !m || (E(U), T(Ie), M(Ie !== V.initialValue), _() ? be.commit(Ie) : be.commit(Ie, !0));
  });
  const Me = cn(
    {
      checked: Ie,
      disabled: Q,
      form: a,
      // parent checkboxes unset `name` to be excluded from form submission
      name: m ? void 0 : U,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: w ? void 0 : J ?? void 0,
      required: v,
      ref: de,
      style: U ? ii : nr,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(Ne) {
        if (Ne.nativeEvent.defaultPrevented)
          return;
        if (h) {
          Ne.preventDefault();
          return;
        }
        const _e = Ne.currentTarget.checked, Pe = De(At, Ne.nativeEvent);
        if (me?.(_e, Pe), ce(_e, Pe), !Pe.isCanceled && (ye(_e), X && le && ge && !m && !q)) {
          const $e = _e ? [...le, X] : le.filter((He) => He !== X);
          ge($e, Pe);
        }
      },
      onFocus() {
        ee.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: (K ? Ie && y : y) || ""
    } : Et,
    H,
    K ? be.getValidationProps : be.getInputValidationProps
  ), Re = q ? !!oe : Ie, Ve = q && se || u;
  x.useEffect(() => {
    if (!G || !X)
      return;
    const Ne = G.disabledStatesRef.current;
    return Ne.set(X, Q), () => {
      Ne.delete(X);
    };
  }, [G, Q, X]);
  const Ze = x.useMemo(() => ({
    ...D,
    checked: Re,
    disabled: Q,
    readOnly: h,
    required: v,
    indeterminate: Ve
  }), [D, Re, Q, h, v, Ve]), Xe = wE(Ze), Be = Le("span", e, {
    state: Ze,
    ref: [fe, ee, n, K?.registerControlRef],
    props: [{
      id: w ? J ?? void 0 : te,
      role: "checkbox",
      "aria-checked": se ? "mixed" : Ie,
      "aria-readonly": h || void 0,
      "aria-required": v || void 0,
      "aria-labelledby": Se,
      [SE]: m ? "" : void 0,
      onFocus() {
        k(!0);
      },
      onBlur() {
        const Ne = xe.current;
        Ne && (P(!0), k(!1), O === "onBlur" && be.commit(K ? le : Ne.checked));
      },
      onClick(Ne) {
        h || Q || (Ne.preventDefault(), xe.current?.dispatchEvent(new PointerEvent("click", {
          bubbles: !0,
          shiftKey: Ne.shiftKey,
          ctrlKey: Ne.ctrlKey,
          altKey: Ne.altKey,
          metaKey: Ne.metaKey
        })));
      }
    }, H, be.getValidationProps, S, pe, ue],
    stateAttributesMapping: Xe
  });
  return /* @__PURE__ */ F(wb.Provider, {
    value: Ze,
    children: [Be, !Ie && !K && U && !m && C !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: a,
      name: U,
      value: C
    }), /* @__PURE__ */ g("input", {
      ...Me,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (Sb.displayName = "CheckboxRoot");
const na = {
  sm: "rounded-[2px]",
  md: "rounded-(--radius-sm)"
}, Hm = {
  sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
  // Snap md to whole pixels to avoid SVG crossfade shimmer from 19.2px subpixel rasterization.
  md: ["w-[20px]", "h-[20px]"]
}, RE = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "group/checkbox",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1px]",
  "focus-visible:ring-checkbox-focus-ring",
  "cursor-[inherit]",
  // touch target — before:inset per size to maintain WCAG 44×44px minimum
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", na.sm, "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", na.md, "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), EE = ae(["absolute", "left-1/2", "top-1/2", "z-10", "inline-flex", "-translate-x-1/2", "-translate-y-1/2", "items-center", "justify-center", "overflow-hidden", "transition-[background-color]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "group-data-[checked]/checkbox:bg-checkbox-filled-default-background", "group-data-[indeterminate]/checkbox:bg-checkbox-filled-default-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-data-[error]/checkbox:bg-error", "group-data-[disabled]/checkbox:bg-checkbox-filled-disabled-background"], {
  variants: {
    size: {
      sm: [na.sm, ...Hm.sm],
      md: [na.md, ...Hm.md]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), NE = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-outline-hover-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), kE = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-outline-pressed-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), IE = ae(["absolute", "inset-0", "h-full", "w-full", "text-checkbox-outline-default-border", "group-[:not([data-error]):not([data-disabled]):hover]/checkbox:text-checkbox-outline-hover-border", "group-[:not([data-error]):not([data-disabled]):active]/checkbox:text-checkbox-outline-pressed-border", "group-data-[error]/checkbox:text-error", "group-data-[disabled]/checkbox:text-checkbox-filled-disabled-background", "group-data-[checked]/checkbox:opacity-0", "group-data-[indeterminate]/checkbox:opacity-0", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), PE = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[checked]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), ME = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[indeterminate]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]);
function TE(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M13.7143 1.14286C14.3464 1.14286 14.8571 1.65357 14.8571 2.28571V13.7143C14.8571 14.3464 14.3464 14.8571 13.7143 14.8571H2.28571C1.65357 14.8571 1.14286 14.3464 1.14286 13.7143V2.28571C1.14286 1.65357 1.65357 1.14286 2.28571 1.14286H13.7143ZM2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function OE(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function DE(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M3 7V9H13V7H3Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
const zm = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), _E = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), VE = ae([], {
  variants: {
    size: {
      sm: [],
      md: []
    },
    labelLeft: {
      true: [],
      false: []
    }
  },
  compoundVariants: [{
    labelLeft: !1,
    size: "sm",
    className: "pl-[calc(var(--icon-sm)+var(--spacing-8))]"
  }, {
    labelLeft: !1,
    size: "md",
    className: "pl-[calc(var(--icon-md)+var(--spacing-8))]"
  }],
  defaultVariants: {
    size: "sm",
    labelLeft: !1
  }
});
function AE(t) {
  const e = W.c(69);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    error: r,
    label: s,
    description: n,
    labelLeft: l,
    size: c,
    indeterminate: i,
    disabled: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = $t();
  let d;
  e[9] !== n || e[10] !== u || e[11] !== a ? (d = [a["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[9] = n, e[10] = u, e[11] = a, e[12] = d) : d = e[12];
  const f = d, p = o ? "cursor-not-allowed" : "cursor-pointer";
  let m;
  e[13] !== p ? (m = ne("inline-flex flex-col gap-(--spacing-4)", p), e[13] = p, e[14] = m) : m = e[14];
  let h;
  e[15] !== o || e[16] !== u || e[17] !== s || e[18] !== l ? (h = l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(zm(), o && "opacity-50"), children: s }), e[15] = o, e[16] = u, e[17] = s, e[18] = l, e[19] = h) : h = e[19];
  const b = s ? void 0 : a["aria-label"], v = s ? `${u}-label` : void 0, C = r || void 0, y = r ? "" : void 0;
  let w;
  e[20] !== c ? (w = ne(RE({
    size: c
  })), e[20] = c, e[21] = w) : w = e[21];
  let R;
  e[22] !== c ? (R = ne(NE({
    size: c
  })), e[22] = c, e[23] = R) : R = e[23];
  let S;
  e[24] !== R ? (S = /* @__PURE__ */ g("span", { className: R }), e[24] = R, e[25] = S) : S = e[25];
  let E;
  e[26] !== c ? (E = ne(kE({
    size: c
  })), e[26] = c, e[27] = E) : E = e[27];
  let N;
  e[28] !== E ? (N = /* @__PURE__ */ g("span", { className: E }), e[28] = E, e[29] = N) : N = e[29];
  let I;
  e[30] !== c ? (I = ne(EE({
    size: c
  })), e[30] = c, e[31] = I) : I = e[31];
  let M;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = /* @__PURE__ */ g(TE, { className: ne(IE()) }), e[32] = M) : M = e[32];
  let T;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ g(OE, { className: ne(PE()) }), e[33] = T) : T = e[33];
  let k;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ g(DE, { className: ne(ME()) }), e[34] = k) : k = e[34];
  let P;
  e[35] !== I ? (P = /* @__PURE__ */ F("span", { className: I, children: [
    M,
    T,
    k
  ] }), e[35] = I, e[36] = P) : P = e[36];
  let D;
  e[37] !== f || e[38] !== o || e[39] !== i || e[40] !== a || e[41] !== S || e[42] !== N || e[43] !== P || e[44] !== b || e[45] !== v || e[46] !== C || e[47] !== y || e[48] !== w ? (D = /* @__PURE__ */ F(Sb, { ...a, indeterminate: i, disabled: o, "aria-label": b, "aria-labelledby": v, "aria-describedby": f, "aria-invalid": C, "data-error": y, className: w, children: [
    S,
    N,
    P
  ] }), e[37] = f, e[38] = o, e[39] = i, e[40] = a, e[41] = S, e[42] = N, e[43] = P, e[44] = b, e[45] = v, e[46] = C, e[47] = y, e[48] = w, e[49] = D) : D = e[49];
  let O;
  e[50] !== o || e[51] !== u || e[52] !== s || e[53] !== l ? (O = !l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(zm(), o && "opacity-50"), children: s }), e[50] = o, e[51] = u, e[52] = s, e[53] = l, e[54] = O) : O = e[54];
  let V;
  e[55] !== D || e[56] !== O || e[57] !== h ? (V = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    h,
    D,
    O
  ] }), e[55] = D, e[56] = O, e[57] = h, e[58] = V) : V = e[58];
  let _;
  e[59] !== n || e[60] !== o || e[61] !== u || e[62] !== l || e[63] !== c ? (_ = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: ne(_E(), o && "opacity-50", VE({
    size: c,
    labelLeft: l
  })), children: n }), e[59] = n, e[60] = o, e[61] = u, e[62] = l, e[63] = c, e[64] = _) : _ = e[64];
  let A;
  return e[65] !== V || e[66] !== _ || e[67] !== m ? (A = /* @__PURE__ */ F("label", { className: m, children: [
    V,
    _
  ] }), e[65] = V, e[66] = _, e[67] = m, e[68] = A) : A = e[68], A;
}
function LE(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const FE = {}, zi = {};
function mr(t, e) {
  try {
    const o = (FE[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return o in zi ? zi[o] : Bm(o, o.split(":"));
  } catch {
    if (t in zi) return zi[t];
    const n = t?.match($E);
    return n ? Bm(t, n.slice(1)) : NaN;
  }
}
const $E = /([+-]\d\d):?(\d\d)?/;
function Bm(t, e) {
  const n = +(e[0] || 0), o = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return zi[t] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class co extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(mr(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Rb(this), Su(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new co(...n, e) : new co(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new co(+this, e);
  }
  getTimezoneOffset() {
    const e = -mr(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), Su(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new co(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Wm = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Wm.test(t)) return;
  const e = t.replace(Wm, "$1UTC");
  co.prototype[e] && (t.startsWith("get") ? co.prototype[t] = function() {
    return this.internal[e]();
  } : (co.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), HE(this), +this;
  }, co.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), Su(this), +this;
  }));
});
function Su(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-mr(t.timeZone, t) * 60));
}
function HE(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), Rb(t);
}
function Rb(t) {
  const e = mr(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), o = /* @__PURE__ */ new Date(+t);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), s = r - i, l = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  s && l && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + s);
  const a = r - n;
  a && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + a);
  const c = /* @__PURE__ */ new Date(+t);
  c.setUTCSeconds(0);
  const u = r > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(mr(t.timeZone, t) * 60)) % 60;
  (d || u) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + d + u));
  const f = mr(t.timeZone, t), p = f > 0 ? Math.floor(f) : Math.ceil(f), h = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - p, b = p !== n, v = h - a;
  if (b && v) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v);
    const C = mr(t.timeZone, t), y = C > 0 ? Math.floor(C) : Math.ceil(C), w = p - y;
    w && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + w), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + w));
  }
}
class vn extends co {
  //#region static
  static tz(e, ...n) {
    return n.length ? new vn(...n, e) : new vn(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${LE(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new vn(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new vn(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Eb = 6048e5, zE = 864e5, Um = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Qt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Um in t ? t[Um](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Dt(t, e) {
  return Qt(e || t, t);
}
function Nb(t, e, n) {
  const o = Dt(t, n?.in);
  return isNaN(e) ? Qt(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function kb(t, e, n) {
  const o = Dt(t, n?.in);
  if (isNaN(e)) return Qt(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), i = Qt(t, o.getTime());
  i.setMonth(o.getMonth() + e + 1, 0);
  const s = i.getDate();
  return r >= s ? i : (o.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), o);
}
let BE = {};
function Fs() {
  return BE;
}
function ni(t, e) {
  const n = Fs(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Dt(t, e?.in), i = r.getDay(), s = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function is(t, e) {
  return ni(t, { ...e, weekStartsOn: 1 });
}
function Ib(t, e) {
  const n = Dt(t, e?.in), o = n.getFullYear(), r = Qt(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = is(r), s = Qt(n, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const l = is(s);
  return n.getTime() >= i.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function Gm(t) {
  const e = Dt(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Si(t, ...e) {
  const n = Qt.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function ss(t, e) {
  const n = Dt(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function l1(t, e, n) {
  const [o, r] = Si(
    n?.in,
    t,
    e
  ), i = ss(o), s = ss(r), l = +i - Gm(i), a = +s - Gm(s);
  return Math.round((l - a) / zE);
}
function WE(t, e) {
  const n = Ib(t, e), o = Qt(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), is(o);
}
function UE(t, e, n) {
  return Nb(t, e * 7, n);
}
function GE(t, e, n) {
  return kb(t, e * 12, n);
}
function YE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Qt.bind(null, r));
    const i = Dt(r, o);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Qt(o, n || NaN);
}
function jE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Qt.bind(null, r));
    const i = Dt(r, o);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Qt(o, n || NaN);
}
function KE(t, e, n) {
  const [o, r] = Si(
    n?.in,
    t,
    e
  );
  return +ss(o) == +ss(r);
}
function Pb(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function qE(t) {
  return !(!Pb(t) && typeof t != "number" || isNaN(+Dt(t)));
}
function Mb(t, e, n) {
  const [o, r] = Si(
    n?.in,
    t,
    e
  ), i = o.getFullYear() - r.getFullYear(), s = o.getMonth() - r.getMonth();
  return i * 12 + s;
}
function ZE(t, e) {
  const n = Dt(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Tb(t, e) {
  const [n, o] = Si(t, e.start, e.end);
  return { start: n, end: o };
}
function XE(t, e) {
  const { start: n, end: o } = Tb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Qt(n, s)), s.setMonth(s.getMonth() + l);
  return r ? a.reverse() : a;
}
function QE(t, e) {
  const n = Dt(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function JE(t, e) {
  const n = Dt(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Ob(t, e) {
  const n = Dt(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function eN(t, e) {
  const { start: n, end: o } = Tb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Qt(n, s)), s.setFullYear(s.getFullYear() + l);
  return r ? a.reverse() : a;
}
function Db(t, e) {
  const n = Fs(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Dt(t, e?.in), i = r.getDay(), s = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function tN(t, e) {
  return Db(t, { ...e, weekStartsOn: 1 });
}
const nN = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, oN = (t, e, n) => {
  let o;
  const r = nN[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function Ic(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const rN = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, iN = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, sN = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lN = {
  date: Ic({
    formats: rN,
    defaultWidth: "full"
  }),
  time: Ic({
    formats: iN,
    defaultWidth: "full"
  }),
  dateTime: Ic({
    formats: sN,
    defaultWidth: "full"
  })
}, aN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, cN = (t, e, n, o) => aN[t];
function Oi(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, l = n?.width ? String(n.width) : s;
      r = t.formattingValues[l] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, l = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[l] || t.values[s];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const uN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, dN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, fN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, pN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, mN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, gN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, hN = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, bN = {
  ordinalNumber: hN,
  era: Oi({
    values: uN,
    defaultWidth: "wide"
  }),
  quarter: Oi({
    values: dN,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Oi({
    values: fN,
    defaultWidth: "wide"
  }),
  day: Oi({
    values: pN,
    defaultWidth: "wide"
  }),
  dayPeriod: Oi({
    values: mN,
    defaultWidth: "wide",
    formattingValues: gN,
    defaultFormattingWidth: "wide"
  })
};
function Di(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const s = i[0], l = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], a = Array.isArray(l) ? yN(l, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      vN(l, (d) => d.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(a) : a, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function vN(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function yN(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function xN(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const l = e.slice(r.length);
    return { value: s, rest: l };
  };
}
const CN = /^(\d+)(th|st|nd|rd)?/i, wN = /\d+/i, SN = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, RN = {
  any: [/^b/i, /^(a|c)/i]
}, EN = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, NN = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kN = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, IN = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, PN = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, MN = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, TN = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ON = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, DN = {
  ordinalNumber: xN({
    matchPattern: CN,
    parsePattern: wN,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Di({
    matchPatterns: SN,
    defaultMatchWidth: "wide",
    parsePatterns: RN,
    defaultParseWidth: "any"
  }),
  quarter: Di({
    matchPatterns: EN,
    defaultMatchWidth: "wide",
    parsePatterns: NN,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Di({
    matchPatterns: kN,
    defaultMatchWidth: "wide",
    parsePatterns: IN,
    defaultParseWidth: "any"
  }),
  day: Di({
    matchPatterns: PN,
    defaultMatchWidth: "wide",
    parsePatterns: MN,
    defaultParseWidth: "any"
  }),
  dayPeriod: Di({
    matchPatterns: TN,
    defaultMatchWidth: "any",
    parsePatterns: ON,
    defaultParseWidth: "any"
  })
}, Hr = {
  code: "en-US",
  formatDistance: oN,
  formatLong: lN,
  formatRelative: cN,
  localize: bN,
  match: DN,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function _N(t, e) {
  const n = Dt(t, e?.in);
  return l1(n, Ob(n)) + 1;
}
function a1(t, e) {
  const n = Dt(t, e?.in), o = +is(n) - +WE(n);
  return Math.round(o / Eb) + 1;
}
function _b(t, e) {
  const n = Dt(t, e?.in), o = n.getFullYear(), r = Fs(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = Qt(e?.in || t, 0);
  s.setFullYear(o + 1, 0, i), s.setHours(0, 0, 0, 0);
  const l = ni(s, e), a = Qt(e?.in || t, 0);
  a.setFullYear(o, 0, i), a.setHours(0, 0, 0, 0);
  const c = ni(a, e);
  return +n >= +l ? o + 1 : +n >= +c ? o : o - 1;
}
function VN(t, e) {
  const n = Fs(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = _b(t, e), i = Qt(e?.in || t, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), ni(i, e);
}
function c1(t, e) {
  const n = Dt(t, e?.in), o = +ni(n, e) - +VN(n, e);
  return Math.round(o / Eb) + 1;
}
function kt(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const zo = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return kt(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : kt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return kt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return kt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return kt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return kt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return kt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return kt(r, e.length);
  }
}, Fr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ym = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return zo.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = _b(t, o), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const s = i % 100;
      return kt(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : kt(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Ib(t);
    return kt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return kt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return kt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return kt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return zo.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return kt(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = c1(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : kt(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = a1(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : kt(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : zo.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = _N(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : kt(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return kt(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return kt(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return kt(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = Fr.noon : o === 0 ? r = Fr.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = Fr.evening : o >= 12 ? r = Fr.afternoon : o >= 4 ? r = Fr.morning : r = Fr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return zo.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : zo.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : kt(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : kt(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : zo.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : zo.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return zo.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Km(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return dr(o);
      // Hours and minutes with `:` delimiter
      default:
        return dr(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Km(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return dr(o);
      // Hours and minutes with `:` delimiter
      default:
        return dr(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jm(o, ":");
      default:
        return "GMT" + dr(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jm(o, ":");
      default:
        return "GMT" + dr(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return kt(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return kt(+t, e.length);
  }
};
function jm(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + kt(i, 2);
}
function Km(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + kt(Math.abs(t) / 60, 2) : dr(t, e);
}
function dr(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = kt(Math.trunc(o / 60), 2), i = kt(o % 60, 2);
  return n + r + e + i;
}
const qm = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, Vb = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, AN = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return qm(t, e);
  let i;
  switch (o) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", qm(o, e)).replace("{{time}}", Vb(r, e));
}, LN = {
  p: Vb,
  P: AN
}, FN = /^D+$/, $N = /^Y+$/, HN = ["D", "DD", "YY", "YYYY"];
function zN(t) {
  return FN.test(t);
}
function BN(t) {
  return $N.test(t);
}
function WN(t, e, n) {
  const o = UN(t, e, n);
  if (console.warn(o), HN.includes(t)) throw new RangeError(o);
}
function UN(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const GN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, YN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jN = /^'([^]*?)'?$/, KN = /''/g, qN = /[a-zA-Z]/;
function Bi(t, e, n) {
  const o = Fs(), r = n?.locale ?? o.locale ?? Hr, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, l = Dt(t, n?.in);
  if (!qE(l))
    throw new RangeError("Invalid time value");
  let a = e.match(YN).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = LN[d];
      return f(u, r.formatLong);
    }
    return u;
  }).join("").match(GN).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: ZN(u) };
    if (Ym[d])
      return { isToken: !0, value: u };
    if (d.match(qN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (a = r.localize.preprocessor(l, a));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: r
  };
  return a.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && BN(d) || !n?.useAdditionalDayOfYearTokens && zN(d)) && WN(d, e, String(t));
    const f = Ym[d[0]];
    return f(l, d, r.localize, c);
  }).join("");
}
function ZN(t) {
  const e = t.match(jN);
  return e ? e[1].replace(KN, "'") : t;
}
function XN(t, e) {
  const n = Dt(t, e?.in), o = n.getFullYear(), r = n.getMonth(), i = Qt(n, 0);
  return i.setFullYear(o, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function QN(t, e) {
  return Dt(t, e?.in).getMonth();
}
function JN(t, e) {
  return Dt(t, e?.in).getFullYear();
}
function ek(t, e) {
  return +Dt(t) > +Dt(e);
}
function tk(t, e) {
  return +Dt(t) < +Dt(e);
}
function nk(t, e, n) {
  const [o, r] = Si(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function ok(t, e, n) {
  const [o, r] = Si(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function rk(t, e, n) {
  const o = Dt(t, n?.in), r = o.getFullYear(), i = o.getDate(), s = Qt(t, 0);
  s.setFullYear(r, e, 15), s.setHours(0, 0, 0, 0);
  const l = XN(s);
  return o.setMonth(e, Math.min(i, l)), o;
}
function ik(t, e, n) {
  const o = Dt(t, n?.in);
  return isNaN(+o) ? Qt(t, NaN) : (o.setFullYear(e), o);
}
const Zm = 5, sk = 4;
function lk(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), i = e.addDays(r, Zm * 7 - 1);
  return e.getMonth(t) === e.getMonth(i) ? Zm : sk;
}
function Ab(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -6) : e.addDays(n, -1 * (o - 1));
}
function ak(t, e) {
  const n = Ab(t, e), o = lk(t, e);
  return e.addDays(n, o * 7 - 1);
}
const Lb = {
  ...Hr,
  labels: {
    labelDayButton: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Bi(s, l, { locale: Hr, ...n });
      let i = r(t, "PPPP");
      return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (t) => `Week ${t}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Bi(r, i, { locale: Hr, ...e }), o(t, "LLLL yyyy");
    },
    labelGridcell: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Bi(s, l, { locale: Hr, ...n });
      let i = r(t, "PPPP");
      return e?.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Bi(r, i, { locale: Hr, ...e }), o(t, "cccc");
    }
  }
};
class _n {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? vn.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, i) => this.overrides?.newDate ? this.overrides.newDate(o, r, i) : this.options.timeZone ? new vn(o, r, i, this.options.timeZone) : new Date(o, r, i), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : Nb(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : kb(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : UE(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : GE(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : l1(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : Mb(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : XE(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : eN(o), i = new Set(r.map((l) => this.getYear(l)));
      if (i.size === r.length)
        return r;
      const s = [];
      return i.forEach((l) => {
        s.push(new Date(l, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : ak(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : tN(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : ZE(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Db(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : JE(o), this.format = (o, r, i) => {
      const s = this.overrides?.format ? this.overrides.format(o, r, this.options) : Bi(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : a1(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : QN(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : JN(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : c1(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : ek(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : tk(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : Pb(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : KE(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : nk(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : ok(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : YE(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : jE(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : rk(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : ik(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : Ab(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : ss(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : is(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : QE(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : ni(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : Ob(o), this.options = { locale: Lb, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && _n.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: n, timeZone: o, numerals: r } = this.options, i = n?.code;
    if (i && _n.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(e);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, s);
  }
}
_n.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const So = new _n();
class Fb {
  constructor(e, n, o = So) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o, this.isoDate = o.format(e, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class ck {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class uk {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function dk(t) {
  return We.createElement("button", { ...t });
}
function fk(t) {
  return We.createElement("span", { ...t });
}
function pk(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    We.createElement(
      "svg",
      { className: o, width: e, height: e, viewBox: "0 0 24 24" },
      n === "up" && We.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && We.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && We.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && We.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function mk(t) {
  const { day: e, modifiers: n, ...o } = t;
  return We.createElement("td", { ...o });
}
function gk(t) {
  const { day: e, modifiers: n, ...o } = t, r = We.useRef(null);
  return We.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), We.createElement("button", { ref: r, ...o });
}
var tt;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(tt || (tt = {}));
var zt;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(zt || (zt = {}));
var Zn;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Zn || (Zn = {}));
var On;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(On || (On = {}));
function hk(t) {
  const { options: e, className: n, components: o, classNames: r, ...i } = t, s = [r[tt.Dropdown], n].join(" "), l = e?.find(({ value: a }) => a === i.value);
  return We.createElement(
    "span",
    { "data-disabled": i.disabled, className: r[tt.DropdownRoot] },
    We.createElement(o.Select, { className: s, ...i }, e?.map(({ value: a, label: c, disabled: u }) => We.createElement(o.Option, { key: a, value: a, disabled: u }, c))),
    We.createElement(
      "span",
      { className: r[tt.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      We.createElement(o.Chevron, { orientation: "down", size: 18, className: r[tt.Chevron] })
    )
  );
}
function bk(t) {
  return We.createElement("div", { ...t });
}
function vk(t) {
  return We.createElement("div", { ...t });
}
function yk(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return We.createElement("div", { ...o }, t.children);
}
function xk(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return We.createElement("div", { ...o });
}
function Ck(t) {
  return We.createElement("table", { ...t });
}
function wk(t) {
  return We.createElement("div", { ...t });
}
const $b = yo(void 0);
function Ri() {
  const t = Ig($b);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function Sk(t) {
  const { components: e } = Ri();
  return We.createElement(e.Dropdown, { ...t });
}
function Rk(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...i } = t, { components: s, classNames: l, labels: { labelPrevious: a, labelNext: c } } = Ri(), u = Ln((f) => {
    r && n?.(f);
  }, [r, n]), d = Ln((f) => {
    o && e?.(f);
  }, [o, e]);
  return We.createElement(
    "nav",
    { ...i },
    We.createElement(
      s.PreviousMonthButton,
      { type: "button", className: l[tt.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": a(o), onClick: d },
      We.createElement(s.Chevron, { disabled: o ? void 0 : !0, className: l[tt.Chevron], orientation: "left" })
    ),
    We.createElement(
      s.NextMonthButton,
      { type: "button", className: l[tt.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      We.createElement(s.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: l[tt.Chevron] })
    )
  );
}
function Ek(t) {
  const { components: e } = Ri();
  return We.createElement(e.Button, { ...t });
}
function Nk(t) {
  return We.createElement("option", { ...t });
}
function kk(t) {
  const { components: e } = Ri();
  return We.createElement(e.Button, { ...t });
}
function Ik(t) {
  const { rootRef: e, ...n } = t;
  return We.createElement("div", { ...n, ref: e });
}
function Pk(t) {
  return We.createElement("select", { ...t });
}
function Mk(t) {
  const { week: e, ...n } = t;
  return We.createElement("tr", { ...n });
}
function Tk(t) {
  return We.createElement("th", { ...t });
}
function Ok(t) {
  return We.createElement(
    "thead",
    { "aria-hidden": !0 },
    We.createElement("tr", { ...t })
  );
}
function Dk(t) {
  const { week: e, ...n } = t;
  return We.createElement("th", { ...n });
}
function _k(t) {
  return We.createElement("th", { ...t });
}
function Vk(t) {
  return We.createElement("tbody", { ...t });
}
function Ak(t) {
  const { components: e } = Ri();
  return We.createElement(e.Dropdown, { ...t });
}
const Lk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: dk,
  CaptionLabel: fk,
  Chevron: pk,
  Day: mk,
  DayButton: gk,
  Dropdown: hk,
  DropdownNav: bk,
  Footer: vk,
  Month: yk,
  MonthCaption: xk,
  MonthGrid: Ck,
  Months: wk,
  MonthsDropdown: Sk,
  Nav: Rk,
  NextMonthButton: Ek,
  Option: Nk,
  PreviousMonthButton: kk,
  Root: Ik,
  Select: Pk,
  Week: Mk,
  WeekNumber: Dk,
  WeekNumberHeader: _k,
  Weekday: Tk,
  Weekdays: Ok,
  Weeks: Vk,
  YearsDropdown: Ak
}, Symbol.toStringTag, { value: "Module" }));
function Po(t, e, n = !1, o = So) {
  let { from: r, to: i } = t;
  const { differenceInCalendarDays: s, isSameDay: l } = o;
  return r && i ? (s(i, r) < 0 && ([r, i] = [i, r]), s(e, r) >= (n ? 1 : 0) && s(i, e) >= (n ? 1 : 0)) : !n && i ? l(i, e) : !n && r ? l(r, e) : !1;
}
function u1(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function Fa(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function d1(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function f1(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Hb(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function zb(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function Mo(t, e, n = So) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: i, isAfter: s } = n;
  return o.some((l) => {
    if (typeof l == "boolean")
      return l;
    if (n.isDate(l))
      return r(t, l);
    if (zb(l, n))
      return l.some((a) => r(t, a));
    if (Fa(l))
      return Po(l, t, !1, n);
    if (Hb(l))
      return Array.isArray(l.dayOfWeek) ? l.dayOfWeek.includes(t.getDay()) : l.dayOfWeek === t.getDay();
    if (u1(l)) {
      const a = i(l.before, t), c = i(l.after, t), u = a > 0, d = c < 0;
      return s(l.before, l.after) ? d && u : u || d;
    }
    return d1(l) ? i(t, l.after) > 0 : f1(l) ? i(l.before, t) > 0 : typeof l == "function" ? l(t) : !1;
  });
}
function Fk(t, e, n, o, r) {
  const { disabled: i, hidden: s, modifiers: l, showOutsideDays: a, broadcastCalendar: c, today: u = r.today() } = e, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: m, endOfMonth: h, isAfter: b } = r, v = n && p(n), C = o && h(o), y = {
    [zt.focused]: [],
    [zt.outside]: [],
    [zt.disabled]: [],
    [zt.hidden]: [],
    [zt.today]: []
  }, w = {};
  for (const R of t) {
    const { date: S, displayMonth: E } = R, N = !!(E && !f(S, E)), I = !!(v && m(S, v)), M = !!(C && b(S, C)), T = !!(i && Mo(S, i, r)), k = !!(s && Mo(S, s, r)) || I || M || // Broadcast calendar will show outside days as default
    !c && !a && N || c && a === !1 && N, P = d(S, u);
    N && y.outside.push(R), T && y.disabled.push(R), k && y.hidden.push(R), P && y.today.push(R), l && Object.keys(l).forEach((D) => {
      const O = l?.[D];
      O && Mo(S, O, r) && (w[D] ? w[D].push(R) : w[D] = [R]);
    });
  }
  return (R) => {
    const S = {
      [zt.focused]: !1,
      [zt.disabled]: !1,
      [zt.hidden]: !1,
      [zt.outside]: !1,
      [zt.today]: !1
    }, E = {};
    for (const N in y) {
      const I = y[N];
      S[N] = I.some((M) => M === R);
    }
    for (const N in w)
      E[N] = w[N].some((I) => I === R);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function $k(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [i]) => (n[i] ? r.push(n[i]) : e[zt[i]] ? r.push(e[zt[i]]) : e[Zn[i]] && r.push(e[Zn[i]]), r), [e[tt.Day]]);
}
function Hk(t) {
  return {
    ...Lk,
    ...t
  };
}
function zk(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function Bk() {
  const t = {};
  for (const e in tt)
    t[tt[e]] = `rdp-${tt[e]}`;
  for (const e in zt)
    t[zt[e]] = `rdp-${zt[e]}`;
  for (const e in Zn)
    t[Zn[e]] = `rdp-${Zn[e]}`;
  for (const e in On)
    t[On[e]] = `rdp-${On[e]}`;
  return t;
}
function Bb(t, e, n) {
  return (n ?? new _n(e)).formatMonthYear(t);
}
const Wk = Bb;
function Uk(t, e, n) {
  return (n ?? new _n(e)).format(t, "d");
}
function Gk(t, e = So) {
  return e.format(t, "LLLL");
}
function Yk(t, e, n) {
  return (n ?? new _n(e)).format(t, "cccccc");
}
function jk(t, e = So) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function Kk() {
  return "";
}
function Wb(t, e = So) {
  return e.format(t, "yyyy");
}
const qk = Wb, Zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Bb,
  formatDay: Uk,
  formatMonthCaption: Wk,
  formatMonthDropdown: Gk,
  formatWeekNumber: jk,
  formatWeekNumberHeader: Kk,
  formatWeekdayName: Yk,
  formatYearCaption: qk,
  formatYearDropdown: Wb
}, Symbol.toStringTag, { value: "Module" }));
function Xk(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...Zk,
    ...t
  };
}
function p1(t, e, n, o) {
  let r = (o ?? new _n(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const Qk = p1;
function m1(t, e, n) {
  return (n ?? new _n(e)).formatMonthYear(t);
}
const Jk = m1;
function Ub(t, e, n, o) {
  let r = (o ?? new _n(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function Gb(t) {
  return "Choose the Month";
}
function Yb() {
  return "";
}
const eI = "Go to the Next Month";
function jb(t, e) {
  return eI;
}
function Kb(t) {
  return "Go to the Previous Month";
}
function qb(t, e, n) {
  return (n ?? new _n(e)).format(t, "cccc");
}
function Zb(t, e) {
  return `Week ${t}`;
}
function Xb(t) {
  return "Week Number";
}
function Qb(t) {
  return "Choose the Year";
}
const tI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Jk,
  labelDay: Qk,
  labelDayButton: p1,
  labelGrid: m1,
  labelGridcell: Ub,
  labelMonthDropdown: Gb,
  labelNav: Yb,
  labelNext: jb,
  labelPrevious: Kb,
  labelWeekNumber: Zb,
  labelWeekNumberHeader: Xb,
  labelWeekday: qb,
  labelYearDropdown: Qb
}, Symbol.toStringTag, { value: "Module" })), jn = (t, e, n) => e || (n ? typeof n == "function" ? n : (...o) => n : t);
function nI(t, e) {
  const n = e.locale?.labels ?? {};
  return {
    ...tI,
    ...t ?? {},
    labelDayButton: jn(p1, t?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: jn(Gb, t?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: jn(jb, t?.labelNext, n.labelNext),
    labelPrevious: jn(Kb, t?.labelPrevious, n.labelPrevious),
    labelWeekNumber: jn(Zb, t?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: jn(Qb, t?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: jn(m1, t?.labelGrid, n.labelGrid),
    labelGridcell: jn(Ub, t?.labelGridcell, n.labelGridcell),
    labelNav: jn(Yb, t?.labelNav, n.labelNav),
    labelWeekNumberHeader: jn(Xb, t?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: jn(qb, t?.labelWeekday, n.labelWeekday)
  };
}
function oI(t, e, n, o, r) {
  const { startOfMonth: i, startOfYear: s, endOfYear: l, eachMonthOfInterval: a, getMonth: c } = r;
  return a({
    start: s(t),
    end: l(t)
  }).map((f) => {
    const p = o.formatMonthDropdown(f, r), m = c(f), h = e && f < i(e) || n && f > i(n) || !1;
    return { value: m, label: p, disabled: h };
  });
}
function rI(t, e = {}, n = {}) {
  let o = { ...e?.[tt.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function iI(t, e, n, o) {
  const r = o ?? t.today(), i = n ? t.startOfBroadcastWeek(r, t) : e ? t.startOfISOWeek(r) : t.startOfWeek(r), s = [];
  for (let l = 0; l < 7; l++) {
    const a = t.addDays(i, l);
    s.push(a);
  }
  return s;
}
function sI(t, e, n, o, r = !1) {
  if (!t || !e)
    return;
  const { startOfYear: i, endOfYear: s, eachYearOfInterval: l, getYear: a } = o, c = i(t), u = s(e), d = l({ start: c, end: u });
  return r && d.reverse(), d.map((f) => {
    const p = n.formatYearDropdown(f, o);
    return {
      value: a(f),
      label: p,
      disabled: !1
    };
  });
}
function lI(t, e = {}) {
  const { weekStartsOn: n, locale: o } = e, r = n ?? o?.options?.weekStartsOn ?? 0, i = (l) => {
    const a = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new vn(a.getFullYear(), a.getMonth(), a.getDate(), 12, 0, 0, t);
  }, s = (l) => {
    const a = i(l);
    return new Date(a.getFullYear(), a.getMonth(), a.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(vn.tz(t)),
    newDate: (l, a, c) => new vn(l, a, c, 12, 0, 0, t),
    startOfDay: (l) => i(l),
    startOfWeek: (l, a) => {
      const c = i(l), u = a?.weekStartsOn ?? r, d = (c.getDay() - u + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfISOWeek: (l) => {
      const a = i(l), c = (a.getDay() - 1 + 7) % 7;
      return a.setDate(a.getDate() - c), a;
    },
    startOfMonth: (l) => {
      const a = i(l);
      return a.setDate(1), a;
    },
    startOfYear: (l) => {
      const a = i(l);
      return a.setMonth(0, 1), a;
    },
    endOfWeek: (l, a) => {
      const c = i(l), f = (((a?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + f), c;
    },
    endOfISOWeek: (l) => {
      const a = i(l), c = (7 - a.getDay()) % 7;
      return a.setDate(a.getDate() + c), a;
    },
    endOfMonth: (l) => {
      const a = i(l);
      return a.setMonth(a.getMonth() + 1, 0), a;
    },
    endOfYear: (l) => {
      const a = i(l);
      return a.setMonth(11, 31), a;
    },
    eachMonthOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new vn(a.getFullYear(), a.getMonth(), 1, 12, 0, 0, t), f = c.getFullYear() * 12 + c.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= f; )
        u.push(new vn(d, t)), d.setMonth(d.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a), c;
    },
    addWeeks: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a * 7), c;
    },
    addMonths: (l, a) => {
      const c = i(l);
      return c.setMonth(c.getMonth() + a), c;
    },
    addYears: (l, a) => {
      const c = i(l);
      return c.setFullYear(c.getFullYear() + a), c;
    },
    eachYearOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new vn(a.getFullYear(), 0, 1, 12, 0, 0, t);
      for (; d.getFullYear() <= c.getFullYear(); )
        u.push(new vn(d, t)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (l, a) => {
      const c = s(l);
      return c1(c, {
        weekStartsOn: a?.weekStartsOn ?? r,
        firstWeekContainsDate: a?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (l) => {
      const a = s(l);
      return a1(a);
    },
    differenceInCalendarDays: (l, a) => {
      const c = s(l), u = s(a);
      return l1(c, u);
    },
    differenceInCalendarMonths: (l, a) => {
      const c = s(l), u = s(a);
      return Mb(c, u);
    }
  };
}
const $s = (t) => t instanceof HTMLElement ? t : null, Pc = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], aI = (t) => $s(t.querySelector("[data-animated-month]")), Mc = (t) => $s(t.querySelector("[data-animated-caption]")), Tc = (t) => $s(t.querySelector("[data-animated-weeks]")), cI = (t) => $s(t.querySelector("[data-animated-nav]")), uI = (t) => $s(t.querySelector("[data-animated-weekdays]"));
function dI(t, e, { classNames: n, months: o, focused: r, dateLib: i }) {
  const s = at(null), l = at(o), a = at(!1);
  go(() => {
    const c = l.current;
    if (l.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const u = i.isSameMonth(o[0].date, c[0].date), d = i.isAfter(o[0].date, c[0].date), f = d ? n[On.caption_after_enter] : n[On.caption_before_enter], p = d ? n[On.weeks_after_enter] : n[On.weeks_before_enter], m = s.current, h = t.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (Pc(h).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const w = aI(y);
      w && y.contains(w) && y.removeChild(w);
      const R = Mc(y);
      R && R.classList.remove(f);
      const S = Tc(y);
      S && S.classList.remove(p);
    }), s.current = h) : s.current = null, a.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const b = m instanceof HTMLElement ? Pc(m) : [], v = Pc(t.current);
    if (v?.every((C) => C instanceof HTMLElement) && b && b.every((C) => C instanceof HTMLElement)) {
      a.current = !0, t.current.style.isolation = "isolate";
      const C = cI(t.current);
      C && (C.style.zIndex = "1"), v.forEach((y, w) => {
        const R = b[w];
        if (!R)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const S = Mc(y);
        S && S.classList.add(f);
        const E = Tc(y);
        E && E.classList.add(p);
        const N = () => {
          a.current = !1, t.current && (t.current.style.isolation = ""), C && (C.style.zIndex = ""), S && S.classList.remove(f), E && E.classList.remove(p), y.style.position = "", y.style.overflow = "", y.contains(R) && y.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const I = uI(R);
        I && (I.style.opacity = "0");
        const M = Mc(R);
        M && (M.classList.add(d ? n[On.caption_before_exit] : n[On.caption_after_exit]), M.addEventListener("animationend", N));
        const T = Tc(R);
        T && T.classList.add(d ? n[On.weeks_before_exit] : n[On.weeks_after_exit]), y.insertBefore(R, y.firstChild);
      });
    }
  });
}
function fI(t, e, n, o) {
  const r = t[0], i = t[t.length - 1], { ISOWeek: s, fixedWeeks: l, broadcastCalendar: a } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: m, endOfWeek: h, isAfter: b, startOfBroadcastWeek: v, startOfISOWeek: C, startOfWeek: y } = o, w = a ? v(r, o) : s ? C(r) : y(r), R = a ? f(i) : s ? p(m(i)) : h(m(i)), S = e && (a ? f(e) : s ? p(e) : h(e)), E = S && b(R, S) ? S : R, N = u(E, w), I = d(i, r) + 1, M = [];
  for (let P = 0; P <= N; P++) {
    const D = c(w, P);
    M.push(D);
  }
  const k = (a ? 35 : 42) * I;
  if (l && M.length < k) {
    const P = k - M.length;
    for (let D = 0; D < P; D++) {
      const O = c(M[M.length - 1], 1);
      M.push(O);
    }
  }
  return M;
}
function pI(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((i, s) => i.concat(s.days.slice()), e.slice());
    return n.concat(r.slice());
  }, e.slice());
}
function mI(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, i = [];
  for (let s = 0; s < r; s++) {
    const l = o.addMonths(t, s);
    if (e && l > e)
      break;
    i.push(l);
  }
  return i;
}
function Xm(t, e, n, o) {
  const { month: r, defaultMonth: i, today: s = o.today(), numberOfMonths: l = 1 } = t;
  let a = r || i || s;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = o;
  if (n && c(n, a) < l - 1) {
    const f = -1 * (l - 1);
    a = u(n, f);
  }
  return e && c(a, e) < 0 && (a = e), d(a);
}
function gI(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: i, endOfISOWeek: s, endOfMonth: l, endOfWeek: a, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = o, m = t.reduce((h, b) => {
    const v = n.broadcastCalendar ? d(b, o) : n.ISOWeek ? f(b) : p(b), C = n.broadcastCalendar ? i(b) : n.ISOWeek ? s(l(b)) : a(l(b)), y = e.filter((E) => E >= v && E <= C), w = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < w) {
      const E = e.filter((N) => {
        const I = w - y.length;
        return N > C && N <= r(C, I);
      });
      y.push(...E);
    }
    const R = y.reduce((E, N) => {
      const I = n.ISOWeek ? c(N) : u(N), M = E.find((k) => k.weekNumber === I), T = new Fb(N, b, o);
      return M ? M.days.push(T) : E.push(new uk(I, [T])), E;
    }, []), S = new ck(b, R);
    return h.push(S), h;
  }, []);
  return n.reverseMonths ? m.reverse() : m;
}
function hI(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: i, startOfMonth: s, endOfMonth: l, addYears: a, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: p, fromMonth: m, toMonth: h } = t;
  !n && m && (n = m), !n && f && (n = e.newDate(f, 0, 1)), !o && h && (o = h), !o && p && (o = u(p, 11, 31));
  const b = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = s(n) : f ? n = u(f, 0, 1) : !n && b && (n = r(a(t.today ?? d(), -100))), o ? o = l(o) : p ? o = u(p, 11, 31) : !o && b && (o = c(t.today ?? d())), [
    n && i(n),
    o && i(o)
  ];
}
function bI(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i = 1 } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i : 1, u = s(t);
  if (!e)
    return l(u, c);
  if (!(a(e, t) < i))
    return l(u, c);
}
function vI(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i ?? 1 : 1, u = s(t);
  if (!e)
    return l(u, -c);
  if (!(a(u, e) <= 0))
    return l(u, -c);
}
function yI(t) {
  const e = [];
  return t.reduce((n, o) => n.concat(o.weeks.slice()), e.slice());
}
function $a(t, e) {
  const [n, o] = qe(t);
  return [e === void 0 ? n : e, o];
}
function xI(t, e) {
  const [n, o] = hI(t, e), { startOfMonth: r, endOfMonth: i } = e, s = Xm(t, n, o, e), [l, a] = $a(
    s,
    // initialMonth is always computed from props.month if provided
    t.month ? s : void 0
  );
  Nt(() => {
    const w = Xm(t, n, o, e);
    a(w);
  }, [t.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: p } = Sl(() => {
    const w = mI(l, o, { numberOfMonths: t.numberOfMonths }, e), R = fI(w, t.endMonth ? i(t.endMonth) : void 0, {
      ISOWeek: t.ISOWeek,
      fixedWeeks: t.fixedWeeks,
      broadcastCalendar: t.broadcastCalendar
    }, e), S = gI(w, R, {
      broadcastCalendar: t.broadcastCalendar,
      fixedWeeks: t.fixedWeeks,
      ISOWeek: t.ISOWeek,
      reverseMonths: t.reverseMonths
    }, e), E = yI(S), N = pI(S), I = vI(l, n, t, e), M = bI(l, o, t, e);
    return {
      months: S,
      weeks: E,
      days: N,
      previousMonth: I,
      nextMonth: M
    };
  }, [
    e,
    l.getTime(),
    o?.getTime(),
    n?.getTime(),
    t.disableNavigation,
    t.broadcastCalendar,
    t.endMonth?.getTime(),
    t.fixedWeeks,
    t.ISOWeek,
    t.numberOfMonths,
    t.pagedNavigation,
    t.reverseMonths
  ]), { disableNavigation: m, onMonthChange: h } = t, b = (w) => u.some((R) => R.days.some((S) => S.isEqualTo(w))), v = (w) => {
    if (m)
      return;
    let R = r(w);
    n && R < r(n) && (R = r(n)), o && R > r(o) && (R = r(o)), a(R), h?.(R);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: o,
    previousMonth: f,
    nextMonth: p,
    goToMonth: v,
    goToDay: (w) => {
      b(w) || v(w.date);
    }
  };
}
var ao;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(ao || (ao = {}));
function Qm(t) {
  return !t[zt.disabled] && !t[zt.hidden] && !t[zt.outside];
}
function CI(t, e, n, o) {
  let r, i = -1;
  for (const s of t) {
    const l = e(s);
    Qm(l) && (l[zt.focused] && i < ao.FocusedModifier ? (r = s, i = ao.FocusedModifier) : o?.isEqualTo(s) && i < ao.LastFocused ? (r = s, i = ao.LastFocused) : n(s.date) && i < ao.Selected ? (r = s, i = ao.Selected) : l[zt.today] && i < ao.Today && (r = s, i = ao.Today));
  }
  return r || (r = t.find((s) => Qm(e(s)))), r;
}
function wI(t, e, n, o, r, i, s) {
  const { ISOWeek: l, broadcastCalendar: a } = i, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: m, endOfWeek: h, max: b, min: v, startOfBroadcastWeek: C, startOfISOWeek: y, startOfWeek: w } = s;
  let S = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (E) => a ? C(E, s) : l ? y(E) : w(E),
    endOfWeek: (E) => a ? p(E) : l ? m(E) : h(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? S = b([o, S]) : e === "after" && r && (S = v([r, S])), S;
}
function Jb(t, e, n, o, r, i, s, l = 0) {
  if (l > 365)
    return;
  const a = wI(t, e, n.date, o, r, i, s), c = !!(i.disabled && Mo(a, i.disabled, s)), u = !!(i.hidden && Mo(a, i.hidden, s)), d = a, f = new Fb(a, d, s);
  return !c && !u ? f : Jb(t, e, f, o, r, i, s, l + 1);
}
function SI(t, e, n, o, r) {
  const { autoFocus: i } = t, [s, l] = qe(), a = CI(e.days, n, o || (() => !1), s), [c, u] = qe(i ? a : void 0);
  return {
    isFocusTarget: (h) => !!a?.isEqualTo(h),
    setFocused: u,
    focused: c,
    blur: () => {
      l(c), u(void 0);
    },
    moveFocus: (h, b) => {
      if (!c)
        return;
      const v = Jb(h, b, c, e.navStart, e.navEnd, t, r);
      v && (t.disableNavigation && !e.days.some((y) => y.isEqualTo(v)) || (e.goToDay(v), u(v)));
    }
  };
}
function RI(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = $a(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e, c = (p) => l?.some((m) => a(m, p)) ?? !1, { min: u, max: d } = t;
  return {
    selected: l,
    select: (p, m, h) => {
      let b = [...l ?? []];
      if (c(p)) {
        if (l?.length === u || o && l?.length === 1)
          return;
        b = l?.filter((v) => !a(v, p));
      } else
        l?.length === d ? b = [p] : b = [...b, p];
      return r || s(b), r?.(b, p, m, h), b;
    },
    isSelected: c
  };
}
function EI(t, e, n = 0, o = 0, r = !1, i = So) {
  const { from: s, to: l } = e || {}, { isSameDay: a, isAfter: c, isBefore: u } = i;
  let d;
  if (!s && !l)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (s && !l)
    a(s, t) ? n === 0 ? d = { from: s, to: t } : r ? d = { from: s, to: void 0 } : d = void 0 : u(t, s) ? d = { from: t, to: s } : d = { from: s, to: t };
  else if (s && l)
    if (a(s, t) && a(l, t))
      r ? d = { from: s, to: l } : d = void 0;
    else if (a(s, t))
      d = { from: s, to: n > 0 ? void 0 : t };
    else if (a(l, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, s))
      d = { from: t, to: l };
    else if (c(t, s))
      d = { from: s, to: t };
    else if (c(t, l))
      d = { from: s, to: t };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = i.differenceInCalendarDays(d.to, d.from);
    o > 0 && f > o ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function NI(t, e, n = So) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const i = n.differenceInCalendarDays(t.to, t.from), s = Math.min(i, 6);
  for (let l = 0; l <= s; l++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Jm(t, e, n = So) {
  return Po(t, e.from, !1, n) || Po(t, e.to, !1, n) || Po(e, t.from, !1, n) || Po(e, t.to, !1, n);
}
function kI(t, e, n = So) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((l) => typeof l != "function").some((l) => typeof l == "boolean" ? l : n.isDate(l) ? Po(t, l, !1, n) : zb(l, n) ? l.some((a) => Po(t, a, !1, n)) : Fa(l) ? l.from && l.to ? Jm(t, { from: l.from, to: l.to }, n) : !1 : Hb(l) ? NI(t, l.dayOfWeek, n) : u1(l) ? n.isAfter(l.before, l.after) ? Jm(t, {
    from: n.addDays(l.after, 1),
    to: n.addDays(l.before, -1)
  }, n) : Mo(t.from, l, n) || Mo(t.to, l, n) : d1(l) || f1(l) ? Mo(t.from, l, n) || Mo(t.to, l, n) : !1))
    return !0;
  const s = o.filter((l) => typeof l == "function");
  if (s.length) {
    let l = t.from;
    const a = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= a; c++) {
      if (s.some((u) => u(l)))
        return !0;
      l = n.addDays(l, 1);
    }
  }
  return !1;
}
function II(t, e) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: i, required: s, onSelect: l } = t, [a, c] = $a(i, l ? i : void 0), u = l ? i : a;
  return {
    selected: u,
    select: (p, m, h) => {
      const { min: b, max: v } = t;
      let C;
      if (p) {
        const y = u?.from, w = u?.to, R = !!y && !!w, S = !!y && !!w && e.isSameDay(y, w) && e.isSameDay(p, y);
        r && (R || !u?.from) ? !s && S ? C = void 0 : C = { from: p, to: void 0 } : C = EI(p, u, b, v, s, e);
      }
      return o && n && C?.from && C.to && kI({ from: C.from, to: C.to }, n, e) && (C.from = p, C.to = void 0), l || c(C), l?.(C, p, m, h), C;
    },
    isSelected: (p) => u && Po(u, p, !1, e)
  };
}
function PI(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = $a(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e;
  return {
    selected: l,
    select: (d, f, p) => {
      let m = d;
      return !o && l && l && a(d, l) && (m = void 0), r || s(m), r?.(m, d, f, p), m;
    },
    isSelected: (d) => l ? a(l, d) : !1
  };
}
function MI(t, e) {
  const n = PI(t, e), o = RI(t, e), r = II(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function Fn(t, e) {
  return t instanceof vn && t.timeZone === e ? t : new vn(t, e);
}
function $r(t, e, n) {
  return Fn(t, e);
}
function eg(t, e, n) {
  return typeof t == "boolean" || typeof t == "function" ? t : t instanceof Date ? $r(t, e) : Array.isArray(t) ? t.map((o) => o instanceof Date ? $r(o, e) : o) : Fa(t) ? {
    ...t,
    from: t.from ? Fn(t.from, e) : t.from,
    to: t.to ? Fn(t.to, e) : t.to
  } : u1(t) ? {
    before: $r(t.before, e),
    after: $r(t.after, e)
  } : d1(t) ? {
    after: $r(t.after, e)
  } : f1(t) ? {
    before: $r(t.before, e)
  } : t;
}
function Oc(t, e, n) {
  return t && (Array.isArray(t) ? t.map((o) => eg(o, e)) : eg(t, e));
}
function TI(t) {
  let e = t;
  const n = e.timeZone;
  if (n && (e = {
    ...t,
    timeZone: n
  }, e.today && (e.today = Fn(e.today, n)), e.month && (e.month = Fn(e.month, n)), e.defaultMonth && (e.defaultMonth = Fn(e.defaultMonth, n)), e.startMonth && (e.startMonth = Fn(e.startMonth, n)), e.endMonth && (e.endMonth = Fn(e.endMonth, n)), e.mode === "single" && e.selected ? e.selected = Fn(e.selected, n) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((Ne) => Fn(Ne, n)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? Fn(e.selected.from, n) : e.selected.from,
    to: e.selected.to ? Fn(e.selected.to, n) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Oc(e.disabled, n)), e.hidden !== void 0 && (e.hidden = Oc(e.hidden, n)), e.modifiers)) {
    const Ne = {};
    Object.keys(e.modifiers).forEach((_e) => {
      Ne[_e] = Oc(e.modifiers?.[_e], n);
    }), e.modifiers = Ne;
  }
  const { components: o, formatters: r, labels: i, dateLib: s, locale: l, classNames: a } = Sl(() => {
    const Ne = { ...Lb, ...e.locale }, _e = e.broadcastCalendar ? 1 : e.weekStartsOn, Pe = e.noonSafe && e.timeZone ? lI(e.timeZone, {
      weekStartsOn: _e,
      locale: Ne
    }) : void 0, $e = e.dateLib && Pe ? { ...Pe, ...e.dateLib } : e.dateLib ?? Pe, He = new _n({
      locale: Ne,
      weekStartsOn: _e,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, $e);
    return {
      dateLib: He,
      components: Hk(e.components),
      formatters: Xk(e.formatters),
      labels: nI(e.labels, He.options),
      locale: Ne,
      classNames: { ...Bk(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: s.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: p, onDayClick: m, onDayFocus: h, onDayKeyDown: b, onDayMouseEnter: v, onDayMouseLeave: C, onNextClick: y, onPrevClick: w, showWeekNumber: R, styles: S } = e, { formatCaption: E, formatDay: N, formatMonthDropdown: I, formatWeekNumber: M, formatWeekNumberHeader: T, formatWeekdayName: k, formatYearDropdown: P } = r, D = xI(e, s), { days: O, months: V, navStart: _, navEnd: A, previousMonth: L, nextMonth: $, goToMonth: B } = D, z = Fk(O, e, _, A, s), { isSelected: H, select: K, selected: G } = MI(e, s) ?? {}, { blur: q, focused: Q, isFocusTarget: U, moveFocus: X, setFocused: te } = SI(e, D, z, H ?? (() => !1), s), { labelDayButton: re, labelGridcell: J, labelGrid: ie, labelMonthDropdown: ce, labelNav: oe, labelPrevious: se, labelNext: me, labelWeekday: pe, labelWeekNumber: le, labelWeekNumberHeader: ge, labelYearDropdown: j } = i, ee = Sl(() => iI(s, e.ISOWeek, e.broadcastCalendar, e.today), [s, e.ISOWeek, e.broadcastCalendar, e.today]), Y = u !== void 0 || m !== void 0, Z = Ln(() => {
    L && (B(L), w?.(L));
  }, [L, B, w]), ue = Ln(() => {
    $ && (B($), y?.($));
  }, [B, $, y]), fe = Ln((Ne, _e) => (Pe) => {
    Pe.preventDefault(), Pe.stopPropagation(), te(Ne), !_e.disabled && (K?.(Ne.date, _e, Pe), m?.(Ne.date, _e, Pe));
  }, [K, m, te]), be = Ln((Ne, _e) => (Pe) => {
    te(Ne), h?.(Ne.date, _e, Pe);
  }, [h, te]), Ie = Ln((Ne, _e) => (Pe) => {
    q(), p?.(Ne.date, _e, Pe);
  }, [q, p]), ye = Ln((Ne, _e) => (Pe) => {
    const $e = {
      ArrowLeft: [
        Pe.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Pe.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Pe.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Pe.shiftKey ? "year" : "week", "before"],
      PageUp: [Pe.shiftKey ? "year" : "month", "before"],
      PageDown: [Pe.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if ($e[Pe.key]) {
      Pe.preventDefault(), Pe.stopPropagation();
      const [He, Te] = $e[Pe.key];
      X(He, Te);
    }
    b?.(Ne.date, _e, Pe);
  }, [X, b, e.dir]), xe = Ln((Ne, _e) => (Pe) => {
    v?.(Ne.date, _e, Pe);
  }, [v]), de = Ln((Ne, _e) => (Pe) => {
    C?.(Ne.date, _e, Pe);
  }, [C]), Se = Ln((Ne) => (_e) => {
    const Pe = Number(_e.target.value), $e = s.setMonth(s.startOfMonth(Ne), Pe);
    B($e);
  }, [s, B]), Me = Ln((Ne) => (_e) => {
    const Pe = Number(_e.target.value), $e = s.setYear(s.startOfMonth(Ne), Pe);
    B($e);
  }, [s, B]), { className: Re, style: Ve } = Sl(() => ({
    className: [a[tt.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[tt.Root], ...e.style }
  }), [a, e.className, e.style, S]), Ze = zk(e), Xe = at(null);
  dI(Xe, !!e.animate, {
    classNames: a,
    months: V,
    focused: Q,
    dateLib: s
  });
  const Be = {
    dayPickerProps: e,
    selected: G,
    select: K,
    isSelected: H,
    months: V,
    nextMonth: $,
    previousMonth: L,
    goToMonth: B,
    getModifiers: z,
    components: o,
    classNames: a,
    styles: S,
    labels: i,
    formatters: r
  };
  return We.createElement(
    $b.Provider,
    { value: Be },
    We.createElement(
      o.Root,
      { rootRef: e.animate ? Xe : void 0, className: Re, style: Ve, dir: e.dir, id: e.id, lang: e.lang ?? l.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...Ze },
      We.createElement(
        o.Months,
        { className: a[tt.Months], style: S?.[tt.Months] },
        !e.hideNavigation && !d && We.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[tt.Nav], style: S?.[tt.Nav], "aria-label": oe(), onPreviousClick: Z, onNextClick: ue, previousMonth: L, nextMonth: $ }),
        V.map((Ne, _e) => We.createElement(
          o.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: a[tt.Month],
            style: S?.[tt.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: _e,
            displayIndex: _e,
            calendarMonth: Ne
          },
          d === "around" && !e.hideNavigation && _e === 0 && We.createElement(
            o.PreviousMonthButton,
            { type: "button", className: a[tt.PreviousMonthButton], tabIndex: L ? void 0 : -1, "aria-disabled": L ? void 0 : !0, "aria-label": se(L), onClick: Z, "data-animated-button": e.animate ? "true" : void 0 },
            We.createElement(o.Chevron, { disabled: L ? void 0 : !0, className: a[tt.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          We.createElement(o.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: a[tt.MonthCaption], style: S?.[tt.MonthCaption], calendarMonth: Ne, displayIndex: _e }, c?.startsWith("dropdown") ? We.createElement(
            o.DropdownNav,
            { className: a[tt.Dropdowns], style: S?.[tt.Dropdowns] },
            (() => {
              const Pe = c === "dropdown" || c === "dropdown-months" ? We.createElement(o.MonthsDropdown, { key: "month", className: a[tt.MonthsDropdown], "aria-label": ce(), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Se(Ne.date), options: oI(Ne.date, _, A, r, s), style: S?.[tt.Dropdown], value: s.getMonth(Ne.date) }) : We.createElement("span", { key: "month" }, I(Ne.date, s)), $e = c === "dropdown" || c === "dropdown-years" ? We.createElement(o.YearsDropdown, { key: "year", className: a[tt.YearsDropdown], "aria-label": j(s.options), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Me(Ne.date), options: sI(_, A, r, s, !!e.reverseYears), style: S?.[tt.Dropdown], value: s.getYear(Ne.date) }) : We.createElement("span", { key: "year" }, P(Ne.date, s));
              return s.getMonthYearOrder() === "year-first" ? [$e, Pe] : [Pe, $e];
            })(),
            We.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, E(Ne.date, s.options, s))
          ) : We.createElement(o.CaptionLabel, { className: a[tt.CaptionLabel], role: "status", "aria-live": "polite" }, E(Ne.date, s.options, s))),
          d === "around" && !e.hideNavigation && _e === f - 1 && We.createElement(
            o.NextMonthButton,
            { type: "button", className: a[tt.NextMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": me($), onClick: ue, "data-animated-button": e.animate ? "true" : void 0 },
            We.createElement(o.Chevron, { disabled: $ ? void 0 : !0, className: a[tt.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          _e === f - 1 && d === "after" && !e.hideNavigation && We.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[tt.Nav], style: S?.[tt.Nav], "aria-label": oe(), onPreviousClick: Z, onNextClick: ue, previousMonth: L, nextMonth: $ }),
          We.createElement(
            o.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": ie(Ne.date, s.options, s) || void 0, className: a[tt.MonthGrid], style: S?.[tt.MonthGrid] },
            !e.hideWeekdays && We.createElement(
              o.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: a[tt.Weekdays], style: S?.[tt.Weekdays] },
              R && We.createElement(o.WeekNumberHeader, { "aria-label": ge(s.options), className: a[tt.WeekNumberHeader], style: S?.[tt.WeekNumberHeader], scope: "col" }, T()),
              ee.map((Pe) => We.createElement(o.Weekday, { "aria-label": pe(Pe, s.options, s), className: a[tt.Weekday], key: String(Pe), style: S?.[tt.Weekday], scope: "col" }, k(Pe, s.options, s)))
            ),
            We.createElement(o.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: a[tt.Weeks], style: S?.[tt.Weeks] }, Ne.weeks.map((Pe) => We.createElement(
              o.Week,
              { className: a[tt.Week], key: Pe.weekNumber, style: S?.[tt.Week], week: Pe },
              R && We.createElement(o.WeekNumber, { week: Pe, style: S?.[tt.WeekNumber], "aria-label": le(Pe.weekNumber, {
                locale: l
              }), className: a[tt.WeekNumber], scope: "row", role: "rowheader" }, M(Pe.weekNumber, s)),
              Pe.days.map(($e) => {
                const { date: He } = $e, Te = z($e);
                if (Te[zt.focused] = !Te.hidden && !!Q?.isEqualTo($e), Te[Zn.selected] = H?.(He) || Te.selected, Fa(G)) {
                  const { from: Ee, to: Ae } = G;
                  Te[Zn.range_start] = !!(Ee && Ae && s.isSameDay(He, Ee)), Te[Zn.range_end] = !!(Ee && Ae && s.isSameDay(He, Ae)), Te[Zn.range_middle] = Po(G, He, !0, s);
                }
                const Rt = rI(Te, S, e.modifiersStyles), rt = $k(Te, a, e.modifiersClassNames), Ce = !Y && !Te.hidden ? J(He, Te, s.options, s) : void 0;
                return We.createElement(o.Day, { key: `${$e.isoDate}_${$e.displayMonthId}`, day: $e, modifiers: Te, className: rt.join(" "), style: Rt, role: "gridcell", "aria-selected": Te.selected || void 0, "aria-label": Ce, "data-day": $e.isoDate, "data-month": $e.outside ? $e.dateMonthId : void 0, "data-selected": Te.selected || void 0, "data-disabled": Te.disabled || void 0, "data-hidden": Te.hidden || void 0, "data-outside": $e.outside || void 0, "data-focused": Te.focused || void 0, "data-today": Te.today || void 0 }, !Te.hidden && Y ? We.createElement(o.DayButton, { className: a[tt.DayButton], style: S?.[tt.DayButton], type: "button", day: $e, modifiers: Te, disabled: !Te.focused && Te.disabled || void 0, "aria-disabled": Te.focused && Te.disabled || void 0, tabIndex: U($e) ? 0 : -1, "aria-label": re(He, Te, s.options, s), onClick: fe($e, Te), onBlur: Ie($e, Te), onFocus: be($e, Te), onKeyDown: ye($e, Te), onMouseEnter: xe($e, Te), onMouseLeave: de($e, Te) }, N(He, s.options, s)) : !Te.hidden && N($e.date, s.options, s));
              })
            )))
          )
        ))
      ),
      e.footer && We.createElement(o.Footer, { className: a[tt.Footer], style: S?.[tt.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function OI(t) {
  const e = W.c(18), {
    children: n,
    positionerClassName: o,
    popupClassName: r,
    listClassName: i
  } = t, s = en();
  let l;
  e[0] !== o ? (l = ne("z-[var(--z-layer-popover)]", o), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = pi({
    size: "auto",
    className: r
  }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== i ? (c = ne("flex flex-col", i), e[4] = i, e[5] = c) : c = e[5];
  let u;
  e[6] !== n || e[7] !== c ? (u = /* @__PURE__ */ g(_f, { className: c, children: n }), e[6] = n, e[7] = c, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== u ? (d = /* @__PURE__ */ g(Df, { className: a, children: u }), e[9] = a, e[10] = u, e[11] = d) : d = e[11];
  let f;
  e[12] !== l || e[13] !== d ? (f = /* @__PURE__ */ g(Of, { sideOffset: 4, alignItemWithTrigger: !1, className: l, children: d }), e[12] = l, e[13] = d, e[14] = f) : f = e[14];
  let p;
  return e[15] !== s || e[16] !== f ? (p = /* @__PURE__ */ g(Mf, { container: s, children: f }), e[15] = s, e[16] = f, e[17] = p) : p = e[17], p;
}
function DI(t) {
  const e = W.c(11), {
    value: n,
    disabled: o,
    icon: r,
    children: i
  } = t;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = bo({}), e[0] = s) : s = e[0];
  let l;
  e[1] !== r ? (l = r && /* @__PURE__ */ g("span", { className: "shrink-0 text-menu-icon-default inline-flex", children: /* @__PURE__ */ g(Ue, { name: r, size: "xs", tone: "inherit" }) }), e[1] = r, e[2] = l) : l = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ g(Ff, { className: "flex-1 min-w-0", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let c;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(B0, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ue, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== a || e[9] !== n ? (u = /* @__PURE__ */ F(Lf, { value: n, disabled: o, className: s, children: [
    l,
    a,
    c
  ] }), e[6] = o, e[7] = l, e[8] = a, e[9] = n, e[10] = u) : u = e[10], u;
}
function _I(t) {
  const e = W.c(2), {
    size: n
  } = t, o = n === void 0 ? "xs" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "transition-transform duration-200 [[data-popup-open]_&]:rotate-180 inline-flex", children: /* @__PURE__ */ g(Ue, { name: "chevron-down", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
function VI(t) {
  const e = W.c(26), {
    value: n,
    onChange: o,
    options: r,
    disabled: i,
    "aria-label": s
  } = t;
  let l;
  e[0] !== r || e[1] !== n ? (l = r?.find((R) => R.value === Number(n)), e[0] = r, e[1] = n, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== o ? (c = function(S) {
    S !== null && o?.({
      target: {
        value: String(S)
      },
      currentTarget: {
        value: String(S)
      }
    });
  }, e[3] = o, e[4] = c) : c = e[4];
  const u = c, d = a?.value ?? null;
  let f;
  e[5] !== r ? (f = r ?? [], e[5] = r, e[6] = f) : f = e[6];
  let p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne("flex items-center gap-(--spacing-2)", "cursor-pointer rounded-(--radius-xs) outline-none", "focus-visible:ring-2 focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"), e[7] = p) : p = e[7];
  const m = a?.label ?? "";
  let h;
  e[8] !== m ? (h = /* @__PURE__ */ g(A0, { className: "text-(length:--font-size-title-md) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default select-none", children: m }), e[8] = m, e[9] = h) : h = e[9];
  let b;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(L0, { className: "text-icon-main", children: /* @__PURE__ */ g(_I, { size: "sm" }) }), e[10] = b) : b = e[10];
  let v;
  e[11] !== s || e[12] !== i || e[13] !== h ? (v = /* @__PURE__ */ F(Pf, { disabled: i, "aria-label": s, className: p, children: [
    h,
    b
  ] }), e[11] = s, e[12] = i, e[13] = h, e[14] = v) : v = e[14];
  let C;
  e[15] !== r ? (C = r?.map(AI), e[15] = r, e[16] = C) : C = e[16];
  let y;
  e[17] !== C ? (y = /* @__PURE__ */ g(OI, { listClassName: "max-h-[368px] overflow-y-auto", children: C }), e[17] = C, e[18] = y) : y = e[18];
  let w;
  return e[19] !== i || e[20] !== u || e[21] !== y || e[22] !== d || e[23] !== f || e[24] !== v ? (w = /* @__PURE__ */ F(V0, { value: d, onValueChange: u, disabled: i, items: f, children: [
    v,
    y
  ] }), e[19] = i, e[20] = u, e[21] = y, e[22] = d, e[23] = f, e[24] = v, e[25] = w) : w = e[25], w;
}
function AI(t) {
  return /* @__PURE__ */ g(DI, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function LI(t) {
  const e = W.c(18), {
    children: n
  } = t, {
    goToMonth: o,
    nextMonth: r,
    previousMonth: i,
    dayPickerProps: s
  } = Ri(), l = s.disabled === !0, a = l || !i;
  let c;
  e[0] !== o || e[1] !== i ? (c = () => i && o(i), e[0] = o, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== a || e[4] !== c ? (u = /* @__PURE__ */ g(bt, { icon: "chevron-left", variant: "ghost", size: "md", "aria-label": "Previous month", disabled: a, onClick: c }), e[3] = a, e[4] = c, e[5] = u) : u = e[5];
  let d;
  e[6] !== n ? (d = /* @__PURE__ */ g("div", { className: "flex items-center gap-[26px]", children: n }), e[6] = n, e[7] = d) : d = e[7];
  const f = l || !r;
  let p;
  e[8] !== o || e[9] !== r ? (p = () => r && o(r), e[8] = o, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ g(bt, { icon: "chevron-right", variant: "ghost", size: "md", "aria-label": "Next month", disabled: f, onClick: p }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  let h;
  return e[14] !== u || e[15] !== d || e[16] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex items-center justify-between pt-(--spacing-8) px-(--spacing-12)", children: [
    u,
    d,
    m
  ] }), e[14] = u, e[15] = d, e[16] = m, e[17] = h) : h = e[17], h;
}
function FI(t) {
  const e = W.c(12), {
    value: n,
    onValueChange: o,
    disabled: r
  } = t, i = r === void 0 ? !1 : r, s = n ?? void 0, l = n ?? void 0;
  let a;
  e[0] !== o ? (a = (h) => o(h ?? null), e[0] = o, e[1] = a) : a = e[1];
  let c, u;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = new Date(2e3, 0), u = new Date(2099, 11), e[2] = c, e[3] = u) : (c = e[2], u = e[3]);
  let d, f, p;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    formatMonthDropdown: $I
  }, f = {
    root: "w-[328px] bg-surface rounded-(--radius-sm) shadow-elevation-3 flex flex-col gap-(--spacing-4)",
    months: "flex flex-col",
    month: "flex flex-col gap-(--spacing-4)",
    month_caption: "",
    nav: "hidden",
    dropdowns: "flex items-center gap-[26px]",
    dropdown_root: "",
    dropdown: "",
    caption_label: "",
    month_grid: "w-full border-collapse",
    weeks: "flex flex-col gap-(--spacing-8) px-(--spacing-2) pb-(--spacing-16)",
    week: "flex gap-[11px] items-center justify-center",
    weekdays: "flex gap-[11px] items-center justify-center px-(--spacing-2) pt-(--spacing-8) pb-(--spacing-12) border-t border-outline-subtle",
    weekday: "size-(--font-line-height-36) flex items-center justify-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) text-text-subtle",
    day: "size-(--font-line-height-36) flex items-center justify-center rounded-full text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default cursor-pointer transition-colors duration-200 ease-in-out [&:not([data-selected])]:hover:bg-surface-hover [&:not([data-selected])]:active:bg-surface-pressed",
    day_button: "size-full flex items-center justify-center outline-none rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring",
    selected: "bg-primary [&>button]:text-primary-on-primary",
    today: "font-(number:--font-weight-semibold)",
    outside: "text-text-subtle",
    disabled: "text-text-disabled pointer-events-none opacity-50",
    hidden: "invisible"
  }, p = {
    MonthCaption: LI,
    Dropdown: VI
  }, e[4] = d, e[5] = f, e[6] = p) : (d = e[4], f = e[5], p = e[6]);
  let m;
  return e[7] !== i || e[8] !== s || e[9] !== l || e[10] !== a ? (m = /* @__PURE__ */ g(TI, { mode: "single", selected: s, defaultMonth: l, onSelect: a, disabled: i, captionLayout: "dropdown", startMonth: c, endMonth: u, showOutsideDays: !0, formatters: d, classNames: f, components: p }), e[7] = i, e[8] = s, e[9] = l, e[10] = a, e[11] = m) : m = e[11], m;
}
function $I(t) {
  return t.toLocaleString("en-US", {
    month: "short"
  });
}
const HI = /^(\d{2})\/(\d{2})\/(\d{4})$/;
function tg(t) {
  const e = t.match(HI);
  if (!e) return null;
  const [, n, o, r] = e, i = new Date(Number(r), Number(n) - 1, Number(o));
  return i.getFullYear() !== Number(r) || i.getMonth() !== Number(n) - 1 || i.getDate() !== Number(o) ? null : i;
}
function Dc(t) {
  const e = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0"), o = t.getFullYear();
  return `${e}/${n}/${o}`;
}
const zI = ae(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-[176px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function KD(t) {
  const e = W.c(73), {
    value: n,
    onValueChange: o,
    label: r,
    size: i,
    required: s,
    description: l,
    tooltip: a,
    error: c,
    disabled: u
  } = t, d = i === void 0 ? "md" : i, f = u === void 0 ? !1 : u, p = en(), [m, h] = qe(!1);
  let b;
  e[0] !== n ? (b = n ? Dc(n) : "", e[0] = n, e[1] = b) : b = e[1];
  const [v, C] = qe(b), y = at(null), w = at(null), R = $t(), S = $t(), E = !!c;
  let N, I;
  e[2] !== n ? (N = () => {
    C((pe) => {
      const le = tg(pe);
      return (n === null ? pe === "" : le !== null && le.getFullYear() === n.getFullYear() && le.getMonth() === n.getMonth() && le.getDate() === n.getDate()) ? pe : n ? Dc(n) : "";
    });
  }, I = [n], e[2] = n, e[3] = N, e[4] = I) : (N = e[3], I = e[4]), Nt(N, I);
  let M;
  e[5] !== o ? (M = function(le) {
    const ge = le.target.value;
    C(ge);
    const j = tg(ge);
    j ? o(j) : ge === "" && o(null);
  }, e[5] = o, e[6] = M) : M = e[6];
  const T = M;
  let k;
  e[7] !== o ? (k = function(le) {
    o(le), C(le ? Dc(le) : ""), h(!1);
  }, e[7] = o, e[8] = k) : k = e[8];
  const P = k;
  let D;
  e[9] !== o ? (D = function() {
    o(null), C(""), h(!1), w.current?.focus();
  }, e[9] = o, e[10] = D) : D = e[10];
  const O = D, V = v, _ = f && "pointer-events-none";
  let A;
  e[11] !== _ ? (A = ne("flex flex-col w-fit", _), e[11] = _, e[12] = A) : A = e[12];
  let L;
  e[13] !== R || e[14] !== r || e[15] !== s || e[16] !== a ? (L = r && /* @__PURE__ */ g(yi, { htmlFor: R, label: r, required: s, tooltip: a }), e[13] = R, e[14] = r, e[15] = s, e[16] = a, e[17] = L) : L = e[17];
  let $;
  e[18] !== f || e[19] !== E || e[20] !== d ? ($ = ne(zI({
    size: d,
    hasError: E
  }), f && "opacity-50"), e[18] = f, e[19] = E, e[20] = d, e[21] = $) : $ = e[21];
  const B = s || void 0, z = E || void 0, H = l || c ? S : void 0, K = E && "text-input-error-text";
  let G;
  e[22] !== K ? (G = ne("flex-1 min-w-0 outline-none bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-text-subtle", K), e[22] = K, e[23] = G) : G = e[23];
  let q;
  e[24] !== f || e[25] !== V || e[26] !== T || e[27] !== R || e[28] !== s || e[29] !== B || e[30] !== z || e[31] !== H || e[32] !== G ? (q = /* @__PURE__ */ g("input", { id: R, ref: w, type: "text", value: V, onChange: T, placeholder: "MM/DD/YYYY", disabled: f, required: s, "aria-required": B, "aria-invalid": z, "aria-describedby": H, className: G }), e[24] = f, e[25] = V, e[26] = T, e[27] = R, e[28] = s, e[29] = B, e[30] = z, e[31] = H, e[32] = G, e[33] = q) : q = e[33];
  let Q;
  e[34] !== f || e[35] !== O || e[36] !== n ? (Q = n !== null && !f && /* @__PURE__ */ g("button", { type: "button", "aria-label": "Clear date", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", onMouseDown: BI, onClick: O, children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = f, e[35] = O, e[36] = n, e[37] = Q) : Q = e[37];
  let U;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = /* @__PURE__ */ g(Ue, { name: "calendar", size: "xs", tone: "inherit" }), e[38] = U) : U = e[38];
  let X;
  e[39] !== f ? (X = /* @__PURE__ */ g(Ea, { render: /* @__PURE__ */ g("button", { type: "button", "aria-label": "Open calendar", disabled: f, className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-main hover:text-icon-main disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: U }) }), e[39] = f, e[40] = X) : X = e[40];
  let te;
  e[41] !== Q || e[42] !== X ? (te = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    Q,
    X
  ] }), e[41] = Q, e[42] = X, e[43] = te) : te = e[43];
  let re;
  e[44] !== $ || e[45] !== q || e[46] !== te ? (re = /* @__PURE__ */ F("div", { ref: y, className: $, children: [
    q,
    te
  ] }), e[44] = $, e[45] = q, e[46] = te, e[47] = re) : re = e[47];
  let J;
  e[48] !== f || e[49] !== P || e[50] !== n ? (J = /* @__PURE__ */ g(ka, { anchor: y, side: "bottom", align: "start", sideOffset: 4, children: /* @__PURE__ */ g(Ia, { children: /* @__PURE__ */ g(FI, { value: n, onValueChange: P, disabled: f }) }) }), e[48] = f, e[49] = P, e[50] = n, e[51] = J) : J = e[51];
  let ie;
  e[52] !== p || e[53] !== J ? (ie = /* @__PURE__ */ g(Na, { container: p, children: J }), e[52] = p, e[53] = J, e[54] = ie) : ie = e[54];
  let ce;
  e[55] !== m || e[56] !== re || e[57] !== ie ? (ce = /* @__PURE__ */ F(nf, { open: m, onOpenChange: h, modal: !1, children: [
    re,
    ie
  ] }), e[55] = m, e[56] = re, e[57] = ie, e[58] = ce) : ce = e[58];
  let oe;
  e[59] !== l || e[60] !== S || e[61] !== c || e[62] !== E ? (oe = E ? /* @__PURE__ */ g(Ar, { match: !0, id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: c }) : l ? /* @__PURE__ */ g(bi, { id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: l }) : null, e[59] = l, e[60] = S, e[61] = c, e[62] = E, e[63] = oe) : oe = e[63];
  let se;
  e[64] !== oe ? (se = /* @__PURE__ */ g("div", { "data-testid": "date-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: oe }), e[64] = oe, e[65] = se) : se = e[65];
  let me;
  return e[66] !== f || e[67] !== E || e[68] !== A || e[69] !== L || e[70] !== ce || e[71] !== se ? (me = /* @__PURE__ */ F(Vr, { invalid: E, disabled: f, className: A, children: [
    L,
    ce,
    se
  ] }), e[66] = f, e[67] = E, e[68] = A, e[69] = L, e[70] = ce, e[71] = se, e[72] = me) : me = e[72], me;
}
function BI(t) {
  return t.preventDefault();
}
const gl = 8, ng = 20, WI = 16, UI = 20;
function e3(t) {
  return {
    offsetX: t ? t.offsetLeft : WI,
    offsetY: t ? t.offsetTop : UI,
    width: t?.offsetWidth || ng,
    height: t?.offsetHeight || ng
  };
}
function GI(t, e) {
  const n = -e.offsetX, o = -e.offsetY, r = window.innerWidth - e.offsetX - e.width, i = window.innerHeight - e.offsetY - e.height;
  return {
    x: Math.max(n, Math.min(t.x, r)),
    y: Math.max(o, Math.min(t.y, i))
  };
}
function YI(t) {
  const e = W.c(24), {
    dragHandleRef: n,
    position: o,
    onPositionChange: r,
    disabled: i
  } = t, s = i === void 0 ? !1 : i, l = x.useRef(!1), [a, c] = x.useState(!1);
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    pointerX: 0,
    pointerY: 0,
    elementX: 0,
    elementY: 0
  }, e[0] = u) : u = e[0];
  const d = x.useRef(u);
  let f;
  e[1] !== n ? (f = (T) => GI(T, e3(n.current)), e[1] = n, e[2] = f) : f = e[2];
  const p = f;
  let m;
  e[3] !== s || e[4] !== o ? (m = (T) => {
    s || T.pointerType === "mouse" && T.button !== 0 || (T.currentTarget.setPointerCapture?.(T.pointerId), l.current = !0, c(!0), d.current = {
      pointerX: T.clientX,
      pointerY: T.clientY,
      elementX: o.x,
      elementY: o.y
    });
  }, e[3] = s, e[4] = o, e[5] = m) : m = e[5];
  const h = m;
  let b;
  e[6] !== p || e[7] !== r ? (b = (T) => {
    if (!l.current)
      return;
    const k = T.clientX - d.current.pointerX, P = T.clientY - d.current.pointerY;
    r(p({
      x: d.current.elementX + k,
      y: d.current.elementY + P
    }));
  }, e[6] = p, e[7] = r, e[8] = b) : b = e[8];
  const v = b;
  let C;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = () => l.current ? (l.current = !1, c(!1), !0) : !1, e[9] = C) : C = e[9];
  const y = C;
  let w;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = (T) => {
    y() && T.currentTarget.releasePointerCapture?.(T.pointerId);
  }, e[10] = w) : w = e[10];
  const R = w;
  let S;
  e[11] !== p || e[12] !== s || e[13] !== r || e[14] !== o ? (S = (T) => {
    if (s || T.target !== T.currentTarget)
      return;
    let k = 0, P = 0;
    if (T.key === "ArrowLeft")
      k = -gl;
    else if (T.key === "ArrowRight")
      k = gl;
    else if (T.key === "ArrowUp")
      P = -gl;
    else if (T.key === "ArrowDown")
      P = gl;
    else
      return;
    T.preventDefault(), r(p({
      x: o.x + k,
      y: o.y + P
    }));
  }, e[11] = p, e[12] = s, e[13] = r, e[14] = o, e[15] = S) : S = e[15];
  const E = S;
  let N;
  e[16] !== E || e[17] !== h || e[18] !== v ? (N = {
    onPointerDown: h,
    onPointerMove: v,
    onPointerUp: R,
    onPointerCancel: y,
    onLostPointerCapture: y,
    onKeyDown: E,
    tabIndex: 0,
    "aria-label": "Drag to reposition",
    "data-slot": "dialog-drag-handle"
  }, e[16] = E, e[17] = h, e[18] = v, e[19] = N) : N = e[19];
  const I = N;
  let M;
  return e[20] !== n || e[21] !== a || e[22] !== I ? (M = {
    dragHandleRef: n,
    isDragging: a,
    dragHandleProps: I
  }, e[20] = n, e[21] = a, e[22] = I, e[23] = M) : M = e[23], M;
}
const og = 550, rg = 400, jI = 16, KI = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]"], {
  variants: {
    expanded: {
      true: ["pointer-events-none", "flex", "items-center", "justify-center", "p-(--spacing-16)"],
      false: "pointer-events-none"
    }
  }
}), qI = ae(["flex", "flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5"], {
  variants: {
    expanded: {
      true: ["pointer-events-auto", "w-[min(1263px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(1136px,calc(100vh_-_var(--spacing-32)))]", "outline-none"],
      false: ["pointer-events-auto", "fixed", "z-[var(--z-layer-dialog)]", "h-[min(400px,100vh)]", "w-[min(550px,100vw)]"]
    }
  }
}), ZI = ae(["shrink-0", "bg-surface-container-lowest", "px-(--spacing-24)", "py-(--spacing-16)", "shadow-elevation-1"]), XI = ae(["flex", "shrink-0", "flex-col", "gap-(--spacing-6)", "p-(--spacing-16)"]), ig = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-bold)", "leading-(--font-line-height-28)", "text-text-default"]), sg = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), QI = ae(["mt-(--spacing-4)", "flex", "size-(--spacing-20)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "select-none", "outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"]), JI = ae(["min-h-0", "flex-1"], {
  variants: {
    expanded: {
      true: "flex",
      false: ["overflow-y-auto", "p-(--spacing-16)"]
    }
  }
}), eP = ae([], {
  variants: {
    expanded: {
      true: ["min-w-0", "flex-1", "overflow-y-auto", "p-(--spacing-16)"],
      false: "contents"
    }
  }
}), lg = ae(["flex", "min-h-(--spacing-40)", "shrink-0", "items-center", "gap-(--spacing-16)", "px-(--spacing-16)", "pb-(--spacing-16)"]);
function t3() {
  return typeof window > "u" ? {
    width: og,
    height: rg
  } : {
    width: Math.min(og, window.innerWidth),
    height: Math.min(rg, window.innerHeight)
  };
}
function hl(t, e = t3()) {
  return typeof window > "u" ? t : {
    x: Math.max(0, Math.min(t.x, window.innerWidth - e.width)),
    y: Math.max(0, Math.min(t.y, window.innerHeight - e.height))
  };
}
function ag(t, e) {
  if (typeof window > "u") return t;
  const n = e3(e);
  return {
    x: Math.max(-n.offsetX, Math.min(t.x, window.innerWidth - n.offsetX - n.width)),
    y: Math.max(-n.offsetY, Math.min(t.y, window.innerHeight - n.offsetY - n.height))
  };
}
function tP(t) {
  if (typeof window > "u") return {
    x: 0,
    y: 0
  };
  const {
    innerWidth: e,
    innerHeight: n
  } = window, o = t3(), r = Math.min(jI, e, n), i = e - o.width - r, s = n - o.height - r;
  switch (t) {
    case "top-start":
      return hl({
        x: r,
        y: r
      }, o);
    case "top-end":
      return hl({
        x: i,
        y: r
      }, o);
    case "bottom-start":
      return hl({
        x: r,
        y: s
      }, o);
    case "bottom-end":
      return hl({
        x: i,
        y: s
      }, o);
  }
}
function qD({
  open: t,
  onOpenChange: e,
  expanded: n = !1,
  onExpandedChange: o,
  initialPlacement: r = "bottom-end",
  position: i,
  onPositionChange: s,
  heading: l,
  description: a,
  headerAccessory: c,
  expandedAside: u,
  children: d,
  floatingFooter: f,
  expandedFooter: p
}) {
  const m = en(), h = !!n, b = i !== void 0, [v, C] = x.useState(() => tP(r)), y = i ?? v, w = x.useRef(null), R = (M) => {
    b || C(M), s?.(M);
  }, S = t && !h ? ag(y, w.current) : y, {
    isDragging: E,
    dragHandleProps: N
  } = YI({
    dragHandleRef: w,
    position: S,
    onPositionChange: R,
    disabled: h
  });
  return x.useEffect(() => {
    if (!t || h || typeof window > "u") return;
    const M = () => {
      const T = ag({
        x: y.x,
        y: y.y
      }, w.current);
      (T.x !== y.x || T.y !== y.y) && (b || C(T), s?.(T));
    };
    return M(), window.addEventListener("resize", M), () => window.removeEventListener("resize", M);
  }, [y.x, y.y, b, h, s, t]), /* @__PURE__ */ g(Ci, { open: t, onOpenChange: (M, T) => {
    const k = T?.reason === "outside-press" || T?.reason === "focus-out";
    if (!h && !M && k) {
      T.cancel();
      return;
    }
    e(M);
  }, modal: h, disablePointerDismissal: !h, children: /* @__PURE__ */ F(Lr, { container: m, children: [
    h && /* @__PURE__ */ g(Os, { "data-slot": "dialog-scrim", className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }),
    /* @__PURE__ */ g(wi, { className: ne(KI({
      expanded: h
    })), children: /* @__PURE__ */ F(xi, { "aria-modal": h ? "true" : void 0, "data-slot": h ? "dialog-expanded" : "dialog", initialFocus: h ? void 0 : () => w.current, className: ne(qI({
      expanded: h
    })), style: h ? void 0 : {
      left: S.x,
      top: S.y
    }, children: [
      h ? /* @__PURE__ */ F("div", { "data-slot": "dialog-expanded-header", className: ne(ZI()), children: [
        /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-16)", children: [
            /* @__PURE__ */ g(rs, { className: ne(ig(), "whitespace-nowrap"), children: l }),
            c && /* @__PURE__ */ g("div", { className: "flex min-w-0 items-center gap-(--spacing-16)", children: c })
          ] }),
          /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-16)", children: [
            o && /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Collapse", onClick: () => o(!1) }),
            /* @__PURE__ */ g(ti, { render: /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
          ] })
        ] }),
        a && /* @__PURE__ */ g(os, { className: ne(sg(), "mt-(--spacing-6)"), children: a })
      ] }) : /* @__PURE__ */ g("div", { className: ne(XI()), children: /* @__PURE__ */ F("div", { className: "flex items-start justify-between gap-(--spacing-6)", children: [
        /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 gap-(--spacing-8)", children: [
          /* @__PURE__ */ g("button", { type: "button", ref: w, ...N, className: ne(QI(), E ? "cursor-grabbing" : "cursor-grab"), children: /* @__PURE__ */ g(Ue, { name: "drag", size: "sm", tone: "secondary" }) }),
          /* @__PURE__ */ F("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8)", children: [
              /* @__PURE__ */ g(rs, { className: ne(ig(), "min-w-0"), children: l }),
              c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
            ] }),
            a && /* @__PURE__ */ g(os, { className: ne(sg(), "mt-(--spacing-4)"), children: a })
          ] })
        ] }),
        /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
          o && /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Expand", onClick: () => o(!0) }),
          /* @__PURE__ */ g(ti, { render: /* @__PURE__ */ g(bt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
        ] })
      ] }) }),
      /* @__PURE__ */ F("div", { className: ne(JI({
        expanded: h
      })), children: [
        h && u && /* @__PURE__ */ F(_t, { children: [
          /* @__PURE__ */ g("div", { className: "min-w-0 basis-1/2 overflow-y-auto p-(--spacing-16)", children: u }),
          /* @__PURE__ */ g(vr, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ g("div", { className: ne(eP({
          expanded: h
        })), children: d }, "body")
      ] }),
      h ? p && /* @__PURE__ */ g("div", { className: ne(lg()), children: p }) : f && /* @__PURE__ */ g("div", { className: ne(lg()), children: f })
    ] }) })
  ] }) });
}
const g1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (g1.displayName = "TabsRootContext");
function h1() {
  const t = x.useContext(g1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : st(64));
  return t;
}
let nP = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const b1 = {
  tabActivationDirection: (t) => ({
    [nP.activationDirection]: t
  })
}, v1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: i,
    orientation: s = "horizontal",
    render: l,
    value: a,
    style: c,
    ...u
  } = e, d = Object.hasOwn(e, "defaultValue"), f = x.useRef([]), [p, m] = x.useState(() => /* @__PURE__ */ new Map()), [h, b] = Sn({
    controlled: a,
    default: r,
    name: "Tabs",
    state: "value"
  }), v = a !== void 0, [C, y] = x.useState(() => /* @__PURE__ */ new Map()), w = x.useCallback((H) => {
    if (H === void 0)
      return null;
    for (const [K, G] of C.entries())
      if (G != null && H === (G.value ?? G.index))
        return K;
    return null;
  }, [C]), [R, S] = x.useState(() => ({
    previousValue: h,
    tabActivationDirection: "none"
  })), {
    previousValue: E,
    tabActivationDirection: N
  } = R;
  let I = N, M = !1;
  E !== h && (I = cg(E, h, s, C), M = E != null && h != null && w(h) == null);
  const T = M ? E : h, k = E !== T || N !== I;
  ke(() => {
    k && S({
      previousValue: T,
      tabActivationDirection: I
    });
  }, [T, k, I]);
  const P = we((H, K) => {
    const G = cg(h, H, s, C);
    K.activationDirection = G, i?.(H, K), !K.isCanceled && b(H);
  }), D = we((H, K) => {
    m((G) => {
      if (G.get(H) === K)
        return G;
      const q = new Map(G);
      return q.set(H, K), q;
    });
  }), O = we((H, K) => {
    m((G) => {
      if (!G.has(H) || G.get(H) !== K)
        return G;
      const q = new Map(G);
      return q.delete(H), q;
    });
  }), V = x.useCallback((H) => p.get(H), [p]), _ = x.useCallback((H) => {
    for (const K of C.values())
      if (H === K?.value)
        return K?.id;
  }, [C]), A = x.useMemo(() => ({
    getTabElementBySelectedValue: w,
    getTabIdByPanelValue: _,
    getTabPanelIdByValue: V,
    onValueChange: P,
    orientation: s,
    registerMountedTabPanel: D,
    setTabMap: y,
    unregisterMountedTabPanel: O,
    tabActivationDirection: I,
    value: h
  }), [w, _, V, P, s, D, y, O, I, h]), L = x.useMemo(() => {
    for (const H of C.values())
      if (H != null && H.value === h)
        return H;
  }, [C, h]), $ = x.useMemo(() => {
    for (const H of C.values())
      if (H != null && !H.disabled)
        return H.value;
  }, [C]);
  ke(() => {
    if (v || C.size === 0)
      return;
    const H = L?.disabled, K = L == null && h !== null;
    if (d && H && h === r || !H && !K)
      return;
    const q = $ ?? null;
    h !== q && (b(q), S((Q) => Q.tabActivationDirection === "none" ? Q : {
      ...Q,
      tabActivationDirection: "none"
    }));
  }, [r, $, d, v, L, b, C, h]);
  const z = Le("div", e, {
    state: {
      orientation: s,
      tabActivationDirection: I
    },
    ref: n,
    props: u,
    stateAttributesMapping: b1
  });
  return /* @__PURE__ */ g(g1.Provider, {
    value: A,
    children: /* @__PURE__ */ g(ci, {
      elementsRef: f,
      children: z
    })
  });
});
process.env.NODE_ENV !== "production" && (v1.displayName = "TabsRoot");
function cg(t, e, n, o) {
  if (t == null || e == null)
    return "none";
  let r = null, i = null;
  for (const [a, c] of o.entries()) {
    if (c == null)
      continue;
    const u = c.value ?? c.index;
    if (t === u && (r = a), e === u && (i = a), r != null && i != null)
      break;
  }
  if (r == null || i == null)
    return r !== i && (typeof t == "number" || typeof t == "string") && typeof t == typeof e ? n === "horizontal" ? e > t ? "right" : "left" : e > t ? "down" : "up" : "none";
  const s = r.getBoundingClientRect(), l = i.getBoundingClientRect();
  if (n === "horizontal") {
    if (l.left < s.left)
      return "left";
    if (l.left > s.left)
      return "right";
  } else {
    if (l.top < s.top)
      return "up";
    if (l.top > s.top)
      return "down";
  }
  return "none";
}
const y1 = "data-composite-item-active", x1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (x1.displayName = "TabsListContext");
function oP() {
  const t = x.useContext(x1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : st(65));
  return t;
}
const C1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: i,
    value: s,
    id: l,
    nativeButton: a = !0,
    style: c,
    ...u
  } = e, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: p
  } = h1(), {
    activateOnFocus: m,
    highlightedTabIndex: h,
    onTabActivation: b,
    registerTabResizeObserverElement: v,
    setHighlightedTabIndex: C,
    tabsListElement: y
  } = oP(), w = Ot(l), R = x.useMemo(() => ({
    disabled: r,
    id: w,
    value: s
  }), [r, w, s]), {
    compositeProps: S,
    compositeRef: E,
    index: N
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = C2({
    metadata: R
  }), I = s === d, M = x.useRef(!1), T = x.useRef(null);
  x.useEffect(() => {
    const z = T.current;
    if (z)
      return v(z);
  }, [v]), ke(() => {
    if (M.current) {
      M.current = !1;
      return;
    }
    if (!(I && N > -1 && h !== N))
      return;
    const z = y;
    if (z != null) {
      const H = Xt(nt(z));
      if (H && Fe(z, H))
        return;
    }
    r || C(N);
  }, [I, N, h, C, r, y]);
  const {
    getButtonProps: k,
    buttonRef: P
  } = qt({
    disabled: r,
    native: a,
    focusableWhenDisabled: !0
  }), D = f(s), O = x.useRef(!1), V = x.useRef(!1);
  function _(z) {
    I || r || b(s, De(At, z.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function A(z) {
    I || (N > -1 && !r && C(N), !r && m && (!O.current || // keyboard or touch focus
    O.current && V.current) && b(s, De(At, z.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function L(z) {
    if (I || r)
      return;
    O.current = !0;
    function H() {
      O.current = !1, V.current = !1;
    }
    (!z.button || z.button === 0) && (V.current = !0, nt(z.currentTarget).addEventListener("pointerup", H, {
      once: !0
    }));
  }
  return Le("button", e, {
    state: {
      disabled: r,
      active: I,
      orientation: p
    },
    ref: [n, P, E, T],
    props: [S, {
      role: "tab",
      "aria-controls": D,
      "aria-selected": I,
      id: w,
      onClick: _,
      onFocus: A,
      onPointerDown: L,
      [y1]: I ? "" : void 0,
      onKeyDownCapture() {
        M.current = !0;
      }
    }, u, k]
  });
});
process.env.NODE_ENV !== "production" && (C1.displayName = "TabsTab");
let rP = (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t[t.startingStyle = Jn.startingStyle] = "startingStyle", t[t.endingStyle = Jn.endingStyle] = "endingStyle", t;
})({});
const iP = {
  ...b1,
  ...Kt
}, n3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: i,
    keepMounted: s = !1,
    style: l,
    ...a
  } = e, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: m
  } = h1(), h = Ot(), b = x.useMemo(() => ({
    id: h,
    value: r
  }), [h, r]), {
    ref: v,
    index: C
  } = Ao({
    metadata: b
  }), y = r === c, {
    mounted: w,
    transitionStatus: R,
    setMounted: S
  } = to(y), E = !w, N = u(r), I = {
    hidden: E,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: R
  }, M = x.useRef(null), T = Le("div", e, {
    state: I,
    ref: [n, v, M],
    props: [{
      "aria-labelledby": N,
      hidden: E,
      id: h,
      role: "tabpanel",
      tabIndex: y ? 0 : -1,
      inert: Tr(!y),
      [rP.index]: C
    }, a],
    stateAttributesMapping: iP
  });
  return Jt({
    open: y,
    ref: M,
    onComplete() {
      y || S(!1);
    }
  }), ke(() => {
    if (!(E && !s) && h != null)
      return p(r, h), () => {
        m(r, h);
      };
  }, [E, s, r, h, p, m]), s || w ? T : null;
});
process.env.NODE_ENV !== "production" && (n3.displayName = "TabsPanel");
const sP = [];
function lP(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    onLoop: r,
    dense: i = !1,
    orientation: s = "both",
    direction: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: p,
    modifierKeys: m = sP
  } = t, [h, b] = x.useState(0), v = n > 1, C = x.useRef(null), y = Rn(C, u), w = x.useRef([]), R = x.useRef(!1), S = a ?? h, E = we((T, k = !1) => {
    if ((c ?? b)(T), k) {
      const P = w.current[T];
      Vp(C.current, P, l, s);
    }
  }), N = we((T) => {
    if (T.size === 0 || R.current)
      return;
    R.current = !0;
    const k = Array.from(T.keys()), P = k.find((O) => O?.hasAttribute(y1)) ?? null, D = P ? k.indexOf(P) : -1;
    D !== -1 && E(D), Vp(C.current, P, l, s);
  }), I = we((T, k, P) => r ? r?.(T, k, P, w) : P), M = x.useMemo(() => ({
    "aria-orientation": s === "both" ? void 0 : s,
    ref: y,
    onFocus(T) {
      const k = C.current, P = yt(T.nativeEvent);
      !k || P == null || !_p(P) || P.setSelectionRange(0, P.value.length ?? 0);
    },
    onKeyDown(T) {
      const k = d ? W9 : l2;
      if (!k.has(T.key) || aP(T, m) || !C.current)
        return;
      const D = l === "rtl", O = D ? ts : qr, V = {
        horizontal: O,
        vertical: pr,
        both: O
      }[s], _ = D ? qr : ts, A = {
        horizontal: _,
        vertical: Kr,
        both: _
      }[s], L = yt(T.nativeEvent);
      if (L != null && _p(L) && !E2(L)) {
        const q = L.selectionStart, Q = L.selectionEnd, U = L.value ?? "";
        if (q == null || T.shiftKey || q !== Q || T.key !== A && q < U.length || T.key !== V && q > 0)
          return;
      }
      let $ = S;
      const B = Nl(w, p), z = fu(w, p);
      if (v) {
        const q = e || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), Q = Rh(q, n, i), U = Q.findIndex((te) => te != null && !To(w.current, te, p)), X = Q.reduce((te, re, J) => re != null && !To(w.current, re, p) ? J : te, -1);
        $ = Q[Sh(Q.map((te) => te != null ? w.current[te] : null), {
          event: T,
          orientation: s,
          loopFocus: o,
          onLoop: I,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: Nh([...p || w.current.map((te, re) => To(w.current, re) ? re : void 0), void 0], Q),
          minIndex: U,
          maxIndex: X,
          prevIndex: Eh(
            S > z ? B : S,
            q,
            Q,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            T.key === pr ? "bl" : T.key === qr ? "tr" : "tl"
          ),
          rtl: D
        })];
      }
      const H = {
        horizontal: [O],
        vertical: [pr],
        both: [O, pr]
      }[s], K = {
        horizontal: [_],
        vertical: [Kr],
        both: [_, Kr]
      }[s], G = v ? k : {
        horizontal: d ? z9 : i2,
        vertical: d ? B9 : s2,
        both: k
      }[s];
      d && (T.key === ws ? $ = B : T.key === Ss && ($ = z)), $ === S && (H.includes(T.key) || K.includes(T.key)) && (o && $ === z && H.includes(T.key) ? ($ = B, r && ($ = r(T, S, $, w))) : o && $ === B && K.includes(T.key) ? ($ = z, r && ($ = r(T, S, $, w))) : $ = bn(w.current, {
        startingIndex: $,
        decrement: K.includes(T.key),
        disabledIndices: p
      })), $ !== S && !Ji(w.current, $) && (f && T.stopPropagation(), G.has(T.key) && T.preventDefault(), E($, !0), queueMicrotask(() => {
        w.current[$]?.focus();
      }));
    }
  }), [n, i, l, p, w, d, S, v, e, o, r, I, y, m, E, s, f]);
  return x.useMemo(() => ({
    props: M,
    highlightedIndex: S,
    onHighlightedIndexChange: E,
    elementsRef: w,
    disabledIndices: p,
    onMapChange: N,
    relayKeyboardEvent: M.onKeyDown
  }), [M, S, E, w, p, N]);
}
function aP(t, e) {
  for (const n of j9.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function o3(t) {
  const {
    render: e,
    className: n,
    style: o,
    refs: r = Hn,
    props: i = Hn,
    state: s = Et,
    stateAttributesMapping: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: p,
    onLoop: m,
    cols: h,
    enableHomeAndEndKeys: b,
    onMapChange: v,
    stopEventPropagation: C = !0,
    rootRef: y,
    disabledIndices: w,
    modifierKeys: R,
    highlightItemOnHover: S = !1,
    tag: E = "div",
    ...N
  } = t, I = Es(), {
    props: M,
    highlightedIndex: T,
    onHighlightedIndexChange: k,
    elementsRef: P,
    onMapChange: D,
    relayKeyboardEvent: O
  } = lP({
    itemSizes: f,
    cols: h,
    loopFocus: p,
    onLoop: m,
    dense: d,
    orientation: u,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: y,
    stopEventPropagation: C,
    enableHomeAndEndKeys: b,
    direction: I,
    disabledIndices: w,
    modifierKeys: R
  }), V = Le(E, t, {
    state: s,
    ref: r,
    props: [M, ...i, N],
    stateAttributesMapping: l
  }), _ = x.useMemo(() => ({
    highlightedIndex: T,
    onHighlightedIndexChange: k,
    highlightItemOnHover: S,
    relayKeyboardEvent: O
  }), [T, k, S, O]);
  return /* @__PURE__ */ g(Bu.Provider, {
    value: _,
    children: /* @__PURE__ */ g(ci, {
      elementsRef: P,
      onMapChange: (A) => {
        v?.(A), D(A);
      },
      children: V
    })
  });
}
const w1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: i = !0,
    render: s,
    style: l,
    ...a
  } = e, {
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: p
  } = h1(), [m, h] = x.useState(0), [b, v] = x.useState(null), C = x.useRef(/* @__PURE__ */ new Set()), y = x.useRef(/* @__PURE__ */ new Set()), w = x.useRef(null), R = we(() => {
    C.current.forEach((k) => {
      k();
    });
  });
  x.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const k = new ResizeObserver(() => {
      C.current.size && R();
    });
    return w.current = k, b && k.observe(b), y.current.forEach((P) => {
      k.observe(P);
    }), () => {
      k.disconnect(), w.current = null;
    };
  }, [b, R]);
  const S = we((k) => (C.current.add(k), () => {
    C.current.delete(k);
  })), E = we((k) => (y.current.add(k), w.current?.observe(k), () => {
    y.current.delete(k), w.current?.unobserve(k);
  })), N = we((k, P) => {
    k !== d && c(k, P);
  }), I = {
    orientation: u,
    tabActivationDirection: p
  }, M = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, T = x.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: m,
    registerIndicatorUpdateListener: S,
    registerTabResizeObserverElement: E,
    onTabActivation: N,
    setHighlightedTabIndex: h,
    tabsListElement: b
  }), [o, m, S, E, N, h, b]);
  return /* @__PURE__ */ g(x1.Provider, {
    value: T,
    children: /* @__PURE__ */ g(o3, {
      render: s,
      className: r,
      style: l,
      state: I,
      refs: [n, v],
      props: [M, a],
      stateAttributesMapping: b1,
      highlightedIndex: m,
      enableHomeAndEndKeys: !0,
      loopFocus: i,
      orientation: u,
      onHighlightedIndexChange: h,
      onMapChange: f,
      disabledIndices: Hn
    })
  });
});
process.env.NODE_ENV !== "production" && (w1.displayName = "TabsList");
function cP(t) {
  const e = W.c(8), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t;
  let i;
  e[0] !== o ? (i = o ?? [], e[0] = o, e[1] = i) : i = e[1];
  const [s, l] = qe(i), a = n !== void 0, c = a ? n : s;
  let u;
  e[2] !== a || e[3] !== r ? (u = function(m) {
    a || l(m), r?.(m);
  }, e[2] = a, e[3] = r, e[4] = u) : u = e[4];
  const d = u;
  let f;
  return e[5] !== c || e[6] !== d ? (f = [c, d], e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
}
function r3(t) {
  const e = W.c(6), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t, [i, s] = qe(o ?? null), l = n !== void 0, a = l ? n : i;
  let c;
  e[0] !== l || e[1] !== r ? (c = function(p) {
    l || s(p), r?.(p);
  }, e[0] = l, e[1] = r, e[2] = c) : c = e[2];
  const u = c;
  let d;
  return e[3] !== a || e[4] !== u ? (d = [a, u], e[3] = a, e[4] = u, e[5] = d) : d = e[5], d;
}
const uP = ae(["inline-flex", "h-(--spacing-32)", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-button-outline-default-text", "outline-none", "transition-colors", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "hover:border-button-outline-hover-border", "hover:bg-button-outline-hover-background", "active:border-button-outline-pressed-border", "active:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-[3px]", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:cursor-not-allowed", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    fullWidth: {
      true: "w-full",
      false: ""
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
});
function Ha(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    leadingIcon: r,
    trailingIcon: u,
    showChevron: s,
    open: l,
    mouseDown: a,
    fullWidth: c,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? !1 : s, f = l === void 0 ? !1 : l, p = a === void 0 ? !1 : a, m = c === void 0 ? !1 : c;
  let h;
  e[10] !== o || e[11] !== m ? (h = ne(uP({
    fullWidth: m
  }), o), e[10] = o, e[11] = m, e[12] = h) : h = e[12];
  const b = p ? "" : void 0, v = d ? f : i["aria-expanded"];
  let C;
  e[13] !== r ? (C = r && /* @__PURE__ */ g(Ue, { name: r, size: "xs", tone: "inherit" }), e[13] = r, e[14] = C) : C = e[14];
  let y;
  e[15] !== n ? (y = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: n }), e[15] = n, e[16] = y) : y = e[16];
  let w;
  e[17] !== u ? (w = u && /* @__PURE__ */ g(Ue, { name: u, size: "xs", tone: "inherit" }), e[17] = u, e[18] = w) : w = e[18];
  let R;
  e[19] !== f || e[20] !== d ? (R = d && /* @__PURE__ */ g("span", { "data-open": f ? "" : void 0, className: "inline-flex transition-transform duration-200 data-[open]:rotate-180", children: /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[19] = f, e[20] = d, e[21] = R) : R = e[21];
  let S;
  return e[22] !== i || e[23] !== w || e[24] !== R || e[25] !== h || e[26] !== b || e[27] !== v || e[28] !== C || e[29] !== y ? (S = /* @__PURE__ */ F(no, { className: h, ...i, "data-mouse-down": b, "aria-expanded": v, children: [
    C,
    y,
    w,
    R
  ] }), e[22] = i, e[23] = w, e[24] = R, e[25] = h, e[26] = b, e[27] = v, e[28] = C, e[29] = y, e[30] = S) : S = e[30], S;
}
function ZD(t) {
  const e = W.c(47), {
    children: n,
    title: o,
    triggerLabel: r,
    align: i,
    open: s,
    defaultOpen: l,
    onOpenChange: a,
    onApply: c,
    applyLabel: u,
    onClearAll: d,
    clearAllLabel: f,
    disabled: p
  } = t, m = o === void 0 ? "Filters" : o, h = i === void 0 ? "start" : i, b = u === void 0 ? "Apply filters" : u, v = f === void 0 ? "Clear All" : f, C = en(), [y, w] = qe(l ?? !1), {
    mouseDown: R,
    triggerMouseDownProps: S
  } = Is(), E = s !== void 0, N = E ? s : y;
  let I;
  e[0] !== E || e[1] !== a ? (I = function(Q) {
    E || w(Q), a?.(Q);
  }, e[0] = E, e[1] = a, e[2] = I) : I = e[2];
  const M = I;
  let T;
  e[3] !== M ? (T = function() {
    M(!1);
  }, e[3] = M, e[4] = T) : T = e[4];
  const k = T;
  let P;
  e[5] !== p || e[6] !== R || e[7] !== m || e[8] !== r || e[9] !== S ? (P = /* @__PURE__ */ g(Ea, { render: r !== void 0 ? /* @__PURE__ */ g(Ha, { trailingIcon: "filter", disabled: p, mouseDown: R, ...S, children: r }) : /* @__PURE__ */ g(bt, { variant: "outline", size: "sm", icon: "filter", "aria-label": m, disabled: p, ...S }) }), e[5] = p, e[6] = R, e[7] = m, e[8] = r, e[9] = S, e[10] = P) : P = e[10];
  let D;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne("flex", "w-[500px]", "max-w-[calc(100vw-var(--spacing-32))]", "max-h-[544px]", "flex-col", "gap-(--spacing-20)", "overflow-y-auto", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface", "p-(--spacing-20)", "shadow-elevation-3", "outline-none"), e[11] = D) : D = e[11];
  let O;
  e[12] !== m ? (O = /* @__PURE__ */ g("h2", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-28) text-text-default", children: m }), e[12] = m, e[13] = O) : O = e[13];
  let V;
  e[14] !== v || e[15] !== d ? (V = d && /* @__PURE__ */ g(pn, { variant: "ghost", size: "sm", onClick: d, children: v }), e[14] = v, e[15] = d, e[16] = V) : V = e[16];
  let _;
  e[17] !== V || e[18] !== O ? (_ = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    O,
    V
  ] }), e[17] = V, e[18] = O, e[19] = _) : _ = e[19];
  let A;
  e[20] !== n || e[21] !== k ? (A = typeof n == "function" ? n({
    close: k
  }) : n, e[20] = n, e[21] = k, e[22] = A) : A = e[22];
  let L;
  e[23] !== A ? (L = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-16)", children: A }), e[23] = A, e[24] = L) : L = e[24];
  let $;
  e[25] !== k || e[26] !== c ? ($ = () => {
    c?.(), k();
  }, e[25] = k, e[26] = c, e[27] = $) : $ = e[27];
  let B;
  e[28] !== b || e[29] !== $ ? (B = /* @__PURE__ */ g("div", { className: "flex justify-end", children: /* @__PURE__ */ g(pn, { size: "sm", onClick: $, children: b }) }), e[28] = b, e[29] = $, e[30] = B) : B = e[30];
  let z;
  e[31] !== _ || e[32] !== L || e[33] !== B || e[34] !== m ? (z = /* @__PURE__ */ F(Ia, { role: "dialog", "aria-label": m, className: D, children: [
    _,
    L,
    B
  ] }), e[31] = _, e[32] = L, e[33] = B, e[34] = m, e[35] = z) : z = e[35];
  let H;
  e[36] !== h || e[37] !== z ? (H = /* @__PURE__ */ g(ka, { side: "bottom", align: h, sideOffset: 4, children: z }), e[36] = h, e[37] = z, e[38] = H) : H = e[38];
  let K;
  e[39] !== C || e[40] !== H ? (K = /* @__PURE__ */ g(Na, { container: C, children: H }), e[39] = C, e[40] = H, e[41] = K) : K = e[41];
  let G;
  return e[42] !== N || e[43] !== M || e[44] !== K || e[45] !== P ? (G = /* @__PURE__ */ F(nf, { open: N, onOpenChange: M, modal: !1, children: [
    P,
    K
  ] }), e[42] = N, e[43] = M, e[44] = K, e[45] = P, e[46] = G) : G = e[46], G;
}
function XD(t) {
  const e = W.c(27), {
    label: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = cP(u), [p, m] = qe(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Is();
  let v;
  e[4] !== d || e[5] !== f ? (v = function(N, I) {
    f(I ? [...d, N] : d.filter((M) => M !== N));
  }, e[4] = d, e[5] = f, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== a || e[8] !== n || e[9] !== h || e[10] !== p || e[11] !== b ? (y = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(Ha, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: n }) }), e[7] = a, e[8] = n, e[9] = h, e[10] = p, e[11] = b, e[12] = y) : y = e[12];
  let w;
  if (e[13] !== C || e[14] !== o || e[15] !== d) {
    let E;
    e[17] !== C || e[18] !== d ? (E = (N) => /* @__PURE__ */ g(k7, { checked: d.includes(N.value), disabled: N.disabled, closeOnClick: !1, onCheckedChange: (I) => {
      C(N.value, I);
    }, children: N.label }, N.value), e[17] = C, e[18] = d, e[19] = E) : E = e[19], w = o.map(E), e[13] = C, e[14] = o, e[15] = d, e[16] = w;
  } else
    w = e[16];
  let R;
  e[20] !== c || e[21] !== w ? (R = /* @__PURE__ */ g(Dr, { size: "auto", align: c, children: w }), e[20] = c, e[21] = w, e[22] = R) : R = e[22];
  let S;
  return e[23] !== p || e[24] !== y || e[25] !== R ? (S = /* @__PURE__ */ F(fi, { open: p, onOpenChange: m, children: [
    y,
    R
  ] }), e[23] = p, e[24] = y, e[25] = R, e[26] = S) : S = e[26], S;
}
function QD(t) {
  const e = W.c(29), {
    options: n,
    value: o,
    defaultValue: r,
    onChange: i,
    placeholder: s,
    align: l,
    disabled: a
  } = t, c = s === void 0 ? "Date Range" : s, u = l === void 0 ? "start" : l;
  let d;
  e[0] !== r || e[1] !== i || e[2] !== o ? (d = {
    value: o,
    defaultValue: r,
    onChange: i
  }, e[0] = r, e[1] = i, e[2] = o, e[3] = d) : d = e[3];
  const [f, p] = r3(d), [m, h] = qe(!1), {
    mouseDown: b,
    triggerMouseDownProps: v
  } = Is();
  let C;
  e[4] !== n || e[5] !== c || e[6] !== f ? (C = n.find((T) => T.value === f)?.label ?? c, e[4] = n, e[5] = c, e[6] = f, e[7] = C) : C = e[7];
  const y = C;
  let w;
  e[8] !== a || e[9] !== b || e[10] !== m || e[11] !== y || e[12] !== v ? (w = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ g(Ha, { leadingIcon: "calendar", showChevron: !0, open: m, mouseDown: b, disabled: a, ...v, children: y }) }), e[8] = a, e[9] = b, e[10] = m, e[11] = y, e[12] = v, e[13] = w) : w = e[13];
  const R = f ?? "";
  let S;
  e[14] !== p ? (S = (T) => {
    p(T), h(!1);
  }, e[14] = p, e[15] = S) : S = e[15];
  let E;
  e[16] !== n ? (E = n.map(dP), e[16] = n, e[17] = E) : E = e[17];
  let N;
  e[18] !== R || e[19] !== S || e[20] !== E ? (N = /* @__PURE__ */ g($d, { value: R, onValueChange: S, children: E }), e[18] = R, e[19] = S, e[20] = E, e[21] = N) : N = e[21];
  let I;
  e[22] !== u || e[23] !== N ? (I = /* @__PURE__ */ g(Dr, { size: "trigger", align: u, children: N }), e[22] = u, e[23] = N, e[24] = I) : I = e[24];
  let M;
  return e[25] !== m || e[26] !== I || e[27] !== w ? (M = /* @__PURE__ */ F(fi, { open: m, onOpenChange: h, children: [
    w,
    I
  ] }), e[25] = m, e[26] = I, e[27] = w, e[28] = M) : M = e[28], M;
}
function dP(t) {
  return /* @__PURE__ */ g(Hd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function JD(t) {
  const e = W.c(33), {
    prefix: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = r3(u), [p, m] = qe(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Is();
  let v;
  e[4] !== o || e[5] !== d ? (v = o.find((k) => k.value === d)?.label ?? "", e[4] = o, e[5] = d, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== n ? (y = /* @__PURE__ */ g("span", { className: "text-text-subtle", children: n }), e[7] = n, e[8] = y) : y = e[8];
  let w;
  e[9] !== C ? (w = C && /* @__PURE__ */ F(_t, { children: [
    " ",
    /* @__PURE__ */ g("span", { children: C })
  ] }), e[9] = C, e[10] = w) : w = e[10];
  let R;
  e[11] !== a || e[12] !== h || e[13] !== p || e[14] !== y || e[15] !== w || e[16] !== b ? (R = /* @__PURE__ */ g(qo, { render: /* @__PURE__ */ F(Ha, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: [
    y,
    w
  ] }) }), e[11] = a, e[12] = h, e[13] = p, e[14] = y, e[15] = w, e[16] = b, e[17] = R) : R = e[17];
  const S = d ?? "";
  let E;
  e[18] !== f ? (E = (k) => {
    f(k), m(!1);
  }, e[18] = f, e[19] = E) : E = e[19];
  let N;
  e[20] !== o ? (N = o.map(fP), e[20] = o, e[21] = N) : N = e[21];
  let I;
  e[22] !== S || e[23] !== E || e[24] !== N ? (I = /* @__PURE__ */ g($d, { value: S, onValueChange: E, children: N }), e[22] = S, e[23] = E, e[24] = N, e[25] = I) : I = e[25];
  let M;
  e[26] !== c || e[27] !== I ? (M = /* @__PURE__ */ g(Dr, { size: "trigger", align: c, children: I }), e[26] = c, e[27] = I, e[28] = M) : M = e[28];
  let T;
  return e[29] !== p || e[30] !== M || e[31] !== R ? (T = /* @__PURE__ */ F(fi, { open: p, onOpenChange: m, children: [
    R,
    M
  ] }), e[29] = p, e[30] = M, e[31] = R, e[32] = T) : T = e[32], T;
}
function fP(t) {
  return /* @__PURE__ */ g(Hd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function e_(t) {
  const e = W.c(14), {
    filters: n,
    onRemove: o,
    onClearAll: r,
    label: i,
    clearAllLabel: s
  } = t, l = i === void 0 ? "Filters:" : i, a = s === void 0 ? "Clear All" : s;
  if (n.length === 0)
    return null;
  let c;
  e[0] !== l ? (c = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtle", children: l }), e[0] = l, e[1] = c) : c = e[1];
  let u;
  if (e[2] !== n || e[3] !== o) {
    let p;
    e[5] !== o ? (p = (m) => /* @__PURE__ */ g(Xv, { label: m.label, removeAriaLabel: m.removeAriaLabel, onClose: () => o(m.id) }, m.id), e[5] = o, e[6] = p) : p = e[6], u = n.map(p), e[2] = n, e[3] = o, e[4] = u;
  } else
    u = e[4];
  let d;
  e[7] !== a || e[8] !== r ? (d = /* @__PURE__ */ g(pn, { variant: "ghost", size: "sm", onClick: r, children: a }), e[7] = a, e[8] = r, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ F("div", { "aria-live": "polite", className: "flex flex-wrap items-center gap-(--spacing-8)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
function t_(t) {
  const e = W.c(13), {
    items: n,
    value: o,
    defaultValue: r,
    onValueChange: i,
    "aria-label": s
  } = t, l = s === void 0 ? "Filter views" : s;
  let a;
  e[0] !== i ? (a = (p) => i?.(p), e[0] = i, e[1] = a) : a = e[1];
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ne("inline-flex", "flex-wrap", "max-w-full", "items-center", "gap-[2px]", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface-container-high", "p-[2px]", "max-sm:gap-(--spacing-4)", "max-sm:p-(--spacing-4)"), e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = n.map(pP), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== l || e[6] !== u ? (d = /* @__PURE__ */ g(w1, { "aria-label": l, className: c, children: u }), e[5] = l, e[6] = u, e[7] = d) : d = e[7];
  let f;
  return e[8] !== r || e[9] !== a || e[10] !== d || e[11] !== o ? (f = /* @__PURE__ */ g(v1, { value: o, defaultValue: r, onValueChange: a, children: d }), e[8] = r, e[9] = a, e[10] = d, e[11] = o, e[12] = f) : f = e[12], f;
}
function pP(t) {
  return /* @__PURE__ */ F(C1, { value: t.value, disabled: t.disabled, "aria-label": t.count === void 0 ? t.label : `${t.label} ${t.count}`, className: ne("relative", "group", "inline-flex", "h-[28px]", "min-w-0", "items-center", "justify-center", "gap-(--spacing-6)", "rounded-(--radius-xs)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-text-subtle", "outline-none", "transition-[background-color,box-shadow]", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "focus-visible:[outline:2px_solid_hsl(var(--button-focus-ring))]", "focus-visible:[outline-offset:2px]", "data-[active]:bg-surface-container-lowest", "data-[active]:text-text-default", "data-[active]:shadow-elevation-1", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "max-sm:before:absolute", "max-sm:before:left-0", "max-sm:before:top-1/2", "max-sm:before:h-[44px]", "max-sm:before:min-w-[44px]", "max-sm:before:w-full", "max-sm:before:-translate-y-1/2", "max-sm:before:content-['']"), children: [
    /* @__PURE__ */ g("span", { className: "truncate", children: t.label }),
    t.count !== void 0 && /* @__PURE__ */ g("span", { className: "text-text-disabled group-data-[active]:text-text-subtle", children: t.count })
  ] }, t.value);
}
const ug = ne("border", "border-outline-subtle", "rounded-(--radius-sm)", "flex", "flex-col");
function n_(t) {
  const e = W.c(24);
  let n, o, r;
  e[0] !== t ? ({
    as: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "form" : r;
  let s, l, a, c;
  if (e[4] !== n) {
    const b = x.Children.toArray(n);
    s = b.find(i3);
    const v = b.filter(mP);
    c = "overflow-hidden p-(--spacing-20)", l = "flex flex-col gap-(--spacing-20) w-full", a = x.Children.map(v, (C, y) => /* @__PURE__ */ F(_t, { children: [
      C,
      y < v.length - 1 && /* @__PURE__ */ g(vr, { variant: "middle-inset" })
    ] })), e[4] = n, e[5] = s, e[6] = l, e[7] = a, e[8] = c;
  } else
    s = e[5], l = e[6], a = e[7], c = e[8];
  let u;
  e[9] !== l || e[10] !== a ? (u = /* @__PURE__ */ g("div", { className: l, children: a }), e[9] = l, e[10] = a, e[11] = u) : u = e[11];
  let d;
  e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[12] = c, e[13] = u, e[14] = d) : d = e[14];
  let f;
  e[15] !== s || e[16] !== d ? (f = /* @__PURE__ */ F(_t, { children: [
    d,
    s
  ] }), e[15] = s, e[16] = d, e[17] = f) : f = e[17];
  const p = f;
  if (i === "div") {
    const b = o;
    let v;
    return e[18] !== p || e[19] !== b ? (v = /* @__PURE__ */ g("div", { className: ug, ...b, children: p }), e[18] = p, e[19] = b, e[20] = v) : v = e[20], v;
  }
  const m = o;
  let h;
  return e[21] !== p || e[22] !== m ? (h = /* @__PURE__ */ g("form", { className: ug, ...m, children: p }), e[21] = p, e[22] = m, e[23] = h) : h = e[23], h;
}
function mP(t) {
  return !i3(t);
}
function i3(t) {
  return x.isValidElement(t) && t.type === vP;
}
const gP = ae(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-text-default", "tracking-(--font-letter-spacing-default)", "shrink-0"], {
  variants: {
    variant: {
      main: ["text-(length:--font-size-title-xl)", "leading-(--font-line-height-28)"],
      subsection: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    }
  }
}), hP = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-text-subtext", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]);
function o_(t) {
  const e = W.c(30), {
    variant: n,
    title: o,
    description: r,
    titleAccessory: i,
    actions: s,
    children: l
  } = t, a = n === "main" ? "h2" : "h3", c = x.useId(), u = r != null, d = u ? `${c}-description` : void 0;
  let f;
  e[0] !== o ? (f = /* @__PURE__ */ g("legend", { className: "sr-only", children: o }), e[0] = o, e[1] = f) : f = e[1];
  let p;
  e[2] !== n ? (p = gP({
    variant: n
  }), e[2] = n, e[3] = p) : p = e[3];
  let m;
  e[4] !== a || e[5] !== p || e[6] !== o ? (m = /* @__PURE__ */ g(a, { className: p, children: o }), e[4] = a, e[5] = p, e[6] = o, e[7] = m) : m = e[7];
  const h = i != null && i;
  let b;
  e[8] !== m || e[9] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6)", children: [
    m,
    h
  ] }), e[8] = m, e[9] = h, e[10] = b) : b = e[10];
  let v;
  e[11] !== r || e[12] !== u || e[13] !== c ? (v = u && /* @__PURE__ */ g("p", { id: `${c}-description`, className: ne(hP(), "mt-(--spacing-6)"), children: r }), e[11] = r, e[12] = u, e[13] = c, e[14] = v) : v = e[14];
  let C;
  e[15] !== b || e[16] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex-1 min-w-0", children: [
    b,
    v
  ] }), e[15] = b, e[16] = v, e[17] = C) : C = e[17];
  let y;
  e[18] !== s ? (y = s != null && /* @__PURE__ */ g("div", { className: "shrink-0", children: s }), e[18] = s, e[19] = y) : y = e[19];
  let w;
  e[20] !== C || e[21] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-12)", children: [
    C,
    y
  ] }), e[20] = C, e[21] = y, e[22] = w) : w = e[22];
  let R;
  e[23] !== l ? (R = l != null && /* @__PURE__ */ g("div", { className: "mt-(--spacing-16) flex flex-col", children: l }), e[23] = l, e[24] = R) : R = e[24];
  let S;
  return e[25] !== d || e[26] !== w || e[27] !== R || e[28] !== f ? (S = /* @__PURE__ */ F("fieldset", { "aria-describedby": d, className: "border-0 p-0 m-0 min-w-0", children: [
    f,
    w,
    R
  ] }), e[25] = d, e[26] = w, e[27] = R, e[28] = f, e[29] = S) : S = e[29], S;
}
const bP = ne("font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-20)", "text-text-default", "text-(length:--font-size-label-lg)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap", "shrink-0");
function r_(t) {
  const e = W.c(10), {
    columns: n
  } = t, [o, r] = n, i = n.length === 2 ? "justify-between" : "justify-center";
  let s;
  e[0] !== i ? (s = ne("flex w-[212px] items-start p-0", i), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(dg, { column: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r != null && /* @__PURE__ */ g(dg, { column: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  return e[6] !== s || e[7] !== l || e[8] !== a ? (c = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    a
  ] }), e[6] = s, e[7] = l, e[8] = a, e[9] = c) : c = e[9], c;
}
function dg(t) {
  const e = W.c(7), {
    column: n
  } = t;
  let o;
  e[0] !== n.icon ? (o = n.icon != null && /* @__PURE__ */ g(Ue, { name: n.icon, size: "sm", "aria-hidden": !0 }), e[0] = n.icon, e[1] = o) : o = e[1];
  let r;
  e[2] !== n.label ? (r = /* @__PURE__ */ g("span", { className: bP, children: n.label }), e[2] = n.label, e[3] = r) : r = e[3];
  let i;
  return e[4] !== o || e[5] !== r ? (i = /* @__PURE__ */ F("div", { className: "flex flex-1 items-center justify-end gap-(--spacing-8) min-w-0 overflow-hidden", children: [
    o,
    r
  ] }), e[4] = o, e[5] = r, e[6] = i) : i = e[6], i;
}
function vP(t) {
  const e = W.c(18);
  let n, o, r;
  e[0] !== t ? ({
    leading: o,
    actions: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none h-[58px] w-full shrink-0 bg-gradient-to-b from-surface-0 to-surface mb-[-12px]" }), e[4] = i) : i = e[4];
  const s = o != null && n != null ? "sm:justify-between" : n != null ? "sm:justify-end" : "sm:justify-start";
  let l;
  e[5] !== s ? (l = ne("flex flex-col items-stretch gap-(--spacing-16) overflow-hidden border-t border-outline-subtle bg-surface p-(--spacing-16) shrink-0 rounded-b-(--radius-sm) sm:flex-row sm:items-center", s), e[5] = s, e[6] = l) : l = e[6];
  let a;
  e[7] !== o ? (a = o != null && /* @__PURE__ */ g("div", { className: "min-w-0 w-full sm:flex-1", children: o }), e[7] = o, e[8] = a) : a = e[8];
  let c;
  e[9] !== n ? (c = n != null && /* @__PURE__ */ g("div", { className: "flex flex-wrap items-center justify-end gap-(--spacing-16) self-end sm:flex-nowrap sm:self-auto sm:shrink-0", children: n }), e[9] = n, e[10] = c) : c = e[10];
  let u;
  e[11] !== l || e[12] !== a || e[13] !== c ? (u = /* @__PURE__ */ F("div", { className: l, children: [
    a,
    c
  ] }), e[11] = l, e[12] = a, e[13] = c, e[14] = u) : u = e[14];
  let d;
  return e[15] !== r || e[16] !== u ? (d = /* @__PURE__ */ F("footer", { role: "none", className: "sticky bottom-0 flex flex-col", ...r, children: [
    i,
    u
  ] }), e[15] = r, e[16] = u, e[17] = d) : d = e[17], d;
}
function i_(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    header: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== n ? (i = /* @__PURE__ */ g("main", { className: "flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-(--spacing-24)", children: n }), e[4] = n, e[5] = i) : i = e[5];
  let s;
  return e[6] !== o || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ F("div", { ...r, "data-slot": "full-page-layout", className: "flex h-dvh min-h-0 w-full flex-col overflow-hidden bg-surface", children: [
    o,
    i
  ] }), e[6] = o, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const yP = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), xP = ae(["pointer-events-none", "fixed", "inset-0", "flex", "flex-col", "gap-(--spacing-10)", "px-(--spacing-24)", "pt-(--spacing-20)", "pb-(--spacing-32)", "outline-none"]), CP = ae(["pointer-events-auto", "max-h-full", "max-w-full", "rounded-(--radius-sm)", "object-contain", "opacity-100", "transition-opacity", "duration-200", "ease-in-out", "starting:opacity-0", "motion-reduce:transition-none"]);
function s_(t) {
  const e = W.c(42), {
    open: n,
    onOpenChange: o,
    images: r,
    index: i,
    onIndexChange: s,
    "aria-label": l
  } = t, a = l === void 0 ? "Image viewer" : l, c = en(), u = r[i], d = r.length > 0;
  let f;
  e[0] !== d || e[1] !== r.length || e[2] !== i || e[3] !== s ? (f = () => {
    d && s((i - 1 + r.length) % r.length);
  }, e[0] = d, e[1] = r.length, e[2] = i, e[3] = s, e[4] = f) : f = e[4];
  const p = f;
  let m;
  e[5] !== d || e[6] !== r.length || e[7] !== i || e[8] !== s ? (m = () => {
    d && s((i + 1) % r.length);
  }, e[5] = d, e[6] = r.length, e[7] = i, e[8] = s, e[9] = m) : m = e[9];
  const h = m;
  let b;
  e[10] !== h || e[11] !== p ? (b = (O) => {
    O.altKey || O.ctrlKey || O.metaKey || (O.key === "ArrowLeft" && (O.preventDefault(), p()), O.key === "ArrowRight" && (O.preventDefault(), h()));
  }, e[10] = h, e[11] = p, e[12] = b) : b = e[12];
  const v = b;
  let C;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g(Os, { "data-slot": "lightbox-scrim", className: ne(yP()) }), e[13] = C) : C = e[13];
  let y;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = ne(xP()), e[14] = y) : y = e[14];
  let w;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ g("div", { className: "pointer-events-auto self-end", children: /* @__PURE__ */ g(ti, { render: /* @__PURE__ */ g(bt, { icon: "x-close", "aria-label": "Close", variant: "outline", size: "md" }) }) }), e[15] = w) : w = e[15];
  const R = !d;
  let S;
  e[16] !== p || e[17] !== R ? (S = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(bt, { icon: "arrow-left", "aria-label": "Previous image", variant: "outline", size: "md", disabled: R, onClick: p }) }), e[16] = p, e[17] = R, e[18] = S) : S = e[18];
  let E;
  e[19] !== u || e[20] !== i ? (E = u && /* @__PURE__ */ g("img", { src: u.src, alt: u.alt, className: ne(CP()) }, `${i}-${u.src}`), e[19] = u, e[20] = i, e[21] = E) : E = e[21];
  let N;
  e[22] !== E ? (N = /* @__PURE__ */ g("div", { "data-slot": "lightbox-image-container", className: "flex min-w-0 flex-1 self-stretch items-center justify-center", children: E }), e[22] = E, e[23] = N) : N = e[23];
  const I = !d;
  let M;
  e[24] !== h || e[25] !== I ? (M = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(bt, { icon: "arrow-right-regular", "aria-label": "Next image", variant: "outline", size: "md", disabled: I, onClick: h }) }), e[24] = h, e[25] = I, e[26] = M) : M = e[26];
  let T;
  e[27] !== N || e[28] !== M || e[29] !== S ? (T = /* @__PURE__ */ F("div", { className: "flex min-h-0 flex-1 items-center gap-(--spacing-24)", children: [
    S,
    N,
    M
  ] }), e[27] = N, e[28] = M, e[29] = S, e[30] = T) : T = e[30];
  let k;
  e[31] !== a || e[32] !== v || e[33] !== T ? (k = /* @__PURE__ */ g(wi, { className: "pointer-events-none fixed inset-0 z-[var(--z-layer-dialog)]", children: /* @__PURE__ */ F(xi, { "aria-label": a, "aria-modal": "true", "data-slot": "lightbox", className: y, onKeyDown: v, children: [
    w,
    T
  ] }) }), e[31] = a, e[32] = v, e[33] = T, e[34] = k) : k = e[34];
  let P;
  e[35] !== c || e[36] !== k ? (P = /* @__PURE__ */ F(Lr, { container: c, children: [
    C,
    k
  ] }), e[35] = c, e[36] = k, e[37] = P) : P = e[37];
  let D;
  return e[38] !== o || e[39] !== n || e[40] !== P ? (D = /* @__PURE__ */ g(Ci, { open: n, onOpenChange: o, modal: !0, children: P }), e[38] = o, e[39] = n, e[40] = P, e[41] = D) : D = e[41], D;
}
const wP = ne("group relative flex  w-full flex-col items-stretch justify-center overflow-hidden", "min-w-0 flex-1", "border-0 border-b border-solid border-b-outline-subtle", "bg-surface", "p-(--spacing-16)", "text-left", "transition-colors duration-200 ease-in-out", "after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-(--spacing-4)", "after:bg-primary after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-['']", "data-[state=active]:bg-primary/8 data-[state=active]:after:opacity-100", "cursor-pointer", "hover:bg-surface-hover", "active:bg-surface-pressed", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring", "disabled:pointer-events-none disabled:opacity-50");
function l_(t) {
  const e = W.c(9);
  let n, o, r;
  e[0] !== t ? ({
    active: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? !1 : r, s = i ? "active" : "default";
  let l;
  return e[4] !== i || e[5] !== n || e[6] !== o || e[7] !== s ? (l = /* @__PURE__ */ g(no, { type: "button", "data-slot": "list-card", "data-state": s, "aria-pressed": i, className: wP, ...o, children: n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s, e[8] = l) : l = e[8], l;
}
function S1(t, e) {
  const n = W.c(10), o = at(void 0), r = at(t);
  let i, s;
  n[0] !== t ? (i = () => {
    r.current = t;
  }, s = [t], n[0] = t, n[1] = i, n[2] = s) : (i = n[1], s = n[2]), Nt(i, s);
  let l;
  n[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = function() {
    o.current !== void 0 && (window.clearTimeout(o.current), o.current = void 0);
  }, n[3] = l) : l = n[3];
  const a = l;
  let c;
  n[4] !== e ? (c = function(h, b) {
    const v = b === void 0 ? !1 : b;
    if (a(), !!r.current) {
      if (v || e === 0) {
        r.current(h);
        return;
      }
      o.current = window.setTimeout(() => {
        o.current = void 0, r.current?.(h);
      }, e);
    }
  }, n[4] = e, n[5] = c) : c = n[5];
  const u = c;
  let d, f;
  n[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = () => () => {
    o.current !== void 0 && window.clearTimeout(o.current);
  }, f = [], n[6] = d, n[7] = f) : (d = n[6], f = n[7]), Nt(d, f);
  let p;
  return n[8] !== u ? (p = {
    cancelSearch: a,
    emitSearch: u
  }, n[8] = u, n[9] = p) : p = n[9], p;
}
const SP = ae(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), fg = ["inline-flex", "items-center", "gap-(--spacing-4)", "h-(--spacing-24)", "bg-chip-neutral-container", "text-chip-neutral-label", "rounded-(--radius-sm)", "px-(--spacing-6)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(number:--font-weight-medium)", "whitespace-nowrap", "overflow-hidden", "max-w-full", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"];
function pg(t) {
  const e = W.c(3), {
    children: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = ne(bo({}), "pointer-events-none cursor-default text-menu-text-subtle"), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("div", { className: o, children: /* @__PURE__ */ g(xr, { children: n }) }), e[1] = n, e[2] = r) : r = e[2], r;
}
function RP(t) {
  const e = W.c(3), {
    loading: n
  } = t, o = HS().length;
  let r;
  return e[0] !== n || e[1] !== o ? (r = /* @__PURE__ */ g(Q0, { children: n ? /* @__PURE__ */ g(pg, { children: "Searching..." }) : o === 0 ? /* @__PURE__ */ g(pg, { children: "No results found" }) : /* @__PURE__ */ g("span", { className: "sr-only", children: o === 1 ? "1 result found" : `${o} results found` }) }), e[0] = n, e[1] = o, e[2] = r) : r = e[2], r;
}
function a_(t) {
  const e = W.c(150), {
    options: n,
    value: o,
    onChange: r,
    defaultValue: i,
    placeholder: s,
    size: l,
    label: a,
    tooltip: c,
    required: u,
    description: d,
    error: f,
    disabled: p,
    readOnly: m,
    name: h,
    "data-testid": b,
    reserveSubtextSpace: v,
    searchValue: C,
    defaultSearchValue: y,
    onSearchChange: w,
    searchDebounceMs: R,
    loading: S,
    selectedOptions: E
  } = t, N = l === void 0 ? "md" : l, I = m === void 0 ? !1 : m, M = v === void 0 ? !0 : v, T = y === void 0 ? "" : y, k = R === void 0 ? 300 : R, P = S === void 0 ? !1 : S, D = en(), O = at(null), V = !!f, A = M || V || !!d, L = o !== void 0, $ = w !== void 0, B = $ && P, z = C !== void 0;
  let H;
  e[0] !== i ? (H = i ?? [], e[0] = i, e[1] = H) : H = e[1];
  const [K, G] = qe(H);
  let q;
  e[2] !== i || e[3] !== E ? (q = () => (i ?? []).flatMap((gt) => E?.find((vt) => vt.value === gt) ?? []), e[2] = i, e[3] = E, e[4] = q) : q = e[4];
  const [Q, U] = qe(q), [X, te] = qe(!1), re = X && !I, [J, ie] = qe(T), ce = z ? C : J, {
    emitSearch: oe
  } = S1(w, k);
  let se, me;
  e[5] !== I ? (me = () => {
    I && te(!1);
  }, se = [I], e[5] = I, e[6] = se, e[7] = me) : (se = e[6], me = e[7]), Nt(me, se);
  const pe = L ? o : K;
  let le;
  e[8] !== Q || e[9] !== L || e[10] !== $ || e[11] !== n || e[12] !== E ? (le = $ ? (L ? E : Q) ?? [] : n, e[8] = Q, e[9] = L, e[10] = $, e[11] = n, e[12] = E, e[13] = le) : le = e[13];
  const ge = le;
  let j;
  e[14] !== ge ? (j = function(vt) {
    return ge.find((Ft) => Ft.value === vt) ?? {
      value: vt,
      label: vt
    };
  }, e[14] = ge, e[15] = j) : j = e[15];
  const ee = j;
  let Y, Z;
  e[16] !== pe || e[17] !== $ || e[18] !== n || e[19] !== ee ? (Y = pe.map(ee), Z = $ ? [...n, ...Y.filter((gt) => !n.some((vt) => vt.value === gt.value))] : n, e[16] = pe, e[17] = $, e[18] = n, e[19] = ee, e[20] = Y, e[21] = Z) : (Y = e[20], Z = e[21]);
  const ue = Z;
  let fe;
  e[22] !== pe ? (fe = {
    items: pe
  }, e[22] = pe, e[23] = fe) : fe = e[23];
  const {
    containerRef: be,
    measuringContainerRef: Ie,
    itemRefs: ye,
    overflowRefs: xe,
    visibleItems: de,
    overflowCount: Se
  } = Jd(fe);
  let Me;
  e[24] !== L || e[25] !== r || e[26] !== n || e[27] !== ge ? (Me = function(vt) {
    const Ft = vt.map(MP), Un = Ft.flatMap((ir) => ge.find((Ni) => Ni.value === ir) ?? n.find((Ni) => Ni.value === ir) ?? []);
    L || (G(Ft), U(Un)), r?.(Ft, Un);
  }, e[24] = L, e[25] = r, e[26] = n, e[27] = ge, e[28] = Me) : Me = e[28];
  const Re = Me;
  let Ve;
  e[29] !== oe || e[30] !== z ? (Ve = function(vt, Ft) {
    if (z || ie(vt), vt === "") {
      oe("", !0);
      return;
    }
    Ft !== "item-press" && oe(vt, z);
  }, e[29] = oe, e[30] = z, e[31] = Ve) : Ve = e[31];
  const Ze = Ve;
  let Xe;
  e[32] !== a || e[33] !== u || e[34] !== c ? (Xe = a && /* @__PURE__ */ g(yi, { label: a, required: u, tooltip: c }), e[32] = a, e[33] = u, e[34] = c, e[35] = Xe) : Xe = e[35];
  let Be;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Be = (gt, vt) => {
    if (!gt && vt.reason === "item-press") {
      vt.cancel();
      return;
    }
    te(gt);
  }, e[36] = Be) : Be = e[36];
  const Ne = $ ? null : void 0;
  let _e;
  e[37] !== B || e[38] !== $ || e[39] !== n ? (_e = $ ? B ? [] : n : void 0, e[37] = B, e[38] = $, e[39] = n, e[40] = _e) : _e = e[40];
  let Pe;
  e[41] !== Ze ? (Pe = (gt, vt) => Ze(gt, vt.reason), e[41] = Ze, e[42] = Pe) : Pe = e[42];
  let $e;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? ($e = /* @__PURE__ */ g("div", {}), e[43] = $e) : $e = e[43];
  let He;
  e[44] !== p || e[45] !== V || e[46] !== N ? (He = ne(SP({
    size: N
  }), p ? "opacity-50 cursor-not-allowed" : "cursor-pointer", !V && "data-[readonly]:border-input-readonly-outline", V && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[44] = p, e[45] = V, e[46] = N, e[47] = He) : He = e[47];
  const Te = u || void 0, Rt = I ? -1 : void 0;
  let rt;
  e[48] !== I ? (rt = (gt) => {
    I && gt.preventDefault();
  }, e[48] = I, e[49] = rt) : rt = e[49];
  let Ce;
  e[50] !== pe.length || e[51] !== p || e[52] !== Se || e[53] !== I || e[54] !== ee || e[55] !== de ? (Ce = pe.length > 0 && /* @__PURE__ */ F(_t, { children: [
    de.map((gt) => I ? /* @__PURE__ */ g(Wn, { label: ee(gt).label, tone: "neutral" }, gt) : /* @__PURE__ */ F(ob, { className: ne(fg), children: [
      /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: ee(gt).label }),
      !p && /* @__PURE__ */ g(rb, { className: "inline-flex shrink-0 cursor-pointer items-center text-icon-secondary rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", "aria-label": "Remove", onMouseDown: NP, children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }) })
    ] }, gt)),
    Se > 0 && /* @__PURE__ */ g(Wn, { label: `+${Se}`, tone: "neutral" })
  ] }), e[50] = pe.length, e[51] = p, e[52] = Se, e[53] = I, e[54] = ee, e[55] = de, e[56] = Ce) : Ce = e[56];
  const Ee = I ? a ?? "Select option" : a ? `Search ${a}` : "Search options", Ae = I ? -1 : void 0;
  let ze;
  e[57] !== I ? (ze = (gt) => {
    I && gt.preventDefault();
  }, e[57] = I, e[58] = ze) : ze = e[58];
  const it = !I && pe.length === 0 ? s : void 0;
  let Ye;
  e[59] !== p || e[60] !== Ee || e[61] !== Ae || e[62] !== ze || e[63] !== it ? (Ye = /* @__PURE__ */ g(_s, { "aria-label": Ee, className: "min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", disabled: p, tabIndex: Ae, onMouseDown: ze, placeholder: it }), e[59] = p, e[60] = Ee, e[61] = Ae, e[62] = ze, e[63] = it, e[64] = Ye) : Ye = e[64];
  let Qe;
  e[65] !== be || e[66] !== Ce || e[67] !== Ye ? (Qe = /* @__PURE__ */ F(nb, { ref: be, "data-multi-select-chips": "", className: "flex flex-1 min-w-0 items-center gap-(--spacing-4) cursor-[inherit]", children: [
    Ce,
    Ye
  ] }), e[65] = be, e[66] = Ce, e[67] = Ye, e[68] = Qe) : Qe = e[68];
  let Ge;
  e[69] !== p || e[70] !== ce || e[71] !== I ? (Ge = !p && !I && ce === "" && /* @__PURE__ */ g(t1, { className: "shrink-0 inline-flex items-center text-icon-secondary", "aria-label": "Clear all", onMouseDown: EP, children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }) }), e[69] = p, e[70] = ce, e[71] = I, e[72] = Ge) : Ge = e[72];
  let Ke;
  e[73] !== b || e[74] !== B || e[75] !== I ? (Ke = !I && /* @__PURE__ */ g("span", { "data-testid": b ? `${b}-trigger` : void 0, className: ne("shrink-0 text-input-text-default inline-flex pointer-events-none", !B && "transition-transform duration-200 [[data-popup-open]_&]:rotate-180"), children: B ? /* @__PURE__ */ g(uf, { size: "xs" }) : /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[73] = b, e[74] = B, e[75] = I, e[76] = Ke) : Ke = e[76];
  let Je;
  e[77] !== b || e[78] !== He || e[79] !== Te || e[80] !== Rt || e[81] !== rt || e[82] !== Qe || e[83] !== Ge || e[84] !== Ke ? (Je = /* @__PURE__ */ F(_a, { "data-testid": b, ref: O, render: $e, nativeButton: !1, className: He, "aria-required": Te, tabIndex: Rt, onMouseDown: rt, children: [
    Qe,
    Ge,
    Ke
  ] }), e[77] = b, e[78] = He, e[79] = Te, e[80] = Rt, e[81] = rt, e[82] = Qe, e[83] = Ge, e[84] = Ke, e[85] = Je) : Je = e[85];
  let lt;
  e[86] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (lt = pi({
    size: "auto"
  }), e[86] = lt) : lt = e[86];
  const pt = B || void 0, ht = b ? `${b}-options` : void 0;
  let It;
  e[87] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (It = (gt) => {
    gt.key === "Escape" && te(!1);
  }, e[87] = It) : It = e[87];
  let ot;
  e[88] !== pe ? (ot = (gt) => {
    const vt = pe.includes(gt.value);
    return /* @__PURE__ */ g(As, { value: gt, disabled: gt.disabled, className: bo({}), children: /* @__PURE__ */ g(xr, { checked: vt, checkbox: !0, children: gt.label }) }, gt.value);
  }, e[88] = pe, e[89] = ot) : ot = e[89];
  let Pt;
  e[90] !== pt || e[91] !== ht || e[92] !== ot ? (Pt = /* @__PURE__ */ g(Vs, { "aria-busy": pt, "data-testid": ht, className: "flex flex-col outline-none", onKeyDownCapture: It, children: ot }), e[90] = pt, e[91] = ht, e[92] = ot, e[93] = Pt) : Pt = e[93];
  let un;
  e[94] !== B ? (un = /* @__PURE__ */ g(RP, { loading: B }), e[94] = B, e[95] = un) : un = e[95];
  let jt;
  e[96] !== Pt || e[97] !== un ? (jt = /* @__PURE__ */ g(Aa, { anchor: O, align: "start", sideOffset: 4, className: "z-[var(--z-layer-popover)] w-(--anchor-width)", children: /* @__PURE__ */ F(La, { className: lt, children: [
    Pt,
    un
  ] }) }), e[96] = Pt, e[97] = un, e[98] = jt) : jt = e[98];
  let rn;
  e[99] !== D || e[100] !== jt ? (rn = /* @__PURE__ */ g(Va, { container: D, children: jt }), e[99] = D, e[100] = jt, e[101] = rn) : rn = e[101];
  let tn;
  if (e[102] !== ye || e[103] !== pe || e[104] !== p || e[105] !== I || e[106] !== ee) {
    let gt;
    e[108] !== ye || e[109] !== p || e[110] !== I || e[111] !== ee ? (gt = (vt, Ft) => /* @__PURE__ */ g("span", { ref: (Un) => {
      ye.current[Ft] = Un;
    }, "data-label": ee(vt).label, "data-multi-select-measure": "chip", "data-multi-select-measure-index": Ft, className: ne(fg, "max-w-none before:content-[attr(data-label)]"), children: !p && !I && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center text-icon-secondary", children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }) }) }, `chip-measure-${vt}`), e[108] = ye, e[109] = p, e[110] = I, e[111] = ee, e[112] = gt) : gt = e[112], tn = pe.map(gt), e[102] = ye, e[103] = pe, e[104] = p, e[105] = I, e[106] = ee, e[107] = tn;
  } else
    tn = e[107];
  let nn;
  if (e[113] !== pe || e[114] !== xe) {
    let gt;
    e[116] !== xe ? (gt = (vt, Ft) => {
      const Un = Ft + 1;
      return /* @__PURE__ */ g("span", { ref: (ir) => {
        xe.current[Un] = ir;
      }, "data-label": `+${Un}`, "data-multi-select-measure": "overflow", "data-multi-select-measure-count": Un, className: "inline-flex items-center justify-center max-w-none gap-(--spacing-4) h-(--spacing-24) rounded-(--radius-sm) overflow-hidden font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-20) font-(--font-weight-medium) whitespace-nowrap bg-chip-neutral-container text-chip-neutral-label px-(--spacing-6) py-(--spacing-4) before:content-[attr(data-label)]" }, `overflow-measure-${Un}`);
    }, e[116] = xe, e[117] = gt) : gt = e[117], nn = pe.slice(1).map(gt), e[113] = pe, e[114] = xe, e[115] = nn;
  } else
    nn = e[115];
  let Ht;
  e[118] !== Ie || e[119] !== tn || e[120] !== nn ? (Ht = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ F("div", { ref: Ie, className: "inline-flex w-max items-center gap-(--spacing-4)", children: [
    tn,
    nn
  ] }) }), e[118] = Ie, e[119] = tn, e[120] = nn, e[121] = Ht) : Ht = e[121];
  let dn;
  e[122] !== ue || e[123] !== p || e[124] !== Re || e[125] !== ce || e[126] !== re || e[127] !== h || e[128] !== I || e[129] !== u || e[130] !== Y || e[131] !== Ne || e[132] !== _e || e[133] !== Pe || e[134] !== Je || e[135] !== rn || e[136] !== Ht ? (dn = /* @__PURE__ */ F(Uf, { multiple: !0, value: Y, onValueChange: Re, disabled: p, readOnly: I, required: u, name: h, modal: !1, open: re, onOpenChange: Be, items: ue, filter: Ne, filteredItems: _e, inputValue: ce, onInputValueChange: Pe, isItemEqualToValue: PP, itemToStringLabel: IP, itemToStringValue: kP, children: [
    Je,
    rn,
    Ht
  ] }), e[122] = ue, e[123] = p, e[124] = Re, e[125] = ce, e[126] = re, e[127] = h, e[128] = I, e[129] = u, e[130] = Y, e[131] = Ne, e[132] = _e, e[133] = Pe, e[134] = Je, e[135] = rn, e[136] = Ht, e[137] = dn) : dn = e[137];
  let Vt;
  e[138] !== d || e[139] !== f || e[140] !== V || e[141] !== M || e[142] !== A ? (Vt = A && /* @__PURE__ */ g("div", { "data-testid": "multi-select-subtext-row", className: ne("mt-(--spacing-4)", M && "min-h-(--spacing-20)"), children: V ? /* @__PURE__ */ g(Ar, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: f }) : d ? /* @__PURE__ */ g(bi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: d }) : null }), e[138] = d, e[139] = f, e[140] = V, e[141] = M, e[142] = A, e[143] = Vt) : Vt = e[143];
  let gn;
  return e[144] !== p || e[145] !== V || e[146] !== Xe || e[147] !== dn || e[148] !== Vt ? (gn = /* @__PURE__ */ F(Vr, { invalid: V, disabled: p, className: "relative flex flex-col w-full", children: [
    Xe,
    dn,
    Vt
  ] }), e[144] = p, e[145] = V, e[146] = Xe, e[147] = dn, e[148] = Vt, e[149] = gn) : gn = e[149], gn;
}
function EP(t) {
  return t.stopPropagation();
}
function NP(t) {
  return t.stopPropagation();
}
function kP(t) {
  return t.value;
}
function IP(t) {
  return t.label;
}
function PP(t, e) {
  return t.value === e.value;
}
function MP(t) {
  return t.value;
}
const TP = [10, 25, 50, 100], s3 = {
  rowsPerPage: "Rows per page",
  ariaLabel: "Table pagination",
  previousPage: "Previous page",
  nextPage: "Next page",
  formatCurrentPageLabel: (t) => `Page ${t}, current page`,
  formatGoToPageLabel: (t) => `Go to page ${t}`,
  formatRange: (t, e, n) => `${t} - ${e} of ${n}`
};
function OP(t) {
  return t ?? s3;
}
function Jo(t, e) {
  return Number.isFinite(t) && t > 0 ? Math.floor(t) : e;
}
function Ei(t, e) {
  const n = Jo(e, 1), o = Jo(t, 1);
  return Math.min(Math.max(o, 1), n);
}
function l3(t, e) {
  const n = Jo(e, 1), o = Ei(t, n);
  return n === 1 ? "none" : o === 1 ? "right" : o === n ? "left" : "both";
}
function DP(t, e) {
  const n = Jo(e, 1), o = Ei(t, n);
  return n <= 4 ? Array.from({
    length: n
  }, (r, i) => ({
    type: "page",
    page: i + 1
  })) : o <= 3 ? [{
    type: "page",
    page: 1
  }, {
    type: "page",
    page: 2
  }, {
    type: "page",
    page: 3
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }] : o >= n - 2 ? [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: n - 2
  }, {
    type: "page",
    page: n - 1
  }, {
    type: "page",
    page: n
  }] : [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: o - 1
  }, {
    type: "page",
    page: o
  }, {
    type: "page",
    page: o + 1
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }];
}
function _P({
  currentPage: t,
  rowsPerPage: e,
  totalItems: n,
  totalPages: o,
  formatRange: r
}) {
  const i = Math.max(0, Math.floor(n)), s = r ?? s3.formatRange;
  if (i === 0)
    return s(0, 0, 0);
  const l = Jo(e, i), a = Ei(t, o), c = (a - 1) * l + 1, u = Math.min(a * l, i);
  return s(c, u, i);
}
function oa(t) {
  const e = W.c(11), {
    direction: n,
    disabled: o,
    mobile: r,
    labels: i,
    onClick: s
  } = t, l = r === void 0 ? !1 : r, a = n === "previous", c = a ? i.previousPage : i.nextPage, u = l ? "size-[44px]" : "size-(--spacing-32)", d = o ? "cursor-default text-icon-disabled" : "cursor-pointer text-surface-on-surface hover:bg-surface-hover active:bg-surface-pressed";
  let f;
  e[0] !== u || e[1] !== d ? (f = ne("inline-flex shrink-0 items-center justify-center rounded-(--radius-sm) border-0 bg-transparent p-0 outline-none transition-colors duration-200 ease-in-out", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", u, d), e[0] = u, e[1] = d, e[2] = f) : f = e[2];
  const p = a ? "chevron-left" : "chevron-right";
  let m;
  e[3] !== p ? (m = /* @__PURE__ */ g(Ue, { name: p, size: "xs", tone: "inherit" }), e[3] = p, e[4] = m) : m = e[4];
  let h;
  return e[5] !== o || e[6] !== s || e[7] !== c || e[8] !== f || e[9] !== m ? (h = /* @__PURE__ */ g("button", { type: "button", "aria-label": c, disabled: o, onClick: s, className: f, children: m }), e[5] = o, e[6] = s, e[7] = c, e[8] = f, e[9] = m, e[10] = h) : h = e[10], h;
}
function mg(t) {
  const e = W.c(29), {
    currentPage: n,
    totalPages: o,
    labels: r,
    onPageChange: i,
    showPageIndicator: s
  } = t, l = s === void 0 ? !1 : s;
  let a, c, u;
  e[0] !== n || e[1] !== o ? (c = Jo(o, 1), a = Ei(n, c), u = l3(a, c), e[0] = n, e[1] = o, e[2] = a, e[3] = c, e[4] = u) : (a = e[2], c = e[3], u = e[4]);
  const d = u, f = d === "both" || d === "left", p = d === "both" || d === "right", m = !f;
  let h;
  e[5] !== i || e[6] !== a ? (h = () => i(a - 1), e[5] = i, e[6] = a, e[7] = h) : h = e[7];
  let b;
  e[8] !== r || e[9] !== m || e[10] !== h ? (b = /* @__PURE__ */ g(oa, { direction: "previous", disabled: m, labels: r, onClick: h }), e[8] = r, e[9] = m, e[10] = h, e[11] = b) : b = e[11];
  let v;
  e[12] !== r || e[13] !== i || e[14] !== a || e[15] !== c || e[16] !== l ? (v = l && /* @__PURE__ */ g(VP, { currentPage: a, totalPages: c, labels: r, onPageChange: i }), e[12] = r, e[13] = i, e[14] = a, e[15] = c, e[16] = l, e[17] = v) : v = e[17];
  const C = !p;
  let y;
  e[18] !== i || e[19] !== a ? (y = () => i(a + 1), e[18] = i, e[19] = a, e[20] = y) : y = e[20];
  let w;
  e[21] !== r || e[22] !== C || e[23] !== y ? (w = /* @__PURE__ */ g(oa, { direction: "next", disabled: C, labels: r, onClick: y }), e[21] = r, e[22] = C, e[23] = y, e[24] = w) : w = e[24];
  let R;
  return e[25] !== b || e[26] !== v || e[27] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-center gap-(--spacing-12)", children: [
    b,
    v,
    w
  ] }), e[25] = b, e[26] = v, e[27] = w, e[28] = R) : R = e[28], R;
}
function VP(t) {
  const e = W.c(11), {
    currentPage: n,
    totalPages: o,
    labels: r,
    onPageChange: i
  } = t;
  let s;
  if (e[0] !== n || e[1] !== r || e[2] !== i || e[3] !== o) {
    let a;
    e[5] !== n || e[6] !== r || e[7] !== i ? (a = (c) => {
      if (c.type === "ellipsis")
        return /* @__PURE__ */ g(AP, {}, c.key);
      const u = c.page === n;
      return /* @__PURE__ */ g("button", { type: "button", "aria-label": u ? r.formatCurrentPageLabel(c.page) : r.formatGoToPageLabel(c.page), "aria-current": u ? "page" : void 0, onClick: () => i(c.page), className: ne("inline-flex min-w-(--spacing-20) items-center justify-center rounded-(--radius-sm) px-(--spacing-6) py-(--spacing-2)", "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20)", "outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", u ? "bg-primary text-primary-on-primary" : "cursor-pointer text-text-subtle hover:bg-surface-hover active:bg-surface-pressed"), children: c.page }, c.page);
    }, e[5] = n, e[6] = r, e[7] = i, e[8] = a) : a = e[8], s = DP(n, o).map(a), e[0] = n, e[1] = r, e[2] = i, e[3] = o, e[4] = s;
  } else
    s = e[4];
  let l;
  return e[9] !== s ? (l = /* @__PURE__ */ g("div", { className: "flex items-center justify-center gap-(--spacing-10)", children: s }), e[9] = s, e[10] = l) : l = e[10], l;
}
function AP() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("span", { className: "select-none whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-default", children: "..." }), t[0] = e) : e = t[0], e;
}
function LP(t) {
  const e = W.c(17), {
    selectId: n,
    rowsPerPage: o,
    rowsPerPageOptions: r,
    rowsPerPageLabel: i,
    disabled: s,
    onRowsPerPageChange: l,
    onPageChange: a
  } = t, c = s === void 0 ? !1 : s;
  let u;
  e[0] !== i || e[1] !== n ? (u = /* @__PURE__ */ g("label", { htmlFor: n, className: "whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: i }), e[0] = i, e[1] = n, e[2] = u) : u = e[2];
  const d = String(o);
  let f;
  e[3] !== r ? (f = r.map(FP), e[3] = r, e[4] = f) : f = e[4];
  let p;
  e[5] !== a || e[6] !== l ? (p = (b) => {
    b != null && (l(Number(b)), a(1));
  }, e[5] = a, e[6] = l, e[7] = p) : p = e[7];
  let m;
  e[8] !== c || e[9] !== n || e[10] !== d || e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ g("div", { className: "h-(--spacing-32) w-(--spacing-80) shrink-0", children: /* @__PURE__ */ g(n1, { id: n, size: "sm", value: d, disabled: c, reserveSubtextSpace: !1, options: f, onChange: p }) }), e[8] = c, e[9] = n, e[10] = d, e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  let h;
  return e[14] !== u || e[15] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex h-(--spacing-40) w-[188px] shrink-0 items-center justify-between gap-(--spacing-12)", children: [
    u,
    m
  ] }), e[14] = u, e[15] = m, e[16] = h) : h = e[16], h;
}
function FP(t) {
  return {
    value: String(t),
    label: String(t)
  };
}
function $P(t) {
  const e = W.c(24), {
    rangeLabel: n,
    currentPage: o,
    totalPages: r,
    labels: i,
    onPageChange: s
  } = t;
  let l, a;
  if (e[0] !== o || e[1] !== r) {
    const w = Jo(r, 1);
    l = Ei(o, w), a = l3(l, w), e[0] = o, e[1] = r, e[2] = l, e[3] = a;
  } else
    l = e[2], a = e[3];
  const c = a, u = c === "both" || c === "left", d = c === "both" || c === "right", f = !u;
  let p;
  e[4] !== s || e[5] !== l ? (p = () => s(l - 1), e[4] = s, e[5] = l, e[6] = p) : p = e[6];
  let m;
  e[7] !== i || e[8] !== f || e[9] !== p ? (m = /* @__PURE__ */ g(oa, { direction: "previous", mobile: !0, disabled: f, labels: i, onClick: p }), e[7] = i, e[8] = f, e[9] = p, e[10] = m) : m = e[10];
  let h;
  e[11] !== n ? (h = /* @__PURE__ */ g("span", { className: "min-w-0 truncate px-(--spacing-12) text-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = h) : h = e[12];
  const b = !d;
  let v;
  e[13] !== s || e[14] !== l ? (v = () => s(l + 1), e[13] = s, e[14] = l, e[15] = v) : v = e[15];
  let C;
  e[16] !== i || e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ g(oa, { direction: "next", mobile: !0, disabled: b, labels: i, onClick: v }), e[16] = i, e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  return e[20] !== m || e[21] !== h || e[22] !== C ? (y = /* @__PURE__ */ F("div", { className: "hidden h-[44px] w-full items-center justify-between px-(--spacing-16) @max-[600px]/pagination:flex", children: [
    m,
    h,
    C
  ] }), e[20] = m, e[21] = h, e[22] = C, e[23] = y) : y = e[23], y;
}
function HP(t) {
  const e = W.c(33), {
    currentPage: n,
    totalPages: o,
    totalItems: r,
    rowsPerPage: i,
    onPageChange: s,
    labels: l
  } = t, a = $t();
  let c, u, d, f, p;
  e[0] !== n || e[1] !== l || e[2] !== i || e[3] !== r || e[4] !== o ? (c = OP(l), f = Jo(o, 1), d = Ei(n, f), u = r <= 0, p = _P({
    currentPage: d,
    rowsPerPage: i,
    totalItems: r,
    totalPages: f,
    formatRange: c.formatRange
  }), e[0] = n, e[1] = l, e[2] = i, e[3] = r, e[4] = o, e[5] = c, e[6] = u, e[7] = d, e[8] = f, e[9] = p) : (c = e[5], u = e[6], d = e[7], f = e[8], p = e[9]);
  const m = p;
  let h;
  e[10] !== s || e[11] !== m || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ g($P, { rangeLabel: m, currentPage: d, totalPages: f, labels: c, onPageChange: s }), e[10] = s, e[11] = m, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== s || e[17] !== t.contextLabel || e[18] !== t.onRowsPerPageChange || e[19] !== t.rowsPerPageOptions || e[20] !== t.variant || e[21] !== m || e[22] !== c || e[23] !== i || e[24] !== u || e[25] !== a || e[26] !== d || e[27] !== f ? (b = t.variant === "simplified" ? /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) @min-[600px]/pagination:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: t.contextLabel }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(mg, { currentPage: d, totalPages: f, labels: c, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "h-(--spacing-40) flex-1" })
  ] }) : /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) @min-[600px]/pagination:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: m }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(mg, { currentPage: d, totalPages: f, labels: c, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ g(LP, { selectId: a, rowsPerPage: i, rowsPerPageOptions: t.rowsPerPageOptions ?? TP, rowsPerPageLabel: c.rowsPerPage, disabled: u, onRowsPerPageChange: t.onRowsPerPageChange, onPageChange: s }) })
  ] }), e[16] = s, e[17] = t.contextLabel, e[18] = t.onRowsPerPageChange, e[19] = t.rowsPerPageOptions, e[20] = t.variant, e[21] = m, e[22] = c, e[23] = i, e[24] = u, e[25] = a, e[26] = d, e[27] = f, e[28] = b) : b = e[28];
  let v;
  return e[29] !== c.ariaLabel || e[30] !== h || e[31] !== b ? (v = /* @__PURE__ */ F("nav", { "aria-label": c.ariaLabel, className: "@container/pagination w-full", children: [
    h,
    b
  ] }), e[29] = c.ariaLabel, e[30] = h, e[31] = b, e[32] = v) : v = e[32], v;
}
const gg = /* @__PURE__ */ new Map();
function zP(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = gg.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return gg.set(n, r), r;
}
function hg(t, e, n) {
  return t == null ? "" : zP(e, n).format(t);
}
function BP(t, e, n) {
  return t == null ? "" : n ? hg(t, e, n) : hg(t / 100, e, {
    style: "percent"
  });
}
const R1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (R1.displayName = "ProgressRootContext");
function a3() {
  const t = x.useContext(R1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : st(51));
  return t;
}
let _c = /* @__PURE__ */ (function(t) {
  return t.complete = "data-complete", t.indeterminate = "data-indeterminate", t.progressing = "data-progressing", t;
})({});
const E1 = {
  status(t) {
    return t === "progressing" ? {
      [_c.progressing]: ""
    } : t === "complete" ? {
      [_c.complete]: ""
    } : t === "indeterminate" ? {
      [_c.indeterminate]: ""
    } : null;
  }
};
function WP(t, e) {
  return e == null ? "indeterminate progress" : t || `${e}%`;
}
const N1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    format: o,
    getAriaValueText: r = WP,
    locale: i,
    max: s = 100,
    min: l = 0,
    value: a,
    render: c,
    className: u,
    children: d,
    style: f,
    ...p
  } = e, [m, h] = x.useState(), b = Yt(o);
  let v = "indeterminate";
  Number.isFinite(a) && (v = a === s ? "complete" : "progressing");
  const C = BP(a, i, b.current), y = x.useMemo(() => ({
    status: v
  }), [v]), w = {
    "aria-labelledby": m,
    "aria-valuemax": s,
    "aria-valuemin": l,
    "aria-valuenow": a ?? void 0,
    "aria-valuetext": r(C, a),
    role: "progressbar",
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [d, /* @__PURE__ */ g("span", {
        role: "presentation",
        style: nr,
        children: "x"
      })]
    })
  }, R = x.useMemo(() => ({
    formattedValue: C,
    max: s,
    min: l,
    setLabelId: h,
    state: y,
    status: v,
    value: a
  }), [C, s, l, h, y, v, a]), S = Le("div", e, {
    state: y,
    ref: n,
    props: [w, p],
    stateAttributesMapping: E1
  });
  return /* @__PURE__ */ g(R1.Provider, {
    value: R,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (N1.displayName = "ProgressRoot");
const c3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = a3();
  return Le("div", e, {
    state: l,
    ref: n,
    props: s,
    stateAttributesMapping: E1
  });
});
process.env.NODE_ENV !== "production" && (c3.displayName = "ProgressTrack");
function UP(t, e, n) {
  return (t - e) * 100 / (n - e);
}
const u3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    max: l,
    min: a,
    value: c,
    state: u
  } = a3(), d = Number.isFinite(c) && c !== null ? UP(c, a, l) : null, f = x.useCallback(() => d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  }, [d]);
  return Le("div", e, {
    state: u,
    ref: n,
    props: [{
      style: f()
    }, s],
    stateAttributesMapping: E1
  });
});
process.env.NODE_ENV !== "production" && (u3.displayName = "ProgressIndicator");
const GP = {
  sm: "2px",
  md: "4px",
  lg: "8px"
}, YP = {
  brand: "bg-primary",
  positive: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  negative: "bg-datavis-crit-red"
};
function c_(t) {
  const e = W.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    value: l,
    size: i,
    tone: s,
    "aria-label": n,
    "aria-labelledby": o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "md" : i, c = s === void 0 ? "brand" : s;
  let u;
  e[7] !== l ? (u = Number.isFinite(l) ? Math.min(100, Math.max(0, l)) : 0, e[7] = l, e[8] = u) : u = e[8];
  const d = u, f = GP[a];
  let p;
  e[9] !== f ? (p = {
    height: f
  }, e[9] = f, e[10] = p) : p = e[10];
  const m = `absolute ${YP[c]}`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g(u3, { className: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  e[13] !== p || e[14] !== h ? (b = /* @__PURE__ */ g(c3, { className: "relative w-full overflow-hidden bg-[hsl(var(--surface-inverse-surface)/0.2)]", style: p, children: h }), e[13] = p, e[14] = h, e[15] = b) : b = e[15];
  let v;
  return e[16] !== n || e[17] !== o || e[18] !== d || e[19] !== r || e[20] !== b ? (v = /* @__PURE__ */ g(N1, { ...r, value: d, "aria-label": n, "aria-labelledby": o, children: b }), e[16] = n, e[17] = o, e[18] = d, e[19] = r, e[20] = b, e[21] = v) : v = e[21], v;
}
const jP = {
  sm: {
    diameter: 16,
    stroke: 3
  },
  md: {
    diameter: 36,
    stroke: 5
  },
  lg: {
    diameter: 56,
    stroke: 7
  }
}, KP = {
  brand: "stroke-primary",
  positive: "stroke-datavis-crit-green",
  warning: "stroke-datavis-crit-yellow",
  negative: "stroke-datavis-crit-red"
};
function u_(t) {
  const e = W.c(40);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    value: a,
    size: s,
    tone: l,
    "aria-label": n,
    "aria-labelledby": o,
    style: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "md" : s, u = l === void 0 ? "brand" : l;
  let d;
  e[8] !== a ? (d = Number.isFinite(a) ? Math.min(100, Math.max(0, a)) : 0, e[8] = a, e[9] = d) : d = e[9];
  const f = d, {
    diameter: p,
    stroke: m
  } = jP[c], h = (p - m) / 2, b = 2 * Math.PI * h, v = b * (1 - f / 100), C = p / 2;
  let y;
  e[10] !== p ? (y = {
    display: "inline-flex",
    width: p,
    height: p
  }, e[10] = p, e[11] = y) : y = e[11];
  const w = y;
  let R;
  e[12] !== w || e[13] !== i ? (R = typeof i == "function" ? (V) => ({
    ...i(V),
    ...w
  }) : {
    ...i,
    ...w
  }, e[12] = w, e[13] = i, e[14] = R) : R = e[14];
  const S = R, E = `0 0 ${p} ${p}`;
  let N;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = {
    stroke: "hsl(var(--surface-inverse-surface) / 0.2)"
  }, e[15] = N) : N = e[15];
  let I;
  e[16] !== C || e[17] !== h || e[18] !== m ? (I = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", style: N }), e[16] = C, e[17] = h, e[18] = m, e[19] = I) : I = e[19];
  const M = `${b} ${b}`, T = KP[u];
  let k;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = {
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%"
  }, e[20] = k) : k = e[20];
  let P;
  e[21] !== C || e[22] !== v || e[23] !== h || e[24] !== m || e[25] !== T || e[26] !== M ? (P = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", strokeDasharray: M, strokeDashoffset: v, className: T, style: k }), e[21] = C, e[22] = v, e[23] = h, e[24] = m, e[25] = T, e[26] = M, e[27] = P) : P = e[27];
  let D;
  e[28] !== p || e[29] !== P || e[30] !== E || e[31] !== I ? (D = /* @__PURE__ */ F("svg", { width: p, height: p, viewBox: E, fill: "none", "aria-hidden": "true", children: [
    I,
    P
  ] }), e[28] = p, e[29] = P, e[30] = E, e[31] = I, e[32] = D) : D = e[32];
  let O;
  return e[33] !== n || e[34] !== o || e[35] !== f || e[36] !== r || e[37] !== S || e[38] !== D ? (O = /* @__PURE__ */ g(N1, { ...r, value: f, "aria-label": n, "aria-labelledby": o, style: S, children: D }), e[33] = n, e[34] = o, e[35] = f, e[36] = r, e[37] = S, e[38] = D, e[39] = O) : O = e[39], O;
}
let bg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const Ru = {
  checked(t) {
    return t ? {
      [bg.checked]: ""
    } : {
      [bg.unchecked]: ""
    };
  },
  ...Kt,
  ...io
}, k1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (k1.displayName = "RadioGroupContext");
function qP() {
  return x.useContext(k1);
}
const I1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (I1.displayName = "RadioRootContext");
function ZP() {
  const t = x.useContext(I1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : st(52));
  return t;
}
const d3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    readOnly: s = !1,
    required: l = !1,
    "aria-labelledby": a,
    value: c,
    inputRef: u,
    nativeButton: d = !1,
    id: f,
    style: p,
    ...m
  } = e, h = qP(), {
    disabled: b,
    readOnly: v,
    required: C,
    form: y,
    checkedValue: w,
    touched: R = !1,
    validation: S,
    name: E
  } = h ?? {}, N = h?.setCheckedValue ?? Ct, I = h?.setTouched ?? Ct, M = h?.registerControlRef ?? Ct, T = h?.registerInputRef ?? Ct, {
    setDirty: k,
    validityData: P,
    setTouched: D,
    setFilled: O,
    state: V,
    disabled: _
  } = mn(), A = q2(), {
    labelId: L,
    getDescriptionProps: $
  } = Nn(), B = _ || A.disabled || b || i, z = v || s, H = C || l, K = y, G = h ? w === c : c === "", q = x.useMemo(() => Jl(c), [c]), Q = x.useRef(null), U = x.useRef(null), X = we((ue) => {
    ue && M(ue, B);
  }), te = Rn(u, U, T);
  ke(() => {
    U.current?.checked && O(!0);
  }, [O]), ke(() => {
    if (U.current) {
      if (B && G) {
        T(null);
        return;
      }
      Q.current && M(Q.current, B), T(U.current);
    }
  }, [G, B, M, T]);
  const re = Ot(), J = _r({
    id: f,
    implicit: !1,
    controlRef: Q
  }), ie = d ? void 0 : J, ce = af(a, L, U, !d, ie), oe = {
    role: "radio",
    "aria-checked": G,
    "aria-required": H || void 0,
    "aria-readonly": z || void 0,
    "aria-labelledby": ce,
    [y1]: G ? "" : void 0,
    id: d ? J : re,
    onKeyDown(ue) {
      ue.key === "Enter" && ue.preventDefault();
    },
    onClick(ue) {
      ue.defaultPrevented || B || z || (ue.preventDefault(), U.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ue.shiftKey,
        ctrlKey: ue.ctrlKey,
        altKey: ue.altKey,
        metaKey: ue.metaKey
      })));
    },
    onFocus(ue) {
      ue.defaultPrevented || B || z || !R || (U.current?.click(), I(!1));
    }
  }, {
    getButtonProps: se,
    buttonRef: me
  } = qt({
    disabled: B,
    native: d
  }), pe = {
    type: "radio",
    ref: te,
    form: K,
    id: ie,
    name: E,
    tabIndex: -1,
    style: E ? ii : nr,
    "aria-hidden": !0,
    ...c !== void 0 ? {
      value: q
    } : Et,
    disabled: B,
    checked: G,
    required: H,
    readOnly: z,
    onChange(ue) {
      if (ue.nativeEvent.defaultPrevented || B || z || c === void 0)
        return;
      const fe = De(At, ue.nativeEvent);
      fe.isCanceled || (D(!0), k(c !== P.initialValue), O(!0), N(c, fe));
    },
    onFocus() {
      Q.current?.focus();
    }
  }, le = x.useMemo(() => ({
    ...V,
    required: H,
    disabled: B,
    readOnly: z,
    checked: G
  }), [V, B, z, G, H]), ge = le, j = h !== void 0, ee = [n, Q, me, X], Y = [oe, $, S?.getValidationProps ?? Et, m, se], Z = Le("span", e, {
    enabled: !j,
    state: le,
    ref: ee,
    props: Y,
    stateAttributesMapping: Ru
  });
  return /* @__PURE__ */ F(I1.Provider, {
    value: ge,
    children: [j ? /* @__PURE__ */ g(Ad, {
      tag: "span",
      render: o,
      className: r,
      style: p,
      state: le,
      refs: ee,
      props: Y,
      stateAttributesMapping: Ru
    }) : Z, /* @__PURE__ */ g("input", {
      ...pe,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (d3.displayName = "RadioRoot");
const f3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = ZP(), c = a.checked, {
    mounted: u,
    transitionStatus: d,
    setMounted: f
  } = to(c), p = {
    ...a,
    transitionStatus: d
  }, m = x.useRef(null), h = s || u, b = Le("span", e, {
    ref: [n, m],
    state: p,
    props: l,
    stateAttributesMapping: Ru
  });
  return Jt({
    open: c,
    ref: m,
    onComplete() {
      c || f(!1);
    }
  }), h ? b : null;
});
process.env.NODE_ENV !== "production" && (f3.displayName = "RadioIndicator");
const XP = [a2], p3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i,
    readOnly: s,
    required: l,
    onValueChange: a,
    value: c,
    defaultValue: u,
    form: d,
    name: f,
    inputRef: p,
    id: m,
    style: h,
    ...b
  } = e, {
    setTouched: v,
    setFocused: C,
    shouldValidateOnChange: y,
    validationMode: w,
    name: R,
    disabled: S,
    state: E,
    validation: N,
    setDirty: I,
    setFilled: M,
    validityData: T
  } = mn(), {
    labelId: k
  } = Nn(), {
    clearErrors: P
  } = Fo(), D = W2(!0), O = S || i, V = R ?? f, _ = Ot(m), [A, L] = Sn({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), $ = we(a), B = we((oe, se) => {
    $(oe, se), !se.isCanceled && L(oe);
  }), z = x.useRef(null), H = x.useRef(null), K = x.useRef(null);
  function G(oe) {
    let se;
    return p && (typeof p == "function" ? se = p(oe) : p.current = oe), H.current = oe, N.inputRef.current = oe, se;
  }
  const q = we((oe, se = !1) => {
    if (oe) {
      if (se) {
        z.current === oe && (z.current = null);
        return;
      }
      z.current == null && (z.current = oe);
    }
  }), Q = we((oe) => {
    if (!oe || oe.disabled)
      return;
    K.current || (K.current = oe);
    const se = H.current;
    if (oe.checked || se == null || se.disabled)
      return G(oe);
  }), U = we(() => A ?? null);
  vi(z, {
    id: _,
    value: A,
    getValue: U
  }), ko(A, () => {
    P(V), I(A !== T.initialValue), M(A != null), y() ? N.commit(A) : N.commit(A, !0);
    const oe = K.current;
    A == null && oe && !oe.disabled && G(oe);
  });
  const [X, te] = x.useState(!1), re = b["aria-labelledby"] ?? k ?? D?.legendId, J = {
    ...E,
    disabled: O ?? !1,
    required: l ?? !1,
    readOnly: s ?? !1
  }, ie = x.useMemo(() => ({
    ...E,
    checkedValue: A,
    disabled: O,
    form: d,
    validation: N,
    name: V,
    onValueChange: $,
    readOnly: s,
    registerControlRef: q,
    registerInputRef: Q,
    required: l,
    setCheckedValue: B,
    setTouched: te,
    touched: X
  }), [A, O, d, N, E, V, $, s, q, Q, l, B, te, X]), ce = {
    role: "radiogroup",
    "aria-required": l || void 0,
    "aria-disabled": O || void 0,
    "aria-readonly": s || void 0,
    "aria-labelledby": re,
    onFocus() {
      C(!0);
    },
    onBlur(oe) {
      Fe(oe.currentTarget, oe.relatedTarget) || (v(!0), C(!1), w === "onBlur" && N.commit(A));
    },
    onKeyDownCapture(oe) {
      oe.key.startsWith("Arrow") && (v(!0), te(!0), C(!0));
    }
  };
  return /* @__PURE__ */ g(k1.Provider, {
    value: ie,
    children: /* @__PURE__ */ g(o3, {
      render: o,
      className: r,
      style: h,
      state: J,
      props: [ce, N.getValidationProps, b],
      refs: [n],
      stateAttributesMapping: io,
      enableHomeAndEndKeys: !1,
      modifierKeys: XP
    })
  });
});
process.env.NODE_ENV !== "production" && (p3.displayName = "RadioGroup");
function QP() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M15 8C15 4.13438 11.8656 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
function JP() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16ZM8 1.5C4.40937 1.5 1.5 4.40937 1.5 8C1.5 11.5906 4.40937 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40937 11.5906 1.5 8 1.5ZM8 11C6.34375 11 5 9.65625 5 8C5 6.34375 6.34375 5 8 5C9.65625 5 11 6.34375 11 8C11 9.65625 9.65625 11 8 11Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const m3 = yo({}), eM = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "group",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1.5px]",
  "focus-visible:ring-radio-focus-ring",
  "cursor-[inherit]",
  // coarse touch target
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), tM = ae(["absolute", "inset-0", "rounded-full", "flex", "items-center", "justify-center", "[[data-checked]_&]:hidden", "group-hover:bg-radio-outline-hover-background", "group-active:bg-radio-outline-pressed-background"]), nM = ae(["flex", "items-center", "justify-center", "text-radio-outline-default-border", "group-hover:text-radio-outline-hover-border", "group-active:text-radio-outline-pressed-border", "[[data-disabled]_&]:text-radio-outline-disabled-border", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), oM = ae(["flex", "items-center", "justify-center", "text-radio-filled-default-background", "group-hover:text-radio-filled-hover-background", "group-active:text-radio-filled-pressed-background", "[[data-disabled]_&]:text-radio-filled-disabled-background", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), g3 = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), rM = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), iM = ae(["flex", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), sM = ae([], {
  variants: {
    size: {
      sm: ["pl-[calc(var(--icon-sm)+var(--spacing-8))]"],
      md: ["pl-[calc(var(--icon-md)+var(--spacing-8))]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function d_(t) {
  const e = W.c(28);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: i,
    error: r,
    disabled: o,
    size: l,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "sm" : l, c = $t();
  let u;
  e[7] !== o || e[8] !== r || e[9] !== a ? (u = {
    error: r,
    disabled: o,
    size: a
  }, e[7] = o, e[8] = r, e[9] = a, e[10] = u) : u = e[10];
  let d;
  e[11] !== c || e[12] !== i ? (d = i && /* @__PURE__ */ g("span", { id: `${c}-label`, className: g3(), children: i }), e[11] = c, e[12] = i, e[13] = d) : d = e[13];
  const f = i ? `${c}-label` : s["aria-labelledby"], p = s["aria-label"], m = r || void 0, h = o || void 0;
  let b;
  e[14] !== n || e[15] !== o || e[16] !== s || e[17] !== f || e[18] !== p || e[19] !== m || e[20] !== h ? (b = /* @__PURE__ */ g(p3, { ...s, disabled: o, "aria-labelledby": f, "aria-label": p, "aria-invalid": m, "aria-disabled": h, className: "flex flex-col gap-(--spacing-8)", children: n }), e[14] = n, e[15] = o, e[16] = s, e[17] = f, e[18] = p, e[19] = m, e[20] = h, e[21] = b) : b = e[21];
  let v;
  e[22] !== d || e[23] !== b ? (v = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    d,
    b
  ] }), e[22] = d, e[23] = b, e[24] = v) : v = e[24];
  let C;
  return e[25] !== u || e[26] !== v ? (C = /* @__PURE__ */ g(m3, { value: u, children: v }), e[25] = u, e[26] = v, e[27] = C) : C = e[27], C;
}
function f_(t) {
  const e = W.c(53);
  let n, o, r, i;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const {
    error: s,
    disabled: l,
    size: a
  } = Cn(m3), c = l || o, u = $t();
  let d;
  e[5] !== n || e[6] !== u || e[7] !== i ? (d = [i["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[5] = n, e[6] = u, e[7] = i, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== c ? (p = iM({
    disabled: c
  }), e[9] = c, e[10] = p) : p = e[10];
  const m = r ? void 0 : i["aria-label"], h = r ? `${u}-label` : void 0, b = s ? "" : void 0;
  let v;
  e[11] !== i ? (v = (O) => {
    i.onKeyDown?.(O), !O.defaultPrevented && O.key === " " && (O.preventDefault(), O.currentTarget.click());
  }, e[11] = i, e[12] = v) : v = e[12];
  let C;
  e[13] !== a ? (C = ne(eM({
    size: a
  })), e[13] = a, e[14] = C) : C = e[14];
  let y;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = tM(), e[15] = y) : y = e[15];
  let w;
  e[16] !== a ? (w = nM({
    size: a
  }), e[16] = a, e[17] = w) : w = e[17];
  let R;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ g(QP, {}), e[18] = R) : R = e[18];
  let S;
  e[19] !== w ? (S = /* @__PURE__ */ g("span", { className: y, children: /* @__PURE__ */ g("span", { className: w, children: R }) }), e[19] = w, e[20] = S) : S = e[20];
  let E;
  e[21] !== a ? (E = oM({
    size: a
  }), e[21] = a, e[22] = E) : E = e[22];
  let N;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g(JP, {}), e[23] = N) : N = e[23];
  let I;
  e[24] !== E ? (I = /* @__PURE__ */ g(f3, { className: E, children: N }), e[24] = E, e[25] = I) : I = e[25];
  let M;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== S || e[30] !== I || e[31] !== m || e[32] !== h || e[33] !== b || e[34] !== v || e[35] !== C ? (M = /* @__PURE__ */ F(d3, { ...i, disabled: c, "aria-label": m, "aria-labelledby": h, "aria-describedby": f, "data-error": b, onKeyDown: v, className: C, children: [
    S,
    I
  ] }), e[26] = f, e[27] = c, e[28] = i, e[29] = S, e[30] = I, e[31] = m, e[32] = h, e[33] = b, e[34] = v, e[35] = C, e[36] = M) : M = e[36];
  let T;
  e[37] !== u || e[38] !== c || e[39] !== r ? (T = r && /* @__PURE__ */ g("span", { id: `${u}-label`, className: ne(g3(), c && "opacity-[0.54]"), children: r }), e[37] = u, e[38] = c, e[39] = r, e[40] = T) : T = e[40];
  let k;
  e[41] !== M || e[42] !== T ? (k = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    M,
    T
  ] }), e[41] = M, e[42] = T, e[43] = k) : k = e[43];
  let P;
  e[44] !== n || e[45] !== u || e[46] !== c || e[47] !== a ? (P = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: ne(rM(), c && "opacity-[0.54]", sM({
    size: a
  })), children: n }), e[44] = n, e[45] = u, e[46] = c, e[47] = a, e[48] = P) : P = e[48];
  let D;
  return e[49] !== k || e[50] !== P || e[51] !== p ? (D = /* @__PURE__ */ F("label", { className: p, children: [
    k,
    P
  ] }), e[49] = k, e[50] = P, e[51] = p, e[52] = D) : D = e[52], D;
}
const lM = ae(["flex", "w-full", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "shadow-elevation-1", "transition-colors", "duration-200", "ease-in-out", "[&:has(input:focus)]:border-input-active-outline", "hover:bg-input-hover-background", "hover:border-input-hover-outline", "active:border-input-pressed-outline", "[&:has(input:disabled)]:cursor-not-allowed", "[&:has(input:disabled)]:opacity-50"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), h3 = ae(["min-w-0", "flex-1", "border-0", "bg-transparent", "p-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-input-text-default", "outline-none", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "[&::-webkit-search-cancel-button]:appearance-none"]);
function b3(t) {
  const e = W.c(7), {
    children: n,
    size: o,
    trailing: r
  } = t, i = o === void 0 ? "md" : o;
  let s;
  e[0] !== i ? (s = ne(lM({
    size: i
  })), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-input-text-placeholder", children: /* @__PURE__ */ g(Ue, { name: "search", size: "sm", tone: "inherit" }) }), e[2] = l) : l = e[2];
  let a;
  return e[3] !== n || e[4] !== s || e[5] !== r ? (a = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    n,
    r
  ] }), e[3] = n, e[4] = s, e[5] = r, e[6] = a) : a = e[6], a;
}
function p_(t) {
  const e = W.c(33), {
    "aria-label": n,
    value: o,
    defaultValue: r,
    onChange: i,
    onSearch: s,
    placeholder: l,
    clearable: a,
    debounceMs: c,
    size: u,
    disabled: d,
    autoFocus: f
  } = t, p = r === void 0 ? "" : r, m = l === void 0 ? "Search" : l, h = a === void 0 ? !0 : a, b = c === void 0 ? 300 : c, v = u === void 0 ? "md" : u, [C, y] = qe(p), {
    emitSearch: w
  } = S1(s, b), R = o !== void 0, S = R ? o : C;
  let E;
  e[0] !== f ? (E = f ? {
    autoFocus: !0
  } : void 0, e[0] = f, e[1] = E) : E = e[1];
  const N = E;
  let I;
  e[2] !== w || e[3] !== R || e[4] !== i ? (I = function($) {
    R || y($), i?.($), w($);
  }, e[2] = w, e[3] = R, e[4] = i, e[5] = I) : I = e[5];
  const M = I;
  let T;
  e[6] !== w || e[7] !== R || e[8] !== i ? (T = function() {
    R || y(""), i?.(""), w("", !0);
  }, e[6] = w, e[7] = R, e[8] = i, e[9] = T) : T = e[9];
  const k = T;
  let P;
  e[10] !== k || e[11] !== h || e[12] !== d || e[13] !== S ? (P = h && S.length > 0 ? /* @__PURE__ */ g(bt, { "aria-label": "Clear search", disabled: d, icon: "x-close", onClick: k, size: "sm", type: "button", variant: "ghost" }) : void 0, e[10] = k, e[11] = h, e[12] = d, e[13] = S, e[14] = P) : P = e[14];
  let D;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne(h3()), e[15] = D) : D = e[15];
  let O;
  e[16] !== M ? (O = (L) => M(L.target.value), e[16] = M, e[17] = O) : O = e[17];
  let V;
  e[18] !== k || e[19] !== S ? (V = (L) => {
    L.key === "Escape" && S.length > 0 && (L.preventDefault(), k());
  }, e[18] = k, e[19] = S, e[20] = V) : V = e[20];
  let _;
  e[21] !== n || e[22] !== N || e[23] !== d || e[24] !== S || e[25] !== m || e[26] !== O || e[27] !== V ? (_ = /* @__PURE__ */ g("input", { "aria-label": n, className: D, disabled: d, onChange: O, onKeyDown: V, placeholder: m, type: "search", value: S, ...N }), e[21] = n, e[22] = N, e[23] = d, e[24] = S, e[25] = m, e[26] = O, e[27] = V, e[28] = _) : _ = e[28];
  let A;
  return e[29] !== v || e[30] !== _ || e[31] !== P ? (A = /* @__PURE__ */ g(b3, { size: v, trailing: P, children: _ }), e[29] = v, e[30] = _, e[31] = P, e[32] = A) : A = e[32], A;
}
function aM(t) {
  const {
    openOnInputClick: e = !1,
    value: n,
    defaultValue: o,
    onValueChange: r,
    mode: i = "list",
    itemToStringValue: s,
    ...l
  } = t, a = i === "inline" || i === "both", c = i === "inline" || i === "none", u = n !== void 0, [d, f] = x.useState(o ?? ""), [p, m] = x.useState("");
  x.useEffect(() => {
    u && m("");
  }, [n, u]);
  let h;
  a && p !== "" ? h = p : u ? h = n ?? "" : h = d;
  const b = we((S, E) => {
    m(""), u || f(S), r?.(S, E);
  }), v = G0(), C = x.useMemo(() => l.filter !== void 0 ? l.filter : v.contains, [l.filter, v]), y = String(u ? n : d).trim(), w = x.useMemo(() => i !== "both" ? c ? null : C : C === null ? null : (S, E, N) => C(S, y, N), [C, i, y, c]), R = we((S, E) => {
    t.onItemHighlighted?.(S, E), E.reason !== g8 && (a ? S == null ? m("") : m(fn(S, s)) : m(""));
  });
  return /* @__PURE__ */ g(j0, {
    ...l,
    itemToStringLabel: s,
    openOnInputClick: e,
    selectionMode: "none",
    fillInputOnItemPress: !0,
    filter: w,
    autoComplete: i,
    inputValue: h,
    defaultInputValue: o,
    onInputValueChange: b,
    onItemHighlighted: R
  });
}
const cM = Da, uM = As, dM = ae(["w-[min(540px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(640px,calc(100vh_-_var(--spacing-40)))]", "flex", "flex-col", "gap-(--spacing-10)", "outline-none", "[outline:none]", "focus:outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out", "max-sm:h-dvh", "max-sm:w-screen", "max-sm:max-h-none", "max-sm:gap-0", "max-sm:bg-surface"]), fM = ae(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface/40", "backdrop-blur-search-overlay", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-100", "ease-in-out"]), pM = ae(["min-h-0", "max-h-[min(520px,calc(100vh_-_160px))]", "overflow-y-auto", "overscroll-contain", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none", "rounded-(--radius-sm)", "bg-surface-container-lowest", "py-(--spacing-20)", "px-(--spacing-10)", "shadow-elevation-3", "max-sm:max-h-none", "max-sm:flex-1", "max-sm:rounded-none", "max-sm:shadow-none"]), mM = ae(["contents", "max-sm:flex", "max-sm:h-[68px]", "max-sm:shrink-0", "max-sm:items-center", "max-sm:gap-(--spacing-8)", "max-sm:border-b", "max-sm:border-outline-subtle", "max-sm:px-(--spacing-16)"]), gM = ae(["hidden", "max-sm:flex", "max-sm:min-h-[44px]", "max-sm:items-center"]), hM = ae(["contents", "max-sm:flex", "max-sm:min-h-[44px]", "max-sm:min-w-0", "max-sm:flex-1", "max-sm:items-center"]), bM = ae(["flex", "flex-col", "gap-(--spacing-16)", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none"]), vM = ae(["flex", "flex-col", "gap-(--spacing-4)"]), yM = ae(["relative", "z-10", "flex", "h-(--spacing-24)", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle"]), xM = ae(["flex", "h-[45px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "bg-transparent", "py-(--spacing-4)", "pl-(--spacing-10)", "pr-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50"]), CM = ae(["inline-flex", "h-(--spacing-32)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-button-outline-default-text", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), wM = ae(["inline-flex", "size-(--spacing-32)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border", "border-solid", "border-transparent", "bg-transparent", "text-button-ghost-default-text", "outline-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background"]);
function SM(t) {
  return t.map((e) => ({
    value: e.label,
    items: e.items.map((n) => ({
      ...n,
      groupLabel: e.label
    }))
  }));
}
function RM(t) {
  return t.every((e) => e.items.length === 0);
}
function Vc(t, e) {
  return t.find((n) => n.label === e);
}
function Ac(t) {
  return `${t.groupLabel}:${t.id}`;
}
const EM = {
  meta: "⌘",
  ctrl: "Ctrl",
  alt: "Alt",
  shift: "Shift"
};
function m_(t) {
  const e = W.c(76), {
    open: n,
    onOpenChange: o,
    query: r,
    onQueryChange: i,
    onSearch: s,
    debounceMs: l,
    groups: a,
    placeholder: c,
    hotkey: u,
    showDividers: d,
    emptyLabel: f,
    disabled: p,
    "aria-label": m,
    onItemSelect: h,
    onItemRemove: b
  } = t, v = l === void 0 ? 300 : l, C = c === void 0 ? "Search" : c, y = d === void 0 ? !0 : d, w = f === void 0 ? "No results found." : f, R = m === void 0 ? "Search" : m, S = en(), E = $t(), {
    cancelSearch: N,
    emitSearch: I
  } = S1(s, v), M = a.filter(IM), T = SM(M), k = RM(M), P = !!u && r.length === 0, D = T.at(-1)?.value, [O, V] = qe();
  let _;
  e[0] !== O ? (_ = (Me) => Ac(Me) === O, e[0] = O, e[1] = _) : _ = e[1];
  const A = T.flatMap(kM).find(_);
  let L;
  e[2] !== N || e[3] !== a || e[4] !== h ? (L = function(Re, Ve) {
    if (Re.target instanceof Element && Re.target.closest("[data-search-remove]"))
      return;
    const Ze = Vc(a, Ve.groupLabel);
    !Ze || Ve.disabled || (N(), h(Ve, Ze));
  }, e[2] = N, e[3] = a, e[4] = h, e[5] = L) : L = e[5];
  const $ = L;
  let B;
  e[6] !== I || e[7] !== i ? (B = function(Re) {
    i(Re), I(Re);
  }, e[6] = I, e[7] = i, e[8] = B) : B = e[8];
  const z = B;
  let H;
  e[9] !== N || e[10] !== o ? (H = function(Re) {
    Re || N(), o(Re);
  }, e[9] = N, e[10] = o, e[11] = H) : H = e[11];
  const K = H;
  let G;
  e[12] !== a || e[13] !== b ? (G = function(Re) {
    const Ve = Vc(a, Re.groupLabel);
    !Ve || Re.disabled || b?.(Re, Ve);
  }, e[12] = a, e[13] = b, e[14] = G) : G = e[14];
  const q = G;
  let Q;
  e[15] !== V ? (Q = function(Re) {
    const Ve = Re ? Ac(Re) : void 0;
    V((Ze) => Ze === Ve ? Ze : Ve);
  }, e[15] = V, e[16] = Q) : Q = e[16];
  const U = Q;
  let X;
  e[17] !== q ? (X = function(Re, Ve) {
    Re.preventDefault(), Re.stopPropagation(), q(Ve);
  }, e[17] = q, e[18] = X) : X = e[18];
  const te = X;
  let re;
  e[19] !== q || e[20] !== A || e[21] !== r ? (re = function(Re) {
    !A?.removable || A.disabled || !(Re.key === "Delete" || Re.key === "Backspace" && r.length === 0) || (Re.preventDefault(), Re.stopPropagation(), q(A));
  }, e[19] = q, e[20] = A, e[21] = r, e[22] = re) : re = e[22];
  const J = re;
  let ie;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = function(Re) {
    if (!Re.removable)
      return;
    const Ve = Re.chip ? `, ${Re.chip}` : "", Ze = Re.removeAriaLabel ? `${Re.removeAriaLabel}. Press Delete.` : "Press Delete to remove.";
    return `${Re.label}${Ve}. ${Ze}`;
  }, e[23] = ie) : ie = e[23];
  const ce = ie;
  let oe;
  e[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (oe = /* @__PURE__ */ g(Os, { className: ne(fM()) }), e[24] = oe) : oe = e[24];
  let se;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = ne(dM()), e[25] = se) : se = e[25];
  let me, pe;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (me = ne(mM()), pe = ne(gM()), e[26] = me, e[27] = pe) : (me = e[26], pe = e[27]);
  let le;
  e[28] !== K ? (le = /* @__PURE__ */ g("div", { className: pe, children: /* @__PURE__ */ g(bt, { "aria-label": "Back", icon: "chevron-left", variant: "ghost", onClick: () => K(!1) }) }), e[28] = K, e[29] = le) : le = e[29];
  let ge;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ge = ne(hM()), e[30] = ge) : ge = e[30];
  let j;
  e[31] !== u || e[32] !== P ? (j = P && u ? /* @__PURE__ */ g(s0, { "aria-hidden": "true", modifier: u.modifier ? EM[u.modifier] : void 0, children: u.key }) : void 0, e[31] = u, e[32] = P, e[33] = j) : j = e[33];
  let ee;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = ne(h3()), e[34] = ee) : ee = e[34];
  let Y;
  e[35] !== p || e[36] !== J || e[37] !== E || e[38] !== C ? (Y = /* @__PURE__ */ g(_s, { id: E, placeholder: C, disabled: p, className: ee, onKeyDown: J }), e[35] = p, e[36] = J, e[37] = E, e[38] = C, e[39] = Y) : Y = e[39];
  let Z;
  e[40] !== j || e[41] !== Y ? (Z = /* @__PURE__ */ g(cM, { children: /* @__PURE__ */ g(b3, { trailing: j, children: Y }) }), e[40] = j, e[41] = Y, e[42] = Z) : Z = e[42];
  let ue;
  e[43] !== E || e[44] !== Z ? (ue = /* @__PURE__ */ g("label", { className: ge, htmlFor: E, children: Z }), e[43] = E, e[44] = Z, e[45] = ue) : ue = e[45];
  let fe;
  e[46] !== le || e[47] !== ue ? (fe = /* @__PURE__ */ F("div", { className: me, children: [
    le,
    ue
  ] }), e[46] = le, e[47] = ue, e[48] = fe) : fe = e[48];
  let be;
  e[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (be = ne(pM()), e[49] = be) : be = e[49];
  let Ie;
  e[50] !== w || e[51] !== a || e[52] !== $ || e[53] !== te || e[54] !== k || e[55] !== D || e[56] !== y ? (Ie = /* @__PURE__ */ g("div", { className: be, children: k ? /* @__PURE__ */ g("div", { className: "flex h-(--spacing-40) items-center px-(--spacing-10) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: w }) : /* @__PURE__ */ g(Vs, { className: ne(bM()), children: (Me) => {
    const Re = Vc(a, Me.value);
    return /* @__PURE__ */ F(Rl, { children: [
      /* @__PURE__ */ F(J0, { items: Me.items, className: ne(vM()), children: [
        /* @__PURE__ */ F(eb, { className: ne(yM(), Re?.action && "pr-(--spacing-4)"), children: [
          /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: Me.value }),
          Re?.action && /* @__PURE__ */ F(no, { className: ne(CM()), "aria-label": Re.action["aria-label"], onClick: Re.action.onClick, children: [
            Re.action.label,
            /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" })
          ] })
        ] }),
        /* @__PURE__ */ g(Z0, { children: (Ve) => /* @__PURE__ */ F(uM, { value: Ve, disabled: Ve.disabled, className: ne(xM()), "aria-label": ce(Ve), onClick: (Ze) => $(Ze, Ve), children: [
          /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
            /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: Ve.label }),
              Ve.subLabel && /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-xsmall) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-menu-text-subtle uppercase", children: Ve.subLabel })
            ] }),
            Ve.chip && /* @__PURE__ */ g(Wn, { label: Ve.chip, tone: "neutral" })
          ] }),
          Ve.removable && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: ne(wM()), "data-search-remove": "", "data-testid": `search-remove-${Ve.id}`, onPointerDown: (Ze) => te(Ze, Ve), children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "sm", tone: "inherit" }) })
        ] }, Ac(Ve)) })
      ] }),
      y && Me.value !== D && /* @__PURE__ */ g(vr, { variant: "middle-inset" })
    ] }, Me.value);
  } }) }), e[50] = w, e[51] = a, e[52] = $, e[53] = te, e[54] = k, e[55] = D, e[56] = y, e[57] = Ie) : Ie = e[57];
  let ye;
  e[58] !== T || e[59] !== p || e[60] !== U || e[61] !== z || e[62] !== r || e[63] !== fe || e[64] !== Ie ? (ye = /* @__PURE__ */ F(aM, { open: !0, inline: !0, mode: "none", items: T, itemToStringValue: NM, value: r, onValueChange: z, onItemHighlighted: U, disabled: p, children: [
    fe,
    Ie
  ] }), e[58] = T, e[59] = p, e[60] = U, e[61] = z, e[62] = r, e[63] = fe, e[64] = Ie, e[65] = ye) : ye = e[65];
  let xe;
  e[66] !== R || e[67] !== ye ? (xe = /* @__PURE__ */ g(wi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-start justify-center px-(--spacing-16) pt-[12vh] max-sm:items-stretch max-sm:p-0", children: /* @__PURE__ */ g(xi, { "aria-label": R, className: se, children: ye }) }), e[66] = R, e[67] = ye, e[68] = xe) : xe = e[68];
  let de;
  e[69] !== S || e[70] !== xe ? (de = /* @__PURE__ */ F(Lr, { container: S, children: [
    oe,
    xe
  ] }), e[69] = S, e[70] = xe, e[71] = de) : de = e[71];
  let Se;
  return e[72] !== K || e[73] !== n || e[74] !== de ? (Se = /* @__PURE__ */ g(Ci, { open: n, onOpenChange: K, modal: !0, children: de }), e[72] = K, e[73] = n, e[74] = de, e[75] = Se) : Se = e[75], Se;
}
function NM(t) {
  return t.label;
}
function kM(t) {
  return t.items;
}
function IM(t) {
  return t.items.length > 0;
}
function PM(t) {
  if (!(t instanceof HTMLElement)) return !1;
  const e = t.tagName.toLowerCase();
  return e === "input" || e === "textarea" || e === "select" || t.isContentEditable;
}
function MM(t, e) {
  if (!e.includes("+"))
    return !t.metaKey && !t.ctrlKey && !t.altKey && !t.shiftKey && t.key.toLowerCase() === e.toLowerCase();
  const [n, o] = e.toLowerCase().split("+");
  return !n || !o ? !1 : !!(n === "mod" ? t.metaKey || t.ctrlKey : n === "meta" ? t.metaKey : n === "ctrl" ? t.ctrlKey : n === "alt" ? t.altKey : n === "shift" && t.shiftKey) && t.key.toLowerCase() === o;
}
function g_(t) {
  const e = W.c(5), {
    key: n,
    enabled: o,
    onOpen: r
  } = t, i = o === void 0 ? !0 : o;
  let s, l;
  e[0] !== i || e[1] !== n || e[2] !== r ? (s = () => {
    if (!i)
      return;
    const a = function(u) {
      PM(u.target) || MM(u, n) && (u.preventDefault(), r());
    };
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, l = [i, n, r], e[0] = i, e[1] = n, e[2] = r, e[3] = s, e[4] = l) : (s = e[3], l = e[4]), Nt(s, l);
}
const TM = ae(["aw-skeleton", "relative", "block", "overflow-hidden", "bg-surface-container"], {
  variants: {
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
function h_(t) {
  const e = W.c(25);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    radius: s,
    width: a,
    height: o,
    className: n,
    style: i,
    "aria-hidden": l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "sm" : s, u = l === void 0 ? !0 : l;
  let d;
  e[8] !== a ? (d = a !== void 0 ? {
    width: a
  } : void 0, e[8] = a, e[9] = d) : d = e[9];
  let f;
  e[10] !== o ? (f = o !== void 0 ? {
    height: o
  } : void 0, e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== i || e[13] !== d || e[14] !== f ? (p = {
    ...i,
    ...d,
    ...f
  }, e[12] = i, e[13] = d, e[14] = f, e[15] = p) : p = e[15];
  const m = p;
  let h;
  e[16] !== n || e[17] !== c ? (h = ne(TM({
    radius: c
  }), n), e[16] = n, e[17] = c, e[18] = h) : h = e[18];
  let b;
  return e[19] !== u || e[20] !== r || e[21] !== c || e[22] !== m || e[23] !== h ? (b = /* @__PURE__ */ g("div", { ...r, "data-slot": "skeleton", "data-radius": c, "aria-hidden": u, className: h, style: m }), e[19] = u, e[20] = r, e[21] = c, e[22] = m, e[23] = h, e[24] = b) : b = e[24], b;
}
const OM = 5, DM = 200;
function _M(t, e, n) {
  const o = [...t], [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}
function _i(t, e, n) {
  return `${t}, position ${e + 1} of ${n}`;
}
function Lc(t, e, n) {
  const o = [...t.tops], r = t.ids.map((l, a) => a), [i] = r.splice(e, 1);
  r.splice(n, 0, i);
  let s = t.tops[0] ?? 0;
  return r.forEach((l, a) => {
    o[l] = s, s += t.heights[l] + (t.gaps[a] ?? 0);
  }), o;
}
function Fc(t, e, n) {
  const r = {
    ArrowUp: (i) => i - 1,
    ArrowDown: (i) => i + 1,
    Home: () => 0,
    End: (i, s) => s
  }[t];
  return r ? Math.max(0, Math.min(n, r(e, n))) : void 0;
}
function VM({
  items: t,
  getItemId: e,
  getItemLabel: n,
  onReorder: o,
  onDragEnd: r
}) {
  const [i, s] = x.useState(null), [l, a] = x.useState(!1), [c, u] = x.useState(""), d = x.useId(), f = x.useRef(/* @__PURE__ */ new Map()), p = x.useRef(null), m = x.useRef(null), h = x.useRef(/* @__PURE__ */ new Map()), b = x.useRef(null), v = x.useRef(null), C = x.useRef(null), y = x.useRef(null), w = x.useRef([]), R = x.useRef({
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  });
  R.current = {
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  };
  function S(U, X) {
    X ? f.current.set(U, X) : f.current.delete(U);
  }
  function E(U) {
    const X = h.current.get(U);
    if (X) return X;
    const te = (re) => S(U, re);
    return h.current.set(U, te), te;
  }
  function N(U) {
    const {
      items: X,
      getItemId: te,
      getItemLabel: re
    } = R.current, J = X.find((ie) => te(ie) === U);
    return J ? re(J) : "";
  }
  function I(U) {
    v.current = U, s(U);
  }
  function M(U) {
    typeof document > "u" || (document.body.style.cursor = "grabbing", document.body.style.userSelect = "none");
  }
  function T() {
    if (typeof document > "u") return;
    const U = C.current;
    U && (document.body.style.cursor = U.previousBodyCursor, document.body.style.userSelect = U.previousBodyUserSelect);
  }
  function k() {
    p.current?.abort(), p.current = null, m.current?.abort(), m.current = null, y.current && (clearTimeout(y.current), y.current = null), b.current = null, T(), C.current = null, I(null);
  }
  function P() {
    for (const U of w.current)
      cancelAnimationFrame(U);
    w.current = [];
  }
  function D() {
    P();
    const U = requestAnimationFrame(() => {
      const X = requestAnimationFrame(() => {
        w.current = [], a(!1);
      });
      w.current = [X];
    });
    w.current = [U];
  }
  function O(U, X) {
    y.current && (clearTimeout(y.current), y.current = null), p.current?.abort(), p.current = null, b.current = null;
    const te = v.current;
    if (!te) {
      k();
      return;
    }
    I({
      ...te,
      delta: U,
      settling: !0
    }), y.current = setTimeout(() => {
      a(!0), X?.(), k(), D();
    }, DM);
  }
  function V() {
    const U = v.current;
    if (!U) {
      k();
      return;
    }
    if (U.settling) return;
    const X = C.current;
    if (!X) {
      k();
      return;
    }
    m.current?.abort(), m.current = null;
    const re = Lc(X, U.fromIndex, U.overIndex)[U.fromIndex] - X.tops[U.fromIndex];
    O(re, () => {
      const {
        items: J,
        getItemId: ie,
        onReorder: ce,
        onDragEnd: oe
      } = R.current;
      if (u(`Dropped ${_i(N(U.id), U.overIndex, J.length)}`), U.overIndex === U.fromIndex) return;
      const se = J.findIndex((ge) => ie(ge) === U.id), me = X.ids[U.overIndex], pe = J.findIndex((ge) => ie(ge) === me);
      if (se < 0 || pe < 0 || se === pe) return;
      const le = _M(J, se, pe);
      ce(le), oe?.(le);
    });
  }
  function _() {
    const U = v.current;
    if (!U) {
      k();
      return;
    }
    U.settling || (u(`Reordering cancelled. ${_i(N(U.id), U.fromIndex, R.current.items.length)}`), I({
      ...U,
      delta: 0,
      overIndex: U.fromIndex
    }), O(0));
  }
  function A(U, X, te = !0) {
    const {
      items: re,
      getItemId: J
    } = R.current, ie = re.findIndex((ge) => J(ge) === U);
    if (ie < 0) return;
    const ce = re.map((ge) => J(ge)), oe = ce.map((ge) => f.current.get(ge)?.getBoundingClientRect()), se = oe.map((ge) => ge ? ge.top + ge.height / 2 : 0), me = oe.map((ge, j) => {
      const ee = oe[j + 1];
      return ge && ee ? ee.top - (ge.top + ge.height) : 0;
    }), pe = oe.map((ge) => ge?.height ?? 0), le = oe.map((ge) => ge?.top ?? 0);
    C.current = {
      centers: se,
      gaps: me,
      heights: pe,
      ids: ce,
      previousBodyCursor: typeof document > "u" ? "" : document.body.style.cursor,
      previousBodyUserSelect: typeof document > "u" ? "" : document.body.style.userSelect,
      startY: X,
      tops: le
    }, te && M(), I({
      id: U,
      fromIndex: ie,
      overIndex: ie,
      delta: 0,
      settling: !1
    }), u(`Picked up ${_i(N(U), ie, re.length)}`);
  }
  function L(U) {
    const te = f.current.get(U)?.getBoundingClientRect();
    A(U, te ? te.top + te.height / 2 : 0, !1), K(U);
  }
  function $(U) {
    const X = v.current, te = C.current;
    if (!X || X.settling || !te) return;
    const re = U - te.startY, J = te.centers[X.fromIndex] + re;
    let ie = 0, ce = Number.POSITIVE_INFINITY;
    for (let oe = 0; oe < te.centers.length; oe++) {
      const se = Math.abs(J - te.centers[oe]);
      se < ce && (ce = se, ie = oe);
    }
    ie !== X.overIndex && u(_i(N(X.id), ie, R.current.items.length)), I({
      ...X,
      delta: re,
      overIndex: ie
    });
  }
  function B(U) {
    const X = v.current, te = C.current;
    if (!X || X.settling || !te) return;
    U !== X.overIndex && u(_i(N(X.id), U, R.current.items.length));
    const re = Lc(te, X.fromIndex, U);
    I({
      ...X,
      delta: re[X.fromIndex] - te.tops[X.fromIndex],
      overIndex: U
    });
  }
  function z(U, X) {
    if (U.pointerType === "mouse" && U.button !== 0 || v.current || b.current) return;
    U.currentTarget.setPointerCapture?.(U.pointerId), b.current = {
      id: X,
      x: U.clientX,
      y: U.clientY
    };
    const te = new AbortController();
    p.current = te;
    const {
      signal: re
    } = te;
    window.addEventListener("pointermove", (J) => {
      const ie = b.current;
      if (ie && !v.current) {
        if (Math.hypot(J.clientX - ie.x, J.clientY - ie.y) < OM)
          return;
        A(ie.id, ie.y);
      }
      v.current && (J.preventDefault(), $(J.clientY));
    }, {
      signal: re
    }), window.addEventListener("pointerup", V, {
      signal: re
    }), window.addEventListener("pointercancel", _, {
      signal: re
    }), window.addEventListener("blur", _, {
      signal: re
    }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && _();
    }, {
      signal: re
    }), window.addEventListener("keydown", (J) => {
      J.key === "Escape" && (J.preventDefault(), _());
    }, {
      signal: re
    });
  }
  function H(U, X) {
    const te = v.current;
    if (te?.id !== X) return;
    if (U.key === "Tab") {
      _();
      return;
    }
    if (U.key === " " || U.key === "Enter") {
      U.preventDefault(), V();
      return;
    }
    if (U.key === "Escape") {
      U.preventDefault(), _();
      return;
    }
    const re = Fc(U.key, te.overIndex, R.current.items.length - 1);
    re !== void 0 && (U.preventDefault(), B(re));
  }
  function K(U) {
    if (m.current?.abort(), typeof document > "u") return;
    const X = new AbortController();
    m.current = X;
    const {
      signal: te
    } = X;
    document.addEventListener("keydown", (re) => H(re, U), {
      signal: te
    }), document.addEventListener("focusin", (re) => {
      if (v.current?.id !== U) return;
      const ie = re.target, ce = f.current.get(U)?.querySelector('[data-slot="sortable-handle"]');
      ie instanceof Node && ce?.contains(ie) || _();
    }, {
      signal: te
    });
  }
  function G(U, X) {
    const te = v.current;
    if (U.key === " " || U.key === "Enter") {
      if (U.preventDefault(), U.stopPropagation(), te?.id === X) {
        V();
        return;
      }
      te || L(X);
      return;
    }
    if (U.key === "Escape" && te?.id === X) {
      U.preventDefault(), U.stopPropagation(), _();
      return;
    }
    const {
      items: re
    } = R.current, J = re.length - 1;
    if (te?.id === X) {
      const ie = Fc(U.key, te.overIndex, J);
      if (ie === void 0) return;
      U.preventDefault(), U.stopPropagation(), B(ie);
      return;
    }
    Fc(U.key, 0, J) !== void 0 && (U.preventDefault(), U.stopPropagation());
  }
  function q(U, X) {
    return {
      "aria-label": `Reorder ${X}`,
      "aria-describedby": d,
      "aria-pressed": i?.id === U,
      "data-slot": "sortable-handle",
      role: "button",
      tabIndex: 0,
      onPointerDown: (te) => z(te, U),
      onKeyDown: (te) => G(te, U),
      onClick: (te) => te.stopPropagation()
    };
  }
  function Q(U, X) {
    if (!i) return;
    if (U === i.id) return `translateY(${i.delta}px)`;
    const te = C.current;
    if (!te) return;
    const {
      fromIndex: re,
      overIndex: J
    } = i, ce = Lc(te, re, J)[X] - te.tops[X];
    return ce === 0 ? void 0 : `translateY(${ce}px)`;
  }
  return x.useEffect(() => () => {
    p.current?.abort(), p.current = null, y.current && (clearTimeout(y.current), y.current = null), m.current?.abort(), m.current = null;
    for (const X of w.current)
      cancelAnimationFrame(X);
    w.current = [], b.current = null;
    const U = C.current;
    typeof document < "u" && U && (document.body.style.cursor = U.previousBodyCursor, document.body.style.userSelect = U.previousBodyUserSelect), C.current = null;
  }, []), {
    draggingId: i?.id ?? null,
    settling: i?.settling ?? !1,
    committing: l,
    getRowRef: E,
    getHandleProps: q,
    getItemTransform: Q,
    announcement: c,
    instructionsId: d
  };
}
const AM = ae(["relative", "transition-transform duration-200 ease-out", "motion-reduce:transition-none"]), LM = ae(["flex size-(--spacing-20) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "text-text-subtext", "cursor-grab touch-none", "active:cursor-grabbing", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), FM = ae(["flex w-full items-stretch", "data-[dragging]:shadow-elevation-1"]);
function b_(t) {
  const e = W.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ne(FM(), n), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "sortable-list-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function $M(t) {
  const e = W.c(7);
  let n, o;
  if (e[0] !== t ? ({
    visible: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]), !(o === void 0 ? !0 : o))
    return null;
  let i, s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = LM(), s = /* @__PURE__ */ g(Ue, { name: "grip-drag", size: "md", tone: "secondary", "aria-hidden": !0 }), e[3] = i, e[4] = s) : (i = e[3], s = e[4]);
  let l;
  return e[5] !== n ? (l = /* @__PURE__ */ g("div", { className: "flex w-(--spacing-40) shrink-0 items-center justify-center", children: /* @__PURE__ */ g("button", { ...n, type: "button", className: i, children: s }) }), e[5] = n, e[6] = l) : l = e[6], l;
}
function HM(t) {
  const e = W.c(36), {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s,
    className: l,
    children: a
  } = t;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== n || e[3] !== s || e[4] !== i ? (c = {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s
  }, e[0] = o, e[1] = r, e[2] = n, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const {
    draggingId: u,
    settling: d,
    committing: f,
    getRowRef: p,
    getHandleProps: m,
    getItemTransform: h,
    announcement: b,
    instructionsId: v
  } = VM(c);
  let C;
  if (e[6] !== a || e[7] !== f || e[8] !== u || e[9] !== m || e[10] !== o || e[11] !== r || e[12] !== h || e[13] !== p || e[14] !== n || e[15] !== d) {
    let S;
    e[17] !== a || e[18] !== f || e[19] !== u || e[20] !== m || e[21] !== o || e[22] !== r || e[23] !== h || e[24] !== p || e[25] !== d ? (S = (E, N) => {
      const I = o(E), M = r(E), T = u === I, k = m(I, M), P = /* @__PURE__ */ g($M, { ...k });
      return /* @__PURE__ */ g("div", { ref: p(I), "data-slot": "sortable-item", "data-dragging": T ? "" : void 0, style: {
        transform: h(I, N)
      }, className: ne(AM(), f && "transition-none", T && "z-10", T && !d && "transition-none"), children: a(E, {
        handle: P,
        handleProps: k,
        isDragging: T
      }) }, I);
    }, e[17] = a, e[18] = f, e[19] = u, e[20] = m, e[21] = o, e[22] = r, e[23] = h, e[24] = p, e[25] = d, e[26] = S) : S = e[26], C = n.map(S), e[6] = a, e[7] = f, e[8] = u, e[9] = m, e[10] = o, e[11] = r, e[12] = h, e[13] = p, e[14] = n, e[15] = d, e[16] = C;
  } else
    C = e[16];
  let y;
  e[27] !== v ? (y = /* @__PURE__ */ g("span", { id: v, className: "sr-only", children: "Press Space or Enter to pick up, arrow keys to move, Space or Enter to drop, or Escape to cancel." }), e[27] = v, e[28] = y) : y = e[28];
  let w;
  e[29] !== b ? (w = /* @__PURE__ */ g("span", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: b }), e[29] = b, e[30] = w) : w = e[30];
  let R;
  return e[31] !== l || e[32] !== C || e[33] !== y || e[34] !== w ? (R = /* @__PURE__ */ F("div", { "data-slot": "sortable-list", className: l, children: [
    C,
    y,
    w
  ] }), e[31] = l, e[32] = C, e[33] = y, e[34] = w, e[35] = R) : R = e[35], R;
}
const v_ = HM, P1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (P1.displayName = "SwitchRootContext");
function zM() {
  const t = x.useContext(P1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : st(63));
  return t;
}
let vg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const v3 = {
  ...io,
  checked(t) {
    return t ? {
      [vg.checked]: ""
    } : {
      [vg.unchecked]: ""
    };
  }
}, y3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i,
    "aria-labelledby": s,
    form: l,
    id: a,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: p = !1,
    required: m = !1,
    disabled: h = !1,
    render: b,
    uncheckedValue: v,
    value: C,
    style: y,
    ...w
  } = e, {
    clearErrors: R
  } = Fo(), {
    state: S,
    setTouched: E,
    setDirty: N,
    validityData: I,
    setFilled: M,
    setFocused: T,
    shouldValidateOnChange: k,
    validationMode: P,
    disabled: D,
    name: O,
    validation: V
  } = mn(), {
    labelId: _
  } = Nn(), A = D || h, L = O ?? u, $ = we(f), B = x.useRef(null), z = Rn(B, c, V.inputRef), H = x.useRef(null), K = Ot(), G = _r({
    id: a,
    implicit: !1,
    controlRef: H
  }), q = d ? void 0 : G, [Q, U] = Sn({
    controlled: o,
    default: !!i,
    name: "Switch",
    state: "checked"
  });
  vi(H, {
    id: K,
    value: Q
  }), ke(() => {
    B.current && M(B.current.checked);
  }, [B, M]), ko(Q, () => {
    R(L), N(Q !== I.initialValue), M(Q), k() ? V.commit(Q) : V.commit(Q, !0);
  });
  const {
    getButtonProps: X,
    buttonRef: te
  } = qt({
    disabled: A,
    native: d
  }), re = af(s, _, B, !d, q), J = {
    id: d ? G : K,
    role: "switch",
    "aria-checked": Q,
    "aria-readonly": p || void 0,
    "aria-required": m || void 0,
    "aria-labelledby": re,
    onFocus() {
      A || T(!0);
    },
    onBlur() {
      const se = B.current;
      !se || A || (E(!0), T(!1), P === "onBlur" && V.commit(se.checked));
    },
    onClick(se) {
      p || A || (se.preventDefault(), B.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: se.shiftKey,
        ctrlKey: se.ctrlKey,
        altKey: se.altKey,
        metaKey: se.metaKey
      })));
    }
  }, ie = x.useMemo(() => cn(
    {
      checked: Q,
      disabled: A,
      form: l,
      id: q,
      name: L,
      required: m,
      style: L ? ii : nr,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: z,
      onChange(se) {
        if (se.nativeEvent.defaultPrevented)
          return;
        if (p) {
          se.preventDefault();
          return;
        }
        const me = se.currentTarget.checked, pe = De(At, se.nativeEvent);
        $?.(me, pe), !pe.isCanceled && U(me);
      },
      onFocus() {
        H.current?.focus();
      }
    },
    V.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    C !== void 0 ? {
      value: C
    } : Et
  ), [Q, A, l, z, q, L, $, p, m, U, V, C]), ce = x.useMemo(() => ({
    ...S,
    checked: Q,
    disabled: A,
    readOnly: p,
    required: m
  }), [S, Q, A, p, m]), oe = Le("span", e, {
    state: ce,
    ref: [n, H, te],
    props: [J, V.getValidationProps, w, X],
    stateAttributesMapping: v3
  });
  return /* @__PURE__ */ F(P1.Provider, {
    value: ce,
    children: [oe, !Q && L && v !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: l,
      name: L,
      value: v
    }), /* @__PURE__ */ g("input", {
      ...ie,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (y3.displayName = "SwitchRoot");
const x3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = mn(), a = zM(), c = {
    ...l,
    ...a
  };
  return Le("span", e, {
    state: c,
    ref: n,
    stateAttributesMapping: v3,
    props: s
  });
});
process.env.NODE_ENV !== "production" && (x3.displayName = "SwitchThumb");
const BM = ae(["inline-flex", "items-start", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["opacity-[0.54]", "cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), WM = ae(["relative", "shrink-0", "w-[44px]", "h-(--spacing-24)", "rounded-full", "bg-surface-container-highest", "data-[checked]:bg-primary", "transition-colors", "duration-200", "ease-in-out", "motion-reduce:transition-none", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2", "focus-visible:ring-tertiary-tertiary", "cursor-[inherit]", "[@media(pointer:coarse)]:before:content-['']", "[@media(pointer:coarse)]:before:absolute", "[@media(pointer:coarse)]:before:inset-x-0", "[@media(pointer:coarse)]:before:inset-y-[-12px]"]), UM = ae(["absolute", "top-(--spacing-2)", "w-(--spacing-20)", "h-(--spacing-20)", "rounded-full", "bg-surface-container-lowest", "shadow-elevation-1", "translate-x-(--spacing-2)", "data-[checked]:translate-x-[22px]", "transition-transform", "duration-150", "ease-in-out", "motion-reduce:transition-none"]), GM = ae(["text-text-default", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), YM = ae(["text-text-subtle", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"]);
function y_(t) {
  const e = W.c(25);
  let n, o, r, i, s;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: s,
    id: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s, a = $t(), c = o ?? a;
  let u;
  e[6] !== l ? (u = ne(BM({
    disabled: l
  })), e[6] = l, e[7] = u) : u = e[7];
  const d = r ? `${c}-label` : void 0, f = n ? `${c}-description` : void 0;
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = WM(), e[8] = p) : p = e[8];
  let m;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ g(x3, { className: UM() }), e[9] = m) : m = e[9];
  let h;
  e[10] !== l || e[11] !== i || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ g(y3, { ...i, id: c, disabled: l, "aria-labelledby": d, "aria-describedby": f, className: p, children: m }), e[10] = l, e[11] = i, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== r || e[18] !== c ? (b = (r || n) && /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-4)", children: [
    r && /* @__PURE__ */ g("span", { id: `${c}-label`, className: GM(), children: r }),
    n && /* @__PURE__ */ g("span", { id: `${c}-description`, className: YM(), children: n })
  ] }), e[16] = n, e[17] = r, e[18] = c, e[19] = b) : b = e[19];
  let v;
  return e[20] !== c || e[21] !== u || e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F("label", { htmlFor: c, className: u, children: [
    h,
    b
  ] }), e[20] = c, e[21] = u, e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Go(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Vn(t, e) {
  return (n) => {
    e.setState((o) => ({
      ...o,
      [t]: Go(n, o[t])
    }));
  };
}
function za(t) {
  return t instanceof Function;
}
function jM(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function KM(t, e) {
  const n = [], o = (r) => {
    r.forEach((i) => {
      n.push(i);
      const s = e(i);
      s != null && s.length && o(s);
    });
  };
  return o(t), n;
}
function ct(t, e, n) {
  let o = [], r;
  return (i) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const l = t(i);
    if (!(l.length !== o.length || l.some((u, d) => o[d] !== u)))
      return r;
    o = l;
    let c;
    if (n.key && n.debug && (c = Date.now()), r = e(...l), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (m, h) => {
        for (m = String(m); m.length < h; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n?.key);
    }
    return r;
  };
}
function ut(t, e, n, o) {
  return {
    debug: () => {
      var r;
      return (r = t?.debugAll) != null ? r : t[e];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function qM(t, e, n, o) {
  const r = () => {
    var s;
    return (s = i.getValue()) != null ? s : t.options.renderFallbackValue;
  }, i = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(o),
    renderValue: r,
    getContext: ct(() => [t, n, e, i], (s, l, a, c) => ({
      table: s,
      column: l,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), ut(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, e, t);
  }, {}), i;
}
function ZM(t, e, n, o) {
  var r, i;
  const l = {
    ...t._getDefaultColumnDef(),
    ...e
  }, a = l.accessorKey;
  let c = (r = (i = l.id) != null ? i : a ? typeof String.prototype.replaceAll == "function" ? a.replaceAll(".", "_") : a.replace(/\./g, "_") : void 0) != null ? r : typeof l.header == "string" ? l.header : void 0, u;
  if (l.accessorFn ? u = l.accessorFn : a && (a.includes(".") ? u = (f) => {
    let p = f;
    for (const h of a.split(".")) {
      var m;
      p = (m = p) == null ? void 0 : m[h], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${h}" in deeply nested key "${a}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: ct(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, ut(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ct(() => [t._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let m = d.columns.flatMap((h) => h.getLeafColumns());
        return f(m);
      }
      return [d];
    }, ut(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const hn = "debugHeaders";
function yg(t, e, n) {
  var o;
  let i = {
    id: (o = n.id) != null ? o : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(l), s.push(a);
      };
      return l(i), s;
    },
    getContext: () => ({
      table: t,
      header: i,
      column: e
    })
  };
  return t._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, t);
  }), i;
}
const XM = {
  createTable: (t) => {
    t.getHeaderGroups = ct(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => {
      var i, s;
      const l = (i = o?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], a = (s = r?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? s : [], c = n.filter((d) => !(o != null && o.includes(d.id)) && !(r != null && r.includes(d.id)));
      return bl(e, [...l, ...c, ...a], t);
    }, ut(t.options, hn, "getHeaderGroups")), t.getCenterHeaderGroups = ct(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => (n = n.filter((i) => !(o != null && o.includes(i.id)) && !(r != null && r.includes(i.id))), bl(e, n, t, "center")), ut(t.options, hn, "getCenterHeaderGroups")), t.getLeftHeaderGroups = ct(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return bl(e, i, t, "left");
    }, ut(t.options, hn, "getLeftHeaderGroups")), t.getRightHeaderGroups = ct(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return bl(e, i, t, "right");
    }, ut(t.options, hn, "getRightHeaderGroups")), t.getFooterGroups = ct(() => [t.getHeaderGroups()], (e) => [...e].reverse(), ut(t.options, hn, "getFooterGroups")), t.getLeftFooterGroups = ct(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), ut(t.options, hn, "getLeftFooterGroups")), t.getCenterFooterGroups = ct(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), ut(t.options, hn, "getCenterFooterGroups")), t.getRightFooterGroups = ct(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), ut(t.options, hn, "getRightFooterGroups")), t.getFlatHeaders = ct(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), ut(t.options, hn, "getFlatHeaders")), t.getLeftFlatHeaders = ct(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), ut(t.options, hn, "getLeftFlatHeaders")), t.getCenterFlatHeaders = ct(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), ut(t.options, hn, "getCenterFlatHeaders")), t.getRightFlatHeaders = ct(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), ut(t.options, hn, "getRightFlatHeaders")), t.getCenterLeafHeaders = ct(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), ut(t.options, hn, "getCenterLeafHeaders")), t.getLeftLeafHeaders = ct(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), ut(t.options, hn, "getLeftLeafHeaders")), t.getRightLeafHeaders = ct(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), ut(t.options, hn, "getRightLeafHeaders")), t.getLeafHeaders = ct(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, o) => {
      var r, i, s, l, a, c;
      return [...(r = (i = e[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(a = (c = o[0]) == null ? void 0 : c.headers) != null ? a : []].map((u) => u.getLeafHeaders()).flat();
    }, ut(t.options, hn, "getLeafHeaders"));
  }
};
function bl(t, e, n, o) {
  var r, i;
  let s = 0;
  const l = function(f, p) {
    p === void 0 && (p = 1), s = Math.max(s, p), f.filter((m) => m.getIsVisible()).forEach((m) => {
      var h;
      (h = m.columns) != null && h.length && l(m.columns, p + 1);
    }, 0);
  };
  l(t);
  let a = [];
  const c = (f, p) => {
    const m = {
      depth: p,
      id: [o, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    f.forEach((b) => {
      const v = [...h].reverse()[0], C = b.column.depth === m.depth;
      let y, w = !1;
      if (C && b.column.parent ? y = b.column.parent : (y = b.column, w = !0), v && v?.column === y)
        v.subHeaders.push(b);
      else {
        const R = yg(n, y, {
          id: [o, p, y.id, b?.id].filter(Boolean).join("_"),
          isPlaceholder: w,
          placeholderId: w ? `${h.filter((S) => S.column === y).length}` : void 0,
          depth: p,
          index: h.length
        });
        R.subHeaders.push(b), h.push(R);
      }
      m.headers.push(b), b.headerGroup = m;
    }), a.push(m), p > 0 && c(h, p - 1);
  }, u = e.map((f, p) => yg(n, f, {
    depth: s,
    index: p
  }));
  c(u, s - 1), a.reverse();
  const d = (f) => f.filter((m) => m.column.getIsVisible()).map((m) => {
    let h = 0, b = 0, v = [0];
    m.subHeaders && m.subHeaders.length ? (v = [], d(m.subHeaders).forEach((y) => {
      let {
        colSpan: w,
        rowSpan: R
      } = y;
      h += w, v.push(R);
    })) : h = 1;
    const C = Math.min(...v);
    return b = b + C, m.colSpan = h, m.rowSpan = b, {
      colSpan: h,
      rowSpan: b
    };
  });
  return d((r = (i = a[0]) == null ? void 0 : i.headers) != null ? r : []), a;
}
const QM = (t, e, n, o, r, i, s) => {
  let l = {
    id: e,
    index: o,
    original: n,
    depth: r,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (l._valuesCache.hasOwnProperty(a))
        return l._valuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return l._valuesCache[a] = c.accessorFn(l.original, o), l._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (l._uniqueValuesCache.hasOwnProperty(a))
        return l._uniqueValuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[a] = c.columnDef.getUniqueValues(l.original, o), l._uniqueValuesCache[a]) : (l._uniqueValuesCache[a] = [l.getValue(a)], l._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = l.getValue(a)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => KM(l.subRows, (a) => a.subRows),
    getParentRow: () => l.parentId ? t.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = l;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        a.push(u), c = u;
      }
      return a.reverse();
    },
    getAllCells: ct(() => [t.getAllLeafColumns()], (a) => a.map((c) => qM(t, l, c, c.id)), ut(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ct(() => [l.getAllCells()], (a) => a.reduce((c, u) => (c[u.column.id] = u, c), {}), ut(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let a = 0; a < t._features.length; a++) {
    const c = t._features[a];
    c == null || c.createRow == null || c.createRow(l, t);
  }
  return l;
}, JM = {
  createColumn: (t, e) => {
    t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, C3 = (t, e, n) => {
  var o, r;
  const i = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
C3.autoRemove = (t) => Qn(t);
const w3 = (t, e, n) => {
  var o;
  return !!(!((o = t.getValue(e)) == null || (o = o.toString()) == null) && o.includes(n));
};
w3.autoRemove = (t) => Qn(t);
const S3 = (t, e, n) => {
  var o;
  return ((o = t.getValue(e)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === n?.toLowerCase();
};
S3.autoRemove = (t) => Qn(t);
const R3 = (t, e, n) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(n);
};
R3.autoRemove = (t) => Qn(t);
const E3 = (t, e, n) => !n.some((o) => {
  var r;
  return !((r = t.getValue(e)) != null && r.includes(o));
});
E3.autoRemove = (t) => Qn(t) || !(t != null && t.length);
const N3 = (t, e, n) => n.some((o) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(o);
});
N3.autoRemove = (t) => Qn(t) || !(t != null && t.length);
const k3 = (t, e, n) => t.getValue(e) === n;
k3.autoRemove = (t) => Qn(t);
const I3 = (t, e, n) => t.getValue(e) == n;
I3.autoRemove = (t) => Qn(t);
const M1 = (t, e, n) => {
  let [o, r] = n;
  const i = t.getValue(e);
  return i >= o && i <= r;
};
M1.resolveFilterValue = (t) => {
  let [e, n] = t, o = typeof e != "number" ? parseFloat(e) : e, r = typeof n != "number" ? parseFloat(n) : n, i = e === null || Number.isNaN(o) ? -1 / 0 : o, s = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > s) {
    const l = i;
    i = s, s = l;
  }
  return [i, s];
};
M1.autoRemove = (t) => Qn(t) || Qn(t[0]) && Qn(t[1]);
const No = {
  includesString: C3,
  includesStringSensitive: w3,
  equalsString: S3,
  arrIncludes: R3,
  arrIncludesAll: E3,
  arrIncludesSome: N3,
  equals: k3,
  weakEquals: I3,
  inNumberRange: M1
};
function Qn(t) {
  return t == null || t === "";
}
const eT = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: Vn("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      return typeof o == "string" ? No.includesString : typeof o == "number" ? No.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? No.equals : Array.isArray(o) ? No.arrIncludes : No.weakEquals;
    }, t.getFilterFn = () => {
      var n, o;
      return za(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = e.options.filterFns) == null ? void 0 : o[t.columnDef.filterFn]) != null ? n : No[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, o, r;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((o = e.options.enableColumnFilters) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((o) => o.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, o;
      return (n = (o = e.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((o) => {
        const r = t.getFilterFn(), i = o?.find((u) => u.id === t.id), s = Go(n, i ? i.value : void 0);
        if (xg(r, s, t)) {
          var l;
          return (l = o?.filter((u) => u.id !== t.id)) != null ? l : [];
        }
        const a = {
          id: t.id,
          value: s
        };
        if (i) {
          var c;
          return (c = o?.map((u) => u.id === t.id ? a : u)) != null ? c : [];
        }
        return o != null && o.length ? [...o, a] : [a];
      });
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), o = (r) => {
        var i;
        return (i = Go(e, r)) == null ? void 0 : i.filter((s) => {
          const l = n.find((a) => a.id === s.id);
          if (l) {
            const a = l.getFilterFn();
            if (xg(a, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(o);
    }, t.resetColumnFilters = (e) => {
      var n, o;
      t.setColumnFilters(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function xg(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const tT = (t, e, n) => n.reduce((o, r) => {
  const i = r.getValue(t);
  return o + (typeof i == "number" ? i : 0);
}, 0), nT = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o > i || o === void 0 && i >= i) && (o = i);
  }), o;
}, oT = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o < i || o === void 0 && i >= i) && (o = i);
  }), o;
}, rT = (t, e, n) => {
  let o, r;
  return n.forEach((i) => {
    const s = i.getValue(t);
    s != null && (o === void 0 ? s >= s && (o = r = s) : (o > s && (o = s), r < s && (r = s)));
  }), [o, r];
}, iT = (t, e) => {
  let n = 0, o = 0;
  if (e.forEach((r) => {
    let i = r.getValue(t);
    i != null && (i = +i) >= i && (++n, o += i);
  }), n) return o / n;
}, sT = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((i) => i.getValue(t));
  if (!jM(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, lT = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), aT = (t, e) => new Set(e.map((n) => n.getValue(t))).size, cT = (t, e) => e.length, $c = {
  sum: tT,
  min: nT,
  max: oT,
  extent: rT,
  mean: iT,
  median: sT,
  unique: lT,
  uniqueCount: aT,
  count: cT
}, uT = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: Vn("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((o) => o !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, o;
      return ((n = t.columnDef.enableGrouping) != null ? n : !0) && ((o = e.options.enableGrouping) != null ? o : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      if (typeof o == "number")
        return $c.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return $c.extent;
    }, t.getAggregationFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return za(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (o = e.options.aggregationFns) == null ? void 0 : o[t.columnDef.aggregationFn]) != null ? n : $c[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, o;
      t.setGrouping(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const o = e.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = o.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, o) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var r;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function dT(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const o = t.filter((i) => !e.includes(i.id));
  return n === "remove" ? o : [...e.map((i) => t.find((s) => s.id === i)).filter(Boolean), ...o];
}
const fT = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: Vn("columnOrder", t)
  }),
  createColumn: (t, e) => {
    t.getIndex = ct((n) => [Yi(e, n)], (n) => n.findIndex((o) => o.id === t.id), ut(e.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (n) => {
      var o;
      return ((o = Yi(e, n)[0]) == null ? void 0 : o.id) === t.id;
    }, t.getIsLastColumn = (n) => {
      var o;
      const r = Yi(e, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = ct(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, o) => (r) => {
      let i = [];
      if (!(e != null && e.length))
        i = r;
      else {
        const s = [...e], l = [...r];
        for (; l.length && s.length; ) {
          const a = s.shift(), c = l.findIndex((u) => u.id === a);
          c > -1 && i.push(l.splice(c, 1)[0]);
        }
        i = [...i, ...l];
      }
      return dT(i, n, o);
    }, ut(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Hc = () => ({
  left: [],
  right: []
}), pT = {
  getInitialState: (t) => ({
    columnPinning: Hc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: Vn("columnPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const o = t.getLeafColumns().map((r) => r.id).filter(Boolean);
      e.setColumnPinning((r) => {
        var i, s;
        if (n === "right") {
          var l, a;
          return {
            left: ((l = r?.left) != null ? l : []).filter((d) => !(o != null && o.includes(d))),
            right: [...((a = r?.right) != null ? a : []).filter((d) => !(o != null && o.includes(d))), ...o]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = r?.left) != null ? c : []).filter((d) => !(o != null && o.includes(d))), ...o],
            right: ((u = r?.right) != null ? u : []).filter((d) => !(o != null && o.includes(d)))
          };
        }
        return {
          left: ((i = r?.left) != null ? i : []).filter((d) => !(o != null && o.includes(d))),
          right: ((s = r?.right) != null ? s : []).filter((d) => !(o != null && o.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((o) => {
      var r, i, s;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((i = (s = e.options.enableColumnPinning) != null ? s : e.options.enablePinning) != null ? i : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((l) => l.id), {
        left: o,
        right: r
      } = e.getState().columnPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "left" : s ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      return r ? (n = (o = e.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.getCenterVisibleCells = ct(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, o, r) => {
      const i = [...o ?? [], ...r ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, ut(e.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = ct(() => [t._getAllVisibleCells(), e.getState().columnPinning.left], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), ut(e.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = ct(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), ut(e.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, o;
      return t.setColumnPinning(e ? Hc() : (n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : Hc());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const o = t.getState().columnPinning;
      if (!e) {
        var r, i;
        return !!((r = o.left) != null && r.length || (i = o.right) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t.getLeftLeafColumns = ct(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), ut(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = ct(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), ut(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = ct(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return e.filter((i) => !r.includes(i.id));
    }, ut(t.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function mT(t) {
  return t || (typeof document < "u" ? document : null);
}
const vl = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, zc = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), gT = {
  getDefaultColumnDef: () => vl,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: zc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Vn("columnSizing", t),
    onColumnSizingInfoChange: Vn("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, o, r;
      const i = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : vl.minSize, (o = i ?? t.columnDef.size) != null ? o : vl.size), (r = t.columnDef.maxSize) != null ? r : vl.maxSize);
    }, t.getStart = ct((n) => [n, Yi(e, n), e.getState().columnSizing], (n, o) => o.slice(0, t.getIndex(n)).reduce((r, i) => r + i.getSize(), 0), ut(e.options, "debugColumns", "getStart")), t.getAfter = ct((n) => [n, Yi(e, n), e.getState().columnSizing], (n, o) => o.slice(t.getIndex(n) + 1).reduce((r, i) => r + i.getSize(), 0), ut(e.options, "debugColumns", "getAfter")), t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: o,
          ...r
        } = n;
        return r;
      });
    }, t.getCanResize = () => {
      var n, o;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((o = e.options.enableColumnResizing) != null ? o : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var i;
          n += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return o(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = (n) => {
      const o = e.getColumn(t.column.id), r = o?.getCanResize();
      return (i) => {
        if (!o || !r || (i.persist == null || i.persist(), Bc(i) && i.touches && i.touches.length > 1))
          return;
        const s = t.getSize(), l = t ? t.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[o.id, o.getSize()]], a = Bc(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (v, C) => {
          typeof C == "number" && (e.setColumnSizingInfo((y) => {
            var w, R;
            const S = e.options.columnResizeDirection === "rtl" ? -1 : 1, E = (C - ((w = y?.startOffset) != null ? w : 0)) * S, N = Math.max(E / ((R = y?.startSize) != null ? R : 0), -0.999999);
            return y.columnSizingStart.forEach((I) => {
              let [M, T] = I;
              c[M] = Math.round(Math.max(T + T * N, 0) * 100) / 100;
            }), {
              ...y,
              deltaOffset: E,
              deltaPercentage: N
            };
          }), (e.options.columnResizeMode === "onChange" || v === "end") && e.setColumnSizing((y) => ({
            ...y,
            ...c
          })));
        }, d = (v) => u("move", v), f = (v) => {
          u("end", v), e.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = mT(n), m = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            p?.removeEventListener("mousemove", m.moveHandler), p?.removeEventListener("mouseup", m.upHandler), f(v.clientX);
          }
        }, h = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var C;
            p?.removeEventListener("touchmove", h.moveHandler), p?.removeEventListener("touchend", h.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), f((C = v.touches[0]) == null ? void 0 : C.clientX);
          }
        }, b = hT() ? {
          passive: !1
        } : !1;
        Bc(i) ? (p?.addEventListener("touchmove", h.moveHandler, b), p?.addEventListener("touchend", h.upHandler, b)) : (p?.addEventListener("mousemove", m.moveHandler, b), p?.addEventListener("mouseup", m.upHandler, b)), e.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: a,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? zc() : (n = t.initialState.columnSizingInfo) != null ? n : zc());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    };
  }
};
let yl = null;
function hT() {
  if (typeof yl == "boolean") return yl;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return yl = t, yl;
}
function Bc(t) {
  return t.type === "touchstart";
}
const bT = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: Vn("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((o) => ({
        ...o,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, o;
      const r = t.columns;
      return (n = r.length ? r.some((i) => i.getIsVisible()) : (o = e.getState().columnVisibility) == null ? void 0 : o[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, o;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((o = e.options.enableHiding) != null ? o : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = ct(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), ut(e.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = ct(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], ut(e.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const e = (n, o) => ct(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), ut(t.options, "debugColumns", n));
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var o;
      t.setColumnVisibility(n ? {} : (o = t.initialState.columnVisibility) != null ? o : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      t.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function Yi(t, e) {
  return e ? e === "center" ? t.getCenterVisibleLeafColumns() : e === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const vT = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, yT = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: Vn("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const o = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getCanGlobalFilter = () => {
      var n, o, r, i;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = e.options.enableGlobalFilter) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && ((i = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? i : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => No.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: o
      } = t.options;
      return za(o) ? o : o === "auto" ? t.getGlobalAutoFilterFn() : (e = (n = t.options.filterFns) == null ? void 0 : n[o]) != null ? e : No[o];
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    };
  }
}, xT = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: Vn("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetExpanded) != null ? o : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (o) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o), t.toggleAllRowsExpanded = (o) => {
      o ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (o) => {
      var r, i;
      t.setExpanded(o ? {} : (r = (i = t.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const o = t.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const o = t.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || t.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let o = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        o = Math.max(o, s.length);
      }), o;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((o) => {
        var r;
        const i = o === !0 ? !0 : !!(o != null && o[t.id]);
        let s = {};
        if (o === !0 ? Object.keys(e.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = o, n = (r = n) != null ? r : !i, !i && n)
          return {
            ...s,
            [t.id]: !0
          };
        if (i && !n) {
          const {
            [t.id]: l,
            ...a
          } = s;
          return a;
        }
        return o;
      });
    }, t.getIsExpanded = () => {
      var n;
      const o = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : o === !0 || o?.[t.id]);
    }, t.getCanExpand = () => {
      var n, o, r;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((o = e.options.enableExpanding) != null ? o : !0) && !!((r = t.subRows) != null && r.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, o = t;
      for (; n && o.parentId; )
        o = e.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, Eu = 0, Nu = 10, Wc = () => ({
  pageIndex: Eu,
  pageSize: Nu
}), CT = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Wc(),
      ...t?.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: Vn("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetPageIndex) != null ? o : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (o) => {
      const r = (i) => Go(o, i);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(r);
    }, t.resetPagination = (o) => {
      var r;
      t.setPagination(o ? Wc() : (r = t.initialState.pagination) != null ? r : Wc());
    }, t.setPageIndex = (o) => {
      t.setPagination((r) => {
        let i = Go(o, r.pageIndex);
        const s = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...r,
          pageIndex: i
        };
      });
    }, t.resetPageIndex = (o) => {
      var r, i;
      t.setPageIndex(o ? Eu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : Eu);
    }, t.resetPageSize = (o) => {
      var r, i;
      t.setPageSize(o ? Nu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : Nu);
    }, t.setPageSize = (o) => {
      t.setPagination((r) => {
        const i = Math.max(1, Go(o, r.pageSize)), s = r.pageSize * r.pageIndex, l = Math.floor(s / i);
        return {
          ...r,
          pageIndex: l,
          pageSize: i
        };
      });
    }, t.setPageCount = (o) => t.setPagination((r) => {
      var i;
      let s = Go(o, (i = t.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...r,
        pageCount: s
      };
    }), t.getPageOptions = ct(() => [t.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((i, s) => s)), r;
    }, ut(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: o
      } = t.getState().pagination, r = t.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, t.previousPage = () => t.setPageIndex((o) => o - 1), t.nextPage = () => t.setPageIndex((o) => o + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var o;
      return (o = t.options.pageCount) != null ? o : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var o;
      return (o = t.options.rowCount) != null ? o : t.getPrePaginationRowModel().rows.length;
    };
  }
}, Uc = () => ({
  top: [],
  bottom: []
}), wT = {
  getInitialState: (t) => ({
    rowPinning: Uc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: Vn("rowPinning", t)
  }),
  createRow: (t, e) => {
    t.pin = (n, o, r) => {
      const i = o ? t.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], s = r ? t.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...s, t.id, ...i]);
      e.setRowPinning((a) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = a?.top) != null ? d : []).filter((h) => !(l != null && l.has(h))),
            bottom: [...((f = a?.bottom) != null ? f : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var p, m;
          return {
            top: [...((p = a?.top) != null ? p : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)],
            bottom: ((m = a?.bottom) != null ? m : []).filter((h) => !(l != null && l.has(h)))
          };
        }
        return {
          top: ((c = a?.top) != null ? c : []).filter((h) => !(l != null && l.has(h))),
          bottom: ((u = a?.bottom) != null ? u : []).filter((h) => !(l != null && l.has(h)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = e.options;
      return typeof o == "function" ? o(t) : (n = o ?? r) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: o,
        bottom: r
      } = e.getState().rowPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "top" : s ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      if (!r) return -1;
      const i = (n = r === "top" ? e.getTopRows() : e.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (o = i?.indexOf(t.id)) != null ? o : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, o;
      return t.setRowPinning(e ? Uc() : (n = (o = t.initialState) == null ? void 0 : o.rowPinning) != null ? n : Uc());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const o = t.getState().rowPinning;
      if (!e) {
        var r, i;
        return !!((r = o.top) != null && r.length || (i = o.bottom) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t._getPinnedRows = (e, n, o) => {
      var r;
      return ((r = t.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const l = t.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => e.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: o
      }));
    }, t.getTopRows = ct(() => [t.getRowModel().rows, t.getState().rowPinning.top], (e, n) => t._getPinnedRows(e, n, "top"), ut(t.options, "debugRows", "getTopRows")), t.getBottomRows = ct(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (e, n) => t._getPinnedRows(e, n, "bottom"), ut(t.options, "debugRows", "getBottomRows")), t.getCenterRows = ct(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return e.filter((i) => !r.has(i.id));
    }, ut(t.options, "debugRows", "getCenterRows"));
  }
}, ST = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: Vn("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = t.getPreGroupedRowModel().flatRows;
        return e ? r.forEach((i) => {
          i.getCanSelect() && (o[i.id] = !0);
        }) : r.forEach((i) => {
          delete o[i.id];
        }), o;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const o = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return t.getRowModel().rows.forEach((i) => {
        ku(r, i.id, o, !0, t);
      }), r;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = ct(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? Gc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ut(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = ct(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? Gc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ut(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = ct(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? Gc(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ut(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let o = !!(e.length && Object.keys(n).length);
      return o && e.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let o = !!e.length;
      return o && e.some((r) => !n[r.id]) && (o = !1), o;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, o) => {
      const r = t.getIsSelected();
      e.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !r, t.getCanSelect() && r === n)
          return i;
        const l = {
          ...i
        };
        return ku(l, t.id, n, (s = o?.selectChildren) != null ? s : !0, e), l;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return T1(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Iu(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Iu(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (o) => {
        var r;
        n && t.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, ku = (t, e, n, o, r) => {
  var i;
  const s = r.getRow(e, !0);
  n ? (s.getCanMultiSelect() || Object.keys(t).forEach((l) => delete t[l]), s.getCanSelect() && (t[e] = !0)) : delete t[e], o && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => ku(t, l.id, n, o, r));
};
function Gc(t, e) {
  const n = t.getState().rowSelection, o = [], r = {}, i = function(s, l) {
    return s.map((a) => {
      var c;
      const u = T1(a, n);
      if (u && (o.push(a), r[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: i(a.subRows)
      }), u)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: i(e.rows),
    flatRows: o,
    rowsById: r
  };
}
function T1(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function Iu(t, e, n) {
  var o;
  if (!((o = t.subRows) != null && o.length)) return !1;
  let r = !0, i = !1;
  return t.subRows.forEach((s) => {
    if (!(i && !r) && (s.getCanSelect() && (T1(s, e) ? i = !0 : r = !1), s.subRows && s.subRows.length)) {
      const l = Iu(s, e);
      l === "all" ? i = !0 : (l === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const Pu = /([0-9]+)/gm, RT = (t, e, n) => P3(er(t.getValue(n)).toLowerCase(), er(e.getValue(n)).toLowerCase()), ET = (t, e, n) => P3(er(t.getValue(n)), er(e.getValue(n))), NT = (t, e, n) => O1(er(t.getValue(n)).toLowerCase(), er(e.getValue(n)).toLowerCase()), kT = (t, e, n) => O1(er(t.getValue(n)), er(e.getValue(n))), IT = (t, e, n) => {
  const o = t.getValue(n), r = e.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, PT = (t, e, n) => O1(t.getValue(n), e.getValue(n));
function O1(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function er(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function P3(t, e) {
  const n = t.split(Pu).filter(Boolean), o = e.split(Pu).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), i = o.shift(), s = parseInt(r, 10), l = parseInt(i, 10), a = [s, l].sort();
    if (isNaN(a[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - o.length;
}
const Vi = {
  alphanumeric: RT,
  alphanumericCaseSensitive: ET,
  text: NT,
  textCaseSensitive: kT,
  datetime: IT,
  basic: PT
}, MT = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: Vn("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const i = r?.getValue(t.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Vi.datetime;
        if (typeof i == "string" && (o = !0, i.split(Pu).length > 1))
          return Vi.alphanumeric;
      }
      return o ? Vi.text : Vi.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(t.id) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return za(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (o = e.options.sortingFns) == null ? void 0 : o[t.columnDef.sortingFn]) != null ? n : Vi[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, o) => {
      const r = t.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      e.setSorting((s) => {
        const l = s?.find((p) => p.id === t.id), a = s?.findIndex((p) => p.id === t.id);
        let c = [], u, d = i ? n : r === "desc";
        if (s != null && s.length && t.getCanMultiSort() && o ? l ? u = "toggle" : u = "add" : s != null && s.length && a !== s.length - 1 ? u = "replace" : l ? u = "toggle" : u = "replace", u === "toggle" && (i || r || (u = "remove")), u === "add") {
          var f;
          c = [...s, {
            id: t.id,
            desc: d
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = s.map((p) => p.id === t.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = s.filter((p) => p.id !== t.id) : c = [{
          id: t.id,
          desc: d
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = t.columnDef.sortDescFirst) != null ? o : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var o, r;
      const i = t.getFirstSortDir(), s = t.getIsSorted();
      return s ? s !== i && ((o = e.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = e.options.enableMultiRemove) != null) || r) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, t.getCanSort = () => {
      var n, o;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((o = e.options.enableSorting) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, o;
      return (n = (o = t.columnDef.enableMultiSort) != null ? o : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const o = (n = e.getState().sorting) == null ? void 0 : n.find((r) => r.id === t.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, o;
      return (n = (o = e.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, o;
      t.setSorting(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, TT = [
  XM,
  bT,
  fT,
  pT,
  JM,
  eT,
  vT,
  //depends on ColumnFaceting
  yT,
  //depends on ColumnFiltering
  MT,
  uT,
  //depends on RowSorting
  xT,
  CT,
  wT,
  ST,
  gT
];
function OT(t) {
  var e, n;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const o = [...TT, ...(e = t._features) != null ? e : []];
  let r = {
    _features: o
  };
  const i = r._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(r)), {}), s = (f) => r.options.mergeOptions ? r.options.mergeOptions(i, f) : {
    ...i,
    ...f
  };
  let a = {
    ...{},
    ...(n = t.initialState) != null ? n : {}
  };
  r._features.forEach((f) => {
    var p;
    a = (p = f.getInitialState == null ? void 0 : f.getInitialState(a)) != null ? p : a;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: o,
    options: {
      ...i,
      ...t
    },
    initialState: a,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (f) => {
      const p = Go(f, r.options);
      r.options = s(p);
    },
    getState: () => r.options.state,
    setState: (f) => {
      r.options.onStateChange == null || r.options.onStateChange(f);
    },
    _getRowId: (f, p, m) => {
      var h;
      return (h = r.options.getRowId == null ? void 0 : r.options.getRowId(f, p, m)) != null ? h : `${m ? [m.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let m = (p ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[f];
      if (!m && (m = r.getCoreRowModel().rowsById[f], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: ct(() => [r.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (m) => {
          const h = m.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var h, b;
          return (h = (b = m.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? h : null;
        },
        ...r._features.reduce((m, h) => Object.assign(m, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...f
      };
    }, ut(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: ct(() => [r._getColumnDefs()], (f) => {
      const p = function(m, h, b) {
        return b === void 0 && (b = 0), m.map((v) => {
          const C = ZM(r, v, b, h), y = v;
          return C.columns = y.columns ? p(y.columns, C, b + 1) : [], C;
        });
      };
      return p(f);
    }, ut(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ct(() => [r.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), ut(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ct(() => [r.getAllFlatColumns()], (f) => f.reduce((p, m) => (p[m.id] = m, p), {}), ut(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ct(() => [r.getAllColumns(), r._getOrderColumnsFn()], (f, p) => {
      let m = f.flatMap((h) => h.getLeafColumns());
      return p(m);
    }, ut(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = r._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(r, d);
  for (let f = 0; f < r._features.length; f++) {
    const p = r._features[f];
    p == null || p.createTable == null || p.createTable(r);
  }
  return r;
}
function DT() {
  return (t) => ct(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, i, s) {
      i === void 0 && (i = 0);
      const l = [];
      for (let c = 0; c < r.length; c++) {
        const u = QM(t, t._getRowId(r[c], c, s), r[c], c, i, void 0, s?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, l.push(u), t.options.getSubRows) {
          var a;
          u.originalSubRows = t.options.getSubRows(r[c], c), (a = u.originalSubRows) != null && a.length && (u.subRows = o(u.originalSubRows, i + 1, u));
        }
      }
      return l;
    };
    return n.rows = o(e), n;
  }, ut(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function _T(t) {
  const e = [], n = (o) => {
    var r;
    e.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function VT(t) {
  return (e) => ct(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: a
    } = o;
    const c = r * i, u = c + r;
    s = s.slice(c, u);
    let d;
    e.options.paginateExpandedRows ? d = {
      rows: s,
      flatRows: l,
      rowsById: a
    } : d = _T({
      rows: s,
      flatRows: l,
      rowsById: a
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, ut(e.options, "debugTable", "getPaginationRowModel"));
}
function AT() {
  return (t) => ct(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const o = t.getState().sorting, r = [], i = o.filter((a) => {
      var c;
      return (c = t.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), s = {};
    i.forEach((a) => {
      const c = t.getColumn(a.id);
      c && (s[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (a) => {
      const c = a.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < i.length; p += 1) {
          var f;
          const m = i[p], h = s[m.id], b = h.sortUndefined, v = (f = m?.desc) != null ? f : !1;
          let C = 0;
          if (b) {
            const y = u.getValue(m.id), w = d.getValue(m.id), R = y === void 0, S = w === void 0;
            if (R || S) {
              if (b === "first") return R ? -1 : 1;
              if (b === "last") return R ? 1 : -1;
              C = R && S ? 0 : R ? b : -b;
            }
          }
          if (C === 0 && (C = h.sortingFn(u, d, m.id)), C !== 0)
            return v && (C *= -1), h.invertSorting && (C *= -1), C;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        r.push(u), (d = u.subRows) != null && d.length && (u.subRows = l(u.subRows));
      }), c;
    };
    return {
      rows: l(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, ut(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Cg(t, e) {
  return t ? LT(t) ? /* @__PURE__ */ x.createElement(t, e) : t : null;
}
function LT(t) {
  return FT(t) || typeof t == "function" || $T(t);
}
function FT(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function $T(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function HT(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = x.useState(() => ({
    current: OT(e)
  })), [o, r] = x.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...t,
    state: {
      ...o,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      r(s), t.onStateChange == null || t.onStateChange(s);
    }
  })), n.current;
}
const zT = {
  starting: "169px",
  text: "170px",
  doubleLine: "250px",
  chip: "90px",
  chipText: "250px",
  currency: "130px",
  icon: "52px",
  button: "191px",
  toggle: "207px",
  dropdown: "182px",
  input: "var(--table-input-cell-width)",
  calendar: "208px",
  expand: "80px",
  endingSpacer: "8px"
}, BT = ae(["w-full", "caption-bottom", "border-collapse", "bg-table-row-light-surface", "text-text-default", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "@max-[480px]/data-table:[--table-input-cell-width:167px]", "@max-[480px]/data-table:[--table-row-height:56px]"], {
  variants: {
    size: {
      sm: ["[--table-input-cell-width:167px]", "[--table-row-height:56px]"],
      md: ["[--table-input-cell-width:167px]", "[--table-row-height:68px]"],
      lg: ["[--table-input-cell-width:208px]", "[--table-row-height:84px]"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), WT = ae(["relative", "border-b", "border-table-outline", "transition-[box-shadow]", "duration-200", "ease-in-out", "data-[interactive]:cursor-pointer", "data-[selected]:bg-table-row-select"], {
  variants: {
    section: {
      header: ["h-(--spacing-40)"],
      body: ["h-(--table-row-height)", "hover:z-[1]", "hover:shadow-elevation-2"]
    }
  },
  defaultVariants: {
    section: "body"
  }
}), UT = ae(["[&>td:first-child]:relative", "[&>td:first-child]:before:pointer-events-none", "[&>td:first-child]:before:absolute", "[&>td:first-child]:before:inset-y-0", "[&>td:first-child]:before:left-0", "[&>td:first-child]:before:w-(--spacing-4)", "[&>td:first-child]:before:content-['']"], {
  variants: {
    tone: {
      brand: "[&>td:first-child]:before:bg-primary",
      positive: "[&>td:first-child]:before:bg-positive",
      warning: "[&>td:first-child]:before:bg-accessibility-warning",
      negative: "[&>td:first-child]:before:bg-negative",
      informative: "[&>td:first-child]:before:bg-informative"
    }
  }
}), M3 = ae([], {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), GT = ae(["h-(--spacing-40)", "whitespace-nowrap", "border-b", "border-table-outline", "bg-table-row-alt-surface", "py-0", "align-middle", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-16)", "text-table-header-text"], {
  variants: {
    variant: {
      default: ["px-(--spacing-16)"],
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      spacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), YT = ae(["h-(--table-row-height)", "min-w-0", "px-(--spacing-16)", "py-0", "align-middle", "text-text-default"], {
  variants: {
    variant: {
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      text: null,
      doubleLine: null,
      chip: null,
      chipText: null,
      currency: ["font-(family-name:--font-family-label)"],
      icon: ["px-(--spacing-16)", "text-center"],
      button: null,
      toggle: null,
      dropdown: null,
      input: null,
      calendar: null,
      expand: ["px-(--spacing-16)", "text-center"],
      endingSpacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "text"
  }
});
function T3(t, e) {
  return t !== void 0 ? typeof t == "number" ? `${t}px` : t : e ? zT[e] : void 0;
}
function O3(t, e) {
  return e ? {
    ...t,
    width: e,
    minWidth: e
  } : t;
}
function D3(t) {
  if (t === "compact") return "@max-[480px]/data-table:hidden";
  if (t === "comfortable") return "@max-[768px]/data-table:hidden";
  if (t === "expanded") return "@max-[1024px]/data-table:hidden";
  if (t === "wide") return "@max-[1280px]/data-table:hidden";
}
function jT(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    style: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "md" : r;
  let s;
  e[4] !== i ? (s = BT({
    size: i
  }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== i || e[8] !== o || e[9] !== s ? (l = /* @__PURE__ */ g("table", { "data-slot": "table", "data-size": i, className: s, style: o, ...n }), e[6] = n, e[7] = i, e[8] = o, e[9] = s, e[10] = l) : l = e[10], l;
}
function KT(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("thead", { "data-slot": "table-header", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function qT(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("tbody", { "data-slot": "table-body", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Yc(t) {
  const e = W.c(17);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    accentTone: n,
    selected: s,
    interactive: l,
    section: i,
    children: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !1 : s, c = l === void 0 ? !1 : l, u = a ? "" : void 0, d = c ? "" : void 0, f = a || void 0;
  let p;
  e[7] !== n || e[8] !== i ? (p = ne(WT({
    section: i
  }), i !== "header" && n && UT({
    tone: n
  })), e[7] = n, e[8] = i, e[9] = p) : p = e[9];
  let m;
  return e[10] !== o || e[11] !== r || e[12] !== u || e[13] !== d || e[14] !== f || e[15] !== p ? (m = /* @__PURE__ */ g("tr", { "data-slot": "table-row", "data-selected": u, "data-interactive": d, "aria-selected": f, className: p, ...r, children: o }), e[10] = o, e[11] = r, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m) : m = e[16], m;
}
function ZT(t) {
  return t || "none";
}
function wg(t, e) {
  return t ? t === e ? "text-primary" : "text-icon-disabled" : "text-icon-main";
}
function XT(t) {
  const e = W.c(13), {
    direction: n
  } = t;
  let o;
  e[0] !== n ? (o = ne("absolute left-(--spacing-2) top-[3px] inline-flex", wg(n, "ascending")), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(Ue, { name: "chevron-up", size: "xs", tone: "inherit" }), e[2] = r) : r = e[2];
  let i;
  e[3] !== o ? (i = /* @__PURE__ */ g("span", { className: o, children: r }), e[3] = o, e[4] = i) : i = e[4];
  let s;
  e[5] !== n ? (s = ne("absolute left-(--spacing-2) top-[9px] inline-flex", wg(n, "descending")), e[5] = n, e[6] = s) : s = e[6];
  let l;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g(Ue, { name: "chevron-down", size: "xs", tone: "inherit" }), e[7] = l) : l = e[7];
  let a;
  e[8] !== s ? (a = /* @__PURE__ */ g("span", { className: s, children: l }), e[8] = s, e[9] = a) : a = e[9];
  let c;
  return e[10] !== i || e[11] !== a ? (c = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "relative block h-[28px] w-(--spacing-20) shrink-0", children: [
    i,
    a
  ] }), e[10] = i, e[11] = a, e[12] = c) : c = e[12], c;
}
function xl(t) {
  const e = W.c(72);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    align: n,
    children: o,
    leadingCheckbox: i,
    sortable: c,
    sortDirection: u,
    tooltip: d,
    hideBelow: r,
    variant: f,
    width: p,
    style: a,
    onSort: s,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const m = c === void 0 ? !1 : c, h = u === void 0 ? !1 : u;
  let b, v, C, y, w;
  if (e[13] !== n || e[14] !== o || e[15] !== r || e[16] !== i || e[17] !== s || e[18] !== h || e[19] !== m || e[20] !== a || e[21] !== d || e[22] !== f || e[23] !== p) {
    const S = T3(p);
    let E;
    e[29] !== d ? (E = d ? /* @__PURE__ */ g(Xo, { label: d, showArrow: !1, children: /* @__PURE__ */ g("button", { type: "button", className: "inline-flex shrink-0 items-center border-0 bg-transparent p-0 text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "aria-label": d, children: /* @__PURE__ */ g(Ue, { name: "circle-info", size: "xs", tone: "inherit" }) }) }) : null, e[29] = d, e[30] = E) : E = e[30];
    const N = E, I = n === "right" && "justify-end", M = n === "center" && "justify-center";
    let T;
    e[31] !== I || e[32] !== M ? (T = ne("flex min-w-0 items-center gap-(--spacing-8)", I, M), e[31] = I, e[32] = M, e[33] = T) : T = e[33];
    let k;
    e[34] !== o ? (k = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: o }), e[34] = o, e[35] = k) : k = e[35];
    let P;
    e[36] !== h || e[37] !== m ? (P = m && /* @__PURE__ */ g(XT, { direction: h }), e[36] = h, e[37] = m, e[38] = P) : P = e[38];
    let D;
    e[39] !== T || e[40] !== k || e[41] !== P ? (D = /* @__PURE__ */ F("span", { className: T, children: [
      k,
      P
    ] }), e[39] = T, e[40] = k, e[41] = P, e[42] = D) : D = e[42];
    const O = D, V = n === "right" && "justify-end", _ = n === "center" && "justify-center";
    let A;
    e[43] !== V || e[44] !== _ ? (A = ne("flex min-w-0 items-center gap-(--spacing-12)", V, _), e[43] = V, e[44] = _, e[45] = A) : A = e[45];
    let L;
    e[46] !== i ? (L = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0", children: i }), e[46] = i, e[47] = L) : L = e[47];
    let $;
    e[48] !== n || e[49] !== O || e[50] !== s || e[51] !== m ? ($ = m ? /* @__PURE__ */ g("button", { type: "button", onClick: s, className: ne("flex h-full min-w-0 items-center bg-transparent p-0 text-inherit", "border-0 outline-none cursor-pointer", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", n === "right" && "justify-end", n === "center" && "justify-center"), children: O }) : O, e[48] = n, e[49] = O, e[50] = s, e[51] = m, e[52] = $) : $ = e[52];
    let B;
    e[53] !== A || e[54] !== L || e[55] !== $ || e[56] !== N ? (B = /* @__PURE__ */ F("span", { className: A, children: [
      L,
      $,
      N
    ] }), e[53] = A, e[54] = L, e[55] = $, e[56] = N, e[57] = B) : B = e[57], b = B, v = "table-head", e[58] !== h || e[59] !== m ? (C = m ? ZT(h) : void 0, e[58] = h, e[59] = m, e[60] = C) : C = e[60], e[61] !== n || e[62] !== r || e[63] !== f ? (y = ne(GT({
      variant: f
    }), M3({
      align: n
    }), D3(r)), e[61] = n, e[62] = r, e[63] = f, e[64] = y) : y = e[64], w = O3(a, S), e[13] = n, e[14] = o, e[15] = r, e[16] = i, e[17] = s, e[18] = h, e[19] = m, e[20] = a, e[21] = d, e[22] = f, e[23] = p, e[24] = b, e[25] = v, e[26] = C, e[27] = y, e[28] = w;
  } else
    b = e[24], v = e[25], C = e[26], y = e[27], w = e[28];
  let R;
  return e[65] !== b || e[66] !== l || e[67] !== v || e[68] !== C || e[69] !== y || e[70] !== w ? (R = /* @__PURE__ */ g("th", { "data-slot": v, "aria-sort": C, className: y, style: w, ...l, children: b }), e[65] = b, e[66] = l, e[67] = v, e[68] = C, e[69] = y, e[70] = w, e[71] = R) : R = e[71], R;
}
function QT(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    align: n,
    variant: a,
    hideBelow: r,
    width: c,
    style: s,
    children: o,
    emptyFallback: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = l === void 0 ? "--" : l, d = a ?? "text";
  let f, p, m, h, b;
  if (e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== d || e[13] !== s || e[14] !== c) {
    const y = T3(c, d);
    f = o == null || typeof o == "string" && o.trim() === "", p = "table-cell", m = d, e[20] !== n || e[21] !== r || e[22] !== d ? (h = ne(YT({
      variant: d
    }), M3({
      align: n
    }), D3(r)), e[20] = n, e[21] = r, e[22] = d, e[23] = h) : h = e[23], b = O3(s, y), e[9] = n, e[10] = o, e[11] = r, e[12] = d, e[13] = s, e[14] = c, e[15] = f, e[16] = p, e[17] = m, e[18] = h, e[19] = b;
  } else
    f = e[15], p = e[16], m = e[17], h = e[18], b = e[19];
  const v = d === "endingSpacer" ? null : f ? u : o;
  let C;
  return e[24] !== i || e[25] !== p || e[26] !== m || e[27] !== h || e[28] !== b || e[29] !== v ? (C = /* @__PURE__ */ g("td", { "data-slot": p, "data-variant": m, className: h, style: b, ...i, children: v }), e[24] = i, e[25] = p, e[26] = m, e[27] = h, e[28] = b, e[29] = v, e[30] = C) : C = e[30], C;
}
function _3(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex min-w-0 flex-col gap-(--spacing-2)", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function D1(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function _1(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtext", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function JT(t) {
  const e = W.c(15), {
    status: n,
    checkbox: o,
    thumbnail: r,
    avatar: i,
    icon: s,
    primary: l,
    secondary: a,
    chip: c
  } = t;
  let u;
  e[0] !== l ? (u = /* @__PURE__ */ g(D1, { children: l }), e[0] = l, e[1] = u) : u = e[1];
  let d;
  e[2] !== c || e[3] !== a ? (d = (a || c) && /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-4) pt-(--spacing-4)", children: [
    a && /* @__PURE__ */ g(_1, { children: a }),
    c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
  ] }), e[2] = c, e[3] = a, e[4] = d) : d = e[4];
  let f;
  e[5] !== u || e[6] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-col justify-center", children: [
    u,
    d
  ] }), e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  let p;
  return e[8] !== i || e[9] !== o || e[10] !== s || e[11] !== n || e[12] !== f || e[13] !== r ? (p = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    o,
    r,
    i,
    s,
    f
  ] }), e[8] = i, e[9] = o, e[10] = s, e[11] = n, e[12] = f, e[13] = r, e[14] = p) : p = e[14], p;
}
function eO(t) {
  const e = W.c(15), {
    leadingIcon: n,
    main: o,
    supporting: r,
    trailingIcon: i
  } = t;
  let s;
  e[0] !== n ? (s = n && /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(D1, { children: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r && /* @__PURE__ */ g(_1, { children: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  e[6] !== l || e[7] !== a ? (c = /* @__PURE__ */ F(_3, { children: [
    l,
    a
  ] }), e[6] = l, e[7] = a, e[8] = c) : c = e[8];
  let u;
  e[9] !== i ? (u = i && /* @__PURE__ */ g("span", { className: "shrink-0", children: i }), e[9] = i, e[10] = u) : u = e[10];
  let d;
  return e[11] !== s || e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    s,
    c,
    u
  ] }), e[11] = s, e[12] = c, e[13] = u, e[14] = d) : d = e[14], d;
}
function tO(t) {
  const e = W.c(7), {
    chip: n,
    secondary: o
  } = t;
  let r;
  e[0] !== n ? (r = /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = r) : r = e[1];
  let i;
  e[2] !== o ? (i = o && /* @__PURE__ */ g("span", { className: "min-w-0 truncate text-text-subtext", children: o }), e[2] = o, e[3] = i) : i = e[3];
  let s;
  return e[4] !== r || e[5] !== i ? (s = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    r,
    i
  ] }), e[4] = r, e[5] = i, e[6] = s) : s = e[6], s;
}
const Cl = Object.assign(QT, {
  ChipText: tO,
  Primary: D1,
  Secondary: _1,
  Stack: _3,
  Starting: JT,
  Text: eO
});
function nO(t) {
  return t === "asc" ? "ascending" : t === "desc" ? "descending" : !1;
}
function oO() {
  return import.meta.env?.DEV ?? !1;
}
function x_({
  ariaLabel: t,
  columns: e,
  data: n,
  size: o = "md",
  getRowId: r,
  sorting: i,
  onSortingChange: s,
  manualSorting: l = !1,
  rowSelection: a,
  onRowSelectionChange: c,
  enableRowSelection: u,
  renderExpandedContent: d,
  expanded: f,
  onExpandedChange: p,
  getRowCanExpand: m,
  getRowAccentTone: h,
  onRowClick: b,
  pagination: v,
  manualPagination: C = !1,
  emptyMessage: y = "No results.",
  variant: w = "fullWidth"
}) {
  const [R, S] = qe({}), E = u ?? !!(a || c), N = {
    expanded: f ?? R,
    ...i !== void 0 ? {
      sorting: i
    } : {},
    ...a !== void 0 ? {
      rowSelection: a
    } : {},
    ...v !== void 0 ? {
      pagination: {
        pageIndex: Math.max(0, v.currentPage - 1),
        pageSize: v.rowsPerPage
      }
    } : {}
  }, I = HT({
    data: n,
    columns: e,
    defaultColumn: {
      enableSorting: !1
    },
    getRowId: r,
    state: N,
    enableRowSelection: E,
    onExpandedChange: (_) => {
      f === void 0 && S(_), p?.(_);
    },
    getRowCanExpand: (_) => !!d && (m?.(_.original) ?? !0),
    onSortingChange: s,
    onRowSelectionChange: c,
    manualSorting: l,
    manualPagination: C,
    getCoreRowModel: DT(),
    ...l ? {} : {
      getSortedRowModel: AT()
    },
    ...v !== void 0 && !C ? {
      getPaginationRowModel: VT()
    } : {},
    ...v !== void 0 ? {
      pageCount: v.totalPages
    } : {}
  }), M = I.getVisibleLeafColumns(), T = !!d, k = M.at(-1)?.columnDef.meta?.cellVariant === "endingSpacer", P = T ? k ? 1 : 2 : 0, D = M[0], O = D?.columnDef.meta;
  oO() && D && O?.cellVariant !== "starting" && console.warn("DataTable expects the first visible column to use meta.cellVariant = 'starting' to match the table design-system contract.");
  function V(_) {
    return /* @__PURE__ */ g(Cl, { variant: "expand", emptyFallback: null, children: _.getCanExpand() && /* @__PURE__ */ g("button", { type: "button", "aria-label": _.getIsExpanded() ? "Collapse row" : "Expand row", "aria-expanded": _.getIsExpanded(), onClick: _.getToggleExpandedHandler(), className: "inline-flex size-(--spacing-32) items-center justify-center rounded-(--radius-sm) border border-button-outline-default-border bg-button-outline-default-background text-button-outline-default-text hover:bg-button-outline-hover-background hover:border-button-outline-hover-border active:bg-button-outline-pressed-background active:border-button-outline-pressed-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", children: /* @__PURE__ */ g(Ue, { name: _.getIsExpanded() ? "chevron-up" : "chevron-down", size: "xs", tone: "inherit" }) }) });
  }
  return /* @__PURE__ */ F("div", { "data-slot": "data-table", "data-variant": w, className: ne("@container/data-table w-full", w === "card" && ["overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"]), children: [
    /* @__PURE__ */ g("div", { "data-slot": "data-table-scroll", className: "w-full overflow-x-auto bg-table-row-light-surface pb-(--spacing-8)", children: /* @__PURE__ */ F(jT, { size: o, "aria-label": t, children: [
      /* @__PURE__ */ g(KT, { children: I.getHeaderGroups().map((_) => /* @__PURE__ */ F(Yc, { section: "header", children: [
        _.headers.map((A) => {
          const L = A.column.columnDef.meta, $ = T && k && A.column.id === M.at(-1)?.id, B = k && A.column.getLeafColumns().some((X) => X.id === M.at(-1)?.id), z = A.column.getCanSort(), H = A.column.getToggleSortingHandler(), K = L?.cellVariant === "starting", G = A.column.id === D?.id, q = E && K && G && !A.isPlaceholder, Q = I.getIsAllPageRowsSelected(), U = I.getIsSomePageRowsSelected();
          return /* @__PURE__ */ F(Rl, { children: [
            T && $ && /* @__PURE__ */ g(xl, { variant: "spacer", width: 80, "aria-label": "Row details" }),
            /* @__PURE__ */ g(xl, { colSpan: A.colSpan + (T && B && !$ ? 1 : 0), scope: "col", align: L?.headerAlign ?? L?.align, variant: K ? "starting" : $ ? "spacer" : void 0, width: $ ? L?.width ?? 8 : L?.width, tooltip: L?.tooltip, hideBelow: L?.hideBelow, leadingCheckbox: q ? /* @__PURE__ */ g(AE, { "aria-label": "Select all visible rows", checked: Q, indeterminate: U && !Q, onCheckedChange: (X) => I.toggleAllPageRowsSelected(!!X) }) : void 0, sortable: z, sortDirection: nO(A.column.getIsSorted()), onSort: z && H ? (X) => H(X) : void 0, children: A.isPlaceholder ? null : Cg(A.column.columnDef.header, A.getContext()) }, A.id)
          ] }, A.id);
        }),
        T && !k && /* @__PURE__ */ F(_t, { children: [
          /* @__PURE__ */ g(xl, { variant: "spacer", width: 80, "aria-label": "Row details" }),
          /* @__PURE__ */ g(xl, { variant: "spacer", width: 8 })
        ] })
      ] }, _.id)) }),
      /* @__PURE__ */ g(qT, { children: I.getRowModel().rows.length > 0 ? I.getRowModel().rows.map((_) => /* @__PURE__ */ F(Rl, { children: [
        /* @__PURE__ */ F(Yc, { accentTone: h?.(_.original), selected: _.getIsSelected(), interactive: !!b, onClick: b ? (A) => {
          const L = A.target, $ = A.currentTarget.ownerDocument.getSelection();
          !(L instanceof Element) || !A.currentTarget.contains(L) || $ && !$.isCollapsed && ($.anchorNode && A.currentTarget.contains($.anchorNode) || $.focusNode && A.currentTarget.contains($.focusNode)) || L.closest("a, button, input, label, select, textarea, summary, [role=button], [role=link], [role=checkbox], [role=switch], [role=radio], [role=combobox], [role=menuitem], [role=tab], [contenteditable]:not([contenteditable=false])") || b(_.original);
        } : void 0, children: [
          _.getVisibleCells().map((A) => {
            const L = A.column.columnDef.meta;
            return /* @__PURE__ */ F(Rl, { children: [
              T && k && A.column.id === M.at(-1)?.id && V(_),
              /* @__PURE__ */ g(Cl, { variant: L?.cellVariant, align: L?.align, width: L?.width, hideBelow: L?.hideBelow, "data-hide-below": L?.hideBelow, children: Cg(A.column.columnDef.cell, A.getContext()) }, A.id)
            ] }, A.id);
          }),
          T && !k && /* @__PURE__ */ F(_t, { children: [
            V(_),
            /* @__PURE__ */ g(Cl, { variant: "endingSpacer" })
          ] })
        ] }, _.id),
        T && _.getIsExpanded() && _.getCanExpand() && /* @__PURE__ */ g("tr", { "data-slot": "data-table-expanded-row", children: /* @__PURE__ */ g("td", { colSpan: M.length + P, className: "border-b border-table-outline bg-table-row-light-surface p-(--spacing-24)", children: d?.(_.original) }) })
      ] }, _.id)) : /* @__PURE__ */ g(Yc, { children: /* @__PURE__ */ g(Cl, { colSpan: M.length + P, emptyFallback: null, children: /* @__PURE__ */ g("div", { className: "flex h-(--table-row-height) items-center justify-center text-text-subtext", children: y }) }) }) })
    ] }) }),
    v && /* @__PURE__ */ g("div", { "data-slot": "data-table-pagination", className: ne(w === "card" && "bg-table-row-light-surface"), children: /* @__PURE__ */ g(HP, { ...v }) })
  ] });
}
const rO = ["flex", "flex-row", "items-center", "border-b", "border-outline-variant"].join(" ");
function C_({
  children: t,
  inset: e = !1,
  ...n
}) {
  const {
    onScroll: o,
    ref: r,
    ...i
  } = n, s = at(null), l = at(() => {
  }), [a, c] = qe(!1), [u, d] = qe(!1);
  l.current = function() {
    const h = s.current;
    if (!h) {
      c(!1), d(!1);
      return;
    }
    const b = h.scrollWidth > h.clientWidth;
    c(b && h.scrollLeft > 0), d(b && h.scrollLeft + h.clientWidth < h.scrollWidth - 1);
  };
  function f(m) {
    s.current = m, typeof r == "function" ? r(m) : r && (r.current = m);
  }
  go(() => {
    l.current();
  }), go(() => {
    const m = s.current;
    if (!m || typeof ResizeObserver > "u")
      return;
    const h = new ResizeObserver(() => {
      l.current();
    });
    h.observe(m);
    for (const v of m.children)
      h.observe(v);
    const b = new MutationObserver(() => {
      for (const v of m.children)
        h.observe(v);
      l.current();
    });
    return b.observe(m, {
      childList: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, []);
  function p(m) {
    l.current(), o?.(m);
  }
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    /* @__PURE__ */ g(w1, { ...i, ref: f, onScroll: p, className: ne(rO, "overflow-x-auto", "overflow-y-hidden", e && "px-(--spacing-24)"), children: t }),
    a && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-left", className: "pointer-events-none absolute inset-y-0 left-0 z-10 w-[24px] bg-linear-to-r from-surface to-transparent" }),
    u && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-right", className: "pointer-events-none absolute inset-y-0 right-0 z-10 w-[24px] bg-linear-to-l from-surface to-transparent" })
  ] });
}
const iO = [
  // Layout
  "inline-flex",
  "flex-row",
  "items-center",
  "gap-(--spacing-8)",
  "px-(--spacing-12)",
  "py-(--spacing-6)",
  "rounded-tl-(--radius-sm)",
  "rounded-tr-(--radius-sm)",
  // Typography base
  "font-(family-name:--font-family-body)",
  "text-(length:--font-size-body-large)",
  "leading-(--font-line-height-24)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "outline-none",
  "cursor-pointer",
  "select-none",
  "relative",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Hover state (pointer devices only, not on disabled)
  "not-data-[disabled]:hover:bg-surface-hover",
  // Pressed state
  "not-data-[disabled]:active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-inset",
  "focus-visible:ring-button-focus-ring",
  // Disabled state
  "data-[disabled]:opacity-50",
  "data-[disabled]:pointer-events-none",
  "data-[disabled]:cursor-default"
].join(" "), sO = ["text-text-subtext", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-(--spacing-2)", "after:translate-y-px", "after:bg-transparent", "after:transition-colors", "after:duration-200", "after:ease-in-out", "group", "data-[active]:text-text-default", "data-[active]:after:bg-primary"].join(" ");
function w_(t) {
  const e = W.c(18);
  let n, o, r, i;
  e[0] !== t ? ({
    icon: r,
    chipLabel: o,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = ne(iO, sO), e[5] = s) : s = e[5];
  let l;
  e[6] !== r ? (l = r && /* @__PURE__ */ g(Ue, { name: r, size: "sm", tone: "inherit" }), e[6] = r, e[7] = l) : l = e[7];
  const a = typeof n == "string" ? n : void 0;
  let c;
  e[8] !== n || e[9] !== a ? (c = /* @__PURE__ */ g("span", { "data-text": a, className: "relative flex flex-col items-center group-data-[active]:font-semibold before:content-[attr(data-text)] before:font-semibold before:invisible before:h-0 before:overflow-hidden before:pointer-events-none", children: n }), e[8] = n, e[9] = a, e[10] = c) : c = e[10];
  let u;
  e[11] !== o ? (u = o != null && /* @__PURE__ */ g(Wn, { tone: "neutral", label: o, "aria-hidden": !0 }), e[11] = o, e[12] = u) : u = e[12];
  let d;
  return e[13] !== i || e[14] !== l || e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(C1, { className: s, ...i, children: [
    l,
    c,
    u
  ] }), e[13] = i, e[14] = l, e[15] = c, e[16] = u, e[17] = d) : d = e[17], d;
}
function S_(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(n3, { className: "outline-none", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function R_(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(v1, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const lO = ae("text-surface-on-surface", {
  variants: {
    tone: {
      base: ["bg-surface-container-lowest"],
      muted: ["bg-surface-container-low"],
      neutral: ["bg-surface-container"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    },
    padding: {
      none: "p-0",
      dense: "px-(--spacing-8) py-(--spacing-10)",
      compact: "p-(--spacing-12)",
      comfortable: "px-(--spacing-20) py-(--spacing-16)"
    },
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    },
    aspect: {
      auto: null,
      square: "aspect-square"
    },
    centered: {
      true: "grid place-items-center",
      false: null
    },
    width: {
      auto: null,
      content: "w-fit",
      full: "w-full"
    }
  },
  defaultVariants: {
    tone: "base",
    padding: "comfortable",
    radius: "sm",
    aspect: "auto",
    centered: !1,
    width: "auto"
  }
});
function E_(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    tone: r,
    padding: i,
    radius: s,
    aspect: l,
    centered: a,
    width: c,
    hasBorder: u,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = r === void 0 ? "base" : r, f = i === void 0 ? "comfortable" : i, p = s === void 0 ? "sm" : s, m = l === void 0 ? "auto" : l, h = a === void 0 ? !1 : a, b = c === void 0 ? "auto" : c, v = u === void 0 ? !1 : u, C = h || void 0;
  let y;
  e[10] !== m || e[11] !== h || e[12] !== v || e[13] !== f || e[14] !== p || e[15] !== d || e[16] !== b ? (y = ne(lO({
    tone: d,
    padding: f,
    radius: p,
    aspect: m,
    centered: h,
    width: b
  }), v && "border border-outline-subtle", "shadow-elevation-1"), e[10] = m, e[11] = h, e[12] = v, e[13] = f, e[14] = p, e[15] = d, e[16] = b, e[17] = y) : y = e[17];
  let w;
  return e[18] !== m || e[19] !== n || e[20] !== f || e[21] !== o || e[22] !== p || e[23] !== C || e[24] !== y || e[25] !== d || e[26] !== b ? (w = /* @__PURE__ */ g("div", { "data-slot": "tile", "data-tone": d, "data-padding": f, "data-radius": p, "data-aspect": m, "data-centered": C, "data-width": b, className: y, ...o, children: n }), e[18] = m, e[19] = n, e[20] = f, e[21] = o, e[22] = p, e[23] = C, e[24] = y, e[25] = d, e[26] = b, e[27] = w) : w = e[27], w;
}
function V3(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM";
  return `${e === 0 ? 12 : e > 12 ? e - 12 : e}:${String(n).padStart(2, "0")} ${o}`;
}
function Hs(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM", r = e === 0 ? 12 : e > 12 ? e - 12 : e;
  return {
    hour: String(r).padStart(2, "0"),
    minute: String(n).padStart(2, "0"),
    period: o
  };
}
function aO(t) {
  const e = Number(t.hour);
  let n = t.period === "PM" ? e + 12 : e;
  return t.period === "AM" && e === 12 && (n = 0), t.period === "PM" && e === 12 && (n = 12), `${String(n).padStart(2, "0")}:${t.minute}`;
}
function Sg(t) {
  const e = t.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!e) return null;
  let n = parseInt(e[1], 10);
  const o = parseInt(e[2], 10), r = e[3].toUpperCase();
  return n < 1 || n > 12 || o < 0 || o > 59 ? null : (r === "AM" ? n === 12 && (n = 0) : n !== 12 && (n += 12), `${String(n).padStart(2, "0")}:${String(o).padStart(2, "0")}`);
}
function cO(t, e, n) {
  const o = [];
  for (let r = 0; r < 1440; r += t) {
    const i = Math.floor(r / 60), s = r % 60, l = `${String(i).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    e && l < e || n && l > n || o.push({
      value: l,
      label: V3(l)
    });
  }
  return o;
}
function uO(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((o) => {
    const r = Hs(o.value);
    n.add(r[e]);
  }), [...n];
}
function dO(t, e) {
  const n = Hs(t.value);
  return n.hour === e.hour && n.minute === e.minute && n.period === e.period;
}
function fO({
  options: t,
  currentParts: e,
  column: n,
  partValue: o
}) {
  const r = {
    ...e,
    [n]: o
  }, i = t.find((s) => dO(s, r));
  return i ? i.value : t.find((s) => Hs(s.value)[n] === o)?.value ?? t[0]?.value ?? aO(r);
}
function pO(t, e) {
  return Hs(t?.value ?? e[0]?.value ?? "00:00");
}
function jc({
  options: t,
  currentParts: e,
  column: n
}) {
  return uO(t, n).map((o) => ({
    kind: n,
    value: `${n}-${o}`,
    label: o,
    partValue: o,
    nextValue: fO({
      options: t,
      currentParts: e,
      column: n,
      partValue: o
    })
  }));
}
const mO = ae(["flex", "items-center", "gap-(--spacing-4)", "w-[228px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function A3(t, e) {
  return e[t.kind] === t.partValue;
}
function gO(t, e) {
  return t.kind === "time" && e.kind === "time" ? t.value === e.value : t.kind !== "time" && e.kind === "time" ? A3(t, Hs(e.value)) : t.value === e.value;
}
function Kc(t) {
  const e = W.c(19), {
    option: n,
    selectedParts: o
  } = t;
  let r, i, s, l, a;
  e[0] !== n || e[1] !== o ? (i = A3(n, o), r = As, s = n, l = `${n.kind} ${n.label}`, a = ne(bo({}), "justify-center px-(--spacing-8)", i && "bg-menu-item-selected"), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a) : (r = e[2], i = e[3], s = e[4], l = e[5], a = e[6]);
  let c;
  e[7] !== n.label ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 text-center", children: n.label }), e[7] = n.label, e[8] = c) : c = e[8];
  let u;
  e[9] !== n.kind || e[10] !== i ? (u = i && n.kind === "period" && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ue, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[9] = n.kind, e[10] = i, e[11] = u) : u = e[11];
  let d;
  return e[12] !== r || e[13] !== s || e[14] !== l || e[15] !== a || e[16] !== c || e[17] !== u ? (d = /* @__PURE__ */ F(r, { value: s, "aria-label": l, className: a, children: [
    c,
    u
  ] }), e[12] = r, e[13] = s, e[14] = l, e[15] = a, e[16] = c, e[17] = u, e[18] = d) : d = e[18], d;
}
function qc() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "h-[36px]" }), t[0] = e) : e = t[0], e;
}
function N_(t) {
  const e = W.c(89), {
    value: n,
    onValueChange: o,
    id: r,
    label: i,
    placeholder: s,
    size: l,
    required: a,
    description: c,
    tooltip: u,
    error: d,
    disabled: f,
    minuteStep: p,
    minTime: m,
    maxTime: h,
    name: b,
    "data-testid": v
  } = t, C = s === void 0 ? "--:--" : s, y = l === void 0 ? "md" : l, w = f === void 0 ? !1 : f, R = p === void 0 ? 15 : p, S = en(), [E, N] = qe(!1), I = $t(), M = r ?? I, T = $t(), k = !!d;
  let P, D, O, V;
  if (e[0] !== h || e[1] !== m || e[2] !== R || e[3] !== n) {
    P = cO(R, m, h), D = n ? {
      ...P.find((Me) => Me.value === n) ?? {
        value: n,
        label: V3(n)
      },
      kind: "time"
    } : null, O = pO(D, P);
    const de = {
      hour: jc({
        options: P,
        currentParts: O,
        column: "hour"
      }),
      minute: jc({
        options: P,
        currentParts: O,
        column: "minute"
      }),
      period: jc({
        options: P,
        currentParts: O,
        column: "period"
      })
    }, Se = Math.max(de.hour.length, de.minute.length, de.period.length);
    V = Array.from({
      length: Se
    }, (Me, Re) => ({
      hour: de.hour[Re],
      minute: de.minute[Re],
      period: de.period[Re]
    })), e[0] = h, e[1] = m, e[2] = R, e[3] = n, e[4] = P, e[5] = D, e[6] = O, e[7] = V;
  } else
    P = e[4], D = e[5], O = e[6], V = e[7];
  const _ = V;
  let A;
  e[8] !== P || e[9] !== o || e[10] !== n ? (A = function(Se) {
    const Me = Sg(Se.currentTarget.value);
    Me !== null && Me !== n && P.some((Re) => Re.value === Me) && o(Me);
  }, e[8] = P, e[9] = o, e[10] = n, e[11] = A) : A = e[11];
  const L = A;
  let $;
  e[12] !== P || e[13] !== o || e[14] !== n ? ($ = function(Se) {
    const Me = Se.currentTarget.value.trim();
    if (Me === "") {
      n !== null && o(null);
      return;
    }
    const Re = Sg(Me);
    Re !== null && Re !== n && P.some((Ve) => Ve.value === Re) && o(Re);
  }, e[12] = P, e[13] = o, e[14] = n, e[15] = $) : $ = e[15];
  const B = $;
  let z;
  e[16] !== o ? (z = function(Se) {
    if (Se === null) {
      o(null);
      return;
    }
    o(Se.kind === "time" ? Se.value : Se.nextValue);
  }, e[16] = o, e[17] = z) : z = e[17];
  const H = z, K = w && "pointer-events-none";
  let G;
  e[18] !== K ? (G = ne("flex flex-col w-fit", K), e[18] = K, e[19] = G) : G = e[19];
  let q;
  e[20] !== M || e[21] !== i || e[22] !== a || e[23] !== u ? (q = i && /* @__PURE__ */ g(yi, { htmlFor: M, label: i, required: a, tooltip: u }), e[20] = M, e[21] = i, e[22] = a, e[23] = u, e[24] = q) : q = e[24];
  let Q;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Q = (de, Se) => {
    N(!de && Se.reason === "item-press" ? !0 : de);
  }, e[25] = Q) : Q = e[25];
  let U;
  e[26] !== w || e[27] !== k || e[28] !== y ? (U = ne(mO({
    size: y,
    hasError: k
  }), w && "opacity-50"), e[26] = w, e[27] = k, e[28] = y, e[29] = U) : U = e[29];
  const X = i ? void 0 : "Choose time", te = a || void 0, re = k || void 0, J = c || d ? T : void 0, ie = k && "text-input-error-text";
  let ce;
  e[30] !== ie ? (ce = ne("flex-1", "min-w-0", "outline-none", "bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-input-text-placeholder", ie), e[30] = ie, e[31] = ce) : ce = e[31];
  let oe;
  e[32] !== v || e[33] !== B || e[34] !== L || e[35] !== M || e[36] !== C || e[37] !== X || e[38] !== te || e[39] !== re || e[40] !== J || e[41] !== ce ? (oe = /* @__PURE__ */ g(_s, { id: M, "data-testid": v, placeholder: C, "aria-autocomplete": "list", "aria-label": X, "aria-required": te, "aria-invalid": re, "aria-describedby": J, onChange: L, onBlur: B, className: ce }), e[32] = v, e[33] = B, e[34] = L, e[35] = M, e[36] = C, e[37] = X, e[38] = te, e[39] = re, e[40] = J, e[41] = ce, e[42] = oe) : oe = e[42];
  let se;
  e[43] !== w || e[44] !== D ? (se = D !== null && !w && /* @__PURE__ */ g(t1, { "aria-label": "Clear time", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "xs", tone: "inherit" }) }), e[43] = w, e[44] = D, e[45] = se) : se = e[45];
  const me = v ? `${v}-trigger` : void 0;
  let pe;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (pe = /* @__PURE__ */ g(Ue, { name: "clock-seven", size: "xs", tone: "secondary" }), e[46] = pe) : pe = e[46];
  let le;
  e[47] !== me ? (le = /* @__PURE__ */ g(_a, { "data-testid": me, "aria-label": "Open time picker", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: pe }), e[47] = me, e[48] = le) : le = e[48];
  let ge;
  e[49] !== se || e[50] !== le ? (ge = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    se,
    le
  ] }), e[49] = se, e[50] = le, e[51] = ge) : ge = e[51];
  let j;
  e[52] !== U || e[53] !== oe || e[54] !== ge ? (j = /* @__PURE__ */ F(Da, { className: U, children: [
    oe,
    ge
  ] }), e[52] = U, e[53] = oe, e[54] = ge, e[55] = j) : j = e[55];
  let ee;
  e[56] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = pi({
    size: "auto",
    className: "w-[228px]"
  }), e[56] = ee) : ee = e[56];
  const Y = v ? `${v}-options` : void 0;
  let Z;
  e[57] !== _ || e[58] !== O ? (Z = _.map((de) => /* @__PURE__ */ F(ib, { className: "grid grid-cols-3 gap-(--spacing-2)", children: [
    de.hour ? /* @__PURE__ */ g(Kc, { option: de.hour, selectedParts: O }) : /* @__PURE__ */ g(qc, {}),
    de.minute ? /* @__PURE__ */ g(Kc, { option: de.minute, selectedParts: O }) : /* @__PURE__ */ g(qc, {}),
    de.period ? /* @__PURE__ */ g(Kc, { option: de.period, selectedParts: O }) : /* @__PURE__ */ g(qc, {})
  ] }, [de.hour?.value ?? "empty-hour", de.minute?.value ?? "empty-minute", de.period?.value ?? "empty-period"].join("-"))), e[57] = _, e[58] = O, e[59] = Z) : Z = e[59];
  let ue;
  e[60] !== Y || e[61] !== Z ? (ue = /* @__PURE__ */ g(Aa, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ g(La, { className: ee, children: /* @__PURE__ */ g(Vs, { "data-testid": Y, "aria-label": "Select a time", className: "flex flex-col gap-(--spacing-2) outline-none", children: Z }) }) }), e[60] = Y, e[61] = Z, e[62] = ue) : ue = e[62];
  let fe;
  e[63] !== S || e[64] !== ue ? (fe = /* @__PURE__ */ g(Va, { container: S, children: ue }), e[63] = S, e[64] = ue, e[65] = fe) : fe = e[65];
  let be;
  e[66] !== w || e[67] !== H || e[68] !== b || e[69] !== E || e[70] !== a || e[71] !== D || e[72] !== j || e[73] !== fe ? (be = /* @__PURE__ */ F(Uf, { open: E, onOpenChange: Q, value: D, onValueChange: H, isItemEqualToValue: gO, itemToStringLabel: bO, itemToStringValue: hO, disabled: w, required: a, name: b, grid: !0, filter: null, autoComplete: "none", children: [
    j,
    fe
  ] }), e[66] = w, e[67] = H, e[68] = b, e[69] = E, e[70] = a, e[71] = D, e[72] = j, e[73] = fe, e[74] = be) : be = e[74];
  let Ie;
  e[75] !== c || e[76] !== T || e[77] !== d || e[78] !== k ? (Ie = k ? /* @__PURE__ */ g(Ar, { match: !0, id: T, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-error-text", children: d }) : c ? /* @__PURE__ */ g(bi, { id: T, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting", children: c }) : null, e[75] = c, e[76] = T, e[77] = d, e[78] = k, e[79] = Ie) : Ie = e[79];
  let ye;
  e[80] !== Ie ? (ye = /* @__PURE__ */ g("div", { "data-testid": "time-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: Ie }), e[80] = Ie, e[81] = ye) : ye = e[81];
  let xe;
  return e[82] !== w || e[83] !== k || e[84] !== G || e[85] !== q || e[86] !== be || e[87] !== ye ? (xe = /* @__PURE__ */ F(Vr, { invalid: k, disabled: w, className: G, children: [
    q,
    be,
    ye
  ] }), e[82] = w, e[83] = k, e[84] = G, e[85] = q, e[86] = be, e[87] = ye, e[88] = xe) : xe = e[88], xe;
}
function hO(t) {
  return t.kind === "time" ? t.value : t.nextValue;
}
function bO(t) {
  return t.label;
}
const Ba = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ba.displayName = "ToastContext");
function V1() {
  const t = x.useContext(Ba);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : st(73));
  return t;
}
let Rg = 0;
function L3(t) {
  return Rg += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${Rg}`;
}
function Zc(t, e) {
  if (typeof t == "string")
    return {
      description: t
    };
  if (typeof t == "function") {
    const n = t(e);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return t;
}
const wl = h9((t) => t.toasts, (t) => {
  const e = /* @__PURE__ */ new Map();
  let n = 0, o = 0;
  return t.forEach((r, i) => {
    const s = r.transitionStatus === "ending";
    e.set(r.id, {
      value: r,
      domIndex: i,
      visibleIndex: s ? -1 : n,
      offsetY: o
    }), o += r.height || 0, s || (n += 1);
  }), e;
}), lo = {
  toasts: he((t) => t.toasts),
  isEmpty: he((t) => t.toasts.length === 0),
  toast: he(wl, (t, e) => t.get(e)?.value),
  toastIndex: he(wl, (t, e) => t.get(e)?.domIndex ?? -1),
  toastOffsetY: he(wl, (t, e) => t.get(e)?.offsetY ?? 0),
  toastVisibleIndex: he(wl, (t, e) => t.get(e)?.visibleIndex ?? -1),
  hovering: he((t) => t.hovering),
  focused: he((t) => t.focused),
  expanded: he((t) => t.hovering || t.focused),
  expandedOrOutOfFocus: he((t) => t.hovering || t.focused || !t.isWindowFocused),
  prevFocusElement: he((t) => t.prevFocusElement)
};
class vO extends Ir {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(e) {
    super(e, {}, lo);
  }
  setFocused(e) {
    this.set("focused", e);
  }
  setHovering(e) {
    this.set("hovering", e);
  }
  setIsWindowFocused(e) {
    this.set("isWindowFocused", e);
  }
  setPrevFocusElement(e) {
    this.set("prevFocusElement", e);
  }
  setViewport = (e) => {
    this.set("viewport", e);
  };
  disposeEffect = () => () => {
    this.timers.forEach((e) => {
      e.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(e, n = {}) {
    const o = lo.toastIndex(this.state, e);
    if (o === -1)
      return;
    const r = this.state.toasts[o];
    n.skipOnRemove || r?.onRemove?.();
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  addToast = (e) => {
    const {
      timeout: n,
      limit: o
    } = this.state, r = e.id || L3("toast");
    if (e.id) {
      const c = lo.toast(this.state, e.id);
      if (c)
        if (c.transitionStatus === "ending")
          this.removeToast(e.id, {
            skipOnRemove: !0
          });
        else {
          const {
            id: u,
            transitionStatus: d,
            ...f
          } = e;
          return this.updateToastInternal(e.id, f, {
            resetTimer: !0,
            markUpdated: !0
          }), e.id;
        }
    }
    const i = {
      ...e,
      id: r,
      updateKey: 0,
      transitionStatus: "starting"
    }, s = [i, ...this.state.toasts], l = s.filter((c) => c.transitionStatus !== "ending");
    if (l.length > o) {
      const c = l.length - o, u = l.slice(-c), d = new Set(u.map((f) => f.id));
      this.setToasts(s.map((f) => {
        const p = d.has(f.id);
        return f.limited !== p ? {
          ...f,
          limited: p
        } : f;
      }));
    } else
      this.setToasts(s.map((c) => c.limited ? {
        ...c,
        limited: !1
      } : c));
    const a = i.timeout ?? n;
    return i.type !== "loading" && a > 0 && this.scheduleTimer(r, a, () => this.closeToast(r)), lo.expandedOrOutOfFocus(this.state) && this.pauseTimers(), r;
  };
  updateToast = (e, n) => {
    this.updateToastInternal(e, n, {
      markUpdated: !0
    });
  };
  updateToastInternal = (e, n, o = {}) => {
    const {
      timeout: r,
      toasts: i
    } = this.state, s = lo.toast(this.state, e) ?? null;
    if (!s || s.transitionStatus === "ending")
      return;
    const l = {
      ...s,
      ...n,
      ...o.markUpdated && {
        updateKey: (s.updateKey ?? 0) + 1
      }
    };
    this.setToasts(i.map((h) => h.id === e ? l : h));
    const a = l.timeout ?? r, c = s?.timeout ?? r, u = Object.hasOwn(n, "timeout"), d = l.transitionStatus !== "ending" && l.type !== "loading" && a > 0, f = this.timers.has(e), p = c !== a, m = s?.type === "loading";
    if (!d && f) {
      this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
      return;
    }
    if (d && (!f || p || u || m || o.resetTimer)) {
      const h = this.timers.get(e);
      h && (h.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, a, () => this.closeToast(e)), lo.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (e) => {
    const n = e === void 0, {
      limit: o,
      toasts: r
    } = this.state;
    let i;
    if (n)
      i = r, this.timers.forEach((c) => {
        c.timeout?.clear();
      }), this.timers.clear();
    else {
      const c = lo.toast(this.state, e);
      if (!c)
        return;
      i = [c];
      const u = this.timers.get(e);
      u?.timeout && (u.timeout.clear(), this.timers.delete(e));
    }
    let s = 0;
    const a = {
      toasts: r.map((c) => {
        if (n || c.id === e)
          return {
            ...c,
            transitionStatus: "ending",
            height: 0
          };
        if (c.transitionStatus === "ending")
          return c;
        const u = s >= o;
        return s += 1, c.limited !== u ? {
          ...c,
          limited: u
        } : c;
      })
    };
    (n || r.length === 1) && (a.hovering = !1, a.focused = !1), this.update(a), i.forEach((c) => {
      c.transitionStatus !== "ending" && c.onClose?.();
    }), this.handleFocusManagement(e);
  };
  promiseToast = (e, n) => {
    const o = Zc(n.loading), r = this.addToast({
      ...o,
      type: "loading"
    }), i = e.then((s) => {
      const l = Zc(n.success, s);
      return this.updateToast(r, {
        ...l,
        type: "success",
        timeout: l.timeout
      }), s;
    }).catch((s) => {
      const l = Zc(n.error, s);
      return this.updateToast(r, {
        ...l,
        type: "error",
        timeout: l.timeout
      }), Promise.reject(s);
    });
    return {}.hasOwnProperty.call(n, "setPromise") && n.setPromise(i), i;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
      if (e.timeout) {
        e.timeout.clear();
        const n = Date.now() - e.start, o = e.delay - n;
        e.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, n) => {
      e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= Pn.create(), e.timeout.start(e.remaining, () => {
        this.timers.delete(n), e.callback();
      }), e.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (e) => {
    if (e.pointerType !== "touch")
      return;
    const n = yt(e);
    Fe(this.state.viewport, n) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(e, n, o) {
    const r = Date.now(), i = !lo.expandedOrOutOfFocus(this.state), s = i ? Pn.create() : void 0;
    s?.start(n, () => {
      this.timers.delete(e), o();
    }), this.timers.set(e, {
      timeout: s,
      start: i ? r : 0,
      delay: n,
      remaining: n,
      callback: o
    });
  }
  setToasts(e) {
    const n = {
      toasts: e
    };
    e.length === 0 && (n.hovering = !1, n.focused = !1), this.update(n);
  }
  handleFocusManagement(e) {
    const n = Xt(nt(this.state.viewport));
    if (!this.state.viewport || !Fe(this.state.viewport, n) || !Bl(n))
      return;
    if (e === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = lo.toasts(this.state), r = lo.toastIndex(this.state, e);
    let i = null, s = r + 1;
    for (; s < o.length; ) {
      if (o[s].transitionStatus !== "ending") {
        i = o[s];
        break;
      }
      s += 1;
    }
    if (!i)
      for (s = r - 1; s >= 0; ) {
        if (o[s].transitionStatus !== "ending") {
          i = o[s];
          break;
        }
        s -= 1;
      }
    i ? i.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const A1 = function(e) {
  const {
    children: n,
    timeout: o = 5e3,
    limit: r = 3,
    toastManager: i
  } = e, s = Lt(() => new vO({
    timeout: o,
    limit: r,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return oi(s.disposeEffect), x.useEffect(function() {
    return i ? i[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? s.promiseToast(u.promise, u) : c === "update" && d ? s.updateToast(d, u) : c === "close" ? s.closeToast(d) : s.addToast(u);
    }) : void 0;
  }, [s, o, i]), s.useSyncedValues({
    timeout: o,
    limit: r
  }), /* @__PURE__ */ g(Ba.Provider, {
    value: s,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (A1.displayName = "ToastProvider");
let yO = /* @__PURE__ */ (function(t) {
  return t.frontmostHeight = "--toast-frontmost-height", t;
})({});
const F3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, a = V1(), c = Bt(), u = x.useRef(!1), d = x.useRef(!1), f = x.useRef(!1), p = a.useState("isEmpty"), m = a.useState("toasts"), h = a.useState("focused"), b = a.useState("expanded"), v = a.useState("prevFocusElement"), C = m[0]?.height ?? 0, y = x.useMemo(() => m.some((_) => _.transitionStatus === "ending"), [m]);
  x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_)
      return;
    function A($) {
      p || $.key === "F6" && yt($) !== _ && ($.preventDefault(), a.setPrevFocusElement(Xt(nt(_))), _?.focus({
        preventScroll: !0
      }), a.pauseTimers(), a.setFocused(!0));
    }
    const L = St(_);
    return dt(L, "keydown", A);
  }, [a, p]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const A = St(_);
    function L(B) {
      yt(B) === A && (a.setIsWindowFocused(!1), a.pauseTimers());
    }
    function $(B) {
      if (B.relatedTarget)
        return;
      const z = yt(B), H = Xt(nt(_));
      (z === A || !Fe(_, z) || !Bl(H)) && a.resumeTimers(), c.start(0, () => a.setIsWindowFocused(!0));
    }
    return Xn(dt(A, "blur", L, !0), dt(A, "focus", $, !0));
  }, [
    a,
    c,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    p
  ]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const A = nt(_);
    return dt(A, "pointerdown", a.handleDocumentPointerDown, !0);
  }, [p, a]);
  function w(_) {
    const A = a.state.viewport;
    A && (u.current = !0, _.relatedTarget === A ? m[0]?.ref?.current?.focus() : a.restoreFocusToPrevElement());
  }
  function R(_) {
    _.key === "Tab" && _.shiftKey && yt(_.nativeEvent) === a.state.viewport && (_.preventDefault(), a.restoreFocusToPrevElement(), a.resumeTimers());
  }
  function S() {
    const _ = a.state.toasts.some((A) => A.transitionStatus === "ending");
    !a.state.isWindowFocused || _ || f.current || !d.current || (a.resumeTimers(), a.setHovering(!1), d.current = !1);
  }
  x.useEffect(S, [y, a]);
  function E() {
    a.pauseTimers(), a.setHovering(!0), d.current = !1;
  }
  function N() {
    y || f.current ? d.current = !0 : (a.resumeTimers(), a.setHovering(!1));
  }
  function I(_) {
    _.pointerType === "touch" && (f.current = !0);
  }
  function M(_) {
    _.pointerType === "touch" && (f.current = !1, S());
  }
  function T() {
    if (u.current) {
      u.current = !1;
      return;
    }
    h || Bl(Xt(nt(a.state.viewport))) && (a.setFocused(!0), a.pauseTimers());
  }
  function k(_) {
    !h || Fe(a.state.viewport, _.relatedTarget) || (a.setFocused(!1), a.resumeTimers());
  }
  const P = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: E,
    onMouseMove: E,
    onMouseLeave: N,
    onFocus: T,
    onBlur: k,
    onKeyDown: R,
    onClick: T,
    onPointerDown: I,
    onPointerUp: M,
    onPointerCancel: M
  }, D = {
    expanded: b
  }, O = Le("div", e, {
    ref: [n, a.setViewport],
    state: D,
    props: [P, {
      style: {
        [yO.frontmostHeight]: C ? `${C}px` : void 0
      }
    }, l, {
      children: /* @__PURE__ */ F(x.Fragment, {
        children: [!p && v && /* @__PURE__ */ g(Bn, {
          onFocus: w
        }), s, !p && v && /* @__PURE__ */ g(Bn, {
          onFocus: w
        })]
      })
    }]
  }), V = x.useMemo(() => m.filter((_) => _.priority === "high"), [m]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!p && v && /* @__PURE__ */ g(Bn, {
      onFocus: w
    }), O, !h && V.length > 0 && /* @__PURE__ */ g("div", {
      style: nr,
      children: V.map((_) => /* @__PURE__ */ F("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ g("div", {
          children: _.title
        }), /* @__PURE__ */ g("div", {
          children: _.description
        })]
      }, _.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (F3.displayName = "ToastViewport");
const L1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (L1.displayName = "ToastRootContext");
function Wa() {
  const t = x.useContext(L1);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : st(66));
  return t;
}
let ur = /* @__PURE__ */ (function(t) {
  return t.index = "--toast-index", t.offsetY = "--toast-offset-y", t.height = "--toast-height", t.swipeMovementX = "--toast-swipe-movement-x", t.swipeMovementY = "--toast-swipe-movement-y", t;
})({});
const xO = {
  ...Kt,
  swipeDirection(t) {
    return t ? {
      "data-swipe-direction": t
    } : null;
  }
}, Ai = 40, CO = 10, Bo = 0.5, wO = 1, SO = `${$h},${e6}`;
function Eg(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function RO(t) {
  const n = St(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
const $3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    toast: o,
    render: r,
    className: i,
    swipeDirection: s = ["down", "right"],
    style: l,
    ...a
  } = e, c = o.positionerProps?.anchor !== void 0;
  let u = [];
  c || (u = Array.isArray(s) ? s : [s]);
  const d = u.length > 0, f = V1(), [p, m] = x.useState(void 0), [h, b] = x.useState(!1), [v, C] = x.useState(!1), [y, w] = x.useState(!1), [R, S] = x.useState({
    x: 0,
    y: 0
  }), [E, N] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [I, M] = x.useState(), [T, k] = x.useState(), [P, D] = x.useState(null), O = x.useRef(null), V = x.useRef({
    x: 0,
    y: 0
  }), _ = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), A = x.useRef(void 0), L = x.useRef(0), $ = x.useRef(!1), B = x.useRef({
    x: 0,
    y: 0
  }), z = x.useRef(!1), H = f.useState("toastIndex", o.id), K = f.useState("toastVisibleIndex", o.id), G = f.useState("toastOffsetY", o.id), q = f.useState("focused"), Q = f.useState("expanded");
  Jt({
    open: o.transitionStatus !== "ending",
    ref: O,
    onComplete() {
      o.transitionStatus === "ending" && f.removeToast(o.id);
    }
  });
  const U = we((j = !1) => {
    const ee = O.current;
    if (!ee)
      return;
    const Y = ee.style.height;
    ee.style.height = "auto";
    const Z = ee.offsetHeight;
    ee.style.height = Y;
    function ue() {
      f.updateToastInternal(o.id, {
        ref: O,
        height: Z,
        ...o.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    j ? yn.flushSync(ue) : ue();
  });
  ke(U, [U]);
  function X(j, ee) {
    let Y = j, Z = ee;
    return !u.includes("left") && !u.includes("right") ? Y = j > 0 ? j ** Bo : -(Math.abs(j) ** Bo) : (!u.includes("right") && j > 0 && (Y = j ** Bo), !u.includes("left") && j < 0 && (Y = -(Math.abs(j) ** Bo))), !u.includes("up") && !u.includes("down") ? Z = ee > 0 ? ee ** Bo : -(Math.abs(ee) ** Bo) : (!u.includes("down") && ee > 0 && (Z = ee ** Bo), !u.includes("up") && ee < 0 && (Z = -(Math.abs(ee) ** Bo))), {
      x: Y,
      y: Z
    };
  }
  function te(j) {
    if (j.button !== 0)
      return;
    j.pointerType === "touch" && f.pauseTimers();
    const ee = yt(j.nativeEvent);
    if (!(ee && ee.closest(`button,a,input,textarea,[role="button"],${SO}`))) {
      if ($.current = !1, A.current = void 0, L.current = 0, V.current = {
        x: j.clientX,
        y: j.clientY
      }, B.current = V.current, O.current) {
        const Z = RO(O.current);
        _.current = Z, N(Z), S({
          x: Z.x,
          y: Z.y
        });
      }
      f.setHovering(!0), b(!0), C(!1), D(null), z.current = !0, O.current?.setPointerCapture(j.pointerId);
    }
  }
  function re(j) {
    if (!h)
      return;
    j.preventDefault(), z.current && (V.current = {
      x: j.clientX,
      y: j.clientY
    }, z.current = !1);
    const {
      clientY: ee,
      clientX: Y,
      movementX: Z,
      movementY: ue
    } = j;
    (ue < 0 && ee > B.current.y || ue > 0 && ee < B.current.y) && (B.current = {
      x: B.current.x,
      y: ee
    }), (Z < 0 && Y > B.current.x || Z > 0 && Y < B.current.x) && (B.current = {
      x: Y,
      y: B.current.y
    });
    const fe = Y - V.current.x, be = ee - V.current.y, Ie = ee - B.current.y, ye = Y - B.current.x;
    if (!v && Math.sqrt(fe * fe + be * be) >= wO && (C(!0), P === null)) {
      const Ve = u.includes("left") || u.includes("right"), Ze = u.includes("up") || u.includes("down");
      if (Ve && Ze) {
        const Xe = Math.abs(fe), Be = Math.abs(be);
        D(Xe > Be ? "horizontal" : "vertical");
      }
    }
    let xe;
    if (!A.current)
      P === "vertical" ? be > 0 ? xe = "down" : be < 0 && (xe = "up") : P === "horizontal" ? fe > 0 ? xe = "right" : fe < 0 && (xe = "left") : Math.abs(fe) >= Math.abs(be) ? xe = fe > 0 ? "right" : "left" : xe = be > 0 ? "down" : "up", xe && u.includes(xe) && (A.current = xe, L.current = Eg(xe, fe, be), m(xe));
    else {
      const Re = A.current, Ve = Eg(Re, ye, Ie);
      Ve > Ai ? ($.current = !1, m(Re)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && L.current - Ve >= CO && ($.current = !0);
    }
    const de = X(fe, be);
    let Se = _.current.x, Me = _.current.y;
    P === "horizontal" ? (u.includes("left") || u.includes("right")) && (Se += de.x) : (P === "vertical" || (u.includes("left") || u.includes("right")) && (Se += de.x), (u.includes("up") || u.includes("down")) && (Me += de.y)), S({
      x: Se,
      y: Me
    });
  }
  function J(j) {
    if (!h)
      return;
    if (b(!1), C(!1), D(null), O.current?.releasePointerCapture(j.pointerId), $.current) {
      S({
        x: E.x,
        y: E.y
      }), m(void 0);
      return;
    }
    let ee = !1;
    const Y = R.x - E.x, Z = R.y - E.y;
    let ue;
    for (const fe of u) {
      switch (fe) {
        case "right":
          Y > Ai && (ee = !0, ue = "right");
          break;
        case "left":
          Y < -Ai && (ee = !0, ue = "left");
          break;
        case "down":
          Z > Ai && (ee = !0, ue = "down");
          break;
        case "up":
          Z < -Ai && (ee = !0, ue = "up");
          break;
      }
      if (ee)
        break;
    }
    ee ? (m(ue), w(!0), f.closeToast(o.id)) : (S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function ie() {
    h && (b(!1), C(!1), D(null), S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function ce(j) {
    if (j.key === "Escape") {
      if (!O.current || !Fe(O.current, Xt(nt(O.current))))
        return;
      f.closeToast(o.id);
    }
  }
  x.useEffect(() => {
    if (!d)
      return;
    const j = O.current;
    if (!j)
      return;
    function ee(Y) {
      Fe(j, yt(Y)) && Y.preventDefault();
    }
    return dt(j, "touchmove", ee, {
      passive: !1
    });
  }, [d]);
  function oe() {
    if (!h && R.x === E.x && R.y === E.y && !y)
      return {
        [ur.swipeMovementX]: "0px",
        [ur.swipeMovementY]: "0px"
      };
    const j = R.x - E.x, ee = R.y - E.y;
    return {
      transition: h ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: h ? `translateX(${R.x}px) translateY(${R.y}px) scale(${E.scale})` : void 0,
      [ur.swipeMovementX]: `${j}px`,
      [ur.swipeMovementY]: `${ee}px`
    };
  }
  const se = o.priority === "high", me = {
    role: se ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": I,
    "aria-describedby": T,
    "aria-hidden": se && !q ? !0 : void 0,
    onPointerDown: d ? te : void 0,
    onPointerMove: d ? re : void 0,
    onPointerUp: d ? J : void 0,
    onPointerCancel: d ? ie : void 0,
    onKeyDown: ce,
    inert: Tr(o.limited),
    style: {
      ...oe(),
      [ur.index]: o.transitionStatus === "ending" ? H : K,
      [ur.offsetY]: `${G}px`,
      [ur.height]: o.height ? `${o.height}px` : void 0
    }
  }, pe = x.useMemo(() => ({
    rootRef: O,
    toast: o,
    titleId: I,
    setTitleId: M,
    descriptionId: T,
    setDescriptionId: k,
    swiping: h,
    swipeDirection: p,
    recalculateHeight: U,
    index: H,
    visibleIndex: K,
    expanded: Q
  }), [o, I, T, h, p, U, H, K, Q]), le = {
    transitionStatus: o.transitionStatus,
    expanded: Q,
    limited: o.limited || !1,
    type: o.type,
    swiping: pe.swiping,
    swipeDirection: pe.swipeDirection
  }, ge = Le("div", e, {
    ref: [n, pe.rootRef],
    state: le,
    stateAttributesMapping: xO,
    props: [me, a]
  });
  return /* @__PURE__ */ g(L1.Provider, {
    value: pe,
    children: ge
  });
});
process.env.NODE_ENV !== "production" && ($3.displayName = "ToastRoot");
const H3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    visibleIndex: l,
    expanded: a,
    recalculateHeight: c
  } = Wa(), u = x.useRef(null);
  ke(() => {
    const m = u.current;
    if (!m || (c(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const h = new ResizeObserver(() => c(!0)), b = new MutationObserver(() => c(!0));
    return h.observe(m), b.observe(m, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, [c]);
  const d = l > 0;
  return Le("div", e, {
    ref: [n, u],
    state: {
      expanded: a,
      behind: d
    },
    props: s
  });
});
process.env.NODE_ENV !== "production" && (H3.displayName = "ToastContent");
const z3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    children: l,
    ...a
  } = e, {
    toast: c,
    setDescriptionId: u
  } = Wa(), d = l ?? c.description, f = !!d, p = Lo(s);
  ke(() => {
    if (f)
      return u(p), () => {
        u(void 0);
      };
  }, [f, p, u]);
  const m = {
    type: c.type
  }, h = Le("p", e, {
    ref: n,
    state: m,
    props: {
      ...a,
      id: p,
      children: d
    }
  });
  return f ? h : null;
});
process.env.NODE_ENV !== "production" && (z3.displayName = "ToastDescription");
const Mu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, c = V1(), {
    toast: u
  } = Wa(), d = c.useState("expanded"), [f, p] = x.useState(!1), {
    getButtonProps: m,
    buttonRef: h
  } = qt({
    disabled: s,
    native: l
  }), b = {
    type: u.type
  };
  return Le("button", e, {
    ref: [n, h],
    state: b,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        p(!0);
      },
      onBlur() {
        p(!1);
      }
    }, a, m]
  });
});
process.env.NODE_ENV !== "production" && (Mu.displayName = "ToastClose");
const Tu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, {
    toast: c
  } = Wa(), u = c.actionProps?.children ?? a.children, d = !!u, {
    getButtonProps: f,
    buttonRef: p
  } = qt({
    disabled: s,
    native: l
  }), m = {
    type: c.type
  }, h = Le("button", e, {
    ref: [n, p],
    state: m,
    props: [a, c.actionProps, f, {
      children: u
    }]
  });
  return d ? h : null;
});
process.env.NODE_ENV !== "production" && (Tu.displayName = "ToastAction");
const EO = Ra;
function NO() {
  const t = x.useContext(Ba);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : st(73));
  const e = t.useState("toasts");
  return x.useMemo(() => ({
    toasts: e,
    add: t.addToast,
    close: t.closeToast,
    update: t.updateToast,
    promise: t.promiseToast
  }), [e, t]);
}
function kO() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    t.forEach((o) => o(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(o) {
      return t.add(o), () => {
        t.delete(o);
      };
    },
    add(n) {
      const o = n.id || L3("toast"), r = {
        ...n,
        id: o,
        transitionStatus: "starting"
      };
      return e({
        action: "add",
        options: r
      }), o;
    },
    close(n) {
      e({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, o) {
      e({
        action: "update",
        options: {
          ...o,
          id: n
        }
      });
    },
    promise(n, o) {
      let r = n;
      return e({
        action: "promise",
        options: {
          ...o,
          promise: n,
          setPromise(i) {
            r = i;
          }
        }
      }), r;
    }
  };
}
const IO = ae(["rounded-(--radius-sm)", "outline-none", "transition-[opacity,transform,height]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "shadow-elevation-3", "[&[data-starting-style]]:translate-y-2", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:translate-y-2", "[&[data-ending-style]]:opacity-0", "[&[data-limited]]:pointer-events-none", "[&[data-limited]]:opacity-0"], {
  variants: {
    variant: {
      default: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      error: ["bg-error", "text-error-on-error"]
    },
    placement: {
      static: ["relative", "w-full", "max-w-[344px]"],
      viewport: ["w-full"]
    }
  },
  defaultVariants: {
    variant: "default",
    placement: "static"
  }
}), PO = ae(["flex", "min-h-[48px]", "w-full", "items-center", "pl-(--spacing-10)"], {
  variants: {
    hasClose: {
      true: "pr-(--spacing-4)",
      false: "pr-(--spacing-8)"
    },
    layout: {
      inline: "gap-(--spacing-10)",
      "inline-action": "gap-(--spacing-4)",
      stacked: "items-start gap-(--spacing-10)"
    }
  },
  defaultVariants: {
    hasClose: !1,
    layout: "inline"
  }
}), MO = ae(["m-0", "min-w-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-current", "overflow-hidden", "[display:-webkit-box]", "[-webkit-box-orient:vertical]", "[-webkit-line-clamp:2]"]), TO = ae("min-w-0 flex-1 py-(--spacing-10)", {
  variants: {
    layout: {
      inline: "block",
      "inline-action": "block",
      stacked: "flex flex-col items-stretch gap-(--spacing-4)"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
}), OO = ae("shrink-0 py-(--spacing-10)", {
  variants: {
    variant: {
      default: "text-primary-inverse-primary",
      error: "text-error-on-error"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), DO = ae(["inline-flex", "h-(--spacing-40)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "whitespace-nowrap", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-12)", "py-0", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-large)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-primary-inverse-primary", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), _O = ae(["inline-flex", "size-[48px]", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-surface-inverse-on-surface", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), VO = ne("fixed", "[left:0]", "[right:0]", "mx-auto", "bottom-(--spacing-24)", "z-[var(--z-layer-notification)]", "h-(--toast-frontmost-height)", "w-[min(344px,calc(100vw_-_var(--spacing-32)))]"), AO = 10;
function Ng({
  children: t,
  variant: e,
  disabled: n = !1,
  ...o
}) {
  return /* @__PURE__ */ g(no, { className: ne(DO({
    variant: e
  })), disabled: n, "aria-disabled": n || void 0, tabIndex: n ? -1 : void 0, ...o, children: t });
}
function kg({
  variant: t,
  disabled: e = !1,
  "aria-label": n = "Dismiss notification",
  ...o
}) {
  return /* @__PURE__ */ g(no, { className: ne(_O({
    variant: t
  })), disabled: e, "aria-disabled": e || void 0, "aria-label": n, tabIndex: e ? -1 : void 0, ...o, children: /* @__PURE__ */ g(Ue, { name: "x-close", size: "sm", tone: "inherit" }) });
}
const B3 = kO();
function LO(t) {
  return t === "error" ? "error" : "default";
}
const FO = {
  add(t, e = {}) {
    const {
      variant: n = "default",
      action: o,
      icon: r = !1,
      onDismiss: i,
      timeout: s
    } = e;
    return B3.add({
      description: t,
      type: n,
      priority: n === "error" ? "high" : "low",
      ...s !== void 0 && {
        timeout: s
      },
      data: {
        action: o,
        icon: r,
        onDismiss: i
      }
    });
  },
  error(t, e = {}) {
    return FO.add(t, {
      ...e,
      variant: "error"
    });
  }
};
function W3(t) {
  const e = W.c(73);
  let n, o, r, i;
  e[0] !== t ? ({
    toast: i,
    onActionComplete: n,
    placement: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "static" : r;
  let l, a, c, u, d, f, p, m, h, b, v, C, y, w, R, S, E;
  if (e[5] !== n || e[6] !== s || e[7] !== o || e[8] !== i) {
    E = LO(i.type), c = i.data?.action;
    const V = i.data?.icon ?? !1, _ = !!i.data?.onDismiss;
    f = c && c.label.length >= AO ? "stacked" : c ? "inline-action" : "inline", p = f === "stacked" && _, m = _ && !p;
    let A;
    e[26] !== c || e[27] !== n ? (A = function() {
      c?.onClick(), n?.();
    }, e[26] = c, e[27] = n, e[28] = A) : A = e[28], u = A;
    let L;
    e[29] !== i.data ? (L = function() {
      i.data?.onDismiss?.();
    }, e[29] = i.data, e[30] = L) : L = e[30], d = L, a = $3, v = i, e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ["down", "right"], e[31] = C) : C = e[31], y = E === "error" ? "alert" : "status", w = E === "error" ? "assertive" : "polite", R = ne(IO({
      variant: E,
      placement: s
    })), S = o, l = H3, e[32] !== f || e[33] !== _ ? (h = ne(PO({
      hasClose: _,
      layout: f
    })), e[32] = f, e[33] = _, e[34] = h) : h = e[34], b = V && /* @__PURE__ */ g("span", { "data-slot": "toast-leading-icon", className: ne(OO({
      variant: E
    })), children: /* @__PURE__ */ g(Ue, { name: E === "error" ? "circle-exclamation" : "circle-check-regular", size: "md", tone: "inherit" }) }), e[5] = n, e[6] = s, e[7] = o, e[8] = i, e[9] = l, e[10] = a, e[11] = c, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m, e[17] = h, e[18] = b, e[19] = v, e[20] = C, e[21] = y, e[22] = w, e[23] = R, e[24] = S, e[25] = E;
  } else
    l = e[9], a = e[10], c = e[11], u = e[12], d = e[13], f = e[14], p = e[15], m = e[16], h = e[17], b = e[18], v = e[19], C = e[20], y = e[21], w = e[22], R = e[23], S = e[24], E = e[25];
  let N;
  e[35] !== f ? (N = ne(TO({
    layout: f
  })), e[35] = f, e[36] = N) : N = e[36];
  let I;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = /* @__PURE__ */ g(z3, { className: ne(MO()) }), e[37] = I) : I = e[37];
  let M;
  e[38] !== c || e[39] !== u || e[40] !== d || e[41] !== f || e[42] !== p || e[43] !== E ? (M = c && f === "stacked" && /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-end", children: [
    /* @__PURE__ */ g(Tu, { render: /* @__PURE__ */ g(Ng, { variant: E, onClick: u }), children: c.label }),
    p && /* @__PURE__ */ g(Mu, { render: /* @__PURE__ */ g(kg, { variant: E, "aria-hidden": void 0, onClick: d }) })
  ] }), e[38] = c, e[39] = u, e[40] = d, e[41] = f, e[42] = p, e[43] = E, e[44] = M) : M = e[44];
  let T;
  e[45] !== N || e[46] !== M ? (T = /* @__PURE__ */ F("div", { className: N, children: [
    I,
    M
  ] }), e[45] = N, e[46] = M, e[47] = T) : T = e[47];
  let k;
  e[48] !== c || e[49] !== u || e[50] !== f || e[51] !== E ? (k = c && f === "inline-action" && /* @__PURE__ */ g(Tu, { render: /* @__PURE__ */ g(Ng, { variant: E, onClick: u }), children: c.label }), e[48] = c, e[49] = u, e[50] = f, e[51] = E, e[52] = k) : k = e[52];
  let P;
  e[53] !== d || e[54] !== m || e[55] !== E ? (P = m && /* @__PURE__ */ g(Mu, { render: /* @__PURE__ */ g(kg, { variant: E, "aria-hidden": void 0, onClick: d }) }), e[53] = d, e[54] = m, e[55] = E, e[56] = P) : P = e[56];
  let D;
  e[57] !== l || e[58] !== T || e[59] !== k || e[60] !== P || e[61] !== h || e[62] !== b ? (D = /* @__PURE__ */ F(l, { className: h, children: [
    b,
    T,
    k,
    P
  ] }), e[57] = l, e[58] = T, e[59] = k, e[60] = P, e[61] = h, e[62] = b, e[63] = D) : D = e[63];
  let O;
  return e[64] !== a || e[65] !== D || e[66] !== v || e[67] !== C || e[68] !== y || e[69] !== w || e[70] !== R || e[71] !== S ? (O = /* @__PURE__ */ g(a, { toast: v, swipeDirection: C, role: y, "aria-live": w, className: R, ...S, children: D }), e[64] = a, e[65] = D, e[66] = v, e[67] = C, e[68] = y, e[69] = w, e[70] = R, e[71] = S, e[72] = O) : O = e[72], O;
}
function k_(t) {
  const e = W.c(20);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    variant: l,
    description: o,
    action: n,
    icon: r,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = $t(), c = l ?? "default", u = l === "error" ? "high" : "low";
  let d;
  e[7] !== n || e[8] !== r || e[9] !== i ? (d = {
    action: n,
    icon: r,
    onDismiss: i
  }, e[7] = n, e[8] = r, e[9] = i, e[10] = d) : d = e[10];
  let f;
  e[11] !== o || e[12] !== a || e[13] !== c || e[14] !== u || e[15] !== d ? (f = {
    id: a,
    description: o,
    type: c,
    priority: u,
    data: d
  }, e[11] = o, e[12] = a, e[13] = c, e[14] = u, e[15] = d, e[16] = f) : f = e[16];
  let p;
  return e[17] !== s || e[18] !== f ? (p = /* @__PURE__ */ g(A1, { timeout: 0, limit: 1, children: /* @__PURE__ */ g(W3, { toast: f, ...s }) }), e[17] = s, e[18] = f, e[19] = p) : p = e[19], p;
}
function $O() {
  const t = W.c(7), e = NO(), n = en();
  let o;
  t[0] !== e ? (o = e.toasts.map((s) => /* @__PURE__ */ g(W3, { onActionComplete: () => e.close(s.id), toast: s, placement: "viewport" }, s.id)), t[0] = e, t[1] = o) : o = t[1];
  let r;
  t[2] !== o ? (r = /* @__PURE__ */ g(F3, { className: VO, children: o }), t[2] = o, t[3] = r) : r = t[3];
  let i;
  return t[4] !== n || t[5] !== r ? (i = /* @__PURE__ */ g(EO, { container: n, children: r }), t[4] = n, t[5] = r, t[6] = i) : i = t[6], i;
}
const U3 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (U3.displayName = "ToggleGroupContext");
function HO(t = !0) {
  const e = x.useContext(U3);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>." : st(7));
  return e;
}
const G3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultPressed: r = !1,
    disabled: i = !1,
    form: s,
    // never participates in form validation
    onPressedChange: l,
    pressed: a,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, h = Ot(d || void 0), b = HO(), v = b?.value ?? [], C = b ? void 0 : r, y = (i || b?.disabled) ?? !1;
  process.env.NODE_ENV !== "production" && ke(() => {
    b && d === void 0 && b.isValueInitialized && Zo("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [b, d, b?.isValueInitialized]);
  const [w, R] = Sn({
    controlled: b ? h !== void 0 && v.indexOf(h) > -1 : a,
    default: C,
    name: "Toggle",
    state: "pressed"
  }), S = we((P, D) => {
    h && b?.setGroupValue?.(h, P, D), l?.(P, D);
  }), {
    getButtonProps: E,
    buttonRef: N
  } = qt({
    disabled: y,
    native: f
  }), I = {
    disabled: y,
    pressed: w
  }, M = [N, n], T = [{
    "aria-pressed": w,
    onClick(P) {
      const D = !w, O = De(At, P.nativeEvent);
      S(D, O), !O.isCanceled && R(D);
    }
  }, m, E], k = Le("button", e, {
    enabled: !b,
    state: I,
    ref: M,
    props: T
  });
  return b ? /* @__PURE__ */ g(Ad, {
    tag: "button",
    render: c,
    className: o,
    style: p,
    state: I,
    refs: M,
    props: T
  }) : k;
});
process.env.NODE_ENV !== "production" && (G3.displayName = "Toggle");
const zO = ae(["inline-flex", "items-center", "justify-center", "overflow-hidden", "whitespace-nowrap", "shrink-0", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"], {
  variants: {
    variant: {
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[pressed]:border-2", "data-[pressed]:border-primary", "data-[pressed]:text-primary"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "data-[pressed]:text-primary"]
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
function I_(t) {
  const e = W.c(23);
  let n, o, r, i, s;
  e[0] !== t ? ({
    icon: n,
    label: o,
    variant: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "outline" : i, a = s === void 0 ? !1 : s;
  let c;
  e[6] !== a || e[7] !== o || e[8] !== l ? (c = ne(zO({
    variant: l
  }), o ? "h-(--spacing-32) px-(--spacing-12)" : "size-(--spacing-32)", a && "opacity-40 pointer-events-none cursor-not-allowed"), e[6] = a, e[7] = o, e[8] = l, e[9] = c) : c = e[9];
  const u = a || void 0, d = a ? -1 : void 0;
  let f;
  e[10] !== o ? (f = o && /* @__PURE__ */ g("span", { className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap", children: o }), e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== n ? (p = /* @__PURE__ */ g(Ue, { name: n, size: "xs", tone: "inherit" }), e[12] = n, e[13] = p) : p = e[13];
  let m;
  return e[14] !== a || e[15] !== r || e[16] !== c || e[17] !== u || e[18] !== d || e[19] !== f || e[20] !== p || e[21] !== l ? (m = /* @__PURE__ */ F(G3, { "data-slot": "toggle", "data-variant": l, className: c, disabled: a, "aria-disabled": u, tabIndex: d, ...r, children: [
    f,
    p
  ] }), e[14] = a, e[15] = r, e[16] = c, e[17] = u, e[18] = d, e[19] = f, e[20] = p, e[21] = l, e[22] = m) : m = e[22], m;
}
const BO = {
  photo: {
    icon: "image-regular",
    accept: "image/png,image/jpeg",
    acceptedFormatsLabel: "PNG, JPG",
    buttonLabel: "Select Image"
  },
  file: {
    icon: "upload",
    accept: "application/pdf,text/plain",
    acceptedFormatsLabel: "PDF, TXT",
    buttonLabel: "Select File"
  }
};
function P_(t) {
  const e = W.c(53);
  let n, o, r, i, s, l, a, c, u, d, f, p, m;
  e[0] !== t ? ({
    variant: c,
    accept: n,
    acceptedFormatsLabel: o,
    error: u,
    "aria-describedby": m,
    maxSizeLabel: d,
    multiple: f,
    disabled: p,
    buttonLabel: r,
    guidanceLabel: s,
    onFilesSelected: l,
    className: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13]);
  const h = c === void 0 ? "photo" : c, b = u === void 0 ? !1 : u, v = d === void 0 ? "5 MB" : d, C = f === void 0 ? !1 : f, y = p === void 0 ? !1 : p, w = $t(), R = $t(), S = at(null), E = BO[h], N = o ?? E.acceptedFormatsLabel, I = r ?? E.buttonLabel, M = n ?? E.accept, T = s ?? `Upload ${N} up to ${v}`;
  let k;
  e[14] !== R || e[15] !== m ? (k = [R, m].filter(Boolean), e[14] = R, e[15] = m, e[16] = k) : k = e[16];
  const P = k.join(" ");
  let D;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = function() {
    S.current?.click();
  }, e[17] = D) : D = e[17];
  const O = D;
  let V;
  e[18] !== l ? (V = function(re) {
    const J = Array.from(re.currentTarget.files ?? []);
    J.length > 0 && l?.(J), re.currentTarget.value = "";
  }, e[18] = l, e[19] = V) : V = e[19];
  const _ = V, A = y || void 0, L = y && "opacity-50";
  let $;
  e[20] !== i || e[21] !== L ? ($ = ne("flex", "w-[480px]", "max-w-full", "relative", "flex-col", "items-center", "justify-center", "gap-(--spacing-24)", "rounded-(--radius-sm)", "bg-surface-container-lowest", "px-(--spacing-16)", "py-(--spacing-24)", L, i), e[20] = i, e[21] = L, e[22] = $) : $ = e[22];
  let B;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = /* @__PURE__ */ g(WO, {}), e[23] = B) : B = e[23];
  let z;
  e[24] !== E.icon ? (z = /* @__PURE__ */ g("span", { "data-slot": "upload-icon", className: "text-text-subtext", children: /* @__PURE__ */ g(Ue, { name: E.icon, size: "lg", tone: "inherit", "aria-hidden": !0 }) }), e[24] = E.icon, e[25] = z) : z = e[25];
  let H;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = ne("m-0", "text-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"), e[26] = H) : H = e[26];
  let K;
  e[27] !== R || e[28] !== T ? (K = /* @__PURE__ */ g("p", { id: R, className: H, children: T }), e[27] = R, e[28] = T, e[29] = K) : K = e[29];
  const G = b || void 0;
  let q;
  e[30] !== P || e[31] !== y || e[32] !== I || e[33] !== G ? (q = /* @__PURE__ */ g(pn, { variant: "outline", size: "md", disabled: y, onClick: O, type: "button", "aria-describedby": P, "aria-invalid": G, children: I }), e[30] = P, e[31] = y, e[32] = I, e[33] = G, e[34] = q) : q = e[34];
  const Q = b || void 0;
  let U;
  e[35] !== P || e[36] !== y || e[37] !== _ || e[38] !== w || e[39] !== C || e[40] !== M || e[41] !== I || e[42] !== Q ? (U = /* @__PURE__ */ g("input", { ref: S, id: w, className: "sr-only", type: "file", accept: M, multiple: C, disabled: y, tabIndex: -1, "aria-label": I, "aria-describedby": P, "aria-invalid": Q, onChange: _ }), e[35] = P, e[36] = y, e[37] = _, e[38] = w, e[39] = C, e[40] = M, e[41] = I, e[42] = Q, e[43] = U) : U = e[43];
  let X;
  return e[44] !== a || e[45] !== $ || e[46] !== z || e[47] !== K || e[48] !== q || e[49] !== U || e[50] !== A || e[51] !== h ? (X = /* @__PURE__ */ F("div", { "data-slot": "upload", "data-variant": h, "data-disabled": A, className: $, ...a, children: [
    B,
    z,
    K,
    q,
    U
  ] }), e[44] = a, e[45] = $, e[46] = z, e[47] = K, e[48] = q, e[49] = U, e[50] = A, e[51] = h, e[52] = X) : X = e[52], X;
}
function WO() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", preserveAspectRatio: "none", viewBox: "0 0 480 188", children: /* @__PURE__ */ g("rect", { className: "stroke-outline-subtle", x: "0.5", y: "0.5", width: "479", height: "187", rx: "4", strokeDasharray: "8 6", strokeLinecap: "butt", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }) }), t[0] = e) : e = t[0], e;
}
function M_(t) {
  const e = W.c(13), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, [i, s] = qe(null), [l, a] = qe(null);
  let c;
  e[0] !== l || e[1] !== i ? (c = {
    blockingLayerHost: l,
    portalHost: i
  }, e[0] = l, e[1] = i, e[2] = c) : c = e[2];
  let u, d, f;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-portal-host", ref: s }), d = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-blocking-layer-host", ref: a }), f = /* @__PURE__ */ g($O, {}), e[3] = u, e[4] = d, e[5] = f) : (u = e[3], d = e[4], f = e[5]);
  let p;
  e[6] !== n || e[7] !== o || e[8] !== r ? (p = /* @__PURE__ */ g(I2, { delay: 300, timeout: 400, children: /* @__PURE__ */ g(A1, { toastManager: B3, timeout: 5e3, limit: 1, children: /* @__PURE__ */ F(UR, { defaultTheme: o, storageKey: r, children: [
    n,
    u,
    d,
    f
  ] }) }) }), e[6] = n, e[7] = o, e[8] = r, e[9] = p) : p = e[9];
  let m;
  return e[10] !== c || e[11] !== p ? (m = /* @__PURE__ */ g(Ld, { value: c, children: p }), e[10] = c, e[11] = p, e[12] = m) : m = e[12], m;
}
export {
  $D as Accordion,
  ED as ActionItemCard,
  _u as AiSparkles,
  Pm as Alert,
  Jv as AnchorLink,
  e5 as AnchorNav,
  sD as AppShell,
  lD as AppShellContent,
  aD as AppShellMobileNavigationTrigger,
  QO as AssetAlertChat,
  TD as AssetStatusCard,
  OD as AssetTimeline,
  l8 as AssetWatchLogo,
  M_ as AssetWatchUiProvider,
  Vx as AssistantChatComposer,
  RD as AssistantChatDialog,
  nD as AssistantChatFeedback,
  bc as AssistantChatHeader,
  SD as AssistantChatPanel,
  _w as AssistantChatSidebar,
  wD as AssistantChatTemplatePicker,
  Xr as Avatar,
  vu as Badge,
  HD as Banner,
  oD as BlockingActionOverlay,
  zD as Breadcrumb,
  lE as BreadcrumbItem,
  aE as BreadcrumbLink,
  BD as BreadcrumbList,
  WD as BreadcrumbPage,
  xb as BreadcrumbSeparator,
  pn as Button,
  qO as Caption,
  wr as Card,
  zw as CardBorderFill,
  UD as CardContainer,
  xD as CardGroup,
  yD as CardImageSlot,
  CD as CardLink,
  GD as Carousel,
  YD as ChatActionButton,
  Hy as ChatAttachment,
  lu as ChatBubble,
  jD as ChatCopyButton,
  iu as ChatMessage,
  Zg as ChatMessageAvatar,
  su as ChatMessageContent,
  K1 as ChatMessageFooter,
  q5 as ChatMessageGroup,
  Xg as ChatMessageHeader,
  Wp as ChatPanel,
  Yp as ChatPanelBody,
  Vy as ChatPanelFooter,
  JO as ChatPanelHeader,
  Gp as ChatPanelMain,
  _y as ChatPanelSidebar,
  Up as ChatPanelSidebarHeader,
  Qg as ChatScroller,
  eh as ChatScrollerContent,
  Wi as ChatScrollerItem,
  th as ChatScrollerJumpToLatest,
  Jg as ChatScrollerViewport,
  Z5 as ChatStatus,
  hx as ChatTextarea,
  AE as Checkbox,
  Wn as Chip,
  u_ as CircularProgress,
  VD as CompanyNavigation,
  eD as Container,
  PD as ContextualAssetGallery,
  MD as CustomerSelect,
  LD as DEFAULT_PROFILE_MENU_LABELS,
  x_ as DataTable,
  KD as DatePicker,
  QD as DateRangeFilter,
  qD as Dialog,
  ZO as Display,
  vr as Divider,
  iw as Drawer,
  dD as DrawerBody,
  sw as DrawerClose,
  lw as DrawerContent,
  fD as DrawerFooter,
  uD as DrawerHeader,
  cD as DrawerTrigger,
  Sm as EmptyState,
  AD as FacilityNavigation,
  ZD as FilterPanel,
  n_ as Form,
  r_ as FormActionColumnHeader,
  vP as FormFooter,
  o_ as FormSection,
  i_ as FullPageLayout,
  rD as FullPageLoading,
  Cr as Group,
  XO as Headline,
  bR as HoverCard,
  yR as HoverCardContent,
  vR as HoverCardTrigger,
  Ue as Icon,
  bt as IconButton,
  kc as InlineLink,
  Lx as Input,
  ND as InsightCard,
  s0 as Kbd,
  mo as Label,
  s_ as Lightbox,
  l_ as ListCard,
  Fd as Menu,
  V7 as MenuButton,
  k7 as MenuCheckboxItem,
  hr as MenuItem,
  Dr as MenuPopup,
  $d as MenuRadioGroup,
  Hd as MenuRadioItem,
  bu as MenuSubHeader,
  qo as MenuTrigger,
  kD as MetricCard,
  wu as Modal,
  a_ as MultiSelect,
  Gx as PageHeader,
  HP as Pagination,
  ex as Popover,
  nx as PopoverContent,
  tx as PopoverTrigger,
  FD as ProfileMenu,
  c_ as Progress,
  Ur as RELEASE_STATUS,
  Hi as RELEASE_STATUS_LABEL,
  f_ as Radio,
  d_ as RadioGroup,
  _D as ReleaseInfoModal,
  DD as STATUS_DISPLAY,
  p_ as SearchInput,
  m_ as SearchSpotlight,
  lS as SectionHeader,
  t_ as SegmentedFilter,
  n1 as Select,
  e_ as SelectedFilters,
  ID as ServiceCard,
  pD as Sidebar,
  mD as SidebarFooter,
  xm as SidebarGroup,
  Ol as SidebarItem,
  yu as SidebarToggle,
  XD as SingleFilter,
  h_ as Skeleton,
  JD as SortGroupFilter,
  v_ as SortableList,
  $M as SortableListHandle,
  b_ as SortableListItem,
  Qo as Stack,
  y_ as Switch,
  jT as Table,
  qT as TableBody,
  Cl as TableCell,
  D1 as TableCellPrimary,
  _1 as TableCellSecondary,
  _3 as TableCellStack,
  tO as TableChipTextCellContent,
  xl as TableHead,
  KT as TableHeader,
  Yc as TableRow,
  JT as TableStartingCellContent,
  eO as TableTextCellContent,
  R_ as Tabs,
  S_ as TabsContent,
  C_ as TabsList,
  w_ as TabsTrigger,
  ns as Tag,
  an as Text,
  tD as Textarea,
  ql as Thumbnail,
  E_ as Tile,
  N_ as TimePicker,
  Mn as Title,
  k_ as Toast,
  I_ as Toggle,
  Xo as Tooltip,
  Ox as TooltipIcon,
  gD as TopBar,
  vD as TopBarActions,
  bD as TopBarContent,
  hD as TopBarLeading,
  k0 as Trend,
  Ay as TypingIndicator,
  P_ as Upload,
  FO as toast,
  n5 as useAnchorNav,
  iD as useAppShell,
  Jd as useOverflowItems,
  g_ as useSearchHotkey,
  wf as useSidebar,
  GR as useTheme,
  Ms as viewportQueries
};
//# sourceMappingURL=index.js.map
